import { Fragment, KeepAlive, Suspense, Teleport, Transition, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineComponent, getCurrentInstance, guardReactiveProps, h, inject, markRaw, mergeModels, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, onActivated, onBeforeMount, onBeforeUnmount, onBeforeUpdate, onDeactivated, onErrorCaptured, onMounted, onUnmounted, onUpdated, onWatcherCleanup, openBlock, provide, reactive, readonly, ref, renderList, renderSlot, resolveComponent, resolveDirective, resolveDynamicComponent, shallowReactive, shallowRef, toDisplayString, toHandlerKey, toHandlers, toRaw, toRef, toRefs, toValue, unref, useAttrs, useCssVars, useModel, useSlots, useTemplateRef, vShow, watch, watchEffect, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import { useI18n } from "vue-i18n";
import { decimal, email, helpers, integer, maxLength, minLength, requiredUnless } from "@vuelidate/validators";
import throttle from "lodash.throttle";
import { RouterLink, RouterView, onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { VueDraggable } from "vue-draggable-plus";
import { Chart, Filler, LineController, LineElement, LinearScale, PointElement, TimeScale, Tooltip } from "chart.js";
import "chartjs-adapter-date-fns";
import useVuelidate, { useVuelidate as useVuelidate$1 } from "@vuelidate/core";
import kebabCase from "lodash.kebabcase";
import createScatterplot from "regl-scatterplot";
import DOMPurify from "dompurify";
import merge from "lodash.merge";
//#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/common/HttpStatusCode.js
var HttpStatusCode;
(function(HttpStatusCode) {
	/**
	* The server has received the request headers and the client should proceed to send the request body
	* (in the case of a request for which a body needs to be sent; for example, a POST request).
	* Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
	* To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
	* and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
	*/
	HttpStatusCode[HttpStatusCode["CONTINUE"] = 100] = "CONTINUE";
	/**
	* The requester has asked the server to switch protocols and the server has agreed to do so.
	*/
	HttpStatusCode[HttpStatusCode["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
	/**
	* A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
	* This code indicates that the server has received and is processing the request, but no response is available yet.
	* This prevents the client from timing out and assuming the request was lost.
	*/
	HttpStatusCode[HttpStatusCode["PROCESSING"] = 102] = "PROCESSING";
	/**
	* Standard response for successful HTTP requests.
	* The actual response will depend on the request method used.
	* In a GET request, the response will contain an entity corresponding to the requested resource.
	* In a POST request, the response will contain an entity describing or containing the result of the action.
	*/
	HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
	/**
	* The request has been fulfilled, resulting in the creation of a new resource.
	*/
	HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
	/**
	* The request has been accepted for processing, but the processing has not been completed.
	* The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
	*/
	HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
	/**
	* SINCE HTTP/1.1
	* The server is a transforming proxy that received a 200 OK from its origin,
	* but is returning a modified version of the origin's response.
	*/
	HttpStatusCode[HttpStatusCode["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
	/**
	* The server successfully processed the request and is not returning any content.
	*/
	HttpStatusCode[HttpStatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
	/**
	* The server successfully processed the request, but is not returning any content.
	* Unlike a 204 response, this response requires that the requester reset the document view.
	*/
	HttpStatusCode[HttpStatusCode["RESET_CONTENT"] = 205] = "RESET_CONTENT";
	/**
	* The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
	* The range header is used by HTTP clients to enable resuming of interrupted downloads,
	* or split a download into multiple simultaneous streams.
	*/
	HttpStatusCode[HttpStatusCode["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
	/**
	* The message body that follows is an XML message and can contain a number of separate response codes,
	* depending on how many sub-requests were made.
	*/
	HttpStatusCode[HttpStatusCode["MULTI_STATUS"] = 207] = "MULTI_STATUS";
	/**
	* The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
	* and are not being included again.
	*/
	HttpStatusCode[HttpStatusCode["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
	/**
	* The server has fulfilled a request for the resource,
	* and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
	*/
	HttpStatusCode[HttpStatusCode["IM_USED"] = 226] = "IM_USED";
	/**
	* Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
	* For example, this code could be used to present multiple video format options,
	* to list files with different filename extensions, or to suggest word-sense disambiguation.
	*/
	HttpStatusCode[HttpStatusCode["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
	/**
	* This and all future requests should be directed to the given URI.
	*/
	HttpStatusCode[HttpStatusCode["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
	/**
	* This is an example of industry practice contradicting the standard.
	* The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
	* (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
	* with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
	* to distinguish between the two behaviours. However, some Web applications and frameworks
	* use the 302 status code as if it were the 303.
	*/
	HttpStatusCode[HttpStatusCode["FOUND"] = 302] = "FOUND";
	/**
	* SINCE HTTP/1.1
	* The response to the request can be found under another URI using a GET method.
	* When received in response to a POST (or PUT/DELETE), the client should presume that
	* the server has received the data and should issue a redirect with a separate GET message.
	*/
	HttpStatusCode[HttpStatusCode["SEE_OTHER"] = 303] = "SEE_OTHER";
	/**
	* Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
	* In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
	*/
	HttpStatusCode[HttpStatusCode["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
	/**
	* SINCE HTTP/1.1
	* The requested resource is available only through a proxy, the address for which is provided in the response.
	* Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
	*/
	HttpStatusCode[HttpStatusCode["USE_PROXY"] = 305] = "USE_PROXY";
	/**
	* No longer used. Originally meant "Subsequent requests should use the specified proxy."
	*/
	HttpStatusCode[HttpStatusCode["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
	/**
	* SINCE HTTP/1.1
	* In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
	* In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
	* For example, a POST request should be repeated using another POST request.
	*/
	HttpStatusCode[HttpStatusCode["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
	/**
	* The request and all future requests should be repeated using another URI.
	* 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
	* So, for example, submitting a form to a permanently redirected resource may continue smoothly.
	*/
	HttpStatusCode[HttpStatusCode["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
	/**
	* The server cannot or will not process the request due to an apparent client error
	* (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
	*/
	HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
	/**
	* Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
	* been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
	* requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
	* "unauthenticated",i.e. the user does not have the necessary credentials.
	*/
	HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
	/**
	* Reserved for future use. The original intention was that this code might be used as part of some form of digital
	* cash or micro payment scheme, but that has not happened, and this code is not usually used.
	* Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
	*/
	HttpStatusCode[HttpStatusCode["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
	/**
	* The request was valid, but the server is refusing action.
	* The user might not have the necessary permissions for a resource.
	*/
	HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
	/**
	* The requested resource could not be found but may be available in the future.
	* Subsequent requests by the client are permissible.
	*/
	HttpStatusCode[HttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
	/**
	* A request method is not supported for the requested resource;
	* for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
	*/
	HttpStatusCode[HttpStatusCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
	/**
	* The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
	*/
	HttpStatusCode[HttpStatusCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
	/**
	* The client must first authenticate itself with the proxy.
	*/
	HttpStatusCode[HttpStatusCode["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
	/**
	* The server timed out waiting for the request.
	* According to HTTP specifications:
	* "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
	*/
	HttpStatusCode[HttpStatusCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
	/**
	* Indicates that the request could not be processed because of conflict in the request,
	* such as an edit conflict between multiple simultaneous updates.
	*/
	HttpStatusCode[HttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
	/**
	* Indicates that the resource requested is no longer available and will not be available again.
	* This should be used when a resource has been intentionally removed and the resource should be purged.
	* Upon receiving a 410 status code, the client should not request the resource in the future.
	* Clients such as search engines should remove the resource from their indices.
	* Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
	*/
	HttpStatusCode[HttpStatusCode["GONE"] = 410] = "GONE";
	/**
	* The request did not specify the length of its content, which is required by the requested resource.
	*/
	HttpStatusCode[HttpStatusCode["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
	/**
	* The server does not meet one of the preconditions that the requester put on the request.
	*/
	HttpStatusCode[HttpStatusCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
	/**
	* The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
	*/
	HttpStatusCode[HttpStatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
	/**
	* The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
	* in which case it should be converted to a POST request.
	* Called "Request-URI Too Long" previously.
	*/
	HttpStatusCode[HttpStatusCode["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
	/**
	* The request entity has a media type which the server or resource does not support.
	* For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
	*/
	HttpStatusCode[HttpStatusCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
	/**
	* The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
	* For example, if the client asked for a part of the file that lies beyond the end of the file.
	* Called "Requested Range Not Satisfiable" previously.
	*/
	HttpStatusCode[HttpStatusCode["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
	/**
	* The server cannot meet the requirements of the Expect request-header field.
	*/
	HttpStatusCode[HttpStatusCode["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
	/**
	* This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
	* and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
	* teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
	*/
	HttpStatusCode[HttpStatusCode["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
	/**
	* The request was directed at a server that is not able to produce a response (for example because a connection reuse).
	*/
	HttpStatusCode[HttpStatusCode["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
	/**
	* The request was well-formed but was unable to be followed due to semantic errors.
	*/
	HttpStatusCode[HttpStatusCode["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
	/**
	* The resource that is being accessed is locked.
	*/
	HttpStatusCode[HttpStatusCode["LOCKED"] = 423] = "LOCKED";
	/**
	* The request failed due to failure of a previous request (e.g., a PROPPATCH).
	*/
	HttpStatusCode[HttpStatusCode["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
	/**
	* The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
	*/
	HttpStatusCode[HttpStatusCode["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
	/**
	* The origin server requires the request to be conditional.
	* Intended to prevent "the 'lost update' problem, where a client
	* GETs a resource's state, modifies it, and PUTs it back to the server,
	* when meanwhile a third party has modified the state on the server, leading to a conflict."
	*/
	HttpStatusCode[HttpStatusCode["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
	/**
	* The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
	*/
	HttpStatusCode[HttpStatusCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
	/**
	* The server is unwilling to process the request because either an individual header field,
	* or all the header fields collectively, are too large.
	*/
	HttpStatusCode[HttpStatusCode["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
	/**
	* A server operator has received a legal demand to deny access to a resource or to a set of resources
	* that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
	*/
	HttpStatusCode[HttpStatusCode["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
	/**
	* A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
	*/
	HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
	/**
	* The server either does not recognize the request method, or it lacks the ability to fulfill the request.
	* Usually this implies future availability (e.g., a new feature of a web-service API).
	*/
	HttpStatusCode[HttpStatusCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
	/**
	* The server was acting as a gateway or proxy and received an invalid response from the upstream server.
	*/
	HttpStatusCode[HttpStatusCode["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
	/**
	* The server is currently unavailable (because it is overloaded or down for maintenance).
	* Generally, this is a temporary state.
	*/
	HttpStatusCode[HttpStatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
	/**
	* The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
	*/
	HttpStatusCode[HttpStatusCode["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
	/**
	* The server does not support the HTTP protocol version used in the request
	*/
	HttpStatusCode[HttpStatusCode["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
	/**
	* Transparent content negotiation for the request results in a circular reference.
	*/
	HttpStatusCode[HttpStatusCode["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
	/**
	* The server is unable to store the representation needed to complete the request.
	*/
	HttpStatusCode[HttpStatusCode["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
	/**
	* The server detected an infinite loop while processing the request.
	*/
	HttpStatusCode[HttpStatusCode["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
	/**
	* Further extensions to the request are required for the server to fulfill it.
	*/
	HttpStatusCode[HttpStatusCode["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
	/**
	* The client needs to authenticate to gain network access.
	* Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
	* to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
	*/
	HttpStatusCode[HttpStatusCode["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/array.js
/**
* Performs a shallow comparison between two arrays to determine if they are equivalent.
* @param { Array } arr1 The array to process
* @param { Array } arr2 The array to process
* @returns Returns true if the values are equivalent, else false.
*
* @example
* arrayShallowEqual([1, 2, 3], [1, 2, 3]) // => true
* arrayShallowEqual([1, 2, {}], [1, 2, {}]) // => false
*/
function arrayShallowEqual(arr1, arr2) {
	if (arr1.length !== arr2.length) return false;
	return arr1.every((a, i) => a === arr2[i]);
}
/**
* Flattens {array} into a single level deep array.
* @param { ReadonlyArray } array The array with arrays inside to process
* @returns { Array } Returns the new array
*
* @example
* flatten([[1, 2], [3, 4]])
* // => [1, 2, 3, 4]
*/
function flatten(array) {
	return [].concat(...array);
}
/**
* Get the last item of an array
* @param { ReadonlyArray } arr the array
* @returns the last item of the array or undefined
*
* @example
* last([1, 2, 3]) // => 3
* last([]) // => undefined
*/
function last(arr) {
	return arr[arr.length - 1];
}
/**
* Returns a new array of unique values checked with predicate function
* @param { Array } arr1 The array to process
* @param { Array } arr2 The array to process
* @param { Function } predicate The function to be used to get value
* @returns Returns a new array
*
* @example
* mergeArraysBy([{ a: 1, b: 1 }, { a: 2, b: 2 }], [{ a: 1, b: 3 }, { a: 3, b: 4 }], (x, y) => x.a === y.a)
* // => [{ a: 1, b: 3 }, { a: 2, b: 2 }, { a: 3, b: 4 }]
*
*/
function mergeArraysBy(arr1, arr2, predicate) {
	const arr = arr1.map((t) => arr2.find((u) => predicate(t, u)) ?? t);
	const rest = arr2.filter((u) => !arr1.some((t) => predicate(t, u)));
	return [...arr, ...rest];
}
/**
* Returns a new array of unique values checked with key
* @param { Array } arr1 The array to process
* @param { Array } arr2 The array to process
* @param { String } key The key to be used to get value
* @returns Returns a new array
*
* @example
* mergeArraysByKey([{ a: 1, b: 1 }, { a: 2, b: 2 }], [{ a: 1, b: 3 }, { a: 3, b: 4 }], 'a')
* // => [{ a: 1, b: 3 }, { a: 2, b: 2 }, { a: 3, b: 4 }]
*
*/
function mergeArraysByKey(arr1, arr2, key) {
	const fn = (t, u) => t[key] === u[key];
	return mergeArraysBy(arr1, arr2, fn);
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/async.js
var CancelAsync$1 = class extends Error {};
/**
* If operation failed - retry it until it success, but maximum 'maxRetries' times
* @param { Function } operation The function to process
* @param { Number } maxRetries The number of times to perform the operation
* @param { Number } backoff The time to wait until perform operation again
* @returns { Promise<T> }
*
* @example
* let i = 0
* const operation = () => {
*    i++
*    return i < 3 ? Promise.reject() Promise.resolve(5)
* }
* await retry(operation) // => 5
*/
async function retry(operation, maxRetries = 5, backoff = 100) {
	let retries = 0;
	let timeout = 0;
	do
		try {
			return await operation();
		} catch (error) {
			if (error instanceof CancelAsync$1) throw error;
			else if (++retries <= maxRetries || !maxRetries) {
				timeout += backoff;
				await wait(timeout);
			} else throw error;
		}
	while (true);
}
retry.CancelAsync = CancelAsync$1;
/**
* Create an async delay
* @param { Number } timeout The time to wait until resolve the promise
* @returns { Promise<void> }
*
* @example
* await wait(1000)
* console.log('some text') // => log 'some text' after 1 second
*/
async function wait(timeout) {
	return new Promise((resolve) => setTimeout(resolve, timeout));
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/colors.js
var DEFAULT_COLORS = [
	"#F2209E",
	"#00B4FF",
	"#FFE100",
	"#00C06E",
	"#FF2424",
	"#3F60FC",
	"#BFD0FF",
	"#FF92FF",
	"#6EA600",
	"#FF800E",
	"#7CA69D",
	"#597DB3",
	"#F2C200",
	"#FFB380",
	"#A65369",
	"#FB9292",
	"#6CD9B5",
	"#D9A3B8",
	"#ACB7C9",
	"#BF7960",
	"#F2BEB6",
	"#B20030",
	"#D03D9F",
	"#C480FF",
	"#CCB499",
	"#F20061",
	"#5CE600",
	"#D48E00",
	"#8D29A6"
];
var LS_KEY$1 = "colors";
/**
* Cache colors so that resources have consistently the same
* color while duplication between resources is avoided as much
* as possible.
*
* This class should not be used directly, prefer using the
* `colorCache` object directly.
*/
var ColorCache = class {
	colors;
	constructor(colors) {
		this.colors = colors;
	}
	getColor(context, key) {
		const cache = JSON.parse(localStorage.getItem(LS_KEY$1) || "{}");
		if (!cache[context]) cache[context] = {};
		if (!cache[context][key]) {
			const index = Object.keys(cache[context]).length % this.colors.length;
			cache[context][key] = this.colors[index];
			localStorage.setItem(LS_KEY$1, JSON.stringify(cache));
		}
		return cache[context][key];
	}
};
new ColorCache(DEFAULT_COLORS);
/**
* Determines a contrast color based on the luminosity of {color}
* @param {string} color The color to process
* @param {string} darkColor Value to be returned as darkColor(default = 'black')
* @param {string} lightColor Value to be returned as lightColor(default = 'white')
* Returns {darkColor} if {color} is light, {lightColor} otherwise.
*
* @example
* getContrastColor('#ffffff') // => 'black' (returns default darkColor)
* getContrastColor('#ffffff', 'grey', 'pink') // => 'grey'
* getContrastColor('#000000', 'grey', 'pink') // => 'pink'
*/
function getContrastColor(color, darkColor = "black", lightColor = "white") {
	const colorString = color.charAt(0) === "#" ? color.substring(1, 7) : color;
	const r = parseInt(colorString.substring(0, 2), 16);
	const g = parseInt(colorString.substring(2, 4), 16);
	const b = parseInt(colorString.substring(4, 6), 16);
	return r * .299 + g * .587 + b * .114 > 186 ? darkColor : lightColor;
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
	if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
	var number = Number(dirtyNumber);
	if (isNaN(number)) return number;
	return number < 0 ? Math.ceil(number) : Math.floor(number);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
	if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/toDate/index.js
/**
* @name toDate
* @category Common Helpers
* @summary Convert the given argument to an instance of Date.
*
* @description
* Convert the given argument to an instance of Date.
*
* If the argument is an instance of Date, the function returns its clone.
*
* If the argument is a number, it is treated as a timestamp.
*
* If the argument is none of the above, the function returns Invalid Date.
*
* **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
*
* @param {Date|Number} argument - the value to convert
* @returns {Date} the parsed date in the local time zone
* @throws {TypeError} 1 argument required
*
* @example
* // Clone the date:
* const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
* //=> Tue Feb 11 2014 11:30:30
*
* @example
* // Convert the timestamp to date:
* const result = toDate(1392098430000)
* //=> Tue Feb 11 2014 11:30:30
*/
function toDate(argument) {
	requiredArgs(1, arguments);
	var argStr = Object.prototype.toString.call(argument);
	if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") return new Date(argument.getTime());
	else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
	else {
		if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
			console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
			console.warn((/* @__PURE__ */ new Error()).stack);
		}
		return /* @__PURE__ */ new Date(NaN);
	}
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/addDays/index.js
/**
* @name addDays
* @category Day Helpers
* @summary Add the specified number of days to the given date.
*
* @description
* Add the specified number of days to the given date.
*
* @param {Date|Number} date - the date to be changed
* @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
* @returns {Date} - the new date with the days added
* @throws {TypeError} - 2 arguments required
*
* @example
* // Add 10 days to 1 September 2014:
* const result = addDays(new Date(2014, 8, 1), 10)
* //=> Thu Sep 11 2014 00:00:00
*/
function addDays(dirtyDate, dirtyAmount) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var amount = toInteger(dirtyAmount);
	if (isNaN(amount)) return /* @__PURE__ */ new Date(NaN);
	if (!amount) return date;
	date.setDate(date.getDate() + amount);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/addMonths/index.js
/**
* @name addMonths
* @category Month Helpers
* @summary Add the specified number of months to the given date.
*
* @description
* Add the specified number of months to the given date.
*
* @param {Date|Number} date - the date to be changed
* @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
* @returns {Date} the new date with the months added
* @throws {TypeError} 2 arguments required
*
* @example
* // Add 5 months to 1 September 2014:
* const result = addMonths(new Date(2014, 8, 1), 5)
* //=> Sun Feb 01 2015 00:00:00
*/
function addMonths(dirtyDate, dirtyAmount) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var amount = toInteger(dirtyAmount);
	if (isNaN(amount)) return /* @__PURE__ */ new Date(NaN);
	if (!amount) return date;
	var dayOfMonth = date.getDate();
	var endOfDesiredMonth = new Date(date.getTime());
	endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	if (dayOfMonth >= endOfDesiredMonth.getDate()) return endOfDesiredMonth;
	else {
		date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
		return date;
	}
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/add/index.js
/**
* @name add
* @category Common Helpers
* @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
*
* @description
* Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
*
* @param {Date|Number} date - the date to be changed
* @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
*
* | Key            | Description                        |
* |----------------|------------------------------------|
* | years          | Amount of years to be added        |
* | months         | Amount of months to be added       |
* | weeks          | Amount of weeks to be added        |
* | days           | Amount of days to be added         |
* | hours          | Amount of hours to be added        |
* | minutes        | Amount of minutes to be added      |
* | seconds        | Amount of seconds to be added      |
*
* All values default to 0
*
* @returns {Date} the new date with the seconds added
* @throws {TypeError} 2 arguments required
*
* @example
* // Add the following duration to 1 September 2014, 10:19:50
* const result = add(new Date(2014, 8, 1, 10, 19, 50), {
*   years: 2,
*   months: 9,
*   weeks: 1,
*   days: 7,
*   hours: 5,
*   minutes: 9,
*   seconds: 30,
* })
* //=> Thu Jun 15 2017 15:29:20
*/
function add(dirtyDate, duration) {
	requiredArgs(2, arguments);
	if (!duration || _typeof(duration) !== "object") return /* @__PURE__ */ new Date(NaN);
	var years = duration.years ? toInteger(duration.years) : 0;
	var months = duration.months ? toInteger(duration.months) : 0;
	var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
	var days = duration.days ? toInteger(duration.days) : 0;
	var hours = duration.hours ? toInteger(duration.hours) : 0;
	var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
	var seconds = duration.seconds ? toInteger(duration.seconds) : 0;
	var date = toDate(dirtyDate);
	var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date;
	var dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
	var msToAdd = (seconds + (minutes + hours * 60) * 60) * 1e3;
	return new Date(dateWithDays.getTime() + msToAdd);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/addMilliseconds/index.js
/**
* @name addMilliseconds
* @category Millisecond Helpers
* @summary Add the specified number of milliseconds to the given date.
*
* @description
* Add the specified number of milliseconds to the given date.
*
* @param {Date|Number} date - the date to be changed
* @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
* @returns {Date} the new date with the milliseconds added
* @throws {TypeError} 2 arguments required
*
* @example
* // Add 750 milliseconds to 10 July 2014 12:45:30.000:
* const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
* //=> Thu Jul 10 2014 12:45:30.750
*/
function addMilliseconds(dirtyDate, dirtyAmount) {
	requiredArgs(2, arguments);
	var timestamp = toDate(dirtyDate).getTime();
	var amount = toInteger(dirtyAmount);
	return new Date(timestamp + amount);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
	return defaultOptions;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
* Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
* They usually appear for dates that denote time before the timezones were introduced
* (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
* and GMT+01:00:00 after that date)
*
* Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
* which would lead to incorrect calculations.
*
* This function returns the timezone offset in milliseconds that takes seconds in account.
*/
function getTimezoneOffsetInMilliseconds(date) {
	var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	utcDate.setUTCFullYear(date.getFullYear());
	return date.getTime() - utcDate.getTime();
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/startOfDay/index.js
/**
* @name startOfDay
* @category Day Helpers
* @summary Return the start of a day for the given date.
*
* @description
* Return the start of a day for the given date.
* The result will be in the local timezone.
*
* @param {Date|Number} date - the original date
* @returns {Date} the start of a day
* @throws {TypeError} 1 argument required
*
* @example
* // The start of a day for 2 September 2014 11:55:00:
* const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
* //=> Tue Sep 02 2014 00:00:00
*/
function startOfDay(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	date.setHours(0, 0, 0, 0);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInCalendarDays/index.js
var MILLISECONDS_IN_DAY$2 = 864e5;
/**
* @name differenceInCalendarDays
* @category Day Helpers
* @summary Get the number of calendar days between the given dates.
*
* @description
* Get the number of calendar days between the given dates. This means that the times are removed
* from the dates and then the difference in days is calculated.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of calendar days
* @throws {TypeError} 2 arguments required
*
* @example
* // How many calendar days are between
* // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
* const result = differenceInCalendarDays(
*   new Date(2012, 6, 2, 0, 0),
*   new Date(2011, 6, 2, 23, 0)
* )
* //=> 366
* // How many calendar days are between
* // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
* const result = differenceInCalendarDays(
*   new Date(2011, 6, 3, 0, 1),
*   new Date(2011, 6, 2, 23, 59)
* )
* //=> 1
*/
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var startOfDayLeft = startOfDay(dirtyDateLeft);
	var startOfDayRight = startOfDay(dirtyDateRight);
	var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
	var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
	return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$2);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/compareAsc/index.js
/**
* @name compareAsc
* @category Common Helpers
* @summary Compare the two dates and return -1, 0 or 1.
*
* @description
* Compare the two dates and return 1 if the first date is after the second,
* -1 if the first date is before the second or 0 if dates are equal.
*
* @param {Date|Number} dateLeft - the first date to compare
* @param {Date|Number} dateRight - the second date to compare
* @returns {Number} the result of the comparison
* @throws {TypeError} 2 arguments required
*
* @example
* // Compare 11 February 1987 and 10 July 1989:
* const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
* //=> -1
*
* @example
* // Sort the array of dates:
* const result = [
*   new Date(1995, 6, 2),
*   new Date(1987, 1, 11),
*   new Date(1989, 6, 10)
* ].sort(compareAsc)
* //=> [
* //   Wed Feb 11 1987 00:00:00,
* //   Mon Jul 10 1989 00:00:00,
* //   Sun Jul 02 1995 00:00:00
* // ]
*/
function compareAsc(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	var diff = dateLeft.getTime() - dateRight.getTime();
	if (diff < 0) return -1;
	else if (diff > 0) return 1;
	else return diff;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/constants/index.js
/**
* Days in 1 year
* One years equals 365.2425 days according to the formula:
*
* > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
* > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
*
* @name daysInYear
* @constant
* @type {number}
* @default
*/
var daysInYear = 365.2425;
/**
* Maximum allowed time.
*
* @name maxTime
* @constant
* @type {number}
* @default
*/
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
/**
* Milliseconds in 1 minute
*
* @name millisecondsInMinute
* @constant
* @type {number}
* @default
*/
var millisecondsInMinute = 6e4;
/**
* Milliseconds in 1 hour
*
* @name millisecondsInHour
* @constant
* @type {number}
* @default
*/
var millisecondsInHour = 36e5;
/**
* Milliseconds in 1 second
*
* @name millisecondsInSecond
* @constant
* @type {number}
* @default
*/
var millisecondsInSecond = 1e3;
-maxTime;
/**
* Seconds in 1 day
*
* @name secondsInDay
* @constant
* @type {number}
* @default
*/
var secondsInDay = 3600 * 24;
secondsInDay * 7;
secondsInDay * daysInYear / 12 * 3;
//#endregion
//#region ../../../../node_modules/date-fns/esm/isDate/index.js
/**
* @name isDate
* @category Common Helpers
* @summary Is the given value a date?
*
* @description
* Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
*
* @param {*} value - the value to check
* @returns {boolean} true if the given value is a date
* @throws {TypeError} 1 arguments required
*
* @example
* // For a valid date:
* const result = isDate(new Date())
* //=> true
*
* @example
* // For an invalid date:
* const result = isDate(new Date(NaN))
* //=> true
*
* @example
* // For some value:
* const result = isDate('2014-02-31')
* //=> false
*
* @example
* // For an object:
* const result = isDate({})
* //=> false
*/
function isDate$1(value) {
	requiredArgs(1, arguments);
	return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/isValid/index.js
/**
* @name isValid
* @category Common Helpers
* @summary Is the given date valid?
*
* @description
* Returns false if argument is Invalid Date and true otherwise.
* Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
* Invalid Date is a Date, whose time value is NaN.
*
* Time value of Date: http://es5.github.io/#x15.9.1.1
*
* @param {*} date - the date to check
* @returns {Boolean} the date is valid
* @throws {TypeError} 1 argument required
*
* @example
* // For the valid date:
* const result = isValid(new Date(2014, 1, 31))
* //=> true
*
* @example
* // For the value, convertable into a date:
* const result = isValid(1393804800000)
* //=> true
*
* @example
* // For the invalid date:
* const result = isValid(new Date(''))
* //=> false
*/
function isValid(dirtyDate) {
	requiredArgs(1, arguments);
	if (!isDate$1(dirtyDate) && typeof dirtyDate !== "number") return false;
	var date = toDate(dirtyDate);
	return !isNaN(Number(date));
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInCalendarMonths/index.js
/**
* @name differenceInCalendarMonths
* @category Month Helpers
* @summary Get the number of calendar months between the given dates.
*
* @description
* Get the number of calendar months between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of calendar months
* @throws {TypeError} 2 arguments required
*
* @example
* // How many calendar months are between 31 January 2014 and 1 September 2014?
* const result = differenceInCalendarMonths(
*   new Date(2014, 8, 1),
*   new Date(2014, 0, 31)
* )
* //=> 8
*/
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	return yearDiff * 12 + monthDiff;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInCalendarYears/index.js
/**
* @name differenceInCalendarYears
* @category Year Helpers
* @summary Get the number of calendar years between the given dates.
*
* @description
* Get the number of calendar years between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of calendar years
* @throws {TypeError} 2 arguments required
*
* @example
* // How many calendar years are between 31 December 2013 and 11 February 2015?
* const result = differenceInCalendarYears(
*   new Date(2015, 1, 11),
*   new Date(2013, 11, 31)
* )
* //=> 2
*/
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	return dateLeft.getFullYear() - dateRight.getFullYear();
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInDays/index.js
function compareLocalAsc(dateLeft, dateRight) {
	var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	if (diff < 0) return -1;
	else if (diff > 0) return 1;
	else return diff;
}
/**
* @name differenceInDays
* @category Day Helpers
* @summary Get the number of full days between the given dates.
*
* @description
* Get the number of full day periods between two dates. Fractional days are
* truncated towards zero.
*
* One "full day" is the distance between a local time in one day to the same
* local time on the next or previous day. A full day can sometimes be less than
* or more than 24 hours if a daylight savings change happens between two dates.
*
* To ignore DST and only measure exact 24-hour periods, use this instead:
* `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
*
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of full days according to the local timezone
* @throws {TypeError} 2 arguments required
*
* @example
* // How many full days are between
* // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
* const result = differenceInDays(
*   new Date(2012, 6, 2, 0, 0),
*   new Date(2011, 6, 2, 23, 0)
* )
* //=> 365
* // How many full days are between
* // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
* const result = differenceInDays(
*   new Date(2011, 6, 3, 0, 1),
*   new Date(2011, 6, 2, 23, 59)
* )
* //=> 0
* // How many full days are between
* // 1 March 2020 0:00 and 1 June 2020 0:00 ?
* // Note: because local time is used, the
* // result will always be 92 days, even in
* // time zones where DST starts and the
* // period has only 92*24-1 hours.
* const result = differenceInDays(
*   new Date(2020, 5, 1),
*   new Date(2020, 2, 1)
* )
//=> 92
*/
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	var sign = compareLocalAsc(dateLeft, dateRight);
	var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
	dateLeft.setDate(dateLeft.getDate() - sign * difference);
	var result = sign * (difference - Number(compareLocalAsc(dateLeft, dateRight) === -sign));
	return result === 0 ? 0 : result;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInMilliseconds/index.js
/**
* @name differenceInMilliseconds
* @category Millisecond Helpers
* @summary Get the number of milliseconds between the given dates.
*
* @description
* Get the number of milliseconds between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of milliseconds
* @throws {TypeError} 2 arguments required
*
* @example
* // How many milliseconds are between
* // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
* const result = differenceInMilliseconds(
*   new Date(2014, 6, 2, 12, 30, 21, 700),
*   new Date(2014, 6, 2, 12, 30, 20, 600)
* )
* //=> 1100
*/
function differenceInMilliseconds(dateLeft, dateRight) {
	requiredArgs(2, arguments);
	return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMap = {
	ceil: Math.ceil,
	round: Math.round,
	floor: Math.floor,
	trunc: function trunc(value) {
		return value < 0 ? Math.ceil(value) : Math.floor(value);
	}
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
	return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInHours/index.js
/**
* @name differenceInHours
* @category Hour Helpers
* @summary Get the number of hours between the given dates.
*
* @description
* Get the number of hours between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @param {Object} [options] - an object with options.
* @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
* @returns {Number} the number of hours
* @throws {TypeError} 2 arguments required
*
* @example
* // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
* const result = differenceInHours(
*   new Date(2014, 6, 2, 19, 0),
*   new Date(2014, 6, 2, 6, 50)
* )
* //=> 12
*/
function differenceInHours(dateLeft, dateRight, options) {
	requiredArgs(2, arguments);
	var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
	return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInMinutes/index.js
/**
* @name differenceInMinutes
* @category Minute Helpers
* @summary Get the number of minutes between the given dates.
*
* @description
* Get the signed number of full (rounded towards 0) minutes between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @param {Object} [options] - an object with options.
* @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
* @returns {Number} the number of minutes
* @throws {TypeError} 2 arguments required
*
* @example
* // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
* const result = differenceInMinutes(
*   new Date(2014, 6, 2, 12, 20, 0),
*   new Date(2014, 6, 2, 12, 7, 59)
* )
* //=> 12
*
* @example
* // How many minutes are between 10:01:59 and 10:00:00
* const result = differenceInMinutes(
*   new Date(2000, 0, 1, 10, 0, 0),
*   new Date(2000, 0, 1, 10, 1, 59)
* )
* //=> -1
*/
function differenceInMinutes(dateLeft, dateRight, options) {
	requiredArgs(2, arguments);
	var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
	return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/endOfDay/index.js
/**
* @name endOfDay
* @category Day Helpers
* @summary Return the end of a day for the given date.
*
* @description
* Return the end of a day for the given date.
* The result will be in the local timezone.
*
* @param {Date|Number} date - the original date
* @returns {Date} the end of a day
* @throws {TypeError} 1 argument required
*
* @example
* // The end of a day for 2 September 2014 11:55:00:
* const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
* //=> Tue Sep 02 2014 23:59:59.999
*/
function endOfDay(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	date.setHours(23, 59, 59, 999);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/endOfMonth/index.js
/**
* @name endOfMonth
* @category Month Helpers
* @summary Return the end of a month for the given date.
*
* @description
* Return the end of a month for the given date.
* The result will be in the local timezone.
*
* @param {Date|Number} date - the original date
* @returns {Date} the end of a month
* @throws {TypeError} 1 argument required
*
* @example
* // The end of a month for 2 September 2014 11:55:00:
* const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
* //=> Tue Sep 30 2014 23:59:59.999
*/
function endOfMonth(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var month = date.getMonth();
	date.setFullYear(date.getFullYear(), month + 1, 0);
	date.setHours(23, 59, 59, 999);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/isLastDayOfMonth/index.js
/**
* @name isLastDayOfMonth
* @category Month Helpers
* @summary Is the given date the last day of a month?
*
* @description
* Is the given date the last day of a month?
*
* @param {Date|Number} date - the date to check
* @returns {Boolean} the date is the last day of a month
* @throws {TypeError} 1 argument required
*
* @example
* // Is 28 February 2014 the last day of a month?
* const result = isLastDayOfMonth(new Date(2014, 1, 28))
* //=> true
*/
function isLastDayOfMonth(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInMonths/index.js
/**
* @name differenceInMonths
* @category Month Helpers
* @summary Get the number of full months between the given dates.
*
* @description
* Get the number of full months between the given dates using trunc as a default rounding method.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of full months
* @throws {TypeError} 2 arguments required
*
* @example
* // How many full months are between 31 January 2014 and 1 September 2014?
* const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
* //=> 7
*/
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	var sign = compareAsc(dateLeft, dateRight);
	var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
	var result;
	if (difference < 1) result = 0;
	else {
		if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) dateLeft.setDate(30);
		dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
		var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
		if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
		result = sign * (difference - Number(isLastMonthNotFull));
	}
	return result === 0 ? 0 : result;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInSeconds/index.js
/**
* @name differenceInSeconds
* @category Second Helpers
* @summary Get the number of seconds between the given dates.
*
* @description
* Get the number of seconds between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @param {Object} [options] - an object with options.
* @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
* @returns {Number} the number of seconds
* @throws {TypeError} 2 arguments required
*
* @example
* // How many seconds are between
* // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
* const result = differenceInSeconds(
*   new Date(2014, 6, 2, 12, 30, 20, 0),
*   new Date(2014, 6, 2, 12, 30, 7, 999)
* )
* //=> 12
*/
function differenceInSeconds(dateLeft, dateRight, options) {
	requiredArgs(2, arguments);
	var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
	return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/differenceInYears/index.js
/**
* @name differenceInYears
* @category Year Helpers
* @summary Get the number of full years between the given dates.
*
* @description
* Get the number of full years between the given dates.
*
* @param {Date|Number} dateLeft - the later date
* @param {Date|Number} dateRight - the earlier date
* @returns {Number} the number of full years
* @throws {TypeError} 2 arguments required
*
* @example
* // How many full years are between 31 December 2013 and 11 February 2015?
* const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
* //=> 1
*/
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	requiredArgs(2, arguments);
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	var sign = compareAsc(dateLeft, dateRight);
	var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
	dateLeft.setFullYear(1584);
	dateRight.setFullYear(1584);
	var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
	var result = sign * (difference - Number(isLastYearNotFull));
	return result === 0 ? 0 : result;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/subMilliseconds/index.js
/**
* @name subMilliseconds
* @category Millisecond Helpers
* @summary Subtract the specified number of milliseconds from the given date.
*
* @description
* Subtract the specified number of milliseconds from the given date.
*
* @param {Date|Number} date - the date to be changed
* @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
* @returns {Date} the new date with the milliseconds subtracted
* @throws {TypeError} 2 arguments required
*
* @example
* // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
* const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
* //=> Thu Jul 10 2014 12:45:29.250
*/
function subMilliseconds(dirtyDate, dirtyAmount) {
	requiredArgs(2, arguments);
	return addMilliseconds(dirtyDate, -toInteger(dirtyAmount));
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js
var MILLISECONDS_IN_DAY$1 = 864e5;
function getUTCDayOfYear(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var timestamp = date.getTime();
	date.setUTCMonth(0, 1);
	date.setUTCHours(0, 0, 0, 0);
	var difference = timestamp - date.getTime();
	return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function startOfUTCISOWeek(dirtyDate) {
	requiredArgs(1, arguments);
	var weekStartsOn = 1;
	var date = toDate(dirtyDate);
	var day = date.getUTCDay();
	var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	date.setUTCDate(date.getUTCDate() - diff);
	date.setUTCHours(0, 0, 0, 0);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function getUTCISOWeekYear(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var year = date.getUTCFullYear();
	var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
	fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
	var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
	fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
	if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
	else if (date.getTime() >= startOfThisYear.getTime()) return year;
	else return year - 1;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function startOfUTCISOWeekYear(dirtyDate) {
	requiredArgs(1, arguments);
	var year = getUTCISOWeekYear(dirtyDate);
	var fourthOfJanuary = /* @__PURE__ */ new Date(0);
	fourthOfJanuary.setUTCFullYear(year, 0, 4);
	fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	return startOfUTCISOWeek(fourthOfJanuary);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
	return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function startOfUTCWeek(dirtyDate, options) {
	var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	requiredArgs(1, arguments);
	var defaultOptions = getDefaultOptions();
	var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var date = toDate(dirtyDate);
	var day = date.getUTCDay();
	var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	date.setUTCDate(date.getUTCDate() - diff);
	date.setUTCHours(0, 0, 0, 0);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function getUTCWeekYear(dirtyDate, options) {
	var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var year = date.getUTCFullYear();
	var defaultOptions = getDefaultOptions();
	var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
	firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
	var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
	firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
	if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
	else if (date.getTime() >= startOfThisYear.getTime()) return year;
	else return year - 1;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function startOfUTCWeekYear(dirtyDate, options) {
	var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	requiredArgs(1, arguments);
	var defaultOptions = getDefaultOptions();
	var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	var year = getUTCWeekYear(dirtyDate, options);
	var firstWeek = /* @__PURE__ */ new Date(0);
	firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	firstWeek.setUTCHours(0, 0, 0, 0);
	return startOfUTCWeek(firstWeek, options);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
	requiredArgs(1, arguments);
	var date = toDate(dirtyDate);
	var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
	return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
	var sign = number < 0 ? "-" : "";
	var output = Math.abs(number).toString();
	while (output.length < targetLength) output = "0" + output;
	return sign + output;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var formatters$1 = {
	y: function y(date, token) {
		var signedYear = date.getUTCFullYear();
		var year = signedYear > 0 ? signedYear : 1 - signedYear;
		return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
	},
	M: function M(date, token) {
		var month = date.getUTCMonth();
		return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
	},
	d: function d(date, token) {
		return addLeadingZeros(date.getUTCDate(), token.length);
	},
	a: function a(date, token) {
		var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (token) {
			case "a":
			case "aa": return dayPeriodEnumValue.toUpperCase();
			case "aaa": return dayPeriodEnumValue;
			case "aaaaa": return dayPeriodEnumValue[0];
			default: return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
		}
	},
	h: function h(date, token) {
		return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
	},
	H: function H(date, token) {
		return addLeadingZeros(date.getUTCHours(), token.length);
	},
	m: function m(date, token) {
		return addLeadingZeros(date.getUTCMinutes(), token.length);
	},
	s: function s(date, token) {
		return addLeadingZeros(date.getUTCSeconds(), token.length);
	},
	S: function S(date, token) {
		var numberOfDigits = token.length;
		var milliseconds = date.getUTCMilliseconds();
		return addLeadingZeros(Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3)), token.length);
	}
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/format/formatters/index.js
var dayPeriodEnum = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
};
var formatters = {
	G: function G(date, token, localize) {
		var era = date.getUTCFullYear() > 0 ? 1 : 0;
		switch (token) {
			case "G":
			case "GG":
			case "GGG": return localize.era(era, { width: "abbreviated" });
			case "GGGGG": return localize.era(era, { width: "narrow" });
			default: return localize.era(era, { width: "wide" });
		}
	},
	y: function y(date, token, localize) {
		if (token === "yo") {
			var signedYear = date.getUTCFullYear();
			var year = signedYear > 0 ? signedYear : 1 - signedYear;
			return localize.ordinalNumber(year, { unit: "year" });
		}
		return formatters$1.y(date, token);
	},
	Y: function Y(date, token, localize, options) {
		var signedWeekYear = getUTCWeekYear(date, options);
		var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
		if (token === "YY") return addLeadingZeros(weekYear % 100, 2);
		if (token === "Yo") return localize.ordinalNumber(weekYear, { unit: "year" });
		return addLeadingZeros(weekYear, token.length);
	},
	R: function R(date, token) {
		return addLeadingZeros(getUTCISOWeekYear(date), token.length);
	},
	u: function u(date, token) {
		return addLeadingZeros(date.getUTCFullYear(), token.length);
	},
	Q: function Q(date, token, localize) {
		var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
		switch (token) {
			case "Q": return String(quarter);
			case "QQ": return addLeadingZeros(quarter, 2);
			case "Qo": return localize.ordinalNumber(quarter, { unit: "quarter" });
			case "QQQ": return localize.quarter(quarter, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return localize.quarter(quarter, {
				width: "narrow",
				context: "formatting"
			});
			default: return localize.quarter(quarter, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function q(date, token, localize) {
		var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
		switch (token) {
			case "q": return String(quarter);
			case "qq": return addLeadingZeros(quarter, 2);
			case "qo": return localize.ordinalNumber(quarter, { unit: "quarter" });
			case "qqq": return localize.quarter(quarter, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return localize.quarter(quarter, {
				width: "narrow",
				context: "standalone"
			});
			default: return localize.quarter(quarter, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function M(date, token, localize) {
		var month = date.getUTCMonth();
		switch (token) {
			case "M":
			case "MM": return formatters$1.M(date, token);
			case "Mo": return localize.ordinalNumber(month + 1, { unit: "month" });
			case "MMM": return localize.month(month, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return localize.month(month, {
				width: "narrow",
				context: "formatting"
			});
			default: return localize.month(month, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function L(date, token, localize) {
		var month = date.getUTCMonth();
		switch (token) {
			case "L": return String(month + 1);
			case "LL": return addLeadingZeros(month + 1, 2);
			case "Lo": return localize.ordinalNumber(month + 1, { unit: "month" });
			case "LLL": return localize.month(month, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return localize.month(month, {
				width: "narrow",
				context: "standalone"
			});
			default: return localize.month(month, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function w(date, token, localize, options) {
		var week = getUTCWeek(date, options);
		if (token === "wo") return localize.ordinalNumber(week, { unit: "week" });
		return addLeadingZeros(week, token.length);
	},
	I: function I(date, token, localize) {
		var isoWeek = getUTCISOWeek(date);
		if (token === "Io") return localize.ordinalNumber(isoWeek, { unit: "week" });
		return addLeadingZeros(isoWeek, token.length);
	},
	d: function d(date, token, localize) {
		if (token === "do") return localize.ordinalNumber(date.getUTCDate(), { unit: "date" });
		return formatters$1.d(date, token);
	},
	D: function D(date, token, localize) {
		var dayOfYear = getUTCDayOfYear(date);
		if (token === "Do") return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
		return addLeadingZeros(dayOfYear, token.length);
	},
	E: function E(date, token, localize) {
		var dayOfWeek = date.getUTCDay();
		switch (token) {
			case "E":
			case "EE":
			case "EEE": return localize.day(dayOfWeek, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return localize.day(dayOfWeek, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return localize.day(dayOfWeek, {
				width: "short",
				context: "formatting"
			});
			default: return localize.day(dayOfWeek, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function e(date, token, localize, options) {
		var dayOfWeek = date.getUTCDay();
		var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
		switch (token) {
			case "e": return String(localDayOfWeek);
			case "ee": return addLeadingZeros(localDayOfWeek, 2);
			case "eo": return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
			case "eee": return localize.day(dayOfWeek, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return localize.day(dayOfWeek, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return localize.day(dayOfWeek, {
				width: "short",
				context: "formatting"
			});
			default: return localize.day(dayOfWeek, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function c(date, token, localize, options) {
		var dayOfWeek = date.getUTCDay();
		var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
		switch (token) {
			case "c": return String(localDayOfWeek);
			case "cc": return addLeadingZeros(localDayOfWeek, token.length);
			case "co": return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
			case "ccc": return localize.day(dayOfWeek, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return localize.day(dayOfWeek, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return localize.day(dayOfWeek, {
				width: "short",
				context: "standalone"
			});
			default: return localize.day(dayOfWeek, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function i(date, token, localize) {
		var dayOfWeek = date.getUTCDay();
		var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
		switch (token) {
			case "i": return String(isoDayOfWeek);
			case "ii": return addLeadingZeros(isoDayOfWeek, token.length);
			case "io": return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
			case "iii": return localize.day(dayOfWeek, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return localize.day(dayOfWeek, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return localize.day(dayOfWeek, {
				width: "short",
				context: "formatting"
			});
			default: return localize.day(dayOfWeek, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function a(date, token, localize) {
		var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
		switch (token) {
			case "a":
			case "aa": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "narrow",
				context: "formatting"
			});
			default: return localize.dayPeriod(dayPeriodEnumValue, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function b(date, token, localize) {
		var hours = date.getUTCHours();
		var dayPeriodEnumValue;
		if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
		else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
		else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
		switch (token) {
			case "b":
			case "bb": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "narrow",
				context: "formatting"
			});
			default: return localize.dayPeriod(dayPeriodEnumValue, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function B(date, token, localize) {
		var hours = date.getUTCHours();
		var dayPeriodEnumValue;
		if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
		else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
		else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
		else dayPeriodEnumValue = dayPeriodEnum.night;
		switch (token) {
			case "B":
			case "BB":
			case "BBB": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return localize.dayPeriod(dayPeriodEnumValue, {
				width: "narrow",
				context: "formatting"
			});
			default: return localize.dayPeriod(dayPeriodEnumValue, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function h(date, token, localize) {
		if (token === "ho") {
			var hours = date.getUTCHours() % 12;
			if (hours === 0) hours = 12;
			return localize.ordinalNumber(hours, { unit: "hour" });
		}
		return formatters$1.h(date, token);
	},
	H: function H(date, token, localize) {
		if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), { unit: "hour" });
		return formatters$1.H(date, token);
	},
	K: function K(date, token, localize) {
		var hours = date.getUTCHours() % 12;
		if (token === "Ko") return localize.ordinalNumber(hours, { unit: "hour" });
		return addLeadingZeros(hours, token.length);
	},
	k: function k(date, token, localize) {
		var hours = date.getUTCHours();
		if (hours === 0) hours = 24;
		if (token === "ko") return localize.ordinalNumber(hours, { unit: "hour" });
		return addLeadingZeros(hours, token.length);
	},
	m: function m(date, token, localize) {
		if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), { unit: "minute" });
		return formatters$1.m(date, token);
	},
	s: function s(date, token, localize) {
		if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), { unit: "second" });
		return formatters$1.s(date, token);
	},
	S: function S(date, token) {
		return formatters$1.S(date, token);
	},
	X: function X(date, token, _localize, options) {
		var timezoneOffset = (options._originalDate || date).getTimezoneOffset();
		if (timezoneOffset === 0) return "Z";
		switch (token) {
			case "X": return formatTimezoneWithOptionalMinutes(timezoneOffset);
			case "XXXX":
			case "XX": return formatTimezone$1(timezoneOffset);
			default: return formatTimezone$1(timezoneOffset, ":");
		}
	},
	x: function x(date, token, _localize, options) {
		var timezoneOffset = (options._originalDate || date).getTimezoneOffset();
		switch (token) {
			case "x": return formatTimezoneWithOptionalMinutes(timezoneOffset);
			case "xxxx":
			case "xx": return formatTimezone$1(timezoneOffset);
			default: return formatTimezone$1(timezoneOffset, ":");
		}
	},
	O: function O(date, token, _localize, options) {
		var timezoneOffset = (options._originalDate || date).getTimezoneOffset();
		switch (token) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + formatTimezoneShort(timezoneOffset, ":");
			default: return "GMT" + formatTimezone$1(timezoneOffset, ":");
		}
	},
	z: function z(date, token, _localize, options) {
		var timezoneOffset = (options._originalDate || date).getTimezoneOffset();
		switch (token) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + formatTimezoneShort(timezoneOffset, ":");
			default: return "GMT" + formatTimezone$1(timezoneOffset, ":");
		}
	},
	t: function t(date, token, _localize, options) {
		var originalDate = options._originalDate || date;
		return addLeadingZeros(Math.floor(originalDate.getTime() / 1e3), token.length);
	},
	T: function T(date, token, _localize, options) {
		return addLeadingZeros((options._originalDate || date).getTime(), token.length);
	}
};
function formatTimezoneShort(offset, dirtyDelimiter) {
	var sign = offset > 0 ? "-" : "+";
	var absOffset = Math.abs(offset);
	var hours = Math.floor(absOffset / 60);
	var minutes = absOffset % 60;
	if (minutes === 0) return sign + String(hours);
	var delimiter = dirtyDelimiter || "";
	return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	if (offset % 60 === 0) return (offset > 0 ? "-" : "+") + addLeadingZeros(Math.abs(offset) / 60, 2);
	return formatTimezone$1(offset, dirtyDelimiter);
}
function formatTimezone$1(offset, dirtyDelimiter) {
	var delimiter = dirtyDelimiter || "";
	var sign = offset > 0 ? "-" : "+";
	var absOffset = Math.abs(offset);
	var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
	var minutes = addLeadingZeros(absOffset % 60, 2);
	return sign + hours + delimiter + minutes;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	switch (pattern) {
		case "P": return formatLong.date({ width: "short" });
		case "PP": return formatLong.date({ width: "medium" });
		case "PPP": return formatLong.date({ width: "long" });
		default: return formatLong.date({ width: "full" });
	}
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	switch (pattern) {
		case "p": return formatLong.time({ width: "short" });
		case "pp": return formatLong.time({ width: "medium" });
		case "ppp": return formatLong.time({ width: "long" });
		default: return formatLong.time({ width: "full" });
	}
};
var longFormatters = {
	p: timeLongFormatter,
	P: function dateTimeLongFormatter(pattern, formatLong) {
		var matchResult = pattern.match(/(P+)(p+)?/) || [];
		var datePattern = matchResult[1];
		var timePattern = matchResult[2];
		if (!timePattern) return dateLongFormatter(pattern, formatLong);
		var dateTimeFormat;
		switch (datePattern) {
			case "P":
				dateTimeFormat = formatLong.dateTime({ width: "short" });
				break;
			case "PP":
				dateTimeFormat = formatLong.dateTime({ width: "medium" });
				break;
			case "PPP":
				dateTimeFormat = formatLong.dateTime({ width: "long" });
				break;
			default:
				dateTimeFormat = formatLong.dateTime({ width: "full" });
				break;
		}
		return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
	}
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
	return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
	return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
	if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
};
var formatDistance = function formatDistance(token, count, options) {
	var result;
	var tokenValue = formatDistanceLocale[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", count.toString());
	if (options !== null && options !== void 0 && options.addSuffix) if (options.comparison && options.comparison > 0) return "in " + result;
	else return result + " ago";
	return result;
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
	return function() {
		var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		var width = options.width ? String(options.width) : args.defaultWidth;
		return args.formats[width] || args.formats[args.defaultWidth];
	};
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var formatLong = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	return formatRelativeLocale[token];
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
	return function(dirtyIndex, options) {
		var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
		var valuesArray;
		if (context === "formatting" && args.formattingValues) {
			var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
			var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
			valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
		} else {
			var _defaultWidth = args.defaultWidth;
			var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
			valuesArray = args.values[_width] || args.values[_defaultWidth];
		}
		var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
		return valuesArray[index];
	};
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var localize = {
	ordinalNumber: function ordinalNumber(dirtyNumber, _options) {
		var number = Number(dirtyNumber);
		var rem100 = number % 100;
		if (rem100 > 20 || rem100 < 10) switch (rem100 % 10) {
			case 1: return number + "st";
			case 2: return number + "nd";
			case 3: return number + "rd";
		}
		return number + "th";
	},
	era: buildLocalizeFn({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: buildLocalizeFn({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: function argumentCallback(quarter) {
			return quarter - 1;
		}
	}),
	month: buildLocalizeFn({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
	return function(string) {
		var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		var width = options.width;
		var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
		var matchResult = string.match(matchPattern);
		if (!matchResult) return null;
		var matchedString = matchResult[0];
		var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
		var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
			return pattern.test(matchedString);
		}) : findKey(parsePatterns, function(pattern) {
			return pattern.test(matchedString);
		});
		var value = args.valueCallback ? args.valueCallback(key) : key;
		value = options.valueCallback ? options.valueCallback(value) : value;
		var rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
function findKey(object, predicate) {
	for (var key in object) if (object.hasOwnProperty(key) && predicate(object[key])) return key;
}
function findIndex(array, predicate) {
	for (var key = 0; key < array.length; key++) if (predicate(array[key])) return key;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
	return function(string) {
		var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		var matchResult = string.match(args.matchPattern);
		if (!matchResult) return null;
		var matchedString = matchResult[0];
		var parseResult = string.match(args.parsePattern);
		if (!parseResult) return null;
		var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
		value = options.valueCallback ? options.valueCallback(value) : value;
		var rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale_default = {
	code: "en-US",
	formatDistance,
	formatLong,
	formatRelative,
	localize,
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: function valueCallback(value) {
				return parseInt(value, 10);
			}
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: function valueCallback(index) {
				return index + 1;
			}
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/format/index.js
var formattingTokensRegExp$2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$2 = /''/g;
var unescapedLatinCharacterRegExp$2 = /[a-zA-Z]/;
/**
* @name format
* @category Common Helpers
* @summary Format the date.
*
* @description
* Return the formatted date string in the given format. The result may vary by locale.
*
* > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
* > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* The characters wrapped between two single quotes characters (') are escaped.
* Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
* (see the last example)
*
* Format of the string is based on Unicode Technical Standard #35:
* https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* with a few additions (see note 7 below the table).
*
* Accepted patterns:
* | Unit                            | Pattern | Result examples                   | Notes |
* |---------------------------------|---------|-----------------------------------|-------|
* | Era                             | G..GGG  | AD, BC                            |       |
* |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
* |                                 | GGGGG   | A, B                              |       |
* | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
* |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
* |                                 | yy      | 44, 01, 00, 17                    | 5     |
* |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
* |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
* |                                 | yyyyy   | ...                               | 3,5   |
* | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
* |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
* |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
* |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
* |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
* |                                 | YYYYY   | ...                               | 3,5   |
* | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
* |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
* |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
* |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
* |                                 | RRRRR   | ...                               | 3,5,7 |
* | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
* |                                 | uu      | -43, 01, 1900, 2017               | 5     |
* |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
* |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
* |                                 | uuuuu   | ...                               | 3,5   |
* | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
* |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
* |                                 | QQ      | 01, 02, 03, 04                    |       |
* |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
* |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
* |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
* | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
* |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
* |                                 | qq      | 01, 02, 03, 04                    |       |
* |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
* |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
* |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
* | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
* |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
* |                                 | MM      | 01, 02, ..., 12                   |       |
* |                                 | MMM     | Jan, Feb, ..., Dec                |       |
* |                                 | MMMM    | January, February, ..., December  | 2     |
* |                                 | MMMMM   | J, F, ..., D                      |       |
* | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
* |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
* |                                 | LL      | 01, 02, ..., 12                   |       |
* |                                 | LLL     | Jan, Feb, ..., Dec                |       |
* |                                 | LLLL    | January, February, ..., December  | 2     |
* |                                 | LLLLL   | J, F, ..., D                      |       |
* | Local week of year              | w       | 1, 2, ..., 53                     |       |
* |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
* |                                 | ww      | 01, 02, ..., 53                   |       |
* | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
* |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
* |                                 | II      | 01, 02, ..., 53                   | 7     |
* | Day of month                    | d       | 1, 2, ..., 31                     |       |
* |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
* |                                 | dd      | 01, 02, ..., 31                   |       |
* | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
* |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
* |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
* |                                 | DDD     | 001, 002, ..., 365, 366           |       |
* |                                 | DDDD    | ...                               | 3     |
* | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
* |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
* |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
* |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
* |                                 | ii      | 01, 02, ..., 07                   | 7     |
* |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
* |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
* |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
* |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
* | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
* |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
* |                                 | ee      | 02, 03, ..., 01                   |       |
* |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
* |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 | eeeee   | M, T, W, T, F, S, S               |       |
* |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
* |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
* |                                 | cc      | 02, 03, ..., 01                   |       |
* |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
* |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 | ccccc   | M, T, W, T, F, S, S               |       |
* |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | AM, PM                          | a..aa   | AM, PM                            |       |
* |                                 | aaa     | am, pm                            |       |
* |                                 | aaaa    | a.m., p.m.                        | 2     |
* |                                 | aaaaa   | a, p                              |       |
* | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
* |                                 | bbb     | am, pm, noon, midnight            |       |
* |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
* |                                 | bbbbb   | a, p, n, mi                       |       |
* | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
* |                                 | BBBB    | at night, in the morning, ...     | 2     |
* |                                 | BBBBB   | at night, in the morning, ...     |       |
* | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
* |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
* |                                 | hh      | 01, 02, ..., 11, 12               |       |
* | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
* |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
* |                                 | HH      | 00, 01, 02, ..., 23               |       |
* | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
* |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
* |                                 | KK      | 01, 02, ..., 11, 00               |       |
* | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
* |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
* |                                 | kk      | 24, 01, 02, ..., 23               |       |
* | Minute                          | m       | 0, 1, ..., 59                     |       |
* |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
* |                                 | mm      | 00, 01, ..., 59                   |       |
* | Second                          | s       | 0, 1, ..., 59                     |       |
* |                                 | so      | 0th, 1st, ..., 59th               | 7     |
* |                                 | ss      | 00, 01, ..., 59                   |       |
* | Fraction of second              | S       | 0, 1, ..., 9                      |       |
* |                                 | SS      | 00, 01, ..., 99                   |       |
* |                                 | SSS     | 000, 001, ..., 999                |       |
* |                                 | SSSS    | ...                               | 3     |
* | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
* |                                 | XX      | -0800, +0530, Z                   |       |
* |                                 | XXX     | -08:00, +05:30, Z                 |       |
* |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
* |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
* | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
* |                                 | xx      | -0800, +0530, +0000               |       |
* |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
* |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
* |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
* | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
* |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
* | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
* |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
* | Seconds timestamp               | t       | 512969520                         | 7     |
* |                                 | tt      | ...                               | 3,7   |
* | Milliseconds timestamp          | T       | 512969520900                      | 7     |
* |                                 | TT      | ...                               | 3,7   |
* | Long localized date             | P       | 04/29/1453                        | 7     |
* |                                 | PP      | Apr 29, 1453                      | 7     |
* |                                 | PPP     | April 29th, 1453                  | 7     |
* |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
* | Long localized time             | p       | 12:00 AM                          | 7     |
* |                                 | pp      | 12:00:00 AM                       | 7     |
* |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
* |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
* | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
* |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
* |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
* |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
* Notes:
* 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
*    are the same as "stand-alone" units, but are different in some languages.
*    "Formatting" units are declined according to the rules of the language
*    in the context of a date. "Stand-alone" units are always nominative singular:
*
*    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
*
*    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
*
* 2. Any sequence of the identical letters is a pattern, unless it is escaped by
*    the single quote characters (see below).
*    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
*    the output will be the same as default pattern for this unit, usually
*    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
*    are marked with "2" in the last column of the table.
*
*    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
*
*    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
*
*    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
*
*    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
*
*    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
*
* 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
*    The output will be padded with zeros to match the length of the pattern.
*
*    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
*
* 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
*    These tokens represent the shortest form of the quarter.
*
* 5. The main difference between `y` and `u` patterns are B.C. years:
*
*    | Year | `y` | `u` |
*    |------|-----|-----|
*    | AC 1 |   1 |   1 |
*    | BC 1 |   1 |   0 |
*    | BC 2 |   2 |  -1 |
*
*    Also `yy` always returns the last two digits of a year,
*    while `uu` pads single digit years to 2 characters and returns other years unchanged:
*
*    | Year | `yy` | `uu` |
*    |------|------|------|
*    | 1    |   01 |   01 |
*    | 14   |   14 |   14 |
*    | 376  |   76 |  376 |
*    | 1453 |   53 | 1453 |
*
*    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
*    except local week-numbering years are dependent on `options.weekStartsOn`
*    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
*    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
*
* 6. Specific non-location timezones are currently unavailable in `date-fns`,
*    so right now these tokens fall back to GMT timezones.
*
* 7. These patterns are not in the Unicode Technical Standard #35:
*    - `i`: ISO day of week
*    - `I`: ISO week of year
*    - `R`: ISO week-numbering year
*    - `t`: seconds timestamp
*    - `T`: milliseconds timestamp
*    - `o`: ordinal number modifier
*    - `P`: long localized date
*    - `p`: long localized time
*
* 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
*    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
*    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* @param {Date|Number} date - the original date
* @param {String} format - the string of tokens
* @param {Object} [options] - an object with options.
* @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
* @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
* @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
* @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
*   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
*   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @returns {String} the formatted date string
* @throws {TypeError} 2 arguments required
* @throws {RangeError} `date` must not be Invalid Date
* @throws {RangeError} `options.locale` must contain `localize` property
* @throws {RangeError} `options.locale` must contain `formatLong` property
* @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
* @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
* @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} format string contains an unescaped latin alphabet character
*
* @example
* // Represent 11 February 2014 in middle-endian format:
* const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
* //=> '02/11/2014'
*
* @example
* // Represent 2 July 2014 in Esperanto:
* import { eoLocale } from 'date-fns/locale/eo'
* const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
*   locale: eoLocale
* })
* //=> '2-a de julio 2014'
*
* @example
* // Escape string by single quote characters:
* const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
* //=> "3 o'clock"
*/
function format(dirtyDate, dirtyFormatStr, options) {
	var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	requiredArgs(2, arguments);
	var formatStr = String(dirtyFormatStr);
	var defaultOptions = getDefaultOptions();
	var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
	var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (!locale.localize) throw new RangeError("locale must contain localize property");
	if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
	var originalDate = toDate(dirtyDate);
	if (!isValid(originalDate)) throw new RangeError("Invalid time value");
	var utcDate = subMilliseconds(originalDate, getTimezoneOffsetInMilliseconds(originalDate));
	var formatterOptions = {
		firstWeekContainsDate,
		weekStartsOn,
		locale,
		_originalDate: originalDate
	};
	return formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
		var firstCharacter = substring[0];
		if (firstCharacter === "p" || firstCharacter === "P") {
			var longFormatter = longFormatters[firstCharacter];
			return longFormatter(substring, locale.formatLong);
		}
		return substring;
	}).join("").match(formattingTokensRegExp$2).map(function(substring) {
		if (substring === "''") return "'";
		var firstCharacter = substring[0];
		if (firstCharacter === "'") return cleanEscapedString$2(substring);
		var formatter = formatters[firstCharacter];
		if (formatter) {
			if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
			if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
			return formatter(utcDate, substring, locale.localize, formatterOptions);
		}
		if (firstCharacter.match(unescapedLatinCharacterRegExp$2)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
		return substring;
	}).join("");
}
function cleanEscapedString$2(input) {
	var matched = input.match(escapedStringRegExp$2);
	if (!matched) return input;
	return matched[1].replace(doubleQuoteRegExp$2, "'");
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/assign/index.js
function assign(target, object) {
	if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
	for (var property in object) if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
	return target;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/formatDuration/index.js
var defaultFormat = [
	"years",
	"months",
	"weeks",
	"days",
	"hours",
	"minutes",
	"seconds"
];
/**
* @name formatDuration
* @category Common Helpers
* @summary Formats a duration in human-readable format
*
* @description
* Return human-readable duration string i.e. "9 months 2 days"
*
* @param {Duration} duration - the duration to format
* @param {Object} [options] - an object with options.
* @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
* @param {boolean} [options.zero=false] - should zeros be included in the output?
* @param {string} [options.delimiter=' '] - delimiter string
* @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
* @returns {string} the formatted date string
* @throws {TypeError} 1 argument required
*
* @example
* // Format full duration
* formatDuration({
*   years: 2,
*   months: 9,
*   weeks: 1,
*   days: 7,
*   hours: 5,
*   minutes: 9,
*   seconds: 30
* })
* //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
*
* @example
* // Format partial duration
* formatDuration({ months: 9, days: 2 })
* //=> '9 months 2 days'
*
* @example
* // Customize the format
* formatDuration(
*   {
*     years: 2,
*     months: 9,
*     weeks: 1,
*     days: 7,
*     hours: 5,
*     minutes: 9,
*     seconds: 30
*   },
*   { format: ['months', 'weeks'] }
* ) === '9 months 1 week'
*
* @example
* // Customize the zeros presence
* formatDuration({ years: 0, months: 9 })
* //=> '9 months'
* formatDuration({ years: 0, months: 9 }, { zero: true })
* //=> '0 years 9 months'
*
* @example
* // Customize the delimiter
* formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
* //=> '2 years, 9 months, 3 weeks'
*/
function formatDuration$2(duration, options) {
	var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
	if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	var defaultOptions = getDefaultOptions();
	var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
	var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
	var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
	var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
	if (!locale.formatDistance) return "";
	return format.reduce(function(acc, unit) {
		var token = "x".concat(unit.replace(/(^.)/, function(m) {
			return m.toUpperCase();
		}));
		var value = duration[unit];
		if (typeof value === "number" && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
		return acc;
	}, []).join(delimiter);
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/intervalToDuration/index.js
/**
* @name intervalToDuration
* @category Common Helpers
* @summary Convert interval to duration
*
* @description
* Convert a interval object to a duration object.
*
* @param {Interval} interval - the interval to convert to duration
*
* @returns {Duration} The duration Object
* @throws {TypeError} Requires 2 arguments
* @throws {RangeError} `start` must not be Invalid Date
* @throws {RangeError} `end` must not be Invalid Date
*
* @example
* // Get the duration between January 15, 1929 and April 4, 1968.
* intervalToDuration({
*   start: new Date(1929, 0, 15, 12, 0, 0),
*   end: new Date(1968, 3, 4, 19, 5, 0)
* })
* // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
*/
function intervalToDuration(interval) {
	requiredArgs(1, arguments);
	var start = toDate(interval.start);
	var end = toDate(interval.end);
	if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
	if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
	var duration = {};
	duration.years = Math.abs(differenceInYears(end, start));
	var sign = compareAsc(end, start);
	var remainingMonths = add(start, { years: sign * duration.years });
	duration.months = Math.abs(differenceInMonths(end, remainingMonths));
	var remainingDays = add(remainingMonths, { months: sign * duration.months });
	duration.days = Math.abs(differenceInDays(end, remainingDays));
	var remainingHours = add(remainingDays, { days: sign * duration.days });
	duration.hours = Math.abs(differenceInHours(end, remainingHours));
	var remainingMinutes = add(remainingHours, { hours: sign * duration.hours });
	duration.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
	var remainingSeconds = add(remainingMinutes, { minutes: sign * duration.minutes });
	duration.seconds = Math.abs(differenceInSeconds(end, remainingSeconds));
	return duration;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/isAfter/index.js
/**
* @name isAfter
* @category Common Helpers
* @summary Is the first date after the second one?
*
* @description
* Is the first date after the second one?
*
* @param {Date|Number} date - the date that should be after the other one to return true
* @param {Date|Number} dateToCompare - the date to compare with
* @returns {Boolean} the first date is after the second date
* @throws {TypeError} 2 arguments required
*
* @example
* // Is 10 July 1989 after 11 February 1987?
* const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
* //=> true
*/
function isAfter(dirtyDate, dirtyDateToCompare) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var dateToCompare = toDate(dirtyDateToCompare);
	return date.getTime() > dateToCompare.getTime();
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/isBefore/index.js
/**
* @name isBefore
* @category Common Helpers
* @summary Is the first date before the second one?
*
* @description
* Is the first date before the second one?
*
* @param {Date|Number} date - the date that should be before the other one to return true
* @param {Date|Number} dateToCompare - the date to compare with
* @returns {Boolean} the first date is before the second date
* @throws {TypeError} 2 arguments required
*
* @example
* // Is 10 July 1989 before 11 February 1987?
* const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
* //=> false
*/
function isBefore(dirtyDate, dirtyDateToCompare) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var dateToCompare = toDate(dirtyDateToCompare);
	return date.getTime() < dateToCompare.getTime();
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
	}
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
function _createForOfIteratorHelper(r, e) {
	var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (!t) {
		if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
			t && (r = t);
			var _n = 0, F = function F() {};
			return {
				s: F,
				n: function n() {
					return _n >= r.length ? { done: !0 } : {
						done: !1,
						value: r[_n++]
					};
				},
				e: function e(r) {
					throw r;
				},
				f: F
			};
		}
		throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	var o, a = !0, u = !1;
	return {
		s: function s() {
			t = t.call(r);
		},
		n: function n() {
			var r = t.next();
			return a = r.done, r;
		},
		e: function e(r) {
			u = !0, o = r;
		},
		f: function f() {
			try {
				a || null == t["return"] || t["return"]();
			} finally {
				if (u) throw o;
			}
		}
	};
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
	if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
	return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
		return t.__proto__ = e, t;
	}, _setPrototypeOf(t, e);
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(t, e) {
	if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	t.prototype = Object.create(e && e.prototype, { constructor: {
		value: t,
		writable: !0,
		configurable: !0
	} }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e);
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
	return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
		return t.__proto__ || Object.getPrototypeOf(t);
	}, _getPrototypeOf(t);
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
	try {
		var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch (t) {}
	return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
		return !!t;
	})();
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(t, e) {
	if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	return _assertThisInitialized(t);
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper(t) {
	var r = _isNativeReflectConstruct();
	return function() {
		var e, o = _getPrototypeOf(t);
		if (r) {
			var s = _getPrototypeOf(this).constructor;
			e = Reflect.construct(o, arguments, s);
		} else e = o.apply(this, arguments);
		return _possibleConstructorReturn(this, e);
	};
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
	if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(e, r) {
	for (var t = 0; t < r.length; t++) {
		var o = r[t];
		o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
	}
}
function _createClass(e, r, t) {
	return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
//#endregion
//#region ../../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/Setter.js
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
	function Setter() {
		_classCallCheck(this, Setter);
		_defineProperty(this, "priority", void 0);
		_defineProperty(this, "subPriority", 0);
	}
	_createClass(Setter, [{
		key: "validate",
		value: function validate(_utcDate, _options) {
			return true;
		}
	}]);
	return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
	_inherits(ValueSetter, _Setter);
	var _super = _createSuper(ValueSetter);
	function ValueSetter(value, validateValue, setValue, priority, subPriority) {
		var _this;
		_classCallCheck(this, ValueSetter);
		_this = _super.call(this);
		_this.value = value;
		_this.validateValue = validateValue;
		_this.setValue = setValue;
		_this.priority = priority;
		if (subPriority) _this.subPriority = subPriority;
		return _this;
	}
	_createClass(ValueSetter, [{
		key: "validate",
		value: function validate(utcDate, options) {
			return this.validateValue(utcDate, this.value, options);
		}
	}, {
		key: "set",
		value: function set(utcDate, flags, options) {
			return this.setValue(utcDate, flags, this.value, options);
		}
	}]);
	return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
	_inherits(DateToSystemTimezoneSetter, _Setter2);
	var _super2 = _createSuper(DateToSystemTimezoneSetter);
	function DateToSystemTimezoneSetter() {
		var _this2;
		_classCallCheck(this, DateToSystemTimezoneSetter);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this2 = _super2.call.apply(_super2, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
		_defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
		return _this2;
	}
	_createClass(DateToSystemTimezoneSetter, [{
		key: "set",
		value: function set(date, flags) {
			if (flags.timestampIsSet) return date;
			var convertedDate = /* @__PURE__ */ new Date(0);
			convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
			convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
			return convertedDate;
		}
	}]);
	return DateToSystemTimezoneSetter;
}(Setter);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/Parser.js
var Parser = /*#__PURE__*/ function() {
	function Parser() {
		_classCallCheck(this, Parser);
		_defineProperty(this, "incompatibleTokens", void 0);
		_defineProperty(this, "priority", void 0);
		_defineProperty(this, "subPriority", void 0);
	}
	_createClass(Parser, [{
		key: "run",
		value: function run(dateString, token, match, options) {
			var result = this.parse(dateString, token, match, options);
			if (!result) return null;
			return {
				setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
				rest: result.rest
			};
		}
	}, {
		key: "validate",
		value: function validate(_utcDate, _value, _options) {
			return true;
		}
	}]);
	return Parser;
}();
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
var EraParser = /*#__PURE__*/ function(_Parser) {
	_inherits(EraParser, _Parser);
	var _super = _createSuper(EraParser);
	function EraParser() {
		var _this;
		_classCallCheck(this, EraParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 140);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"R",
			"u",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(EraParser, [{
		key: "parse",
		value: function parse(dateString, token, match) {
			switch (token) {
				case "G":
				case "GG":
				case "GGG": return match.era(dateString, { width: "abbreviated" }) || match.era(dateString, { width: "narrow" });
				case "GGGGG": return match.era(dateString, { width: "narrow" });
				default: return match.era(dateString, { width: "wide" }) || match.era(dateString, { width: "abbreviated" }) || match.era(dateString, { width: "narrow" });
			}
		}
	}, {
		key: "set",
		value: function set(date, flags, value) {
			flags.era = value;
			date.setUTCFullYear(value, 0, 1);
			date.setUTCHours(0, 0, 0, 0);
			return date;
		}
	}]);
	return EraParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
	month: /^(1[0-2]|0?\d)/,
	date: /^(3[0-1]|[0-2]?\d)/,
	dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	week: /^(5[0-3]|[0-4]?\d)/,
	hour23h: /^(2[0-3]|[0-1]?\d)/,
	hour24h: /^(2[0-4]|[0-1]?\d)/,
	hour11h: /^(1[0-1]|0?\d)/,
	hour12h: /^(1[0-2]|0?\d)/,
	minute: /^[0-5]?\d/,
	second: /^[0-5]?\d/,
	singleDigit: /^\d/,
	twoDigits: /^\d{1,2}/,
	threeDigits: /^\d{1,3}/,
	fourDigits: /^\d{1,4}/,
	anyDigitsSigned: /^-?\d+/,
	singleDigitSigned: /^-?\d/,
	twoDigitsSigned: /^-?\d{1,2}/,
	threeDigitsSigned: /^-?\d{1,3}/,
	fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
	basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	basic: /^([+-])(\d{2})(\d{2})|Z/,
	basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	extended: /^([+-])(\d{2}):(\d{2})|Z/,
	extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/utils.js
function mapValue(parseFnResult, mapFn) {
	if (!parseFnResult) return parseFnResult;
	return {
		value: mapFn(parseFnResult.value),
		rest: parseFnResult.rest
	};
}
function parseNumericPattern(pattern, dateString) {
	var matchResult = dateString.match(pattern);
	if (!matchResult) return null;
	return {
		value: parseInt(matchResult[0], 10),
		rest: dateString.slice(matchResult[0].length)
	};
}
function parseTimezonePattern(pattern, dateString) {
	var matchResult = dateString.match(pattern);
	if (!matchResult) return null;
	if (matchResult[0] === "Z") return {
		value: 0,
		rest: dateString.slice(1)
	};
	var sign = matchResult[1] === "+" ? 1 : -1;
	var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	return {
		value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
		rest: dateString.slice(matchResult[0].length)
	};
}
function parseAnyDigitsSigned(dateString) {
	return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
	switch (n) {
		case 1: return parseNumericPattern(numericPatterns.singleDigit, dateString);
		case 2: return parseNumericPattern(numericPatterns.twoDigits, dateString);
		case 3: return parseNumericPattern(numericPatterns.threeDigits, dateString);
		case 4: return parseNumericPattern(numericPatterns.fourDigits, dateString);
		default: return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
	}
}
function parseNDigitsSigned(n, dateString) {
	switch (n) {
		case 1: return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
		case 2: return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
		case 3: return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
		case 4: return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
		default: return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
	}
}
function dayPeriodEnumToHours(dayPeriod) {
	switch (dayPeriod) {
		case "morning": return 4;
		case "evening": return 17;
		case "pm":
		case "noon":
		case "afternoon": return 12;
		default: return 0;
	}
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	var isCommonEra = currentYear > 0;
	var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	var result;
	if (absCurrentYear <= 50) result = twoDigitYear || 100;
	else {
		var rangeEnd = absCurrentYear + 50;
		var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
		var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
		result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	}
	return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
	return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
var YearParser = /*#__PURE__*/ function(_Parser) {
	_inherits(YearParser, _Parser);
	var _super = _createSuper(YearParser);
	function YearParser() {
		var _this;
		_classCallCheck(this, YearParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 130);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"u",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(YearParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				var valueCallback = function valueCallback(year) {
					return {
						year,
						isTwoDigitYear: token === "yy"
					};
				};
				switch (token) {
					case "y": return mapValue(parseNDigits(4, dateString), valueCallback);
					case "yo": return mapValue(match.ordinalNumber(dateString, { unit: "year" }), valueCallback);
					default: return mapValue(parseNDigits(token.length, dateString), valueCallback);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value.isTwoDigitYear || value.year > 0;
			}
		},
		{
			key: "set",
			value: function set(date, flags, value) {
				var currentYear = date.getUTCFullYear();
				if (value.isTwoDigitYear) {
					var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
					date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
					date.setUTCHours(0, 0, 0, 0);
					return date;
				}
				var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
				date.setUTCFullYear(year, 0, 1);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return YearParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
	_inherits(LocalWeekYearParser, _Parser);
	var _super = _createSuper(LocalWeekYearParser);
	function LocalWeekYearParser() {
		var _this;
		_classCallCheck(this, LocalWeekYearParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 130);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"R",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(LocalWeekYearParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				var valueCallback = function valueCallback(year) {
					return {
						year,
						isTwoDigitYear: token === "YY"
					};
				};
				switch (token) {
					case "Y": return mapValue(parseNDigits(4, dateString), valueCallback);
					case "Yo": return mapValue(match.ordinalNumber(dateString, { unit: "year" }), valueCallback);
					default: return mapValue(parseNDigits(token.length, dateString), valueCallback);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value.isTwoDigitYear || value.year > 0;
			}
		},
		{
			key: "set",
			value: function set(date, flags, value, options) {
				var currentYear = getUTCWeekYear(date, options);
				if (value.isTwoDigitYear) {
					var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
					date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
					date.setUTCHours(0, 0, 0, 0);
					return startOfUTCWeek(date, options);
				}
				var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
				date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
				date.setUTCHours(0, 0, 0, 0);
				return startOfUTCWeek(date, options);
			}
		}
	]);
	return LocalWeekYearParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ISOWeekYearParser, _Parser);
	var _super = _createSuper(ISOWeekYearParser);
	function ISOWeekYearParser() {
		var _this;
		_classCallCheck(this, ISOWeekYearParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 130);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"G",
			"y",
			"Y",
			"u",
			"Q",
			"q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(ISOWeekYearParser, [{
		key: "parse",
		value: function parse(dateString, token) {
			if (token === "R") return parseNDigitsSigned(4, dateString);
			return parseNDigitsSigned(token.length, dateString);
		}
	}, {
		key: "set",
		value: function set(_date, _flags, value) {
			var firstWeekOfYear = /* @__PURE__ */ new Date(0);
			firstWeekOfYear.setUTCFullYear(value, 0, 4);
			firstWeekOfYear.setUTCHours(0, 0, 0, 0);
			return startOfUTCISOWeek(firstWeekOfYear);
		}
	}]);
	return ISOWeekYearParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ExtendedYearParser, _Parser);
	var _super = _createSuper(ExtendedYearParser);
	function ExtendedYearParser() {
		var _this;
		_classCallCheck(this, ExtendedYearParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 130);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"G",
			"y",
			"Y",
			"R",
			"w",
			"I",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(ExtendedYearParser, [{
		key: "parse",
		value: function parse(dateString, token) {
			if (token === "u") return parseNDigitsSigned(4, dateString);
			return parseNDigitsSigned(token.length, dateString);
		}
	}, {
		key: "set",
		value: function set(date, _flags, value) {
			date.setUTCFullYear(value, 0, 1);
			date.setUTCHours(0, 0, 0, 0);
			return date;
		}
	}]);
	return ExtendedYearParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
var QuarterParser = /*#__PURE__*/ function(_Parser) {
	_inherits(QuarterParser, _Parser);
	var _super = _createSuper(QuarterParser);
	function QuarterParser() {
		var _this;
		_classCallCheck(this, QuarterParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 120);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(QuarterParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "Q":
					case "QQ": return parseNDigits(token.length, dateString);
					case "Qo": return match.ordinalNumber(dateString, { unit: "quarter" });
					case "QQQ": return match.quarter(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.quarter(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "QQQQQ": return match.quarter(dateString, {
						width: "narrow",
						context: "formatting"
					});
					default: return match.quarter(dateString, {
						width: "wide",
						context: "formatting"
					}) || match.quarter(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.quarter(dateString, {
						width: "narrow",
						context: "formatting"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 4;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMonth((value - 1) * 3, 1);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return QuarterParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
	_inherits(StandAloneQuarterParser, _Parser);
	var _super = _createSuper(StandAloneQuarterParser);
	function StandAloneQuarterParser() {
		var _this;
		_classCallCheck(this, StandAloneQuarterParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 120);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(StandAloneQuarterParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "q":
					case "qq": return parseNDigits(token.length, dateString);
					case "qo": return match.ordinalNumber(dateString, { unit: "quarter" });
					case "qqq": return match.quarter(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.quarter(dateString, {
						width: "narrow",
						context: "standalone"
					});
					case "qqqqq": return match.quarter(dateString, {
						width: "narrow",
						context: "standalone"
					});
					default: return match.quarter(dateString, {
						width: "wide",
						context: "standalone"
					}) || match.quarter(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.quarter(dateString, {
						width: "narrow",
						context: "standalone"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 4;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMonth((value - 1) * 3, 1);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return StandAloneQuarterParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
var MonthParser = /*#__PURE__*/ function(_Parser) {
	_inherits(MonthParser, _Parser);
	var _super = _createSuper(MonthParser);
	function MonthParser() {
		var _this;
		_classCallCheck(this, MonthParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"q",
			"Q",
			"L",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		_defineProperty(_assertThisInitialized(_this), "priority", 110);
		return _this;
	}
	_createClass(MonthParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				var valueCallback = function valueCallback(value) {
					return value - 1;
				};
				switch (token) {
					case "M": return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
					case "MM": return mapValue(parseNDigits(2, dateString), valueCallback);
					case "Mo": return mapValue(match.ordinalNumber(dateString, { unit: "month" }), valueCallback);
					case "MMM": return match.month(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.month(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "MMMMM": return match.month(dateString, {
						width: "narrow",
						context: "formatting"
					});
					default: return match.month(dateString, {
						width: "wide",
						context: "formatting"
					}) || match.month(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.month(dateString, {
						width: "narrow",
						context: "formatting"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 11;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMonth(value, 1);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return MonthParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
	_inherits(StandAloneMonthParser, _Parser);
	var _super = _createSuper(StandAloneMonthParser);
	function StandAloneMonthParser() {
		var _this;
		_classCallCheck(this, StandAloneMonthParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 110);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(StandAloneMonthParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				var valueCallback = function valueCallback(value) {
					return value - 1;
				};
				switch (token) {
					case "L": return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
					case "LL": return mapValue(parseNDigits(2, dateString), valueCallback);
					case "Lo": return mapValue(match.ordinalNumber(dateString, { unit: "month" }), valueCallback);
					case "LLL": return match.month(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.month(dateString, {
						width: "narrow",
						context: "standalone"
					});
					case "LLLLL": return match.month(dateString, {
						width: "narrow",
						context: "standalone"
					});
					default: return match.month(dateString, {
						width: "wide",
						context: "standalone"
					}) || match.month(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.month(dateString, {
						width: "narrow",
						context: "standalone"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 11;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMonth(value, 1);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return StandAloneMonthParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/setUTCWeek/index.js
function setUTCWeek(dirtyDate, dirtyWeek, options) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var week = toInteger(dirtyWeek);
	var diff = getUTCWeek(date, options) - week;
	date.setUTCDate(date.getUTCDate() - diff * 7);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
	_inherits(LocalWeekParser, _Parser);
	var _super = _createSuper(LocalWeekParser);
	function LocalWeekParser() {
		var _this;
		_classCallCheck(this, LocalWeekParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 100);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"i",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(LocalWeekParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "w": return parseNumericPattern(numericPatterns.week, dateString);
					case "wo": return match.ordinalNumber(dateString, { unit: "week" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 53;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value, options) {
				return startOfUTCWeek(setUTCWeek(date, value, options), options);
			}
		}
	]);
	return LocalWeekParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	requiredArgs(2, arguments);
	var date = toDate(dirtyDate);
	var isoWeek = toInteger(dirtyISOWeek);
	var diff = getUTCISOWeek(date) - isoWeek;
	date.setUTCDate(date.getUTCDate() - diff * 7);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ISOWeekParser, _Parser);
	var _super = _createSuper(ISOWeekParser);
	function ISOWeekParser() {
		var _this;
		_classCallCheck(this, ISOWeekParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 100);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(ISOWeekParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "I": return parseNumericPattern(numericPatterns.week, dateString);
					case "Io": return match.ordinalNumber(dateString, { unit: "week" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 53;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				return startOfUTCISOWeek(setUTCISOWeek(date, value));
			}
		}
	]);
	return ISOWeekParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
var DAYS_IN_MONTH = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
	_inherits(DateParser, _Parser);
	var _super = _createSuper(DateParser);
	function DateParser() {
		var _this;
		_classCallCheck(this, DateParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "subPriority", 1);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"q",
			"Q",
			"w",
			"I",
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(DateParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "d": return parseNumericPattern(numericPatterns.date, dateString);
					case "do": return match.ordinalNumber(dateString, { unit: "date" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(date, value) {
				var isLeapYear = isLeapYearIndex$1(date.getUTCFullYear());
				var month = date.getUTCMonth();
				if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
				else return value >= 1 && value <= DAYS_IN_MONTH[month];
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCDate(value);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return DateParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
	_inherits(DayOfYearParser, _Parser);
	var _super = _createSuper(DayOfYearParser);
	function DayOfYearParser() {
		var _this;
		_classCallCheck(this, DayOfYearParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "subpriority", 1);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"Y",
			"R",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"I",
			"d",
			"E",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(DayOfYearParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "D":
					case "DD": return parseNumericPattern(numericPatterns.dayOfYear, dateString);
					case "Do": return match.ordinalNumber(dateString, { unit: "date" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(date, value) {
				if (isLeapYearIndex$1(date.getUTCFullYear())) return value >= 1 && value <= 366;
				else return value >= 1 && value <= 365;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMonth(0, value);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return DayOfYearParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/setUTCDay/index.js
function setUTCDay(dirtyDate, dirtyDay, options) {
	var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	requiredArgs(2, arguments);
	var defaultOptions = getDefaultOptions();
	var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
	var date = toDate(dirtyDate);
	var day = toInteger(dirtyDay);
	var currentDay = date.getUTCDay();
	var diff = ((day % 7 + 7) % 7 < weekStartsOn ? 7 : 0) + day - currentDay;
	date.setUTCDate(date.getUTCDate() + diff);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
var DayParser = /*#__PURE__*/ function(_Parser) {
	_inherits(DayParser, _Parser);
	var _super = _createSuper(DayParser);
	function DayParser() {
		var _this;
		_classCallCheck(this, DayParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"D",
			"i",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(DayParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "E":
					case "EE":
					case "EEE": return match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "EEEEE": return match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "EEEEEE": return match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					default: return match.day(dateString, {
						width: "wide",
						context: "formatting"
					}) || match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 6;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value, options) {
				date = setUTCDay(date, value, options);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return DayParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
	_inherits(LocalDayParser, _Parser);
	var _super = _createSuper(LocalDayParser);
	function LocalDayParser() {
		var _this;
		_classCallCheck(this, LocalDayParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(LocalDayParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match, options) {
				var valueCallback = function valueCallback(value) {
					var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
					return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
				};
				switch (token) {
					case "e":
					case "ee": return mapValue(parseNDigits(token.length, dateString), valueCallback);
					case "eo": return mapValue(match.ordinalNumber(dateString, { unit: "day" }), valueCallback);
					case "eee": return match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "eeeee": return match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					case "eeeeee": return match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
					default: return match.day(dateString, {
						width: "wide",
						context: "formatting"
					}) || match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 6;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value, options) {
				date = setUTCDay(date, value, options);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return LocalDayParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
	_inherits(StandAloneLocalDayParser, _Parser);
	var _super = _createSuper(StandAloneLocalDayParser);
	function StandAloneLocalDayParser() {
		var _this;
		_classCallCheck(this, StandAloneLocalDayParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"R",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"I",
			"d",
			"D",
			"E",
			"i",
			"e",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(StandAloneLocalDayParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match, options) {
				var valueCallback = function valueCallback(value) {
					var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
					return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
				};
				switch (token) {
					case "c":
					case "cc": return mapValue(parseNDigits(token.length, dateString), valueCallback);
					case "co": return mapValue(match.ordinalNumber(dateString, { unit: "day" }), valueCallback);
					case "ccc": return match.day(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.day(dateString, {
						width: "short",
						context: "standalone"
					}) || match.day(dateString, {
						width: "narrow",
						context: "standalone"
					});
					case "ccccc": return match.day(dateString, {
						width: "narrow",
						context: "standalone"
					});
					case "cccccc": return match.day(dateString, {
						width: "short",
						context: "standalone"
					}) || match.day(dateString, {
						width: "narrow",
						context: "standalone"
					});
					default: return match.day(dateString, {
						width: "wide",
						context: "standalone"
					}) || match.day(dateString, {
						width: "abbreviated",
						context: "standalone"
					}) || match.day(dateString, {
						width: "short",
						context: "standalone"
					}) || match.day(dateString, {
						width: "narrow",
						context: "standalone"
					});
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 6;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value, options) {
				date = setUTCDay(date, value, options);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return StandAloneLocalDayParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/_lib/setUTCISODay/index.js
function setUTCISODay(dirtyDate, dirtyDay) {
	requiredArgs(2, arguments);
	var day = toInteger(dirtyDay);
	if (day % 7 === 0) day = day - 7;
	var weekStartsOn = 1;
	var date = toDate(dirtyDate);
	var currentDay = date.getUTCDay();
	var diff = ((day % 7 + 7) % 7 < weekStartsOn ? 7 : 0) + day - currentDay;
	date.setUTCDate(date.getUTCDate() + diff);
	return date;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
var ISODayParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ISODayParser, _Parser);
	var _super = _createSuper(ISODayParser);
	function ISODayParser() {
		var _this;
		_classCallCheck(this, ISODayParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 90);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"y",
			"Y",
			"u",
			"q",
			"Q",
			"M",
			"L",
			"w",
			"d",
			"D",
			"E",
			"e",
			"c",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(ISODayParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				var valueCallback = function valueCallback(value) {
					if (value === 0) return 7;
					return value;
				};
				switch (token) {
					case "i":
					case "ii": return parseNDigits(token.length, dateString);
					case "io": return match.ordinalNumber(dateString, { unit: "day" });
					case "iii": return mapValue(match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					}), valueCallback);
					case "iiiii": return mapValue(match.day(dateString, {
						width: "narrow",
						context: "formatting"
					}), valueCallback);
					case "iiiiii": return mapValue(match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					}), valueCallback);
					default: return mapValue(match.day(dateString, {
						width: "wide",
						context: "formatting"
					}) || match.day(dateString, {
						width: "abbreviated",
						context: "formatting"
					}) || match.day(dateString, {
						width: "short",
						context: "formatting"
					}) || match.day(dateString, {
						width: "narrow",
						context: "formatting"
					}), valueCallback);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 7;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date = setUTCISODay(date, value);
				date.setUTCHours(0, 0, 0, 0);
				return date;
			}
		}
	]);
	return ISODayParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
var AMPMParser = /*#__PURE__*/ function(_Parser) {
	_inherits(AMPMParser, _Parser);
	var _super = _createSuper(AMPMParser);
	function AMPMParser() {
		var _this;
		_classCallCheck(this, AMPMParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 80);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"b",
			"B",
			"H",
			"k",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(AMPMParser, [{
		key: "parse",
		value: function parse(dateString, token, match) {
			switch (token) {
				case "a":
				case "aa":
				case "aaa": return match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				case "aaaaa": return match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				default: return match.dayPeriod(dateString, {
					width: "wide",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
			}
		}
	}, {
		key: "set",
		value: function set(date, _flags, value) {
			date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
			return date;
		}
	}]);
	return AMPMParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
	_inherits(AMPMMidnightParser, _Parser);
	var _super = _createSuper(AMPMMidnightParser);
	function AMPMMidnightParser() {
		var _this;
		_classCallCheck(this, AMPMMidnightParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 80);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"a",
			"B",
			"H",
			"k",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(AMPMMidnightParser, [{
		key: "parse",
		value: function parse(dateString, token, match) {
			switch (token) {
				case "b":
				case "bb":
				case "bbb": return match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				case "bbbbb": return match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				default: return match.dayPeriod(dateString, {
					width: "wide",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
			}
		}
	}, {
		key: "set",
		value: function set(date, _flags, value) {
			date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
			return date;
		}
	}]);
	return AMPMMidnightParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
	_inherits(DayPeriodParser, _Parser);
	var _super = _createSuper(DayPeriodParser);
	function DayPeriodParser() {
		var _this;
		_classCallCheck(this, DayPeriodParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 80);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"a",
			"b",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(DayPeriodParser, [{
		key: "parse",
		value: function parse(dateString, token, match) {
			switch (token) {
				case "B":
				case "BB":
				case "BBB": return match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				case "BBBBB": return match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
				default: return match.dayPeriod(dateString, {
					width: "wide",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "abbreviated",
					context: "formatting"
				}) || match.dayPeriod(dateString, {
					width: "narrow",
					context: "formatting"
				});
			}
		}
	}, {
		key: "set",
		value: function set(date, _flags, value) {
			date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
			return date;
		}
	}]);
	return DayPeriodParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
	_inherits(Hour1to12Parser, _Parser);
	var _super = _createSuper(Hour1to12Parser);
	function Hour1to12Parser() {
		var _this;
		_classCallCheck(this, Hour1to12Parser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 70);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"H",
			"K",
			"k",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(Hour1to12Parser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "h": return parseNumericPattern(numericPatterns.hour12h, dateString);
					case "ho": return match.ordinalNumber(dateString, { unit: "hour" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 12;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				var isPM = date.getUTCHours() >= 12;
				if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
				else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
				else date.setUTCHours(value, 0, 0, 0);
				return date;
			}
		}
	]);
	return Hour1to12Parser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
	_inherits(Hour0to23Parser, _Parser);
	var _super = _createSuper(Hour0to23Parser);
	function Hour0to23Parser() {
		var _this;
		_classCallCheck(this, Hour0to23Parser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 70);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"a",
			"b",
			"h",
			"K",
			"k",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(Hour0to23Parser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "H": return parseNumericPattern(numericPatterns.hour23h, dateString);
					case "Ho": return match.ordinalNumber(dateString, { unit: "hour" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 23;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCHours(value, 0, 0, 0);
				return date;
			}
		}
	]);
	return Hour0to23Parser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
	_inherits(Hour0To11Parser, _Parser);
	var _super = _createSuper(Hour0To11Parser);
	function Hour0To11Parser() {
		var _this;
		_classCallCheck(this, Hour0To11Parser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 70);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"h",
			"H",
			"k",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(Hour0To11Parser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "K": return parseNumericPattern(numericPatterns.hour11h, dateString);
					case "Ko": return match.ordinalNumber(dateString, { unit: "hour" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 11;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				if (date.getUTCHours() >= 12 && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
				else date.setUTCHours(value, 0, 0, 0);
				return date;
			}
		}
	]);
	return Hour0To11Parser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
	_inherits(Hour1To24Parser, _Parser);
	var _super = _createSuper(Hour1To24Parser);
	function Hour1To24Parser() {
		var _this;
		_classCallCheck(this, Hour1To24Parser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 70);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"a",
			"b",
			"h",
			"H",
			"K",
			"t",
			"T"
		]);
		return _this;
	}
	_createClass(Hour1To24Parser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "k": return parseNumericPattern(numericPatterns.hour24h, dateString);
					case "ko": return match.ordinalNumber(dateString, { unit: "hour" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 1 && value <= 24;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				var hours = value <= 24 ? value % 24 : value;
				date.setUTCHours(hours, 0, 0, 0);
				return date;
			}
		}
	]);
	return Hour1To24Parser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
var MinuteParser = /*#__PURE__*/ function(_Parser) {
	_inherits(MinuteParser, _Parser);
	var _super = _createSuper(MinuteParser);
	function MinuteParser() {
		var _this;
		_classCallCheck(this, MinuteParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 60);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
		return _this;
	}
	_createClass(MinuteParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "m": return parseNumericPattern(numericPatterns.minute, dateString);
					case "mo": return match.ordinalNumber(dateString, { unit: "minute" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 59;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCMinutes(value, 0, 0);
				return date;
			}
		}
	]);
	return MinuteParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
var SecondParser = /*#__PURE__*/ function(_Parser) {
	_inherits(SecondParser, _Parser);
	var _super = _createSuper(SecondParser);
	function SecondParser() {
		var _this;
		_classCallCheck(this, SecondParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 50);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
		return _this;
	}
	_createClass(SecondParser, [
		{
			key: "parse",
			value: function parse(dateString, token, match) {
				switch (token) {
					case "s": return parseNumericPattern(numericPatterns.second, dateString);
					case "so": return match.ordinalNumber(dateString, { unit: "second" });
					default: return parseNDigits(token.length, dateString);
				}
			}
		},
		{
			key: "validate",
			value: function validate(_date, value) {
				return value >= 0 && value <= 59;
			}
		},
		{
			key: "set",
			value: function set(date, _flags, value) {
				date.setUTCSeconds(value, 0);
				return date;
			}
		}
	]);
	return SecondParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
	_inherits(FractionOfSecondParser, _Parser);
	var _super = _createSuper(FractionOfSecondParser);
	function FractionOfSecondParser() {
		var _this;
		_classCallCheck(this, FractionOfSecondParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 30);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
		return _this;
	}
	_createClass(FractionOfSecondParser, [{
		key: "parse",
		value: function parse(dateString, token) {
			return mapValue(parseNDigits(token.length, dateString), function valueCallback(value) {
				return Math.floor(value * Math.pow(10, -token.length + 3));
			});
		}
	}, {
		key: "set",
		value: function set(date, _flags, value) {
			date.setUTCMilliseconds(value);
			return date;
		}
	}]);
	return FractionOfSecondParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ISOTimezoneWithZParser, _Parser);
	var _super = _createSuper(ISOTimezoneWithZParser);
	function ISOTimezoneWithZParser() {
		var _this;
		_classCallCheck(this, ISOTimezoneWithZParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 10);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"t",
			"T",
			"x"
		]);
		return _this;
	}
	_createClass(ISOTimezoneWithZParser, [{
		key: "parse",
		value: function parse(dateString, token) {
			switch (token) {
				case "X": return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
				case "XX": return parseTimezonePattern(timezonePatterns.basic, dateString);
				case "XXXX": return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
				case "XXXXX": return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
				default: return parseTimezonePattern(timezonePatterns.extended, dateString);
			}
		}
	}, {
		key: "set",
		value: function set(date, flags, value) {
			if (flags.timestampIsSet) return date;
			return new Date(date.getTime() - value);
		}
	}]);
	return ISOTimezoneWithZParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
	_inherits(ISOTimezoneParser, _Parser);
	var _super = _createSuper(ISOTimezoneParser);
	function ISOTimezoneParser() {
		var _this;
		_classCallCheck(this, ISOTimezoneParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 10);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
			"t",
			"T",
			"X"
		]);
		return _this;
	}
	_createClass(ISOTimezoneParser, [{
		key: "parse",
		value: function parse(dateString, token) {
			switch (token) {
				case "x": return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
				case "xx": return parseTimezonePattern(timezonePatterns.basic, dateString);
				case "xxxx": return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
				case "xxxxx": return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
				default: return parseTimezonePattern(timezonePatterns.extended, dateString);
			}
		}
	}, {
		key: "set",
		value: function set(date, flags, value) {
			if (flags.timestampIsSet) return date;
			return new Date(date.getTime() - value);
		}
	}]);
	return ISOTimezoneParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
	_inherits(TimestampSecondsParser, _Parser);
	var _super = _createSuper(TimestampSecondsParser);
	function TimestampSecondsParser() {
		var _this;
		_classCallCheck(this, TimestampSecondsParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 40);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
		return _this;
	}
	_createClass(TimestampSecondsParser, [{
		key: "parse",
		value: function parse(dateString) {
			return parseAnyDigitsSigned(dateString);
		}
	}, {
		key: "set",
		value: function set(_date, _flags, value) {
			return [/* @__PURE__ */ new Date(value * 1e3), { timestampIsSet: true }];
		}
	}]);
	return TimestampSecondsParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
	_inherits(TimestampMillisecondsParser, _Parser);
	var _super = _createSuper(TimestampMillisecondsParser);
	function TimestampMillisecondsParser() {
		var _this;
		_classCallCheck(this, TimestampMillisecondsParser);
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		_this = _super.call.apply(_super, [this].concat(args));
		_defineProperty(_assertThisInitialized(_this), "priority", 20);
		_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
		return _this;
	}
	_createClass(TimestampMillisecondsParser, [{
		key: "parse",
		value: function parse(dateString) {
			return parseAnyDigitsSigned(dateString);
		}
	}, {
		key: "set",
		value: function set(_date, _flags, value) {
			return [new Date(value), { timestampIsSet: true }];
		}
	}]);
	return TimestampMillisecondsParser;
}(Parser);
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/_lib/parsers/index.js
var parsers = {
	G: new EraParser(),
	y: new YearParser(),
	Y: new LocalWeekYearParser(),
	R: new ISOWeekYearParser(),
	u: new ExtendedYearParser(),
	Q: new QuarterParser(),
	q: new StandAloneQuarterParser(),
	M: new MonthParser(),
	L: new StandAloneMonthParser(),
	w: new LocalWeekParser(),
	I: new ISOWeekParser(),
	d: new DateParser(),
	D: new DayOfYearParser(),
	E: new DayParser(),
	e: new LocalDayParser(),
	c: new StandAloneLocalDayParser(),
	i: new ISODayParser(),
	a: new AMPMParser(),
	b: new AMPMMidnightParser(),
	B: new DayPeriodParser(),
	h: new Hour1to12Parser(),
	H: new Hour0to23Parser(),
	K: new Hour0To11Parser(),
	k: new Hour1To24Parser(),
	m: new MinuteParser(),
	s: new SecondParser(),
	S: new FractionOfSecondParser(),
	X: new ISOTimezoneWithZParser(),
	x: new ISOTimezoneParser(),
	t: new TimestampSecondsParser(),
	T: new TimestampMillisecondsParser()
};
//#endregion
//#region ../../../../node_modules/date-fns/esm/parse/index.js
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
* @name parse
* @category Common Helpers
* @summary Parse the date.
*
* @description
* Return the date parsed from string using the given format string.
*
* > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
* > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* The characters in the format string wrapped between two single quotes characters (') are escaped.
* Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
*
* Format of the format string is based on Unicode Technical Standard #35:
* https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* with a few additions (see note 5 below the table).
*
* Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
* and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
*
* ```javascript
* parse('23 AM', 'HH a', new Date())
* //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
* ```
*
* See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
*
* Accepted format string patterns:
* | Unit                            |Prior| Pattern | Result examples                   | Notes |
* |---------------------------------|-----|---------|-----------------------------------|-------|
* | Era                             | 140 | G..GGG  | AD, BC                            |       |
* |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
* |                                 |     | GGGGG   | A, B                              |       |
* | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
* |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
* |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
* |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
* |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
* |                                 |     | yyyyy   | ...                               | 2,4   |
* | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
* |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
* |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
* |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
* |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
* |                                 |     | YYYYY   | ...                               | 2,4   |
* | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
* |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
* |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
* |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
* |                                 |     | RRRRR   | ...                               | 2,4,5 |
* | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
* |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
* |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
* |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
* |                                 |     | uuuuu   | ...                               | 2,4   |
* | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
* |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
* |                                 |     | QQ      | 01, 02, 03, 04                    |       |
* |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
* |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
* |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
* | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
* |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
* |                                 |     | qq      | 01, 02, 03, 04                    |       |
* |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
* |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
* |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
* | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
* |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
* |                                 |     | MM      | 01, 02, ..., 12                   |       |
* |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
* |                                 |     | MMMM    | January, February, ..., December  | 2     |
* |                                 |     | MMMMM   | J, F, ..., D                      |       |
* | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
* |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
* |                                 |     | LL      | 01, 02, ..., 12                   |       |
* |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
* |                                 |     | LLLL    | January, February, ..., December  | 2     |
* |                                 |     | LLLLL   | J, F, ..., D                      |       |
* | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
* |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
* |                                 |     | ww      | 01, 02, ..., 53                   |       |
* | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
* |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
* |                                 |     | II      | 01, 02, ..., 53                   | 5     |
* | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
* |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
* |                                 |     | dd      | 01, 02, ..., 31                   |       |
* | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
* |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
* |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
* |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
* |                                 |     | DDDD    | ...                               | 2     |
* | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
* |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
* |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
* |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
* |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
* |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
* |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
* |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
* |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
* | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
* |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
* |                                 |     | ee      | 02, 03, ..., 01                   |       |
* |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
* |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
* |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
* |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
* |                                 |     | cc      | 02, 03, ..., 01                   |       |
* |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
* |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
* |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
* |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
* | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
* |                                 |     | aaaa    | a.m., p.m.                        | 2     |
* |                                 |     | aaaaa   | a, p                              |       |
* | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
* |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
* |                                 |     | bbbbb   | a, p, n, mi                       |       |
* | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
* |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
* |                                 |     | BBBBB   | at night, in the morning, ...     |       |
* | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
* |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
* |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
* | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
* |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
* |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
* | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
* |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
* |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
* | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
* |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
* |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
* | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
* |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
* |                                 |     | mm      | 00, 01, ..., 59                   |       |
* | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
* |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
* |                                 |     | ss      | 00, 01, ..., 59                   |       |
* | Seconds timestamp               |  40 | t       | 512969520                         |       |
* |                                 |     | tt      | ...                               | 2     |
* | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
* |                                 |     | SS      | 00, 01, ..., 99                   |       |
* |                                 |     | SSS     | 000, 001, ..., 999                |       |
* |                                 |     | SSSS    | ...                               | 2     |
* | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
* |                                 |     | TT      | ...                               | 2     |
* | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
* |                                 |     | XX      | -0800, +0530, Z                   |       |
* |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
* |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
* |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
* | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
* |                                 |     | xx      | -0800, +0530, +0000               |       |
* |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
* |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
* |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
* | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
* |                                 |     | PP      | May 29, 1453                      |       |
* |                                 |     | PPP     | May 29th, 1453                    |       |
* |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
* | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
* |                                 |     | pp      | 12:00:00 AM                       |       |
* | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
* |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
* |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
* |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
* Notes:
* 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
*    are the same as "stand-alone" units, but are different in some languages.
*    "Formatting" units are declined according to the rules of the language
*    in the context of a date. "Stand-alone" units are always nominative singular.
*    In `format` function, they will produce different result:
*
*    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
*
*    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
*
*    `parse` will try to match both formatting and stand-alone units interchangably.
*
* 2. Any sequence of the identical letters is a pattern, unless it is escaped by
*    the single quote characters (see below).
*    If the sequence is longer than listed in table:
*    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
*      as wide as the sequence
*    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
*      These variations are marked with "2" in the last column of the table.
*
* 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
*    These tokens represent the shortest form of the quarter.
*
* 4. The main difference between `y` and `u` patterns are B.C. years:
*
*    | Year | `y` | `u` |
*    |------|-----|-----|
*    | AC 1 |   1 |   1 |
*    | BC 1 |   1 |   0 |
*    | BC 2 |   2 |  -1 |
*
*    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
*
*    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
*
*    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
*
*    while `uu` will just assign the year as is:
*
*    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
*
*    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
*
*    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
*    except local week-numbering years are dependent on `options.weekStartsOn`
*    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
*    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
*
* 5. These patterns are not in the Unicode Technical Standard #35:
*    - `i`: ISO day of week
*    - `I`: ISO week of year
*    - `R`: ISO week-numbering year
*    - `o`: ordinal number modifier
*    - `P`: long localized date
*    - `p`: long localized time
*
* 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
*    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
*    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
*    on the given locale.
*
*    using `en-US` locale: `P` => `MM/dd/yyyy`
*    using `en-US` locale: `p` => `hh:mm a`
*    using `pt-BR` locale: `P` => `dd/MM/yyyy`
*    using `pt-BR` locale: `p` => `HH:mm`
*
* Values will be assigned to the date in the descending order of its unit's priority.
* Units of an equal priority overwrite each other in the order of appearance.
*
* If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
* the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
*
* `referenceDate` must be passed for correct work of the function.
* If you're not sure which `referenceDate` to supply, create a new instance of Date:
* `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
* In this case parsing will be done in the context of the current date.
* If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
* then `Invalid Date` will be returned.
*
* The result may vary by locale.
*
* If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
*
* If parsing failed, `Invalid Date` will be returned.
* Invalid Date is a Date, whose time value is NaN.
* Time value of Date: http://es5.github.io/#x15.9.1.1
*
* @param {String} dateString - the string to parse
* @param {String} formatString - the string of tokens
* @param {Date|Number} referenceDate - defines values missing from the parsed dateString
* @param {Object} [options] - an object with options.
* @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
* @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
* @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
* @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
*   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
*   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @returns {Date} the parsed date
* @throws {TypeError} 3 arguments required
* @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
* @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
* @throws {RangeError} `options.locale` must contain `match` property
* @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
* @throws {RangeError} format string contains an unescaped latin alphabet character
*
* @example
* // Parse 11 February 2014 from middle-endian format:
* var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
* //=> Tue Feb 11 2014 00:00:00
*
* @example
* // Parse 28th of February in Esperanto locale in the context of 2010 year:
* import eo from 'date-fns/locale/eo'
* var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
*   locale: eo
* })
* //=> Sun Feb 28 2010 00:00:00
*/
function parse$1(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	requiredArgs(3, arguments);
	var dateString = String(dirtyDateString);
	var formatString = String(dirtyFormatString);
	var defaultOptions = getDefaultOptions();
	var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
	if (!locale.match) throw new RangeError("locale must contain match property");
	var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
	var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
	if (formatString === "") if (dateString === "") return toDate(dirtyReferenceDate);
	else return /* @__PURE__ */ new Date(NaN);
	var subFnOptions = {
		firstWeekContainsDate,
		weekStartsOn,
		locale
	};
	var setters = [new DateToSystemTimezoneSetter()];
	var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
		var firstCharacter = substring[0];
		if (firstCharacter in longFormatters) {
			var longFormatter = longFormatters[firstCharacter];
			return longFormatter(substring, locale.formatLong);
		}
		return substring;
	}).join("").match(formattingTokensRegExp$1);
	var usedTokens = [];
	var _iterator = _createForOfIteratorHelper(tokens), _step;
	try {
		var _loop = function _loop() {
			var token = _step.value;
			if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) throwProtectedError(token, formatString, dirtyDateString);
			if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) throwProtectedError(token, formatString, dirtyDateString);
			var firstCharacter = token[0];
			var parser = parsers[firstCharacter];
			if (parser) {
				var incompatibleTokens = parser.incompatibleTokens;
				if (Array.isArray(incompatibleTokens)) {
					var incompatibleToken = usedTokens.find(function(usedToken) {
						return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
					});
					if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
				} else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
				usedTokens.push({
					token: firstCharacter,
					fullToken: token
				});
				var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
				if (!parseResult) return { v: /* @__PURE__ */ new Date(NaN) };
				setters.push(parseResult.setter);
				dateString = parseResult.rest;
			} else {
				if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
				if (token === "''") token = "'";
				else if (firstCharacter === "'") token = cleanEscapedString$1(token);
				if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
				else return { v: /* @__PURE__ */ new Date(NaN) };
			}
		};
		for (_iterator.s(); !(_step = _iterator.n()).done;) {
			var _ret = _loop();
			if (_typeof(_ret) === "object") return _ret.v;
		}
	} catch (err) {
		_iterator.e(err);
	} finally {
		_iterator.f();
	}
	if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return /* @__PURE__ */ new Date(NaN);
	var uniquePrioritySetters = setters.map(function(setter) {
		return setter.priority;
	}).sort(function(a, b) {
		return b - a;
	}).filter(function(priority, index, array) {
		return array.indexOf(priority) === index;
	}).map(function(priority) {
		return setters.filter(function(setter) {
			return setter.priority === priority;
		}).sort(function(a, b) {
			return b.subPriority - a.subPriority;
		});
	}).map(function(setterArray) {
		return setterArray[0];
	});
	var date = toDate(dirtyReferenceDate);
	if (isNaN(date.getTime())) return /* @__PURE__ */ new Date(NaN);
	var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
	var flags = {};
	var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
	try {
		for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
			var setter = _step2.value;
			if (!setter.validate(utcDate, subFnOptions)) return /* @__PURE__ */ new Date(NaN);
			var result = setter.set(utcDate, flags, subFnOptions);
			if (Array.isArray(result)) {
				utcDate = result[0];
				assign(flags, result[1]);
			} else utcDate = result;
		}
	} catch (err) {
		_iterator2.e(err);
	} finally {
		_iterator2.f();
	}
	return utcDate;
}
function cleanEscapedString$1(input) {
	return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/isWithinInterval/index.js
/**
* @name isWithinInterval
* @category Interval Helpers
* @summary Is the given date within the interval?
*
* @description
* Is the given date within the interval? (Including start and end.)
*
* @param {Date|Number} date - the date to check
* @param {Interval} interval - the interval to check
* @returns {Boolean} the date is within the interval
* @throws {TypeError} 2 arguments required
* @throws {RangeError} The start of an interval cannot be after its end
* @throws {RangeError} Date in interval cannot be `Invalid Date`
*
* @example
* // For the date within the interval:
* isWithinInterval(new Date(2014, 0, 3), {
*   start: new Date(2014, 0, 1),
*   end: new Date(2014, 0, 7)
* })
* //=> true
*
* @example
* // For the date outside of the interval:
* isWithinInterval(new Date(2014, 0, 10), {
*   start: new Date(2014, 0, 1),
*   end: new Date(2014, 0, 7)
* })
* //=> false
*
* @example
* // For date equal to interval start:
* isWithinInterval(date, { start, end: date }) // => true
*
* @example
* // For date equal to interval end:
* isWithinInterval(date, { start: date, end }) // => true
*/
function isWithinInterval(dirtyDate, interval) {
	requiredArgs(2, arguments);
	var time = toDate(dirtyDate).getTime();
	var startTime = toDate(interval.start).getTime();
	var endTime = toDate(interval.end).getTime();
	if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
	return time >= startTime && time <= endTime;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/lightFormat/index.js
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
* @name lightFormat
* @category Common Helpers
* @summary Format the date.
*
* @description
* Return the formatted date string in the given format. Unlike `format`,
* `lightFormat` doesn't use locales and outputs date using the most popular tokens.
*
* > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
* > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
*
* The characters wrapped between two single quotes characters (') are escaped.
* Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
*
* Format of the string is based on Unicode Technical Standard #35:
* https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
*
* Accepted patterns:
* | Unit                            | Pattern | Result examples                   |
* |---------------------------------|---------|-----------------------------------|
* | AM, PM                          | a..aaa  | AM, PM                            |
* |                                 | aaaa    | a.m., p.m.                        |
* |                                 | aaaaa   | a, p                              |
* | Calendar year                   | y       | 44, 1, 1900, 2017                 |
* |                                 | yy      | 44, 01, 00, 17                    |
* |                                 | yyy     | 044, 001, 000, 017                |
* |                                 | yyyy    | 0044, 0001, 1900, 2017            |
* | Month (formatting)              | M       | 1, 2, ..., 12                     |
* |                                 | MM      | 01, 02, ..., 12                   |
* | Day of month                    | d       | 1, 2, ..., 31                     |
* |                                 | dd      | 01, 02, ..., 31                   |
* | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
* |                                 | hh      | 01, 02, ..., 11, 12               |
* | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
* |                                 | HH      | 00, 01, 02, ..., 23               |
* | Minute                          | m       | 0, 1, ..., 59                     |
* |                                 | mm      | 00, 01, ..., 59                   |
* | Second                          | s       | 0, 1, ..., 59                     |
* |                                 | ss      | 00, 01, ..., 59                   |
* | Fraction of second              | S       | 0, 1, ..., 9                      |
* |                                 | SS      | 00, 01, ..., 99                   |
* |                                 | SSS     | 000, 001, ..., 999                |
* |                                 | SSSS    | ...                               |
*
* @param {Date|Number} date - the original date
* @param {String} format - the string of tokens
* @returns {String} the formatted date string
* @throws {TypeError} 2 arguments required
* @throws {RangeError} format string contains an unescaped latin alphabet character
*
* @example
* const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
* //=> '2014-02-11'
*/
function lightFormat(dirtyDate, formatStr) {
	requiredArgs(2, arguments);
	var originalDate = toDate(dirtyDate);
	if (!isValid(originalDate)) throw new RangeError("Invalid time value");
	var utcDate = subMilliseconds(originalDate, getTimezoneOffsetInMilliseconds(originalDate));
	var tokens = formatStr.match(formattingTokensRegExp);
	if (!tokens) return "";
	return tokens.map(function(substring) {
		if (substring === "''") return "'";
		var firstCharacter = substring[0];
		if (firstCharacter === "'") return cleanEscapedString(substring);
		var formatter = formatters$1[firstCharacter];
		if (formatter) return formatter(utcDate, substring);
		if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
		return substring;
	}).join("");
}
function cleanEscapedString(input) {
	var matches = input.match(escapedStringRegExp);
	if (!matches) return input;
	return matches[1].replace(doubleQuoteRegExp, "'");
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/parseISO/index.js
/**
* @name parseISO
* @category Common Helpers
* @summary Parse ISO string
*
* @description
* Parse the given string in ISO 8601 format and return an instance of Date.
*
* Function accepts complete ISO 8601 formats as well as partial implementations.
* ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
*
* If the argument isn't a string, the function cannot parse the string or
* the values are invalid, it returns Invalid Date.
*
* @param {String} argument - the value to convert
* @param {Object} [options] - an object with options.
* @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
* @returns {Date} the parsed date in the local time zone
* @throws {TypeError} 1 argument required
* @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
*
* @example
* // Convert string '2014-02-11T11:30:30' to date:
* const result = parseISO('2014-02-11T11:30:30')
* //=> Tue Feb 11 2014 11:30:30
*
* @example
* // Convert string '+02014101' to date,
* // if the additional number of digits in the extended year format is 1:
* const result = parseISO('+02014101', { additionalDigits: 1 })
* //=> Fri Apr 11 2014 00:00:00
*/
function parseISO(argument, options) {
	var _options$additionalDi;
	requiredArgs(1, arguments);
	var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
	if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return /* @__PURE__ */ new Date(NaN);
	var dateStrings = splitDateString(argument);
	var date;
	if (dateStrings.date) {
		var parseYearResult = parseYear(dateStrings.date, additionalDigits);
		date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	}
	if (!date || isNaN(date.getTime())) return /* @__PURE__ */ new Date(NaN);
	var timestamp = date.getTime();
	var time = 0;
	var offset;
	if (dateStrings.time) {
		time = parseTime(dateStrings.time);
		if (isNaN(time)) return /* @__PURE__ */ new Date(NaN);
	}
	if (dateStrings.timezone) {
		offset = parseTimezone(dateStrings.timezone);
		if (isNaN(offset)) return /* @__PURE__ */ new Date(NaN);
	} else {
		var dirtyDate = new Date(timestamp + time);
		var result = /* @__PURE__ */ new Date(0);
		result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
		result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
		return result;
	}
	return new Date(timestamp + time + offset);
}
var patterns = {
	dateTimeDelimiter: /[T ]/,
	timeZoneDelimiter: /[Z ]/i,
	timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
	var dateStrings = {};
	var array = dateString.split(patterns.dateTimeDelimiter);
	var timeString;
	if (array.length > 2) return dateStrings;
	if (/:/.test(array[0])) timeString = array[0];
	else {
		dateStrings.date = array[0];
		timeString = array[1];
		if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
			dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
			timeString = dateString.substr(dateStrings.date.length, dateString.length);
		}
	}
	if (timeString) {
		var token = patterns.timezone.exec(timeString);
		if (token) {
			dateStrings.time = timeString.replace(token[1], "");
			dateStrings.timezone = token[1];
		} else dateStrings.time = timeString;
	}
	return dateStrings;
}
function parseYear(dateString, additionalDigits) {
	var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
	var captures = dateString.match(regex);
	if (!captures) return {
		year: NaN,
		restDateString: ""
	};
	var year = captures[1] ? parseInt(captures[1]) : null;
	var century = captures[2] ? parseInt(captures[2]) : null;
	return {
		year: century === null ? year : century * 100,
		restDateString: dateString.slice((captures[1] || captures[2]).length)
	};
}
function parseDate(dateString, year) {
	if (year === null) return /* @__PURE__ */ new Date(NaN);
	var captures = dateString.match(dateRegex);
	if (!captures) return /* @__PURE__ */ new Date(NaN);
	var isWeekDate = !!captures[4];
	var dayOfYear = parseDateUnit(captures[1]);
	var month = parseDateUnit(captures[2]) - 1;
	var day = parseDateUnit(captures[3]);
	var week = parseDateUnit(captures[4]);
	var dayOfWeek = parseDateUnit(captures[5]) - 1;
	if (isWeekDate) {
		if (!validateWeekDate(year, week, dayOfWeek)) return /* @__PURE__ */ new Date(NaN);
		return dayOfISOWeekYear(year, week, dayOfWeek);
	} else {
		var date = /* @__PURE__ */ new Date(0);
		if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return /* @__PURE__ */ new Date(NaN);
		date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
		return date;
	}
}
function parseDateUnit(value) {
	return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
	var captures = timeString.match(timeRegex);
	if (!captures) return NaN;
	var hours = parseTimeUnit(captures[1]);
	var minutes = parseTimeUnit(captures[2]);
	var seconds = parseTimeUnit(captures[3]);
	if (!validateTime(hours, minutes, seconds)) return NaN;
	return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value) {
	return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
	if (timezoneString === "Z") return 0;
	var captures = timezoneString.match(timezoneRegex);
	if (!captures) return 0;
	var sign = captures[1] === "+" ? -1 : 1;
	var hours = parseInt(captures[2]);
	var minutes = captures[3] && parseInt(captures[3]) || 0;
	if (!validateTimezone(hours, minutes)) return NaN;
	return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
	var date = /* @__PURE__ */ new Date(0);
	date.setUTCFullYear(isoWeekYear, 0, 4);
	var fourthOfJanuaryDay = date.getUTCDay() || 7;
	var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	date.setUTCDate(date.getUTCDate() + diff);
	return date;
}
var daysInMonths = [
	31,
	null,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function isLeapYearIndex(year) {
	return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
	return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
	return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
	return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
	if (hours === 24) return minutes === 0 && seconds === 0;
	return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
	return minutes >= 0 && minutes <= 59;
}
//#endregion
//#region ../../../../node_modules/date-fns/esm/startOfToday/index.js
/**
* @name startOfToday
* @category Day Helpers
* @summary Return the start of today.
* @pure false
*
* @description
* Return the start of today.
*
* > ⚠️ Please note that this function is not present in the FP submodule as
* > it uses `Date.now()` internally hence impure and can't be safely curried.
*
* @returns {Date} the start of today
*
* @example
* // If today is 6 October 2014:
* const result = startOfToday()
* //=> Mon Oct 6 2014 00:00:00
*/
function startOfToday() {
	return startOfDay(Date.now());
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/date.js
var DateTemplates;
(function(DateTemplates) {
	DateTemplates["Days"] = "MMMM d";
	DateTemplates["Long"] = "yyyy-MM-dd HH:mm:ss";
	DateTemplates["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
/**
* Format еру date value according to the passed format
* @param { string | Date } value The date value
* @param { string | DateTemplates } fmt The format template
* @returns { string } Returns the formatted string
*
* @example
* formatDate(new Date(2022, 2, 1, 12, 34, 56)) // => '2022-03-01 12:34:56'
* formatDate(new Date(2022, 2, 1, 12, 34, 56), 'yyyy-MM-dd') // => '2022-03-01'
*/
function formatDate$1(value, fmt = DateTemplates.Long) {
	const date = value instanceof Date ? value : parseISO(value);
	return isValid(date) ? lightFormat(date, fmt) : "";
}
/**
* Counts the time in human readable format
* @param { number } duration Duration in miliseconds
* @returns { string } Returns human readable duration time
*
* @example
* formatDuration(86400000) // => '1 day'
*/
function formatDuration$1(duration) {
	return formatDuration$2(intervalToDuration({
		end: duration,
		start: 0
	}), { delimiter: " " });
}
/**
* Counts the time difference in human readable format
* @param { Date } start Start date
* @param { DateTemplates } end End date
* @returns { string } Returns the formatted string
*
* @example
* formatInterval(new Date(2022, 2, 1, 12, 34, 56), new Date(2022, 2, 1, 13, 34, 56)) // => '1h 0m'
*/
function formatInterval(start, end) {
	const diff = differenceInSeconds(end, start);
	const hours = Math.floor(diff / 3600);
	const minutes = Math.floor(diff / 60 % 60);
	const seconds = diff % 60;
	return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
(() => {
	try {
		return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
	} catch {
		return false;
	}
})();
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/elements.js
/**
* Check if DOM element is an input element
* @param { EventTarget | null } el DOM element
* @returns { Boolean } Returns the boolean value
*
* @example
* isInputElement(undefined) // => false
* isInputElement(new HTMLDivElement()) // => false
* isInputElement(new HTMLInputElement()) // => true
* isInputElement(new HTMLTextAreaElement()) // => true
*/
function isInputElement(el) {
	if (!el) return false;
	return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLDivElement && !!el.isContentEditable;
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/file.js
async function getFiles(items) {
	const entryFiles = [];
	for (let i = 0; i < items.length; i++) {
		const item = items[i].webkitGetAsEntry();
		if (!item) continue;
		entryFiles.push(item);
	}
	const filePromises = entryFiles.map(scanFiles);
	return flatten(await Promise.all(filePromises));
}
function readEntries(reader) {
	return new Promise((resolve, reject) => {
		reader.readEntries(resolve, reject);
	});
}
function readFile(item) {
	return new Promise((resolve, reject) => {
		item.file(resolve, reject);
	});
}
async function scanDirectories(item) {
	const reader = item.createReader();
	const result = [];
	let entries;
	do {
		entries = await readEntries(reader);
		result.push(...entries);
	} while (entries.length > 0);
	return result;
}
async function scanFiles(item) {
	if (item.isFile) return [await readFile(item)];
	else if (item.isDirectory) {
		const filePromises = (await scanDirectories(item)).map(scanFiles);
		return flatten(await Promise.all(filePromises));
	} else return [];
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/numbers.js
var K = 1024;
var SIZES$3 = [
	"Bytes",
	"KB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
];
/**
* Converts bytes into in human readable string format
* @param { Number } bytes Bytes value
* @param { Number } decimals The number of digits to appear after the decimal point
* @returns { String } Returns the formatted string
*
* @example
* formatBytes(0) // => '0 MB'
* formatBytes(2) // => '2 Bytes'
* formatBytes(2 ** 20) // => '1 MB'
*/
function formatBytes(bytes, decimals = 1) {
	if (!bytes) return "0 MB";
	if (bytes === 1) return "1 Byte";
	const i = Math.floor(Math.log(bytes) / Math.log(K));
	return `${parseFloat((bytes / Math.pow(K, i)).toFixed(decimals))} ${SIZES$3[i]}`;
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/sort.js
/**
* Compare two values according to date sort order
* @param x Value to compare
* @param y Value to compare
* @returns Returns a positive value if {x} is greater than {y}, a negative value if {x} is less than {y}, 0 if they are equal.
*
* @example
* ['2022-09-12T10:00:00Z', '2022-09-11T10:00:00Z'].sort(dateSort) // => ['2022-09-11T10:00:00Z', '2022-09-12T10:00:00Z'].
*/
function dateSort(x, y) {
	const valueX = typeof x === "string" ? parseISO(x) : new Date(x);
	const valueY = typeof y === "string" ? parseISO(y) : new Date(y);
	const invalidX = !isValid(valueX);
	const invalidY = !isValid(valueY);
	if (invalidX && invalidY) return 0;
	if (invalidX) return 1;
	if (invalidY) return -1;
	return compareAsc(valueX, valueY);
}
/**
* Compare two values according to default sort order
* @param x Value to compare
* @param y Value to compare
* @returns Returns a positive value if {x} is greater than {y}, a negative value if {x} is less than {y}, 0 if they are equal.
*/
function defaultSort(x, y) {
	if (x == null && y == null) return 0;
	if (x == null) return 1;
	if (y == null) return -1;
	if (x < y) return -1;
	if (x > y) return 1;
	return 0;
}
var naturalSortFn = new Intl.Collator(void 0, {
	numeric: true,
	sensitivity: "base"
}).compare;
/**
* Compare two strings according to natural sort order.
* @param {string} x Value to compare
* @param {string} y Value to compare
* @returns {number} Returns a positive value if {x} is greater than {y}, a negative value if {x} is less than {y}, 0 if they are equal.
*
* @example
* ['1', '5', '2', '1'].sort(naturalSort) // => ['1', '1', '2', '5']
* ['1', '001', '10', '3'].sort(naturalSort) // => ['1', '001', '3', '10']
* [{ v: '5' }, { v: '1' }, { v: '2' }].sort((a, b) => naturalSort(a.v, b.v)) // => [{ v: '1' }, { v: '2' }, { v: '5' }]
*/
function naturalSort(x, y) {
	if (x == null && y == null) return 0;
	if (x == null) return 1;
	if (y == null) return -1;
	return naturalSortFn(x, y);
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/iterable.js
/**
* Creates a new array with only the distinct values in {iterable}
* @param iterable The iterable of elements to process
* @returns Returns the new array
*
* @example
* distinct([5, 2, 2, 6, 6])
* // => [5, 2, 6]
*/
function distinct(iterable) {
	return [...new Set(iterable)];
}
/**
* Creates a new array with only the distinct values in {iterable} by comparing the values given a property key.
* @param iterable The iterable of elements to process
* @param key Key in the item to compare
* @returns Returns the new array
*
* @example
* distinctByKey([{a: 2}, {a: 3}, {a: 2}], 'a')
* // => [{a: 2}, {a: 3}]
*/
function distinctByKey(iterable, key) {
	const result = [];
	const uniqueSet = /* @__PURE__ */ new Set();
	for (const t of iterable) {
		const value = t[key];
		if (uniqueSet.has(value)) continue;
		uniqueSet.add(value);
		result.push(t);
	}
	return result;
}
/**
* Sort array by key values,
* @param iterable The array to iterate over.
* @param key The key to get data value to sort by.
* @param asc Sort order
* @returns Returns a new array
*
* @example
* sortByDate([{ k: new Date('2022-01-02T12:00:00+0000') }, { k: new Date('2022-01-01T12:00:00+0000') }], 'k')
* // => [{ k: new Date('2022-01-01T12:00:00+0000') }, { k: new Date('2022-01-02T12:00:00+0000') }]
*/
function sortByDate(iterable, key, asc = true) {
	const sortFn = (a, b) => {
		return dateSort(asc ? a[key] : b[key], asc ? b[key] : a[key]);
	};
	return Array.from(iterable).sort(sortFn);
}
/**
* Sort array by key values,
* @param iterable The array to iterate over.
* @param key The key to get data value to sort by.
* @param asc Sort order
* @param keySortFn Compare function
* @returns Returns a new array
*
* @example
* sortByKey([{ k: 2 }, { k: 1 }], 'k')
* // => [{ k: 1 }, { k: 2 }]
*/
function sortByKey(iterable, key, asc = true, keySortFn = defaultSort) {
	const sortFn = (a, b) => {
		return keySortFn(asc ? a[key] : b[key], asc ? b[key] : a[key]);
	};
	return Array.from(iterable).sort(sortFn);
}
var ProbeResult;
(function(ProbeResult) {
	/**
	* No items in the list
	*/
	ProbeResult[ProbeResult["None"] = 0] = "None";
	/**
	* All items do not satisfy the predicate
	*/
	ProbeResult[ProbeResult["FalseOnly"] = 1] = "FalseOnly";
	/**
	* All items satisfy the predicate
	*/
	ProbeResult[ProbeResult["TrueOnly"] = 2] = "TrueOnly";
	/**
	* There are item that satisfy the predicate
	* and an item that do not satisfy the predicate
	*/
	ProbeResult[ProbeResult["Both"] = 3] = "Both";
})(ProbeResult || (ProbeResult = {}));
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/objects.js
/**
* Checks if value is an empty object.
* @param { Object } object The array to process
* @returns { Boolean } Returns a boolean value
*
* @example
* isEmpty(undefined) // => false
* isEmpty({}) // => true
* isEmpty({ a: 1 }) // => false
*/
function isEmptyPlainObject(object) {
	return object != null && Object.keys(object).length === 0;
}
/**
* Create a new object, sort and filter it's value using given functions.
* @param { Object } o The value to process
* @param { Function } mapfn Function to generate a new value
* @param { Function } filterFn Function to filter object values and keys
* @param { Function } sortFn Function to sort
* @returns { Object } Returns a new Object
*
* @example
* mapToObject({ 1: { b: 1 }, 2: { b: 2 } }, (v) => v.b) // { 1: 1, 2: 2 }
* mapToObject({ 1: { b: 1 }, 2: { b: 2 } }, (v) => v.b, (v, k) => v.b === 2) // { 2: 2 }
*/
function mapToObject(o, mapfn, filterFn, sortFn) {
	let entries = Object.entries(o);
	if (filterFn) entries = entries.filter(([key, value]) => filterFn(value, key));
	if (sortFn) entries = entries.sort((a, b) => sortFn(a[1], b[1]));
	const mapped = entries.map(([key, value], index) => ({ [key]: mapfn(value, key, index) }));
	return Object.assign({}, ...mapped);
}
/**
* Returns a new object with filtered keys and values.
* @param { Object } o The value to process
* @param { Function } filterFn Function to filter object values and keys
* @returns { Object } Returns a new Object
*
* @example
* filterObject({ 1: { b: 1 }, 2: { b: 1 } }, (v, k) => v.b === 2) // { 2: { b: 1 } }
*/
function filterObject(o, filterfn) {
	const filtered = Object.entries(o).filter(([key, value]) => filterfn(value, key));
	return Object.fromEntries(filtered);
}
/**
* Converts an iterable into an object given a key and value getter functions.
* @param iterable The iterable to process
* @param getKey The function to be used to get key value
* @param getValue The function to be used to get value
* @returns object
*
* @example
* buildObject([ { k: 'a', v: 1 }, { k: 'b', v: 2 } ], (x) => x.k, (x) => x.v)
* // => { a: 1, b: 2 }
*/
function buildObject(iterable, getKey, getValue) {
	const record = {};
	for (const t of iterable) {
		const key = getKey.call(this, t);
		record[key] = getValue.call(this, t);
	}
	return record;
}
/**
* Converts an iterable into an object given a key getter and an async value getter function.
* @param iterable The iterable to process
* @param keyGetter The function to be used to get key value
* @param loadValue The async function to be used to get value
* @param batchSize The number of items to process in parallel at a time (defaults to size of the array)
* @returns Returns Object
*
* @example
* await buildObjectAsync([ { k: 'a', v: 1 }, { k: 'b', v: 2 } ], (x) => x.k, (x) => Promise.resolve(x.v))
* // => { a: 1, b: 2 }
*/
async function buildObjectAsync(iterable, keyGetter, loadValue, batchSize = Infinity) {
	const record = {};
	const pendingPromises = [];
	const loadPending = async () => {
		const toLoad = [...pendingPromises];
		pendingPromises.length = 0;
		const loaded = await Promise.all(toLoad);
		for (const [key, value] of loaded) record[key] = value;
	};
	for (const t of iterable) {
		if (pendingPromises.length >= batchSize) await loadPending();
		const key = keyGetter.call(this, t);
		const promise = loadValue.call(this, t).then((value) => [key, value]);
		pendingPromises.push(promise);
	}
	await loadPending();
	return record;
}
//#endregion
//#region src/options/useOptions.ts
var globalOptions = {
	darkMode: false,
	layout: {},
	navigation: {},
	notification: {},
	session: {},
	tables: {
		carousel: true,
		queryParamsFilters: true
	},
	warnAutomation: true
};
function initializeOptions(options) {
	Object.assign(globalOptions, options ?? {});
}
/**
* @deprecated use `useOptions` instead which does not have the `Readonly` type and will not infer (slower types generation)
*/
function useOptionsReadOnly() {
	return readonly(globalOptions);
}
function useOptions() {
	return globalOptions;
}
//#endregion
//#region src/composables/useAutomation.ts
function useAutomation(id) {
	const { warnAutomation } = useOptionsReadOnly();
	if (!id && warnAutomation) try {
		let node = getCurrentInstance();
		const hierarchy = [];
		while (node) {
			hierarchy.unshift(node.type.name ?? node.type.__file ?? "?");
			node = node.parent;
		}
		if (hierarchy.length) console.warn(`Missing data-automation for ${hierarchy.join(" > ")}`);
		else console.warn("Missing data-automation somewhere (not enough information to determine where)");
	} catch {
		console.warn("Missing data-automation somewhere (not enough information to determine where)");
	}
	const buildId = (suffix) => {
		if (!id) return void 0;
		if (typeof id === "string") return suffix ? `${id}__${suffix}` : id;
		const idValue = toValue(id);
		if (!idValue) return void 0;
		return suffix ? `${idValue}__${suffix}` : idValue;
	};
	return {
		buildId,
		dataAttrs: computed(() => {
			const attrs = getCurrentInstance()?.attrs;
			if (!attrs) return void 0;
			return filterObject(attrs, (_, key) => key.startsWith("data-"));
		})
	};
}
//#endregion
//#region ../../../../node_modules/quasar/dist/quasar.client.js
/*!
* Quasar Framework v2.24.0
* (c) 2015-present Razvan Stoenescu
* Released under the MIT License.
*/
/**
* Quasar runtime flags are needed only if NOT using
* Quasar CLI or @quasar/vite-plugin or vue-cli-plugin-quasar
*/
var attachPoint = null;
function getAttachPoint() {
	if (attachPoint !== null) return attachPoint;
	return attachPoint = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
}
if (typeof __QUASAR_SSR__ !== "boolean") getAttachPoint().__QUASAR_SSR__ = false;
if (typeof __QUASAR_SSR_CLIENT__ !== "boolean") getAttachPoint().__QUASAR_SSR_CLIENT__ = false;
if (typeof __QUASAR_SSR_PWA__ !== "boolean") getAttachPoint().__QUASAR_SSR_PWA__ = false;
function injectProp(target, propName, get, set) {
	Object.defineProperty(target, propName, {
		get,
		set,
		enumerable: true
	});
	return target;
}
function injectMultipleProps(target, props) {
	for (const key in props) injectProp(target, key, props[key]);
	return target;
}
/**
* __ QUASAR_SSR __            -> runs on SSR/SSG on client or server
* __ QUASAR_SSR_SERVER __     -> runs on SSR/SSG on server
* __ QUASAR_SSR_CLIENT __     -> runs on SSR/SSG on client
* __ QUASAR_SSR_PWA __        -> built with SSR/SSG + PWA; may run on SSR/SSG on client or on PWA client
*                              (needs runtime detection)
*/
var isRuntimeSsrPreHydration = ref(__QUASAR_SSR_CLIENT__ && (__QUASAR_SSR_PWA__ ? "serverRendered" in document.body.dataset : true));
var preHydrationBrowser;
var maxUserAgentLength = 512;
function normalizeUserAgent(userAgent) {
	return typeof userAgent === "string" ? userAgent.slice(0, maxUserAgentLength).toLowerCase() : "";
}
var safariVersionRE = /(?:^|\s)version\/([\w.]+)/;
var applewebkitRE = /(?:^|\s)applewebkit\/[\w.]+/;
var safariAgentRE = /(?:^|\s)safari\/[\w.]+/;
function getSafariMatch(userAgent) {
	const versionMatch = safariVersionRE.exec(userAgent);
	return versionMatch !== null && applewebkitRE.test(userAgent) && safariAgentRE.test(userAgent) ? {
		browser: "safari",
		version: versionMatch[1]
	} : null;
}
var operaAgentRE = /(?:^|\s)opera\/([\w.]+)/;
var operaVersionRE = /(?:^|\s)version\/([\w.]+)/;
function getOperaMatch(userAgent) {
	const operaMatch = operaAgentRE.exec(userAgent);
	if (operaMatch === null) return null;
	return {
		browser: "opera",
		version: operaVersionRE.exec(userAgent)?.[1] || operaMatch[1]
	};
}
var edgeRE = /(edg|edge|edga|edgios)\/([\w.]+)/;
var oprRE = /(opr)[\/]([\w.]+)/;
var vivaldiRE = /(vivaldi)[\/]([\w.]+)/;
var chromeRE = /(chrome|crios)[\/]([\w.]+)/;
var firefoxRE = /(firefox|fxios)[\/]([\w.]+)/;
var webkitRE = /(webkit)[\/]([\w.]+)/;
function getMatch(userAgent, platformMatch) {
	let match = edgeRE.exec(userAgent) || oprRE.exec(userAgent) || vivaldiRE.exec(userAgent) || chromeRE.exec(userAgent);
	if (match === null) {
		const safariMatch = getSafariMatch(userAgent);
		if (safariMatch !== null) return {
			...safariMatch,
			platform: platformMatch[0] || ""
		};
		match = firefoxRE.exec(userAgent) || webkitRE.exec(userAgent);
		if (match === null) {
			const operaMatch = getOperaMatch(userAgent);
			if (operaMatch !== null) return {
				...operaMatch,
				platform: platformMatch[0] || ""
			};
			match = [];
		}
	}
	return {
		browser: match[5] || match[3] || match[1] || "",
		version: match[4] || match[2] || "0",
		platform: platformMatch[0] || ""
	};
}
var ipadRE = /(ipad)/;
var ipodRE = /(ipod)/;
var iphoneRE = /(iphone)/;
var windowsPhoneRE = /(windows phone)/;
var kindleRE = /(kindle)/;
var silkRE = /(silk)/;
var androidRE = /(android)/;
var winRE = /(win)/;
var macRE = /(mac)/;
var linuxRE = /(linux)/;
var crosRE = /(cros)/;
function getPlatformMatch(userAgent) {
	return ipadRE.exec(userAgent) || ipodRE.exec(userAgent) || windowsPhoneRE.exec(userAgent) || iphoneRE.exec(userAgent) || kindleRE.exec(userAgent) || silkRE.exec(userAgent) || androidRE.exec(userAgent) || winRE.exec(userAgent) || macRE.exec(userAgent) || linuxRE.exec(userAgent) || crosRE.exec(userAgent) || [];
}
var hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform(UA) {
	const userAgent = normalizeUserAgent(UA);
	const matched = getMatch(userAgent, getPlatformMatch(userAgent));
	const browser = {
		mobile: false,
		desktop: false,
		cordova: false,
		capacitor: false,
		nativeMobile: false,
		electron: false,
		bex: false,
		linux: false,
		mac: false,
		win: false,
		cros: false,
		chrome: false,
		firefox: false,
		opera: false,
		safari: false,
		vivaldi: false,
		edge: false,
		edgeChromium: false,
		ie: false,
		webkit: false,
		android: false,
		ios: false,
		ipad: false,
		iphone: false,
		ipod: false,
		kindle: false,
		winphone: false,
		silk: false
	};
	if (matched.browser) {
		browser[matched.browser] = true;
		browser.version = matched.version;
		browser.versionNumber = Number.parseInt(matched.version, 10);
	}
	if (matched.platform) browser[matched.platform] = true;
	if (browser["windows phone"]) {
		browser.winphone = true;
		delete browser["windows phone"];
	}
	const knownMobiles = browser.android || browser.ios || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.silk || browser.winphone;
	if (knownMobiles === true || userAgent.includes("mobile")) browser.mobile = true;
	else browser.desktop = true;
	if (browser.edga || browser.edgios || browser.edg) {
		browser.edge = true;
		matched.browser = "edge";
	} else if (browser.crios) {
		browser.chrome = true;
		matched.browser = "chrome";
	} else if (browser.fxios) {
		browser.firefox = true;
		matched.browser = "firefox";
	}
	if (browser.ipod || browser.ipad || browser.iphone) browser.ios = true;
	if (browser.vivaldi) {
		matched.browser = "vivaldi";
		browser.vivaldi = true;
	}
	if (browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile && !browser.ios && !knownMobiles) browser.webkit = true;
	if (browser.opr) {
		matched.browser = "opera";
		browser.opera = true;
	}
	if (browser.safari) {
		if (browser.android) {
			matched.browser = "android";
			browser.android = true;
		} else if (browser.kindle) {
			matched.browser = "kindle";
			browser.kindle = true;
		} else if (browser.silk) {
			matched.browser = "silk";
			browser.silk = true;
		}
	}
	browser.name = matched.browser;
	browser.platform = matched.platform;
	if (userAgent.includes("electron")) browser.electron = true;
	else if (document.location.href.includes("-extension://")) browser.bex = true;
	else {
		if (window.Capacitor !== void 0) {
			browser.capacitor = true;
			browser.nativeMobile = true;
			browser.nativeMobileWrapper = "capacitor";
		} else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
			browser.cordova = true;
			browser.nativeMobile = true;
			browser.nativeMobileWrapper = "cordova";
		}
		if (isRuntimeSsrPreHydration.value) preHydrationBrowser = { is: { ...browser } };
		if (hasTouch && browser.mac && (browser.desktop && browser.safari || browser.nativeMobile && !browser.android && !browser.ios && !browser.ipad)) {
			delete browser.mac;
			delete browser.desktop;
			const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
			Object.assign(browser, {
				mobile: true,
				ios: true,
				platform,
				[platform]: true
			});
		}
		if (!browser.mobile && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
			delete browser.desktop;
			browser.mobile = true;
		}
	}
	return browser;
}
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
var ssrClient = {
	has: {
		touch: false,
		webStorage: false
	},
	within: { iframe: false }
};
var client = {
	userAgent,
	is: getPlatform(userAgent),
	has: { touch: hasTouch },
	within: { iframe: window.self !== window.top }
};
var Platform = { install(opts) {
	const { $q } = opts;
	if (isRuntimeSsrPreHydration.value) {
		opts.onSSRHydrated.push(() => {
			Object.assign($q.platform, client);
			isRuntimeSsrPreHydration.value = false;
		});
		$q.platform = reactive(this);
	} else $q.platform = this;
} };
{
	let hasWebStorage;
	injectProp(client.has, "webStorage", () => {
		if (hasWebStorage !== void 0) return hasWebStorage;
		try {
			if (window.localStorage) {
				hasWebStorage = true;
				return true;
			}
		} catch {}
		hasWebStorage = false;
		return false;
	});
	Object.assign(Platform, client);
	if (isRuntimeSsrPreHydration.value) {
		Object.assign(Platform, preHydrationBrowser, ssrClient);
		preHydrationBrowser = null;
	}
}
function createComponent(raw) {
	return markRaw(defineComponent(raw));
}
function createDirective(raw) {
	return markRaw(raw);
}
var createReactivePlugin = (state, plugin) => {
	const reactiveState = reactive(state);
	for (const name in state) injectProp(plugin, name, () => reactiveState[name], (val) => {
		reactiveState[name] = val;
	});
	return plugin;
};
var listenOpts = {
	hasPassive: false,
	passiveCapture: true,
	notPassiveCapture: true
};
try {
	const opts = Object.defineProperty({}, "passive", { get() {
		Object.assign(listenOpts, {
			hasPassive: true,
			passive: { passive: true },
			notPassive: { passive: false },
			passiveCapture: {
				passive: true,
				capture: true
			},
			notPassiveCapture: {
				passive: false,
				capture: true
			}
		});
	} });
	window.addEventListener("qtest", null, opts);
	window.removeEventListener("qtest", null, opts);
} catch {}
function noop() {}
function leftClick(e) {
	return e.button === 0;
}
function position(e) {
	if (e.touches && e.touches[0]) e = e.touches[0];
	else if (e.changedTouches && e.changedTouches[0]) e = e.changedTouches[0];
	else if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0];
	return {
		top: e.clientY,
		left: e.clientX
	};
}
function stop(e) {
	e.stopPropagation();
}
function prevent(e) {
	if (e.cancelable !== false) e.preventDefault();
}
function stopAndPrevent(e) {
	if (e.cancelable !== false) e.preventDefault();
	e.stopPropagation();
}
function preventDraggable(el, status) {
	if (el === void 0 || status && el.__dragPrevented) return;
	if (status) el.__dragPrevented = true;
	else delete el.__dragPrevented;
	const fn = status ? (element) => {
		element.__dragPrevented = true;
		element.addEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
	} : (element) => {
		delete element.__dragPrevented;
		element.removeEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
	};
	el.querySelectorAll("a, img").forEach(fn);
}
function addEvt(ctx, targetName, events) {
	const name = `__q_${targetName}_evt`;
	ctx[name] = [...ctx[name] ?? [], ...events];
	events.forEach((evt) => {
		evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
	});
}
function cleanEvt(ctx, targetName) {
	const name = `__q_${targetName}_evt`;
	if (ctx[name] !== void 0) {
		ctx[name].forEach((evt) => {
			evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
		});
		ctx[name] = void 0;
	}
}
function debounce(fn, wait = 250, immediate) {
	let timer = null;
	function debounced(...args) {
		const later = () => {
			timer = null;
			if (!immediate) fn.apply(this, args);
		};
		if (timer !== null) clearTimeout(timer);
		else if (immediate) fn.apply(this, args);
		timer = setTimeout(later, wait);
	}
	debounced.cancel = () => {
		if (timer !== null) {
			clearTimeout(timer);
			timer = null;
		}
	};
	return debounced;
}
var { passive: passive$4 } = listenOpts;
function setCssVar(propName, value, element = document.body) {
	if (typeof propName !== "string") throw new TypeError("Expected a string as propName");
	if (typeof value !== "string") throw new TypeError("Expected a string as value");
	if (!(element instanceof Element)) throw new TypeError("Expected a DOM element");
	element.style.setProperty(`--q-${propName}`, value);
}
var lastKeyCompositionStatus = false;
function shouldIgnoreKey(evt) {
	return lastKeyCompositionStatus || evt !== Object(evt) || evt.isComposing || evt.qKeyEvent;
}
function isKeyCode(evt, keyCodes) {
	return !shouldIgnoreKey(evt) && [keyCodes].flat().includes(evt.keyCode);
}
var getTrue = () => true;
function filterInvalidPath(path) {
	return typeof path === "string" && path !== "" && path !== "/" && path !== "#/";
}
function normalizeExitPath(path) {
	if (path.startsWith("#")) path = path.slice(1);
	if (!path.startsWith("/")) path = "/" + path;
	if (path.endsWith("/")) path = path.slice(0, -1);
	return "#" + path;
}
function getShouldExitFn(cfg) {
	if (cfg.backButtonExit === false) return () => false;
	if (cfg.backButtonExit === "*") return getTrue;
	const exitPaths = ["#/"];
	if (Array.isArray(cfg.backButtonExit)) exitPaths.push(...cfg.backButtonExit.filter(filterInvalidPath).map(normalizeExitPath));
	return () => exitPaths.includes(window.location.hash);
}
var History_default = {
	__history: [],
	add: noop,
	remove: noop,
	install({ $q }) {
		if (this.__installed) return;
		const { cordova, capacitor } = client.is;
		if (!cordova && !capacitor) return;
		const qConf = $q.config[cordova ? "cordova" : "capacitor"];
		if (qConf?.backButton === false) return;
		if (capacitor && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) return;
		this.add = (entry) => {
			if (entry.condition === void 0) entry.condition = getTrue;
			this.__history.push(entry);
		};
		this.remove = (entry) => {
			const index = this.__history.indexOf(entry);
			if (index !== -1) this.__history.splice(index, 1);
		};
		const shouldExit = getShouldExitFn({
			backButtonExit: true,
			...qConf
		});
		const backHandler = () => {
			if (this.__history.length !== 0) {
				const entry = this.__history.at(-1);
				if (entry.condition()) {
					this.__history.pop();
					entry.handler();
				}
			} else if (shouldExit()) navigator.app.exitApp();
			else window.history.back();
		};
		if (cordova) document.addEventListener("deviceready", () => {
			document.addEventListener("backbutton", backHandler, false);
		});
		else window.Capacitor.Plugins.App.addListener("backButton", backHandler);
	}
};
var en_US_default = {
	isoName: "en-US",
	nativeName: "English (US)",
	label: {
		clear: "Clear",
		ok: "OK",
		cancel: "Cancel",
		close: "Close",
		set: "Set",
		select: "Select",
		reset: "Reset",
		remove: "Remove",
		update: "Update",
		create: "Create",
		search: "Search",
		filter: "Filter",
		refresh: "Refresh",
		expand: (label) => label ? `Expand "${label}"` : "Expand",
		collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
	},
	date: {
		days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
		daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
		months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
		monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
		firstDayOfWeek: 0,
		format24h: false,
		pluralDay: "days",
		prevMonth: "Previous month",
		nextMonth: "Next month",
		prevYear: "Previous year",
		nextYear: "Next year",
		today: "Today",
		prevRangeYears: (range) => `Previous ${range} years`,
		nextRangeYears: (range) => `Next ${range} years`
	},
	table: {
		noData: "No data available",
		noResults: "No matching records found",
		loading: "Loading...",
		selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
		recordsPerPage: "Records per page:",
		allRows: "All",
		pagination: (start, end, total) => start + "–" + end + " of " + total,
		columns: "Columns"
	},
	pagination: {
		first: "First page",
		prev: "Previous page",
		next: "Next page",
		last: "Last page"
	},
	editor: {
		url: "URL",
		bold: "Bold",
		italic: "Italic",
		strikethrough: "Strikethrough",
		underline: "Underline",
		unorderedList: "Unordered List",
		orderedList: "Ordered List",
		subscript: "Subscript",
		superscript: "Superscript",
		hyperlink: "Hyperlink",
		toggleFullscreen: "Toggle Fullscreen",
		quote: "Quote",
		left: "Left align",
		center: "Center align",
		right: "Right align",
		justify: "Justify align",
		print: "Print",
		outdent: "Decrease indentation",
		indent: "Increase indentation",
		removeFormat: "Remove formatting",
		formatting: "Formatting",
		fontSize: "Font Size",
		align: "Align",
		hr: "Insert Horizontal Rule",
		undo: "Undo",
		redo: "Redo",
		heading1: "Heading 1",
		heading2: "Heading 2",
		heading3: "Heading 3",
		heading4: "Heading 4",
		heading5: "Heading 5",
		heading6: "Heading 6",
		paragraph: "Paragraph",
		code: "Code",
		size1: "Very small",
		size2: "A bit small",
		size3: "Normal",
		size4: "Medium-large",
		size5: "Big",
		size6: "Very big",
		size7: "Maximum",
		defaultFont: "Default Font",
		viewSource: "View Source"
	},
	tree: {
		noNodes: "No nodes available",
		noResults: "No matching nodes found"
	}
};
function getLocale() {
	const val = Array.isArray(navigator.languages) && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
	if (typeof val === "string") return val.split(/[-_]/).map((v, i) => i === 0 ? v.toLowerCase() : i > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
}
var Plugin$5 = /*#__PURE__*/ createReactivePlugin({ __qLang: {} }, {
	getLocale,
	set(langObject = en_US_default, ssrContext) {
		const lang = {
			...langObject,
			rtl: langObject.rtl === true,
			getLocale
		};
		lang.set = Plugin$5.set;
		if (Plugin$5.__langConfig === void 0 || !Plugin$5.__langConfig.noHtmlAttrs) {
			const el = document.documentElement;
			el.setAttribute("dir", lang.rtl ? "rtl" : "ltr");
			el.setAttribute("lang", lang.isoName);
		}
		Object.assign(Plugin$5.__qLang, lang);
	},
	install({ $q, lang, ssrContext }) {
		$q.lang = Plugin$5.__qLang;
		Plugin$5.__langConfig = $q.config.lang;
		if (this.__installed) {
			if (lang !== void 0) this.set(lang);
		} else {
			this.props = new Proxy(this.__qLang, {
				get: Reflect.get,
				ownKeys(target) {
					return Reflect.ownKeys(target).filter((key) => key !== "set" && key !== "getLocale");
				}
			});
			this.set(lang || en_US_default);
		}
	}
});
var layoutKey = "_q_l_";
var pageContainerKey = "_q_pc_";
var formKey = "_q_fo_";
var tabsKey = "_q_tabs_";
function emptyRenderFn() {}
function isDeepEqual(a, b) {
	if (a === b) return true;
	if (a !== null && b !== null && typeof a === "object" && typeof b === "object") {
		if (a.constructor !== b.constructor) return false;
		let length, i;
		if (a.constructor === Array) {
			length = a.length;
			if (length !== b.length) return false;
			for (i = length; i-- !== 0;) if (!isDeepEqual(a[i], b[i])) return false;
			return true;
		}
		if (a.constructor === Map) {
			if (a.size !== b.size) return false;
			let iter = a.entries();
			i = iter.next();
			while (!i.done) {
				if (!b.has(i.value[0])) return false;
				i = iter.next();
			}
			iter = a.entries();
			i = iter.next();
			while (!i.done) {
				if (!isDeepEqual(i.value[1], b.get(i.value[0]))) return false;
				i = iter.next();
			}
			return true;
		}
		if (a.constructor === Set) {
			if (a.size !== b.size) return false;
			const iter = a.entries();
			i = iter.next();
			while (!i.done) {
				if (!b.has(i.value[0])) return false;
				i = iter.next();
			}
			return true;
		}
		if (a.buffer != null && a.buffer.constructor === ArrayBuffer) {
			length = a.length;
			if (length !== b.length) return false;
			for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
			return true;
		}
		if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
		if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
		if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
		const keys = Object.keys(a).filter((key) => a[key] !== void 0);
		length = keys.length;
		if (length !== Object.keys(b).filter((key) => b[key] !== void 0).length) return false;
		for (i = length; i-- !== 0;) {
			const key = keys[i];
			if (!isDeepEqual(a[key], b[key])) return false;
		}
		return true;
	}
	return a !== a && b !== b;
}
function isObject(v) {
	return v !== null && typeof v === "object" && !Array.isArray(v);
}
function isDate(v) {
	return Object.prototype.toString.call(v) === "[object Date]";
}
function isRegexp(v) {
	return Object.prototype.toString.call(v) === "[object RegExp]";
}
function isNumber(v) {
	return typeof v === "number" && Number.isFinite(v);
}
var globalConfig = {};
var units = [
	"B",
	"KB",
	"MB",
	"GB",
	"TB",
	"PB"
];
function humanStorageSize(bytes, decimals = 1) {
	let u = 0;
	while (Number.parseInt(bytes, 10) >= 1024 && u < units.length - 1) {
		bytes /= 1024;
		++u;
	}
	return `${bytes.toFixed(decimals)}${units[u]}`;
}
function between(v, min, max) {
	return max <= min ? min : Math.min(max, Math.max(min, v));
}
function normalizeToInterval(v, min, max) {
	if (max <= min) return min;
	const size = max - min + 1;
	let index = min + (v - min) % size;
	if (index < min) index = size + index;
	return index === 0 ? 0 : index;
}
function pad(v, length = 2, char = "0") {
	if (v === void 0 || v === null) return v;
	return String(v).padStart(length, char);
}
XMLHttpRequest.prototype.open;
var useSizeDefaults = {
	xs: 18,
	sm: 24,
	md: 32,
	lg: 38,
	xl: 46
};
var useSizeProps = { size: String };
function useSize(props, sizes = useSizeDefaults) {
	return computed(() => props.size !== void 0 ? { fontSize: props.size in sizes ? `${sizes[props.size]}px` : props.size } : null);
}
function hSlot(slot, otherwise) {
	return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot(slot, otherwise) {
	if (slot !== void 0) {
		const vnode = slot();
		if (vnode !== void 0 && vnode !== null) return [...vnode];
	}
	return otherwise;
}
/**
* Source definitely exists,
* so it's merged with the possible slot
*/
function hMergeSlot(slot, source) {
	return slot !== void 0 ? source.concat(slot()) : source;
}
/**
* Merge with possible slot,
* even if source might not exist
*/
function hMergeSlotSafely(slot, source) {
	if (slot === void 0) return source;
	return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir(tag, data, children, key, condition, getDirsFn) {
	data.key = key + condition;
	const vnode = h(tag, data, children);
	return condition ? withDirectives(vnode, getDirsFn()) : vnode;
}
var defaultViewBox = "0 0 24 24";
var sameFn = (i) => i;
var ionFn = (i) => `ionicons ${i}`;
var libMap = {
	"mdi-": (i) => `mdi ${i}`,
	"icon-": sameFn,
	"bt-": (i) => `bt ${i}`,
	"eva-": (i) => `eva ${i}`,
	"ion-md": ionFn,
	"ion-ios": ionFn,
	"ion-logo": ionFn,
	"iconfont ": sameFn,
	"ti-": (i) => `themify-icon ${i}`,
	"bi-": (i) => `bootstrap-icons ${i}`,
	"i-": sameFn
};
var matMap = {
	o_: "-outlined",
	r_: "-round",
	s_: "-sharp"
};
var symMap = {
	sym_o_: "-outlined",
	sym_r_: "-rounded",
	sym_s_: "-sharp"
};
var libRE = new RegExp("^(" + Object.keys(libMap).join("|") + ")");
var matRE = new RegExp("^(" + Object.keys(matMap).join("|") + ")");
var symRE = new RegExp("^(" + Object.keys(symMap).join("|") + ")");
var mRE = /^[Mm]\s?[-+]?\.?\d/;
var imgRE = /^img:/;
var svgUseRE = /^svguse:/;
var ionRE = /^ion-/;
var faRE = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var QIcon_default = /*#__PURE__*/ createComponent({
	name: "QIcon",
	props: {
		...useSizeProps,
		tag: {
			type: String,
			default: "i"
		},
		name: String,
		color: String,
		left: Boolean,
		right: Boolean
	},
	setup(props, { slots }) {
		const { proxy: { $q } } = getCurrentInstance();
		const sizeStyle = useSize(props);
		const classes = computed(() => "q-icon" + (props.left ? " on-left" : "") + (props.right ? " on-right" : "") + (props.color !== void 0 ? ` text-${props.color}` : ""));
		const type = computed(() => {
			let cls;
			let icon = props.name;
			if (icon === "none" || !icon) return { none: true };
			if ($q.iconMapFn !== null) {
				const res = $q.iconMapFn(icon);
				if (res !== void 0) if (res.icon !== void 0) {
					icon = res.icon;
					if (icon === "none" || !icon) return { none: true };
				} else return {
					cls: res.cls,
					content: res.content !== void 0 ? res.content : " "
				};
			}
			if (mRE.test(icon)) {
				const [def, viewBox = defaultViewBox] = icon.split("|");
				return {
					svg: true,
					viewBox,
					nodes: def.split("&&").map((path) => {
						const [d, style, transform] = path.split("@@");
						return h("path", {
							style,
							d,
							transform
						});
					})
				};
			}
			if (imgRE.test(icon)) return {
				img: true,
				src: icon.slice(4)
			};
			if (svgUseRE.test(icon)) {
				const [def, viewBox = defaultViewBox] = icon.split("|");
				return {
					svguse: true,
					src: def.slice(7),
					viewBox
				};
			}
			let content = " ";
			const matches = icon.match(libRE);
			if (matches !== null) cls = libMap[matches[1]](icon);
			else if (faRE.test(icon)) cls = icon;
			else if (ionRE.test(icon)) cls = `ionicons ion-${$q.platform.is.ios ? "ios" : "md"}${icon.slice(3)}`;
			else if (symRE.test(icon)) {
				cls = "notranslate material-symbols";
				const symMatches = icon.match(symRE);
				if (symMatches !== null) {
					icon = icon.slice(6);
					cls += symMap[symMatches[1]];
				}
				content = icon;
			} else {
				cls = "notranslate material-icons";
				const matMatches = icon.match(matRE);
				if (matMatches !== null) {
					icon = icon.slice(2);
					cls += matMap[matMatches[1]];
				}
				content = icon;
			}
			return {
				cls,
				content
			};
		});
		return () => {
			const data = {
				class: classes.value,
				style: sizeStyle.value,
				"aria-hidden": "true"
			};
			if (type.value.none) return h(props.tag, data, hSlot(slots.default));
			if (type.value.img) return h(props.tag, data, hMergeSlot(slots.default, [h("img", { src: type.value.src })]));
			if (type.value.svg) return h(props.tag, data, hMergeSlot(slots.default, [h("svg", { viewBox: type.value.viewBox || "0 0 24 24" }, type.value.nodes)]));
			if (type.value.svguse) return h(props.tag, data, hMergeSlot(slots.default, [h("svg", { viewBox: type.value.viewBox }, [h("use", { "xlink:href": type.value.src })])]));
			if (type.value.cls !== void 0) data.class += " " + type.value.cls;
			return h(props.tag, data, hMergeSlot(slots.default, [type.value.content]));
		};
	}
});
var QAvatar_default = /*#__PURE__*/ createComponent({
	name: "QAvatar",
	props: {
		...useSizeProps,
		fontSize: String,
		color: String,
		textColor: String,
		icon: String,
		square: Boolean,
		rounded: Boolean
	},
	setup(props, { slots }) {
		const sizeStyle = useSize(props);
		const classes = computed(() => "q-avatar" + (props.color ? ` bg-${props.color}` : "") + (props.textColor ? ` text-${props.textColor} q-chip--colored` : "") + (props.square ? " q-avatar--square" : props.rounded ? " rounded-borders" : ""));
		const contentStyle = computed(() => props.fontSize ? { fontSize: props.fontSize } : null);
		return () => {
			const icon = props.icon !== void 0 ? [h(QIcon_default, { name: props.icon })] : void 0;
			return h("div", {
				class: classes.value,
				style: sizeStyle.value
			}, [h("div", {
				class: "q-avatar__content row flex-center overflow-hidden",
				style: contentStyle.value
			}, hMergeSlotSafely(slots.default, icon))]);
		};
	}
});
var useDarkProps = { dark: {
	type: Boolean,
	default: null
} };
function useDark(props, $q) {
	return computed(() => props.dark === null ? $q.dark.isActive : props.dark);
}
({ ...useDarkProps });
({ ...useDarkProps });
var alignMap = {
	left: "start",
	center: "center",
	right: "end",
	between: "between",
	around: "around",
	evenly: "evenly",
	stretch: "stretch"
};
var alignValues$2 = Object.keys(alignMap);
var useAlignProps = { align: {
	type: String,
	validator: (v) => alignValues$2.includes(v)
} };
function useAlign(props) {
	return computed(() => {
		const align = props.align === void 0 ? props.vertical ? "stretch" : "left" : props.align;
		return `${props.vertical ? "items" : "justify"}-${alignMap[align]}`;
	});
}
function getParentProxy(proxy) {
	if (Object(proxy.$parent) === proxy.$parent) return proxy.$parent;
	let { parent } = proxy.$;
	while (Object(parent) === parent) {
		if (Object(parent.proxy) === parent.proxy) return parent.proxy;
		parent = parent.parent;
	}
}
function fillNormalizedVNodes(children, vnode) {
	if (typeof vnode.type === "symbol") {
		if (Array.isArray(vnode.children)) vnode.children.forEach((child) => {
			fillNormalizedVNodes(children, child);
		});
	} else children.add(vnode);
}
function getNormalizedVNodes(vnodes) {
	const children = /* @__PURE__ */ new Set();
	vnodes.forEach((vnode) => {
		fillNormalizedVNodes(children, vnode);
	});
	return [...children];
}
function vmHasRouter(vm) {
	return vm.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed(vm) {
	return vm.isUnmounted === true || vm.isDeactivated === true;
}
({ ...useAlignProps });
function getOriginalPath(record) {
	return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord(a, b) {
	return (a.aliasOf || a) === (b.aliasOf || b);
}
function includesParams(outer, inner) {
	for (const key in inner) {
		const innerValue = inner[key], outerValue = outer[key];
		if (typeof innerValue === "string") {
			if (innerValue !== outerValue) return false;
		} else if (!Array.isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i) => value !== outerValue[i])) return false;
	}
	return true;
}
function isEquivalentArray(a, b) {
	return Array.isArray(b) ? a.length === b.length && a.every((value, i) => value === b[i]) : a.length === 1 && a[0] === b;
}
function isSameRouteLocationParamsValue(a, b) {
	return Array.isArray(a) ? isEquivalentArray(a, b) : Array.isArray(b) ? isEquivalentArray(b, a) : a === b;
}
function isSameRouteLocationParams(a, b) {
	if (Object.keys(a).length !== Object.keys(b).length) return false;
	for (const key in a) if (!isSameRouteLocationParamsValue(a[key], b[key])) return false;
	return true;
}
var useRouterLinkNonMatchingProps = {
	to: [String, Object],
	replace: Boolean,
	href: String,
	target: String,
	disable: Boolean
};
var useRouterLinkProps = {
	...useRouterLinkNonMatchingProps,
	exact: Boolean,
	activeClass: {
		type: String,
		default: "q-router-link--active"
	},
	exactActiveClass: {
		type: String,
		default: "q-router-link--exact-active"
	}
};
function useRouterLink({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
	const vm = getCurrentInstance();
	const { props, proxy, emit } = vm;
	const hasRouter = vmHasRouter(vm);
	const hasHrefLink = computed(() => !props.disable && props.href !== void 0);
	const hasRouterLinkProps = useDisableForRouterLinkProps ? computed(() => hasRouter && !props.disable && !hasHrefLink.value && props.to !== void 0 && props.to !== null && props.to !== "") : computed(() => hasRouter && !hasHrefLink.value && props.to !== void 0 && props.to !== null && props.to !== "");
	const resolvedLink = computed(() => hasRouterLinkProps.value ? getLink(props.to) : null);
	const hasRouterLink = computed(() => resolvedLink.value !== null);
	const hasLink = computed(() => hasHrefLink.value || hasRouterLink.value);
	const linkTag = computed(() => props.type === "a" || hasLink.value ? "a" : props.tag || fallbackTag || "div");
	const linkAttrs = computed(() => hasHrefLink.value ? {
		href: props.href,
		target: props.target
	} : hasRouterLink.value ? {
		href: resolvedLink.value.href,
		target: props.target
	} : {});
	const linkActiveIndex = computed(() => {
		if (!hasRouterLink.value) return -1;
		const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
		if (routeMatched === void 0) return -1;
		const currentMatched = proxy.$route.matched;
		if (currentMatched.length === 0) return -1;
		const index = currentMatched.findIndex(isSameRouteRecord.bind(null, routeMatched));
		if (index !== -1) return index;
		const parentRecordPath = getOriginalPath(matched[length - 2]);
		return length > 1 && getOriginalPath(routeMatched) === parentRecordPath && currentMatched.at(-1).path !== parentRecordPath ? currentMatched.findIndex(isSameRouteRecord.bind(null, matched[length - 2])) : index;
	});
	const linkIsActive = computed(() => hasRouterLink.value && linkActiveIndex.value !== -1 && includesParams(proxy.$route.params, resolvedLink.value.params));
	const linkIsExactActive = computed(() => linkIsActive.value && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams(proxy.$route.params, resolvedLink.value.params));
	const linkClass = computed(() => hasRouterLink.value ? linkIsExactActive.value ? ` ${props.exactActiveClass} ${props.activeClass}` : props.exact ? "" : linkIsActive.value ? ` ${props.activeClass}` : "" : "");
	function getLink(to) {
		try {
			return proxy.$router.resolve(to);
		} catch {}
		return null;
	}
	/**
	* @returns Promise<RouterError | false | undefined>
	*/
	function navigateToRouterLink(e, { returnRouterError, to = props.to, replace = props.replace } = {}) {
		if (props.disable) {
			e.preventDefault();
			return Promise.resolve(false);
		}
		if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button !== void 0 && e.button !== 0 || props.target === "_blank") return Promise.resolve(false);
		e.preventDefault();
		const promise = proxy.$router[replace ? "replace" : "push"](to);
		return returnRouterError ? promise : promise.then(() => {}).catch(() => {});
	}
	function navigateOnClick(e) {
		if (hasRouterLink.value) {
			const go = (opts) => navigateToRouterLink(e, opts);
			emit("click", e, go);
			if (!e.defaultPrevented) go();
		} else emit("click", e);
	}
	return {
		hasRouterLink,
		hasHrefLink,
		hasLink,
		linkTag,
		resolvedLink,
		linkIsActive,
		linkIsExactActive,
		linkClass,
		linkAttrs,
		getLink,
		navigateToRouterLink,
		navigateOnClick
	};
}
({ ...useRouterLinkProps });
var useSpinnerProps = {
	size: {
		type: [String, Number],
		default: "1em"
	},
	color: String
};
function useSpinner(props) {
	return {
		cSize: computed(() => props.size in useSizeDefaults ? `${useSizeDefaults[props.size]}px` : props.size),
		classes: computed(() => "q-spinner" + (props.color ? ` text-${props.color}` : ""))
	};
}
var QSpinner_default = /*#__PURE__*/ createComponent({
	name: "QSpinner",
	props: {
		...useSpinnerProps,
		thickness: {
			type: Number,
			default: 5
		}
	},
	setup(props) {
		const { cSize, classes } = useSpinner(props);
		return () => h("svg", {
			class: classes.value + " q-spinner-mat",
			width: cSize.value,
			height: cSize.value,
			viewBox: "25 25 50 50"
		}, [h("circle", {
			class: "path",
			cx: "50",
			cy: "50",
			r: "20",
			fill: "none",
			stroke: "currentColor",
			"stroke-width": props.thickness,
			"stroke-miterlimit": "10"
		})]);
	}
});
function height(el) {
	return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function css(element, cssObject) {
	const elementStyle = element.style;
	for (const prop in cssObject) elementStyle[prop] = cssObject[prop];
}
function getElement$1(el) {
	if (el === void 0 || el === null) return;
	if (typeof el === "string") try {
		return document.querySelector(el) || void 0;
	} catch {
		return;
	}
	const target = unref(el);
	if (target) return target.$el || target;
}
function childHasFocus(el, focusedEl) {
	if (el === void 0 || el === null || el.contains(focusedEl)) return true;
	for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) if (next.contains(focusedEl)) return true;
	return false;
}
function throttle$1(fn, limit = 250) {
	let wait = false, result;
	return function runThrottle(...args) {
		if (!wait) {
			wait = true;
			setTimeout(() => {
				wait = false;
			}, limit);
			result = fn.apply(this, args);
		}
		return result;
	};
}
function showRipple(evt, el, ctx, forceCenter) {
	if (ctx.modifiers.stop) stop(evt);
	const color = ctx.modifiers.color, center = ctx.modifiers.center || forceCenter === true, node = document.createElement("span"), innerNode = document.createElement("span"), pos = position(evt), { left, top, width, height } = el.getBoundingClientRect(), diameter = Math.hypot(width, height), radius = diameter / 2, centerX = `${(width - diameter) / 2}px`, x = center ? centerX : `${pos.left - left - radius}px`, centerY = `${(height - diameter) / 2}px`, y = center ? centerY : `${pos.top - top - radius}px`;
	innerNode.className = "q-ripple__inner";
	css(innerNode, {
		height: `${diameter}px`,
		width: `${diameter}px`,
		transform: `translate3d(${x},${y},0) scale3d(.2,.2,1)`,
		opacity: 0
	});
	node.className = `q-ripple${color ? " text-" + color : ""}`;
	node.setAttribute("dir", "ltr");
	node.append(innerNode);
	el.append(node);
	const abort = () => {
		node.remove();
		clearTimeout(timer);
	};
	ctx.abort.push(abort);
	let timer = setTimeout(() => {
		innerNode.classList.add("q-ripple__inner--enter");
		innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
		innerNode.style.opacity = .2;
		timer = setTimeout(() => {
			innerNode.classList.remove("q-ripple__inner--enter");
			innerNode.classList.add("q-ripple__inner--leave");
			innerNode.style.opacity = 0;
			timer = setTimeout(() => {
				node.remove();
				ctx.abort.splice(ctx.abort.indexOf(abort), 1);
			}, 275);
		}, 250);
	}, 50);
}
function updateModifiers$1(ctx, { modifiers, value, arg }) {
	const cfg = {
		...ctx.cfg.ripple,
		...modifiers,
		...value
	};
	ctx.modifiers = {
		early: cfg.early === true,
		stop: cfg.stop === true,
		center: cfg.center === true,
		color: cfg.color || arg,
		keyCodes: [cfg.keyCodes || 13].flat()
	};
}
var Ripple_default = /*#__PURE__*/ createDirective({
	name: "ripple",
	beforeMount(el, binding) {
		const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
		if (cfg.ripple === false) return;
		const ctx = {
			cfg,
			enabled: binding.value !== false,
			modifiers: {},
			abort: [],
			start(evt) {
				if (ctx.enabled && !evt.qSkipRipple && evt.type === (ctx.modifiers.early ? "pointerdown" : "click")) showRipple(evt, el, ctx, evt.qKeyEvent === true);
			},
			keystart: throttle$1((evt) => {
				if (ctx.enabled && !evt.qSkipRipple && isKeyCode(evt, ctx.modifiers.keyCodes) && evt.type === `key${ctx.modifiers.early ? "down" : "up"}`) showRipple(evt, el, ctx, true);
			}, 300)
		};
		updateModifiers$1(ctx, binding);
		el.__qripple = ctx;
		addEvt(ctx, "main", [
			[
				el,
				"pointerdown",
				"start",
				"passive"
			],
			[
				el,
				"click",
				"start",
				"passive"
			],
			[
				el,
				"keydown",
				"keystart",
				"passive"
			],
			[
				el,
				"keyup",
				"keystart",
				"passive"
			]
		]);
	},
	updated(el, binding) {
		if (binding.oldValue !== binding.value) {
			const ctx = el.__qripple;
			if (ctx !== void 0) {
				ctx.enabled = binding.value !== false;
				if (ctx.enabled && Object(binding.value) === binding.value) updateModifiers$1(ctx, binding);
			}
		}
	},
	beforeUnmount(el) {
		const ctx = el.__qripple;
		if (ctx !== void 0) {
			ctx.abort.forEach((fn) => {
				fn();
			});
			cleanEvt(ctx, "main");
			delete el.__qripple;
		}
	}
});
var btnPadding = {
	none: 0,
	xs: 4,
	sm: 8,
	md: 16,
	lg: 24,
	xl: 32
};
var defaultSizes$2 = {
	xs: 8,
	sm: 10,
	md: 14,
	lg: 20,
	xl: 24
};
var formTypes = [
	"button",
	"submit",
	"reset"
];
var mediaTypeRE = /[^\s]\/[^\s]/;
var btnDesignOptions = [
	"flat",
	"outline",
	"push",
	"unelevated"
];
function getBtnDesign(props, defaultValue) {
	if (props.flat) return "flat";
	if (props.outline) return "outline";
	if (props.push) return "push";
	if (props.unelevated) return "unelevated";
	return defaultValue;
}
function getBtnDesignAttr(props) {
	const design = getBtnDesign(props);
	return design !== void 0 ? { [design]: true } : {};
}
var nonRoundBtnProps = {
	...useSizeProps,
	...useRouterLinkNonMatchingProps,
	type: {
		type: String,
		default: "button"
	},
	label: [Number, String],
	icon: String,
	iconRight: String,
	...btnDesignOptions.reduce((acc, val) => (acc[val] = Boolean) && acc, {}),
	square: Boolean,
	rounded: Boolean,
	glossy: Boolean,
	size: String,
	fab: Boolean,
	fabMini: Boolean,
	padding: String,
	color: String,
	textColor: String,
	noCaps: Boolean,
	noWrap: Boolean,
	dense: Boolean,
	tabindex: [Number, String],
	ripple: {
		type: [Boolean, Object],
		default: true
	},
	align: {
		...useAlignProps.align,
		default: "center"
	},
	stack: Boolean,
	stretch: Boolean,
	loading: {
		type: Boolean,
		default: null
	},
	disable: Boolean
};
var useBtnProps = {
	...nonRoundBtnProps,
	round: Boolean
};
function useBtn(props) {
	const sizeStyle = useSize(props, defaultSizes$2);
	const alignClass = useAlign(props);
	const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = useRouterLink({ fallbackTag: "button" });
	const style = computed(() => {
		const obj = props.fab || props.fabMini ? {} : sizeStyle.value;
		return props.padding !== void 0 ? {
			...obj,
			padding: props.padding.split(/\s+/).map((v) => v in btnPadding ? btnPadding[v] + "px" : v).join(" "),
			minWidth: "0",
			minHeight: "0"
		} : obj;
	});
	const isRounded = computed(() => props.rounded || props.fab || props.fabMini);
	const isActionable = computed(() => !props.disable && !props.loading);
	const tabIndex = computed(() => isActionable.value ? props.tabindex || 0 : -1);
	const design = computed(() => getBtnDesign(props, "standard"));
	const attributes = computed(() => {
		const acc = { tabindex: tabIndex.value };
		if (hasLink.value) Object.assign(acc, linkAttrs.value);
		else if (formTypes.includes(props.type)) acc.type = props.type;
		if (linkTag.value === "a") {
			if (props.disable) acc["aria-disabled"] = "true";
			else if (acc.href === void 0) acc.role = "button";
			if (!hasRouterLink.value && mediaTypeRE.test(props.type)) acc.type = props.type;
		} else if (props.disable) {
			acc.disabled = "";
			acc["aria-disabled"] = "true";
		}
		if (props.loading && props.percentage !== void 0) Object.assign(acc, {
			role: "progressbar",
			"aria-valuemin": 0,
			"aria-valuemax": 100,
			"aria-valuenow": props.percentage
		});
		return acc;
	});
	return {
		classes: computed(() => {
			let colors;
			if (props.color !== void 0) colors = props.flat || props.outline ? `text-${props.textColor || props.color}` : `bg-${props.color} text-${props.textColor || "white"}`;
			else if (props.textColor) colors = `text-${props.textColor}`;
			const shape = props.round ? "round" : `rectangle${isRounded.value ? " q-btn--rounded" : props.square ? " q-btn--square" : ""}`;
			return `q-btn--${design.value} q-btn--${shape}` + (colors !== void 0 ? " " + colors : "") + (isActionable.value ? " q-btn--actionable q-focusable q-hoverable" : props.disable ? " disabled" : "") + (props.fab ? " q-btn--fab" : props.fabMini ? " q-btn--fab-mini" : "") + (props.noCaps ? " q-btn--no-uppercase" : "") + (props.dense ? " q-btn--dense" : "") + (props.stretch ? " no-border-radius self-stretch" : "") + (props.glossy ? " glossy" : "") + (props.square ? " q-btn--square" : "");
		}),
		style,
		innerClasses: computed(() => alignClass.value + (props.stack ? " column" : " row") + (props.noWrap ? " no-wrap text-no-wrap" : "") + (props.loading ? " q-btn__content--hidden" : "")),
		attributes,
		hasLink,
		linkTag,
		navigateOnClick,
		isActionable
	};
}
var { passiveCapture } = listenOpts;
var touchTarget = null;
var keyboardTarget = null;
var mouseTarget = null;
function onLoadingEvt(evt) {
	stopAndPrevent(evt);
	evt.qSkipRipple = true;
}
var QBtn_default = /*#__PURE__*/ createComponent({
	name: "QBtn",
	props: {
		...useBtnProps,
		percentage: Number,
		darkPercentage: Boolean,
		onTouchstart: [Function, Array]
	},
	emits: [
		"click",
		"keydown",
		"mousedown",
		"keyup"
	],
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const { classes, style, innerClasses, attributes, hasLink, linkTag, navigateOnClick, isActionable } = useBtn(props);
		const rootRef = ref(null);
		const blurTargetRef = ref(null);
		let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null, clickCleanup = null;
		const hasLabel = computed(() => props.label !== void 0 && props.label !== null && props.label !== "");
		const ripple = computed(() => props.disable || props.ripple === false ? false : {
			keyCodes: hasLink.value ? [13, 32] : [13],
			...props.ripple === true ? {} : props.ripple
		});
		const rippleProps = computed(() => ({ center: props.round }));
		const percentageStyle = computed(() => {
			const val = Math.max(0, Math.min(100, props.percentage));
			return val > 0 ? {
				transition: "transform 0.6s",
				transform: `translateX(${val - 100}%)`
			} : {};
		});
		const onEvents = computed(() => {
			if (props.loading) return {
				onMousedown: onLoadingEvt,
				onTouchstart: onLoadingEvt,
				onClick: onLoadingEvt,
				onKeydown: onLoadingEvt,
				onKeyup: onLoadingEvt
			};
			if (isActionable.value) {
				const acc = {
					onClick,
					onKeydown,
					onMousedown
				};
				if (proxy.$q.platform.has.touch) {
					const suffix = props.onTouchstart !== void 0 ? "" : "Passive";
					acc[`onTouchstart${suffix}`] = onTouchstart;
				}
				return acc;
			}
			return { onClick: stopAndPrevent };
		});
		const nodeProps = computed(() => ({
			ref: rootRef,
			class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
			style: style.value,
			...attributes.value,
			...onEvents.value
		}));
		function onClick(e) {
			if (rootRef.value === null) return;
			if (e !== void 0) {
				if (e.defaultPrevented) return;
				const el = document.activeElement;
				if (props.type === "submit" && el !== document.body && !rootRef.value.contains(el) && !el.contains(rootRef.value)) {
					if (!e.qAvoidFocus) rootRef.value.focus();
					const onClickCleanup = () => {
						clickCleanup = null;
						document.removeEventListener("keydown", stopAndPrevent, true);
						document.removeEventListener("keyup", onClickCleanup, passiveCapture);
						rootRef.value?.removeEventListener("blur", onClickCleanup, passiveCapture);
					};
					clickCleanup = onClickCleanup;
					document.addEventListener("keydown", stopAndPrevent, true);
					document.addEventListener("keyup", onClickCleanup, passiveCapture);
					rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture);
				}
			}
			navigateOnClick(e);
		}
		function onKeydown(e) {
			if (rootRef.value === null) return;
			emit("keydown", e);
			if (isKeyCode(e, [13, 32]) && keyboardTarget !== rootRef.value) {
				if (keyboardTarget !== null) cleanup();
				if (!e.defaultPrevented) {
					if (!e.qAvoidFocus) rootRef.value.focus();
					keyboardTarget = rootRef.value;
					rootRef.value.classList.add("q-btn--active");
					document.addEventListener("keyup", onPressEnd, true);
					rootRef.value.addEventListener("blur", onPressEnd, passiveCapture);
				}
				stopAndPrevent(e);
			}
		}
		function onTouchstart(e) {
			if (rootRef.value === null) return;
			emit("touchstart", e);
			if (e.defaultPrevented) return;
			if (touchTarget !== rootRef.value) {
				if (touchTarget !== null) cleanup();
				touchTarget = rootRef.value;
				localTouchTargetEl = e.target;
				localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture);
				localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture);
			}
			avoidMouseRipple = true;
			if (mouseTimer !== null) clearTimeout(mouseTimer);
			mouseTimer = setTimeout(() => {
				mouseTimer = null;
				avoidMouseRipple = false;
			}, 200);
		}
		function onMousedown(e) {
			if (rootRef.value === null) return;
			e.qSkipRipple = avoidMouseRipple === true;
			emit("mousedown", e);
			if (!e.defaultPrevented && mouseTarget !== rootRef.value) {
				if (mouseTarget !== null) cleanup();
				mouseTarget = rootRef.value;
				rootRef.value.classList.add("q-btn--active");
				document.addEventListener("mouseup", onPressEnd, passiveCapture);
			}
		}
		function onPressEnd(e) {
			if (rootRef.value === null) return;
			if (e?.type === "blur" && document.activeElement === rootRef.value) return;
			if (e?.type === "keyup") {
				if (keyboardTarget === rootRef.value && isKeyCode(e, [13, 32])) {
					const evt = new MouseEvent("click", e);
					evt.qKeyEvent = true;
					if (e.defaultPrevented) prevent(evt);
					if (e.cancelBubble) stop(evt);
					rootRef.value.dispatchEvent(evt);
					stopAndPrevent(e);
					e.qKeyEvent = true;
				}
				emit("keyup", e);
			}
			cleanup();
		}
		function cleanup(destroying) {
			clickCleanup?.();
			const blurTarget = blurTargetRef.value;
			if (!destroying && (touchTarget === rootRef.value || mouseTarget === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
				blurTarget.setAttribute("tabindex", -1);
				blurTarget.focus({ preventScroll: true });
			}
			if (touchTarget === rootRef.value) {
				if (localTouchTargetEl !== null) {
					localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture);
					localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture);
				}
				touchTarget = localTouchTargetEl = null;
			}
			if (mouseTarget === rootRef.value) {
				document.removeEventListener("mouseup", onPressEnd, passiveCapture);
				mouseTarget = null;
			}
			if (keyboardTarget === rootRef.value) {
				document.removeEventListener("keyup", onPressEnd, true);
				rootRef.value?.removeEventListener("blur", onPressEnd, passiveCapture);
				keyboardTarget = null;
			}
			rootRef.value?.classList.remove("q-btn--active");
		}
		onBeforeUnmount(() => {
			cleanup(true);
		});
		Object.assign(proxy, { click: (e) => {
			if (isActionable.value) onClick(e);
		} });
		return () => {
			let inner = [];
			if (props.icon !== void 0) inner.push(h(QIcon_default, {
				name: props.icon,
				left: !props.stack && hasLabel.value,
				role: "img"
			}));
			if (hasLabel.value) inner.push(h("span", { class: "block" }, [props.label]));
			inner = hMergeSlot(slots.default, inner);
			if (props.iconRight !== void 0 && !props.round) inner.push(h(QIcon_default, {
				name: props.iconRight,
				right: !props.stack && hasLabel.value,
				role: "img"
			}));
			const child = [h("span", {
				class: "q-focus-helper",
				ref: blurTargetRef
			})];
			if (props.loading && props.percentage !== void 0) child.push(h("span", { class: "q-btn__progress absolute-full overflow-hidden" + (props.darkPercentage ? " q-btn__progress--dark" : "") }, [h("span", {
				class: "q-btn__progress-indicator fit block",
				style: percentageStyle.value
			})]));
			child.push(h("span", { class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value }, inner));
			if (props.loading !== null) child.push(h(Transition, { name: "q-transition--fade" }, () => props.loading ? [h("span", {
				key: "loading",
				class: "absolute-full flex flex-center"
			}, slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default)])] : null));
			return withDirectives(h(linkTag.value, nodeProps.value, child), [[
				Ripple_default,
				ripple.value,
				void 0,
				rippleProps.value
			]]);
		};
	}
});
var QBtnGroup_default = /*#__PURE__*/ createComponent({
	name: "QBtnGroup",
	props: {
		unelevated: Boolean,
		outline: Boolean,
		flat: Boolean,
		rounded: Boolean,
		square: Boolean,
		push: Boolean,
		stretch: Boolean,
		glossy: Boolean,
		spread: Boolean
	},
	setup(props, { slots }) {
		const classes = computed(() => {
			const cls = [
				"unelevated",
				"outline",
				"flat",
				"rounded",
				"square",
				"push",
				"stretch",
				"glossy"
			].filter((t) => props[t]).map((t) => `q-btn-group--${t}`).join(" ");
			return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props.spread ? " q-btn-group--spread" : " inline");
		});
		return () => h("div", { class: classes.value }, hSlot(slots.default));
	}
});
function clearSelection() {
	if (window.getSelection !== void 0) {
		const selection = window.getSelection();
		if (selection.empty !== void 0) selection.empty();
		else if (selection.removeAllRanges !== void 0) {
			selection.removeAllRanges();
			if (!Platform.is.mobile) selection.addRange(document.createRange());
		}
	} else if (document.selection !== void 0) document.selection.empty();
}
var useAnchorStaticProps = {
	target: {
		type: [
			Boolean,
			String,
			Element
		],
		default: true
	},
	noParentEvent: Boolean
};
var useAnchorProps = {
	...useAnchorStaticProps,
	contextMenu: Boolean
};
function useAnchor({ showing, avoidEmit, configureAnchorEl }) {
	const { props, proxy, emit } = getCurrentInstance();
	const anchorEl = ref(null);
	let touchTimer = null;
	function canShow(evt) {
		return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
	}
	const anchorEvents = {};
	if (configureAnchorEl === void 0) {
		Object.assign(anchorEvents, {
			hide(evt) {
				proxy.hide(evt);
			},
			toggle(evt) {
				proxy.toggle(evt);
				evt.qAnchorHandled = true;
			},
			toggleKey(evt) {
				if (isKeyCode(evt, 13)) anchorEvents.toggle(evt);
			},
			contextClick(evt) {
				proxy.hide(evt);
				prevent(evt);
				nextTick(() => {
					proxy.show(evt);
					evt.qAnchorHandled = true;
				});
			},
			prevent,
			mobileTouch(evt) {
				anchorEvents.mobileCleanup(evt);
				if (!canShow(evt)) return;
				proxy.hide(evt);
				anchorEl.value.classList.add("non-selectable");
				const target = evt.target;
				addEvt(anchorEvents, "anchor", [
					[
						target,
						"touchmove",
						"mobileCleanup",
						"passive"
					],
					[
						target,
						"touchend",
						"mobileCleanup",
						"passive"
					],
					[
						target,
						"touchcancel",
						"mobileCleanup",
						"passive"
					],
					[
						anchorEl.value,
						"contextmenu",
						"prevent",
						"notPassive"
					]
				]);
				touchTimer = setTimeout(() => {
					touchTimer = null;
					proxy.show(evt);
					evt.qAnchorHandled = true;
				}, 300);
			},
			mobileCleanup(evt) {
				anchorEl.value.classList.remove("non-selectable");
				if (touchTimer !== null) {
					clearTimeout(touchTimer);
					touchTimer = null;
				}
				if (showing.value && evt !== void 0) clearSelection();
			}
		});
		configureAnchorEl = function configureAnchorElFn(context = props.contextMenu) {
			if (props.noParentEvent || anchorEl.value === null) return;
			const evts = context ? proxy.$q.platform.is.mobile ? [[
				anchorEl.value,
				"touchstart",
				"mobileTouch",
				"passive"
			]] : [[
				anchorEl.value,
				"mousedown",
				"hide",
				"passive"
			], [
				anchorEl.value,
				"contextmenu",
				"contextClick",
				"notPassive"
			]] : [[
				anchorEl.value,
				"click",
				"toggle",
				"passive"
			], [
				anchorEl.value,
				"keyup",
				"toggleKey",
				"passive"
			]];
			addEvt(anchorEvents, "anchor", evts);
		};
	}
	function unconfigureAnchorEl() {
		cleanEvt(anchorEvents, "anchor");
	}
	function setAnchorEl(el) {
		anchorEl.value = el;
		while (anchorEl.value.classList.contains("q-anchor--skip")) anchorEl.value = anchorEl.value.parentNode;
		configureAnchorEl();
	}
	function pickAnchorEl() {
		if (props.target === false || props.target === "" || proxy.$el.parentNode === null) anchorEl.value = null;
		else if (props.target === true) setAnchorEl(proxy.$el.parentNode);
		else {
			let el = props.target;
			if (typeof props.target === "string") try {
				el = document.querySelector(props.target);
			} catch {
				el = void 0;
			}
			if (el !== void 0 && el !== null) {
				anchorEl.value = el.$el || el;
				configureAnchorEl();
			} else {
				anchorEl.value = null;
				console.error(`Anchor: target "${props.target}" not found`);
			}
		}
	}
	watch(() => props.contextMenu, (val) => {
		if (anchorEl.value !== null) {
			unconfigureAnchorEl();
			configureAnchorEl(val);
		}
	});
	watch(() => props.target, () => {
		if (anchorEl.value !== null) unconfigureAnchorEl();
		pickAnchorEl();
	});
	watch(() => props.noParentEvent, (val) => {
		if (anchorEl.value !== null) if (val) unconfigureAnchorEl();
		else configureAnchorEl();
	});
	onMounted(() => {
		pickAnchorEl();
		if (!avoidEmit && props.modelValue && anchorEl.value === null) emit("update:modelValue", false);
	});
	onBeforeUnmount(() => {
		if (touchTimer !== null) clearTimeout(touchTimer);
		unconfigureAnchorEl();
	});
	return {
		anchorEl,
		canShow,
		anchorEvents
	};
}
function useScrollTarget(props, configureScrollTarget) {
	const localScrollTarget = ref(null);
	let scrollFn;
	function changeScrollEvent(scrollTarget, fn) {
		const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
		const fnHandler = fn !== void 0 ? fn : scrollFn;
		if (scrollTarget !== window) scrollTarget[fnProp]("scroll", fnHandler, listenOpts.passive);
		window[fnProp]("scroll", fnHandler, listenOpts.passive);
		scrollFn = fn;
	}
	function unconfigureScrollTarget() {
		if (localScrollTarget.value !== null) {
			changeScrollEvent(localScrollTarget.value);
			localScrollTarget.value = null;
		}
	}
	onBeforeUnmount(watch(() => props.noParentEvent, () => {
		if (localScrollTarget.value !== null) {
			unconfigureScrollTarget();
			configureScrollTarget();
		}
	}));
	return {
		localScrollTarget,
		unconfigureScrollTarget,
		changeScrollEvent
	};
}
var useModelToggleProps = {
	modelValue: {
		type: Boolean,
		default: null
	},
	"onUpdate:modelValue": [Function, Array]
};
var useModelToggleEmits = [
	"beforeShow",
	"show",
	"beforeHide",
	"hide"
];
function useModelToggle({ showing, canShow, hideOnRouteChange, handleShow, handleHide, handleRouteChange, processOnMount }) {
	const vm = getCurrentInstance();
	const { props, emit, proxy } = vm;
	let payload;
	function toggle(evt) {
		if (showing.value) hide(evt);
		else show(evt);
	}
	function show(evt) {
		if (props.disable || evt?.qAnchorHandled === true || canShow !== void 0 && !canShow(evt)) return;
		const listener = props["onUpdate:modelValue"] !== void 0;
		if (listener && true) {
			emit("update:modelValue", true);
			payload = evt;
			nextTick(() => {
				if (payload === evt) payload = void 0;
			});
		}
		if (props.modelValue === null || !listener) processShow(evt);
	}
	function processShow(evt) {
		if (showing.value) return;
		showing.value = true;
		emit("beforeShow", evt);
		if (handleShow !== void 0) handleShow(evt);
		else emit("show", evt);
	}
	function hide(evt) {
		if (props.disable) return;
		const listener = props["onUpdate:modelValue"] !== void 0;
		if (listener && true) {
			emit("update:modelValue", false);
			payload = evt;
			nextTick(() => {
				if (payload === evt) payload = void 0;
			});
		}
		if (props.modelValue === null || !listener) processHide(evt);
	}
	function processHide(evt) {
		if (!showing.value) return;
		showing.value = false;
		emit("beforeHide", evt);
		if (handleHide !== void 0) handleHide(evt);
		else emit("hide", evt);
	}
	function processModelChange(val) {
		if (props.disable && val) {
			if (props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", false);
		} else if (val === true !== showing.value) (val ? processShow : processHide)(payload);
	}
	watch(() => props.modelValue, processModelChange);
	if (hideOnRouteChange !== void 0 && vmHasRouter(vm)) watch(() => proxy.$route.fullPath, () => {
		if (hideOnRouteChange.value && showing.value) {
			handleRouteChange?.();
			hide();
		}
	});
	if (processOnMount) onMounted(() => {
		processModelChange(props.modelValue);
	});
	const publicMethods = {
		show,
		hide,
		toggle
	};
	Object.assign(proxy, publicMethods);
	return publicMethods;
}
var portalProxyList = [];
function closePortalMenus(proxy, evt) {
	do {
		if (proxy.$options.name === "QMenu") {
			proxy.hide(evt);
			if (proxy.$props.separateClosePopup) return getParentProxy(proxy);
		} else if (proxy.__qPortal) {
			const parent = getParentProxy(proxy);
			if (parent?.$options.name === "QPopupProxy") {
				proxy.hide(evt);
				return parent;
			}
			return proxy;
		}
		proxy = getParentProxy(proxy);
	} while (proxy !== void 0 && proxy !== null);
}
var queue = [];
var waitFlags = [];
function clearFlag(flag) {
	waitFlags = waitFlags.filter((entry) => entry !== flag);
}
function addFocusWaitFlag(flag) {
	clearFlag(flag);
	waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
	clearFlag(flag);
	if (waitFlags.length === 0 && queue.length !== 0) {
		queue.at(-1)();
		queue = [];
	}
}
function addFocusFn(fn) {
	if (waitFlags.length === 0) fn();
	else queue.push(fn);
}
function removeFocusFn(fn) {
	queue = queue.filter((entry) => entry !== fn);
}
var nodesList = [];
var portalTypeList = [];
var portalIndex = 1;
var target = document.body;
function createGlobalNode(id, portalType) {
	const el = document.createElement("div");
	el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex++}` : id;
	if (globalConfig.globalNodes !== void 0) {
		const cls = globalConfig.globalNodes.class;
		if (cls !== void 0) el.className = cls;
	}
	target.append(el);
	nodesList.push(el);
	portalTypeList.push(portalType);
	return el;
}
function removeGlobalNode(el) {
	const nodeIndex = nodesList.indexOf(el);
	if (nodeIndex !== -1) {
		nodesList.splice(nodeIndex, 1);
		portalTypeList.splice(nodeIndex, 1);
	}
	el.remove();
}
function changeGlobalNodesTarget(newTarget) {
	if (newTarget === target) return;
	target = newTarget;
	if (target === document.body || portalTypeList.reduce((acc, type) => type === "dialog" ? acc + 1 : acc, 0) < 2) {
		nodesList.forEach((node) => {
			if (!node.contains(target)) target.append(node);
		});
		return;
	}
	const lastDialogIndex = portalTypeList.lastIndexOf("dialog");
	for (let i = 0; i < nodesList.length; i++) {
		const el = nodesList[i];
		if ((i === lastDialogIndex || portalTypeList[i] !== "dialog") && !el.contains(target)) target.append(el);
	}
}
/**
* Noop internal component to ease testing
* of the teleported content.
*
* const wrapper = mount(QDialog, { ... })
* const teleportedWrapper = wrapper.findComponent({ name: 'QPortal' })
*/
var QPortal = /*#__PURE__*/ createComponent({
	name: "QPortal",
	setup(_, { slots }) {
		return () => slots.default();
	}
});
function isOnGlobalDialog(vm) {
	vm = vm.parent;
	while (vm !== void 0 && vm !== null) {
		if (vm.type.name === "QGlobalDialog") return true;
		if (vm.type.name === "QDialog" || vm.type.name === "QMenu") return false;
		vm = vm.parent;
	}
	return false;
}
function usePortal(vm, innerRef, renderPortalContent, type) {
	const portalIsActive = ref(false);
	const portalIsAccessible = ref(false);
	let portalEl = null;
	const focusObj = {};
	const onGlobalDialog = type === "dialog" && isOnGlobalDialog(vm);
	function showPortal(isReady) {
		if (isReady) {
			removeFocusWaitFlag(focusObj);
			portalIsAccessible.value = true;
			return;
		}
		portalIsAccessible.value = false;
		if (!portalIsActive.value) {
			if (!onGlobalDialog && portalEl === null) portalEl = createGlobalNode(false, type);
			portalIsActive.value = true;
			portalProxyList.push(vm.proxy);
			addFocusWaitFlag(focusObj);
		}
	}
	function hidePortal(isReady) {
		portalIsAccessible.value = false;
		if (!isReady) return;
		removeFocusWaitFlag(focusObj);
		portalIsActive.value = false;
		const index = portalProxyList.indexOf(vm.proxy);
		if (index !== -1) portalProxyList.splice(index, 1);
		if (portalEl !== null) {
			removeGlobalNode(portalEl);
			portalEl = null;
		}
	}
	onUnmounted(() => {
		hidePortal(true);
	});
	vm.proxy.__qPortal = true;
	injectProp(vm.proxy, "contentEl", () => innerRef.value);
	return {
		showPortal,
		hidePortal,
		portalIsActive,
		portalIsAccessible,
		renderPortal: () => onGlobalDialog ? renderPortalContent() : portalIsActive.value ? [h(Teleport, { to: portalEl }, h(QPortal, renderPortalContent))] : void 0
	};
}
var useTransitionProps = {
	transitionShow: {
		type: String,
		default: "fade"
	},
	transitionHide: {
		type: String,
		default: "fade"
	},
	transitionDuration: {
		type: [String, Number],
		default: 300
	}
};
function useTransition(props, defaultShowFn = () => {}, defaultHideFn = () => {}) {
	return {
		transitionProps: computed(() => {
			const show = `q-transition--${props.transitionShow || defaultShowFn()}`;
			const hide = `q-transition--${props.transitionHide || defaultHideFn()}`;
			return {
				appear: true,
				enterFromClass: `${show}-enter-from`,
				enterActiveClass: `${show}-enter-active`,
				enterToClass: `${show}-enter-to`,
				leaveFromClass: `${hide}-leave-from`,
				leaveActiveClass: `${hide}-leave-active`,
				leaveToClass: `${hide}-leave-to`
			};
		}),
		transitionStyle: computed(() => `--q-transition-duration: ${props.transitionDuration}ms`)
	};
}
function useTick() {
	let tickFn;
	const vm = getCurrentInstance();
	function removeTick() {
		tickFn = void 0;
	}
	onDeactivated(removeTick);
	onBeforeUnmount(removeTick);
	return {
		removeTick,
		registerTick(fn) {
			tickFn = fn;
			nextTick(() => {
				if (tickFn === fn) {
					if (!vmIsDestroyed(vm)) tickFn();
					tickFn = void 0;
				}
			});
		}
	};
}
function useTimeout() {
	let timer = null;
	const vm = getCurrentInstance();
	function removeTimeout() {
		if (timer !== null) {
			clearTimeout(timer);
			timer = null;
		}
	}
	onDeactivated(removeTimeout);
	onBeforeUnmount(removeTimeout);
	return {
		removeTimeout,
		registerTimeout(fn, delay) {
			removeTimeout();
			if (!vmIsDestroyed(vm)) timer = setTimeout(() => {
				timer = null;
				fn();
			}, delay);
		}
	};
}
var scrollTargetProp = [Element, String];
var scrollTargets = [
	null,
	document,
	document.body,
	document.scrollingElement,
	document.documentElement
];
function getScrollTarget(el, targetEl) {
	let target = getElement$1(targetEl);
	if (target === void 0) {
		if (el === void 0 || el === null) return window;
		target = el.closest(".scroll,.scroll-y,.overflow-auto");
	}
	return scrollTargets.includes(target) ? window : target;
}
function getScrollHeight(el) {
	return (el === window ? document.body : el).scrollHeight;
}
function getVerticalScrollPosition(scrollTarget) {
	return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition(scrollTarget) {
	return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo(el, to, duration = 0, rawPrevTime) {
	const prevTime = rawPrevTime === void 0 ? performance.now() : rawPrevTime;
	const pos = getVerticalScrollPosition(el);
	if (duration <= 0) {
		if (pos !== to) setScroll$1(el, to);
		return;
	}
	requestAnimationFrame((nowTime) => {
		const frameTime = nowTime - prevTime;
		const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
		setScroll$1(el, newPos);
		if (newPos !== to) animVerticalScrollTo(el, to, duration - frameTime, nowTime);
	});
}
function animHorizontalScrollTo(el, to, duration = 0, rawPrevTime) {
	const prevTime = rawPrevTime === void 0 ? performance.now() : rawPrevTime;
	const pos = getHorizontalScrollPosition(el);
	if (duration <= 0) {
		if (pos !== to) setHorizontalScroll(el, to);
		return;
	}
	requestAnimationFrame((nowTime) => {
		const frameTime = nowTime - prevTime;
		const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
		setHorizontalScroll(el, newPos);
		if (newPos !== to) animHorizontalScrollTo(el, to, duration - frameTime, nowTime);
	});
}
function setScroll$1(scrollTarget, offset) {
	if (scrollTarget === window) {
		window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset);
		return;
	}
	scrollTarget.scrollTop = offset;
}
function setHorizontalScroll(scrollTarget, offset) {
	if (scrollTarget === window) {
		window.scrollTo(offset, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
		return;
	}
	scrollTarget.scrollLeft = offset;
}
function setVerticalScrollPosition(scrollTarget, offset, duration) {
	if (duration) {
		animVerticalScrollTo(scrollTarget, offset, duration);
		return;
	}
	setScroll$1(scrollTarget, offset);
}
function setHorizontalScrollPosition(scrollTarget, offset, duration) {
	if (duration) {
		animHorizontalScrollTo(scrollTarget, offset, duration);
		return;
	}
	setHorizontalScroll(scrollTarget, offset);
}
var size;
function getScrollbarWidth() {
	if (size !== void 0) return size;
	const inner = document.createElement("p"), outer = document.createElement("div");
	css(inner, {
		width: "100%",
		height: "200px"
	});
	css(outer, {
		position: "absolute",
		top: "0px",
		left: "0px",
		visibility: "hidden",
		width: "200px",
		height: "150px",
		overflow: "hidden"
	});
	outer.append(inner);
	document.body.append(outer);
	const w1 = inner.offsetWidth;
	outer.style.overflow = "scroll";
	let w2 = inner.offsetWidth;
	if (w1 === w2) w2 = outer.clientWidth;
	outer.remove();
	size = w1 - w2;
	return size;
}
var handlers$1 = [];
var escDown;
function onKeydown$3(evt) {
	if (evt.keyCode === 27) escDown = true;
}
function onBlur() {
	if (escDown) escDown = false;
}
function onKeyup(evt) {
	if (escDown && isKeyCode(evt, 27)) {
		escDown = false;
		handlers$1.at(-1)(evt);
	}
}
function update$4(action) {
	window[action]("keydown", onKeydown$3);
	window[action]("blur", onBlur);
	window[action]("keyup", onKeyup);
	escDown = false;
}
function addEscapeKey(fn) {
	if (client.is.desktop) {
		handlers$1.push(fn);
		if (handlers$1.length === 1) update$4("addEventListener");
	}
}
function removeEscapeKey(fn) {
	const index = handlers$1.indexOf(fn);
	if (index !== -1) {
		handlers$1.splice(index, 1);
		if (handlers$1.length === 0) update$4("removeEventListener");
	}
}
var handlers = [];
function trigger$1(e) {
	handlers.at(-1)(e);
}
function addFocusout(fn) {
	if (client.is.desktop) {
		handlers.push(fn);
		if (handlers.length === 1) document.body.addEventListener("focusin", trigger$1);
	}
}
function removeFocusout(fn) {
	const index = handlers.indexOf(fn);
	if (index !== -1) {
		handlers.splice(index, 1);
		if (handlers.length === 0) document.body.removeEventListener("focusin", trigger$1);
	}
}
var timer = null;
var { notPassiveCapture } = listenOpts, registeredList = [];
function globalHandler(evt) {
	if (timer !== null) {
		clearTimeout(timer);
		timer = null;
	}
	const target = evt.target;
	if (target === void 0 || target.nodeType === 8 || target.classList.contains("no-pointer-events")) return;
	let closableContentEls = null;
	let sawClosablePortal = false;
	for (let i = portalProxyList.length - 1; i >= 0; i--) {
		const proxy = portalProxyList[i].$;
		const name = proxy.type.name;
		if (name === "QTooltip") continue;
		if (name === "QDialog") {
			if (proxy.props.seamless !== true) {
				if (sawClosablePortal === false) return;
				closableContentEls = new Set(portalProxyList.slice(i + 1).map((vm) => vm.contentEl));
				break;
			}
			continue;
		}
		sawClosablePortal = true;
	}
	for (let i = registeredList.length - 1; i >= 0; i--) {
		const state = registeredList[i];
		if (closableContentEls !== null && !closableContentEls.has(state.innerRef.value)) return;
		if ((state.anchorEl.value === null || !state.anchorEl.value.contains(target)) && (target === document.body || state.innerRef.value !== null && !state.innerRef.value.contains(target))) {
			evt.qClickOutside = true;
			state.onClickOutside(evt);
		} else return;
	}
}
function addClickOutside(clickOutsideProps) {
	registeredList.push(clickOutsideProps);
	if (registeredList.length === 1) {
		document.addEventListener("mousedown", globalHandler, notPassiveCapture);
		document.addEventListener("touchstart", globalHandler, notPassiveCapture);
	}
}
function removeClickOutside(clickOutsideProps) {
	const index = registeredList.indexOf(clickOutsideProps);
	if (index !== -1) {
		registeredList.splice(index, 1);
		if (registeredList.length === 0) {
			if (timer !== null) {
				clearTimeout(timer);
				timer = null;
			}
			document.removeEventListener("mousedown", globalHandler, notPassiveCapture);
			document.removeEventListener("touchstart", globalHandler, notPassiveCapture);
		}
	}
}
/**
* Registry of elements that have been detached from their original DOM
* position. Currently only useFullscreen() does this: it moves the element
* to <body> so that the fullscreen mixin can escape ancestor overflow,
* transform and stacking contexts.
*
* The key is the filler node that the mover leaves behind at the original
* position -- once the element is gone it is the only stable handle to where
* the element logically belongs. The value is the component proxy rather than
* a captured $el, so that the component's current root is read at test time
* instead of a possibly stale reference.
*/
var detachedMap = /* @__PURE__ */ new Map();
function addDetachedFullscreen(fillerNode, vm) {
	detachedMap.set(fillerNode, vm);
}
function removeDetachedFullscreen(fillerNode) {
	detachedMap.delete(fillerNode);
}
function fillerNodeFor(el) {
	for (const [fillerNode, vm] of detachedMap) if (vm.$el.contains(el) === true) return fillerNode;
}
/**
* Tells if focusedEl sits inside an element that was detached from somewhere
* within rootEl, which makes it a logical -- but no longer physical -- child.
*
* Walks the filler chain instead of testing a single hop, so that an element
* detached from inside another detached element resolves as well.
*
* Ownership of each filler is decided with childHasFocus() so that this
* agrees with the physical containment test it complements at the call sites.
*/
function focusIsInDetachedFullscreen(rootEl, focusedEl) {
	if (rootEl === void 0 || rootEl === null) return false;
	const visited = /* @__PURE__ */ new Set();
	for (let node = fillerNodeFor(focusedEl); node !== void 0 && visited.has(node) === false; node = fillerNodeFor(node)) {
		if (childHasFocus(rootEl, node) === true) return true;
		visited.add(node);
	}
	return false;
}
var vpLeft;
var vpTop;
var partsFirst = [
	"top",
	"center",
	"bottom"
];
var partsSecond = [
	"left",
	"middle",
	"right",
	"start",
	"end"
];
function validatePosition(pos) {
	const parts = pos.split(" ");
	if (parts.length !== 2) return false;
	if (!partsFirst.includes(parts[0])) {
		console.error("Anchor/Self position must start with one of top/center/bottom");
		return false;
	}
	if (!partsSecond.includes(parts[1])) {
		console.error("Anchor/Self position must end with one of left/middle/right/start/end");
		return false;
	}
	return true;
}
function validateOffset(val) {
	if (!val) return true;
	if (val.length !== 2) return false;
	if (typeof val[0] !== "number" || typeof val[1] !== "number") return false;
	return true;
}
var horizontalPos = {
	"start#ltr": "left",
	"start#rtl": "right",
	"end#ltr": "right",
	"end#rtl": "left"
};
[
	"left",
	"middle",
	"right"
].forEach((pos) => {
	horizontalPos[`${pos}#ltr`] = pos;
	horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
	const parts = pos.split(" ");
	return {
		vertical: parts[0],
		horizontal: horizontalPos[`${parts[1]}#${rtl ? "rtl" : "ltr"}`]
	};
}
function getAnchorProps(el, offset) {
	let { top, left, right, bottom, width, height } = el.getBoundingClientRect();
	if (offset !== void 0) {
		top -= offset[1];
		left -= offset[0];
		bottom += offset[1];
		right += offset[0];
		width += offset[0];
		height += offset[1];
	}
	return {
		top,
		bottom,
		height,
		left,
		right,
		width,
		middle: left + (right - left) / 2,
		center: top + (bottom - top) / 2
	};
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset) {
	let { top, left } = el.getBoundingClientRect();
	top += absoluteOffset.top;
	left += absoluteOffset.left;
	if (offset !== void 0) {
		top += offset[1];
		left += offset[0];
	}
	return {
		top,
		bottom: top + 1,
		height: 1,
		left,
		right: left + 1,
		width: 1,
		middle: left,
		center: top
	};
}
function getTargetProps(width, height) {
	return {
		top: 0,
		center: height / 2,
		bottom: height,
		left: 0,
		middle: width / 2,
		right: width
	};
}
function getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin) {
	return {
		top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
		left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
	};
}
function setPosition(cfg, retryNumber = 0) {
	if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) return;
	if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
		setTimeout(() => {
			setPosition(cfg, retryNumber + 1);
		}, 10);
		return;
	}
	const { targetEl, offset, anchorEl, anchorOrigin, selfOrigin, absoluteOffset, fit, cover, maxHeight, maxWidth } = cfg;
	if (client.is.ios && window.visualViewport !== void 0) {
		const el = document.body.style;
		const { offsetLeft: left, offsetTop: top } = window.visualViewport;
		if (left !== vpLeft) {
			el.setProperty("--q-pe-left", left + "px");
			vpLeft = left;
		}
		if (top !== vpTop) {
			el.setProperty("--q-pe-top", top + "px");
			vpTop = top;
		}
	}
	const { scrollLeft, scrollTop } = targetEl;
	const anchorProps = absoluteOffset === void 0 ? getAnchorProps(anchorEl, cover ? [0, 0] : offset) : getAbsoluteAnchorProps(anchorEl, absoluteOffset, offset);
	/**
	* We "reset" the critical CSS properties
	* so we can take an accurate measurement.
	*
	* Ensure that targetEl has a max-width & max-height
	* set in CSS and that the value does NOT exceeds 100vw/vh.
	* All users of the position-engine (currently QMenu & QTooltip)
	* have CSS for this.
	*/
	Object.assign(targetEl.style, {
		top: 0,
		left: 0,
		minWidth: null,
		minHeight: null,
		maxWidth,
		maxHeight,
		visibility: "visible"
	});
	const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
	const { elWidth, elHeight } = fit || cover ? {
		elWidth: Math.max(anchorProps.width, origElWidth),
		elHeight: cover ? Math.max(anchorProps.height, origElHeight) : origElHeight
	} : {
		elWidth: origElWidth,
		elHeight: origElHeight
	};
	let elStyle = {
		maxWidth,
		maxHeight
	};
	if (fit || cover) {
		elStyle.minWidth = anchorProps.width + "px";
		if (cover) elStyle.minHeight = anchorProps.height + "px";
	}
	Object.assign(targetEl.style, elStyle);
	const targetProps = getTargetProps(elWidth, elHeight);
	let props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
	if (absoluteOffset === void 0 || offset === void 0) applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
	else {
		const { top, left } = props;
		applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
		let hasChanged = false;
		if (props.top !== top) {
			hasChanged = true;
			const offsetY = 2 * offset[1];
			anchorProps.center = anchorProps.top -= offsetY;
			anchorProps.bottom -= offsetY + 2;
		}
		if (props.left !== left) {
			hasChanged = true;
			const offsetX = 2 * offset[0];
			anchorProps.middle = anchorProps.left -= offsetX;
			anchorProps.right -= offsetX + 2;
		}
		if (hasChanged) {
			props = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
			applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);
		}
	}
	elStyle = {
		top: props.top + "px",
		left: props.left + "px"
	};
	if (props.maxHeight !== void 0) {
		elStyle.maxHeight = props.maxHeight + "px";
		if (anchorProps.height > props.maxHeight) elStyle.minHeight = elStyle.maxHeight;
	}
	if (props.maxWidth !== void 0) {
		elStyle.maxWidth = props.maxWidth + "px";
		if (anchorProps.width > props.maxWidth) elStyle.minWidth = elStyle.maxWidth;
	}
	Object.assign(targetEl.style, elStyle);
	if (targetEl.scrollTop !== scrollTop) targetEl.scrollTop = scrollTop;
	if (targetEl.scrollLeft !== scrollLeft) targetEl.scrollLeft = scrollLeft;
}
function applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin) {
	const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
	if (props.top < 0 || props.top + currentHeight > innerHeight) if (selfOrigin.vertical === "center") {
		props.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
		props.maxHeight = Math.min(currentHeight, innerHeight);
	} else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
		const anchorY = Math.min(innerHeight, anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top);
		props.maxHeight = Math.min(currentHeight, anchorY);
		props.top = Math.max(0, anchorY - currentHeight);
	} else {
		props.top = Math.max(0, anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom);
		props.maxHeight = Math.min(currentHeight, innerHeight - props.top);
	}
	if (props.left < 0 || props.left + currentWidth > innerWidth) {
		props.maxWidth = Math.min(currentWidth, innerWidth);
		if (selfOrigin.horizontal === "middle") props.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
		else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
			const anchorX = Math.min(innerWidth, anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left);
			props.maxWidth = Math.min(currentWidth, anchorX);
			props.left = Math.max(0, anchorX - props.maxWidth);
		} else {
			props.left = Math.max(0, anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right);
			props.maxWidth = Math.min(currentWidth, innerWidth - props.left);
		}
	}
}
var QMenu_default = /*#__PURE__*/ createComponent({
	name: "QMenu",
	inheritAttrs: false,
	props: {
		...useAnchorProps,
		...useModelToggleProps,
		...useDarkProps,
		...useTransitionProps,
		persistent: Boolean,
		autoClose: Boolean,
		separateClosePopup: Boolean,
		noEscDismiss: Boolean,
		noRouteDismiss: Boolean,
		noRefocus: Boolean,
		noFocus: Boolean,
		fit: Boolean,
		cover: Boolean,
		square: Boolean,
		anchor: {
			type: String,
			validator: validatePosition
		},
		self: {
			type: String,
			validator: validatePosition
		},
		offset: {
			type: Array,
			validator: validateOffset
		},
		scrollTarget: scrollTargetProp,
		touchPosition: Boolean,
		maxHeight: {
			type: String,
			default: null
		},
		maxWidth: {
			type: String,
			default: null
		}
	},
	emits: [
		...useModelToggleEmits,
		"click",
		"escapeKey"
	],
	setup(props, { slots, emit, attrs }) {
		let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
		const vm = getCurrentInstance();
		const { proxy } = vm;
		const { $q } = proxy;
		const innerRef = ref(null);
		const showing = ref(false);
		const hideOnRouteChange = computed(() => !props.persistent && !props.noRouteDismiss);
		const isDark = useDark(props, $q);
		const { registerTick, removeTick } = useTick();
		const { registerTimeout } = useTimeout();
		const { transitionProps, transitionStyle } = useTransition(props);
		const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = useScrollTarget(props, configureScrollTarget);
		const { anchorEl, canShow } = useAnchor({ showing });
		const { hide } = useModelToggle({
			showing,
			canShow,
			handleShow,
			handleHide,
			handleRouteChange,
			hideOnRouteChange,
			processOnMount: true
		});
		const { showPortal, hidePortal, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "menu");
		const clickOutsideProps = {
			anchorEl,
			innerRef,
			onClickOutside(e) {
				if (!props.persistent && showing.value) {
					hide(e);
					if (e.type === "touchstart" || e.target.classList.contains("q-dialog__backdrop")) stopAndPrevent(e);
					return true;
				}
			}
		};
		const anchorOrigin = computed(() => parsePosition(props.anchor || (props.cover ? "center middle" : "bottom start"), $q.lang.rtl));
		const selfOrigin = computed(() => props.cover ? anchorOrigin.value : parsePosition(props.self || "top start", $q.lang.rtl));
		const menuClass = computed(() => (props.square ? " q-menu--square" : "") + (isDark.value ? " q-menu--dark q-dark" : ""));
		const onEvents = computed(() => props.autoClose ? { onClick: onAutoClose } : {});
		const handlesFocus = computed(() => showing.value && !props.persistent);
		watch(handlesFocus, (val) => {
			if (val) {
				addEscapeKey(onEscapeKey);
				addClickOutside(clickOutsideProps);
			} else {
				removeEscapeKey(onEscapeKey);
				removeClickOutside(clickOutsideProps);
			}
		});
		function focus() {
			addFocusFn(() => {
				let node = innerRef.value;
				if (node && !node.contains(document.activeElement)) {
					node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
					node.focus({ preventScroll: true });
				}
			});
		}
		function handleShow(evt) {
			refocusTarget = props.noRefocus ? null : document.activeElement;
			addFocusout(onFocusout);
			showPortal();
			configureScrollTarget();
			absoluteOffset = void 0;
			if (evt !== void 0 && (props.touchPosition || props.contextMenu)) {
				const pos = position(evt);
				if (pos.left !== void 0) {
					const { top, left } = anchorEl.value.getBoundingClientRect();
					absoluteOffset = {
						left: pos.left - left,
						top: pos.top - top
					};
				}
			}
			if (unwatchPosition === void 0) unwatchPosition = watch(() => $q.screen.width + "|" + $q.screen.height + "|" + props.self + "|" + props.anchor + "|" + $q.lang.rtl, updatePosition);
			if (!props.noFocus) document.activeElement.blur();
			registerTick(() => {
				updatePosition();
				if (!props.noFocus) focus();
			});
			registerTimeout(() => {
				if ($q.platform.is.ios) {
					avoidAutoClose = props.autoClose;
					innerRef.value.click();
				}
				updatePosition();
				showPortal(true);
				emit("show", evt);
			}, props.transitionDuration);
		}
		function handleHide(evt) {
			removeTick();
			hidePortal();
			anchorCleanup(true);
			if (refocusTarget !== null && (evt === void 0 || !evt.qClickOutside)) {
				const target = (evt?.type.indexOf("key") === 0 ? refocusTarget.closest("[tabindex]:not([tabindex^=\"-\"])") : void 0) || refocusTarget;
				refocusTarget = null;
				addFocusFn(() => {
					if (target.isConnected) target.focus({ preventScroll: true });
				});
			}
			registerTimeout(() => {
				hidePortal(true);
				emit("hide", evt);
			}, props.transitionDuration);
		}
		function handleRouteChange() {
			refocusTarget = null;
		}
		function anchorCleanup(hiding) {
			absoluteOffset = void 0;
			if (unwatchPosition !== void 0) {
				unwatchPosition();
				unwatchPosition = void 0;
			}
			if (hiding || showing.value) {
				removeFocusout(onFocusout);
				unconfigureScrollTarget();
				removeClickOutside(clickOutsideProps);
				removeEscapeKey(onEscapeKey);
			}
			if (!hiding) refocusTarget = null;
		}
		function configureScrollTarget() {
			if (anchorEl.value !== null || props.scrollTarget !== void 0) {
				localScrollTarget.value = getScrollTarget(anchorEl.value, props.scrollTarget);
				changeScrollEvent(localScrollTarget.value, updatePosition);
			}
		}
		function onAutoClose(e) {
			if (!avoidAutoClose) {
				closePortalMenus(proxy, e);
				emit("click", e);
			} else avoidAutoClose = false;
		}
		function onFocusout(evt) {
			if (handlesFocus.value && !props.noFocus && !childHasFocus(innerRef.value, evt.target) && !focusIsInDetachedFullscreen(innerRef.value, evt.target)) focus();
		}
		function onEscapeKey(evt) {
			if (!props.noEscDismiss) {
				emit("escapeKey");
				hide(evt);
			}
		}
		function updatePosition() {
			setPosition({
				targetEl: innerRef.value,
				offset: props.offset,
				anchorEl: anchorEl.value,
				anchorOrigin: anchorOrigin.value,
				selfOrigin: selfOrigin.value,
				absoluteOffset,
				fit: props.fit,
				cover: props.cover,
				maxHeight: props.maxHeight,
				maxWidth: props.maxWidth
			});
		}
		function renderPortalContent() {
			return h(Transition, transitionProps.value, () => showing.value ? h("div", {
				role: "menu",
				...attrs,
				ref: innerRef,
				tabindex: -1,
				class: ["q-menu q-position-engine scroll" + menuClass.value, attrs.class],
				style: [attrs.style, transitionStyle.value],
				...onEvents.value
			}, hSlot(slots.default)) : null);
		}
		onBeforeUnmount(() => {
			anchorCleanup();
		});
		Object.assign(proxy, {
			focus,
			updatePosition
		});
		return renderPortal;
	}
});
function createUidFn() {
	if (typeof crypto === "undefined") return () => {
		throw new Error("[Quasar uid()] Secure RNG not available. Cannot generate collision-resistant UUID.");
	};
	if (crypto.randomUUID) return () => crypto.randomUUID();
	const hex = Array.from({ length: 256 }, (_, i) => (i + 256).toString(16).slice(1));
	let buf, bufIdx;
	return () => {
		if (buf === void 0 || bufIdx + 16 > 4096) {
			bufIdx = 0;
			buf = /* @__PURE__ */ new Uint8Array(4096);
			crypto.getRandomValues(buf);
		}
		const i = bufIdx;
		bufIdx += 16;
		buf[i + 6] = buf[i + 6] & 15 | 64;
		buf[i + 8] = buf[i + 8] & 63 | 128;
		return hex[buf[i]] + hex[buf[i + 1]] + hex[buf[i + 2]] + hex[buf[i + 3]] + "-" + hex[buf[i + 4]] + hex[buf[i + 5]] + "-" + hex[buf[i + 6]] + hex[buf[i + 7]] + "-" + hex[buf[i + 8]] + hex[buf[i + 9]] + "-" + hex[buf[i + 10]] + hex[buf[i + 11]] + hex[buf[i + 12]] + hex[buf[i + 13]] + hex[buf[i + 14]] + hex[buf[i + 15]];
	};
}
var uid_default = /*#__PURE__*/ createUidFn();
function parseValue(val) {
	return val === void 0 || val === null ? null : val;
}
function getId(val, required) {
	return val === void 0 || val === null ? required ? `f_${uid_default()}` : null : val;
}
/**
* Returns an "id" which is a ref() that can be used as
* a unique identifier to apply to a DOM node attribute.
*
* On SSR/SSG, it takes care of generating the id on the client side (only) to
* avoid hydration errors.
*/
function useId({ getValue, required = true } = {}) {
	if (isRuntimeSsrPreHydration.value) {
		const id = getValue !== void 0 ? ref(parseValue(getValue())) : ref(null);
		if (required && id.value === null) onMounted(() => {
			id.value = `f_${uid_default()}`;
		});
		if (getValue !== void 0) watch(getValue, (newId) => {
			id.value = getId(newId, required);
		});
		return id;
	}
	return getValue !== void 0 ? computed(() => getId(getValue(), required)) : ref(`f_${uid_default()}`);
}
var btnPropsList = Object.keys(nonRoundBtnProps);
function passBtnProps(props) {
	return btnPropsList.reduce((acc, key) => {
		const val = props[key];
		if (val !== void 0) acc[key] = val;
		return acc;
	}, {});
}
var QBtnDropdown_default = /*#__PURE__*/ createComponent({
	name: "QBtnDropdown",
	props: {
		...nonRoundBtnProps,
		...useTransitionProps,
		modelValue: Boolean,
		split: Boolean,
		dropdownIcon: String,
		contentClass: [
			Array,
			String,
			Object
		],
		contentStyle: [
			Array,
			String,
			Object
		],
		cover: Boolean,
		persistent: Boolean,
		noEscDismiss: Boolean,
		noRouteDismiss: Boolean,
		autoClose: Boolean,
		noRefocus: Boolean,
		noFocus: Boolean,
		menuAnchor: {
			type: String,
			default: "bottom end"
		},
		menuSelf: {
			type: String,
			default: "top end"
		},
		menuOffset: Array,
		disableMainBtn: Boolean,
		disableDropdown: Boolean,
		noIconAnimation: Boolean,
		toggleAriaLabel: String
	},
	emits: [
		"update:modelValue",
		"click",
		"beforeShow",
		"show",
		"beforeHide",
		"hide"
	],
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const showing = ref(props.modelValue);
		const menuRef = ref(null);
		const targetUid = useId();
		const ariaAttrs = computed(() => {
			const acc = {
				"aria-expanded": showing.value ? "true" : "false",
				"aria-haspopup": "true",
				"aria-controls": targetUid.value,
				"aria-label": props.toggleAriaLabel || proxy.$q.lang.label[showing.value ? "collapse" : "expand"](props.label)
			};
			if (props.disable || !props.split && props.disableMainBtn || props.disableDropdown) acc["aria-disabled"] = "true";
			return acc;
		});
		const iconClass = computed(() => "q-btn-dropdown__arrow" + (showing.value && !props.noIconAnimation ? " rotate-180" : "") + (props.split ? "" : " q-btn-dropdown__arrow-container"));
		const btnDesignAttr = computed(() => getBtnDesignAttr(props));
		const btnProps = computed(() => passBtnProps(props));
		watch(() => props.modelValue, (val) => {
			menuRef.value?.[val ? "show" : "hide"]();
		});
		watch(() => props.split, hide);
		function onBeforeShow(e) {
			showing.value = true;
			emit("beforeShow", e);
		}
		function onShow(e) {
			emit("show", e);
			emit("update:modelValue", true);
		}
		function onBeforeHide(e) {
			showing.value = false;
			emit("beforeHide", e);
		}
		function onHide(e) {
			emit("hide", e);
			emit("update:modelValue", false);
		}
		function onClick(e) {
			emit("click", e);
		}
		function onClickHide(e) {
			stop(e);
			hide();
			emit("click", e);
		}
		function toggle(evt) {
			menuRef.value?.toggle(evt);
		}
		function show(evt) {
			menuRef.value?.show(evt);
		}
		function hide(evt) {
			menuRef.value?.hide(evt);
		}
		Object.assign(proxy, {
			show,
			hide,
			toggle
		});
		onMounted(() => {
			if (props.modelValue) show();
		});
		return () => {
			const Arrow = [h(QIcon_default, {
				class: iconClass.value,
				name: props.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
			})];
			if (!props.disableDropdown) Arrow.push(h(QMenu_default, {
				ref: menuRef,
				id: targetUid.value,
				class: props.contentClass,
				style: props.contentStyle,
				cover: props.cover,
				fit: true,
				persistent: props.persistent,
				noEscDismiss: props.noEscDismiss,
				noRouteDismiss: props.noRouteDismiss,
				autoClose: props.autoClose,
				noFocus: props.noFocus,
				noRefocus: props.noRefocus,
				anchor: props.menuAnchor,
				self: props.menuSelf,
				offset: props.menuOffset,
				separateClosePopup: true,
				transitionShow: props.transitionShow,
				transitionHide: props.transitionHide,
				transitionDuration: props.transitionDuration,
				onBeforeShow,
				onShow,
				onBeforeHide,
				onHide
			}, slots.default));
			if (!props.split) return h(QBtn_default, {
				class: "q-btn-dropdown q-btn-dropdown--simple",
				...btnProps.value,
				...ariaAttrs.value,
				disable: props.disable || props.disableMainBtn,
				noWrap: true,
				round: false,
				onClick
			}, {
				default: () => hSlot(slots.label, []).concat(Arrow),
				loading: slots.loading
			});
			return h(QBtnGroup_default, {
				class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
				rounded: props.rounded,
				square: props.square,
				...btnDesignAttr.value,
				glossy: props.glossy,
				stretch: props.stretch
			}, () => [h(QBtn_default, {
				class: "q-btn-dropdown--current",
				...btnProps.value,
				disable: props.disable || props.disableMainBtn,
				noWrap: true,
				round: false,
				onClick: onClickHide
			}, {
				default: slots.label,
				loading: slots.loading
			}), h(QBtn_default, {
				class: "q-btn-dropdown__arrow-container q-anchor--skip",
				...ariaAttrs.value,
				...btnDesignAttr.value,
				disable: props.disable || props.disableDropdown,
				rounded: props.rounded,
				color: props.color,
				textColor: props.textColor,
				dense: props.dense,
				size: props.size,
				padding: props.padding,
				ripple: props.ripple
			}, () => Arrow)]);
		};
	}
});
var useFormProps = { name: String };
function useFormAttrs(props) {
	return computed(() => ({
		type: "hidden",
		name: props.name,
		value: props.modelValue
	}));
}
function useFormInject(formAttrs = {}) {
	return (child, action, className) => {
		child[action](h("input", {
			class: "hidden" + (className || ""),
			...formAttrs.value
		}));
	};
}
function useFormInputNameAttr(props) {
	return computed(() => props.name || props.for);
}
({ ...useFormProps });
var QCard_default = /*#__PURE__*/ createComponent({
	name: "QCard",
	props: {
		...useDarkProps,
		tag: {
			type: String,
			default: "div"
		},
		square: Boolean,
		flat: Boolean,
		bordered: Boolean
	},
	setup(props, { slots }) {
		const { proxy: { $q } } = getCurrentInstance();
		const isDark = useDark(props, $q);
		const classes = computed(() => "q-card" + (isDark.value ? " q-card--dark q-dark" : "") + (props.bordered ? " q-card--bordered" : "") + (props.square ? " q-card--square no-border-radius" : "") + (props.flat ? " q-card--flat no-shadow" : ""));
		return () => h(props.tag, { class: classes.value }, hSlot(slots.default));
	}
});
var QCardSection_default = /*#__PURE__*/ createComponent({
	name: "QCardSection",
	props: {
		tag: {
			type: String,
			default: "div"
		},
		horizontal: Boolean
	},
	setup(props, { slots }) {
		const classes = computed(() => `q-card__section q-card__section--${props.horizontal ? "horiz row no-wrap" : "vert"}`);
		return () => h(props.tag, { class: classes.value }, hSlot(slots.default));
	}
});
var QCardActions_default = /*#__PURE__*/ createComponent({
	name: "QCardActions",
	props: {
		...useAlignProps,
		vertical: Boolean
	},
	setup(props, { slots }) {
		const alignClass = useAlign(props);
		const classes = computed(() => `q-card__actions ${alignClass.value} q-card__actions--${props.vertical ? "vert column" : "horiz row"}`);
		return () => h("div", { class: classes.value }, hSlot(slots.default));
	}
});
var modifiersAll = {
	left: true,
	right: true,
	up: true,
	down: true,
	horizontal: true,
	vertical: true
};
var directionList = Object.keys(modifiersAll);
modifiersAll.all = true;
function getModifierDirections(mod) {
	const dir = {};
	for (const direction of directionList) if (mod[direction]) dir[direction] = true;
	if (Object.keys(dir).length === 0) return modifiersAll;
	if (dir.horizontal) dir.left = dir.right = true;
	else if (dir.left && dir.right) dir.horizontal = true;
	if (dir.vertical) dir.up = dir.down = true;
	else if (dir.up && dir.down) dir.vertical = true;
	if (dir.horizontal && dir.vertical) dir.all = true;
	return dir;
}
var avoidNodeNamesList = ["INPUT", "TEXTAREA"];
function shouldStart(evt, ctx) {
	return ctx.event === void 0 && evt.target !== void 0 && !evt.target.draggable && typeof ctx.handler === "function" && !avoidNodeNamesList.includes(evt.target.nodeName.toUpperCase()) && (evt.qClonedBy === void 0 || !evt.qClonedBy.includes(ctx.uid));
}
function parseArg(arg) {
	const data = [
		.06,
		6,
		50
	];
	if (typeof arg === "string" && arg.length !== 0) arg.split(":").forEach((val, index) => {
		const v = Number.parseFloat(val);
		if (v) data[index] = v;
	});
	return data;
}
function removeBodyChildrenNoPointerEvents() {
	document.body.classList.remove("no-pointer-events--children");
}
var TouchSwipe_default = /*#__PURE__*/ createDirective({
	name: "touch-swipe",
	beforeMount(el, { value, arg, modifiers }) {
		if (!modifiers.mouse && !client.has.touch) return;
		const mouseCapture = modifiers.mouseCapture || modifiers.mousecapture ? "Capture" : "";
		const ctx = {
			handler: value,
			sensitivity: parseArg(arg),
			direction: getModifierDirections(modifiers),
			noop,
			mouseStart(evt) {
				if (shouldStart(evt, ctx) && leftClick(evt)) {
					addEvt(ctx, "temp", [[
						document,
						"mousemove",
						"move",
						`notPassive${mouseCapture}`
					], [
						document,
						"mouseup",
						"end",
						"notPassiveCapture"
					]]);
					ctx.start(evt, true);
				}
			},
			touchStart(evt) {
				if (shouldStart(evt, ctx)) {
					const target = evt.target;
					addEvt(ctx, "temp", [
						[
							target,
							"touchmove",
							"move",
							"notPassiveCapture"
						],
						[
							target,
							"touchcancel",
							"end",
							"notPassiveCapture"
						],
						[
							target,
							"touchend",
							"end",
							"notPassiveCapture"
						]
					]);
					ctx.start(evt);
				}
			},
			start(evt, mouseEvent) {
				if (client.is.firefox) preventDraggable(el, true);
				const pos = position(evt);
				ctx.event = {
					x: pos.left,
					y: pos.top,
					time: Date.now(),
					mouse: mouseEvent === true,
					dir: false
				};
			},
			move(evt) {
				if (ctx.event === void 0) return;
				if (ctx.event.dir !== false) {
					stopAndPrevent(evt);
					return;
				}
				const time = Date.now() - ctx.event.time;
				if (time === 0) return;
				const pos = position(evt), distX = pos.left - ctx.event.x, absX = Math.abs(distX), distY = pos.top - ctx.event.y, absY = Math.abs(distY);
				if (!ctx.event.mouse) {
					if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
						ctx.end(evt);
						return;
					}
				} else if (window.getSelection().toString() !== "") {
					ctx.end(evt);
					return;
				} else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) return;
				const velX = absX / time, velY = absY / time;
				if (ctx.direction.vertical && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = distY < 0 ? "up" : "down";
				if (ctx.direction.horizontal && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = distX < 0 ? "left" : "right";
				if (ctx.direction.up && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = "up";
				if (ctx.direction.down && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) ctx.event.dir = "down";
				if (ctx.direction.left && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = "left";
				if (ctx.direction.right && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) ctx.event.dir = "right";
				if (ctx.event.dir !== false) {
					stopAndPrevent(evt);
					if (ctx.event.mouse) {
						document.body.classList.add("no-pointer-events--children", "non-selectable");
						clearSelection();
						ctx.styleCleanup = () => {
							ctx.styleCleanup = void 0;
							document.body.classList.remove("non-selectable");
							removeBodyChildrenNoPointerEvents();
						};
					}
					ctx.handler({
						evt,
						touch: ctx.event.mouse !== true,
						mouse: ctx.event.mouse,
						direction: ctx.event.dir,
						duration: time,
						distance: {
							x: absX,
							y: absY
						}
					});
				} else ctx.end(evt);
			},
			end(evt) {
				if (ctx.event === void 0) return;
				cleanEvt(ctx, "temp");
				if (client.is.firefox) preventDraggable(el, false);
				ctx.styleCleanup?.();
				if (evt !== void 0 && ctx.event.dir !== false) stopAndPrevent(evt);
				ctx.event = void 0;
			}
		};
		el.__qtouchswipe = ctx;
		if (modifiers.mouse) addEvt(ctx, "main", [[
			el,
			"mousedown",
			"mouseStart",
			`passive${modifiers.mouseCapture || modifiers.mousecapture ? "Capture" : ""}`
		]]);
		if (client.has.touch) addEvt(ctx, "main", [[
			el,
			"touchstart",
			"touchStart",
			`passive${modifiers.capture ? "Capture" : ""}`
		], [
			el,
			"touchmove",
			"noop",
			"notPassiveCapture"
		]]);
	},
	updated(el, bindings) {
		const ctx = el.__qtouchswipe;
		if (ctx !== void 0) {
			if (bindings.oldValue !== bindings.value) {
				if (typeof bindings.value !== "function") ctx.end();
				ctx.handler = bindings.value;
			}
			ctx.direction = getModifierDirections(bindings.modifiers);
		}
	},
	beforeUnmount(el) {
		const ctx = el.__qtouchswipe;
		if (ctx !== void 0) {
			cleanEvt(ctx, "main");
			cleanEvt(ctx, "temp");
			if (client.is.firefox) preventDraggable(el, false);
			ctx.styleCleanup?.();
			delete el.__qtouchswipe;
		}
	}
});
function useRenderCache() {
	let cache = Object.create(null);
	return {
		getCache: (key, defaultValue) => Object.hasOwn(cache, key) ? cache[key] : cache[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue,
		setCache(key, obj) {
			cache[key] = obj;
		},
		hasCache(key) {
			return Object.hasOwn(cache, key);
		},
		clearCache(key) {
			if (key !== void 0) delete cache[key];
			else cache = Object.create(null);
		}
	};
}
var usePanelChildProps = {
	name: { required: true },
	disable: Boolean
};
var PanelWrapper$1 = { setup(_, { slots }) {
	return () => h("div", {
		class: "q-panel scroll",
		role: "tabpanel"
	}, hSlot(slots.default));
} };
var usePanelProps = {
	modelValue: { required: true },
	animated: Boolean,
	infinite: Boolean,
	swipeable: Boolean,
	vertical: Boolean,
	transitionPrev: String,
	transitionNext: String,
	transitionDuration: {
		type: [String, Number],
		default: 300
	},
	keepAlive: Boolean,
	keepAliveInclude: [
		String,
		Array,
		RegExp
	],
	keepAliveExclude: [
		String,
		Array,
		RegExp
	],
	keepAliveMax: Number
};
var usePanelEmits = [
	"update:modelValue",
	"beforeTransition",
	"transition"
];
function isValidPanelName(name) {
	return name !== void 0 && name !== null && name !== "";
}
function usePanel() {
	const { props, emit, proxy } = getCurrentInstance();
	const { getCache } = useRenderCache();
	const { registerTimeout } = useTimeout();
	let panels, forcedPanelTransition;
	const panelTransition = ref(null);
	const panelIndex = { value: null };
	function onSwipe(evt) {
		const dir = props.vertical ? "up" : "left";
		goToPanelByOffset((!props.vertical && proxy.$q.lang.rtl ? -1 : 1) * (evt.direction === dir ? 1 : -1));
	}
	const panelDirectives = computed(() => [[
		TouchSwipe_default,
		onSwipe,
		void 0,
		{
			horizontal: !props.vertical,
			vertical: props.vertical,
			mouse: true
		}
	]]);
	const transitionPrev = computed(() => props.transitionPrev || `slide-${props.vertical ? "down" : proxy.$q.lang.rtl ? "left" : "right"}`);
	const transitionNext = computed(() => props.transitionNext || `slide-${props.vertical ? "up" : proxy.$q.lang.rtl ? "right" : "left"}`);
	const transitionStyle = computed(() => `--q-transition-duration: ${props.transitionDuration}ms`);
	const contentKey = computed(() => typeof props.modelValue === "string" || typeof props.modelValue === "number" ? props.modelValue : String(props.modelValue));
	const keepAliveProps = computed(() => ({
		include: props.keepAliveInclude,
		exclude: props.keepAliveExclude,
		max: props.keepAliveMax
	}));
	const needsUniqueKeepAliveWrapper = computed(() => props.keepAliveInclude !== void 0 || props.keepAliveExclude !== void 0);
	watch(() => props.modelValue, (newVal, oldVal) => {
		const index = isValidPanelName(newVal) ? getPanelIndex(newVal) : -1;
		if (!forcedPanelTransition) updatePanelTransition(index === -1 ? 0 : index < getPanelIndex(oldVal) ? -1 : 1);
		if (panelIndex.value !== index) {
			panelIndex.value = index;
			emit("beforeTransition", newVal, oldVal);
			registerTimeout(() => {
				emit("transition", newVal, oldVal);
			}, props.transitionDuration);
		}
	});
	function nextPanel() {
		goToPanelByOffset(1);
	}
	function previousPanel() {
		goToPanelByOffset(-1);
	}
	function goToPanel(name) {
		emit("update:modelValue", name);
	}
	function getPanelIndex(name) {
		return panels.findIndex((panel) => panel.props.name === name && panel.props.disable !== "" && panel.props.disable !== true);
	}
	function getEnabledPanels() {
		return panels.filter((panel) => panel.props.disable !== "" && panel.props.disable !== true);
	}
	function updatePanelTransition(direction) {
		const val = direction !== 0 && props.animated && panelIndex.value !== -1 ? "q-transition--" + (direction === -1 ? transitionPrev.value : transitionNext.value) : null;
		if (panelTransition.value !== val) panelTransition.value = val;
	}
	function goToPanelByOffset(direction, startIndex = panelIndex.value) {
		let index = startIndex + direction;
		while (index >= 0 && index < panels.length) {
			const opt = panels[index];
			if (opt !== void 0 && opt.props.disable !== "" && opt.props.disable !== true) {
				updatePanelTransition(direction);
				forcedPanelTransition = true;
				emit("update:modelValue", opt.props.name);
				setTimeout(() => {
					forcedPanelTransition = false;
				}, 0);
				return;
			}
			index += direction;
		}
		if (props.infinite && panels.length !== 0 && startIndex !== -1 && startIndex !== panels.length) goToPanelByOffset(direction, direction === -1 ? panels.length : -1);
	}
	function updatePanelIndex() {
		const index = getPanelIndex(props.modelValue);
		if (panelIndex.value !== index) panelIndex.value = index;
		return true;
	}
	function getPanelContentChild() {
		const panel = isValidPanelName(props.modelValue) && updatePanelIndex() && panels[panelIndex.value];
		return props.keepAlive ? [h(KeepAlive, keepAliveProps.value, [h(needsUniqueKeepAliveWrapper.value ? getCache(contentKey.value, () => ({
			...PanelWrapper$1,
			name: contentKey.value
		})) : PanelWrapper$1, {
			key: contentKey.value,
			style: transitionStyle.value
		}, () => panel)])] : [h("div", {
			class: "q-panel scroll",
			style: transitionStyle.value,
			key: contentKey.value,
			role: "tabpanel"
		}, [panel])];
	}
	function getPanelContent() {
		if (panels.length === 0) return;
		return props.animated ? [h(Transition, { name: panelTransition.value }, getPanelContentChild)] : getPanelContentChild();
	}
	function updatePanelsList(slots) {
		panels = getNormalizedVNodes(hSlot(slots.default, [])).filter((panel) => panel.props !== null && panel.props.slot === void 0 && isValidPanelName(panel.props.name));
		return panels.length;
	}
	function getPanels() {
		return panels;
	}
	Object.assign(proxy, {
		next: nextPanel,
		previous: previousPanel,
		goTo: goToPanel
	});
	return {
		panelIndex,
		panelDirectives,
		updatePanelsList,
		updatePanelIndex,
		getPanelContent,
		getEnabledPanels,
		getPanels,
		isValidPanelName,
		keepAliveProps,
		needsUniqueKeepAliveWrapper,
		goToPanelByOffset,
		goToPanel,
		nextPanel,
		previousPanel
	};
}
function useAnimationFrame() {
	let frameId = null;
	const vm = getCurrentInstance();
	function removeAnimationFrame() {
		if (frameId !== null) {
			cancelAnimationFrame(frameId);
			frameId = null;
		}
	}
	onDeactivated(removeAnimationFrame);
	onBeforeUnmount(removeAnimationFrame);
	return {
		removeAnimationFrame,
		registerAnimationFrame(fn) {
			removeAnimationFrame();
			if (!vmIsDestroyed(vm)) frameId = requestAnimationFrame(() => {
				frameId = null;
				fn();
			});
		}
	};
}
var counter = 0;
var restoreState = null;
var useFullscreenProps = {
	fullscreen: Boolean,
	noRouteFullscreenExit: Boolean
};
var useFullscreenEmits = ["update:fullscreen", "fullscreen"];
function useFullscreen() {
	const vm = getCurrentInstance();
	const { props, emit, proxy } = vm;
	let historyEntry, fullscreenFillerNode;
	const inFullscreen = ref(false);
	const { registerTick, removeTick } = useTick();
	const { registerAnimationFrame, removeAnimationFrame } = useAnimationFrame();
	if (vmHasRouter(vm)) watch(() => proxy.$route.fullPath, () => {
		if (!props.noRouteFullscreenExit) exitFullscreen();
	});
	watch(() => props.fullscreen, (v) => {
		if (inFullscreen.value !== v) toggleFullscreen();
	});
	watch(inFullscreen, (v) => {
		emit("update:fullscreen", v);
		emit("fullscreen", v);
	});
	function toggleFullscreen() {
		if (inFullscreen.value) exitFullscreen();
		else setFullscreen();
	}
	function setFullscreen() {
		if (vmIsDestroyed(vm) || inFullscreen.value) return;
		removeAnimationFrame();
		removeTick();
		if (counter === 0) restoreState = {
			left: getHorizontalScrollPosition(window),
			top: getVerticalScrollPosition(window),
			width: window.innerWidth,
			height: window.innerHeight
		};
		inFullscreen.value = true;
		proxy.$el.replaceWith(fullscreenFillerNode);
		document.body.append(proxy.$el);
		addDetachedFullscreen(fullscreenFillerNode, proxy);
		counter++;
		if (counter === 1) document.body.classList.add("q-body--fullscreen-mixin");
		historyEntry = { handler: exitFullscreen };
		History_default.add(historyEntry);
	}
	function exitFullscreenImpl(shouldRestoreElement) {
		if (!inFullscreen.value) return;
		if (historyEntry !== void 0) {
			History_default.remove(historyEntry);
			historyEntry = void 0;
		}
		removeDetachedFullscreen(fullscreenFillerNode);
		if (shouldRestoreElement === true) fullscreenFillerNode.replaceWith(proxy.$el);
		else fullscreenFillerNode.remove();
		inFullscreen.value = false;
		counter = Math.max(0, counter - 1);
		if (counter !== 0) return;
		document.body.classList.remove("q-body--fullscreen-mixin");
		if (restoreState === null) return;
		const { left, top, width, height } = restoreState;
		restoreState = null;
		if (vmIsDestroyed(vm)) return;
		registerTick(() => {
			if (counter !== 0) return;
			registerAnimationFrame(() => {
				if (counter !== 0) return;
				if (window.innerWidth !== width || window.innerHeight !== height)
 /**
				* If user has resized the window while in fullscreen mode,
				* we cannot restore the scroll position because it will be wrong.
				* So we just scroll the element into view instead,
				* which is the best we can do.
				*/
				proxy.$el.scrollIntoView();
				else window.scrollTo(left, top);
			});
		});
	}
	function exitFullscreen() {
		exitFullscreenImpl(true);
	}
	onBeforeMount(() => {
		fullscreenFillerNode = document.createElement("span");
	});
	onMounted(() => {
		if (props.fullscreen) setFullscreen();
	});
	onDeactivated(() => {
		exitFullscreenImpl(proxy.$el.isConnected);
	});
	onActivated(() => {
		if (props.fullscreen) setFullscreen();
	});
	onBeforeUnmount(exitFullscreen);
	Object.assign(proxy, {
		toggleFullscreen,
		setFullscreen,
		exitFullscreen
	});
	return {
		inFullscreen,
		toggleFullscreen
	};
}
({
	...useDarkProps,
	...usePanelProps,
	...useFullscreenProps
}), [...useFullscreenEmits, ...usePanelEmits];
({ ...usePanelChildProps });
function useRefocusTarget(props, rootRef) {
	const refocusRef = ref(null);
	const refocusTargetEl = computed(() => {
		if (props.disable) return null;
		return h("span", {
			ref: refocusRef,
			class: "no-outline",
			tabindex: -1
		});
	});
	function refocusTarget(e) {
		const root = rootRef.value;
		if (e?.qAvoidFocus === true) return;
		if (e?.type.indexOf("key") === 0) {
			if (document.activeElement !== root && root?.contains(document.activeElement) === true) root.focus({ preventScroll: true });
		} else if (refocusRef.value !== null && (e === void 0 || root?.contains(e.target) === true)) refocusRef.value.focus({ preventScroll: true });
	}
	return {
		refocusTargetEl,
		refocusTarget
	};
}
var option_sizes_default = {
	xs: 30,
	sm: 35,
	md: 40,
	lg: 50,
	xl: 60
};
var useCheckboxProps = {
	...useDarkProps,
	...useSizeProps,
	...useFormProps,
	modelValue: {
		required: true,
		default: null
	},
	val: {},
	trueValue: { default: true },
	falseValue: { default: false },
	indeterminateValue: { default: null },
	checkedIcon: String,
	uncheckedIcon: String,
	indeterminateIcon: String,
	toggleOrder: {
		type: String,
		validator: (v) => v === "tf" || v === "ft"
	},
	toggleIndeterminate: Boolean,
	label: String,
	leftLabel: Boolean,
	color: String,
	keepColor: Boolean,
	dense: Boolean,
	disable: Boolean,
	tabindex: [String, Number]
};
var useCheckboxEmits = ["update:modelValue"];
function onKeydown$2(e) {
	if (e.keyCode === 13 || e.keyCode === 32) stopAndPrevent(e);
}
function useCheckbox(type, getInner) {
	const { props, slots, emit, proxy } = getCurrentInstance();
	const { $q } = proxy;
	const isDark = useDark(props, $q);
	const rootRef = ref(null);
	const { refocusTargetEl, refocusTarget } = useRefocusTarget(props, rootRef);
	const sizeStyle = useSize(props, option_sizes_default);
	const modelIsArray = computed(() => props.val !== void 0 && Array.isArray(props.modelValue));
	const index = computed(() => {
		const val = toRaw(props.val);
		return modelIsArray.value ? props.modelValue.findIndex((opt) => toRaw(opt) === val) : -1;
	});
	const isTrue = computed(() => modelIsArray.value ? index.value !== -1 : toRaw(props.modelValue) === toRaw(props.trueValue));
	const isFalse = computed(() => modelIsArray.value ? index.value === -1 : toRaw(props.modelValue) === toRaw(props.falseValue));
	const isIndeterminate = computed(() => !isTrue.value && !isFalse.value);
	const tabindex = computed(() => props.disable ? -1 : props.tabindex || 0);
	const classes = computed(() => `q-${type} cursor-pointer no-outline row inline no-wrap items-center` + (props.disable ? " disabled" : "") + (isDark.value ? ` q-${type}--dark` : "") + (props.dense ? ` q-${type}--dense` : "") + (props.leftLabel ? " reverse" : ""));
	const innerClass = computed(() => {
		return `q-${type}__inner relative-position non-selectable q-${type}__inner--${isTrue.value ? "truthy" : isFalse.value ? "falsy" : "indet"}${props.color !== void 0 && (props.keepColor || (type === "toggle" ? isTrue.value : !isFalse.value)) ? ` text-${props.color}` : ""}`;
	});
	const injectFormInput = useFormInject(computed(() => {
		const prop = { type: "checkbox" };
		if (props.name !== void 0) Object.assign(prop, {
			".checked": isTrue.value,
			"^checked": isTrue.value ? "checked" : void 0,
			name: props.name,
			value: modelIsArray.value ? props.val : props.trueValue
		});
		return prop;
	}));
	const attributes = computed(() => {
		const attrs = {
			tabindex: tabindex.value,
			role: type === "toggle" ? "switch" : "checkbox",
			"aria-label": props.label,
			"aria-checked": isIndeterminate.value ? "mixed" : isTrue.value ? "true" : "false"
		};
		if (props.disable) attrs["aria-disabled"] = "true";
		return attrs;
	});
	function onClick(e) {
		if (e !== void 0) {
			stopAndPrevent(e);
			refocusTarget(e);
		}
		if (!props.disable) emit("update:modelValue", getNextValue(), e);
	}
	function getNextValue() {
		if (modelIsArray.value) {
			if (isTrue.value) {
				const val = [...props.modelValue];
				val.splice(index.value, 1);
				return val;
			}
			return [...props.modelValue, props.val];
		}
		if (isTrue.value) {
			if (props.toggleOrder !== "ft" || !props.toggleIndeterminate) return props.falseValue;
		} else if (isFalse.value) {
			if (props.toggleOrder === "ft" || !props.toggleIndeterminate) return props.trueValue;
		} else return props.toggleOrder !== "ft" ? props.trueValue : props.falseValue;
		return props.indeterminateValue;
	}
	function onKeyup(e) {
		if (e.keyCode === 13 || e.keyCode === 32) onClick(e);
	}
	const getInnerContent = getInner(isTrue, isIndeterminate);
	Object.assign(proxy, { toggle: onClick });
	return () => {
		const inner = getInnerContent();
		if (!props.disable) injectFormInput(inner, "unshift", ` q-${type}__native absolute q-ma-none q-pa-none`);
		const child = [h("div", {
			class: innerClass.value,
			style: sizeStyle.value,
			"aria-hidden": "true"
		}, inner)];
		if (refocusTargetEl.value !== null) child.push(refocusTargetEl.value);
		const label = props.label !== void 0 ? hMergeSlot(slots.default, [props.label]) : hSlot(slots.default);
		if (label !== void 0) child.push(h("div", { class: `q-${type}__label q-anchor--skip` }, label));
		return h("div", {
			ref: rootRef,
			class: classes.value,
			...attributes.value,
			onClick,
			onKeydown: onKeydown$2,
			onKeyup
		}, child);
	};
}
var createBgNode = () => h("div", {
	key: "svg",
	class: "q-checkbox__bg absolute"
}, [h("svg", {
	class: "q-checkbox__svg fit absolute-full",
	viewBox: "0 0 24 24"
}, [h("path", {
	class: "q-checkbox__truthy",
	fill: "none",
	d: "M1.73,12.91 8.1,19.28 22.79,4.59"
}), h("path", {
	class: "q-checkbox__indet",
	d: "M4,14H20V10H4"
})])]);
var QCheckbox_default = /*#__PURE__*/ createComponent({
	name: "QCheckbox",
	props: useCheckboxProps,
	emits: useCheckboxEmits,
	setup(props) {
		const bgNode = createBgNode();
		function getInner(isTrue, isIndeterminate) {
			const icon = computed(() => (isTrue.value ? props.checkedIcon : isIndeterminate.value ? props.indeterminateIcon : props.uncheckedIcon) || null);
			return () => icon.value !== null ? [h("div", {
				key: "icon",
				class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
			}, [h(QIcon_default, {
				class: "q-checkbox__icon",
				name: icon.value
			})])] : [bgNode];
		}
		return useCheckbox("checkbox", getInner);
	}
});
function preventSpace$3(e) {
	if (e.keyCode === 32) stopAndPrevent(e);
}
var defaultSizes$1 = {
	xs: 8,
	sm: 10,
	md: 14,
	lg: 20,
	xl: 24
};
var QChip_default = /*#__PURE__*/ createComponent({
	name: "QChip",
	props: {
		...useDarkProps,
		...useSizeProps,
		dense: Boolean,
		icon: String,
		iconRight: String,
		iconRemove: String,
		iconSelected: String,
		label: [String, Number],
		color: String,
		textColor: String,
		modelValue: {
			type: Boolean,
			default: true
		},
		selected: {
			type: Boolean,
			default: null
		},
		square: Boolean,
		outline: Boolean,
		clickable: Boolean,
		removable: Boolean,
		removeAriaLabel: String,
		tabindex: [String, Number],
		disable: Boolean,
		ripple: {
			type: [Boolean, Object],
			default: true
		}
	},
	emits: [
		"update:modelValue",
		"update:selected",
		"remove",
		"click"
	],
	setup(props, { slots, emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const isDark = useDark(props, $q);
		const sizeStyle = useSize(props, defaultSizes$1);
		const hasLeftIcon = computed(() => props.selected || props.icon !== void 0);
		const leftIcon = computed(() => props.selected ? props.iconSelected || $q.iconSet.chip.selected : props.icon);
		const removeIcon = computed(() => props.iconRemove || $q.iconSet.chip.remove);
		const isClickable = computed(() => !props.disable && (props.clickable || props.selected !== null));
		const classes = computed(() => {
			const text = props.outline ? props.color || props.textColor : props.textColor;
			return "q-chip row inline no-wrap items-center" + (!props.outline && props.color !== void 0 ? ` bg-${props.color}` : "") + (text ? ` text-${text} q-chip--colored` : "") + (props.disable ? " disabled" : "") + (props.dense ? " q-chip--dense" : "") + (props.outline ? " q-chip--outline" : "") + (props.selected ? " q-chip--selected" : "") + (isClickable.value ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props.square ? " q-chip--square" : "") + (isDark.value ? " q-chip--dark q-dark" : "");
		});
		const attributes = computed(() => {
			const chip = props.disable ? {
				tabindex: -1,
				"aria-disabled": "true"
			} : {
				tabindex: props.tabindex || 0,
				role: "button",
				"aria-pressed": props.selected ? "true" : "false"
			};
			return {
				chip,
				remove: {
					...chip,
					role: "button",
					"aria-hidden": "false",
					"aria-label": props.removeAriaLabel || $q.lang.label.remove
				}
			};
		});
		function onKeyup(e) {
			if ([13, 32].includes(e.keyCode)) {
				onClick(e);
				stopAndPrevent(e);
			}
		}
		function onClick(e) {
			if (!props.disable) {
				emit("update:selected", !props.selected);
				emit("click", e);
			}
		}
		function onRemove(e) {
			if (e.keyCode === void 0 || [13, 32].includes(e.keyCode)) {
				stopAndPrevent(e);
				if (!props.disable) {
					emit("update:modelValue", false);
					emit("remove");
				}
			}
		}
		function getContent() {
			const child = [];
			if (isClickable.value) child.push(h("div", { class: "q-focus-helper" }));
			if (hasLeftIcon.value) child.push(h(QIcon_default, {
				class: "q-chip__icon q-chip__icon--left",
				name: leftIcon.value
			}));
			const label = props.label !== void 0 ? [h("div", { class: "ellipsis" }, [props.label])] : void 0;
			child.push(h("div", { class: "q-chip__content col row no-wrap items-center q-anchor--skip" }, hMergeSlotSafely(slots.default, label)));
			if (props.iconRight) child.push(h(QIcon_default, {
				class: "q-chip__icon q-chip__icon--right",
				name: props.iconRight
			}));
			if (props.removable) child.push(h(QIcon_default, {
				class: "q-chip__icon q-chip__icon--remove cursor-pointer",
				name: removeIcon.value,
				...attributes.value.remove,
				onClick: onRemove,
				onKeydown: preventSpace$3,
				onKeyup: onRemove
			}));
			return child;
		}
		return () => {
			if (!props.modelValue) return;
			const data = {
				class: classes.value,
				style: sizeStyle.value
			};
			if (isClickable.value) Object.assign(data, attributes.value.chip, {
				onClick,
				onKeydown: preventSpace$3,
				onKeyup
			});
			return hDir("div", data, getContent(), "ripple", props.ripple !== false && !props.disable, () => [[Ripple_default, props.ripple]]);
		};
	}
});
var useCircularCommonProps = {
	...useSizeProps,
	min: {
		type: Number,
		default: 0
	},
	max: {
		type: Number,
		default: 100
	},
	color: String,
	centerColor: String,
	trackColor: String,
	fontSize: String,
	rounded: Boolean,
	thickness: {
		type: Number,
		default: .2,
		validator: (v) => v >= 0 && v <= 1
	},
	angle: {
		type: Number,
		default: 0
	},
	showValue: Boolean,
	reverse: Boolean,
	instantFeedback: Boolean
};
var radius = 50;
var diameter = 100;
var circumference = diameter * Math.PI;
var strokeDashArray = Math.round(circumference * 1e3) / 1e3;
var QCircularProgress_default = /*#__PURE__*/ createComponent({
	name: "QCircularProgress",
	props: {
		...useCircularCommonProps,
		value: {
			type: Number,
			default: 0
		},
		animationSpeed: {
			type: [String, Number],
			default: 600
		},
		indeterminate: Boolean
	},
	setup(props, { slots }) {
		const { proxy: { $q } } = getCurrentInstance();
		const sizeStyle = useSize(props);
		const svgStyle = computed(() => {
			const angle = ($q.lang.rtl ? -1 : 1) * props.angle;
			return { transform: props.reverse !== ($q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle}deg)` : `rotate3d(0, 0, 1, ${angle - 90}deg)` };
		});
		const circleStyle = computed(() => !props.instantFeedback && !props.indeterminate ? { transition: `stroke-dashoffset ${props.animationSpeed}ms ease 0s, stroke ${props.animationSpeed}ms ease` } : "");
		const viewBox = computed(() => diameter / (1 - props.thickness / 2));
		const viewBoxAttr = computed(() => `${viewBox.value / 2} ${viewBox.value / 2} ${viewBox.value} ${viewBox.value}`);
		const normalized = computed(() => between(props.value, props.min, props.max));
		const range = computed(() => props.max - props.min);
		const strokeWidth = computed(() => props.thickness / 2 * viewBox.value);
		const strokeDashOffset = computed(() => {
			const dashRatio = (props.max - normalized.value) / range.value;
			const dashGap = props.rounded && normalized.value < props.max && dashRatio < .25 ? strokeWidth.value / 2 * (1 - dashRatio / .25) : 0;
			return circumference * dashRatio + dashGap;
		});
		function getCircle({ thickness, offset, color, cls, rounded }) {
			return h("circle", {
				class: "q-circular-progress__" + cls + (color !== void 0 ? ` text-${color}` : ""),
				style: circleStyle.value,
				fill: "transparent",
				stroke: "currentColor",
				"stroke-width": thickness,
				"stroke-dasharray": strokeDashArray,
				"stroke-dashoffset": offset,
				"stroke-linecap": rounded,
				cx: viewBox.value,
				cy: viewBox.value,
				r: radius
			});
		}
		return () => {
			const svgChild = [];
			if (props.centerColor !== void 0 && props.centerColor !== "transparent") svgChild.push(h("circle", {
				class: `q-circular-progress__center text-${props.centerColor}`,
				fill: "currentColor",
				r: radius - strokeWidth.value / 2,
				cx: viewBox.value,
				cy: viewBox.value
			}));
			if (props.trackColor !== void 0 && props.trackColor !== "transparent") svgChild.push(getCircle({
				cls: "track",
				thickness: strokeWidth.value,
				offset: 0,
				color: props.trackColor
			}));
			svgChild.push(getCircle({
				cls: "circle",
				thickness: strokeWidth.value,
				offset: strokeDashOffset.value,
				color: props.color,
				rounded: props.rounded ? "round" : void 0
			}));
			const child = [h("svg", {
				class: "q-circular-progress__svg",
				style: svgStyle.value,
				viewBox: viewBoxAttr.value,
				"aria-hidden": "true"
			}, svgChild)];
			if (props.showValue) child.push(h("div", {
				class: "q-circular-progress__text absolute-full row flex-center content-center",
				style: { fontSize: props.fontSize }
			}, slots.default !== void 0 ? slots.default() : [h("div", normalized.value)]));
			return h("div", {
				class: `q-circular-progress q-circular-progress--${props.indeterminate ? "in" : ""}determinate`,
				style: sizeStyle.value,
				role: "progressbar",
				"aria-valuemin": props.min,
				"aria-valuemax": props.max,
				"aria-valuenow": props.indeterminate ? void 0 : normalized.value
			}, hMergeSlotSafely(slots.internal, child));
		};
	}
});
function getChanges(evt, ctx, isFinal) {
	const pos = position(evt);
	let dir, distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y, absX = Math.abs(distX), absY = Math.abs(distY);
	const direction = ctx.direction;
	if (direction.horizontal && !direction.vertical) dir = distX < 0 ? "left" : "right";
	else if (!direction.horizontal && direction.vertical) dir = distY < 0 ? "up" : "down";
	else if (direction.up && distY < 0) {
		dir = "up";
		if (absX > absY) {
			if (direction.left && distX < 0) dir = "left";
			else if (direction.right && distX > 0) dir = "right";
		}
	} else if (direction.down && distY > 0) {
		dir = "down";
		if (absX > absY) {
			if (direction.left && distX < 0) dir = "left";
			else if (direction.right && distX > 0) dir = "right";
		}
	} else if (direction.left && distX < 0) {
		dir = "left";
		if (absX < absY) {
			if (direction.up && distY < 0) dir = "up";
			else if (direction.down && distY > 0) dir = "down";
		}
	} else if (direction.right && distX > 0) {
		dir = "right";
		if (absX < absY) {
			if (direction.up && distY < 0) dir = "up";
			else if (direction.down && distY > 0) dir = "down";
		}
	}
	let synthetic = false;
	if (dir === void 0 && isFinal === false) {
		if (ctx.event.isFirst || ctx.event.lastDir === void 0) return {};
		dir = ctx.event.lastDir;
		synthetic = true;
		if (dir === "left" || dir === "right") {
			pos.left -= distX;
			absX = 0;
			distX = 0;
		} else {
			pos.top -= distY;
			absY = 0;
			distY = 0;
		}
	}
	return {
		synthetic,
		payload: {
			evt,
			touch: ctx.event.mouse !== true,
			mouse: ctx.event.mouse === true,
			position: pos,
			direction: dir,
			isFirst: ctx.event.isFirst,
			isFinal: isFinal === true,
			duration: Date.now() - ctx.event.time,
			distance: {
				x: absX,
				y: absY
			},
			offset: {
				x: distX,
				y: distY
			},
			delta: {
				x: pos.left - ctx.event.lastX,
				y: pos.top - ctx.event.lastY
			}
		}
	};
}
function removeChildrenNoPointerEvents() {
	document.body.classList.remove("no-pointer-events--children");
}
var uid$2 = 0;
var TouchPan_default = /*#__PURE__*/ createDirective({
	name: "touch-pan",
	beforeMount(el, { value, modifiers }) {
		if (!modifiers.mouse && !client.has.touch) return;
		function handleEvent(evt, mouseEvent) {
			if (modifiers.mouse && mouseEvent) stopAndPrevent(evt);
			else {
				if (modifiers.stop) stop(evt);
				if (modifiers.prevent) prevent(evt);
			}
		}
		const ctx = {
			uid: "qvtp_" + uid$2++,
			handler: value,
			modifiers,
			direction: getModifierDirections(modifiers),
			noop,
			mouseStart(evt) {
				if (shouldStart(evt, ctx) && leftClick(evt)) {
					addEvt(ctx, "temp", [[
						document,
						"mousemove",
						"move",
						"notPassiveCapture"
					], [
						document,
						"mouseup",
						"end",
						"passiveCapture"
					]]);
					ctx.start(evt, true);
				}
			},
			touchStart(evt) {
				if (shouldStart(evt, ctx)) {
					const target = evt.target;
					addEvt(ctx, "temp", [
						[
							target,
							"touchmove",
							"move",
							"notPassiveCapture"
						],
						[
							target,
							"touchcancel",
							"end",
							"passiveCapture"
						],
						[
							target,
							"touchend",
							"end",
							"passiveCapture"
						]
					]);
					ctx.start(evt);
				}
			},
			start(evt, mouseEvent) {
				if (client.is.firefox) preventDraggable(el, true);
				ctx.lastEvt = evt;
				if (mouseEvent || modifiers.stop) {
					if (!ctx.direction.all && (!mouseEvent || !ctx.modifiers.mouseAllDir && !ctx.modifiers.mousealldir)) {
						const clone = evt.type.includes("mouse") ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
						if (evt.defaultPrevented) prevent(clone);
						if (evt.cancelBubble) stop(clone);
						Object.assign(clone, {
							qKeyEvent: evt.qKeyEvent,
							qClickOutside: evt.qClickOutside,
							qAnchorHandled: evt.qAnchorHandled,
							qClonedBy: evt.qClonedBy === void 0 ? [ctx.uid] : evt.qClonedBy.concat(ctx.uid)
						});
						ctx.initialEvent = {
							target: evt.target,
							event: clone
						};
					}
					stop(evt);
				}
				const { left, top } = position(evt);
				ctx.event = {
					x: left,
					y: top,
					time: Date.now(),
					mouse: mouseEvent === true,
					detected: false,
					isFirst: true,
					isFinal: false,
					lastX: left,
					lastY: top
				};
			},
			move(evt) {
				if (ctx.event === void 0) return;
				const pos = position(evt), distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y;
				if (distX === 0 && distY === 0) return;
				ctx.lastEvt = evt;
				const isMouseEvt = ctx.event.mouse === true;
				const start = () => {
					handleEvent(evt, isMouseEvt);
					let cursor;
					if (!modifiers.preserveCursor && !modifiers.preservecursor) {
						cursor = document.documentElement.style.cursor || "";
						document.documentElement.style.cursor = "grabbing";
					}
					if (isMouseEvt) document.body.classList.add("no-pointer-events--children");
					document.body.classList.add("non-selectable");
					clearSelection();
					ctx.styleCleanup = (withDelayedFn) => {
						ctx.styleCleanup = void 0;
						if (cursor !== void 0) document.documentElement.style.cursor = cursor;
						document.body.classList.remove("non-selectable");
						if (isMouseEvt) {
							removeChildrenNoPointerEvents();
							if (withDelayedFn !== void 0) setTimeout(withDelayedFn, 50);
						} else if (withDelayedFn !== void 0) withDelayedFn();
					};
				};
				if (ctx.event.detected) {
					if (!ctx.event.isFirst) handleEvent(evt, ctx.event.mouse);
					const { payload, synthetic } = getChanges(evt, ctx, false);
					if (payload !== void 0) if (ctx.handler(payload) === false) ctx.end(evt);
					else {
						if (ctx.styleCleanup === void 0 && ctx.event.isFirst) start();
						ctx.event.lastX = payload.position.left;
						ctx.event.lastY = payload.position.top;
						ctx.event.lastDir = synthetic ? void 0 : payload.direction;
						ctx.event.isFirst = false;
					}
					return;
				}
				if (ctx.direction.all || isMouseEvt && (ctx.modifiers.mouseAllDir || ctx.modifiers.mousealldir)) {
					start();
					ctx.event.detected = true;
					ctx.move(evt);
					return;
				}
				const absX = Math.abs(distX), absY = Math.abs(distY);
				if (absX !== absY) if (ctx.direction.horizontal && absX > absY || ctx.direction.vertical && absX < absY || ctx.direction.up && absX < absY && distY < 0 || ctx.direction.down && absX < absY && distY > 0 || ctx.direction.left && absX > absY && distX < 0 || ctx.direction.right && absX > absY && distX > 0) {
					ctx.event.detected = true;
					ctx.move(evt);
				} else ctx.end(evt, true);
			},
			end(evt, abort) {
				if (ctx.event === void 0) return;
				cleanEvt(ctx, "temp");
				if (client.is.firefox) preventDraggable(el, false);
				if (abort) {
					ctx.styleCleanup?.();
					if (!ctx.event.detected && ctx.initialEvent !== void 0) ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
				} else if (ctx.event.detected) {
					if (ctx.event.isFirst) ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
					const { payload } = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
					const fn = () => {
						ctx.handler(payload);
					};
					if (ctx.styleCleanup !== void 0) ctx.styleCleanup(fn);
					else fn();
				}
				ctx.event = void 0;
				ctx.initialEvent = void 0;
				ctx.lastEvt = void 0;
			}
		};
		el.__qtouchpan = ctx;
		if (modifiers.mouse) addEvt(ctx, "main", [[
			el,
			"mousedown",
			"mouseStart",
			`passive${modifiers.mouseCapture || modifiers.mousecapture ? "Capture" : ""}`
		]]);
		if (client.has.touch) addEvt(ctx, "main", [[
			el,
			"touchstart",
			"touchStart",
			`passive${modifiers.capture ? "Capture" : ""}`
		], [
			el,
			"touchmove",
			"noop",
			"notPassiveCapture"
		]]);
	},
	updated(el, bindings) {
		const ctx = el.__qtouchpan;
		if (ctx !== void 0) {
			if (bindings.oldValue !== bindings.value) {
				if (typeof bindings.value !== "function") ctx.end();
				ctx.handler = bindings.value;
			}
			ctx.direction = getModifierDirections(bindings.modifiers);
		}
	},
	beforeUnmount(el) {
		const ctx = el.__qtouchpan;
		if (ctx !== void 0) {
			if (ctx.event !== void 0) ctx.end();
			cleanEvt(ctx, "main");
			cleanEvt(ctx, "temp");
			if (client.is.firefox) preventDraggable(el, false);
			ctx.styleCleanup?.();
			delete el.__qtouchpan;
		}
	}
});
var markerPrefixClass = "q-slider__marker-labels";
var defaultMarkerConvertFn = (v) => ({ value: v });
var defaultMarkerLabelRenderFn = ({ marker }) => h("div", {
	key: marker.value,
	style: marker.style,
	class: marker.classes
}, marker.label);
var keyCodes$2 = [
	34,
	37,
	40,
	33,
	39,
	38
];
var useSliderProps = {
	...useDarkProps,
	...useFormProps,
	min: {
		type: Number,
		default: 0
	},
	max: {
		type: Number,
		default: 100
	},
	innerMin: Number,
	innerMax: Number,
	step: {
		type: Number,
		default: 1,
		validator: (v) => v >= 0
	},
	snap: Boolean,
	vertical: Boolean,
	reverse: Boolean,
	color: String,
	markerLabelsClass: String,
	label: Boolean,
	labelColor: String,
	labelTextColor: String,
	labelAlways: Boolean,
	switchLabelSide: Boolean,
	markers: [Boolean, Number],
	markerLabels: [
		Boolean,
		Array,
		Object,
		Function
	],
	switchMarkerLabelsSide: Boolean,
	trackImg: String,
	trackColor: String,
	innerTrackImg: String,
	innerTrackColor: String,
	selectionColor: String,
	selectionImg: String,
	thumbSize: {
		type: String,
		default: "20px"
	},
	trackSize: {
		type: String,
		default: "4px"
	},
	disable: Boolean,
	readonly: Boolean,
	dense: Boolean,
	tabindex: [String, Number],
	thumbColor: String,
	thumbPath: {
		type: String,
		default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
	}
};
var useSliderEmits = [
	"pan",
	"update:modelValue",
	"change"
];
function useSlider({ updateValue, updatePosition, getDragging, formAttrs }) {
	const { props, emit, slots, proxy: { $q } } = getCurrentInstance();
	const isDark = useDark(props, $q);
	const injectFormInput = useFormInject(formAttrs);
	const active = ref(false);
	const preventFocus = ref(false);
	const focus = ref(false);
	const dragging = ref(false);
	const axis = computed(() => props.vertical ? "--v" : "--h");
	const labelSide = computed(() => "-" + (props.switchLabelSide ? "switched" : "standard"));
	const isReversed = computed(() => props.vertical ? props.reverse : props.reverse !== ($q.lang.rtl === true));
	const innerMin = computed(() => !Number.isFinite(props.innerMin) || props.innerMin < props.min ? props.min : props.innerMin);
	const innerMax = computed(() => !Number.isFinite(props.innerMax) || props.innerMax > props.max ? props.max : props.innerMax);
	const editable = computed(() => !props.disable && !props.readonly && innerMin.value < innerMax.value);
	const roundValueFn = computed(() => {
		if (props.step === 0) return (v) => v;
		const decimals = (String(props.step).trim().split(".")[1] || "").length;
		return (v) => Number.parseFloat(v.toFixed(decimals));
	});
	const keyStep = computed(() => props.step === 0 ? 1 : props.step);
	const tabindex = computed(() => editable.value ? props.tabindex || 0 : -1);
	const trackLen = computed(() => props.max - props.min);
	const innerBarLen = computed(() => innerMax.value - innerMin.value);
	const innerMinRatio = computed(() => convertModelToRatio(innerMin.value));
	const innerMaxRatio = computed(() => convertModelToRatio(innerMax.value));
	const positionProp = computed(() => props.vertical ? isReversed.value ? "bottom" : "top" : isReversed.value ? "right" : "left");
	const sizeProp = computed(() => props.vertical ? "height" : "width");
	const thicknessProp = computed(() => props.vertical ? "width" : "height");
	const orientation = computed(() => props.vertical ? "vertical" : "horizontal");
	const attributes = computed(() => {
		const acc = {
			role: "slider",
			"aria-valuemin": innerMin.value,
			"aria-valuemax": innerMax.value,
			"aria-orientation": orientation.value,
			"data-step": props.step
		};
		if (props.disable) acc["aria-disabled"] = "true";
		else if (props.readonly) acc["aria-readonly"] = "true";
		return acc;
	});
	const classes = computed(() => `q-slider q-slider${axis.value} q-slider--${active.value ? "" : "in"}active inline no-wrap ` + (props.vertical ? "row" : "column") + (props.disable ? " disabled" : " q-slider--enabled" + (editable.value ? " q-slider--editable" : "")) + (focus.value === "both" ? " q-slider--focus" : "") + (props.label || props.labelAlways ? " q-slider--label" : "") + (props.labelAlways ? " q-slider--label-always" : "") + (isDark.value ? " q-slider--dark" : "") + (props.dense ? " q-slider--dense q-slider--dense" + axis.value : ""));
	function getPositionClass(name) {
		const cls = "q-slider__" + name;
		return `${cls} ${cls}${axis.value} ${cls}${axis.value}${labelSide.value}`;
	}
	function getAxisClass(name) {
		const cls = "q-slider__" + name;
		return `${cls} ${cls}${axis.value}`;
	}
	const selectionBarClass = computed(() => {
		const color = props.selectionColor || props.color;
		return "q-slider__selection absolute" + (color !== void 0 ? ` text-${color}` : "");
	});
	const markerClass = computed(() => getAxisClass("markers") + " absolute overflow-hidden");
	const trackContainerClass = computed(() => getAxisClass("track-container"));
	const pinClass = computed(() => getPositionClass("pin"));
	const labelClass = computed(() => getPositionClass("label"));
	const textContainerClass = computed(() => getPositionClass("text-container"));
	const markerLabelsContainerClass = computed(() => getPositionClass("marker-labels-container") + (props.markerLabelsClass !== void 0 ? ` ${props.markerLabelsClass}` : ""));
	const trackClass = computed(() => "q-slider__track relative-position no-outline" + (props.trackColor !== void 0 ? ` bg-${props.trackColor}` : ""));
	const trackStyle = computed(() => {
		const acc = { [thicknessProp.value]: props.trackSize };
		if (props.trackImg !== void 0) acc.backgroundImage = `url(${props.trackImg}) !important`;
		return acc;
	});
	const innerBarClass = computed(() => "q-slider__inner absolute" + (props.innerTrackColor !== void 0 ? ` bg-${props.innerTrackColor}` : ""));
	const innerBarStyle = computed(() => {
		const innerDiff = innerMaxRatio.value - innerMinRatio.value;
		const acc = {
			[positionProp.value]: `${100 * innerMinRatio.value}%`,
			[sizeProp.value]: innerDiff === 0 ? "2px" : `${100 * innerDiff}%`
		};
		if (props.innerTrackImg !== void 0) acc.backgroundImage = `url(${props.innerTrackImg}) !important`;
		return acc;
	});
	function convertRatioToModel(ratio) {
		const { min, max, step } = props;
		let model = min + ratio * (max - min);
		if (step > 0) {
			const modulo = (model - innerMin.value) % step;
			model += (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0) - modulo;
		}
		model = roundValueFn.value(model);
		return between(model, innerMin.value, innerMax.value);
	}
	function convertModelToRatio(model) {
		return trackLen.value === 0 ? 0 : (model - props.min) / trackLen.value;
	}
	function getDraggingRatio(evt, draggingInfo) {
		const pos = position(evt), val = props.vertical ? between((pos.top - draggingInfo.top) / draggingInfo.height, 0, 1) : between((pos.left - draggingInfo.left) / draggingInfo.width, 0, 1);
		return between(isReversed.value ? 1 - val : val, innerMinRatio.value, innerMaxRatio.value);
	}
	const markerStep = computed(() => isNumber(props.markers) && props.markers > 0 ? props.markers : keyStep.value);
	const markerTicks = computed(() => {
		const acc = [];
		const step = markerStep.value;
		const max = props.max;
		let value = props.min;
		do {
			acc.push(value);
			value += step;
		} while (value < max);
		acc.push(max);
		return acc;
	});
	const markerLabelClass = computed(() => {
		const prefix = ` ${markerPrefixClass}${axis.value}-`;
		return `q-slider__marker-labels${prefix}${props.switchMarkerLabelsSide ? "switched" : "standard"}${prefix}${isReversed.value ? "rtl" : "ltr"}`;
	});
	const markerLabelsList = computed(() => {
		if (props.markerLabels === false) return null;
		return getMarkerList(props.markerLabels).map((entry, index) => ({
			index,
			value: entry.value,
			label: entry.label || entry.value,
			classes: markerLabelClass.value + (entry.classes !== void 0 ? " " + entry.classes : ""),
			style: {
				...getMarkerLabelStyle(entry.value),
				...entry.style
			}
		}));
	});
	const markerScope = computed(() => ({
		markerList: markerLabelsList.value,
		markerMap: markerLabelsMap.value,
		classes: markerLabelClass.value,
		getStyle: getMarkerLabelStyle
	}));
	const markerStyle = computed(() => {
		const size = innerBarLen.value === 0 ? "2px" : 100 * markerStep.value / innerBarLen.value;
		return {
			...innerBarStyle.value,
			backgroundSize: props.vertical ? `2px ${size}%` : `${size}% 2px`
		};
	});
	function getMarkerList(def) {
		if (def === false) return null;
		if (def === true) return markerTicks.value.map(defaultMarkerConvertFn);
		if (typeof def === "function") return markerTicks.value.map((value) => {
			const item = def(value);
			return isObject(item) ? {
				...item,
				value
			} : {
				value,
				label: item
			};
		});
		const filterFn = ({ value }) => value >= props.min && value <= props.max;
		if (Array.isArray(def)) return def.map((item) => isObject(item) ? item : { value: item }).filter(filterFn);
		return Object.keys(def).map((key) => {
			const item = def[key];
			const value = Number(key);
			return isObject(item) ? {
				...item,
				value
			} : {
				value,
				label: item
			};
		}).filter(filterFn);
	}
	function getMarkerLabelStyle(val) {
		return { [positionProp.value]: `${100 * (val - props.min) / trackLen.value}%` };
	}
	const markerLabelsMap = computed(() => {
		if (props.markerLabels === false) return null;
		const acc = {};
		markerLabelsList.value.forEach((entry) => {
			acc[entry.value] = entry;
		});
		return acc;
	});
	function getMarkerLabelsContent() {
		if (slots["marker-label-group"] !== void 0) return slots["marker-label-group"](markerScope.value);
		const fn = slots["marker-label"] || defaultMarkerLabelRenderFn;
		return markerLabelsList.value.map((marker) => fn({
			marker,
			...markerScope.value
		}));
	}
	const panDirective = computed(() => [[
		TouchPan_default,
		onPan,
		void 0,
		{
			[orientation.value]: true,
			prevent: true,
			stop: true,
			mouse: true,
			mouseAllDir: true
		}
	]]);
	function onPan(event) {
		if (event.isFinal) {
			if (dragging.value !== void 0) {
				updatePosition(event.evt);
				if (event.touch) updateValue(true);
				dragging.value = void 0;
				emit("pan", "end");
			}
			active.value = false;
			focus.value = false;
		} else if (event.isFirst) {
			dragging.value = getDragging(event.evt);
			updatePosition(event.evt);
			updateValue();
			active.value = true;
			emit("pan", "start");
		} else {
			updatePosition(event.evt);
			updateValue();
		}
	}
	function onBlur() {
		focus.value = false;
	}
	function onActivate(evt) {
		updatePosition(evt, getDragging(evt));
		updateValue();
		preventFocus.value = true;
		active.value = true;
		document.addEventListener("mouseup", onDeactivate, true);
	}
	function onDeactivate() {
		preventFocus.value = false;
		active.value = false;
		updateValue(true);
		onBlur();
		document.removeEventListener("mouseup", onDeactivate, true);
	}
	function onMobileClick(evt) {
		updatePosition(evt, getDragging(evt));
		updateValue(true);
	}
	function onKeyup(evt) {
		if (keyCodes$2.includes(evt.keyCode)) updateValue(true);
	}
	function getTextContainerStyle(ratio) {
		if (props.vertical) return null;
		const p = $q.lang.rtl !== props.reverse ? 1 - ratio : ratio;
		return { transform: `translateX(calc(${2 * p - 1} * ${props.thumbSize} / 2 + ${50 - 100 * p}%))` };
	}
	function getThumbRenderFn(thumb) {
		const focusClass = computed(() => !preventFocus.value && (focus.value === thumb.focusValue || focus.value === "both") ? " q-slider--focus" : "");
		const thumbClasses = computed(() => `q-slider__thumb q-slider__thumb${axis.value} q-slider__thumb${axis.value}-${isReversed.value ? "rtl" : "ltr"} absolute non-selectable` + focusClass.value + (thumb.thumbColor.value !== void 0 ? ` text-${thumb.thumbColor.value}` : ""));
		const style = computed(() => ({
			width: props.thumbSize,
			height: props.thumbSize,
			[positionProp.value]: `${100 * thumb.ratio.value}%`,
			zIndex: focus.value === thumb.focusValue ? 2 : void 0
		}));
		const pinColor = computed(() => thumb.labelColor.value !== void 0 ? ` text-${thumb.labelColor.value}` : "");
		const textContainerStyle = computed(() => getTextContainerStyle(thumb.ratio.value));
		const textClass = computed(() => "q-slider__text" + (thumb.labelTextColor.value !== void 0 ? ` text-${thumb.labelTextColor.value}` : ""));
		return () => {
			const thumbContent = [h("svg", {
				class: "q-slider__thumb-shape absolute-full",
				viewBox: "0 0 20 20",
				"aria-hidden": "true"
			}, [h("path", { d: props.thumbPath })]), h("div", { class: "q-slider__focus-ring fit" })];
			if (props.label || props.labelAlways) thumbContent.push(h("div", { class: pinClass.value + " absolute fit no-pointer-events" + pinColor.value }, [h("div", {
				class: labelClass.value,
				style: { minWidth: props.thumbSize }
			}, [h("div", {
				class: textContainerClass.value,
				style: textContainerStyle.value
			}, [h("span", { class: textClass.value }, thumb.label.value)])])]));
			if (thumb.injectFormInput !== false && props.name !== void 0 && !props.disable) injectFormInput(thumbContent, "push");
			return h("div", {
				class: thumbClasses.value,
				style: style.value,
				...thumb.getNodeData()
			}, thumbContent);
		};
	}
	function getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, injectThumb) {
		const trackContent = [];
		if (props.innerTrackColor !== "transparent") trackContent.push(h("div", {
			key: "inner",
			class: innerBarClass.value,
			style: innerBarStyle.value
		}));
		if (props.selectionColor !== "transparent") trackContent.push(h("div", {
			key: "selection",
			class: selectionBarClass.value,
			style: selectionBarStyle.value
		}));
		if (props.markers !== false) trackContent.push(h("div", {
			key: "marker",
			class: markerClass.value,
			style: markerStyle.value
		}));
		injectThumb(trackContent);
		const content = [hDir("div", {
			key: "trackC",
			class: trackContainerClass.value,
			tabindex: trackContainerTabindex.value,
			...trackContainerEvents.value
		}, [h("div", {
			class: trackClass.value,
			style: trackStyle.value
		}, trackContent)], "slide", editable.value, () => panDirective.value)];
		if (props.markerLabels !== false) content[props.switchMarkerLabelsSide ? "unshift" : "push"](h("div", {
			key: "markerL",
			class: markerLabelsContainerClass.value
		}, getMarkerLabelsContent()));
		return content;
	}
	onBeforeUnmount(() => {
		document.removeEventListener("mouseup", onDeactivate, true);
	});
	return {
		state: {
			active,
			focus,
			preventFocus,
			dragging,
			editable,
			classes,
			tabindex,
			attributes,
			roundValueFn,
			keyStep,
			trackLen,
			innerMin,
			innerMinRatio,
			innerMax,
			innerMaxRatio,
			positionProp,
			sizeProp,
			isReversed
		},
		methods: {
			onActivate,
			onMobileClick,
			onBlur,
			onKeyup,
			getContent,
			getThumbRenderFn,
			convertRatioToModel,
			convertModelToRatio,
			getDraggingRatio
		}
	};
}
var getNodeData = () => ({});
var QSlider_default = /*#__PURE__*/ createComponent({
	name: "QSlider",
	props: {
		...useSliderProps,
		modelValue: {
			required: true,
			default: null,
			validator: (v) => typeof v === "number" || v === null
		},
		labelValue: [String, Number]
	},
	emits: useSliderEmits,
	setup(props, { emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const { state, methods } = useSlider({
			updateValue,
			updatePosition,
			getDragging,
			formAttrs: useFormAttrs(props)
		});
		const rootRef = ref(null);
		const curRatio = ref(0);
		const model = ref(0);
		function normalizeModel() {
			model.value = props.modelValue === null ? state.innerMin.value : between(props.modelValue, state.innerMin.value, state.innerMax.value);
		}
		watch(() => `${props.modelValue}|${state.innerMin.value}|${state.innerMax.value}`, normalizeModel, { immediate: true });
		const modelRatio = computed(() => methods.convertModelToRatio(model.value));
		const ratio = computed(() => state.active.value ? curRatio.value : modelRatio.value);
		const selectionBarStyle = computed(() => {
			const acc = {
				[state.positionProp.value]: `${100 * state.innerMinRatio.value}%`,
				[state.sizeProp.value]: `${100 * (ratio.value - state.innerMinRatio.value)}%`
			};
			if (props.selectionImg !== void 0) acc.backgroundImage = `url(${props.selectionImg}) !important`;
			return acc;
		});
		const getThumb = methods.getThumbRenderFn({
			focusValue: true,
			getNodeData,
			ratio,
			label: computed(() => props.labelValue !== void 0 ? props.labelValue : model.value),
			thumbColor: computed(() => props.thumbColor || props.color),
			labelColor: computed(() => props.labelColor),
			labelTextColor: computed(() => props.labelTextColor)
		});
		const trackContainerEvents = computed(() => {
			if (!state.editable.value) return {};
			return $q.platform.is.mobile ? { onClick: methods.onMobileClick } : {
				onMousedown: methods.onActivate,
				onFocus,
				onBlur: methods.onBlur,
				onKeydown,
				onKeyup: methods.onKeyup
			};
		});
		function updateValue(change) {
			if (model.value !== props.modelValue) emit("update:modelValue", model.value);
			if (change) emit("change", model.value);
		}
		function getDragging() {
			return rootRef.value.getBoundingClientRect();
		}
		function updatePosition(event, dragging = state.dragging.value) {
			const localRatio = methods.getDraggingRatio(event, dragging);
			model.value = methods.convertRatioToModel(localRatio);
			curRatio.value = !props.snap || props.step === 0 ? localRatio : methods.convertModelToRatio(model.value);
		}
		function onFocus() {
			state.focus.value = true;
		}
		function onKeydown(evt) {
			if (!keyCodes$2.includes(evt.keyCode)) return;
			stopAndPrevent(evt);
			const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state.keyStep.value, offset = ([
				34,
				37,
				40
			].includes(evt.keyCode) ? -1 : 1) * (state.isReversed.value ? -1 : 1) * (props.vertical ? -1 : 1) * stepVal;
			model.value = between(state.roundValueFn.value(model.value + offset), state.innerMin.value, state.innerMax.value);
			updateValue();
		}
		return () => {
			const content = methods.getContent(selectionBarStyle, state.tabindex, trackContainerEvents, (node) => {
				node.push(getThumb());
			});
			return h("div", {
				ref: rootRef,
				class: state.classes.value + (props.modelValue === null ? " q-slider--no-value" : ""),
				...state.attributes.value,
				"aria-valuenow": props.modelValue
			}, content);
		};
	}
});
function useHydration() {
	const isHydrated = ref(!isRuntimeSsrPreHydration.value);
	if (!isHydrated.value) onMounted(() => {
		isHydrated.value = true;
	});
	return { isHydrated };
}
var hasObserver = typeof ResizeObserver !== "undefined";
var resizeProps = hasObserver ? {} : {
	style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
	url: "about:blank"
};
var QResizeObserver_default = /*#__PURE__*/ createComponent({
	name: "QResizeObserver",
	props: { debounce: {
		type: [String, Number],
		default: 100
	} },
	emits: ["resize"],
	setup(props, { emit }) {
		let timer = null, targetEl, size = {
			width: -1,
			height: -1
		};
		function trigger(immediately) {
			if (immediately === true || props.debounce === 0 || props.debounce === "0") emitEvent();
			else if (timer === null) timer = setTimeout(emitEvent, props.debounce);
		}
		function emitEvent() {
			if (timer !== null) {
				clearTimeout(timer);
				timer = null;
			}
			if (targetEl) {
				const { offsetWidth: width, offsetHeight: height } = targetEl;
				if (width !== size.width || height !== size.height) {
					size = {
						width,
						height
					};
					emit("resize", size);
				}
			}
		}
		const { proxy } = getCurrentInstance();
		proxy.trigger = trigger;
		if (hasObserver) {
			let observer, isDestroyed = false;
			const init = (stop) => {
				if (isDestroyed) return;
				targetEl = proxy.$el.parentNode;
				if (targetEl) {
					observer = new ResizeObserver(trigger);
					observer.observe(targetEl);
					emitEvent();
				} else if (!stop) nextTick(() => {
					init(true);
				});
			};
			onMounted(() => {
				init();
			});
			onBeforeUnmount(() => {
				isDestroyed = true;
				if (timer !== null) clearTimeout(timer);
				if (observer !== void 0) {
					if (observer.disconnect !== void 0) observer.disconnect();
					else if (targetEl) observer.unobserve(targetEl);
				}
			});
			return noop;
		}
		const { isHydrated } = useHydration();
		let curDocView, isDestroyed = false;
		const cleanup = () => {
			if (timer !== null) {
				clearTimeout(timer);
				timer = null;
			}
			if (curDocView !== void 0) {
				if (curDocView.removeEventListener !== void 0) curDocView.removeEventListener("resize", trigger, listenOpts.passive);
				curDocView = void 0;
			}
		};
		const onObjLoad = () => {
			cleanup();
			if (targetEl?.contentDocument) {
				curDocView = targetEl.contentDocument.defaultView;
				curDocView.addEventListener("resize", trigger, listenOpts.passive);
				emitEvent();
			}
		};
		onMounted(() => {
			nextTick(() => {
				if (isDestroyed) return;
				targetEl = proxy.$el;
				if (targetEl) onObjLoad();
			});
		});
		onBeforeUnmount(() => {
			isDestroyed = true;
			cleanup();
		});
		return () => {
			if (isHydrated.value) return h("object", {
				class: "q--avoid-card-border",
				style: resizeProps.style,
				tabindex: -1,
				type: "text/html",
				data: resizeProps.url,
				"aria-hidden": "true",
				onLoad: onObjLoad
			});
		};
	}
});
var rtlHasScrollBug = false;
if (!__QUASAR_SSR__) {
	const scroller = document.createElement("div");
	scroller.setAttribute("dir", "rtl");
	Object.assign(scroller.style, {
		width: "1px",
		height: "1px",
		overflow: "auto"
	});
	const spacer = document.createElement("div");
	Object.assign(spacer.style, {
		width: "1000px",
		height: "1px"
	});
	document.body.append(scroller);
	scroller.append(spacer);
	scroller.scrollLeft = -1e3;
	rtlHasScrollBug = scroller.scrollLeft >= 0;
	scroller.remove();
}
function getIndicatorClass(color, top, vertical) {
	const pos = vertical ? ["left", "right"] : ["top", "bottom"];
	return `absolute-${top ? pos[0] : pos[1]}${color ? ` text-${color}` : ""}`;
}
function hasQueryIncluded(targetQuery, matchingQuery) {
	for (const key in targetQuery) if (targetQuery[key] !== matchingQuery[key]) return false;
	return true;
}
var alignValues$1 = [
	"left",
	"center",
	"right",
	"justify"
];
var QTabs_default = /*#__PURE__*/ createComponent({
	name: "QTabs",
	props: {
		modelValue: [Number, String],
		align: {
			type: String,
			default: "center",
			validator: (v) => alignValues$1.includes(v)
		},
		breakpoint: {
			type: [String, Number],
			default: 600
		},
		vertical: Boolean,
		shrink: Boolean,
		stretch: Boolean,
		activeClass: String,
		activeColor: String,
		activeBgColor: String,
		indicatorColor: String,
		leftIcon: String,
		rightIcon: String,
		outsideArrows: Boolean,
		mobileArrows: Boolean,
		switchIndicator: Boolean,
		narrowIndicator: Boolean,
		inlineLabel: Boolean,
		noCaps: Boolean,
		dense: Boolean,
		contentClass: String,
		"onUpdate:modelValue": [Function, Array]
	},
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const { registerTick: registerScrollTick } = useTick();
		const { registerTick: registerUpdateArrowsTick } = useTick();
		const { registerTick: registerAnimateTick } = useTick();
		const { registerTimeout: registerFocusTimeout, removeTimeout: removeFocusTimeout } = useTimeout();
		const { registerTimeout: registerScrollToTabTimeout, removeTimeout: removeScrollToTabTimeout } = useTimeout();
		const rootRef = ref(null);
		const contentRef = ref(null);
		const currentModel = ref(props.modelValue);
		const scrollable = ref(false);
		const leftArrow = ref(true);
		const rightArrow = ref(false);
		const justify = ref(false);
		const tabDataList = [];
		const tabDataListLen = ref(0);
		const hasFocus = ref(false);
		let animateTimer = null, scrollTimer = null, unwatchRoute;
		const tabProps = computed(() => ({
			activeClass: props.activeClass,
			activeColor: props.activeColor,
			activeBgColor: props.activeBgColor,
			indicatorClass: getIndicatorClass(props.indicatorColor, props.switchIndicator, props.vertical),
			narrowIndicator: props.narrowIndicator,
			inlineLabel: props.inlineLabel,
			noCaps: props.noCaps
		}));
		const hasActiveTab = computed(() => {
			const len = tabDataListLen.value;
			const val = currentModel.value;
			for (let i = 0; i < len; i++) if (tabDataList[i].name.value === val) return true;
			return false;
		});
		const alignClass = computed(() => {
			return `q-tabs__content--align-${scrollable.value ? "left" : justify.value ? "justify" : props.align}`;
		});
		const classes = computed(() => `q-tabs row no-wrap items-center q-tabs--${scrollable.value ? "" : "not-"}scrollable q-tabs--${props.vertical ? "vertical" : "horizontal"} q-tabs__arrows--${props.outsideArrows ? "outside" : "inside"} q-tabs--mobile-with${props.mobileArrows ? "" : "out"}-arrows` + (props.dense ? " q-tabs--dense" : "") + (props.shrink ? " col-shrink" : "") + (props.stretch ? " self-stretch" : ""));
		const innerClass = computed(() => "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + alignClass.value + (props.contentClass !== void 0 ? ` ${props.contentClass}` : ""));
		const domProps = computed(() => props.vertical ? {
			container: "height",
			content: "offsetHeight",
			scroll: "scrollHeight"
		} : {
			container: "width",
			content: "offsetWidth",
			scroll: "scrollWidth"
		});
		const isRTL = computed(() => !props.vertical && $q.lang.rtl === true);
		const rtlPosCorrection = computed(() => !rtlHasScrollBug && isRTL.value);
		watch(isRTL, updateArrows);
		watch(() => props.modelValue, (name) => {
			updateModel({
				name,
				setCurrent: true,
				skipEmit: true
			});
		});
		watch(() => props.outsideArrows, recalculateScroll);
		function updateModel({ name, setCurrent, skipEmit }) {
			if (currentModel.value === name) return;
			if (!skipEmit && props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", name);
			if (setCurrent || props["onUpdate:modelValue"] === void 0) {
				animate(currentModel.value, name);
				currentModel.value = name;
			}
		}
		function recalculateScroll() {
			registerScrollTick(() => {
				if (rootRef.value) updateContainer({
					width: rootRef.value.offsetWidth,
					height: rootRef.value.offsetHeight
				});
			});
		}
		function updateContainer(domSize) {
			if (domProps.value === void 0 || contentRef.value === null) return;
			const size = domSize[domProps.value.container], scrollSize = Math.min(contentRef.value[domProps.value.scroll], Array.prototype.reduce.call(contentRef.value.children, (acc, el) => acc + (el[domProps.value.content] || 0), 0)), scroll = size > 0 && scrollSize > size;
			scrollable.value = scroll;
			if (scroll) registerUpdateArrowsTick(updateArrows);
			justify.value = size < Number.parseInt(props.breakpoint, 10);
		}
		function animate(oldName, newName) {
			const oldTab = oldName !== void 0 && oldName !== null && oldName !== "" ? tabDataList.find((tab) => tab.name.value === oldName) : null, newTab = newName !== void 0 && newName !== null && newName !== "" ? tabDataList.find((tab) => tab.name.value === newName) : null;
			if (hadActivated) hadActivated = false;
			else if (oldTab && newTab) {
				const oldEl = oldTab.tabIndicatorRef.value, newEl = newTab.tabIndicatorRef.value;
				if (animateTimer !== null) {
					clearTimeout(animateTimer);
					animateTimer = null;
				}
				oldEl.style.transition = "none";
				oldEl.style.transform = "none";
				newEl.style.transition = "none";
				newEl.style.transform = "none";
				const oldPos = oldEl.getBoundingClientRect(), newPos = newEl.getBoundingClientRect();
				newEl.style.transform = props.vertical ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;
				registerAnimateTick(() => {
					animateTimer = setTimeout(() => {
						animateTimer = null;
						newEl.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)";
						newEl.style.transform = "none";
					}, 70);
				});
			}
			if (newTab && scrollable.value) scrollToTabEl(newTab.rootRef.value);
		}
		function scrollToTabEl(el) {
			const { left, width, top, height } = contentRef.value.getBoundingClientRect(), newPos = el.getBoundingClientRect();
			let offset = props.vertical ? newPos.top - top : newPos.left - left;
			if (offset < 0) {
				contentRef.value[props.vertical ? "scrollTop" : "scrollLeft"] += Math.floor(offset);
				updateArrows();
				return;
			}
			offset += props.vertical ? newPos.height - height : newPos.width - width;
			if (offset > 0) {
				contentRef.value[props.vertical ? "scrollTop" : "scrollLeft"] += Math.ceil(offset);
				updateArrows();
			}
		}
		function updateArrows() {
			const content = contentRef.value;
			if (content === null) return;
			const rect = content.getBoundingClientRect(), pos = props.vertical ? content.scrollTop : Math.abs(content.scrollLeft);
			if (isRTL.value) {
				leftArrow.value = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
				rightArrow.value = pos > 0;
			} else {
				leftArrow.value = pos > 0;
				rightArrow.value = props.vertical ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
			}
		}
		function animScrollTo(value) {
			if (scrollTimer !== null) clearInterval(scrollTimer);
			scrollTimer = setInterval(() => {
				if (scrollTowards(value)) stopAnimScroll();
			}, 5);
		}
		function scrollToStart() {
			animScrollTo(rtlPosCorrection.value ? Number.MAX_SAFE_INTEGER : 0);
		}
		function scrollToEnd() {
			animScrollTo(rtlPosCorrection.value ? 0 : Number.MAX_SAFE_INTEGER);
		}
		function stopAnimScroll() {
			if (scrollTimer !== null) {
				clearInterval(scrollTimer);
				scrollTimer = null;
			}
		}
		function onKbdNavigate(keyCode, fromEl) {
			const tabs = Array.prototype.filter.call(contentRef.value.children, (el) => el === fromEl || el.matches?.(".q-tab.q-focusable"));
			const len = tabs.length;
			if (len === 0) return;
			if (keyCode === 36) {
				scrollToTabEl(tabs[0]);
				tabs[0].focus();
				return true;
			}
			if (keyCode === 35) {
				scrollToTabEl(tabs[len - 1]);
				tabs[len - 1].focus();
				return true;
			}
			const dirPrev = keyCode === (props.vertical ? 38 : 37);
			const dirNext = keyCode === (props.vertical ? 40 : 39);
			const dir = dirPrev ? -1 : dirNext ? 1 : void 0;
			if (dir !== void 0) {
				const rtlDir = props.vertical !== true && isRTL.value ? -1 : 1;
				const index = (tabs.indexOf(fromEl) + dir * rtlDir + len) % len;
				scrollToTabEl(tabs[index]);
				tabs[index].focus({ preventScroll: true });
				return true;
			}
		}
		const posFn = computed(() => rtlPosCorrection.value ? {
			get: (content) => Math.abs(content.scrollLeft),
			set: (content, pos) => {
				content.scrollLeft = -pos;
			}
		} : props.vertical ? {
			get: (content) => content.scrollTop,
			set: (content, pos) => {
				content.scrollTop = pos;
			}
		} : {
			get: (content) => content.scrollLeft,
			set: (content, pos) => {
				content.scrollLeft = pos;
			}
		});
		function scrollTowards(value) {
			const content = contentRef.value, { get, set } = posFn.value;
			let done = false, pos = get(content);
			const direction = value < pos ? -1 : 1;
			pos += direction * 5;
			if (pos < 0) {
				done = true;
				pos = 0;
			} else if (direction === -1 && pos <= value || direction === 1 && pos >= value) {
				done = true;
				pos = value;
			}
			set(content, pos);
			updateArrows();
			return done;
		}
		function updateActiveRoute() {
			let name = null, bestScore = {
				matchedLen: 0,
				queryDiff: 9999,
				hrefLen: 0
			};
			const list = tabDataList.filter((tab) => tab.routeData?.hasRouterLink.value === true);
			const { hash: currentHash, query: currentQuery } = proxy.$route;
			const currentQueryLen = Object.keys(currentQuery).length;
			for (const tab of list) {
				const exact = tab.routeData.exact.value === true;
				if (!tab.routeData[exact ? "linkIsExactActive" : "linkIsActive"].value) continue;
				const { hash, query, matched, href } = tab.routeData.resolvedLink.value;
				const queryLen = Object.keys(query).length;
				if (exact) {
					if (hash !== currentHash) continue;
					if (queryLen !== currentQueryLen || !hasQueryIncluded(currentQuery, query)) continue;
					name = tab.name.value;
					break;
				}
				if (hash !== "" && hash !== currentHash) continue;
				if (queryLen !== 0 && !hasQueryIncluded(query, currentQuery)) continue;
				const newScore = {
					matchedLen: matched.length,
					queryDiff: currentQueryLen - queryLen,
					hrefLen: href.length - hash.length
				};
				if (newScore.matchedLen > bestScore.matchedLen) {
					name = tab.name.value;
					bestScore = newScore;
					continue;
				} else if (newScore.matchedLen !== bestScore.matchedLen) continue;
				if (newScore.queryDiff < bestScore.queryDiff) {
					name = tab.name.value;
					bestScore = newScore;
				} else if (newScore.queryDiff !== bestScore.queryDiff) continue;
				if (newScore.hrefLen > bestScore.hrefLen) {
					name = tab.name.value;
					bestScore = newScore;
				}
			}
			if (name === null && tabDataList.some((tab) => tab.routeData === void 0 && tab.name.value === currentModel.value)) {
				hadActivated = false;
				return;
			}
			updateModel({
				name,
				setCurrent: true
			});
		}
		function onFocusin(e) {
			removeFocusTimeout();
			if (!hasFocus.value && rootRef.value !== null && e.target && typeof e.target.closest === "function") {
				const tab = e.target.closest(".q-tab");
				if (tab && rootRef.value.contains(tab)) {
					hasFocus.value = true;
					if (scrollable.value) scrollToTabEl(tab);
				}
			}
		}
		function onFocusout() {
			registerFocusTimeout(() => {
				hasFocus.value = false;
			}, 30);
		}
		function verifyRouteModel() {
			if ($tabs.avoidRouteWatcher === false) registerScrollToTabTimeout(updateActiveRoute);
			else removeScrollToTabTimeout();
		}
		function watchRoute() {
			if (unwatchRoute === void 0) {
				const unwatch = watch(() => proxy.$route.fullPath, verifyRouteModel);
				unwatchRoute = () => {
					unwatch();
					unwatchRoute = void 0;
				};
			}
		}
		function registerTab(tabData) {
			tabDataList.push(tabData);
			tabDataListLen.value++;
			recalculateScroll();
			if (tabData.routeData === void 0 || proxy.$route === void 0) registerScrollToTabTimeout(() => {
				if (scrollable.value) {
					const value = currentModel.value;
					const newTab = value !== void 0 && value !== null && value !== "" ? tabDataList.find((tab) => tab.name.value === value) : null;
					if (newTab) scrollToTabEl(newTab.rootRef.value);
				}
			});
			else {
				watchRoute();
				if (tabData.routeData.hasRouterLink.value) verifyRouteModel();
			}
		}
		function unregisterTab(tabData) {
			tabDataList.splice(tabDataList.indexOf(tabData), 1);
			tabDataListLen.value--;
			recalculateScroll();
			if (unwatchRoute !== void 0 && tabData.routeData !== void 0) {
				if (tabDataList.every((tab) => tab.routeData === void 0)) unwatchRoute();
				verifyRouteModel();
			}
		}
		const $tabs = {
			currentModel,
			tabProps,
			hasFocus,
			hasActiveTab,
			registerTab,
			unregisterTab,
			verifyRouteModel,
			updateModel,
			onKbdNavigate,
			avoidRouteWatcher: false
		};
		provide(tabsKey, $tabs);
		function cleanup() {
			if (animateTimer !== null) clearTimeout(animateTimer);
			stopAnimScroll();
			unwatchRoute?.();
		}
		let hadRouteWatcher = false, hadActivated = false;
		onBeforeUnmount(cleanup);
		onDeactivated(() => {
			hadRouteWatcher = unwatchRoute !== void 0;
			cleanup();
		});
		onActivated(() => {
			if (hadRouteWatcher) {
				watchRoute();
				hadActivated = true;
				verifyRouteModel();
			}
			recalculateScroll();
		});
		return () => h("div", {
			ref: rootRef,
			class: classes.value,
			role: "tablist",
			"aria-orientation": props.vertical ? "vertical" : "horizontal",
			onFocusin,
			onFocusout
		}, [
			h(QResizeObserver_default, { onResize: updateContainer }),
			h("div", {
				ref: contentRef,
				class: innerClass.value,
				onScroll: updateArrows
			}, hSlot(slots.default)),
			h(QIcon_default, {
				class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (leftArrow.value ? "" : " q-tabs__arrow--faded"),
				name: props.leftIcon || $q.iconSet.tabs[props.vertical ? "up" : "left"],
				onMousedownPassive: scrollToStart,
				onTouchstartPassive: scrollToStart,
				onMouseupPassive: stopAnimScroll,
				onMouseleavePassive: stopAnimScroll,
				onTouchendPassive: stopAnimScroll
			}),
			h(QIcon_default, {
				class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (rightArrow.value ? "" : " q-tabs__arrow--faded"),
				name: props.rightIcon || $q.iconSet.tabs[props.vertical ? "down" : "right"],
				onMousedownPassive: scrollToEnd,
				onTouchstartPassive: scrollToEnd,
				onMouseupPassive: stopAnimScroll,
				onMouseleavePassive: stopAnimScroll,
				onTouchendPassive: stopAnimScroll
			})
		]);
	}
});
var id$1 = 0;
var useTabEmits = ["click", "keydown"];
var useTabProps = {
	icon: String,
	label: [Number, String],
	alert: [Boolean, String],
	alertIcon: String,
	name: {
		type: [Number, String],
		default: () => `t_${id$1++}`
	},
	noCaps: Boolean,
	tabindex: [String, Number],
	disable: Boolean,
	contentClass: String,
	ripple: {
		type: [Boolean, Object],
		default: true
	}
};
function useTab(props, slots, emit, routeData) {
	const $tabs = inject(tabsKey, emptyRenderFn);
	if ($tabs === emptyRenderFn) {
		console.error("QTab/QRouteTab component needs to be child of QTabs");
		return emptyRenderFn;
	}
	const { proxy } = getCurrentInstance();
	const blurTargetRef = ref(null);
	const rootRef = ref(null);
	const tabIndicatorRef = ref(null);
	const ripple = computed(() => props.disable || props.ripple === false ? false : {
		keyCodes: [13, 32],
		early: true,
		...props.ripple === true ? {} : props.ripple
	});
	const isActive = computed(() => $tabs.currentModel.value === props.name);
	const classes = computed(() => "q-tab relative-position self-stretch flex flex-center text-center" + (isActive.value ? " q-tab--active" + ($tabs.tabProps.value.activeClass ? " " + $tabs.tabProps.value.activeClass : "") + ($tabs.tabProps.value.activeColor ? ` text-${$tabs.tabProps.value.activeColor}` : "") + ($tabs.tabProps.value.activeBgColor ? ` bg-${$tabs.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (props.icon && props.label && !$tabs.tabProps.value.inlineLabel ? " q-tab--full" : "") + (props.noCaps || $tabs.tabProps.value.noCaps ? " q-tab--no-caps" : "") + (props.disable ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (routeData !== void 0 ? routeData.linkClass.value : ""));
	const innerClass = computed(() => "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + ($tabs.tabProps.value.inlineLabel ? "row no-wrap q-tab__content--inline" : "column") + (props.contentClass !== void 0 ? ` ${props.contentClass}` : ""));
	const tabIndex = computed(() => props.disable || $tabs.hasFocus.value || !isActive.value && $tabs.hasActiveTab.value ? -1 : props.tabindex || 0);
	function onClick(e, keyboard) {
		if (!keyboard && !e?.qAvoidFocus) blurTargetRef.value?.focus({ preventScroll: true });
		if (props.disable) {
			if (routeData?.hasRouterLink.value === true) stopAndPrevent(e);
			return;
		}
		if (routeData === void 0) {
			$tabs.updateModel({ name: props.name });
			emit("click", e);
			return;
		}
		if (routeData.hasRouterLink.value) {
			const go = (opts = {}) => {
				let hardError;
				const reqId = opts.to === void 0 || isDeepEqual(opts.to, props.to) ? $tabs.avoidRouteWatcher = uid_default() : null;
				return routeData.navigateToRouterLink(e, {
					...opts,
					returnRouterError: true
				}).catch((err) => {
					hardError = err;
				}).then((softError) => {
					if (reqId === $tabs.avoidRouteWatcher) {
						$tabs.avoidRouteWatcher = false;
						if (hardError === void 0 && (softError === void 0 || softError.message?.startsWith("Avoided redundant navigation") === true)) $tabs.updateModel({ name: props.name });
					}
					if (opts.returnRouterError) return hardError !== void 0 ? Promise.reject(hardError) : softError;
				});
			};
			emit("click", e, go);
			if (!e.defaultPrevented) go();
			return;
		}
		emit("click", e);
	}
	function onKeydown(e) {
		if (isKeyCode(e, [13, 32])) onClick(e, true);
		else if (!shouldIgnoreKey(e) && e.keyCode >= 35 && e.keyCode <= 40 && !e.altKey && !e.metaKey && $tabs.onKbdNavigate(e.keyCode, proxy.$el)) stopAndPrevent(e);
		emit("keydown", e);
	}
	function getContent() {
		const narrow = $tabs.tabProps.value.narrowIndicator, content = [], indicator = h("div", {
			ref: tabIndicatorRef,
			class: ["q-tab__indicator", $tabs.tabProps.value.indicatorClass]
		});
		if (props.icon !== void 0) content.push(h(QIcon_default, {
			class: "q-tab__icon",
			name: props.icon
		}));
		if (props.label !== void 0) content.push(h("div", { class: "q-tab__label" }, props.label));
		if (props.alert) content.push(props.alertIcon !== void 0 ? h(QIcon_default, {
			class: "q-tab__alert-icon",
			color: props.alert !== true ? props.alert : void 0,
			name: props.alertIcon
		}) : h("div", { class: "q-tab__alert" + (props.alert !== true ? ` text-${props.alert}` : "") }));
		if (narrow) content.push(indicator);
		const node = [h("div", {
			class: "q-focus-helper",
			tabindex: -1,
			ref: blurTargetRef
		}), h("div", { class: innerClass.value }, hMergeSlot(slots.default, content))];
		if (!narrow) node.push(indicator);
		return node;
	}
	const tabData = {
		name: computed(() => props.name),
		rootRef,
		tabIndicatorRef,
		routeData
	};
	onBeforeUnmount(() => {
		$tabs.unregisterTab(tabData);
	});
	onMounted(() => {
		$tabs.registerTab(tabData);
	});
	function renderTab(tag, customData) {
		return withDirectives(h(tag, {
			ref: rootRef,
			class: classes.value,
			tabindex: tabIndex.value,
			role: "tab",
			"aria-selected": isActive.value ? "true" : "false",
			"aria-disabled": props.disable ? "true" : void 0,
			onClick,
			onKeydown,
			...customData
		}, getContent()), [[Ripple_default, ripple.value]]);
	}
	return {
		renderTab,
		$tabs
	};
}
var QTab_default = /*#__PURE__*/ createComponent({
	name: "QTab",
	props: useTabProps,
	emits: useTabEmits,
	setup(props, { slots, emit }) {
		const { renderTab } = useTab(props, slots, emit);
		return () => renderTab("div");
	}
});
var QTabPanels_default = /*#__PURE__*/ createComponent({
	name: "QTabPanels",
	props: {
		...usePanelProps,
		...useDarkProps
	},
	emits: usePanelEmits,
	setup(props, { slots }) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const { updatePanelsList, getPanelContent, panelDirectives } = usePanel();
		const classes = computed(() => "q-tab-panels q-panel-parent" + (isDark.value ? " q-tab-panels--dark q-dark" : ""));
		return () => {
			updatePanelsList(slots);
			return hDir("div", { class: classes.value }, getPanelContent(), "pan", props.swipeable, () => panelDirectives.value);
		};
	}
});
var QTabPanel_default = /*#__PURE__*/ createComponent({
	name: "QTabPanel",
	props: usePanelChildProps,
	setup(_, { slots }) {
		return () => h("div", {
			class: "q-tab-panel",
			role: "tabpanel"
		}, hSlot(slots.default));
	}
});
var hexRE$1 = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
var hexaRE = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/;
var hexOrHexaRE = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
var rgbRE$1 = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/;
var rgbaRE$1 = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0(\.[\d]+)?|1(\.0+)?)\)$/;
var dateRE = /^-?[\d]+\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/;
var timeRE = /^([0-1]?\d|2[0-3]):[0-5]\d$/;
var fulltimeRE = /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/;
var timeOrFulltimeRE = /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;
var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var testPattern = {
	date: (v) => dateRE.test(v),
	time: (v) => timeRE.test(v),
	fulltime: (v) => fulltimeRE.test(v),
	timeOrFulltime: (v) => timeOrFulltimeRE.test(v),
	email: (v) => emailRE.test(v),
	hexColor: (v) => hexRE$1.test(v),
	hexaColor: (v) => hexaRE.test(v),
	hexOrHexaColor: (v) => hexOrHexaRE.test(v),
	rgbColor: (v) => rgbRE$1.test(v),
	rgbaColor: (v) => rgbaRE$1.test(v),
	rgbOrRgbaColor: (v) => rgbRE$1.test(v) || rgbaRE$1.test(v),
	hexOrRgbColor: (v) => hexRE$1.test(v) || rgbRE$1.test(v),
	hexaOrRgbaColor: (v) => hexaRE.test(v) || rgbaRE$1.test(v),
	anyColor: (v) => hexOrHexaRE.test(v) || rgbRE$1.test(v) || rgbaRE$1.test(v)
};
var reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex({ r, g, b, a }) {
	const alpha = a !== void 0;
	r = Math.round(r);
	g = Math.round(g);
	b = Math.round(b);
	if (r > 255 || g > 255 || b > 255 || alpha && a > 100) throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
	a = alpha ? (Math.round(255 * a / 100) | 256).toString(16).slice(1) : "";
	return "#" + (b | g << 8 | r << 16 | 1 << 24).toString(16).slice(1) + a;
}
function rgbToString({ r, g, b, a }) {
	return `rgb${a !== void 0 ? "a" : ""}(${r},${g},${b}${a !== void 0 ? "," + a / 100 : ""})`;
}
function hexToRgb(hex) {
	if (typeof hex !== "string") throw new TypeError("Expected a string");
	hex = hex.replace(/^#/, "");
	if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	else if (hex.length === 4) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
	const num = Number.parseInt(hex, 16);
	return hex.length > 6 ? {
		r: num >> 24 & 255,
		g: num >> 16 & 255,
		b: num >> 8 & 255,
		a: Math.round((num & 255) / 2.55)
	} : {
		r: num >> 16,
		g: num >> 8 & 255,
		b: num & 255
	};
}
function hsvToRgb({ h, s, v, a }) {
	let r, g, b;
	s = s / 100;
	v = v / 100;
	h = h / 360;
	const i = Math.floor(h * 6), f = h * 6 - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
	switch (i % 6) {
		case 0:
			r = v;
			g = t;
			b = p;
			break;
		case 1:
			r = q;
			g = v;
			b = p;
			break;
		case 2:
			r = p;
			g = v;
			b = t;
			break;
		case 3:
			r = p;
			g = q;
			b = v;
			break;
		case 4:
			r = t;
			g = p;
			b = v;
			break;
		case 5:
			r = v;
			g = p;
			b = q;
	}
	return {
		r: Math.round(r * 255),
		g: Math.round(g * 255),
		b: Math.round(b * 255),
		a
	};
}
function rgbToHsv({ r, g, b, a }) {
	const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, s = max === 0 ? 0 : d / max, v = max / 255;
	let h;
	switch (max) {
		case min:
			h = 0;
			break;
		case r:
			h = g - b + d * (g < b ? 6 : 0);
			h /= 6 * d;
			break;
		case g:
			h = b - r + d * 2;
			h /= 6 * d;
			break;
		case b:
			h = r - g + d * 4;
			h /= 6 * d;
	}
	return {
		h: Math.round(h * 360),
		s: Math.round(s * 100),
		v: Math.round(v * 100),
		a
	};
}
function textToRgb(str) {
	if (typeof str !== "string") throw new TypeError("Expected a string");
	const color = str.replaceAll(" ", "");
	const m = reRGBA.exec(color);
	if (m === null) return hexToRgb(color);
	const rgb = {
		r: Math.min(255, Math.max(0, Number.parseInt(m[2], 10))),
		g: Math.min(255, Math.max(0, Number.parseInt(m[3], 10))),
		b: Math.min(255, Math.max(0, Number.parseInt(m[4], 10)))
	};
	if (m[1]) {
		const alpha = Number.parseFloat(m[5]);
		rgb.a = Math.round((Number.isFinite(alpha) ? Math.max(0, Math.min(1, alpha)) : 1) * 100);
	}
	return rgb;
}
function lighten$2(color, percent) {
	if (typeof color !== "string") throw new TypeError("Expected a string as color");
	if (typeof percent !== "number") throw new TypeError("Expected a numeric percent");
	const rgb = textToRgb(color), t = percent < 0 ? 0 : 255, p = Math.abs(percent) / 100, R = rgb.r, G = rgb.g, B = rgb.b;
	return "#" + (16777216 + (Math.round((t - R) * p) + R) * 65536 + (Math.round((t - G) * p) + G) * 256 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}
function luminosity$1(color) {
	if (typeof color !== "string" && (!color || color.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
	const rgb = typeof color === "string" ? textToRgb(color) : color, r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255, R = r <= .03928 ? r / 12.92 : ((r + .055) / 1.055) ** 2.4, G = g <= .03928 ? g / 12.92 : ((g + .055) / 1.055) ** 2.4, B = b <= .03928 ? b / 12.92 : ((b + .055) / 1.055) ** 2.4;
	return .2126 * R + .7152 * G + .0722 * B;
}
function brightness(color) {
	if (typeof color !== "string" && (!color || color.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
	const rgb = typeof color === "string" ? textToRgb(color) : color;
	return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
}
function blend(fgColor, bgColor) {
	if (typeof fgColor !== "string" && (!fgColor || fgColor.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
	if (typeof bgColor !== "string" && (!bgColor || bgColor.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
	const rgb1 = typeof fgColor === "string" ? textToRgb(fgColor) : fgColor, r1 = rgb1.r / 255, g1 = rgb1.g / 255, b1 = rgb1.b / 255, a1 = rgb1.a !== void 0 ? rgb1.a / 100 : 1, rgb2 = typeof bgColor === "string" ? textToRgb(bgColor) : bgColor, r2 = rgb2.r / 255, g2 = rgb2.g / 255, b2 = rgb2.b / 255, a2 = rgb2.a !== void 0 ? rgb2.a / 100 : 1, a = a1 + a2 * (1 - a1);
	const ret = {
		r: Math.round((r1 * a1 + r2 * a2 * (1 - a1)) / a * 255),
		g: Math.round((g1 * a1 + g2 * a2 * (1 - a1)) / a * 255),
		b: Math.round((b1 * a1 + b2 * a2 * (1 - a1)) / a * 255),
		a: Math.round(a * 100)
	};
	return typeof fgColor === "string" ? rgbToHex(ret) : ret;
}
function changeAlpha(color, offset) {
	if (typeof color !== "string") throw new TypeError("Expected a string as color");
	if (offset === void 0 || offset < -1 || offset > 1) throw new TypeError("Expected offset to be between -1 and 1");
	const { r, g, b, a } = textToRgb(color);
	const alpha = a !== void 0 ? a / 100 : 0;
	return rgbToHex({
		r,
		g,
		b,
		a: Math.round(Math.min(1, Math.max(0, alpha + offset)) * 100)
	});
}
function getPaletteColor$1(colorName) {
	if (typeof colorName !== "string") throw new TypeError("Expected a string as color");
	const el = document.createElement("div");
	el.className = `text-${colorName} invisible fixed no-pointer-events`;
	document.body.append(el);
	const result = getComputedStyle(el).getPropertyValue("color");
	el.remove();
	return rgbToHex(textToRgb(result));
}
var colors_default = {
	rgbToHex,
	hexToRgb,
	hsvToRgb,
	rgbToHsv,
	textToRgb,
	lighten: lighten$2,
	luminosity: luminosity$1,
	brightness,
	blend,
	changeAlpha,
	getPaletteColor: getPaletteColor$1
};
var palette = [
	"rgb(255,204,204)",
	"rgb(255,230,204)",
	"rgb(255,255,204)",
	"rgb(204,255,204)",
	"rgb(204,255,230)",
	"rgb(204,255,255)",
	"rgb(204,230,255)",
	"rgb(204,204,255)",
	"rgb(230,204,255)",
	"rgb(255,204,255)",
	"rgb(255,153,153)",
	"rgb(255,204,153)",
	"rgb(255,255,153)",
	"rgb(153,255,153)",
	"rgb(153,255,204)",
	"rgb(153,255,255)",
	"rgb(153,204,255)",
	"rgb(153,153,255)",
	"rgb(204,153,255)",
	"rgb(255,153,255)",
	"rgb(255,102,102)",
	"rgb(255,179,102)",
	"rgb(255,255,102)",
	"rgb(102,255,102)",
	"rgb(102,255,179)",
	"rgb(102,255,255)",
	"rgb(102,179,255)",
	"rgb(102,102,255)",
	"rgb(179,102,255)",
	"rgb(255,102,255)",
	"rgb(255,51,51)",
	"rgb(255,153,51)",
	"rgb(255,255,51)",
	"rgb(51,255,51)",
	"rgb(51,255,153)",
	"rgb(51,255,255)",
	"rgb(51,153,255)",
	"rgb(51,51,255)",
	"rgb(153,51,255)",
	"rgb(255,51,255)",
	"rgb(255,0,0)",
	"rgb(255,128,0)",
	"rgb(255,255,0)",
	"rgb(0,255,0)",
	"rgb(0,255,128)",
	"rgb(0,255,255)",
	"rgb(0,128,255)",
	"rgb(0,0,255)",
	"rgb(128,0,255)",
	"rgb(255,0,255)",
	"rgb(245,0,0)",
	"rgb(245,123,0)",
	"rgb(245,245,0)",
	"rgb(0,245,0)",
	"rgb(0,245,123)",
	"rgb(0,245,245)",
	"rgb(0,123,245)",
	"rgb(0,0,245)",
	"rgb(123,0,245)",
	"rgb(245,0,245)",
	"rgb(214,0,0)",
	"rgb(214,108,0)",
	"rgb(214,214,0)",
	"rgb(0,214,0)",
	"rgb(0,214,108)",
	"rgb(0,214,214)",
	"rgb(0,108,214)",
	"rgb(0,0,214)",
	"rgb(108,0,214)",
	"rgb(214,0,214)",
	"rgb(163,0,0)",
	"rgb(163,82,0)",
	"rgb(163,163,0)",
	"rgb(0,163,0)",
	"rgb(0,163,82)",
	"rgb(0,163,163)",
	"rgb(0,82,163)",
	"rgb(0,0,163)",
	"rgb(82,0,163)",
	"rgb(163,0,163)",
	"rgb(92,0,0)",
	"rgb(92,46,0)",
	"rgb(92,92,0)",
	"rgb(0,92,0)",
	"rgb(0,92,46)",
	"rgb(0,92,92)",
	"rgb(0,46,92)",
	"rgb(0,0,92)",
	"rgb(46,0,92)",
	"rgb(92,0,92)",
	"rgb(255,255,255)",
	"rgb(205,205,205)",
	"rgb(178,178,178)",
	"rgb(153,153,153)",
	"rgb(127,127,127)",
	"rgb(102,102,102)",
	"rgb(76,76,76)",
	"rgb(51,51,51)",
	"rgb(25,25,25)",
	"rgb(0,0,0)"
];
var thumbPath = "M5 5 h10 v10 h-10 v-10 z";
var alphaTrackImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
var numericRE = /^[0-9]+$/;
var hexRE = /^#[0-9A-Fa-f]+$/;
var rgbRE = /^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/;
var rgbaRE = /^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
var QColor_default = /*#__PURE__*/ createComponent({
	name: "QColor",
	props: {
		...useDarkProps,
		...useFormProps,
		modelValue: String,
		defaultValue: String,
		defaultView: {
			type: String,
			default: "spectrum",
			validator: (v) => [
				"spectrum",
				"tune",
				"palette"
			].includes(v)
		},
		formatModel: {
			type: String,
			default: "auto",
			validator: (v) => [
				"auto",
				"hex",
				"rgb",
				"hexa",
				"rgba"
			].includes(v)
		},
		palette: Array,
		noHeader: Boolean,
		noHeaderTabs: Boolean,
		noFooter: Boolean,
		square: Boolean,
		flat: Boolean,
		bordered: Boolean,
		disable: Boolean,
		readonly: Boolean
	},
	emits: ["update:modelValue", "change"],
	setup(props, { emit }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const isDark = useDark(props, $q);
		const { getCache } = useRenderCache();
		const spectrumRef = ref(null);
		const errorIconRef = ref(null);
		const forceHex = computed(() => props.formatModel === "auto" ? null : props.formatModel.includes("hex"));
		const forceAlpha = computed(() => props.formatModel === "auto" ? null : props.formatModel.includes("a"));
		const topView = ref(props.formatModel === "auto" ? props.modelValue === void 0 || props.modelValue === null || props.modelValue === "" || props.modelValue.startsWith("#") ? "hex" : "rgb" : props.formatModel.startsWith("hex") ? "hex" : "rgb");
		const view = ref(props.defaultView);
		const model = ref(parseModel(props.modelValue || props.defaultValue));
		const editable = computed(() => !props.disable && !props.readonly);
		const isHex = computed(() => props.modelValue === void 0 || props.modelValue === null || props.modelValue === "" || props.modelValue.startsWith("#"));
		const isOutputHex = computed(() => forceHex.value !== null ? forceHex.value : isHex.value);
		const injectFormInput = useFormInject(computed(() => ({
			type: "hidden",
			name: props.name,
			value: model.value[isOutputHex.value ? "hex" : "rgb"]
		})));
		const hasAlpha = computed(() => forceAlpha.value !== null ? forceAlpha.value : model.value.a !== void 0);
		const currentBgColor = computed(() => ({ backgroundColor: model.value.rgb || "#000" }));
		const headerClass = computed(() => {
			return `q-color-picker__header-content q-color-picker__header-content--${(model.value.a !== void 0 && model.value.a < 65 ? true : luminosity$1(model.value) > .4) ? "light" : "dark"}`;
		});
		const spectrumStyle = computed(() => ({ background: `hsl(${model.value.h},100%,50%)` }));
		const spectrumPointerStyle = computed(() => ({
			top: `${100 - model.value.v}%`,
			[$q.lang.rtl ? "right" : "left"]: `${model.value.s}%`
		}));
		const computedPalette = computed(() => props.palette !== void 0 && props.palette.length !== 0 ? props.palette : palette);
		const classes = computed(() => "q-color-picker" + (props.bordered ? " q-color-picker--bordered" : "") + (props.square ? " q-color-picker--square no-border-radius" : "") + (props.flat ? " q-color-picker--flat no-shadow" : "") + (props.disable ? " disabled" : "") + (isDark.value ? " q-color-picker--dark q-dark" : ""));
		const attributes = computed(() => props.disable ? { "aria-disabled": "true" } : {});
		const spectrumDirective = computed(() => [[
			TouchPan_default,
			onSpectrumPan,
			void 0,
			{
				prevent: true,
				stop: true,
				mouse: true
			}
		]]);
		watch(() => props.modelValue, (v) => {
			const localModel = parseModel(v || props.defaultValue);
			if (localModel.hex !== model.value.hex) model.value = localModel;
		});
		watch(() => props.defaultValue, (v) => {
			if (!props.modelValue && v) {
				const localModel = parseModel(v);
				if (localModel.hex !== model.value.hex) model.value = localModel;
			}
		});
		function updateModel(rgb, change) {
			model.value.hex = rgbToHex(rgb);
			model.value.rgb = rgbToString(rgb);
			model.value.r = rgb.r;
			model.value.g = rgb.g;
			model.value.b = rgb.b;
			model.value.a = rgb.a;
			const value = model.value[isOutputHex.value ? "hex" : "rgb"];
			emit("update:modelValue", value);
			if (change) emit("change", value);
		}
		function parseModel(v) {
			const alpha = forceAlpha.value !== void 0 ? forceAlpha.value : props.formatModel === "auto" ? null : props.formatModel.includes("a");
			if (typeof v !== "string" || v.length === 0 || !testPattern.anyColor(v.replaceAll(" ", ""))) return {
				h: 0,
				s: 0,
				v: 0,
				r: 0,
				g: 0,
				b: 0,
				a: alpha ? 100 : void 0,
				hex: void 0,
				rgb: void 0
			};
			const localModel = textToRgb(v);
			if (alpha && localModel.a === void 0) localModel.a = 100;
			localModel.hex = rgbToHex(localModel);
			localModel.rgb = rgbToString(localModel);
			return Object.assign(localModel, rgbToHsv(localModel));
		}
		function changeSpectrum(left, top, change) {
			const panel = spectrumRef.value;
			if (panel === null) return;
			const width = panel.clientWidth, height = panel.clientHeight, rect = panel.getBoundingClientRect();
			let x = Math.min(width, Math.max(0, left - rect.left));
			if ($q.lang.rtl) x = width - x;
			const y = Math.min(height, Math.max(0, top - rect.top)), s = Math.round(100 * x / width), v = Math.round(100 * Math.max(0, Math.min(1, -(y / height) + 1))), rgb = hsvToRgb({
				h: model.value.h,
				s,
				v,
				a: hasAlpha.value ? model.value.a : void 0
			});
			model.value.s = s;
			model.value.v = v;
			updateModel(rgb, change);
		}
		function onHue(val, change) {
			const hue = Math.round(val);
			const rgb = hsvToRgb({
				h: hue,
				s: model.value.s,
				v: model.value.v,
				a: hasAlpha.value ? model.value.a : void 0
			});
			model.value.h = hue;
			updateModel(rgb, change);
		}
		function onHueChange(val) {
			onHue(val, true);
		}
		function onNumericChange(value, formatModel, max, evt, change) {
			if (evt !== void 0) stop(evt);
			if (!numericRE.test(value)) {
				if (change) proxy.$forceUpdate();
				return;
			}
			const val = Math.floor(Number(value));
			if (val < 0 || val > max) {
				if (change) proxy.$forceUpdate();
				return;
			}
			const rgb = {
				r: formatModel === "r" ? val : model.value.r,
				g: formatModel === "g" ? val : model.value.g,
				b: formatModel === "b" ? val : model.value.b,
				a: hasAlpha.value ? formatModel === "a" ? val : model.value.a : void 0
			};
			if (formatModel !== "a") {
				const hsv = rgbToHsv(rgb);
				model.value.h = hsv.h;
				model.value.s = hsv.s;
				model.value.v = hsv.v;
			}
			updateModel(rgb, change);
			if (!change && evt?.target.selectionEnd !== void 0) {
				const index = evt.target.selectionEnd;
				nextTick(() => {
					evt.target.setSelectionRange(index, index);
				});
			}
		}
		function onEditorChange(evt, change) {
			let rgb;
			const inp = evt.target.value;
			stop(evt);
			if (topView.value === "hex") {
				if (inp.length !== (hasAlpha.value ? 9 : 7) || !hexRE.test(inp)) return true;
				rgb = hexToRgb(inp);
			} else {
				let localModel;
				if (!inp.endsWith(")")) return true;
				else if (!hasAlpha.value && inp.startsWith("rgb(")) {
					localModel = inp.slice(4, -1).split(",").map((n) => Number.parseInt(n, 10));
					if (localModel.length !== 3 || !rgbRE.test(inp)) return true;
				} else if (hasAlpha.value && inp.startsWith("rgba(")) {
					localModel = inp.slice(5, -1).split(",");
					if (localModel.length !== 4 || !rgbaRE.test(inp)) return true;
					for (let i = 0; i < 3; i++) {
						const v = Number.parseInt(localModel[i], 10);
						if (v < 0 || v > 255) return true;
						localModel[i] = v;
					}
					const v = Number.parseFloat(localModel[3]);
					if (v < 0 || v > 1) return true;
					localModel[3] = v;
				} else return true;
				if (localModel[0] < 0 || localModel[0] > 255 || localModel[1] < 0 || localModel[1] > 255 || localModel[2] < 0 || localModel[2] > 255 || hasAlpha.value && (localModel[3] < 0 || localModel[3] > 1)) return true;
				rgb = {
					r: localModel[0],
					g: localModel[1],
					b: localModel[2],
					a: hasAlpha.value ? localModel[3] * 100 : void 0
				};
			}
			const hsv = rgbToHsv(rgb);
			model.value.h = hsv.h;
			model.value.s = hsv.s;
			model.value.v = hsv.v;
			updateModel(rgb, change);
			if (!change) {
				const index = evt.target.selectionEnd;
				nextTick(() => {
					evt.target.setSelectionRange(index, index);
				});
			}
		}
		function onPalettePick(color) {
			const def = parseModel(color);
			const rgb = {
				r: def.r,
				g: def.g,
				b: def.b,
				a: def.a
			};
			if (rgb.a === void 0) rgb.a = model.value.a;
			model.value.h = def.h;
			model.value.s = def.s;
			model.value.v = def.v;
			updateModel(rgb, true);
		}
		function onSpectrumPan(evt) {
			if (evt.isFinal) changeSpectrum(evt.position.left, evt.position.top, true);
			else onSpectrumChange(evt);
		}
		const onSpectrumChange = throttle$1((evt) => {
			changeSpectrum(evt.position.left, evt.position.top);
		}, 20);
		function onSpectrumClick(evt) {
			changeSpectrum(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset, true);
		}
		function onActivate(evt) {
			changeSpectrum(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset);
		}
		function updateErrorIcon(val) {
			if (errorIconRef.value !== null) errorIconRef.value.$el.style.opacity = val ? 1 : 0;
		}
		function setTopView(val) {
			topView.value = val;
		}
		function getHeader() {
			const child = [];
			if (!props.noHeaderTabs) child.push(h(QTabs_default, {
				class: "q-color-picker__header-tabs",
				modelValue: topView.value,
				dense: true,
				align: "justify",
				"onUpdate:modelValue": setTopView
			}, () => [h(QTab_default, {
				label: "HEX" + (hasAlpha.value ? "A" : ""),
				name: "hex",
				ripple: false
			}), h(QTab_default, {
				label: "RGB" + (hasAlpha.value ? "A" : ""),
				name: "rgb",
				ripple: false
			})]));
			child.push(h("div", { class: "q-color-picker__header-banner row flex-center no-wrap" }, [h("input", {
				class: "fit",
				value: model.value[topView.value],
				...editable.value ? {} : { readonly: true },
				...getCache("topIn", {
					onInput: (evt) => {
						updateErrorIcon(onEditorChange(evt));
					},
					onChange: stop,
					onBlur: (evt) => {
						if (onEditorChange(evt, true)) proxy.$forceUpdate();
						updateErrorIcon(false);
					}
				})
			}), h(QIcon_default, {
				ref: errorIconRef,
				class: "q-color-picker__error-icon absolute no-pointer-events",
				name: $q.iconSet.type.negative
			})]));
			return h("div", { class: "q-color-picker__header relative-position overflow-hidden" }, [h("div", { class: "q-color-picker__header-bg absolute-full" }), h("div", {
				class: headerClass.value,
				style: currentBgColor.value
			}, child)]);
		}
		function getContent() {
			return h(QTabPanels_default, {
				modelValue: view.value,
				animated: true
			}, () => [
				h(QTabPanel_default, {
					class: "q-color-picker__spectrum-tab overflow-hidden",
					name: "spectrum"
				}, getSpectrumTab),
				h(QTabPanel_default, {
					class: "q-pa-md q-color-picker__tune-tab",
					name: "tune"
				}, getTuneTab),
				h(QTabPanel_default, {
					class: "q-color-picker__palette-tab",
					name: "palette"
				}, getPaletteTab)
			]);
		}
		function setView(val) {
			view.value = val;
		}
		function getFooter() {
			return h("div", { class: "q-color-picker__footer relative-position overflow-hidden" }, [h(QTabs_default, {
				class: "absolute-full",
				modelValue: view.value,
				dense: true,
				align: "justify",
				"onUpdate:modelValue": setView
			}, () => [
				h(QTab_default, {
					icon: $q.iconSet.colorPicker.spectrum,
					name: "spectrum",
					ripple: false
				}),
				h(QTab_default, {
					icon: $q.iconSet.colorPicker.tune,
					name: "tune",
					ripple: false
				}),
				h(QTab_default, {
					icon: $q.iconSet.colorPicker.palette,
					name: "palette",
					ripple: false
				})
			])]);
		}
		function getSpectrumTab() {
			const data = {
				ref: spectrumRef,
				class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (editable.value ? "" : " readonly"),
				style: spectrumStyle.value,
				...editable.value ? {
					onClick: onSpectrumClick,
					onMousedown: onActivate
				} : {}
			};
			const child = [
				h("div", { style: { paddingBottom: "100%" } }),
				h("div", { class: "q-color-picker__spectrum-white absolute-full" }),
				h("div", { class: "q-color-picker__spectrum-black absolute-full" }),
				h("div", {
					class: "absolute",
					style: spectrumPointerStyle.value
				}, [model.value.hex !== void 0 ? h("div", { class: "q-color-picker__spectrum-circle" }) : null])
			];
			const sliders = [h(QSlider_default, {
				class: "q-color-picker__hue non-selectable",
				modelValue: model.value.h,
				min: 0,
				max: 360,
				trackSize: "8px",
				innerTrackColor: "transparent",
				selectionColor: "transparent",
				readonly: !editable.value,
				thumbPath,
				"onUpdate:modelValue": onHue,
				onChange: onHueChange
			})];
			if (hasAlpha.value) sliders.push(h(QSlider_default, {
				class: "q-color-picker__alpha non-selectable",
				modelValue: model.value.a,
				min: 0,
				max: 100,
				trackSize: "8px",
				trackColor: "white",
				innerTrackColor: "transparent",
				selectionColor: "transparent",
				trackImg: alphaTrackImg,
				readonly: !editable.value,
				hideSelection: true,
				thumbPath,
				...getCache("alphaSlide", {
					"onUpdate:modelValue": (value) => onNumericChange(value, "a", 100),
					onChange: (value) => onNumericChange(value, "a", 100, void 0, true)
				})
			}));
			return [hDir("div", data, child, "spec", editable.value, () => spectrumDirective.value), h("div", { class: "q-color-picker__sliders" }, sliders)];
		}
		function getTuneTab() {
			return [
				h("div", { class: "row items-center no-wrap" }, [
					h("div", "R"),
					h(QSlider_default, {
						modelValue: model.value.r,
						min: 0,
						max: 255,
						color: "red",
						dark: isDark.value,
						readonly: !editable.value,
						...getCache("rSlide", {
							"onUpdate:modelValue": (value) => onNumericChange(value, "r", 255),
							onChange: (value) => onNumericChange(value, "r", 255, void 0, true)
						})
					}),
					h("input", {
						value: model.value.r,
						maxlength: 3,
						readonly: !editable.value,
						onChange: stop,
						...getCache("rIn", {
							onInput: (evt) => onNumericChange(evt.target.value, "r", 255, evt),
							onBlur: (evt) => onNumericChange(evt.target.value, "r", 255, evt, true)
						})
					})
				]),
				h("div", { class: "row items-center no-wrap" }, [
					h("div", "G"),
					h(QSlider_default, {
						modelValue: model.value.g,
						min: 0,
						max: 255,
						color: "green",
						dark: isDark.value,
						readonly: !editable.value,
						...getCache("gSlide", {
							"onUpdate:modelValue": (value) => onNumericChange(value, "g", 255),
							onChange: (value) => onNumericChange(value, "g", 255, void 0, true)
						})
					}),
					h("input", {
						value: model.value.g,
						maxlength: 3,
						readonly: !editable.value,
						onChange: stop,
						...getCache("gIn", {
							onInput: (evt) => onNumericChange(evt.target.value, "g", 255, evt),
							onBlur: (evt) => onNumericChange(evt.target.value, "g", 255, evt, true)
						})
					})
				]),
				h("div", { class: "row items-center no-wrap" }, [
					h("div", "B"),
					h(QSlider_default, {
						modelValue: model.value.b,
						min: 0,
						max: 255,
						color: "blue",
						readonly: !editable.value,
						dark: isDark.value,
						...getCache("bSlide", {
							"onUpdate:modelValue": (value) => onNumericChange(value, "b", 255),
							onChange: (value) => onNumericChange(value, "b", 255, void 0, true)
						})
					}),
					h("input", {
						value: model.value.b,
						maxlength: 3,
						readonly: !editable.value,
						onChange: stop,
						...getCache("bIn", {
							onInput: (evt) => onNumericChange(evt.target.value, "b", 255, evt),
							onBlur: (evt) => onNumericChange(evt.target.value, "b", 255, evt, true)
						})
					})
				]),
				hasAlpha.value ? h("div", { class: "row items-center no-wrap" }, [
					h("div", "A"),
					h(QSlider_default, {
						modelValue: model.value.a,
						color: "grey",
						readonly: !editable.value,
						dark: isDark.value,
						...getCache("aSlide", {
							"onUpdate:modelValue": (value) => onNumericChange(value, "a", 100),
							onChange: (value) => onNumericChange(value, "a", 100, void 0, true)
						})
					}),
					h("input", {
						value: model.value.a,
						maxlength: 3,
						readonly: !editable.value,
						onChange: stop,
						...getCache("aIn", {
							onInput: (evt) => onNumericChange(evt.target.value, "a", 100, evt),
							onBlur: (evt) => onNumericChange(evt.target.value, "a", 100, evt, true)
						})
					})
				]) : null
			];
		}
		function getPaletteTab() {
			const fn = (color) => h("div", {
				class: "q-color-picker__cube col-auto",
				style: { backgroundColor: color },
				...editable.value ? getCache("palette#" + color, { onClick: () => {
					onPalettePick(color);
				} }) : {}
			});
			return [h("div", { class: "row items-center q-color-picker__palette-rows" + (editable.value ? " q-color-picker__palette-rows--editable" : "") }, computedPalette.value.map(fn))];
		}
		return () => {
			const child = [getContent()];
			if (props.name !== void 0 && !props.disable) injectFormInput(child, "push");
			if (!props.noHeader) child.unshift(getHeader());
			if (!props.noFooter) child.push(getFooter());
			return h("div", {
				class: classes.value,
				...attributes.value
			}, child);
		};
	}
});
var breaks = [
	-61,
	9,
	38,
	199,
	426,
	686,
	756,
	818,
	1111,
	1181,
	1210,
	1635,
	2060,
	2097,
	2192,
	2262,
	2324,
	2394,
	2456,
	3178
];
function toJalaali(gy, gm, gd) {
	if (Object.prototype.toString.call(gy) === "[object Date]") {
		gd = gy.getDate();
		gm = gy.getMonth() + 1;
		gy = gy.getFullYear();
	}
	return d2j(g2d(gy, gm, gd));
}
function toGregorian(jy, jm, jd) {
	return d2g(j2d(jy, jm, jd));
}
function isLeapJalaaliYear(jy) {
	return jalCalLeap(jy) === 0;
}
function jalaaliMonthLength(jy, jm) {
	if (jm <= 6) return 31;
	if (jm <= 11) return 30;
	if (isLeapJalaaliYear(jy)) return 30;
	return 29;
}
function jalCalLeap(jy) {
	const bl = breaks.length;
	let jp = breaks[0], jm, jump, leap, n, i;
	if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
	for (i = 1; i < bl; i += 1) {
		jm = breaks[i];
		jump = jm - jp;
		if (jy < jm) break;
		jp = jm;
	}
	n = jy - jp;
	if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
	leap = mod(mod(n + 1, 33) - 1, 4);
	if (leap === -1) leap = 4;
	return leap;
}
function jalCal(jy, withoutLeap) {
	const bl = breaks.length, gy = jy + 621;
	let leapJ = -14, jp = breaks[0], jm, jump, leap, n, i;
	if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
	for (i = 1; i < bl; i += 1) {
		jm = breaks[i];
		jump = jm - jp;
		if (jy < jm) break;
		leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
		jp = jm;
	}
	n = jy - jp;
	leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
	if (mod(jump, 33) === 4 && jump - n === 4) leapJ += 1;
	const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
	const march = 20 + leapJ - leapG;
	if (!withoutLeap) {
		if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
		leap = mod(mod(n + 1, 33) - 1, 4);
		if (leap === -1) leap = 4;
	}
	return {
		leap,
		gy,
		march
	};
}
function j2d(jy, jm, jd) {
	const r = jalCal(jy, true);
	return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
function d2j(jdn) {
	const gy = d2g(jdn).gy;
	let jy = gy - 621, jd, jm, k;
	const r = jalCal(jy, false);
	k = jdn - g2d(gy, 3, r.march);
	if (k >= 0) {
		if (k <= 185) {
			jm = 1 + div(k, 31);
			jd = mod(k, 31) + 1;
			return {
				jy,
				jm,
				jd
			};
		}
		k -= 186;
	} else {
		jy -= 1;
		k += 179;
		if (r.leap === 1) k += 1;
	}
	jm = 7 + div(k, 30);
	jd = mod(k, 30) + 1;
	return {
		jy,
		jm,
		jd
	};
}
function g2d(gy, gm, gd) {
	let d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
	d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
	return d;
}
function d2g(jdn) {
	let j = 4 * jdn + 139361631;
	j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
	const i = div(mod(j, 1461), 4) * 5 + 308, gd = div(mod(i, 153), 5) + 1, gm = mod(div(i, 153), 12) + 1;
	return {
		gy: div(j, 1461) - 100100 + div(8 - gm, 6),
		gm,
		gd
	};
}
function div(a, b) {
	return Math.trunc(a / b);
}
function mod(a, b) {
	return a - Math.trunc(a / b) * b;
}
var calendars = ["gregorian", "persian"];
var useDatetimeProps = {
	mask: { type: String },
	locale: Object,
	calendar: {
		type: String,
		validator: (v) => calendars.includes(v),
		default: "gregorian"
	},
	landscape: Boolean,
	color: String,
	textColor: String,
	square: Boolean,
	flat: Boolean,
	bordered: Boolean,
	readonly: Boolean,
	disable: Boolean
};
var useDatetimeEmits = ["update:modelValue"];
function getDayHash(date) {
	return date.year + "/" + pad(date.month) + "/" + pad(date.day);
}
function useDatetime(props, $q) {
	const editable = computed(() => !props.disable && !props.readonly);
	const tabindex = computed(() => editable.value ? 0 : -1);
	const headerClass = computed(() => {
		const cls = [];
		if (props.color !== void 0) cls.push(`bg-${props.color}`);
		if (props.textColor !== void 0) cls.push(`text-${props.textColor}`);
		return cls.join(" ");
	});
	function getLocale() {
		return props.locale !== void 0 ? {
			...$q.lang.date,
			...props.locale
		} : $q.lang.date;
	}
	function getCurrentDate(dateOnly) {
		const d = /* @__PURE__ */ new Date();
		const timeFill = dateOnly ? null : 0;
		if (props.calendar === "persian") {
			const jDate = toJalaali(d);
			return {
				year: jDate.jy,
				month: jDate.jm,
				day: jDate.jd
			};
		}
		return {
			year: d.getFullYear(),
			month: d.getMonth() + 1,
			day: d.getDate(),
			hour: timeFill,
			minute: timeFill,
			second: timeFill,
			millisecond: timeFill
		};
	}
	return {
		editable,
		tabindex,
		headerClass,
		getLocale,
		getCurrentDate
	};
}
var MILLISECONDS_IN_DAY = 864e5;
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var defaultMask = "YYYY-MM-DDTHH:mm:ss.SSSZ";
var token = /\[((?:[^\]\\]|\\]|\\)*)\]|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g;
var reverseToken = /(\[[^\]]*\])|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g;
var escapeRegexRE = /[.*+?^${}()|[\]\\]/g;
var regexStore = /* @__PURE__ */ new Map();
function escapeRegex(str) {
	return str.replaceAll(escapeRegexRE, String.raw`\$&`);
}
function getRegexData(mask, dateLocale) {
	const days = "(" + dateLocale.days.map(escapeRegex).join("|") + ")", daysShort = "(" + dateLocale.daysShort.map(escapeRegex).join("|") + ")", months = "(" + dateLocale.months.map(escapeRegex).join("|") + ")", monthsShort = "(" + dateLocale.monthsShort.map(escapeRegex).join("|") + ")";
	const key = [
		mask,
		days,
		daysShort,
		months,
		monthsShort
	].join("|");
	if (regexStore.has(key)) return regexStore.get(key);
	const map = {};
	let index = 0;
	const regexText = mask.replace(reverseToken, (match) => {
		index++;
		switch (match) {
			case "YY":
				map.YY = index;
				return String.raw`(-?\d{1,2})`;
			case "YYYY":
				map.YYYY = index;
				return String.raw`(-?\d{1,4})`;
			case "M":
				map.M = index;
				return String.raw`(\d{1,2})`;
			case "Mo":
				map.M = index++;
				return String.raw`(\d{1,2}(st|nd|rd|th))`;
			case "MM":
				map.M = index;
				return String.raw`(\d{2})`;
			case "MMM":
				map.MMM = index;
				return monthsShort;
			case "MMMM":
				map.MMMM = index;
				return months;
			case "D":
				map.D = index;
				return String.raw`(\d{1,2})`;
			case "Do":
				map.D = index++;
				return String.raw`(\d{1,2}(st|nd|rd|th))`;
			case "DD":
				map.D = index;
				return String.raw`(\d{2})`;
			case "H":
				map.H = index;
				return String.raw`(\d{1,2})`;
			case "HH":
				map.H = index;
				return String.raw`(\d{2})`;
			case "h":
				map.h = index;
				return String.raw`(\d{1,2})`;
			case "hh":
				map.h = index;
				return String.raw`(\d{2})`;
			case "m":
				map.m = index;
				return String.raw`(\d{1,2})`;
			case "mm":
				map.m = index;
				return String.raw`(\d{2})`;
			case "s":
				map.s = index;
				return String.raw`(\d{1,2})`;
			case "ss":
				map.s = index;
				return String.raw`(\d{2})`;
			case "S":
				map.S = index;
				return String.raw`(\d{1})`;
			case "SS":
				map.S = index;
				return String.raw`(\d{2})`;
			case "SSS":
				map.S = index;
				return String.raw`(\d{3})`;
			case "A":
				map.A = index;
				return "(AM|PM)";
			case "a":
				map.a = index;
				return "(am|pm)";
			case "aa":
				map.aa = index;
				return String.raw`(a\.m\.|p\.m\.)`;
			case "ddd": return daysShort;
			case "dddd": return days;
			case "Q":
			case "d":
			case "E": return String.raw`(\d{1})`;
			case "do":
				index++;
				return String.raw`(\d{1}(st|nd|rd|th))`;
			case "Qo": return "(1st|2nd|3rd|4th)";
			case "DDD":
			case "DDDD": return String.raw`(\d{1,3})`;
			case "DDDo":
				index++;
				return String.raw`(\d{1,3}(st|nd|rd|th))`;
			case "w": return String.raw`(\d{1,2})`;
			case "wo":
				index++;
				return String.raw`(\d{1,2}(st|nd|rd|th))`;
			case "ww": return String.raw`(\d{2})`;
			case "Z":
				map.Z = index;
				return String.raw`(Z|[+-]\d{2}:\d{2})`;
			case "ZZ":
				map.ZZ = index;
				return String.raw`(Z|[+-]\d{2}\d{2})`;
			case "X":
				map.X = index;
				return String.raw`(-?\d+)`;
			case "x":
				map.x = index;
				return String.raw`(-?\d{4,})`;
			default:
				index--;
				if (match[0] === "[") match = match.slice(1, -1);
				return escapeRegex(match);
		}
	});
	const res = {
		map,
		regex: new RegExp("^" + regexText)
	};
	regexStore.set(key, res);
	return res;
}
function getDateLocale(paramDateLocale, langProps) {
	return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : en_US_default.date;
}
function formatTimezone(offset, delimeter = "") {
	const sign = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
	return sign + pad(hours) + delimeter + pad(minutes);
}
function __splitDate(str, mask, dateLocale, calendar, defaultModel) {
	const date = {
		year: null,
		month: null,
		day: null,
		hour: null,
		minute: null,
		second: null,
		millisecond: null,
		timezoneOffset: null,
		dateHash: null,
		timeHash: null
	};
	if (defaultModel !== void 0) Object.assign(date, defaultModel);
	if (str === void 0 || str === null || str === "" || typeof str !== "string") return date;
	if (mask === void 0) mask = defaultMask;
	const langOpts = getDateLocale(dateLocale, Plugin$5.props), months = langOpts.months, monthsShort = langOpts.monthsShort;
	const { regex, map } = getRegexData(mask, langOpts);
	const match = str.match(regex);
	if (match === null) return date;
	let tzString = "";
	if (map.X !== void 0 || map.x !== void 0) {
		const stamp = Number.parseInt(match[map.X ?? map.x], 10);
		if (Number.isNaN(stamp)) return date;
		const d = /* @__PURE__ */ new Date(stamp * (map.X !== void 0 ? 1e3 : 1));
		date.year = d.getFullYear();
		date.month = d.getMonth() + 1;
		date.day = d.getDate();
		date.hour = d.getHours();
		date.minute = d.getMinutes();
		date.second = d.getSeconds();
		date.millisecond = d.getMilliseconds();
	} else {
		if (map.YYYY !== void 0) date.year = Number.parseInt(match[map.YYYY], 10);
		else if (map.YY !== void 0) {
			const y = Number.parseInt(match[map.YY], 10);
			date.year = y < 0 ? y : 2e3 + y;
		}
		if (map.M !== void 0) {
			date.month = Number.parseInt(match[map.M], 10);
			if (date.month < 1 || date.month > 12) return date;
		} else if (map.MMM !== void 0) date.month = monthsShort.indexOf(match[map.MMM]) + 1;
		else if (map.MMMM !== void 0) date.month = months.indexOf(match[map.MMMM]) + 1;
		if (map.D !== void 0) {
			date.day = Number.parseInt(match[map.D], 10);
			if (date.year === null || date.month === null || date.day < 1) return date;
			const maxDay = calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
			if (date.day > maxDay) return date;
		}
		if (map.H !== void 0) {
			date.hour = Number.parseInt(match[map.H], 10);
			if (date.hour > 23) {
				date.hour = null;
				return date;
			}
		} else if (map.h !== void 0) {
			date.hour = Number.parseInt(match[map.h], 10);
			if (date.hour < 1 || date.hour > 12) {
				date.hour = null;
				return date;
			}
			date.hour %= 12;
			if (map.A && match[map.A] === "PM" || map.a && match[map.a] === "pm" || map.aa && match[map.aa] === "p.m.") date.hour += 12;
			date.hour = date.hour % 24;
		}
		if (map.m !== void 0) {
			date.minute = Number.parseInt(match[map.m], 10);
			if (date.minute > 59) {
				date.minute = null;
				return date;
			}
		}
		if (map.s !== void 0) {
			date.second = Number.parseInt(match[map.s], 10);
			if (date.second > 59) {
				date.second = null;
				return date;
			}
		}
		if (map.S !== void 0) date.millisecond = Number.parseInt(match[map.S], 10) * 10 ** (3 - match[map.S].length);
		if (map.Z !== void 0 || map.ZZ !== void 0) {
			tzString = map.Z !== void 0 ? match[map.Z].replace(":", "") : match[map.ZZ];
			if (tzString === "Z") date.timezoneOffset = 0;
			else {
				const tzHours = Number(tzString.slice(1, 3)), tzMinutes = Number(tzString.slice(3, 5));
				if (tzHours > 23 || tzMinutes > 59) return date;
				date.timezoneOffset = (tzString[0] === "+" ? -1 : 1) * (60 * tzHours + tzMinutes);
			}
		}
	}
	date.dateHash = pad(date.year, 4) + "/" + pad(date.month) + "/" + pad(date.day);
	date.timeHash = pad(date.hour) + ":" + pad(date.minute) + ":" + pad(date.second) + tzString;
	return date;
}
function getWeekOfYear(date) {
	const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);
	const firstThursday = new Date(thursday.getFullYear(), 0, 4);
	firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
	const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	thursday.setMinutes(thursday.getMinutes() - ds);
	const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY * 7);
	return 1 + Math.floor(weekDiff);
}
function startOfDate(date, unit, utc) {
	const t = new Date(date), prefix = `set${utc ? "UTC" : ""}`;
	switch (unit) {
		case "year":
		case "years": t[`${prefix}Month`](0);
		case "month":
		case "months": t[`${prefix}Date`](1);
		case "day":
		case "days":
		case "date": t[`${prefix}Hours`](0);
		case "hour":
		case "hours": t[`${prefix}Minutes`](0);
		case "minute":
		case "minutes": t[`${prefix}Seconds`](0);
		case "second":
		case "seconds": t[`${prefix}Milliseconds`](0);
	}
	return t;
}
function getDiff(t, sub, interval) {
	return (t.getTime() - t.getTimezoneOffset() * MILLISECONDS_IN_MINUTE - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE)) / interval;
}
function getDateDiff(date, subtract, unit = "days") {
	const t = new Date(date), sub = new Date(subtract);
	switch (unit) {
		case "years":
		case "year": return t.getFullYear() - sub.getFullYear();
		case "months":
		case "month": return (t.getFullYear() - sub.getFullYear()) * 12 + t.getMonth() - sub.getMonth();
		case "days":
		case "day":
		case "date": return getDiff(startOfDate(t, "day"), startOfDate(sub, "day"), MILLISECONDS_IN_DAY);
		case "hours":
		case "hour": return getDiff(startOfDate(t, "hour"), startOfDate(sub, "hour"), MILLISECONDS_IN_HOUR);
		case "minutes":
		case "minute": return getDiff(startOfDate(t, "minute"), startOfDate(sub, "minute"), MILLISECONDS_IN_MINUTE);
		case "seconds":
		case "second": return getDiff(startOfDate(t, "second"), startOfDate(sub, "second"), 1e3);
	}
}
function getDayOfYear(date) {
	return getDateDiff(date, startOfDate(date, "year"), "days") + 1;
}
function getOrdinal(n) {
	if (n >= 11 && n <= 13) return `${n}th`;
	switch (n % 10) {
		case 1: return `${n}st`;
		case 2: return `${n}nd`;
		case 3: return `${n}rd`;
	}
	return `${n}th`;
}
var formatter = {
	YY(date, dateLocale, forcedYear) {
		const y = this.YYYY(date, dateLocale, forcedYear) % 100;
		return y >= 0 ? pad(y) : "-" + pad(Math.abs(y));
	},
	YYYY(date, _dateLocale, forcedYear) {
		return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
	},
	M(date) {
		return date.getMonth() + 1;
	},
	Mo(date) {
		return getOrdinal(date.getMonth() + 1);
	},
	MM(date) {
		return pad(date.getMonth() + 1);
	},
	MMM(date, dateLocale) {
		return dateLocale.monthsShort[date.getMonth()];
	},
	MMMM(date, dateLocale) {
		return dateLocale.months[date.getMonth()];
	},
	Q(date) {
		return Math.ceil((date.getMonth() + 1) / 3);
	},
	Qo(date) {
		return getOrdinal(this.Q(date));
	},
	D(date) {
		return date.getDate();
	},
	Do(date) {
		return getOrdinal(date.getDate());
	},
	DD(date) {
		return pad(date.getDate());
	},
	DDD(date) {
		return getDayOfYear(date);
	},
	DDDo(date) {
		return getOrdinal(getDayOfYear(date));
	},
	DDDD(date) {
		return pad(getDayOfYear(date), 3);
	},
	d(date) {
		return date.getDay();
	},
	do(date) {
		return getOrdinal(date.getDay());
	},
	dd(date, dateLocale) {
		return dateLocale.days[date.getDay()].slice(0, 2);
	},
	ddd(date, dateLocale) {
		return dateLocale.daysShort[date.getDay()];
	},
	dddd(date, dateLocale) {
		return dateLocale.days[date.getDay()];
	},
	E(date) {
		return date.getDay() || 7;
	},
	w(date) {
		return getWeekOfYear(date);
	},
	wo(date) {
		return getOrdinal(getWeekOfYear(date));
	},
	ww(date) {
		return pad(getWeekOfYear(date));
	},
	H(date) {
		return date.getHours();
	},
	HH(date) {
		return pad(date.getHours());
	},
	h(date) {
		const hours = date.getHours();
		return hours === 0 ? 12 : hours > 12 ? hours % 12 : hours;
	},
	hh(date) {
		return pad(this.h(date));
	},
	m(date) {
		return date.getMinutes();
	},
	mm(date) {
		return pad(date.getMinutes());
	},
	s(date) {
		return date.getSeconds();
	},
	ss(date) {
		return pad(date.getSeconds());
	},
	S(date) {
		return Math.floor(date.getMilliseconds() / 100);
	},
	SS(date) {
		return pad(Math.floor(date.getMilliseconds() / 10));
	},
	SSS(date) {
		return pad(date.getMilliseconds(), 3);
	},
	A(date) {
		return date.getHours() < 12 ? "AM" : "PM";
	},
	a(date) {
		return date.getHours() < 12 ? "am" : "pm";
	},
	aa(date) {
		return date.getHours() < 12 ? "a.m." : "p.m.";
	},
	Z(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
		return formatTimezone(forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset, ":");
	},
	ZZ(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
		return formatTimezone(forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset);
	},
	X(date) {
		return Math.floor(date.getTime() / 1e3);
	},
	x(date) {
		return date.getTime();
	}
};
function formatDate(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
	if (val !== 0 && !val || val === Infinity || val === -Infinity) return;
	const date = new Date(val);
	if (Number.isNaN(date.getTime())) return;
	if (mask === void 0) mask = defaultMask;
	const locale = getDateLocale(dateLocale, Plugin$5.props);
	return mask.replace(token, (match, text) => match in formatter ? formatter[match](date, locale, __forcedYear, __forcedTimezoneOffset) : text === void 0 ? match : text.split(String.raw`\]`).join("]"));
}
var yearsInterval = 20;
var views = [
	"Calendar",
	"Years",
	"Months"
];
var viewIsValid = (v) => views.includes(v);
var yearMonthRE = /^-?[\d]+\/[0-1]\d$/;
var yearMonthValidator = (v) => yearMonthRE.test(v);
var lineStr = " — ";
function getMonthHash(date) {
	return date.year + "/" + pad(date.month);
}
function getShortDate(date) {
	return {
		year: date.year,
		month: date.month,
		day: date.day
	};
}
var QDate_default = /*#__PURE__*/ createComponent({
	name: "QDate",
	props: {
		...useDatetimeProps,
		...useFormProps,
		...useDarkProps,
		modelValue: {
			required: true,
			default: null,
			validator: (val) => typeof val === "string" || Array.isArray(val) || Object(val) === val || val === null
		},
		multiple: Boolean,
		range: Boolean,
		title: String,
		subtitle: String,
		mask: {
			...useDatetimeProps.mask,
			default: "YYYY/MM/DD"
		},
		defaultYearMonth: {
			type: String,
			validator: yearMonthValidator
		},
		yearsInMonthView: Boolean,
		events: [Array, Function],
		eventColor: [String, Function],
		emitImmediately: Boolean,
		options: [Array, Function],
		navigationMinYearMonth: {
			type: String,
			validator: yearMonthValidator
		},
		navigationMaxYearMonth: {
			type: String,
			validator: yearMonthValidator
		},
		noUnset: Boolean,
		firstDayOfWeek: [String, Number],
		todayBtn: Boolean,
		minimal: Boolean,
		defaultView: {
			type: String,
			default: "Calendar",
			validator: viewIsValid
		}
	},
	emits: [
		...useDatetimeEmits,
		"rangeStart",
		"rangeEnd",
		"navigation"
	],
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const isDark = useDark(props, $q);
		const { getCache } = useRenderCache();
		const { isHydrated } = useHydration();
		const { tabindex, headerClass, getLocale, getCurrentDate } = useDatetime(props, $q);
		let lastEmitValue;
		const injectFormInput = useFormInject(useFormAttrs(props));
		const blurTargetRef = ref(null);
		const innerMask = ref(getMask());
		const innerLocale = ref(getLocale());
		const mask = computed(() => getMask());
		const locale = computed(() => getLocale());
		const today = computed(() => getCurrentDate());
		const viewModel = ref(getViewModel(innerMask.value, innerLocale.value));
		const view = ref(props.defaultView);
		const direction = computed(() => $q.lang.rtl ? "right" : "left");
		const monthDirection = ref(direction.value);
		const yearDirection = ref(direction.value);
		const localYear = viewModel.value.year;
		const startYear = ref(localYear - localYear % yearsInterval - (localYear < 0 ? yearsInterval : 0));
		const editRange = ref(null);
		const classes = computed(() => {
			const type = props.landscape ? "landscape" : "portrait";
			return `q-date q-date--${type} q-date--${type}-${props.minimal ? "minimal" : "standard"}` + (isDark.value ? " q-date--dark q-dark" : "") + (props.bordered ? " q-date--bordered" : "") + (props.square ? " q-date--square no-border-radius" : "") + (props.flat ? " q-date--flat no-shadow" : "") + (props.disable ? " disabled" : props.readonly ? " q-date--readonly" : "");
		});
		const computedColor = computed(() => props.color || "primary");
		const computedTextColor = computed(() => props.textColor || "white");
		const isImmediate = computed(() => props.emitImmediately && !props.multiple && !props.range);
		const normalizedModel = computed(() => Array.isArray(props.modelValue) ? props.modelValue : props.modelValue !== null && props.modelValue !== void 0 ? [props.modelValue] : []);
		const daysModel = computed(() => normalizedModel.value.filter((date) => typeof date === "string").map((date) => decodeString(date, innerMask.value, innerLocale.value)).filter((date) => date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null));
		const rangeModel = computed(() => {
			const fn = (date) => decodeString(date, innerMask.value, innerLocale.value);
			return normalizedModel.value.filter((date) => isObject(date) && date.from !== void 0 && date.to !== void 0).map((range) => ({
				from: fn(range.from),
				to: fn(range.to)
			})).filter((range) => range.from.dateHash !== null && range.to.dateHash !== null && range.from.dateHash < range.to.dateHash);
		});
		const getNativeDateFn = computed(() => props.calendar !== "persian" ? (model) => new Date(model.year, model.month - 1, model.day) : (model) => {
			const gDate = toGregorian(model.year, model.month, model.day);
			return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
		});
		const encodeObjectFn = computed(() => props.calendar === "persian" ? getDayHash : (date, dateMask, dateLocale) => formatDate(new Date(date.year, date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond), dateMask === void 0 ? innerMask.value : dateMask, dateLocale === void 0 ? innerLocale.value : dateLocale, date.year, date.timezoneOffset));
		const daysInModel = computed(() => daysModel.value.length + rangeModel.value.reduce((acc, range) => acc + 1 + getDateDiff(getNativeDateFn.value(range.to), getNativeDateFn.value(range.from)), 0));
		const headerTitle = computed(() => {
			if (props.title !== void 0 && props.title !== null && props.title.length !== 0) return props.title;
			if (editRange.value !== null) {
				const model = editRange.value.init;
				const date = getNativeDateFn.value(model);
				return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day + " — ?";
			}
			if (daysInModel.value === 0) return lineStr;
			if (daysInModel.value > 1) return `${daysInModel.value} ${innerLocale.value.pluralDay}`;
			const model = daysModel.value[0];
			const date = getNativeDateFn.value(model);
			if (Number.isNaN(date.valueOf())) return lineStr;
			if (innerLocale.value.headerTitle !== void 0) return innerLocale.value.headerTitle(date, model);
			return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day;
		});
		const minSelectedModel = computed(() => {
			return [...daysModel.value, ...rangeModel.value.map((range) => range.from)].sort((a, b) => a.year - b.year || a.month - b.month)[0];
		});
		const maxSelectedModel = computed(() => {
			return [...daysModel.value, ...rangeModel.value.map((range) => range.to)].sort((a, b) => b.year - a.year || b.month - a.month)[0];
		});
		const headerSubtitle = computed(() => {
			if (props.subtitle !== void 0 && props.subtitle !== null && props.subtitle.length !== 0) return props.subtitle;
			if (daysInModel.value === 0) return lineStr;
			if (daysInModel.value > 1) {
				const from = minSelectedModel.value;
				const to = maxSelectedModel.value;
				const month = innerLocale.value.monthsShort;
				return month[from.month - 1] + (from.year !== to.year ? " " + from.year + lineStr + month[to.month - 1] + " " : from.month !== to.month ? lineStr + month[to.month - 1] : "") + " " + to.year;
			}
			return daysModel.value[0].year;
		});
		const dateArrow = computed(() => {
			const val = [$q.iconSet.datetime.arrowLeft, $q.iconSet.datetime.arrowRight];
			return $q.lang.rtl ? val.reverse() : val;
		});
		const computedFirstDayOfWeek = computed(() => props.firstDayOfWeek !== void 0 ? Number(props.firstDayOfWeek) : innerLocale.value.firstDayOfWeek);
		const daysOfWeek = computed(() => {
			const days = innerLocale.value.daysShort, first = computedFirstDayOfWeek.value;
			return first > 0 ? [...days.slice(first, 7), ...days.slice(0, first)] : days;
		});
		const daysInMonth = computed(() => {
			const date = viewModel.value;
			return props.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
		});
		const evtColor = computed(() => typeof props.eventColor === "function" ? props.eventColor : () => props.eventColor);
		const minNav = computed(() => {
			if (props.navigationMinYearMonth === void 0) return null;
			const data = props.navigationMinYearMonth.split("/");
			return {
				year: Number.parseInt(data[0], 10),
				month: Number.parseInt(data[1], 10)
			};
		});
		const maxNav = computed(() => {
			if (props.navigationMaxYearMonth === void 0) return null;
			const data = props.navigationMaxYearMonth.split("/");
			return {
				year: Number.parseInt(data[0], 10),
				month: Number.parseInt(data[1], 10)
			};
		});
		const navBoundaries = computed(() => {
			const data = {
				month: {
					prev: true,
					next: true
				},
				year: {
					prev: true,
					next: true
				}
			};
			if (minNav.value !== null && minNav.value.year >= viewModel.value.year) {
				data.year.prev = false;
				if (minNav.value.year === viewModel.value.year && minNav.value.month >= viewModel.value.month) data.month.prev = false;
			}
			if (maxNav.value !== null && maxNav.value.year <= viewModel.value.year) {
				data.year.next = false;
				if (maxNav.value.year === viewModel.value.year && maxNav.value.month <= viewModel.value.month) data.month.next = false;
			}
			return data;
		});
		const daysMap = computed(() => {
			const map = {};
			daysModel.value.forEach((entry) => {
				const hash = getMonthHash(entry);
				if (map[hash] === void 0) map[hash] = [];
				map[hash].push(entry.day);
			});
			return map;
		});
		const rangeMap = computed(() => {
			const map = {};
			rangeModel.value.forEach((entry) => {
				const hashFrom = getMonthHash(entry.from);
				const hashTo = getMonthHash(entry.to);
				if (map[hashFrom] === void 0) map[hashFrom] = [];
				map[hashFrom].push({
					from: entry.from.day,
					to: hashFrom === hashTo ? entry.to.day : void 0,
					range: entry
				});
				if (hashFrom < hashTo) {
					let hash;
					const { year, month } = entry.from;
					const cur = month < 12 ? {
						year,
						month: month + 1
					} : {
						year: year + 1,
						month: 1
					};
					while ((hash = getMonthHash(cur)) <= hashTo) {
						if (map[hash] === void 0) map[hash] = [];
						map[hash].push({
							from: void 0,
							to: hash === hashTo ? entry.to.day : void 0,
							range: entry
						});
						cur.month++;
						if (cur.month > 12) {
							cur.year++;
							cur.month = 1;
						}
					}
				}
			});
			return map;
		});
		const rangeView = computed(() => {
			if (editRange.value === null) return;
			const { init, initHash, final, finalHash } = editRange.value;
			const [from, to] = initHash <= finalHash ? [init, final] : [final, init];
			const fromHash = getMonthHash(from);
			const toHash = getMonthHash(to);
			if (fromHash !== viewMonthHash.value && toHash !== viewMonthHash.value) return;
			const localView = {};
			if (fromHash === viewMonthHash.value) {
				localView.from = from.day;
				localView.includeFrom = true;
			} else localView.from = 1;
			if (toHash === viewMonthHash.value) {
				localView.to = to.day;
				localView.includeTo = true;
			} else localView.to = daysInMonth.value;
			return localView;
		});
		const viewMonthHash = computed(() => getMonthHash(viewModel.value));
		const selectionDaysMap = computed(() => {
			const map = {};
			if (props.options === void 0) {
				for (let i = 1; i <= daysInMonth.value; i++) map[i] = true;
				return map;
			}
			const fn = typeof props.options === "function" ? props.options : (date) => props.options.includes(date);
			for (let i = 1; i <= daysInMonth.value; i++) map[i] = fn(viewMonthHash.value + "/" + pad(i));
			return map;
		});
		const eventDaysMap = computed(() => {
			const map = {};
			if (props.events === void 0) for (let i = 1; i <= daysInMonth.value; i++) map[i] = false;
			else {
				const fn = typeof props.events === "function" ? props.events : (date) => props.events.includes(date);
				for (let i = 1; i <= daysInMonth.value; i++) {
					const dayHash = viewMonthHash.value + "/" + pad(i);
					if (fn(dayHash)) {
						const color = evtColor.value(dayHash);
						map[i] = "q-date__event" + (color ? ` bg-${color}` : "");
					} else map[i] = false;
				}
			}
			return map;
		});
		const viewDays = computed(() => {
			let date, endDay;
			const { year, month } = viewModel.value;
			if (props.calendar !== "persian") {
				date = new Date(year, month - 1, 1);
				endDay = new Date(year, month - 1, 0).getDate();
			} else {
				const gDate = toGregorian(year, month, 1);
				date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
				let prevJM = month - 1;
				let prevJY = year;
				if (prevJM === 0) {
					prevJM = 12;
					prevJY--;
				}
				endDay = jalaaliMonthLength(prevJY, prevJM);
			}
			return {
				days: date.getDay() - computedFirstDayOfWeek.value - 1,
				endDay
			};
		});
		const days = computed(() => {
			const res = [];
			const { days: localDays, endDay } = viewDays.value;
			const len = localDays < 0 ? localDays + 7 : localDays;
			if (len < 6) for (let i = endDay - len; i <= endDay; i++) res.push({
				i,
				fill: true
			});
			const index = res.length;
			for (let i = 1; i <= daysInMonth.value; i++) {
				const day = {
					i,
					event: eventDaysMap.value[i],
					classes: []
				};
				if (selectionDaysMap.value[i]) {
					day.in = true;
					day.flat = true;
				}
				res.push(day);
			}
			if (daysMap.value[viewMonthHash.value] !== void 0) daysMap.value[viewMonthHash.value].forEach((day) => {
				const i = index + day - 1;
				Object.assign(res[i], {
					selected: true,
					unelevated: true,
					flat: false,
					color: computedColor.value,
					textColor: computedTextColor.value
				});
			});
			if (rangeMap.value[viewMonthHash.value] !== void 0) rangeMap.value[viewMonthHash.value].forEach((entry) => {
				if (entry.from !== void 0) {
					const from = index + entry.from - 1;
					const to = index + (entry.to || daysInMonth.value) - 1;
					for (let day = from; day <= to; day++) Object.assign(res[day], {
						range: entry.range,
						unelevated: true,
						color: computedColor.value,
						textColor: computedTextColor.value
					});
					Object.assign(res[from], {
						rangeFrom: true,
						flat: false
					});
					if (entry.to !== void 0) Object.assign(res[to], {
						rangeTo: true,
						flat: false
					});
				} else if (entry.to !== void 0) {
					const to = index + entry.to - 1;
					for (let day = index; day <= to; day++) Object.assign(res[day], {
						range: entry.range,
						unelevated: true,
						color: computedColor.value,
						textColor: computedTextColor.value
					});
					Object.assign(res[to], {
						flat: false,
						rangeTo: true
					});
				} else {
					const to = index + daysInMonth.value - 1;
					for (let day = index; day <= to; day++) Object.assign(res[day], {
						range: entry.range,
						unelevated: true,
						color: computedColor.value,
						textColor: computedTextColor.value
					});
				}
			});
			if (rangeView.value !== void 0) {
				const from = index + rangeView.value.from - 1;
				const to = index + rangeView.value.to - 1;
				for (let day = from; day <= to; day++) {
					res[day].color = computedColor.value;
					res[day].editRange = true;
				}
				if (rangeView.value.includeFrom) res[from].editRangeFrom = true;
				if (rangeView.value.includeTo) res[to].editRangeTo = true;
			}
			if (isHydrated.value && viewModel.value.year === today.value.year && viewModel.value.month === today.value.month) res[index + today.value.day - 1].today = true;
			const left = res.length % 7;
			if (left > 0) {
				const afterDays = 7 - left;
				for (let i = 1; i <= afterDays; i++) res.push({
					i,
					fill: true
				});
			}
			res.forEach((day) => {
				let cls = "q-date__calendar-item ";
				if (day.fill) cls += "q-date__calendar-item--fill";
				else {
					cls += `q-date__calendar-item--${day.in ? "in" : "out"}`;
					if (day.range !== void 0) cls += ` q-date__range${day.rangeTo ? "-to" : day.rangeFrom ? "-from" : ""}`;
					if (day.editRange) cls += ` q-date__edit-range${day.editRangeFrom ? "-from" : ""}${day.editRangeTo ? "-to" : ""}`;
					if (day.range !== void 0 || day.editRange) cls += ` text-${day.color}`;
				}
				day.classes = cls;
			});
			return res;
		});
		const attributes = computed(() => props.disable ? { "aria-disabled": "true" } : {});
		watch(() => props.modelValue, (v) => {
			if (lastEmitValue === JSON.stringify(v)) lastEmitValue = 0;
			else {
				const model = getViewModel(innerMask.value, innerLocale.value);
				updateViewModel(model.year, model.month, model);
			}
		});
		watch(view, () => {
			if (blurTargetRef.value !== null && proxy.$el.contains(document.activeElement)) blurTargetRef.value.focus({ preventScroll: true });
		});
		watch(() => viewModel.value.year + "|" + viewModel.value.month, () => {
			emit("navigation", {
				year: viewModel.value.year,
				month: viewModel.value.month
			});
		});
		watch(mask, (val) => {
			updateValue(val, innerLocale.value, "mask");
			innerMask.value = val;
		});
		watch(locale, (val) => {
			updateValue(innerMask.value, val, "locale");
			innerLocale.value = val;
		});
		function setLastValue(v) {
			lastEmitValue = JSON.stringify(v);
		}
		function setToday() {
			const { year, month, day } = today.value;
			const date = {
				...viewModel.value,
				year,
				month,
				day
			};
			const monthMap = daysMap.value[getMonthHash(date)];
			if (monthMap === void 0 || !monthMap.includes(date.day)) addToModel(date);
			setCalendarTo(date.year, date.month);
		}
		function setView(viewMode) {
			if (viewIsValid(viewMode)) view.value = viewMode;
		}
		function offsetCalendar(type, descending) {
			if (["month", "year"].includes(type)) (type === "month" ? goToMonth : goToYear)(descending ? -1 : 1);
		}
		function setCalendarTo(year, month) {
			view.value = "Calendar";
			updateViewModel(year, month);
		}
		function setEditingRange(from, to) {
			if (!props.range || !from) {
				editRange.value = null;
				return;
			}
			const init = {
				...viewModel.value,
				...from
			};
			const final = to !== void 0 ? {
				...viewModel.value,
				...to
			} : init;
			editRange.value = {
				init,
				initHash: getDayHash(init),
				final,
				finalHash: getDayHash(final)
			};
			setCalendarTo(init.year, init.month);
		}
		function getMask() {
			return props.calendar === "persian" ? "YYYY/MM/DD" : props.mask;
		}
		function decodeString(date, dateMask, dateLocale) {
			return __splitDate(date, dateMask, dateLocale, props.calendar, {
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0
			});
		}
		function getViewModel(dateMask, dateLocale) {
			const model = Array.isArray(props.modelValue) ? props.modelValue : props.modelValue ? [props.modelValue] : [];
			if (model.length === 0) return getDefaultViewModel();
			const target = model.at(-1);
			const decoded = decodeString(target.from !== void 0 ? target.from : target, dateMask, dateLocale);
			return decoded.dateHash === null ? getDefaultViewModel() : decoded;
		}
		function getDefaultViewModel() {
			let year, month;
			if (props.defaultYearMonth !== void 0) {
				const d = props.defaultYearMonth.split("/");
				year = Number.parseInt(d[0], 10);
				month = Number.parseInt(d[1], 10);
			} else {
				const d = today.value !== void 0 ? today.value : getCurrentDate();
				year = d.year;
				month = d.month;
			}
			return {
				year,
				month,
				day: 1,
				hour: 0,
				minute: 0,
				second: 0,
				millisecond: 0,
				dateHash: year + "/" + pad(month) + "/01"
			};
		}
		function goToMonth(offset) {
			let year = viewModel.value.year;
			let month = Number(viewModel.value.month) + offset;
			if (month === 13) {
				month = 1;
				year++;
			} else if (month === 0) {
				month = 12;
				year--;
			}
			updateViewModel(year, month);
			if (isImmediate.value) emitImmediately("month");
		}
		function goToYear(offset) {
			updateViewModel(Number(viewModel.value.year) + offset, viewModel.value.month);
			if (isImmediate.value) emitImmediately("year");
		}
		function setYear(year) {
			updateViewModel(year, viewModel.value.month);
			view.value = props.defaultView === "Years" ? "Months" : "Calendar";
			if (isImmediate.value) emitImmediately("year");
		}
		function setMonth(month) {
			updateViewModel(viewModel.value.year, month);
			view.value = "Calendar";
			if (isImmediate.value) emitImmediately("month");
		}
		function toggleDate(date, monthHash) {
			(daysMap.value[monthHash]?.includes(date.day) === true ? removeFromModel : addToModel)(date);
		}
		function updateViewModel(year, month, time) {
			if (minNav.value !== null && year <= minNav.value.year) {
				if (month < minNav.value.month || year < minNav.value.year) month = minNav.value.month;
				year = minNav.value.year;
			}
			if (maxNav.value !== null && year >= maxNav.value.year) {
				if (month > maxNav.value.month || year > maxNav.value.year) month = maxNav.value.month;
				year = maxNav.value.year;
			}
			if (time !== void 0) {
				const { hour, minute, second, millisecond, timezoneOffset, timeHash } = time;
				Object.assign(viewModel.value, {
					hour,
					minute,
					second,
					millisecond,
					timezoneOffset,
					timeHash
				});
			}
			const newHash = year + "/" + pad(month) + "/01";
			if (newHash !== viewModel.value.dateHash) {
				monthDirection.value = viewModel.value.dateHash < newHash === ($q.lang.rtl !== true) ? "left" : "right";
				if (year !== viewModel.value.year) yearDirection.value = monthDirection.value;
				nextTick(() => {
					startYear.value = year - year % yearsInterval - (year < 0 ? yearsInterval : 0);
					Object.assign(viewModel.value, {
						year,
						month,
						day: 1,
						dateHash: newHash
					});
				});
			}
		}
		function emitValue(val, action, date) {
			const value = val !== null && val.length === 1 && !props.multiple ? val[0] : val;
			const { reason, details } = getEmitParams(action, date);
			setLastValue(value);
			emit("update:modelValue", value, reason, details);
		}
		function emitImmediately(reason) {
			const date = daysModel.value[0] !== void 0 && daysModel.value[0].dateHash !== null ? { ...daysModel.value[0] } : { ...viewModel.value };
			nextTick(() => {
				date.year = viewModel.value.year;
				date.month = viewModel.value.month;
				const maxDay = props.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
				date.day = Math.min(Math.max(1, date.day), maxDay);
				const value = encodeEntry(date);
				const { details } = getEmitParams("", date);
				setLastValue(value);
				emit("update:modelValue", value, reason, details);
			});
		}
		function getEmitParams(action, date) {
			return date.from !== void 0 ? {
				reason: `${action}-range`,
				details: {
					...getShortDate(date.target),
					from: getShortDate(date.from),
					to: getShortDate(date.to)
				}
			} : {
				reason: `${action}-day`,
				details: getShortDate(date)
			};
		}
		function encodeEntry(date, dateMask, dateLocale) {
			return date.from !== void 0 ? {
				from: encodeObjectFn.value(date.from, dateMask, dateLocale),
				to: encodeObjectFn.value(date.to, dateMask, dateLocale)
			} : encodeObjectFn.value(date, dateMask, dateLocale);
		}
		function addToModel(date) {
			let value;
			if (props.multiple) if (date.from !== void 0) {
				const fromHash = getDayHash(date.from);
				const toHash = getDayHash(date.to);
				const localDays = daysModel.value.filter((day) => day.dateHash < fromHash || day.dateHash > toHash);
				const ranges = rangeModel.value.filter(({ from, to }) => to.dateHash < fromHash || from.dateHash > toHash);
				value = [
					...localDays,
					...ranges,
					date
				].map((entry) => encodeEntry(entry));
			} else value = [...normalizedModel.value, encodeEntry(date)];
			else value = encodeEntry(date);
			emitValue(value, "add", date);
		}
		function removeFromModel(date) {
			if (props.noUnset) return;
			let model = null;
			if (props.multiple && Array.isArray(props.modelValue)) {
				const val = encodeEntry(date);
				model = date.from !== void 0 ? props.modelValue.filter((item) => item.from !== void 0 ? item.from !== val.from && item.to !== val.to : true) : props.modelValue.filter((item) => item !== val);
				if (model.length === 0) model = null;
			}
			emitValue(model, "remove", date);
		}
		function updateValue(dateMask, dateLocale, reason) {
			const model = [...daysModel.value, ...rangeModel.value].map((entry) => encodeEntry(entry, dateMask, dateLocale)).filter((entry) => entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null);
			const value = (props.multiple ? model : model[0]) || null;
			setLastValue(value);
			emit("update:modelValue", value, reason);
		}
		function getHeader() {
			if (props.minimal) return;
			return h("div", { class: "q-date__header " + headerClass.value }, [h("div", { class: "relative-position" }, [h(Transition, { name: "q-transition--fade" }, () => h("div", {
				key: "h-yr-" + headerSubtitle.value,
				class: "q-date__header-subtitle q-date__header-link " + (view.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
				tabindex: tabindex.value,
				...getCache("vY", {
					onClick() {
						view.value = "Years";
					},
					onKeyup(e) {
						if (e.keyCode === 13) view.value = "Years";
					}
				})
			}, [headerSubtitle.value]))]), h("div", { class: "q-date__header-title relative-position flex no-wrap" }, [h("div", { class: "relative-position col" }, [h(Transition, { name: "q-transition--fade" }, () => h("div", {
				key: "h-sub" + headerTitle.value,
				class: "q-date__header-title-label q-date__header-link " + (view.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
				tabindex: tabindex.value,
				...getCache("vC", {
					onClick() {
						view.value = "Calendar";
					},
					onKeyup(e) {
						if (e.keyCode === 13) view.value = "Calendar";
					}
				})
			}, [headerTitle.value]))]), props.todayBtn ? h(QBtn_default, {
				class: "q-date__header-today self-start",
				icon: $q.iconSet.datetime.today,
				"aria-label": $q.lang.date.today,
				flat: true,
				size: "sm",
				round: true,
				tabindex: tabindex.value,
				onClick: setToday
			}) : null])]);
		}
		function getNavigation({ label, type, key, dir, goTo, boundaries, cls }) {
			return [
				h("div", { class: "row items-center q-date__arrow" }, [h(QBtn_default, {
					round: true,
					dense: true,
					size: "sm",
					flat: true,
					icon: dateArrow.value[0],
					"aria-label": type === "Years" ? $q.lang.date.prevYear : $q.lang.date.prevMonth,
					tabindex: tabindex.value,
					disable: !boundaries.prev,
					...getCache("go-#" + type, { onClick() {
						goTo(-1);
					} })
				})]),
				h("div", { class: "relative-position overflow-hidden flex flex-center" + cls }, [h(Transition, { name: "q-transition--jump-" + dir }, () => h("div", { key }, [h(QBtn_default, {
					flat: true,
					dense: true,
					noCaps: true,
					label,
					tabindex: tabindex.value,
					...getCache("view#" + type, { onClick: () => {
						view.value = type;
					} })
				})]))]),
				h("div", { class: "row items-center q-date__arrow" }, [h(QBtn_default, {
					round: true,
					dense: true,
					size: "sm",
					flat: true,
					icon: dateArrow.value[1],
					"aria-label": type === "Years" ? $q.lang.date.nextYear : $q.lang.date.nextMonth,
					tabindex: tabindex.value,
					disable: !boundaries.next,
					...getCache("go+#" + type, { onClick() {
						goTo(1);
					} })
				})])
			];
		}
		const renderViews = {
			Calendar: () => [h("div", {
				key: "calendar-view",
				class: "q-date__view q-date__calendar"
			}, [
				h("div", { class: "q-date__navigation row items-center no-wrap" }, [...getNavigation({
					label: innerLocale.value.months[viewModel.value.month - 1],
					type: "Months",
					key: viewModel.value.month,
					dir: monthDirection.value,
					goTo: goToMonth,
					boundaries: navBoundaries.value.month,
					cls: " col"
				}), ...getNavigation({
					label: viewModel.value.year,
					type: "Years",
					key: viewModel.value.year,
					dir: yearDirection.value,
					goTo: goToYear,
					boundaries: navBoundaries.value.year,
					cls: ""
				})]),
				h("div", { class: "q-date__calendar-weekdays row items-center no-wrap" }, daysOfWeek.value.map((day) => h("div", { class: "q-date__calendar-item" }, [h("div", day)]))),
				h("div", { class: "q-date__calendar-days-container relative-position overflow-hidden" }, [h(Transition, { name: "q-transition--slide-" + monthDirection.value }, () => h("div", {
					key: viewMonthHash.value,
					class: "q-date__calendar-days fit"
				}, days.value.map((day) => h("div", { class: day.classes }, [day.in ? h(QBtn_default, {
					class: day.today ? "q-date__today" : "",
					dense: true,
					flat: day.flat,
					unelevated: day.unelevated,
					color: day.color,
					textColor: day.textColor,
					label: day.i,
					tabindex: tabindex.value,
					...getCache("day#" + day.i, {
						onClick: () => {
							onDayClick(day.i);
						},
						onMouseover: () => {
							onDayMouseover(day.i);
						}
					})
				}, day.event ? () => h("div", { class: day.event }) : null) : h("div", String(day.i))]))))])
			])],
			Months() {
				const currentYear = isHydrated.value && viewModel.value.year === today.value.year;
				const isDisabled = (month) => minNav.value !== null && viewModel.value.year === minNav.value.year && minNav.value.month > month || maxNav.value !== null && viewModel.value.year === maxNav.value.year && maxNav.value.month < month;
				const content = innerLocale.value.monthsShort.map((month, i) => {
					const active = viewModel.value.month === i + 1;
					return h("div", { class: "q-date__months-item flex flex-center" }, [h(QBtn_default, {
						class: currentYear && today.value.month === i + 1 ? "q-date__today" : null,
						flat: !active,
						label: month,
						unelevated: active,
						color: active ? computedColor.value : null,
						textColor: active ? computedTextColor.value : null,
						tabindex: tabindex.value,
						disable: isDisabled(i + 1),
						...getCache("month#" + i, { onClick: () => {
							setMonth(i + 1);
						} })
					})]);
				});
				if (props.yearsInMonthView) content.unshift(h("div", { class: "row no-wrap full-width" }, [getNavigation({
					label: viewModel.value.year,
					type: "Years",
					key: viewModel.value.year,
					dir: yearDirection.value,
					goTo: goToYear,
					boundaries: navBoundaries.value.year,
					cls: " col"
				})]));
				return h("div", {
					key: "months-view",
					class: "q-date__view q-date__months flex flex-center"
				}, content);
			},
			Years() {
				const start = startYear.value, stop = start + yearsInterval, years = [];
				const isDisabled = (year) => minNav.value !== null && minNav.value.year > year || maxNav.value !== null && maxNav.value.year < year;
				for (let i = start; i <= stop; i++) {
					const active = viewModel.value.year === i;
					years.push(h("div", { class: "q-date__years-item flex flex-center" }, [h(QBtn_default, {
						key: "yr" + i,
						class: isHydrated.value && today.value.year === i ? "q-date__today" : null,
						flat: !active,
						label: i,
						dense: true,
						unelevated: active,
						color: active ? computedColor.value : null,
						textColor: active ? computedTextColor.value : null,
						tabindex: tabindex.value,
						disable: isDisabled(i),
						...getCache("yr#" + i, { onClick: () => {
							setYear(i);
						} })
					})]));
				}
				return h("div", { class: "q-date__view q-date__years flex flex-center" }, [
					h("div", { class: "col-auto" }, [h(QBtn_default, {
						round: true,
						dense: true,
						flat: true,
						icon: dateArrow.value[0],
						"aria-label": $q.lang.date.prevRangeYears(yearsInterval),
						tabindex: tabindex.value,
						disable: isDisabled(start),
						...getCache("y-", { onClick: () => {
							startYear.value -= yearsInterval;
						} })
					})]),
					h("div", { class: "q-date__years-content col self-stretch row items-center" }, years),
					h("div", { class: "col-auto" }, [h(QBtn_default, {
						round: true,
						dense: true,
						flat: true,
						icon: dateArrow.value[1],
						"aria-label": $q.lang.date.nextRangeYears(yearsInterval),
						tabindex: tabindex.value,
						disable: isDisabled(stop),
						...getCache("y+", { onClick: () => {
							startYear.value += yearsInterval;
						} })
					})])
				]);
			}
		};
		function onDayClick(dayIndex) {
			const day = {
				...viewModel.value,
				day: dayIndex
			};
			if (!props.range) {
				toggleDate(day, viewMonthHash.value);
				return;
			}
			if (editRange.value === null) {
				const dayProps = days.value.find((item) => !item.fill && item.i === dayIndex);
				if (!props.noUnset && dayProps.range !== void 0) {
					removeFromModel({
						target: day,
						from: dayProps.range.from,
						to: dayProps.range.to
					});
					return;
				}
				if (dayProps.selected) {
					removeFromModel(day);
					return;
				}
				const initHash = getDayHash(day);
				editRange.value = {
					init: day,
					initHash,
					final: day,
					finalHash: initHash
				};
				emit("rangeStart", getShortDate(day));
			} else {
				const initHash = editRange.value.initHash, finalHash = getDayHash(day), payload = initHash <= finalHash ? {
					from: editRange.value.init,
					to: day
				} : {
					from: day,
					to: editRange.value.init
				};
				editRange.value = null;
				addToModel(initHash === finalHash ? day : {
					target: day,
					...payload
				});
				emit("rangeEnd", {
					from: getShortDate(payload.from),
					to: getShortDate(payload.to)
				});
			}
		}
		function onDayMouseover(dayIndex) {
			if (editRange.value !== null) {
				const final = {
					...viewModel.value,
					day: dayIndex
				};
				Object.assign(editRange.value, {
					final,
					finalHash: getDayHash(final)
				});
			}
		}
		Object.assign(proxy, {
			setToday,
			setView,
			offsetCalendar,
			setCalendarTo,
			setEditingRange
		});
		return () => {
			const content = [h("div", { class: "q-date__content col relative-position" }, [h(Transition, { name: "q-transition--fade" }, renderViews[view.value])])];
			const def = hSlot(slots.default);
			if (def !== void 0) content.push(h("div", { class: "q-date__actions" }, def));
			if (props.name !== void 0 && !props.disable) injectFormInput(content, "push");
			return h("div", {
				class: classes.value,
				...attributes.value
			}, [getHeader(), h("div", {
				ref: blurTargetRef,
				class: "q-date__main col column",
				tabindex: -1
			}, content)]);
		};
	}
});
function useHistory(showing, hide, hideOnRouteChange) {
	let historyEntry;
	function removeFromHistory() {
		if (historyEntry !== void 0) {
			History_default.remove(historyEntry);
			historyEntry = void 0;
		}
	}
	onBeforeUnmount(() => {
		if (showing.value) removeFromHistory();
	});
	return {
		removeFromHistory,
		addToHistory() {
			historyEntry = {
				condition: () => hideOnRouteChange.value,
				handler: hide
			};
			History_default.add(historyEntry);
		}
	};
}
var registered = 0;
var scrollPositionX;
var scrollPositionY;
var maxScrollTop;
var vpPendingUpdate = false;
var bodyLeft;
var bodyTop;
var routePath;
var closeTimer = null;
function onAppleScroll(e) {
	if (e.target === document) document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
}
function onAppleResize(evt) {
	if (vpPendingUpdate) return;
	vpPendingUpdate = true;
	requestAnimationFrame(() => {
		vpPendingUpdate = false;
		const { height } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
		if (maxScrollTop === void 0 || height !== window.innerHeight) {
			maxScrollTop = clientHeight - height;
			document.scrollingElement.scrollTop = scrollTop;
		}
		if (scrollTop > maxScrollTop) document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
	});
}
function apply$1(action) {
	const body = document.body, hasViewport = window.visualViewport !== void 0;
	if (action === "add") {
		const { overflowY, overflowX } = window.getComputedStyle(body);
		scrollPositionX = getHorizontalScrollPosition(window);
		scrollPositionY = getVerticalScrollPosition(window);
		bodyLeft = body.style.left;
		bodyTop = body.style.top;
		routePath = window.location.pathname;
		body.style.left = `-${scrollPositionX}px`;
		body.style.top = `-${scrollPositionY}px`;
		if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) body.classList.add("q-body--force-scrollbar-x");
		if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) body.classList.add("q-body--force-scrollbar-y");
		document.documentElement.classList.add("q-document--prevent-scroll");
		document.qScrollPrevented = true;
		if (client.is.ios) if (hasViewport) {
			window.scrollTo(0, 0);
			window.visualViewport.addEventListener("resize", onAppleResize, listenOpts.passiveCapture);
			window.visualViewport.addEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
			window.scrollTo(0, 0);
		} else window.addEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
	} else {
		if (client.is.ios) if (hasViewport) {
			window.visualViewport.removeEventListener("resize", onAppleResize, listenOpts.passiveCapture);
			window.visualViewport.removeEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
		} else window.removeEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
		document.documentElement.classList.remove("q-document--prevent-scroll");
		body.classList.remove("q-body--force-scrollbar-x", "q-body--force-scrollbar-y");
		document.qScrollPrevented = false;
		body.style.left = bodyLeft;
		body.style.top = bodyTop;
		if (window.location.pathname === routePath) window.scrollTo(scrollPositionX, scrollPositionY);
		maxScrollTop = void 0;
	}
}
function preventScroll(state) {
	let action = "add";
	if (state === true) {
		registered++;
		if (closeTimer !== null) {
			clearTimeout(closeTimer);
			closeTimer = null;
			return;
		}
		if (registered > 1) return;
	} else {
		if (registered === 0) return;
		registered--;
		if (registered > 0) return;
		action = "remove";
		if (client.is.ios && client.is.nativeMobile) {
			if (closeTimer !== null) clearTimeout(closeTimer);
			closeTimer = setTimeout(() => {
				apply$1(action);
				closeTimer = null;
			}, 100);
			return;
		}
	}
	apply$1(action);
}
function usePreventScroll() {
	let currentState;
	return { preventBodyScroll(state) {
		if (state !== currentState && (currentState !== void 0 || state)) {
			currentState = state;
			preventScroll(state);
		}
	} };
}
var maximizedModals = 0;
var positionClass$1 = {
	standard: "fixed-full flex-center",
	top: "fixed-top justify-center",
	bottom: "fixed-bottom justify-center",
	right: "fixed-right items-center",
	left: "fixed-left items-center"
};
var defaultTransitions = {
	standard: ["scale", "scale"],
	top: ["slide-down", "slide-up"],
	bottom: ["slide-up", "slide-down"],
	right: ["slide-left", "slide-right"],
	left: ["slide-right", "slide-left"]
};
var QDialog_default = /*#__PURE__*/ createComponent({
	name: "QDialog",
	inheritAttrs: false,
	props: {
		...useModelToggleProps,
		...useTransitionProps,
		transitionShow: String,
		transitionHide: String,
		persistent: Boolean,
		autoClose: Boolean,
		allowFocusOutside: Boolean,
		noEscDismiss: Boolean,
		noBackdropDismiss: Boolean,
		noRouteDismiss: Boolean,
		noRefocus: Boolean,
		noFocus: Boolean,
		noShake: Boolean,
		seamless: Boolean,
		maximized: Boolean,
		fullWidth: Boolean,
		fullHeight: Boolean,
		square: Boolean,
		backdropFilter: String,
		position: {
			type: String,
			default: "standard",
			validator: (val) => [
				"standard",
				"top",
				"bottom",
				"left",
				"right"
			].includes(val)
		}
	},
	emits: [
		...useModelToggleEmits,
		"shake",
		"click",
		"escapeKey"
	],
	setup(props, { slots, emit, attrs }) {
		const vm = getCurrentInstance();
		const innerRef = ref(null);
		const showing = ref(false);
		const animating = ref(false);
		let shakeTimeout = null, refocusTarget = null, isMaximized = false, avoidAutoClose = false;
		const hideOnRouteChange = computed(() => !props.persistent && !props.noRouteDismiss && !props.seamless);
		const { preventBodyScroll } = usePreventScroll();
		const { registerTimeout } = useTimeout();
		const { registerTick, removeTick } = useTick();
		const { transitionProps, transitionStyle } = useTransition(props, () => defaultTransitions[props.position][0], () => defaultTransitions[props.position][1]);
		const backdropStyle = computed(() => transitionStyle.value + (props.backdropFilter !== void 0 ? `;backdrop-filter:${props.backdropFilter};-webkit-backdrop-filter:${props.backdropFilter}` : ""));
		const { showPortal, hidePortal, portalIsAccessible, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "dialog");
		const { hide } = useModelToggle({
			showing,
			hideOnRouteChange,
			handleShow,
			handleHide,
			handleRouteChange,
			processOnMount: true
		});
		const { addToHistory, removeFromHistory } = useHistory(showing, hide, hideOnRouteChange);
		const classes = computed(() => `q-dialog__inner flex no-pointer-events q-dialog__inner--${props.maximized ? "maximized" : "minimized"} q-dialog__inner--${props.position} ${positionClass$1[props.position]}` + (animating.value ? " q-dialog__inner--animating" : "") + (props.fullWidth ? " q-dialog__inner--fullwidth" : "") + (props.fullHeight ? " q-dialog__inner--fullheight" : "") + (props.square ? " q-dialog__inner--square" : ""));
		const useBackdrop = computed(() => showing.value && !props.seamless);
		const onEvents = computed(() => props.autoClose ? { onClick: onAutoClose } : {});
		const rootClasses = computed(() => [`q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value ? "modal" : "seamless"}`, attrs.class]);
		watch(() => props.maximized, (state) => {
			if (showing.value) updateMaximized(state);
		});
		watch(useBackdrop, (val) => {
			preventBodyScroll(val);
			if (val) {
				addFocusout(onFocusChange);
				addEscapeKey(onEscapeKey);
			} else {
				removeFocusout(onFocusChange);
				removeEscapeKey(onEscapeKey);
			}
		});
		function handleShow(evt) {
			addToHistory();
			refocusTarget = !props.noRefocus && document.activeElement !== null ? document.activeElement : null;
			updateMaximized(props.maximized);
			showPortal();
			animating.value = true;
			if (props.noFocus) removeTick();
			else {
				document.activeElement?.blur();
				registerTick(focus);
			}
			registerTimeout(() => {
				if (vm.proxy.$q.platform.is.ios) {
					if (!props.seamless && document.activeElement) {
						const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
						if (top > 0 && bottom > height / 2) document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - height, bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height / 2));
						document.activeElement.scrollIntoView();
					}
					avoidAutoClose = true;
					innerRef.value.click();
					avoidAutoClose = false;
				}
				showPortal(true);
				animating.value = false;
				emit("show", evt);
			}, props.transitionDuration);
		}
		function handleHide(evt) {
			removeTick();
			removeFromHistory();
			cleanup(true);
			animating.value = true;
			hidePortal();
			if (refocusTarget !== null) {
				const target = (evt?.type.indexOf("key") === 0 ? refocusTarget.closest("[tabindex]:not([tabindex^=\"-\"])") : void 0) || refocusTarget;
				refocusTarget = null;
				addFocusFn(() => {
					if (target.isConnected) target.focus({ preventScroll: true });
				});
			}
			registerTimeout(() => {
				hidePortal(true);
				animating.value = false;
				emit("hide", evt);
			}, props.transitionDuration);
		}
		function handleRouteChange() {
			refocusTarget = null;
		}
		function focus(selector) {
			addFocusFn(() => {
				let node = innerRef.value;
				if (node === null) return;
				if (selector !== void 0) {
					const target = node.querySelector(selector);
					if (target !== null) {
						target.focus({ preventScroll: true });
						return;
					}
				}
				if (!node.contains(document.activeElement)) {
					node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
					node.focus({ preventScroll: true });
				}
			});
		}
		function shake(focusTarget) {
			if (focusTarget && typeof focusTarget.focus === "function") focusTarget.focus({ preventScroll: true });
			else focus();
			emit("shake");
			const node = innerRef.value;
			if (node !== null) {
				node.classList.remove("q-animate--scale");
				node.classList.add("q-animate--scale");
				if (shakeTimeout !== null) clearTimeout(shakeTimeout);
				shakeTimeout = setTimeout(() => {
					shakeTimeout = null;
					if (innerRef.value !== null) {
						node.classList.remove("q-animate--scale");
						focus();
					}
				}, 170);
			}
		}
		function onEscapeKey() {
			if (!props.seamless) if (props.persistent || props.noEscDismiss) {
				if (!props.maximized && !props.noShake) shake();
			} else {
				emit("escapeKey");
				hide();
			}
		}
		function cleanup(hiding) {
			if (shakeTimeout !== null) {
				clearTimeout(shakeTimeout);
				shakeTimeout = null;
			}
			if (hiding || showing.value) {
				updateMaximized(false);
				if (!props.seamless) {
					preventBodyScroll(false);
					removeFocusout(onFocusChange);
					removeEscapeKey(onEscapeKey);
				}
			}
			if (!hiding) refocusTarget = null;
		}
		function updateMaximized(active) {
			if (active) {
				if (!isMaximized) {
					if (maximizedModals < 1) document.body.classList.add("q-body--dialog");
					maximizedModals++;
					isMaximized = true;
				}
			} else if (isMaximized) {
				if (maximizedModals < 2) document.body.classList.remove("q-body--dialog");
				maximizedModals--;
				isMaximized = false;
			}
		}
		function onAutoClose(e) {
			if (!avoidAutoClose) {
				hide(e);
				emit("click", e);
			}
		}
		function onBackdropClick(e) {
			if (!props.persistent && !props.noBackdropDismiss) hide(e);
			else if (!props.noShake) shake();
		}
		function onFocusChange(evt) {
			if (!props.allowFocusOutside && portalIsAccessible.value && !childHasFocus(innerRef.value, evt.target) && !focusIsInDetachedFullscreen(innerRef.value, evt.target)) focus("[tabindex]:not([tabindex=\"-1\"])");
		}
		Object.assign(vm.proxy, {
			focus,
			shake,
			__updateRefocusTarget(target) {
				refocusTarget = target || null;
			}
		});
		onBeforeUnmount(cleanup);
		function renderPortalContent() {
			return h("div", {
				role: "dialog",
				"aria-modal": useBackdrop.value ? "true" : "false",
				...attrs,
				class: rootClasses.value
			}, [h(Transition, {
				name: "q-transition--fade",
				appear: true
			}, () => useBackdrop.value ? h("div", {
				class: "q-dialog__backdrop fixed-full",
				style: backdropStyle.value,
				"aria-hidden": "true",
				onClick: onBackdropClick
			}) : null), h(Transition, transitionProps.value, () => showing.value ? h("div", {
				ref: innerRef,
				class: classes.value,
				style: transitionStyle.value,
				tabindex: -1,
				...onEvents.value
			}, hSlot(slots.default)) : null)]);
		}
		return renderPortal;
	}
});
var duration = 150;
function updateLocal$2(prop, val) {
	if (prop.value !== val) prop.value = val;
}
var QDrawer_default = /*#__PURE__*/ createComponent({
	name: "QDrawer",
	inheritAttrs: false,
	props: {
		...useModelToggleProps,
		...useDarkProps,
		side: {
			type: String,
			default: "left",
			validator: (v) => ["left", "right"].includes(v)
		},
		width: {
			type: Number,
			default: 300
		},
		mini: Boolean,
		miniToOverlay: Boolean,
		miniWidth: {
			type: Number,
			default: 57
		},
		noMiniAnimation: Boolean,
		breakpoint: {
			type: Number,
			default: 1023
		},
		showIfAbove: Boolean,
		behavior: {
			type: String,
			validator: (v) => [
				"default",
				"desktop",
				"mobile"
			].includes(v),
			default: "default"
		},
		bordered: Boolean,
		elevated: Boolean,
		overlay: Boolean,
		persistent: Boolean,
		noSwipeOpen: Boolean,
		noSwipeClose: Boolean,
		noSwipeBackdrop: Boolean
	},
	emits: [
		...useModelToggleEmits,
		"onLayout",
		"miniState"
	],
	setup(props, { slots, emit, attrs }) {
		const vm = getCurrentInstance();
		const { proxy: { $q } } = vm;
		const isDark = useDark(props, $q);
		const { preventBodyScroll } = usePreventScroll();
		const { registerTimeout, removeTimeout } = useTimeout();
		const $layout = inject(layoutKey, emptyRenderFn);
		if ($layout === emptyRenderFn) {
			console.error("QDrawer needs to be child of QLayout");
			return emptyRenderFn;
		}
		let lastDesktopState, timerMini = null, layoutTotalWidthWatcher;
		const belowBreakpoint = ref(props.behavior === "mobile" || props.behavior !== "desktop" && $layout.totalWidth.value <= props.breakpoint);
		const isMini = computed(() => props.mini && !belowBreakpoint.value);
		const size = computed(() => isMini.value ? props.miniWidth : props.width);
		const fixed = computed(() => props.overlay || props.miniToOverlay || $layout.view.value.includes(rightSide.value ? "R" : "L") || $q.platform.is.ios && $layout.isContainer.value);
		const showing = ref(props.showIfAbove && !belowBreakpoint.value || props.modelValue === true);
		const onLayout = computed(() => !props.overlay && showing.value && !belowBreakpoint.value);
		const onScreenOverlay = computed(() => props.overlay && showing.value && !belowBreakpoint.value);
		const hideOnRouteChange = computed(() => !props.persistent && (belowBreakpoint.value || onScreenOverlay.value));
		function handleShow(evt, noEvent) {
			addToHistory();
			if (evt !== false) $layout.animate();
			applyPosition(0);
			if (belowBreakpoint.value) {
				const otherInstance = $layout.instances[otherSide.value];
				if (otherInstance?.belowBreakpoint === true) otherInstance.hide(false);
				applyBackdrop(1);
				if (!$layout.isContainer.value) preventBodyScroll(true);
			} else {
				applyBackdrop(0);
				if (evt !== false) setScrollable(false);
			}
			registerTimeout(() => {
				if (evt !== false) setScrollable(true);
				if (!noEvent) emit("show", evt);
			}, duration);
		}
		function handleHide(evt, noEvent) {
			removeFromHistory();
			if (evt !== false) $layout.animate();
			applyBackdrop(0);
			applyPosition(stateDirection.value * size.value);
			cleanup();
			if (!noEvent) registerTimeout(() => {
				emit("hide", evt);
			}, duration);
			else removeTimeout();
		}
		const { show, hide } = useModelToggle({
			showing,
			hideOnRouteChange,
			handleShow,
			handleHide
		});
		const { addToHistory, removeFromHistory } = useHistory(showing, hide, hideOnRouteChange);
		const instance = {
			belowBreakpoint,
			hide
		};
		const rightSide = computed(() => props.side === "right");
		const stateDirection = computed(() => ($q.lang.rtl ? -1 : 1) * (rightSide.value ? 1 : -1));
		const flagBackdropBg = ref(0);
		const flagPanning = ref(false);
		const flagMiniAnimate = ref(false);
		const flagContentPosition = ref(size.value * stateDirection.value);
		const otherSide = computed(() => rightSide.value ? "left" : "right");
		const offset = computed(() => showing.value && !belowBreakpoint.value && !props.overlay ? props.miniToOverlay ? props.miniWidth : size.value : 0);
		const backdropClass = computed(() => "fullscreen q-drawer__backdrop" + (!showing.value && !flagPanning.value ? " hidden" : ""));
		const backdropStyle = computed(() => ({ backgroundColor: `rgba(0,0,0,${flagBackdropBg.value * .4})` }));
		const headerSlot = computed(() => rightSide.value ? $layout.rows.value.top[2] === "r" : $layout.rows.value.top[0] === "l");
		const footerSlot = computed(() => rightSide.value ? $layout.rows.value.bottom[2] === "r" : $layout.rows.value.bottom[0] === "l");
		const aboveStyle = computed(() => {
			const css = {};
			if ($layout.header.space && !headerSlot.value) {
				if (fixed.value) css.top = `${$layout.header.offset}px`;
				else if ($layout.header.space) css.top = `${$layout.header.size}px`;
			}
			if ($layout.footer.space && !footerSlot.value) {
				if (fixed.value) css.bottom = `${$layout.footer.offset}px`;
				else if ($layout.footer.space) css.bottom = `${$layout.footer.size}px`;
			}
			return css;
		});
		const style = computed(() => {
			const acc = {
				width: `${size.value}px`,
				transform: `translateX(${flagContentPosition.value}px)`
			};
			return belowBreakpoint.value ? acc : Object.assign(acc, aboveStyle.value);
		});
		const contentClass = computed(() => "q-drawer__content fit " + ($layout.isContainer.value ? "overflow-auto" : "scroll"));
		const classes = computed(() => `q-drawer q-drawer--${props.side}` + (flagMiniAnimate.value ? " q-drawer--mini-animate" : "") + (props.bordered ? " q-drawer--bordered" : "") + (isDark.value ? " q-drawer--dark q-dark" : "") + (flagPanning.value ? " no-transition" : showing.value ? "" : " q-layout--prevent-focus") + (belowBreakpoint.value ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${isMini.value ? "mini" : "standard"}` + (fixed.value || !onLayout.value ? " fixed" : "") + (props.overlay || props.miniToOverlay ? " q-drawer--on-top" : "") + (headerSlot.value ? " q-drawer--top-padding" : "")));
		const openDirective = computed(() => {
			return [[
				TouchPan_default,
				onOpenPan,
				void 0,
				{
					[$q.lang.rtl ? props.side : otherSide.value]: true,
					mouse: true
				}
			]];
		});
		const contentCloseDirective = computed(() => {
			return [[
				TouchPan_default,
				onClosePan,
				void 0,
				{
					[$q.lang.rtl ? otherSide.value : props.side]: true,
					mouse: true
				}
			]];
		});
		const backdropCloseDirective = computed(() => {
			return [[
				TouchPan_default,
				onClosePan,
				void 0,
				{
					[$q.lang.rtl ? otherSide.value : props.side]: true,
					mouse: true,
					mouseAllDir: true
				}
			]];
		});
		function updateBelowBreakpoint() {
			updateLocal$2(belowBreakpoint, props.behavior === "mobile" || props.behavior !== "desktop" && $layout.totalWidth.value <= props.breakpoint);
		}
		watch(belowBreakpoint, (val) => {
			if (val) {
				lastDesktopState = showing.value;
				if (showing.value) hide(false);
			} else if (!props.overlay && props.behavior !== "mobile" && lastDesktopState !== false) if (showing.value) {
				applyPosition(0);
				applyBackdrop(0);
				cleanup();
			} else show(false);
		});
		watch(() => props.side, (newSide, oldSide) => {
			if ($layout.instances[oldSide] === instance) {
				$layout.instances[oldSide] = void 0;
				$layout[oldSide].space = false;
				$layout[oldSide].offset = 0;
			}
			$layout.instances[newSide] = instance;
			$layout[newSide].size = size.value;
			$layout[newSide].space = onLayout.value;
			$layout[newSide].offset = offset.value;
		});
		watch($layout.totalWidth, () => {
			if ($layout.isContainer.value || !document.qScrollPrevented) updateBelowBreakpoint();
		});
		watch(() => props.behavior + props.breakpoint, updateBelowBreakpoint);
		watch($layout.isContainer, (val) => {
			if (showing.value) preventBodyScroll(!val);
			if (val) updateBelowBreakpoint();
		});
		watch($layout.scrollbarWidth, () => {
			applyPosition(showing.value ? 0 : void 0);
		});
		watch(offset, (val) => {
			updateLayout("offset", val);
		});
		watch(onLayout, (val) => {
			emit("onLayout", val);
			updateLayout("space", val);
		});
		watch(rightSide, () => {
			applyPosition();
		});
		watch(size, (val) => {
			applyPosition();
			updateSizeOnLayout(props.miniToOverlay, val);
		});
		watch(() => props.miniToOverlay, (val) => {
			updateSizeOnLayout(val, size.value);
		});
		watch(() => $q.lang.rtl, () => {
			applyPosition();
		});
		watch(() => props.mini, () => {
			if (props.noMiniAnimation) return;
			if (props.modelValue) {
				animateMini();
				$layout.animate();
			}
		});
		watch(isMini, (val) => {
			emit("miniState", val);
		});
		function applyPosition(position) {
			if (position === void 0) nextTick(() => {
				position = showing.value ? 0 : size.value;
				applyPosition(stateDirection.value * position);
			});
			else {
				if ($layout.isContainer.value && rightSide.value && (belowBreakpoint.value || Math.abs(position) === size.value)) position += stateDirection.value * $layout.scrollbarWidth.value;
				flagContentPosition.value = position;
			}
		}
		function applyBackdrop(x) {
			flagBackdropBg.value = x;
		}
		function setScrollable(v) {
			const action = v ? "remove" : $layout.isContainer.value ? "" : "add";
			if (action !== "") document.body.classList[action]("q-body--drawer-toggle");
		}
		function animateMini() {
			if (timerMini !== null) clearTimeout(timerMini);
			if (vm.proxy && vm.proxy.$el) vm.proxy.$el.classList.add("q-drawer--mini-animate");
			flagMiniAnimate.value = true;
			timerMini = setTimeout(() => {
				timerMini = null;
				flagMiniAnimate.value = false;
				vm?.proxy?.$el?.classList.remove("q-drawer--mini-animate");
			}, 150);
		}
		function onOpenPan(evt) {
			if (showing.value) return;
			const width = size.value, position = between(evt.distance.x, 0, width);
			if (evt.isFinal) {
				if (position >= Math.min(75, width)) show();
				else {
					$layout.animate();
					applyBackdrop(0);
					applyPosition(stateDirection.value * width);
				}
				flagPanning.value = false;
				return;
			}
			applyPosition(($q.lang.rtl ? !rightSide.value : rightSide.value) ? Math.max(width - position, 0) : Math.min(0, position - width));
			applyBackdrop(between(position / width, 0, 1));
			if (evt.isFirst) flagPanning.value = true;
		}
		function onClosePan(evt) {
			if (!showing.value) return;
			const width = size.value, dir = evt.direction === props.side, position = ($q.lang.rtl ? !dir : dir) ? between(evt.distance.x, 0, width) : 0;
			if (evt.isFinal) {
				if (Math.abs(position) < Math.min(75, width)) {
					$layout.animate();
					applyBackdrop(1);
					applyPosition(0);
				} else hide();
				flagPanning.value = false;
				return;
			}
			applyPosition(stateDirection.value * position);
			applyBackdrop(between(1 - position / width, 0, 1));
			if (evt.isFirst) flagPanning.value = true;
		}
		function cleanup() {
			preventBodyScroll(false);
			setScrollable(true);
		}
		function updateLayout(prop, val) {
			$layout.update(props.side, prop, val);
		}
		function updateSizeOnLayout(miniToOverlay, newSize) {
			updateLayout("size", miniToOverlay ? props.miniWidth : newSize);
		}
		$layout.instances[props.side] = instance;
		updateSizeOnLayout(props.miniToOverlay, size.value);
		updateLayout("space", onLayout.value);
		updateLayout("offset", offset.value);
		if (props.showIfAbove && !props.modelValue && showing.value && props["onUpdate:modelValue"] !== void 0) emit("update:modelValue", true);
		onMounted(() => {
			emit("onLayout", onLayout.value);
			emit("miniState", isMini.value);
			lastDesktopState = props.showIfAbove;
			const fn = () => {
				(showing.value ? handleShow : handleHide)(false, true);
			};
			if ($layout.totalWidth.value !== 0) {
				nextTick(fn);
				return;
			}
			layoutTotalWidthWatcher = watch($layout.totalWidth, () => {
				layoutTotalWidthWatcher();
				layoutTotalWidthWatcher = void 0;
				if (!showing.value && props.showIfAbove && !belowBreakpoint.value) show(false);
				else fn();
			});
		});
		onBeforeUnmount(() => {
			layoutTotalWidthWatcher?.();
			if (timerMini !== null) {
				clearTimeout(timerMini);
				timerMini = null;
			}
			if (showing.value) cleanup();
			if ($layout.instances[props.side] === instance) {
				$layout.instances[props.side] = void 0;
				updateLayout("size", 0);
				updateLayout("offset", 0);
				updateLayout("space", false);
			}
		});
		return () => {
			const child = [];
			if (belowBreakpoint.value) {
				if (!props.noSwipeOpen) child.push(withDirectives(h("div", {
					key: "open",
					class: `q-drawer__opener fixed-${props.side}`,
					"aria-hidden": "true"
				}), openDirective.value));
				child.push(hDir("div", {
					ref: "backdrop",
					class: backdropClass.value,
					style: backdropStyle.value,
					"aria-hidden": "true",
					onClick: hide
				}, void 0, "backdrop", !props.noSwipeBackdrop && showing.value, () => backdropCloseDirective.value));
			}
			const mini = isMini.value && slots.mini !== void 0;
			const content = [h("div", {
				...attrs,
				key: String(mini),
				class: [contentClass.value, attrs.class]
			}, mini ? slots.mini() : hSlot(slots.default))];
			if (props.elevated && showing.value) content.push(h("div", { class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events" }));
			child.push(hDir("aside", {
				ref: "content",
				class: classes.value,
				style: style.value
			}, content, "contentclose", !props.noSwipeClose && belowBreakpoint.value, () => contentCloseDirective.value));
			return h("div", { class: "q-drawer-container" }, child);
		};
	}
});
var tagList = [
	"div",
	"li",
	"ul",
	"ol",
	"blockquote"
];
function getBlockElement(el, parent) {
	if (parent && el === parent) return null;
	const nodeName = el.nodeName.toLowerCase();
	if (tagList.includes(nodeName)) return el;
	const display = (window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle).display;
	if (display === "block" || display === "table") return el;
	return getBlockElement(el.parentNode);
}
function createRange(node, chars, range) {
	if (!range) {
		range = document.createRange();
		range.selectNode(node);
		range.setStart(node, 0);
	}
	if (chars.count === 0) range.setEnd(node, chars.count);
	else if (chars.count > 0) if (node.nodeType === Node.TEXT_NODE) if (node.textContent.length < chars.count) chars.count -= node.textContent.length;
	else {
		range.setEnd(node, chars.count);
		chars.count = 0;
	}
	else for (let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) range = createRange(node.childNodes[lp], chars, range);
	return range;
}
var nonSelectableCount = 0;
var QTooltip_default = /*#__PURE__*/ createComponent({
	name: "QTooltip",
	inheritAttrs: false,
	props: {
		...useAnchorStaticProps,
		...useModelToggleProps,
		...useTransitionProps,
		maxHeight: {
			type: String,
			default: null
		},
		maxWidth: {
			type: String,
			default: null
		},
		transitionShow: {
			...useTransitionProps.transitionShow,
			default: "jump-down"
		},
		transitionHide: {
			...useTransitionProps.transitionHide,
			default: "jump-up"
		},
		anchor: {
			type: String,
			default: "bottom middle",
			validator: validatePosition
		},
		self: {
			type: String,
			default: "top middle",
			validator: validatePosition
		},
		offset: {
			type: Array,
			default: () => [14, 14],
			validator: validateOffset
		},
		scrollTarget: scrollTargetProp,
		delay: {
			type: Number,
			default: 0
		},
		hideDelay: {
			type: Number,
			default: 0
		},
		persistent: Boolean
	},
	emits: [...useModelToggleEmits],
	setup(props, { slots, emit, attrs }) {
		let unwatchPosition, observer, removeNonSelectableTimer, hasNonSelectable = false, describedBy;
		const vm = getCurrentInstance();
		const { proxy: { $q } } = vm;
		const innerRef = ref(null);
		const showing = ref(false);
		const targetUid = useId();
		const tooltipId = computed(() => attrs.id || targetUid.value);
		const anchorOrigin = computed(() => parsePosition(props.anchor, $q.lang.rtl));
		const selfOrigin = computed(() => parsePosition(props.self, $q.lang.rtl));
		const hideOnRouteChange = computed(() => !props.persistent);
		const { registerTick, removeTick } = useTick();
		const { registerTimeout } = useTimeout();
		const { transitionProps, transitionStyle } = useTransition(props);
		const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = useScrollTarget(props, configureScrollTarget);
		const { anchorEl, canShow, anchorEvents } = useAnchor({
			showing,
			configureAnchorEl
		});
		const { show, hide } = useModelToggle({
			showing,
			canShow,
			handleShow,
			handleHide,
			hideOnRouteChange,
			processOnMount: true
		});
		Object.assign(anchorEvents, {
			delayShow,
			delayHide,
			onFocusin
		});
		const { showPortal, hidePortal, renderPortal } = usePortal(vm, innerRef, renderPortalContent, "tooltip");
		if ($q.platform.is.mobile) {
			const clickOutsideProps = {
				anchorEl,
				innerRef,
				onClickOutside(e) {
					hide(e);
					if (e.target.classList.contains("q-dialog__backdrop")) stopAndPrevent(e);
					return true;
				}
			};
			watch(computed(() => props.modelValue === null && !props.persistent && showing.value), (val) => {
				(val ? addClickOutside : removeClickOutside)(clickOutsideProps);
			});
			onBeforeUnmount(() => {
				removeClickOutside(clickOutsideProps);
			});
		} else watch(() => (props.modelValue === null || props["onUpdate:modelValue"]) && showing.value === true && props.persistent !== true, (val) => {
			(val === true ? addEscapeKey : removeEscapeKey)(onEscapeKey);
		});
		function handleShow(evt) {
			showPortal();
			addAriaDescription();
			registerTick(() => {
				observer?.disconnect();
				if (innerRef.value === null) {
					observer = void 0;
					return;
				}
				observer = new MutationObserver(() => updatePosition());
				observer.observe(innerRef.value, {
					attributes: false,
					childList: true,
					characterData: true,
					subtree: true
				});
				updatePosition();
				configureScrollTarget();
			});
			if (unwatchPosition === void 0) unwatchPosition = watch(() => $q.screen.width + "|" + $q.screen.height + "|" + props.self + "|" + props.anchor + "|" + $q.lang.rtl, updatePosition);
			registerTimeout(() => {
				showPortal(true);
				emit("show", evt);
			}, props.transitionDuration);
		}
		function handleHide(evt) {
			removeTick();
			hidePortal();
			anchorCleanup();
			registerTimeout(() => {
				hidePortal(true);
				emit("hide", evt);
			}, props.transitionDuration);
		}
		function anchorCleanup() {
			if (observer !== void 0) {
				observer.disconnect();
				observer = void 0;
			}
			if (unwatchPosition !== void 0) {
				unwatchPosition();
				unwatchPosition = void 0;
			}
			unconfigureScrollTarget();
			removeEscapeKey(onEscapeKey);
			cleanEvt(anchorEvents, "tooltipTemp");
			removeAriaDescription();
			setNonSelectable(false);
		}
		function updatePosition() {
			setPosition({
				targetEl: innerRef.value,
				offset: props.offset,
				anchorEl: anchorEl.value,
				anchorOrigin: anchorOrigin.value,
				selfOrigin: selfOrigin.value,
				maxHeight: props.maxHeight,
				maxWidth: props.maxWidth
			});
		}
		function delayShow(evt) {
			if ($q.platform.is.mobile) {
				if (removeNonSelectableTimer !== void 0) {
					clearTimeout(removeNonSelectableTimer);
					removeNonSelectableTimer = void 0;
				}
				clearSelection();
				setNonSelectable(true);
				const target = anchorEl.value;
				const evts = [
					"touchmove",
					"touchcancel",
					"touchend",
					"click"
				].map((e) => [
					target,
					e,
					"delayHide",
					"passiveCapture"
				]);
				addEvt(anchorEvents, "tooltipTemp", evts);
			}
			registerTimeout(() => {
				show(evt);
			}, props.delay);
		}
		function delayHide(evt) {
			if ($q.platform.is.mobile) {
				cleanEvt(anchorEvents, "tooltipTemp");
				clearSelection();
				removeNonSelectableTimer = setTimeout(() => {
					removeNonSelectableTimer = void 0;
					setNonSelectable(false);
				}, 10);
			}
			registerTimeout(() => {
				hide(evt);
			}, props.hideDelay);
		}
		function onFocusin(evt) {
			const el = evt.target;
			if (!el) return;
			try {
				if (el.matches(":focus-visible") === false) return;
			} catch {}
			delayShow(evt);
		}
		function onEscapeKey(evt) {
			hide(evt);
		}
		function configureAnchorEl() {
			if (props.noParentEvent || anchorEl.value === null) return;
			const evts = $q.platform.is.mobile ? [[
				anchorEl.value,
				"touchstart",
				"delayShow",
				"passive"
			]] : [
				[
					anchorEl.value,
					"mouseenter",
					"delayShow",
					"passive"
				],
				[
					anchorEl.value,
					"mouseleave",
					"delayHide",
					"passive"
				],
				[
					anchorEl.value,
					"focusin",
					"onFocusin",
					"passive"
				],
				[
					anchorEl.value,
					"focusout",
					"delayHide",
					"passive"
				]
			];
			addEvt(anchorEvents, "anchor", evts);
		}
		function setNonSelectable(state) {
			if (hasNonSelectable === state) return;
			hasNonSelectable = state;
			nonSelectableCount += state ? 1 : -1;
			document.body.classList.toggle("non-selectable", nonSelectableCount > 0);
			if (!state && removeNonSelectableTimer !== void 0) {
				clearTimeout(removeNonSelectableTimer);
				removeNonSelectableTimer = void 0;
			}
		}
		function addAriaDescription() {
			const el = anchorEl.value, id = tooltipId.value;
			if (el === null || id === void 0) return;
			const ids = (el.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
			describedBy = {
				el,
				id,
				added: !ids.includes(id)
			};
			if (describedBy.added) {
				ids.push(id);
				el.setAttribute("aria-describedby", ids.join(" "));
			}
		}
		function removeAriaDescription() {
			if (describedBy?.added === true) {
				const { el, id } = describedBy, value = (el.getAttribute("aria-describedby") || "").split(/\s+/).filter((entry) => entry !== "" && entry !== id);
				if (value.length === 0) el.removeAttribute("aria-describedby");
				else el.setAttribute("aria-describedby", value.join(" "));
			}
			describedBy = void 0;
		}
		function configureScrollTarget() {
			if (anchorEl.value !== null || props.scrollTarget !== void 0) {
				localScrollTarget.value = getScrollTarget(anchorEl.value, props.scrollTarget);
				const fn = props.noParentEvent ? updatePosition : hide;
				changeScrollEvent(localScrollTarget.value, fn);
			}
		}
		function getTooltipContent() {
			return showing.value ? h("div", {
				...attrs,
				id: tooltipId.value,
				ref: innerRef,
				class: ["q-tooltip q-tooltip--style q-position-engine no-pointer-events", attrs.class],
				style: [attrs.style, transitionStyle.value],
				role: "tooltip"
			}, hSlot(slots.default)) : null;
		}
		function renderPortalContent() {
			return h(Transition, transitionProps.value, getTooltipContent);
		}
		onBeforeUnmount(anchorCleanup);
		Object.assign(vm.proxy, { updatePosition });
		return renderPortal;
	}
});
var QItem_default = /*#__PURE__*/ createComponent({
	name: "QItem",
	props: {
		...useDarkProps,
		...useRouterLinkProps,
		tag: {
			type: String,
			default: "div"
		},
		active: {
			type: Boolean,
			default: null
		},
		clickable: Boolean,
		dense: Boolean,
		insetLevel: Number,
		tabindex: [String, Number],
		focused: Boolean,
		manualFocus: Boolean
	},
	emits: ["click", "keyup"],
	setup(props, { slots, emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const isDark = useDark(props, $q);
		const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = useRouterLink();
		const rootRef = ref(null);
		const blurTargetRef = ref(null);
		const isActionable = computed(() => props.clickable || hasLink.value || props.tag === "label");
		const isClickable = computed(() => !props.disable && isActionable.value);
		const classes = computed(() => "q-item q-item-type row no-wrap" + (props.dense ? " q-item--dense" : "") + (isDark.value ? " q-item--dark" : "") + (hasLink.value && props.active === null ? linkClass.value : props.active ? ` q-item--active${props.activeClass !== void 0 ? ` ${props.activeClass}` : ""}` : "") + (props.disable ? " disabled" : "") + (isClickable.value ? " q-item--clickable q-link cursor-pointer " + (props.manualFocus ? "q-manual-focusable" : "q-focusable q-hoverable") + (props.focused ? " q-manual-focusable--focused" : "") : ""));
		const style = computed(() => {
			if (props.insetLevel === void 0) return null;
			return { ["padding" + ($q.lang.rtl ? "Right" : "Left")]: 16 + props.insetLevel * 56 + "px" };
		});
		function onClick(e) {
			if (isClickable.value) {
				if (blurTargetRef.value !== null && !e.qAvoidFocus) {
					if (!e.qKeyEvent && document.activeElement === rootRef.value) blurTargetRef.value.focus({ preventScroll: true });
					else if (document.activeElement === blurTargetRef.value) rootRef.value.focus({ preventScroll: true });
				}
				navigateOnClick(e);
			}
		}
		function onKeyup(e) {
			if (isClickable.value && isKeyCode(e, [13, 32])) {
				stopAndPrevent(e);
				e.qKeyEvent = true;
				const evt = new MouseEvent("click", e);
				evt.qKeyEvent = true;
				rootRef.value.dispatchEvent(evt);
			}
			emit("keyup", e);
		}
		function onKeydown(e) {
			if (isClickable.value && e.keyCode === 32) stopAndPrevent(e);
		}
		function getContent() {
			const child = hUniqueSlot(slots.default, []);
			if (isClickable.value) child.unshift(h("div", {
				class: "q-focus-helper",
				tabindex: -1,
				ref: blurTargetRef
			}));
			return child;
		}
		return () => {
			const data = {
				ref: rootRef,
				class: classes.value,
				style: style.value,
				role: hasLink.value ? void 0 : isClickable.value ? "button" : "listitem",
				onClick,
				onKeydown,
				onKeyup
			};
			if (isClickable.value) {
				data.tabindex = props.tabindex || "0";
				Object.assign(data, linkAttrs.value);
			} else if (isActionable.value) data["aria-disabled"] = "true";
			return h(linkTag.value, data, getContent());
		};
	}
});
var QItemSection_default = /*#__PURE__*/ createComponent({
	name: "QItemSection",
	props: {
		avatar: Boolean,
		thumbnail: Boolean,
		side: Boolean,
		top: Boolean,
		noWrap: Boolean
	},
	setup(props, { slots }) {
		const classes = computed(() => `q-item__section column q-item__section--${props.avatar || props.side || props.thumbnail ? "side" : "main"}` + (props.top ? " q-item__section--top justify-start" : " justify-center") + (props.avatar ? " q-item__section--avatar" : "") + (props.thumbnail ? " q-item__section--thumbnail" : "") + (props.noWrap ? " q-item__section--nowrap" : ""));
		return () => h("div", { class: classes.value }, hSlot(slots.default));
	}
});
var listenerRE = /^on[A-Z]/;
function useSplitAttrs() {
	const vm = getCurrentInstance();
	const { attrs } = vm;
	const acc = {
		listeners: ref({}),
		attributes: ref({})
	};
	function update() {
		const attributes = {};
		const listeners = {};
		for (const key in attrs) if (key !== "class" && key !== "style" && !listenerRE.test(key)) attributes[key] = attrs[key];
		for (const key in vm.vnode.props) if (listenerRE.test(key)) listeners[key] = vm.vnode.props[key];
		acc.attributes.value = attributes;
		acc.listeners.value = listeners;
	}
	onBeforeUpdate(update);
	update();
	return acc;
}
var toString = Object.prototype.toString;
var hasOwn = Object.prototype.hasOwnProperty;
var notPlainObject = new Set([
	"Boolean",
	"Number",
	"String",
	"Function",
	"Array",
	"Date",
	"RegExp"
].map((name) => "[object " + name + "]"));
function isPlainObject(obj) {
	if (obj !== Object(obj) || notPlainObject.has(toString.call(obj))) return false;
	if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) return false;
	let key;
	for (key in obj);
	return key === void 0 || hasOwn.call(obj, key);
}
function extend(...args) {
	let options, name, src, copy, copyIsArray, clone, target = args[0] || {}, i = 1, deep = false;
	const length = args.length;
	if (typeof target === "boolean") {
		deep = target;
		target = args[1] || {};
		i = 2;
	}
	if (Object(target) !== target && typeof target !== "function") target = {};
	if (length === i) {
		target = this;
		i--;
	}
	for (; i < length; i++) if ((options = args[i]) !== null) for (name in options) {
		if (name === "__proto__") continue;
		src = target[name];
		copy = options[name];
		if (target === copy) continue;
		if (deep && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject(copy))) {
			if (copyIsArray) clone = Array.isArray(src) ? src : [];
			else clone = isPlainObject(src) ? src : {};
			target[name] = extend(deep, clone, copy);
		} else if (copy !== void 0) target[name] = copy;
	}
	return target;
}
({
	...useDarkProps,
	...useFullscreenProps
}), [...useFullscreenEmits];
var QItemLabel_default = /*#__PURE__*/ createComponent({
	name: "QItemLabel",
	props: {
		overline: Boolean,
		caption: Boolean,
		header: Boolean,
		lines: [Number, String]
	},
	setup(props, { slots }) {
		const parsedLines = computed(() => Number.parseInt(props.lines, 10));
		const classes = computed(() => "q-item__label" + (props.overline ? " q-item__label--overline text-overline" : "") + (props.caption ? " q-item__label--caption text-caption" : "") + (props.header ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : ""));
		const style = computed(() => props.lines !== void 0 && parsedLines.value > 1 ? {
			overflow: "hidden",
			display: "-webkit-box",
			"-webkit-box-orient": "vertical",
			"-webkit-line-clamp": parsedLines.value
		} : null);
		return () => h("div", {
			style: style.value,
			class: classes.value
		}, hSlot(slots.default));
	}
});
var QSlideTransition_default = /*#__PURE__*/ createComponent({
	name: "QSlideTransition",
	props: {
		appear: Boolean,
		duration: {
			type: Number,
			default: 300
		}
	},
	emits: ["show", "hide"],
	setup(props, { slots, emit }) {
		let animating = false, doneFn, element;
		let timer = null, timerFallback = null, animListener, lastEvent;
		function cleanup() {
			doneFn?.();
			doneFn = null;
			animating = false;
			if (timer !== null) {
				clearTimeout(timer);
				timer = null;
			}
			if (timerFallback !== null) {
				clearTimeout(timerFallback);
				timerFallback = null;
			}
			element?.removeEventListener("transitionend", animListener);
			animListener = null;
		}
		function begin(el, height, done) {
			if (height !== void 0) el.style.height = `${height}px`;
			el.style.transition = `height ${props.duration}ms cubic-bezier(.25, .8, .50, 1)`;
			animating = true;
			doneFn = done;
		}
		function end(el, event) {
			el.style.overflowY = null;
			el.style.height = null;
			el.style.transition = null;
			cleanup();
			if (event !== lastEvent) emit(event);
		}
		function onEnter(el, done) {
			let pos = 0;
			element = el;
			if (animating) {
				cleanup();
				pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
			} else {
				lastEvent = "hide";
				el.style.overflowY = "hidden";
			}
			begin(el, pos, done);
			timer = setTimeout(() => {
				timer = null;
				el.style.height = `${el.scrollHeight}px`;
				animListener = (evt) => {
					if (Object(evt) !== evt || evt.target === el) end(el, "show");
				};
				el.addEventListener("transitionend", animListener);
				timerFallback = setTimeout(animListener, props.duration * 1.1);
			}, 100);
		}
		function onLeave(el, done) {
			let pos;
			element = el;
			if (animating) cleanup();
			else {
				lastEvent = "show";
				el.style.overflowY = "hidden";
				pos = el.scrollHeight;
			}
			begin(el, pos, done);
			timer = setTimeout(() => {
				timer = null;
				el.style.height = 0;
				animListener = (evt) => {
					if (Object(evt) !== evt || evt.target === el) end(el, "hide");
				};
				el.addEventListener("transitionend", animListener);
				timerFallback = setTimeout(animListener, props.duration * 1.1);
			}, 100);
		}
		onBeforeUnmount(() => {
			if (animating) cleanup();
		});
		return () => h(Transition, {
			css: false,
			appear: props.appear,
			onEnter,
			onLeave
		}, slots.default);
	}
});
var insetMap = {
	true: "inset",
	item: "item-inset",
	"item-thumbnail": "item-thumbnail-inset"
};
var margins = {
	xs: 2,
	sm: 4,
	md: 8,
	lg: 16,
	xl: 24
};
var QSeparator_default = /*#__PURE__*/ createComponent({
	name: "QSeparator",
	props: {
		...useDarkProps,
		spaced: [Boolean, String],
		inset: [Boolean, String],
		vertical: Boolean,
		color: String,
		size: String
	},
	setup(props) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const orientation = computed(() => props.vertical ? "vertical" : "horizontal");
		const orientClass = computed(() => ` q-separator--${orientation.value}`);
		const insetClass = computed(() => props.inset ? `${orientClass.value}-${insetMap[props.inset]}` : "");
		const classes = computed(() => `q-separator${orientClass.value}${insetClass.value}` + (props.color !== void 0 ? ` bg-${props.color}` : "") + (isDark.value ? " q-separator--dark" : ""));
		const style = computed(() => {
			const acc = {};
			if (props.size !== void 0) acc[props.vertical ? "width" : "height"] = props.size;
			if (props.spaced) {
				const size = props.spaced === true ? `${margins.md}px` : props.spaced in margins ? `${margins[props.spaced]}px` : props.spaced;
				const dir = props.vertical ? ["Left", "Right"] : ["Top", "Bottom"];
				acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size;
			}
			return acc;
		});
		return () => h("hr", {
			class: classes.value,
			style: style.value,
			"aria-orientation": orientation.value
		});
	}
});
var itemGroups = /*#__PURE__*/ shallowReactive({});
function preventSpace$2(e) {
	if (e.keyCode === 32) stopAndPrevent(e);
}
var LINK_PROPS = Object.keys(useRouterLinkProps);
var QExpansionItem_default = /*#__PURE__*/ createComponent({
	name: "QExpansionItem",
	props: {
		...useRouterLinkProps,
		...useModelToggleProps,
		...useDarkProps,
		icon: String,
		label: String,
		labelLines: [Number, String],
		caption: String,
		captionLines: [Number, String],
		dense: Boolean,
		toggleAriaLabel: String,
		expandIcon: String,
		expandedIcon: String,
		expandIconClass: [
			Array,
			String,
			Object
		],
		duration: {},
		headerInsetLevel: Number,
		contentInsetLevel: Number,
		expandSeparator: Boolean,
		defaultOpened: Boolean,
		hideExpandIcon: Boolean,
		expandIconToggle: Boolean,
		switchToggleSide: Boolean,
		denseToggle: Boolean,
		group: String,
		popup: Boolean,
		headerStyle: [
			Array,
			String,
			Object
		],
		headerClass: [
			Array,
			String,
			Object
		]
	},
	emits: [
		...useModelToggleEmits,
		"click",
		"afterShow",
		"afterHide"
	],
	setup(props, { slots, emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const isDark = useDark(props, $q);
		const showing = ref(props.modelValue !== null ? props.modelValue : props.defaultOpened);
		const blurTargetRef = ref(null);
		const targetUid = useId();
		const { show, hide, toggle } = useModelToggle({ showing });
		let uniqueId, exitGroup;
		const classes = computed(() => `q-expansion-item q-item-type q-expansion-item--${showing.value ? "expanded" : "collapsed"} q-expansion-item--${props.popup ? "popup" : "standard"}`);
		const contentStyle = computed(() => {
			if (props.contentInsetLevel === void 0) return null;
			return { ["padding" + ($q.lang.rtl ? "Right" : "Left")]: props.contentInsetLevel * 56 + "px" };
		});
		const hasLink = computed(() => !props.disable && (props.href !== void 0 || props.to !== void 0 && props.to !== null && props.to !== ""));
		const linkProps = computed(() => {
			const acc = {};
			LINK_PROPS.forEach((key) => {
				acc[key] = props[key];
			});
			return acc;
		});
		const isClickable = computed(() => hasLink.value || !props.expandIconToggle);
		const expansionIcon = computed(() => props.expandedIcon !== void 0 && showing.value ? props.expandedIcon : props.expandIcon || $q.iconSet.expansionItem[props.denseToggle ? "denseIcon" : "icon"]);
		const activeToggleIcon = computed(() => !props.disable && (hasLink.value || props.expandIconToggle));
		const headerSlotScope = computed(() => ({
			expanded: showing.value,
			detailsId: targetUid.value,
			toggle,
			show,
			hide
		}));
		const toggleAriaAttrs = computed(() => {
			const toggleAriaLabel = props.toggleAriaLabel !== void 0 ? props.toggleAriaLabel : $q.lang.label[showing.value ? "collapse" : "expand"](props.label);
			return {
				role: "button",
				"aria-expanded": showing.value ? "true" : "false",
				"aria-controls": targetUid.value,
				"aria-label": toggleAriaLabel
			};
		});
		watch(() => props.group, (name) => {
			exitGroup?.();
			if (name !== void 0) enterGroup();
		});
		function onHeaderClick(e) {
			if (!hasLink.value) toggle(e);
			emit("click", e);
		}
		function toggleIconKeyboard(e) {
			if ([13, 32].includes(e.keyCode)) toggleIcon(e, true);
		}
		function toggleIcon(e, keyboard) {
			if (!keyboard && !e.qAvoidFocus) blurTargetRef.value?.focus({ preventScroll: true });
			toggle(e);
			stopAndPrevent(e);
		}
		function onShow() {
			emit("afterShow");
		}
		function onHide() {
			emit("afterHide");
		}
		function enterGroup() {
			if (uniqueId === void 0) uniqueId = uid_default();
			if (showing.value) itemGroups[props.group] = uniqueId;
			const stopShowWatcher = watch(showing, (val) => {
				if (val) itemGroups[props.group] = uniqueId;
				else if (itemGroups[props.group] === uniqueId) delete itemGroups[props.group];
			});
			const stopGroupWatcher = watch(() => itemGroups[props.group], (val, oldVal) => {
				if (oldVal === uniqueId && val !== void 0 && val !== uniqueId) hide();
			});
			exitGroup = () => {
				stopShowWatcher();
				stopGroupWatcher();
				if (itemGroups[props.group] === uniqueId) delete itemGroups[props.group];
				exitGroup = void 0;
			};
		}
		function getToggleIcon() {
			const data = {
				class: [`q-focusable relative-position cursor-pointer${props.denseToggle && props.switchToggleSide ? " items-end" : ""}`, props.expandIconClass],
				side: !props.switchToggleSide,
				avatar: props.switchToggleSide
			};
			const child = [h(QIcon_default, {
				class: "q-expansion-item__toggle-icon" + (props.expandedIcon === void 0 && showing.value ? " q-expansion-item__toggle-icon--rotated" : ""),
				name: expansionIcon.value
			})];
			if (activeToggleIcon.value) {
				Object.assign(data, {
					tabindex: 0,
					...toggleAriaAttrs.value,
					onClick: toggleIcon,
					onKeydown: preventSpace$2,
					onKeyup: toggleIconKeyboard
				});
				child.unshift(h("div", {
					ref: blurTargetRef,
					class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
					tabindex: -1
				}));
			}
			return h(QItemSection_default, data, () => child);
		}
		function getHeaderChild() {
			let child;
			if (slots.header !== void 0) child = [slots.header(headerSlotScope.value)].flat();
			else {
				child = [h(QItemSection_default, () => [h(QItemLabel_default, { lines: props.labelLines }, () => props.label || ""), props.caption ? h(QItemLabel_default, {
					lines: props.captionLines,
					caption: true
				}, () => props.caption) : null])];
				if (props.icon) child[props.switchToggleSide ? "push" : "unshift"](h(QItemSection_default, {
					side: props.switchToggleSide,
					avatar: !props.switchToggleSide
				}, () => h(QIcon_default, { name: props.icon })));
			}
			if (!props.disable && !props.hideExpandIcon) child[props.switchToggleSide ? "unshift" : "push"](getToggleIcon());
			return child;
		}
		function getHeader() {
			const data = {
				ref: "item",
				style: props.headerStyle,
				class: props.headerClass,
				dark: isDark.value,
				disable: props.disable,
				dense: props.dense,
				insetLevel: props.headerInsetLevel
			};
			if (isClickable.value) {
				data.clickable = true;
				data.onClick = onHeaderClick;
				Object.assign(data, hasLink.value ? linkProps.value : toggleAriaAttrs.value);
			}
			return h(QItem_default, data, getHeaderChild);
		}
		function getTransitionChild() {
			return withDirectives(h("div", {
				key: "e-content",
				class: "q-expansion-item__content relative-position",
				style: contentStyle.value,
				id: targetUid.value
			}, hSlot(slots.default)), [[vShow, showing.value]]);
		}
		function getContent() {
			const node = [getHeader(), h(QSlideTransition_default, {
				duration: props.duration,
				onShow,
				onHide
			}, getTransitionChild)];
			if (props.expandSeparator) node.push(h(QSeparator_default, {
				class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
				dark: isDark.value
			}), h(QSeparator_default, {
				class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
				dark: isDark.value
			}));
			return node;
		}
		if (props.group !== void 0) enterGroup();
		onBeforeUnmount(() => {
			exitGroup?.();
		});
		return () => h("div", { class: classes.value }, [h("div", { class: "q-expansion-item__container relative-position" }, getContent())]);
	}
});
var labelPositions = [
	"top",
	"right",
	"bottom",
	"left"
];
var useFabProps = {
	type: {
		type: String,
		default: "a"
	},
	outline: Boolean,
	push: Boolean,
	flat: Boolean,
	unelevated: Boolean,
	color: String,
	textColor: String,
	glossy: Boolean,
	square: Boolean,
	padding: String,
	label: {
		type: [String, Number],
		default: ""
	},
	labelPosition: {
		type: String,
		default: "right",
		validator: (v) => labelPositions.includes(v)
	},
	externalLabel: Boolean,
	hideLabel: { type: Boolean },
	labelClass: [
		Array,
		String,
		Object
	],
	labelStyle: [
		Array,
		String,
		Object
	],
	disable: Boolean,
	tabindex: [Number, String]
};
({
	...useFabProps,
	...useModelToggleProps
}), { ...useFabProps.hideLabel };
({ ...useFabProps });
function useFormChild({ validate, resetValidation, requiresQForm }) {
	const $form = inject(formKey, false);
	if ($form !== false) {
		const { props, proxy } = getCurrentInstance();
		Object.assign(proxy, {
			validate,
			resetValidation
		});
		watch(() => props.disable, (val) => {
			if (val) {
				if (typeof resetValidation === "function") resetValidation();
				$form.unbindComponent(proxy);
			} else $form.bindComponent(proxy);
		});
		onMounted(() => {
			if (!props.disable) $form.bindComponent(proxy);
		});
		onBeforeUnmount(() => {
			if (!props.disable) $form.unbindComponent(proxy);
		});
	} else if (requiresQForm) console.error("Parent QForm not found on useFormChild()!");
}
var lazyRulesValues = [
	true,
	false,
	"ondemand"
];
var useValidateProps = {
	modelValue: {},
	error: {
		type: Boolean,
		default: null
	},
	errorMessage: String,
	noErrorIcon: Boolean,
	rules: Array,
	reactiveRules: Boolean,
	lazyRules: {
		type: [Boolean, String],
		default: false,
		validator: (v) => lazyRulesValues.includes(v)
	}
};
function useValidate(focused, innerLoading) {
	const { props, proxy } = getCurrentInstance();
	const innerError = ref(false);
	const innerErrorMessage = ref(null);
	const isDirtyModel = ref(false);
	useFormChild({
		validate,
		resetValidation
	});
	let validateIndex = 0, unwatchRules;
	const hasRules = computed(() => props.rules !== void 0 && props.rules !== null && props.rules.length !== 0);
	const canDebounceValidate = computed(() => !props.disable && hasRules.value && !innerLoading.value);
	const hasError = computed(() => props.error === true || innerError.value);
	const errorMessage = computed(() => typeof props.errorMessage === "string" && props.errorMessage.length !== 0 ? props.errorMessage : innerErrorMessage.value);
	watch(() => props.modelValue, () => {
		isDirtyModel.value = true;
		if (canDebounceValidate.value && props.lazyRules === false) debouncedValidate();
	});
	function onRulesChange() {
		if (props.lazyRules !== "ondemand" && canDebounceValidate.value && isDirtyModel.value) debouncedValidate();
	}
	watch(() => props.reactiveRules, (val) => {
		if (val) {
			if (unwatchRules === void 0) unwatchRules = watch(() => props.rules, onRulesChange, {
				immediate: true,
				deep: true
			});
		} else if (unwatchRules !== void 0) {
			unwatchRules();
			unwatchRules = void 0;
		}
	}, { immediate: true });
	watch(() => props.lazyRules, onRulesChange);
	watch(focused, (val) => {
		if (val) isDirtyModel.value = true;
		else if (canDebounceValidate.value && props.lazyRules !== "ondemand") debouncedValidate();
	});
	function resetValidation() {
		validateIndex++;
		innerLoading.value = false;
		isDirtyModel.value = false;
		innerError.value = false;
		innerErrorMessage.value = null;
		debouncedValidate.cancel();
	}
	function validate(val = props.modelValue) {
		if (props.disable || !hasRules.value) return true;
		const index = ++validateIndex;
		const setDirty = innerLoading.value ? () => {} : () => {
			isDirtyModel.value = true;
		};
		const update = (hasErr, msg) => {
			if (hasErr) setDirty();
			innerError.value = hasErr;
			innerErrorMessage.value = msg || null;
			innerLoading.value = false;
		};
		const promises = [];
		for (let i = 0; i < props.rules.length; i++) {
			const rule = props.rules[i];
			let res;
			if (typeof rule === "function") res = rule(val, testPattern);
			else if (typeof rule === "string") if (testPattern[rule] === void 0) {
				console.error(`Unknown validation pattern rule: "${rule}"`);
				res = false;
			} else res = testPattern[rule](val);
			if (res === false || typeof res === "string") {
				update(true, res);
				return false;
			} else if (res !== true && res !== void 0) promises.push(res);
		}
		if (promises.length === 0) {
			update(false);
			return true;
		}
		innerLoading.value = true;
		return Promise.all(promises).then((res) => {
			if (res === void 0 || !Array.isArray(res) || res.length === 0) {
				if (index === validateIndex) update(false);
				return true;
			}
			const msg = res.find((r) => r === false || typeof r === "string");
			if (index === validateIndex) update(msg !== void 0, msg);
			return msg === void 0;
		}, (err) => {
			if (index === validateIndex) {
				console.error(err);
				update(true);
			}
			return false;
		});
	}
	const debouncedValidate = debounce(validate, 0);
	onBeforeUnmount(() => {
		unwatchRules?.();
		debouncedValidate.cancel();
	});
	Object.assign(proxy, {
		resetValidation,
		validate
	});
	injectProp(proxy, "hasError", () => hasError.value);
	return {
		isDirtyModel,
		hasRules,
		hasError,
		errorMessage,
		validate,
		resetValidation
	};
}
function fieldValueIsFilled(val) {
	return val !== void 0 && val !== null && String(val).length !== 0;
}
var useNonInputFieldProps = {
	...useDarkProps,
	...useValidateProps,
	label: String,
	stackLabel: Boolean,
	hint: String,
	hideHint: Boolean,
	prefix: String,
	suffix: String,
	labelColor: String,
	color: String,
	bgColor: String,
	filled: Boolean,
	outlined: Boolean,
	borderless: Boolean,
	standout: [Boolean, String],
	square: Boolean,
	loading: Boolean,
	labelSlot: Boolean,
	bottomSlots: Boolean,
	hideBottomSpace: Boolean,
	rounded: Boolean,
	dense: Boolean,
	itemAligned: Boolean,
	counter: Boolean,
	clearable: Boolean,
	clearIcon: String,
	disable: Boolean,
	readonly: Boolean,
	autofocus: Boolean,
	for: String
};
var useFieldProps = {
	...useNonInputFieldProps,
	maxlength: [Number, String]
};
var useFieldEmits = [
	"update:modelValue",
	"clear",
	"focus",
	"blur"
];
function useFieldState({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
	const { props, proxy } = getCurrentInstance();
	const isDark = useDark(props, proxy.$q);
	const targetUid = useId({
		required: requiredForAttr,
		getValue: () => props.for
	});
	return {
		requiredForAttr,
		changeEvent,
		tag: tagProp ? computed(() => props.tag) : { value: "label" },
		isDark,
		editable: computed(() => !props.disable && !props.readonly),
		innerLoading: ref(false),
		focused: ref(false),
		hasPopupOpen: false,
		splitAttrs: useSplitAttrs(),
		targetUid,
		rootRef: ref(null),
		targetRef: ref(null),
		controlRef: ref(null)
	};
}
function getInnerAppendNode(key, content) {
	return content === null ? null : h("div", {
		key,
		class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
	}, content);
}
function useField(state) {
	const { props, emit, slots, attrs, proxy } = getCurrentInstance();
	const { $q } = proxy;
	let focusoutTimer = null;
	if (state.hasValue === void 0) state.hasValue = computed(() => fieldValueIsFilled(props.modelValue));
	if (state.emitValue === void 0) state.emitValue = (value) => {
		emit("update:modelValue", value);
	};
	if (state.controlEvents === void 0) state.controlEvents = {
		onFocusin: onControlFocusin,
		onFocusout: onControlFocusout
	};
	Object.assign(state, {
		clearValue,
		onControlFocusin,
		onControlFocusout,
		focus
	});
	if (state.computedCounter === void 0) state.computedCounter = computed(() => {
		if (props.counter) {
			const len = typeof props.modelValue === "string" || typeof props.modelValue === "number" ? String(props.modelValue).length : Array.isArray(props.modelValue) ? props.modelValue.length : 0;
			const max = props.maxlength !== void 0 ? props.maxlength : props.maxValues;
			return len + (max !== void 0 ? " / " + max : "");
		}
	});
	const { isDirtyModel, hasRules, hasError, errorMessage, resetValidation } = useValidate(state.focused, state.innerLoading);
	const floatingLabel = state.floatingLabel !== void 0 ? computed(() => props.stackLabel || state.focused.value || state.floatingLabel.value) : computed(() => props.stackLabel || state.focused.value || state.hasValue.value);
	const shouldRenderBottom = computed(() => props.bottomSlots || props.hint !== void 0 || hasRules.value || props.counter || props.error !== null);
	const styleType = computed(() => {
		if (props.filled) return "filled";
		if (props.outlined) return "outlined";
		if (props.borderless) return "borderless";
		if (props.standout) return "standout";
		return "standard";
	});
	const classes = computed(() => `q-field row no-wrap items-start q-field--${styleType.value}` + (state.fieldClass !== void 0 ? ` ${state.fieldClass.value}` : "") + (props.rounded ? " q-field--rounded" : "") + (props.square ? " q-field--square" : "") + (floatingLabel.value ? " q-field--float" : "") + (hasLabel.value ? " q-field--labeled" : "") + (props.dense ? " q-field--dense" : "") + (props.itemAligned ? " q-field--item-aligned q-item-type" : "") + (state.isDark.value ? " q-field--dark" : "") + (state.getControl === void 0 ? " q-field--auto-height" : "") + (state.focused.value ? " q-field--focused" : "") + (hasError.value ? " q-field--error" : "") + (hasError.value || state.focused.value ? " q-field--highlighted" : "") + (!props.hideBottomSpace && shouldRenderBottom.value ? " q-field--with-bottom" : "") + (props.disable ? " q-field--disabled" : props.readonly ? " q-field--readonly" : ""));
	const contentClass = computed(() => "q-field__control relative-position row no-wrap" + (props.bgColor !== void 0 ? ` bg-${props.bgColor}` : "") + (hasError.value ? " text-negative" : typeof props.standout === "string" && props.standout.length !== 0 && state.focused.value ? ` ${props.standout}` : props.color !== void 0 ? ` text-${props.color}` : ""));
	const hasLabel = computed(() => props.labelSlot || props.label !== void 0);
	const labelClass = computed(() => "q-field__label no-pointer-events absolute ellipsis" + (props.labelColor !== void 0 && !hasError.value ? ` text-${props.labelColor}` : ""));
	const controlSlotScope = computed(() => injectProp({
		id: state.targetUid.value,
		editable: state.editable.value,
		focused: state.focused.value,
		floatingLabel: floatingLabel.value,
		modelValue: props.modelValue,
		emitValue: state.emitValue
	}, "field", () => state.rootRef.value));
	const attributes = computed(() => {
		const acc = {};
		if (state.targetUid.value) acc.for = state.targetUid.value;
		if (props.disable) acc["aria-disabled"] = "true";
		return acc;
	});
	function focusHandler() {
		const el = document.activeElement;
		let target = state.targetRef?.value;
		if (target && (el === null || el.id !== state.targetUid.value)) {
			if (!target.hasAttribute("tabindex")) target = target.querySelector("[tabindex]");
			if (target !== el) target?.focus({ preventScroll: true });
		}
	}
	function focus() {
		addFocusFn(focusHandler);
	}
	function blur() {
		removeFocusFn(focusHandler);
		const el = document.activeElement;
		if (el !== null && state.rootRef.value.contains(el)) el.blur();
	}
	function onControlFocusin(e) {
		if (focusoutTimer !== null) {
			clearTimeout(focusoutTimer);
			focusoutTimer = null;
		}
		if (state.editable.value && !state.focused.value) {
			state.focused.value = true;
			emit("focus", e);
		}
	}
	function onControlFocusout(e, then) {
		if (focusoutTimer !== null) clearTimeout(focusoutTimer);
		focusoutTimer = setTimeout(() => {
			focusoutTimer = null;
			if (document.hasFocus() && (state.hasPopupOpen || state.controlRef === void 0 || state.controlRef.value === null || state.controlRef.value.contains(document.activeElement))) return;
			if (state.focused.value) {
				state.focused.value = false;
				emit("blur", e);
			}
			then?.();
		}, 0);
	}
	function clearValue(e) {
		stopAndPrevent(e);
		if (!$q.platform.is.mobile) (state.targetRef?.value || state.rootRef.value).focus();
		else if (state.rootRef.value.contains(document.activeElement)) document.activeElement.blur();
		if (props.type === "file") state.inputRef.value.value = null;
		state.onClear?.();
		emit("update:modelValue", null);
		if (state.changeEvent) emit("change", null);
		emit("clear", props.modelValue);
		nextTick(() => {
			const isDirty = isDirtyModel.value;
			resetValidation();
			isDirtyModel.value = isDirty;
		});
	}
	function onClearableKeyup(evt) {
		if ([13, 32].includes(evt.keyCode)) clearValue(evt);
	}
	function getContent() {
		const node = [];
		if (slots.prepend !== void 0) node.push(h("div", {
			class: "q-field__prepend q-field__marginal row no-wrap items-center",
			key: "prepend",
			onClick: prevent
		}, slots.prepend()));
		node.push(h("div", { class: "q-field__control-container col relative-position row no-wrap q-anchor--skip" }, getControlContainer()));
		if (hasError.value && !props.noErrorIcon) node.push(getInnerAppendNode("error", [h(QIcon_default, {
			name: $q.iconSet.field.error,
			color: "negative"
		})]));
		if (props.loading || state.innerLoading.value) node.push(getInnerAppendNode("inner-loading-append", slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default, { color: props.color })]));
		else if (props.clearable && state.hasValue.value && state.editable.value) node.push(getInnerAppendNode("inner-clearable-append", [h(QIcon_default, {
			class: "q-field__focusable-action",
			name: props.clearIcon || $q.iconSet.field.clear,
			tabindex: 0,
			role: "button",
			"aria-hidden": "false",
			"aria-label": $q.lang.label.clear,
			onKeyup: onClearableKeyup,
			onClick: clearValue
		})]));
		if (slots.append !== void 0) node.push(h("div", {
			class: "q-field__append q-field__marginal row no-wrap items-center",
			key: "append",
			onClick: prevent
		}, slots.append()));
		if (state.getInnerAppend !== void 0) node.push(getInnerAppendNode("inner-append", state.getInnerAppend()));
		if (state.getControlChild !== void 0) node.push(state.getControlChild());
		return node;
	}
	function getControlContainer() {
		const node = [];
		if (props.prefix !== void 0 && props.prefix !== null) node.push(h("div", { class: "q-field__prefix no-pointer-events row items-center" }, props.prefix));
		if (state.getShadowControl !== void 0 && state.hasShadow.value) node.push(state.getShadowControl());
		if (hasLabel.value) node.push(h("div", { class: labelClass.value }, hSlot(slots.label, props.label)));
		if (state.getControl !== void 0) node.push(state.getControl());
		else if (slots.rawControl !== void 0) node.push(slots.rawControl());
		else if (slots.control !== void 0) node.push(h("div", {
			ref: state.targetRef,
			class: "q-field__native row",
			tabindex: -1,
			...state.splitAttrs.attributes.value,
			"data-autofocus": props.autofocus || void 0
		}, slots.control(controlSlotScope.value)));
		if (props.suffix !== void 0 && props.suffix !== null) node.push(h("div", { class: "q-field__suffix no-pointer-events row items-center" }, props.suffix));
		return node.concat(hSlot(slots.default));
	}
	function getBottom() {
		let msg, key;
		if (hasError.value) if (errorMessage.value !== null) {
			msg = [h("div", { role: "alert" }, errorMessage.value)];
			key = `q--slot-error-${errorMessage.value}`;
		} else {
			msg = hSlot(slots.error);
			key = "q--slot-error";
		}
		else if (!props.hideHint || state.focused.value) if (props.hint !== void 0) {
			msg = [h("div", props.hint)];
			key = `q--slot-hint-${props.hint}`;
		} else {
			msg = hSlot(slots.hint);
			key = "q--slot-hint";
		}
		const hasCounter = props.counter || slots.counter !== void 0;
		if (props.hideBottomSpace && !hasCounter && msg === void 0) return;
		const main = h("div", {
			key,
			class: "q-field__messages col"
		}, msg);
		return h("div", {
			class: "q-field__bottom row items-start q-field__bottom--" + (props.hideBottomSpace ? "stale" : "animated"),
			onClick: prevent
		}, [props.hideBottomSpace ? main : h(Transition, { name: "q-transition--field-message" }, () => main), hasCounter ? h("div", { class: "q-field__counter" }, slots.counter !== void 0 ? slots.counter() : state.computedCounter.value) : null]);
	}
	let shouldActivate = false;
	onDeactivated(() => {
		shouldActivate = true;
	});
	onActivated(() => {
		if (shouldActivate && props.autofocus) proxy.focus();
	});
	if (props.autofocus) onMounted(() => {
		proxy.focus();
	});
	onBeforeUnmount(() => {
		if (focusoutTimer !== null) clearTimeout(focusoutTimer);
	});
	Object.assign(proxy, {
		focus,
		blur
	});
	return function renderField() {
		const labelAttrs = state.getControl === void 0 && slots.control === void 0 ? {
			...state.splitAttrs.attributes.value,
			"data-autofocus": props.autofocus || void 0,
			...attributes.value
		} : attributes.value;
		return h(state.tag.value, {
			ref: state.rootRef,
			class: [classes.value, attrs.class],
			style: attrs.style,
			...labelAttrs
		}, [
			slots.before !== void 0 ? h("div", {
				class: "q-field__before q-field__marginal row no-wrap items-center",
				onClick: prevent
			}, slots.before()) : null,
			h("div", { class: "q-field__inner relative-position col self-stretch" }, [h("div", {
				ref: state.controlRef,
				class: contentClass.value,
				tabindex: -1,
				...state.controlEvents
			}, getContent()), shouldRenderBottom.value ? getBottom() : null]),
			slots.after !== void 0 ? h("div", {
				class: "q-field__after q-field__marginal row no-wrap items-center",
				onClick: prevent
			}, slots.after()) : null
		]);
	};
}
var QField_default = /*#__PURE__*/ createComponent({
	name: "QField",
	inheritAttrs: false,
	props: {
		...useFieldProps,
		tag: {
			type: String,
			default: "label"
		}
	},
	emits: useFieldEmits,
	setup() {
		return useField(useFieldState({ tagProp: true }));
	}
});
function filterFiles(files, rejectedFiles, failedPropValidation, filterFn) {
	const acceptedFiles = [];
	files.forEach((file) => {
		if (filterFn(file)) acceptedFiles.push(file);
		else rejectedFiles.push({
			failedPropValidation,
			file
		});
	});
	return acceptedFiles;
}
function stopAndPreventDrag(e) {
	if (e?.dataTransfer) e.dataTransfer.dropEffect = "copy";
	stopAndPrevent(e);
}
var useFileProps = {
	multiple: Boolean,
	accept: String,
	capture: String,
	maxFileSize: [Number, String],
	maxTotalSize: [Number, String],
	maxFiles: [Number, String],
	filter: Function
};
var useFileEmits = ["rejected"];
function useFile({ editable, dnd, getFileInput, addFilesToQueue }) {
	const { props, emit, proxy } = getCurrentInstance();
	const dndRef = ref(null);
	const extensions = computed(() => props.accept !== void 0 ? props.accept.split(",").map((ext) => {
		ext = ext.trim();
		if (ext === "*") return "*/";
		else if (ext.endsWith("/*")) ext = ext.slice(0, -1);
		return ext.toUpperCase();
	}) : null);
	const maxFilesNumber = computed(() => Number.parseInt(props.maxFiles, 10));
	const maxTotalSizeNumber = computed(() => Number.parseInt(props.maxTotalSize, 10));
	function pickFiles(e) {
		if (editable.value) {
			if (e !== Object(e)) e = { target: null };
			if (e.target?.matches("input[type=\"file\"]") === true) {
				if (e.clientX === 0 && e.clientY === 0) stop(e);
			} else {
				const input = getFileInput();
				if (input !== e.target) input?.click(e);
			}
		}
	}
	function addFiles(files) {
		if (editable.value && files) addFilesToQueue(null, files);
	}
	function processFiles(e, filesToProcess, currentFileList, append) {
		let files = [...filesToProcess || e.target.files];
		const rejectedFiles = [];
		const done = () => {
			if (rejectedFiles.length !== 0) emit("rejected", rejectedFiles);
		};
		if (props.accept !== void 0 && !extensions.value.includes("*/")) {
			files = filterFiles(files, rejectedFiles, "accept", (file) => extensions.value.some((ext) => (ext.endsWith("/") ? file.type.toUpperCase().startsWith(ext) : file.type.toUpperCase() === ext) || file.name.toUpperCase().endsWith(ext)));
			if (files.length === 0) return done();
		}
		if (props.maxFileSize !== void 0) {
			const maxFileSize = Number.parseInt(props.maxFileSize, 10);
			files = filterFiles(files, rejectedFiles, "max-file-size", (file) => file.size <= maxFileSize);
			if (files.length === 0) return done();
		}
		if (!props.multiple && files.length !== 0) files = [files[0]];
		files.forEach((file) => {
			file.__key = JSON.stringify([
				file.webkitRelativePath,
				file.lastModified,
				file.name,
				file.size
			]);
		});
		if (append) {
			const filenameSet = new Set(currentFileList.map((entry) => entry.__key));
			files = filterFiles(files, rejectedFiles, "duplicate", (file) => {
				if (filenameSet.has(file.__key)) return false;
				filenameSet.add(file.__key);
				return true;
			});
		}
		if (files.length === 0) return done();
		if (props.maxTotalSize !== void 0) {
			let size = append ? currentFileList.reduce((total, file) => total + file.size, 0) : 0;
			files = filterFiles(files, rejectedFiles, "max-total-size", (file) => {
				const newSize = size + file.size;
				if (newSize > maxTotalSizeNumber.value) return false;
				size = newSize;
				return true;
			});
			if (files.length === 0) return done();
		}
		if (typeof props.filter === "function") {
			const filteredFiles = props.filter(files);
			files = filterFiles(files, rejectedFiles, "filter", (file) => filteredFiles.includes(file));
		}
		if (props.maxFiles !== void 0) {
			let filesNumber = append ? currentFileList.length : 0;
			files = filterFiles(files, rejectedFiles, "max-files", () => {
				filesNumber++;
				return filesNumber <= maxFilesNumber.value;
			});
			if (files.length === 0) return done();
		}
		done();
		if (files.length !== 0) return files;
	}
	function onDragover(e) {
		stopAndPreventDrag(e);
		if (!dnd.value) dnd.value = true;
	}
	function onDragleave(e) {
		stopAndPrevent(e);
		if (e.relatedTarget !== null || !client.is.safari ? e.relatedTarget !== dndRef.value : !document.elementsFromPoint(e.clientX, e.clientY).includes(dndRef.value)) dnd.value = false;
	}
	function onDrop(e) {
		stopAndPreventDrag(e);
		const files = e.dataTransfer.files;
		if (files.length !== 0) addFilesToQueue(null, files);
		dnd.value = false;
	}
	function getDndNode(type) {
		if (dnd.value) return h("div", {
			ref: dndRef,
			class: `q-${type}__dnd absolute-full`,
			onDragenter: stopAndPreventDrag,
			onDragover: stopAndPreventDrag,
			onDragleave,
			onDrop
		});
	}
	Object.assign(proxy, {
		pickFiles,
		addFiles
	});
	return {
		pickFiles,
		addFiles,
		onDragover,
		onDragleave,
		processFiles,
		getDndNode,
		maxFilesNumber,
		maxTotalSizeNumber
	};
}
function useFileDomProps(props, typeGuard) {
	function getFormDomProps() {
		const model = props.modelValue;
		try {
			const dt = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
			if (Object(model) === model) ("length" in model ? [...model] : [model]).forEach((file) => {
				dt.items.add(file);
			});
			return { files: dt.files };
		} catch {
			return { files: void 0 };
		}
	}
	return typeGuard ? computed(() => {
		if (props.type !== "file") return;
		return getFormDomProps();
	}) : computed(getFormDomProps);
}
function onKeydown$1(e) {
	if (e.keyCode === 13) prevent(e);
}
var QFile_default = /*#__PURE__*/ createComponent({
	name: "QFile",
	inheritAttrs: false,
	props: {
		...useNonInputFieldProps,
		...useFormProps,
		...useFileProps,
		modelValue: [
			File,
			FileList,
			Array
		],
		append: Boolean,
		useChips: Boolean,
		displayValue: [String, Number],
		tabindex: {
			type: [String, Number],
			default: 0
		},
		counterLabel: Function,
		inputClass: [
			Array,
			String,
			Object
		],
		inputStyle: [
			Array,
			String,
			Object
		]
	},
	emits: [...useFieldEmits, ...useFileEmits],
	setup(props, { slots, emit, attrs }) {
		const { proxy } = getCurrentInstance();
		const state = useFieldState();
		const inputRef = ref(null);
		const dnd = ref(false);
		const nameProp = useFormInputNameAttr(props);
		const { pickFiles, onDragover, onDragleave, processFiles, getDndNode } = useFile({
			editable: state.editable,
			dnd,
			getFileInput,
			addFilesToQueue
		});
		const formDomProps = useFileDomProps(props);
		const innerValue = computed(() => Object(props.modelValue) === props.modelValue ? "length" in props.modelValue ? [...props.modelValue] : [props.modelValue] : []);
		const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
		const selectedString = computed(() => innerValue.value.map((file) => file.name).join(", "));
		const totalSize = computed(() => humanStorageSize(innerValue.value.reduce((acc, file) => acc + file.size, 0)));
		const counterProps = computed(() => ({
			totalSize: totalSize.value,
			filesNumber: innerValue.value.length,
			maxFiles: props.maxFiles
		}));
		const inputAttrs = computed(() => ({
			tabindex: -1,
			type: "file",
			title: "",
			accept: props.accept,
			capture: props.capture,
			name: nameProp.value,
			...attrs,
			id: state.targetUid.value,
			disabled: !state.editable.value
		}));
		const fieldClass = computed(() => "q-file q-field--auto-height" + (dnd.value ? " q-file--dnd" : ""));
		const isAppending = computed(() => props.multiple && props.append);
		function removeAtIndex(index) {
			const files = [...innerValue.value];
			files.splice(index, 1);
			emitValue(files);
		}
		function removeFile(file) {
			const index = innerValue.value.indexOf(file);
			if (index !== -1) removeAtIndex(index);
		}
		function emitValue(files) {
			emit("update:modelValue", props.multiple ? files : files[0]);
		}
		function onKeyup(e) {
			if (e.keyCode === 13 || e.keyCode === 32) pickFiles(e);
		}
		function getFileInput() {
			return inputRef.value;
		}
		function addFilesToQueue(e, fileList) {
			const files = processFiles(e, fileList, innerValue.value, isAppending.value);
			const fileInput = getFileInput();
			if (fileInput !== void 0 && fileInput !== null) fileInput.value = "";
			if (files === void 0) return;
			if (props.multiple ? props.modelValue && files.every((f) => innerValue.value.includes(f)) : props.modelValue === files[0]) return;
			emitValue(isAppending.value ? [...innerValue.value, ...files] : files);
		}
		function getFiller() {
			return [h("input", {
				class: [props.inputClass, "q-file__filler"],
				style: props.inputStyle
			})];
		}
		function getSelection() {
			if (slots.file !== void 0) return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, index) => slots.file({
				index,
				file,
				ref: proxy
			}));
			if (slots.selected !== void 0) return innerValue.value.length === 0 ? getFiller() : slots.selected({
				files: innerValue.value,
				ref: proxy
			});
			if (props.useChips) return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, i) => h(QChip_default, {
				key: "file-" + i,
				removable: state.editable.value,
				dense: true,
				textColor: props.color,
				tabindex: props.tabindex,
				onRemove: () => {
					removeAtIndex(i);
				}
			}, () => h("span", {
				class: "ellipsis",
				textContent: file.name
			})));
			const textContent = props.displayValue !== void 0 ? props.displayValue : selectedString.value;
			return textContent.length !== 0 ? [h("div", {
				class: props.inputClass,
				style: props.inputStyle,
				textContent
			})] : getFiller();
		}
		function getInput() {
			const data = {
				ref: inputRef,
				...inputAttrs.value,
				...formDomProps.value,
				class: "q-field__input fit absolute-full cursor-pointer",
				onChange: addFilesToQueue
			};
			if (props.multiple) data.multiple = true;
			return h("input", data);
		}
		Object.assign(state, {
			fieldClass,
			emitValue,
			hasValue,
			inputRef,
			innerValue,
			floatingLabel: computed(() => hasValue.value || fieldValueIsFilled(props.displayValue)),
			computedCounter: computed(() => {
				if (props.counterLabel !== void 0) return props.counterLabel(counterProps.value);
				const max = props.maxFiles;
				return `${innerValue.value.length}${max !== void 0 ? " / " + max : ""} (${totalSize.value})`;
			}),
			getControlChild: () => getDndNode("file"),
			getControl: () => {
				const data = {
					ref: state.targetRef,
					class: "q-field__native row items-center cursor-pointer",
					tabindex: props.tabindex
				};
				if (state.editable.value) Object.assign(data, {
					onDragover,
					onDragleave,
					onKeydown: onKeydown$1,
					onKeyup
				});
				return h("div", data, [getInput()].concat(getSelection()));
			}
		});
		Object.assign(proxy, {
			removeAtIndex,
			removeFile,
			getNativeElement: () => inputRef.value
		});
		injectProp(proxy, "nativeEl", () => inputRef.value);
		return useField(state);
	}
});
function updateLocal(prop, val) {
	if (prop.value !== val) prop.value = val;
}
var QHeader_default = /*#__PURE__*/ createComponent({
	name: "QHeader",
	props: {
		modelValue: {
			type: Boolean,
			default: true
		},
		reveal: Boolean,
		revealOffset: {
			type: Number,
			default: 250
		},
		bordered: Boolean,
		elevated: Boolean,
		heightHint: {
			type: [String, Number],
			default: 50
		}
	},
	emits: ["reveal", "focusin"],
	setup(props, { slots, emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const $layout = inject(layoutKey, emptyRenderFn);
		if ($layout === emptyRenderFn) {
			console.error("QHeader needs to be child of QLayout");
			return emptyRenderFn;
		}
		const size = ref(Number.parseInt(props.heightHint, 10));
		const revealed = ref(true);
		const fixed = computed(() => props.reveal || $layout.view.value.includes("H") || $q.platform.is.ios && $layout.isContainer.value);
		const offset = computed(() => {
			if (!props.modelValue) return 0;
			if (fixed.value) return revealed.value ? size.value : 0;
			const localOffset = size.value - $layout.scroll.value.position;
			return Math.max(localOffset, 0);
		});
		const hidden = computed(() => !props.modelValue || fixed.value && !revealed.value);
		const revealOnFocus = computed(() => props.modelValue && hidden.value && props.reveal);
		const classes = computed(() => "q-header q-layout__section--marginal " + (fixed.value ? "fixed" : "absolute") + "-top" + (props.bordered ? " q-header--bordered" : "") + (hidden.value ? " q-header--hidden" : "") + (props.modelValue ? "" : " q-layout--prevent-focus"));
		const style = computed(() => {
			const view = $layout.rows.value.top, css = {};
			if (view[0] === "l" && $layout.left.space) css[$q.lang.rtl ? "right" : "left"] = `${$layout.left.size}px`;
			if (view[2] === "r" && $layout.right.space) css[$q.lang.rtl ? "left" : "right"] = `${$layout.right.size}px`;
			return css;
		});
		function updateLayout(prop, val) {
			$layout.update("header", prop, val);
		}
		function onResize({ height }) {
			updateLocal(size, height);
			updateLayout("size", height);
		}
		function onFocusin(evt) {
			if (revealOnFocus.value) updateLocal(revealed, true);
			emit("focusin", evt);
		}
		watch(() => props.modelValue, (val) => {
			updateLayout("space", val);
			updateLocal(revealed, true);
			$layout.animate();
		});
		watch(offset, (val) => {
			updateLayout("offset", val);
		});
		watch(() => props.reveal, (val) => {
			if (!val) updateLocal(revealed, props.modelValue);
		});
		watch(revealed, (val) => {
			$layout.animate();
			emit("reveal", val);
		});
		watch($layout.scroll, (scroll) => {
			if (props.reveal) updateLocal(revealed, scroll.direction === "up" || scroll.position <= props.revealOffset || scroll.position - scroll.inflectionPoint < 100);
		});
		const instance = {};
		$layout.instances.header = instance;
		if (props.modelValue) updateLayout("size", size.value);
		updateLayout("space", props.modelValue);
		updateLayout("offset", offset.value);
		onBeforeUnmount(() => {
			if ($layout.instances.header === instance) {
				$layout.instances.header = void 0;
				updateLayout("size", 0);
				updateLayout("offset", 0);
				updateLayout("space", false);
			}
		});
		return () => {
			const child = hUniqueSlot(slots.default, []);
			if (props.elevated) child.push(h("div", { class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events" }));
			child.push(h(QResizeObserver_default, {
				debounce: 0,
				onResize
			}));
			return h("header", {
				class: classes.value,
				style: style.value,
				onFocusin
			}, child);
		};
	}
});
var useRatioProps = { ratio: [String, Number] };
function useRatio(props, naturalRatio) {
	return computed(() => {
		const rawValue = props.ratio || naturalRatio?.value;
		if (typeof rawValue === "string" && rawValue.trim() === "") return null;
		const ratio = Number(rawValue);
		return Number.isFinite(ratio) && ratio > 0 ? { paddingBottom: `${100 / ratio}%` } : null;
	});
}
var defaultRatio = 1.7778;
var QImg_default = /*#__PURE__*/ createComponent({
	name: "QImg",
	props: {
		...useRatioProps,
		src: String,
		srcset: String,
		sizes: String,
		alt: String,
		crossorigin: String,
		decoding: String,
		referrerpolicy: String,
		draggable: Boolean,
		loading: {
			type: String,
			default: "lazy"
		},
		loadingShowDelay: {
			type: [Number, String],
			default: 0
		},
		fetchpriority: {
			type: String,
			default: "auto"
		},
		width: String,
		height: String,
		initialRatio: {
			type: [Number, String],
			default: defaultRatio
		},
		placeholderSrc: String,
		errorSrc: String,
		fit: {
			type: String,
			default: "cover"
		},
		position: {
			type: String,
			default: "50% 50%"
		},
		imgClass: String,
		imgStyle: Object,
		noSpinner: Boolean,
		noNativeMenu: Boolean,
		noTransition: Boolean,
		spinnerColor: String,
		spinnerSize: String
	},
	emits: ["load", "error"],
	setup(props, { slots, emit }) {
		const naturalRatio = ref(props.initialRatio);
		const ratioStyle = useRatio(props, naturalRatio);
		const vm = getCurrentInstance();
		const { registerTimeout: registerLoadTimeout, removeTimeout: removeLoadTimeout } = useTimeout();
		const { registerTimeout: registerLoadShowTimeout, removeTimeout: removeLoadShowTimeout } = useTimeout();
		const placeholderImg = computed(() => props.placeholderSrc !== void 0 ? { src: props.placeholderSrc } : null);
		const errorImg = computed(() => props.errorSrc !== void 0 ? {
			src: props.errorSrc,
			__qerror: true
		} : null);
		const images = [ref(null), ref(placeholderImg.value)];
		const position = ref(0);
		const isLoading = ref(false);
		const hasError = ref(false);
		const classes = computed(() => `q-img q-img--${props.noNativeMenu ? "no-" : ""}menu`);
		const style = computed(() => ({
			width: props.width,
			height: props.height
		}));
		const imgClass = computed(() => `q-img__image ${props.imgClass !== void 0 ? props.imgClass + " " : ""}q-img__image--with${props.noTransition ? "out" : ""}-transition q-img__image--`);
		const imgStyle = computed(() => ({
			...props.imgStyle,
			objectFit: props.fit,
			objectPosition: props.position
		}));
		function setLoading() {
			removeLoadShowTimeout();
			if (props.loadingShowDelay === 0) {
				isLoading.value = true;
				return;
			}
			registerLoadShowTimeout(() => {
				isLoading.value = true;
			}, props.loadingShowDelay);
		}
		function clearLoading() {
			removeLoadShowTimeout();
			isLoading.value = false;
		}
		function onLoad({ target }) {
			if (vmIsDestroyed(vm)) return;
			removeLoadTimeout();
			naturalRatio.value = target.naturalHeight === 0 ? .5 : target.naturalWidth / target.naturalHeight;
			waitForCompleteness(target, 1);
		}
		function waitForCompleteness(target, count) {
			if (count === 1e3 || vmIsDestroyed(vm)) return;
			if (target.complete) onReady(target);
			else registerLoadTimeout(() => {
				waitForCompleteness(target, count + 1);
			}, 50);
		}
		function onReady(target) {
			if (vmIsDestroyed(vm)) return;
			position.value = position.value ^ 1;
			images[position.value].value = null;
			clearLoading();
			if (target.getAttribute("__qerror") !== "true") hasError.value = false;
			emit("load", target.currentSrc || target.src);
		}
		function onError(err) {
			removeLoadTimeout();
			clearLoading();
			hasError.value = true;
			images[position.value].value = errorImg.value;
			images[position.value ^ 1].value = placeholderImg.value;
			emit("error", err);
		}
		function getImage(index) {
			const img = images[index].value;
			const data = {
				key: "img_" + index,
				class: imgClass.value,
				style: imgStyle.value,
				alt: props.alt,
				crossorigin: props.crossorigin,
				decoding: props.decoding,
				referrerpolicy: props.referrerpolicy,
				height: props.height,
				width: props.width,
				loading: props.loading,
				fetchpriority: props.fetchpriority,
				"aria-hidden": "true",
				draggable: props.draggable,
				...img
			};
			if (position.value === index) Object.assign(data, {
				class: data.class + "current",
				onLoad,
				onError
			});
			else data.class += "loaded";
			return h("div", {
				class: "q-img__container absolute-full",
				key: "img" + index
			}, h("img", data));
		}
		function getContent() {
			if (!isLoading.value) return h("div", {
				key: "content",
				class: "q-img__content absolute-full q-anchor--skip"
			}, hSlot(slots[hasError.value ? "error" : "default"]));
			return h("div", {
				key: "loading",
				class: "q-img__loading absolute-full flex flex-center"
			}, slots.loading !== void 0 ? slots.loading() : props.noSpinner ? void 0 : [h(QSpinner_default, {
				color: props.spinnerColor,
				size: props.spinnerSize
			})]);
		}
		{
			const watchSrc = () => {
				watch(() => props.src || props.srcset || props.sizes ? {
					src: props.src,
					srcset: props.srcset,
					sizes: props.sizes
				} : null, (imgProps) => {
					removeLoadTimeout();
					hasError.value = false;
					if (imgProps === null) {
						clearLoading();
						images[position.value ^ 1].value = placeholderImg.value;
					} else setLoading();
					images[position.value].value = imgProps;
				}, { immediate: true });
			};
			if (isRuntimeSsrPreHydration.value) onMounted(watchSrc);
			else watchSrc();
		}
		return () => {
			const content = [];
			if (ratioStyle.value !== null) content.push(h("div", {
				key: "filler",
				style: ratioStyle.value
			}));
			if (images[0].value !== null) content.push(getImage(0));
			if (images[1].value !== null) content.push(getImage(1));
			content.push(h(Transition, { name: "q-transition--fade" }, getContent));
			return h("div", {
				key: "main",
				class: classes.value,
				style: style.value,
				role: "img",
				"aria-label": props.alt
			}, content);
		};
	}
});
var { passive: passive$3 } = listenOpts;
var QInfiniteScroll_default = /*#__PURE__*/ createComponent({
	name: "QInfiniteScroll",
	props: {
		offset: {
			type: Number,
			default: 500
		},
		debounce: {
			type: [String, Number],
			default: 100
		},
		scrollTarget: scrollTargetProp,
		initialIndex: {
			type: Number,
			default: 0
		},
		disable: Boolean,
		reverse: Boolean
	},
	emits: ["load"],
	setup(props, { slots, emit }) {
		const isFetching = ref(false);
		const isWorking = ref(true);
		const suppressAnchoring = ref(false);
		const rootRef = ref(null);
		const loadingRef = ref(null);
		let index = props.initialIndex;
		let localScrollTarget, poll;
		const classes = computed(() => "q-infinite-scroll__loading" + (isFetching.value ? "" : " invisible"));
		const rootClasses = computed(() => "q-infinite-scroll" + (suppressAnchoring.value ? " q-infinite-scroll--no-anchoring" : ""));
		function immediatePoll() {
			if (props.disable || isFetching.value || !isWorking.value) return;
			const scrollHeight = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), containerHeight = height(localScrollTarget);
			if (!props.reverse) {
				if (Math.round(scrollPosition + containerHeight + props.offset) >= Math.round(scrollHeight)) trigger();
			} else if (Math.round(scrollPosition) <= props.offset) trigger();
		}
		function trigger() {
			if (props.disable || isFetching.value || !isWorking.value) return;
			index++;
			isFetching.value = true;
			if (props.reverse === true) suppressAnchoring.value = true;
			const heightBefore = getScrollHeight(localScrollTarget);
			emit("load", index, (isDone) => {
				if (isWorking.value) {
					isFetching.value = false;
					nextTick(() => {
						if (props.reverse) {
							const heightAfter = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), heightDifference = heightAfter - heightBefore;
							setVerticalScrollPosition(localScrollTarget, scrollPosition + heightDifference);
						}
						suppressAnchoring.value = false;
						if (isDone === true) stop();
						else if (rootRef.value?.closest("body")) poll();
					});
				}
			});
		}
		function reset() {
			index = 0;
		}
		function resume() {
			if (!isWorking.value) {
				isWorking.value = true;
				localScrollTarget.addEventListener("scroll", poll, passive$3);
			}
			immediatePoll();
		}
		function stop() {
			if (isWorking.value) {
				isWorking.value = false;
				isFetching.value = false;
				suppressAnchoring.value = false;
				localScrollTarget.removeEventListener("scroll", poll, passive$3);
				poll?.cancel?.();
			}
		}
		function updateScrollTarget() {
			if (localScrollTarget && isWorking.value) localScrollTarget.removeEventListener("scroll", poll, passive$3);
			localScrollTarget = getScrollTarget(rootRef.value, props.scrollTarget);
			if (isWorking.value) {
				localScrollTarget.addEventListener("scroll", poll, passive$3);
				if (props.reverse) {
					const scrollHeight = getScrollHeight(localScrollTarget), containerHeight = height(localScrollTarget);
					setVerticalScrollPosition(localScrollTarget, scrollHeight - containerHeight);
				}
				immediatePoll();
			}
		}
		function setIndex(newIndex) {
			index = newIndex;
		}
		function setDebounce(val) {
			val = Number.parseInt(val, 10);
			const oldPoll = poll;
			poll = val <= 0 ? immediatePoll : debounce(immediatePoll, Number.isNaN(val) ? 100 : val);
			if (localScrollTarget && isWorking.value) {
				if (oldPoll !== void 0) localScrollTarget.removeEventListener("scroll", oldPoll, passive$3);
				localScrollTarget.addEventListener("scroll", poll, passive$3);
			}
		}
		function updateSvgAnimations(isRetry) {
			if (renderLoadingSlot.value) {
				if (loadingRef.value === null) {
					if (!isRetry) nextTick(() => {
						updateSvgAnimations(true);
					});
					return;
				}
				const action = `${isFetching.value ? "un" : ""}pauseAnimations`;
				[...loadingRef.value.getElementsByTagName("svg")].forEach((el) => {
					el[action]();
				});
			}
		}
		const renderLoadingSlot = computed(() => !props.disable && isWorking.value);
		watch([isFetching, renderLoadingSlot], () => {
			updateSvgAnimations();
		});
		watch(() => props.disable, (val) => {
			if (val) stop();
			else resume();
		});
		watch(() => props.reverse, () => {
			if (!isFetching.value && isWorking.value) immediatePoll();
		});
		watch(() => props.scrollTarget, updateScrollTarget);
		watch(() => props.debounce, setDebounce);
		let scrollPos = false;
		onActivated(() => {
			if (scrollPos !== false && localScrollTarget) setVerticalScrollPosition(localScrollTarget, scrollPos);
		});
		onDeactivated(() => {
			scrollPos = localScrollTarget ? getVerticalScrollPosition(localScrollTarget) : false;
		});
		onBeforeUnmount(() => {
			if (isWorking.value) localScrollTarget.removeEventListener("scroll", poll, passive$3);
		});
		onMounted(() => {
			setDebounce(props.debounce);
			updateScrollTarget();
			if (!isFetching.value) updateSvgAnimations();
		});
		const vm = getCurrentInstance();
		Object.assign(vm.proxy, {
			poll: () => {
				poll?.();
			},
			trigger,
			stop,
			reset,
			resume,
			setIndex,
			updateScrollTarget
		});
		return () => {
			const child = hUniqueSlot(slots.default, []);
			if (renderLoadingSlot.value) child[props.reverse ? "unshift" : "push"](h("div", {
				ref: loadingRef,
				class: classes.value
			}, hSlot(slots.loading)));
			return h("div", {
				class: rootClasses.value,
				ref: rootRef
			}, child);
		};
	}
});
var QInnerLoading_default = /*#__PURE__*/ createComponent({
	name: "QInnerLoading",
	props: {
		...useDarkProps,
		...useTransitionProps,
		showing: Boolean,
		color: String,
		size: {
			type: [String, Number],
			default: "42px"
		},
		label: String,
		labelClass: String,
		labelStyle: [
			String,
			Array,
			Object
		]
	},
	setup(props, { slots }) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const { transitionProps, transitionStyle } = useTransition(props);
		const classes = computed(() => "q-inner-loading q--avoid-card-border absolute-full column flex-center" + (isDark.value ? " q-inner-loading--dark" : ""));
		const labelClass = computed(() => "q-inner-loading__label" + (props.labelClass !== void 0 ? ` ${props.labelClass}` : ""));
		function getInner() {
			const child = [h(QSpinner_default, {
				size: props.size,
				color: props.color
			})];
			if (props.label !== void 0) child.push(h("div", {
				class: labelClass.value,
				style: props.labelStyle
			}, [props.label]));
			return child;
		}
		function getContent() {
			return props.showing ? h("div", {
				class: classes.value,
				style: transitionStyle.value
			}, slots.default !== void 0 ? slots.default() : getInner()) : null;
		}
		return () => h(Transition, transitionProps.value, getContent);
	}
});
var NAMED_MASKS = {
	date: "####/##/##",
	datetime: "####/##/## ##:##",
	time: "##:##",
	fulltime: "##:##:##",
	phone: "(###) ### - ####",
	card: "#### #### #### ####"
};
var { tokenMap: DEFAULT_TOKEN_MAP, tokenKeys: DEFAULT_TOKEN_MAP_KEYS } = /*#__PURE__*/ getTokenMap({
	"#": {
		pattern: "[\\d]",
		negate: "[^\\d]"
	},
	S: {
		pattern: "[a-zA-Z]",
		negate: "[^a-zA-Z]"
	},
	N: {
		pattern: "[0-9a-zA-Z]",
		negate: "[^0-9a-zA-Z]"
	},
	A: {
		pattern: "[a-zA-Z]",
		negate: "[^a-zA-Z]",
		transform: (v) => v.toLocaleUpperCase()
	},
	a: {
		pattern: "[a-zA-Z]",
		negate: "[^a-zA-Z]",
		transform: (v) => v.toLocaleLowerCase()
	},
	X: {
		pattern: "[0-9a-zA-Z]",
		negate: "[^0-9a-zA-Z]",
		transform: (v) => v.toLocaleUpperCase()
	},
	x: {
		pattern: "[0-9a-zA-Z]",
		negate: "[^0-9a-zA-Z]",
		transform: (v) => v.toLocaleLowerCase()
	}
});
function getTokenMap(tokens) {
	const tokenKeys = Object.keys(tokens);
	const tokenMap = {};
	tokenKeys.forEach((key) => {
		const entry = tokens[key];
		tokenMap[key] = {
			...entry,
			regex: new RegExp(entry.pattern)
		};
	});
	return {
		tokenMap,
		tokenKeys
	};
}
function getTokenRegexMask(keys) {
	return new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + keys.join("") + "])|(.)", "g");
}
var escRegex = /[.*+?^${}()|[\]\\]/g;
var DEFAULT_TOKEN_REGEX_MASK = /*#__PURE__*/ getTokenRegexMask(DEFAULT_TOKEN_MAP_KEYS);
var MARKER = String.fromCodePoint(1);
var useMaskProps = {
	mask: String,
	reverseFillMask: Boolean,
	fillMask: [Boolean, String],
	unmaskedValue: Boolean,
	maskTokens: Object
};
function useMask(props, emit, emitValue, inputRef) {
	let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
	const tokens = computed(() => {
		if (props.maskTokens === void 0 || props.maskTokens === null) return {
			tokenMap: DEFAULT_TOKEN_MAP,
			tokenRegexMask: DEFAULT_TOKEN_REGEX_MASK
		};
		const { tokenMap: customTokens } = getTokenMap(props.maskTokens);
		const tokenMap = {
			...DEFAULT_TOKEN_MAP,
			...customTokens
		};
		return {
			tokenMap,
			tokenRegexMask: getTokenRegexMask(Object.keys(tokenMap))
		};
	});
	const hasMask = ref(null);
	const innerValue = ref(getInitialMaskedValue());
	function getIsTypeText() {
		return props.autogrow || [
			"textarea",
			"text",
			"search",
			"url",
			"tel",
			"password"
		].includes(props.type);
	}
	watch(() => props.type + props.autogrow, updateMaskInternals);
	watch(() => props.mask, (v) => {
		if (v !== void 0) updateMaskValue(innerValue.value, true);
		else {
			const val = unmaskValue(innerValue.value);
			updateMaskInternals();
			if (props.modelValue !== val) emit("update:modelValue", val);
		}
	});
	watch(() => props.fillMask + props.reverseFillMask, () => {
		if (hasMask.value) updateMaskValue(innerValue.value, true);
	});
	watch(() => props.unmaskedValue, () => {
		if (hasMask.value) updateMaskValue(innerValue.value);
	});
	watch(() => props.maskTokens, () => {
		if (hasMask.value) updateMaskValue(innerValue.value, true);
	}, { deep: true });
	function getInitialMaskedValue() {
		updateMaskInternals();
		if (hasMask.value) {
			const masked = maskValue(unmaskValue(props.modelValue));
			return props.fillMask !== false ? fillWithMask(masked) : masked;
		}
		return props.modelValue;
	}
	function getPaddedMaskMarked(size) {
		if (size < maskMarked.length) return maskMarked.slice(-size);
		let pad = "", localMaskMarked = maskMarked;
		const padPos = localMaskMarked.indexOf(MARKER);
		if (padPos !== -1) {
			for (let i = size - localMaskMarked.length; i > 0; i--) pad += MARKER;
			localMaskMarked = localMaskMarked.slice(0, padPos) + pad + localMaskMarked.slice(padPos);
		}
		return localMaskMarked;
	}
	function updateMaskInternals() {
		hasMask.value = props.mask !== void 0 && props.mask.length !== 0 && getIsTypeText();
		if (!hasMask.value) {
			computedUnmask = void 0;
			maskMarked = "";
			maskReplaced = "";
			return;
		}
		const localComputedMask = NAMED_MASKS[props.mask] === void 0 ? props.mask : NAMED_MASKS[props.mask], fillChar = typeof props.fillMask === "string" && props.fillMask.length !== 0 ? props.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex, String.raw`\$&`), unmask = [], extract = [], mask = [];
		let firstMatch = props.reverseFillMask, unmaskChar = "", negateChar = "";
		localComputedMask.replace(tokens.value.tokenRegexMask, (_, char1, esc, token, char2) => {
			if (token !== void 0) {
				const c = tokens.value.tokenMap[token];
				mask.push(c);
				negateChar = c.negate;
				if (firstMatch) {
					extract.push("(?:" + negateChar + "+)?(" + c.pattern + "+)?(?:" + negateChar + "+)?(" + c.pattern + "+)?");
					firstMatch = false;
				}
				extract.push("(?:" + negateChar + "+)?(" + c.pattern + ")?");
				return;
			}
			if (esc !== void 0) {
				unmaskChar = "\\" + (esc === "\\" ? "" : esc);
				mask.push(esc);
			} else {
				const c = char1 !== void 0 ? char1 : char2;
				unmaskChar = c === "\\" ? String.raw`\\\\` : c.replace(escRegex, String.raw`\\$&`);
				mask.push(c);
			}
			unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
		});
		const unmaskMatcher = new RegExp("^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"), extractLast = extract.length - 1, extractMatcher = extract.map((re, index) => {
			if (index === 0 && props.reverseFillMask) return new RegExp("^" + fillCharEscaped + "*" + re);
			else if (index === extractLast) return new RegExp("^" + re + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props.reverseFillMask ? "$" : fillCharEscaped + "*"));
			return new RegExp("^" + re);
		});
		computedMask = mask;
		computedUnmask = (val) => {
			const unmaskMatch = unmaskMatcher.exec(props.reverseFillMask ? val : val.slice(0, mask.length + 1));
			if (unmaskMatch !== null) val = unmaskMatch.slice(1).join("");
			const extractMatch = [], extractMatcherLength = extractMatcher.length;
			for (let i = 0, str = val; i < extractMatcherLength; i++) {
				const m = extractMatcher[i].exec(str);
				if (m === null) break;
				str = str.slice(m.shift().length);
				extractMatch.push(...m);
			}
			if (extractMatch.length !== 0) return extractMatch.join("");
			return val;
		};
		maskMarked = mask.map((v) => typeof v === "string" ? v : MARKER).join("");
		maskReplaced = maskMarked.split(MARKER).join(fillChar);
	}
	function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
		const inp = inputRef.value, end = inp?.selectionEnd ?? 0, endReverse = inp === null ? 0 : inp.value.length - end, unmasked = unmaskValue(rawVal);
		if (updateMaskInternalsFlag === true) updateMaskInternals();
		const preMasked = maskValue(unmasked, updateMaskInternalsFlag), masked = props.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed = innerValue.value !== masked;
		if (inp !== null && inp.value !== masked) inp.value = masked;
		if (changed) innerValue.value = masked;
		if (inp !== null && document.activeElement === inp) nextTick(() => {
			if (masked === maskReplaced) {
				const cursor = props.reverseFillMask ? maskReplaced.length : 0;
				inp.setSelectionRange(cursor, cursor, "forward");
				return;
			}
			if (inputType === "insertFromPaste" && !props.reverseFillMask) {
				const maxEnd = inp.selectionEnd;
				let cursor = end - 1;
				for (let i = pastedTextStart; i <= cursor && i < maxEnd; i++) if (maskMarked[i] !== MARKER) cursor++;
				moveCursor.right(inp, cursor);
				return;
			}
			if (["deleteContentBackward", "deleteContentForward"].includes(inputType)) {
				const cursor = props.reverseFillMask ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
				inp.setSelectionRange(cursor, cursor, "forward");
				return;
			}
			if (props.reverseFillMask) if (changed) {
				const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
				if (cursor === 1 && end === 1) inp.setSelectionRange(cursor, cursor, "forward");
				else moveCursor.rightReverse(inp, cursor);
			} else {
				const cursor = masked.length - endReverse;
				inp.setSelectionRange(cursor, cursor, "backward");
			}
			else if (changed) {
				const cursor = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
				moveCursor.right(inp, cursor);
			} else {
				const cursor = end - 1;
				moveCursor.right(inp, cursor);
			}
		});
		const val = props.unmaskedValue ? unmaskValue(masked) : masked;
		if (String(props.modelValue) !== val && (props.modelValue !== null || val !== "")) emitValue(val, true);
	}
	function moveCursorForPaste(inp, start, end) {
		const preMasked = maskValue(unmaskValue(inp.value));
		start = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
		pastedTextStart = start;
		inp.setSelectionRange(start, end, "forward");
	}
	const moveCursor = {
		left(inp, cursor) {
			const noMarkBefore = !maskMarked.slice(cursor - 1).includes(MARKER);
			let i = Math.max(0, cursor - 1);
			for (; i >= 0; i--) if (maskMarked[i] === MARKER) {
				cursor = i;
				if (noMarkBefore) cursor++;
				break;
			}
			if (i < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) return moveCursor.right(inp, 0);
			if (cursor >= 0) inp.setSelectionRange(cursor, cursor, "backward");
		},
		right(inp, cursor) {
			const limit = inp.value.length;
			let i = Math.min(limit, cursor + 1);
			for (; i <= limit; i++) if (maskMarked[i] === MARKER) {
				cursor = i;
				break;
			} else if (maskMarked[i - 1] === MARKER) cursor = i;
			if (i > limit && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) return moveCursor.left(inp, limit);
			inp.setSelectionRange(cursor, cursor, "forward");
		},
		leftReverse(inp, cursor) {
			const localMaskMarked = getPaddedMaskMarked(inp.value.length);
			let i = Math.max(0, cursor - 1);
			for (; i >= 0; i--) if (localMaskMarked[i - 1] === MARKER) {
				cursor = i;
				break;
			} else if (localMaskMarked[i] === MARKER) {
				cursor = i;
				if (i === 0) break;
			}
			if (i < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER) return moveCursor.rightReverse(inp, 0);
			if (cursor >= 0) inp.setSelectionRange(cursor, cursor, "backward");
		},
		rightReverse(inp, cursor) {
			const limit = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit), noMarkBefore = !localMaskMarked.slice(0, cursor + 1).includes(MARKER);
			let i = Math.min(limit, cursor + 1);
			for (; i <= limit; i++) if (localMaskMarked[i - 1] === MARKER) {
				cursor = i;
				if (cursor > 0 && noMarkBefore) cursor--;
				break;
			}
			if (i > limit && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER) return moveCursor.leftReverse(inp, limit);
			inp.setSelectionRange(cursor, cursor, "forward");
		}
	};
	function onMaskedClick(e) {
		emit("click", e);
		selectionAnchor = void 0;
	}
	function onMaskedKeydown(e) {
		emit("keydown", e);
		if (shouldIgnoreKey(e) || e.altKey) return;
		const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
		if (!e.shiftKey) selectionAnchor = void 0;
		if (e.keyCode === 37 || e.keyCode === 39) {
			if (e.shiftKey && selectionAnchor === void 0) selectionAnchor = inp.selectionDirection === "forward" ? start : end;
			const fn = moveCursor[(e.keyCode === 39 ? "right" : "left") + (props.reverseFillMask ? "Reverse" : "")];
			e.preventDefault();
			fn(inp, selectionAnchor === start ? end : start);
			if (e.shiftKey) {
				const cursor = inp.selectionStart;
				inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
			}
		} else if (e.keyCode === 8 && !props.reverseFillMask && start === end) {
			moveCursor.left(inp, start);
			inp.setSelectionRange(inp.selectionStart, end, "backward");
		} else if (e.keyCode === 46 && props.reverseFillMask && start === end) {
			moveCursor.rightReverse(inp, end);
			inp.setSelectionRange(start, inp.selectionEnd, "forward");
		}
	}
	function maskValue(val, updateMaskInternalsFlag) {
		if (val === void 0 || val === null || val === "") return "";
		if (props.reverseFillMask) return maskValueReverse(val, updateMaskInternalsFlag);
		const mask = computedMask;
		let valIndex = 0, output = "";
		for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
			const valChar = val[valIndex], maskDef = mask[maskIndex];
			if (typeof maskDef === "string") {
				output += maskDef;
				if (updateMaskInternalsFlag === true && valChar === maskDef) valIndex++;
			} else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
				output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
				valIndex++;
			} else return output;
		}
		return output;
	}
	function maskValueReverse(val, updateMaskInternalsFlag) {
		const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER);
		let valIndex = val.length - 1, output = "";
		for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--) {
			const maskDef = mask[maskIndex];
			let valChar = val[valIndex];
			if (typeof maskDef === "string") {
				output = maskDef + output;
				if (updateMaskInternalsFlag === true && valChar === maskDef) valIndex--;
			} else if (valChar !== void 0 && maskDef.regex.test(valChar)) do {
				output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
				valIndex--;
				valChar = val[valIndex];
			} while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
			else return output;
		}
		return output;
	}
	function unmaskValue(val) {
		return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask(String(val)) : val : computedUnmask(val);
	}
	function fillWithMask(val) {
		if (maskReplaced.length - val.length <= 0) return val;
		return props.reverseFillMask && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
	}
	return {
		innerValue,
		hasMask,
		moveCursorForPaste,
		updateMaskValue,
		onMaskedKeydown,
		onMaskedClick
	};
}
var isJapanese = /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFF9F\u4E00-\u9FAF\u3400-\u4DBF]/;
var isChinese = /[\u4E00-\u9FFF\u3400-\u4DBF\u{20000}-\u{2A6DF}\u{2A700}-\u{2B73F}\u{2B740}-\u{2B81F}\u{2B820}-\u{2CEAF}\uF900-\uFAFF\u3300-\u33FF\uFE30-\uFE4F\uF900-\uFAFF\u{2F800}-\u{2FA1F}]/u;
var isKorean = /[\u3131-\u314E\u314F-\u3163\uAC00-\uD7A3]/;
var isPlainText = /[a-z0-9_ -]$/i;
function useKeyComposition(onInput) {
	return function onComposition(e) {
		if (e.type === "compositionend" || e.type === "change") {
			if (!e.target.qComposing) return;
			e.target.qComposing = false;
			onInput(e);
		} else if (e.type === "compositionupdate" && !e.target.qComposing && typeof e.data === "string") {
			if (client.is.firefox ? !isPlainText.test(e.data) : isJapanese.test(e.data) || isChinese.test(e.data) || isKorean.test(e.data)) e.target.qComposing = true;
		}
	};
}
var QInput_default = /*#__PURE__*/ createComponent({
	name: "QInput",
	inheritAttrs: false,
	props: {
		...useFieldProps,
		...useMaskProps,
		...useFormProps,
		modelValue: [
			String,
			Number,
			FileList
		],
		modelModifiers: Object,
		shadowText: String,
		type: {
			type: String,
			default: "text"
		},
		debounce: [String, Number],
		autogrow: Boolean,
		inputClass: [
			Array,
			String,
			Object
		],
		inputStyle: [
			Array,
			String,
			Object
		]
	},
	emits: [
		...useFieldEmits,
		"paste",
		"change",
		"keydown",
		"click",
		"animationend"
	],
	setup(props, { emit, attrs }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const temp = {};
		let emitCachedValue = NaN, typedNumber = false, stopValueWatcher = false, emitTimer = null, emitValueFn;
		const inputRef = ref(null);
		const nameProp = useFormInputNameAttr(props);
		const { innerValue, hasMask, moveCursorForPaste, updateMaskValue, onMaskedKeydown, onMaskedClick } = useMask(props, emit, emitValue, inputRef);
		const formDomProps = useFileDomProps(props, true);
		const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
		const onKeyComposition = useKeyComposition(onInput);
		function onComposition(e) {
			if (hasMask.value && e.type === "compositionstart") {
				e.target.qComposing = true;
				return;
			}
			onKeyComposition(e);
		}
		const state = useFieldState({ changeEvent: true });
		const isTextarea = computed(() => props.type === "textarea" || props.autogrow);
		const isTypeText = computed(() => isTextarea.value || [
			"text",
			"search",
			"url",
			"tel",
			"password"
		].includes(props.type));
		const onEvents = computed(() => {
			const evt = {
				...state.splitAttrs.listeners.value,
				onInput,
				onPaste,
				onChange,
				onBlur: onFinishEditing,
				onFocus: stop
			};
			evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
			if (hasMask.value) {
				evt.onKeydown = onMaskedKeydown;
				evt.onClick = onMaskedClick;
			}
			if (props.autogrow) evt.onAnimationend = onAnimationend;
			return evt;
		});
		const inputAttrs = computed(() => {
			const acc = {
				tabindex: 0,
				"data-autofocus": props.autofocus || void 0,
				rows: props.type === "textarea" ? 6 : void 0,
				"aria-label": props.label,
				name: nameProp.value,
				...state.splitAttrs.attributes.value,
				id: state.targetUid.value,
				maxlength: props.maxlength,
				disabled: props.disable,
				readonly: props.readonly
			};
			if (!isTextarea.value) acc.type = props.type;
			if (props.autogrow) acc.rows = 1;
			return acc;
		});
		watch(() => props.type, () => {
			if (inputRef.value) inputRef.value.value = props.modelValue;
		});
		watch(() => props.modelValue, (v) => {
			if (emitTimer !== null) {
				cancelPendingValueEmission();
				typedNumber = false;
				stopValueWatcher = false;
				delete temp.value;
			}
			if (hasMask.value) {
				if (stopValueWatcher) {
					stopValueWatcher = false;
					if (String(v) === emitCachedValue) return;
				}
				updateMaskValue(v);
			} else if (innerValue.value !== v) {
				innerValue.value = v;
				if (props.type === "number" && Object.hasOwn(temp, "value")) if (typedNumber) typedNumber = false;
				else delete temp.value;
				if (props.modelModifiers?.trim === true && Object.hasOwn(temp, "value") && (typeof temp.value !== "string" || temp.value.trim() !== v)) delete temp.value;
			}
			if (props.autogrow) nextTick(adjustHeight);
		});
		watch(() => props.autogrow, (val) => {
			if (val) nextTick(adjustHeight);
			else if (inputRef.value !== null && attrs.rows > 0) inputRef.value.style.height = "auto";
		});
		watch(() => props.dense, () => {
			if (props.autogrow) nextTick(adjustHeight);
		});
		function focusHandler() {
			const el = document.activeElement;
			if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state.targetUid.value)) inputRef.value.focus({ preventScroll: true });
		}
		function focus() {
			addFocusFn(focusHandler);
		}
		function blur() {
			removeFocusFn(focusHandler);
			const el = document.activeElement;
			if (el !== null && state.rootRef.value.contains(el)) el.blur();
		}
		function select() {
			inputRef.value?.select();
		}
		function onPaste(e) {
			if (hasMask.value && props.reverseFillMask !== true) {
				const inp = e.target;
				moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
			}
			emit("paste", e);
		}
		function onInput(e) {
			if (!e || !e.target) return;
			if (props.type === "file") {
				emit("update:modelValue", e.target.files);
				return;
			}
			const val = e.target.value;
			if (e.target.qComposing) {
				temp.value = val;
				return;
			}
			if (hasMask.value) updateMaskValue(val, false, e.inputType);
			else {
				if (props.modelModifiers?.trim === true) temp.value = val;
				emitValue(val);
				if (isTypeText.value && e.target === document.activeElement) {
					const { selectionStart, selectionEnd } = e.target;
					if (selectionStart !== void 0 && selectionEnd !== void 0) nextTick(() => {
						if (e.target === document.activeElement && val.indexOf(e.target.value) === 0) e.target.setSelectionRange(selectionStart, selectionEnd);
					});
				}
			}
			if (props.autogrow) adjustHeight();
		}
		function onAnimationend(e) {
			emit("animationend", e);
			adjustHeight();
		}
		function emitValue(val, stopWatcher) {
			emitValueFn = () => {
				emitTimer = null;
				if (props.type !== "number" && (props.modelModifiers?.trim !== true || hasMask.value) && Object.hasOwn(temp, "value")) delete temp.value;
				if (props.modelValue !== val && emitCachedValue !== val) {
					emitCachedValue = val;
					if (stopWatcher === true) stopValueWatcher = true;
					emit("update:modelValue", val);
					nextTick(() => {
						if (emitCachedValue === val) emitCachedValue = NaN;
					});
				}
				emitValueFn = void 0;
			};
			if (props.type === "number") {
				typedNumber = true;
				temp.value = val;
			}
			if (props.debounce !== void 0) {
				if (emitTimer !== null) clearTimeout(emitTimer);
				temp.value = val;
				emitTimer = setTimeout(emitValueFn, props.debounce);
			} else emitValueFn();
		}
		function cancelPendingValueEmission() {
			if (emitTimer !== null) {
				clearTimeout(emitTimer);
				emitTimer = null;
			}
			emitValueFn = void 0;
		}
		function onClear() {
			cancelPendingValueEmission();
			typedNumber = false;
			stopValueWatcher = false;
			delete temp.value;
		}
		function adjustHeight() {
			requestAnimationFrame(() => {
				const inp = inputRef.value;
				if (inp !== null) {
					const parentStyle = inp.parentNode.style;
					const { scrollTop } = inp;
					const { overflowY, maxHeight } = $q.platform.is.firefox ? {} : window.getComputedStyle(inp);
					const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
					if (changeOverflow) inp.style.overflowY = "hidden";
					parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
					inp.style.height = "1px";
					inp.style.height = inp.scrollHeight + "px";
					if (changeOverflow) inp.style.overflowY = Number.parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden";
					parentStyle.marginBottom = "";
					inp.scrollTop = scrollTop;
				}
			});
		}
		function onChange(e) {
			onComposition(e);
			if (emitTimer !== null) {
				clearTimeout(emitTimer);
				emitTimer = null;
			}
			emitValueFn?.();
			emit("change", e.target.value);
		}
		function onFinishEditing(e) {
			if (e !== void 0) stop(e);
			if (emitTimer !== null) {
				clearTimeout(emitTimer);
				emitTimer = null;
			}
			emitValueFn?.();
			typedNumber = false;
			stopValueWatcher = false;
			delete temp.value;
			if (props.type !== "file") setTimeout(() => {
				if (inputRef.value !== null) inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
			}, 0);
		}
		function getCurValue() {
			return Object.hasOwn(temp, "value") ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
		}
		onBeforeUnmount(() => {
			onFinishEditing();
		});
		onMounted(() => {
			if (props.autogrow) adjustHeight();
		});
		Object.assign(state, {
			innerValue,
			fieldClass: computed(() => `q-${isTextarea.value ? "textarea" : "input"}` + (props.autogrow ? " q-textarea--autogrow" : "")),
			hasShadow: computed(() => props.type !== "file" && typeof props.shadowText === "string" && props.shadowText.length !== 0),
			inputRef,
			emitValue,
			onClear,
			hasValue,
			floatingLabel: computed(() => hasValue.value && (props.type !== "number" || Number.isFinite(Number(innerValue.value))) || fieldValueIsFilled(props.displayValue)),
			getControl: () => h(isTextarea.value ? "textarea" : "input", {
				ref: inputRef,
				class: ["q-field__native q-placeholder", props.inputClass],
				style: props.inputStyle,
				...inputAttrs.value,
				...onEvents.value,
				...props.type !== "file" ? { value: getCurValue() } : formDomProps.value
			}),
			getShadowControl: () => h("div", { class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value ? "" : " text-no-wrap") }, [h("span", { class: "invisible" }, getCurValue()), h("span", props.shadowText)])
		});
		const renderFn = useField(state);
		Object.assign(proxy, {
			focus,
			blur,
			select,
			getNativeElement: () => inputRef.value
		});
		injectProp(proxy, "nativeEl", () => inputRef.value);
		return renderFn;
	}
});
var defaultCfg$1 = {
	threshold: 0,
	root: null,
	rootMargin: "0px"
};
function update$3(el, ctx, value) {
	let handler, cfg, changed;
	if (typeof value === "function") {
		handler = value;
		changed = ctx.cfg !== defaultCfg$1;
		cfg = defaultCfg$1;
	} else {
		handler = value.handler;
		cfg = {
			...defaultCfg$1,
			...value.cfg
		};
		changed = ctx.cfg === void 0 || !isDeepEqual(ctx.cfg, cfg);
	}
	if (ctx.handler !== handler) ctx.handler = handler;
	if (!changed) return;
	ctx.cfg = cfg;
	ctx.observer?.disconnect();
	ctx.observer = new IntersectionObserver(([entry]) => {
		if (typeof ctx.handler === "function") {
			if (entry.rootBounds === null && document.body.contains(el)) {
				ctx.observer.unobserve(el);
				ctx.observer.observe(el);
				return;
			}
			if (ctx.handler(entry, ctx.observer) === false || ctx.once && entry.isIntersecting) destroy$1(el);
		}
	}, cfg);
	ctx.observer.observe(el);
}
function destroy$1(el) {
	const ctx = el.__qvisible;
	if (ctx !== void 0) {
		ctx.observer?.disconnect();
		delete el.__qvisible;
	}
}
var Intersection_default = /*#__PURE__*/ createDirective({
	name: "intersection",
	mounted(el, { modifiers, value }) {
		const ctx = { once: modifiers.once === true };
		update$3(el, ctx, value);
		el.__qvisible = ctx;
	},
	updated(el, binding) {
		const ctx = el.__qvisible;
		if (ctx !== void 0) update$3(el, ctx, binding.value);
	},
	beforeUnmount: destroy$1
});
var QIntersection_default = /*#__PURE__*/ createComponent({
	name: "QIntersection",
	props: {
		tag: {
			type: String,
			default: "div"
		},
		once: Boolean,
		transition: String,
		transitionDuration: {
			type: [String, Number],
			default: 300
		},
		ssrPrerender: Boolean,
		margin: String,
		threshold: [Number, Array],
		root: { default: null },
		disable: Boolean,
		onVisibility: Function
	},
	setup(props, { slots, emit }) {
		const showing = ref(isRuntimeSsrPreHydration.value ? props.ssrPrerender : false);
		const intersectionProps = computed(() => props.root !== void 0 || props.margin !== void 0 || props.threshold !== void 0 ? {
			handler: trigger,
			cfg: {
				root: props.root,
				rootMargin: props.margin,
				threshold: props.threshold
			}
		} : trigger);
		const hasDirective = computed(() => !props.disable && (!isRuntimeSsrPreHydration.value || !props.once || !props.ssrPrerender));
		const directives = computed(() => [[
			Intersection_default,
			intersectionProps.value,
			void 0,
			{ once: props.once }
		]]);
		const transitionStyle = computed(() => `--q-transition-duration: ${props.transitionDuration}ms`);
		function trigger(entry) {
			if (showing.value !== entry.isIntersecting) {
				showing.value = entry.isIntersecting;
				if (props.onVisibility !== void 0) emit("visibility", showing.value);
			}
		}
		function getContent() {
			if (showing.value) return [h("div", {
				key: "content",
				style: transitionStyle.value
			}, hSlot(slots.default))];
			if (slots.hidden !== void 0) return [h("div", {
				key: "hidden",
				style: transitionStyle.value
			}, slots.hidden())];
		}
		return () => {
			const child = props.transition ? [h(Transition, { name: "q-transition--" + props.transition }, getContent)] : getContent();
			return hDir(props.tag, { class: "q-intersection" }, child, "main", hasDirective.value, () => directives.value);
		};
	}
});
var roleAttrExceptions = ["ul", "ol"];
var QList_default = /*#__PURE__*/ createComponent({
	name: "QList",
	props: {
		...useDarkProps,
		bordered: Boolean,
		dense: Boolean,
		separator: Boolean,
		padding: Boolean,
		tag: {
			type: String,
			default: "div"
		}
	},
	setup(props, { slots }) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const role = computed(() => roleAttrExceptions.includes(props.tag) ? null : "list");
		const classes = computed(() => "q-list" + (props.bordered ? " q-list--bordered" : "") + (props.dense ? " q-list--dense" : "") + (props.separator ? " q-list--separator" : "") + (isDark.value ? " q-list--dark" : "") + (props.padding ? " q-list--padding" : ""));
		return () => h(props.tag, {
			class: classes.value,
			role: role.value
		}, hSlot(slots.default));
	}
});
Object.keys(useCircularCommonProps);
({
	...useFormProps,
	...useCircularCommonProps
});
var { passive: passive$2 } = listenOpts;
var axisValues = [
	"both",
	"horizontal",
	"vertical"
];
var QScrollObserver_default = /*#__PURE__*/ createComponent({
	name: "QScrollObserver",
	props: {
		axis: {
			type: String,
			validator: (v) => axisValues.includes(v),
			default: "vertical"
		},
		debounce: [String, Number],
		scrollTarget: scrollTargetProp
	},
	emits: ["scroll"],
	setup(props, { emit }) {
		const scroll = {
			position: {
				top: 0,
				left: 0
			},
			direction: "down",
			directionChanged: false,
			delta: {
				top: 0,
				left: 0
			},
			inflectionPoint: {
				top: 0,
				left: 0
			}
		};
		let clearTimer = null, localScrollTarget, parentEl;
		watch(() => props.scrollTarget, () => {
			unconfigureScrollTarget();
			configureScrollTarget();
		});
		function emitEvent() {
			clearTimer?.();
			const top = Math.max(0, getVerticalScrollPosition(localScrollTarget));
			const left = getHorizontalScrollPosition(localScrollTarget);
			const delta = {
				top: top - scroll.position.top,
				left: left - scroll.position.left
			};
			if (props.axis === "vertical" && delta.top === 0 || props.axis === "horizontal" && delta.left === 0) return;
			const curDir = Math.abs(delta.top) >= Math.abs(delta.left) ? delta.top < 0 ? "up" : "down" : delta.left < 0 ? "left" : "right";
			scroll.position = {
				top,
				left
			};
			scroll.directionChanged = scroll.direction !== curDir;
			scroll.delta = delta;
			if (scroll.directionChanged) {
				scroll.direction = curDir;
				scroll.inflectionPoint = scroll.position;
			}
			emit("scroll", { ...scroll });
		}
		function configureScrollTarget() {
			localScrollTarget = getScrollTarget(parentEl, props.scrollTarget);
			localScrollTarget.addEventListener("scroll", trigger, passive$2);
			trigger(true);
		}
		function unconfigureScrollTarget() {
			if (localScrollTarget !== void 0) {
				localScrollTarget.removeEventListener("scroll", trigger, passive$2);
				localScrollTarget = void 0;
			}
		}
		function trigger(immediately) {
			if (immediately === true || props.debounce === 0 || props.debounce === "0") emitEvent();
			else if (clearTimer === null) {
				const [timer, fn] = props.debounce ? [setTimeout(emitEvent, props.debounce), clearTimeout] : [requestAnimationFrame(emitEvent), cancelAnimationFrame];
				clearTimer = () => {
					fn(timer);
					clearTimer = null;
				};
			}
		}
		const { proxy } = getCurrentInstance();
		watch(() => proxy.$q.lang.rtl, emitEvent);
		onMounted(() => {
			parentEl = proxy.$el.parentNode;
			configureScrollTarget();
		});
		onBeforeUnmount(() => {
			clearTimer?.();
			unconfigureScrollTarget();
		});
		Object.assign(proxy, {
			trigger,
			getPosition: () => scroll
		});
		return noop;
	}
});
var viewRE = /^(h|l)h(h|r) lpr (f|l)f(f|r)$/;
var QLayout_default = /*#__PURE__*/ createComponent({
	name: "QLayout",
	props: {
		container: Boolean,
		view: {
			type: String,
			default: "hhh lpr fff",
			validator: (v) => viewRE.test(v.toLowerCase())
		},
		onScroll: Function,
		onScrollHeight: Function,
		onResize: Function
	},
	setup(props, { slots, emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const rootRef = ref(null);
		const height = ref($q.screen.height);
		const width = ref(props.container ? 0 : $q.screen.width);
		const scroll = ref({
			position: 0,
			direction: "down",
			inflectionPoint: 0
		});
		const containerHeight = ref(0);
		const scrollbarWidth = ref(isRuntimeSsrPreHydration.value ? 0 : getScrollbarWidth());
		const classes = computed(() => "q-layout q-layout--" + (props.container ? "containerized" : "standard"));
		const style = computed(() => props.container ? null : { minHeight: $q.screen.height + "px" });
		const targetStyle = computed(() => scrollbarWidth.value !== 0 ? { [$q.lang.rtl ? "left" : "right"]: `${scrollbarWidth.value}px` } : null);
		const targetChildStyle = computed(() => scrollbarWidth.value !== 0 ? {
			[$q.lang.rtl ? "right" : "left"]: 0,
			[$q.lang.rtl ? "left" : "right"]: `-${scrollbarWidth.value}px`,
			width: `calc(100% + ${scrollbarWidth.value}px)`
		} : null);
		function onPageScroll(data) {
			if (props.container || !document.qScrollPrevented) {
				const info = {
					position: data.position.top,
					direction: data.direction,
					directionChanged: data.directionChanged,
					inflectionPoint: data.inflectionPoint.top,
					delta: data.delta.top
				};
				scroll.value = info;
				if (props.onScroll !== void 0) emit("scroll", info);
			}
		}
		function onPageResize(data) {
			const { height: newHeight, width: newWidth } = data;
			let resized = false;
			if (height.value !== newHeight) {
				resized = true;
				height.value = newHeight;
				if (props.onScrollHeight !== void 0) emit("scrollHeight", newHeight);
				updateScrollbarWidth();
			}
			if (width.value !== newWidth) {
				resized = true;
				width.value = newWidth;
			}
			if (resized && props.onResize !== void 0) emit("resize", data);
		}
		function onContainerResize({ height: newHeight }) {
			if (containerHeight.value !== newHeight) {
				containerHeight.value = newHeight;
				updateScrollbarWidth();
			}
		}
		function updateScrollbarWidth() {
			if (props.container) {
				const newWidth = height.value > containerHeight.value ? getScrollbarWidth() : 0;
				if (scrollbarWidth.value !== newWidth) scrollbarWidth.value = newWidth;
			}
		}
		let animateTimer = null;
		const $layout = {
			instances: {},
			view: computed(() => props.view),
			isContainer: computed(() => props.container),
			rootRef,
			height,
			containerHeight,
			scrollbarWidth,
			totalWidth: computed(() => width.value + scrollbarWidth.value),
			rows: computed(() => {
				const rows = props.view.toLowerCase().split(" ");
				return {
					top: [...rows[0]],
					middle: [...rows[1]],
					bottom: [...rows[2]]
				};
			}),
			header: reactive({
				size: 0,
				offset: 0,
				space: false
			}),
			right: reactive({
				size: 300,
				offset: 0,
				space: false
			}),
			footer: reactive({
				size: 0,
				offset: 0,
				space: false
			}),
			left: reactive({
				size: 300,
				offset: 0,
				space: false
			}),
			scroll,
			animate() {
				if (animateTimer !== null) clearTimeout(animateTimer);
				else document.body.classList.add("q-body--layout-animate");
				animateTimer = setTimeout(() => {
					animateTimer = null;
					document.body.classList.remove("q-body--layout-animate");
				}, 155);
			},
			update(part, prop, val) {
				$layout[part][prop] = val;
			}
		};
		provide(layoutKey, $layout);
		if (getScrollbarWidth() > 0) {
			let timer = null;
			const el = document.body;
			const restoreScrollbar = () => {
				timer = null;
				el.classList.remove("hide-scrollbar");
			};
			const hideScrollbar = () => {
				if (timer === null) {
					if (el.scrollHeight > $q.screen.height) return;
					el.classList.add("hide-scrollbar");
				} else clearTimeout(timer);
				timer = setTimeout(restoreScrollbar, 300);
			};
			const updateScrollEvent = (action) => {
				if (timer !== null && action === "remove") {
					clearTimeout(timer);
					restoreScrollbar();
				}
				window[`${action}EventListener`]("resize", hideScrollbar);
			};
			watch(() => props.container ? "remove" : "add", updateScrollEvent);
			if (!props.container) updateScrollEvent("add");
			onUnmounted(() => {
				updateScrollEvent("remove");
			});
		}
		return () => {
			const content = hMergeSlot(slots.default, [h(QScrollObserver_default, { onScroll: onPageScroll }), h(QResizeObserver_default, { onResize: onPageResize })]);
			const layout = h("div", {
				class: classes.value,
				style: style.value,
				ref: props.container ? void 0 : rootRef,
				tabindex: -1
			}, content);
			if (props.container) return h("div", {
				class: "q-layout-container overflow-hidden",
				ref: rootRef
			}, [h(QResizeObserver_default, { onResize: onContainerResize }), h("div", {
				class: "absolute-full",
				style: targetStyle.value
			}, [h("div", {
				class: "scroll",
				style: targetChildStyle.value
			}, [layout])])]);
			return layout;
		};
	}
});
var defaultSizes = {
	xs: 2,
	sm: 4,
	md: 6,
	lg: 10,
	xl: 14
};
function width(val) {
	return { transform: `scale3d(${val},1,1)` };
}
var QLinearProgress_default = /*#__PURE__*/ createComponent({
	name: "QLinearProgress",
	props: {
		...useDarkProps,
		...useSizeProps,
		value: {
			type: Number,
			default: 0
		},
		buffer: Number,
		color: String,
		trackColor: String,
		reverse: Boolean,
		stripe: Boolean,
		indeterminate: Boolean,
		query: Boolean,
		rounded: Boolean,
		animationSpeed: {
			type: [String, Number],
			default: 2100
		},
		instantFeedback: Boolean
	},
	setup(props, { slots }) {
		const { proxy } = getCurrentInstance();
		const isDark = useDark(props, proxy.$q);
		const sizeStyle = useSize(props, defaultSizes);
		const motion = computed(() => props.indeterminate || props.query);
		const style = computed(() => ({
			...sizeStyle.value !== null ? sizeStyle.value : {},
			"--q-linear-progress-speed": `${props.animationSpeed}ms`
		}));
		const classes = computed(() => "q-linear-progress" + (props.color !== void 0 ? ` text-${props.color}` : "") + (props.reverse || props.query ? " q-linear-progress--reverse" : "") + (props.rounded ? " rounded-borders" : ""));
		const trackStyle = computed(() => width(props.buffer !== void 0 ? props.buffer : 1));
		const transitionSuffix = computed(() => `with${props.instantFeedback ? "out" : ""}-transition`);
		const trackClass = computed(() => `q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value ? "dark" : "light"}` + (props.trackColor !== void 0 ? ` bg-${props.trackColor}` : ""));
		const modelStyle = computed(() => width(motion.value ? 1 : props.value));
		const modelClass = computed(() => `q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value ? "in" : ""}determinate`);
		const stripeStyle = computed(() => ({ width: `${props.value * 100}%` }));
		const stripeClass = computed(() => `q-linear-progress__stripe absolute-${props.reverse ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`);
		return () => {
			const child = [h("div", {
				class: trackClass.value,
				style: trackStyle.value
			}), h("div", {
				class: modelClass.value,
				style: modelStyle.value
			})];
			if (props.stripe && !motion.value) child.push(h("div", {
				class: stripeClass.value,
				style: stripeStyle.value
			}));
			return h("div", {
				class: classes.value,
				style: style.value,
				role: "progressbar",
				"aria-valuemin": 0,
				"aria-valuemax": 1,
				"aria-valuenow": props.indeterminate ? void 0 : props.value
			}, hMergeSlot(slots.default, child));
		};
	}
});
var separatorValues = [
	"horizontal",
	"vertical",
	"cell",
	"none"
];
var QMarkupTable_default = /*#__PURE__*/ createComponent({
	name: "QMarkupTable",
	props: {
		...useDarkProps,
		dense: Boolean,
		flat: Boolean,
		bordered: Boolean,
		square: Boolean,
		wrapCells: Boolean,
		separator: {
			type: String,
			default: "horizontal",
			validator: (v) => separatorValues.includes(v)
		}
	},
	setup(props, { slots }) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const classes = computed(() => `q-markup-table q-table__container q-table__card q-table--${props.separator}-separator` + (isDark.value ? " q-table--dark q-table__card--dark q-dark" : "") + (props.dense ? " q-table--dense" : "") + (props.flat ? " q-table--flat" : "") + (props.bordered ? " q-table--bordered" : "") + (props.square ? " q-table--square" : "") + (props.wrapCells ? "" : " q-table--no-wrap"));
		return () => h("div", { class: classes.value }, [h("table", { class: "q-table" }, hSlot(slots.default))]);
	}
});
var createSvg = () => h("svg", {
	key: "svg",
	class: "q-radio__bg absolute non-selectable",
	viewBox: "0 0 24 24"
}, [h("path", { d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12" }), h("path", {
	class: "q-radio__check",
	d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
})]);
function onKeydown(e) {
	if (e.keyCode === 13 || e.keyCode === 32) stopAndPrevent(e);
}
var QRadio_default = /*#__PURE__*/ createComponent({
	name: "QRadio",
	props: {
		...useDarkProps,
		...useSizeProps,
		...useFormProps,
		modelValue: { required: true },
		val: { required: true },
		label: String,
		leftLabel: Boolean,
		checkedIcon: String,
		uncheckedIcon: String,
		color: String,
		keepColor: Boolean,
		dense: Boolean,
		disable: Boolean,
		tabindex: [String, Number]
	},
	emits: ["update:modelValue"],
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const isDark = useDark(props, proxy.$q);
		const sizeStyle = useSize(props, option_sizes_default);
		const rootRef = ref(null);
		const { refocusTargetEl, refocusTarget } = useRefocusTarget(props, rootRef);
		const isTrue = computed(() => toRaw(props.modelValue) === toRaw(props.val));
		const classes = computed(() => "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (props.disable ? " disabled" : "") + (isDark.value ? " q-radio--dark" : "") + (props.dense ? " q-radio--dense" : "") + (props.leftLabel ? " reverse" : ""));
		const innerClass = computed(() => {
			const color = props.color !== void 0 && (props.keepColor || isTrue.value) ? ` text-${props.color}` : "";
			return `q-radio__inner relative-position q-radio__inner--${isTrue.value ? "truthy" : "falsy"}${color}`;
		});
		const icon = computed(() => (isTrue.value ? props.checkedIcon : props.uncheckedIcon) || null);
		const tabindex = computed(() => props.disable ? -1 : props.tabindex || 0);
		const injectFormInput = useFormInject(computed(() => {
			const prop = { type: "radio" };
			if (props.name !== void 0) Object.assign(prop, {
				".checked": isTrue.value,
				"^checked": isTrue.value ? "checked" : void 0,
				name: props.name,
				value: props.val
			});
			return prop;
		}));
		function onClick(e) {
			if (e !== void 0) {
				stopAndPrevent(e);
				refocusTarget(e);
			}
			if (!props.disable && !isTrue.value) emit("update:modelValue", props.val, e);
		}
		function onKeyup(e) {
			if (e.keyCode === 13 || e.keyCode === 32) onClick(e);
		}
		Object.assign(proxy, { set: onClick });
		const svg = createSvg();
		return () => {
			const content = icon.value !== null ? [h("div", {
				key: "icon",
				class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
			}, [h(QIcon_default, {
				class: "q-radio__icon",
				name: icon.value
			})])] : [svg];
			if (!props.disable) injectFormInput(content, "unshift", " q-radio__native q-ma-none q-pa-none");
			const child = [h("div", {
				class: innerClass.value,
				style: sizeStyle.value,
				"aria-hidden": "true"
			}, content)];
			if (refocusTargetEl.value !== null) child.push(refocusTargetEl.value);
			const label = props.label !== void 0 ? hMergeSlot(slots.default, [props.label]) : hSlot(slots.default);
			if (label !== void 0) child.push(h("div", { class: "q-radio__label q-anchor--skip" }, label));
			return h("div", {
				ref: rootRef,
				class: classes.value,
				tabindex: tabindex.value,
				role: "radio",
				"aria-label": props.label,
				"aria-checked": isTrue.value ? "true" : "false",
				"aria-disabled": props.disable ? "true" : void 0,
				onClick,
				onKeydown,
				onKeyup
			}, child);
		};
	}
});
var QToggle_default = /*#__PURE__*/ createComponent({
	name: "QToggle",
	props: {
		...useCheckboxProps,
		icon: String,
		iconColor: String
	},
	emits: useCheckboxEmits,
	setup(props) {
		function getInner(isTrue, isIndeterminate) {
			const icon = computed(() => (isTrue.value ? props.checkedIcon : isIndeterminate.value ? props.indeterminateIcon : props.uncheckedIcon) || props.icon);
			const color = computed(() => isTrue.value ? props.iconColor : null);
			return () => [h("div", { class: "q-toggle__track" }), h("div", { class: "q-toggle__thumb absolute flex flex-center no-wrap" }, icon.value !== void 0 ? [h(QIcon_default, {
				name: icon.value,
				color: color.value
			})] : void 0)];
		}
		return useCheckbox("toggle", getInner);
	}
});
({ ...useDarkProps });
var QPage_default = /*#__PURE__*/ createComponent({
	name: "QPage",
	props: {
		padding: Boolean,
		styleFn: Function
	},
	setup(props, { slots }) {
		const { proxy: { $q } } = getCurrentInstance();
		const $layout = inject(layoutKey, emptyRenderFn);
		if ($layout === emptyRenderFn) {
			console.error("QPage needs to be a deep child of QLayout");
			return emptyRenderFn;
		}
		if (inject("_q_pc_", emptyRenderFn) === emptyRenderFn) {
			console.error("QPage needs to be child of QPageContainer");
			return emptyRenderFn;
		}
		const style = computed(() => {
			const offset = ($layout.header.space ? $layout.header.size : 0) + ($layout.footer.space ? $layout.footer.size : 0);
			if (typeof props.styleFn === "function") {
				const height = $layout.isContainer.value ? $layout.containerHeight.value : $q.screen.height;
				return props.styleFn(offset, height);
			}
			return { minHeight: $layout.isContainer.value ? $layout.containerHeight.value - offset + "px" : $q.screen.height === 0 ? offset !== 0 ? `calc(100vh - ${offset}px)` : "100vh" : $q.screen.height - offset + "px" };
		});
		const classes = computed(() => `q-page${props.padding ? " q-layout-padding" : ""}`);
		return () => h("main", {
			class: classes.value,
			style: style.value
		}, hSlot(slots.default));
	}
});
var QPageContainer_default = /*#__PURE__*/ createComponent({
	name: "QPageContainer",
	setup(_, { slots }) {
		const { proxy: { $q } } = getCurrentInstance();
		const $layout = inject(layoutKey, emptyRenderFn);
		if ($layout === emptyRenderFn) {
			console.error("QPageContainer needs to be child of QLayout");
			return emptyRenderFn;
		}
		provide(pageContainerKey, true);
		const style = computed(() => {
			const css = {};
			if ($layout.header.space) css.paddingTop = `${$layout.header.size}px`;
			if ($layout.right.space) css[`padding${$q.lang.rtl ? "Left" : "Right"}`] = `${$layout.right.size}px`;
			if ($layout.footer.space) css.paddingBottom = `${$layout.footer.size}px`;
			if ($layout.left.space) css[`padding${$q.lang.rtl ? "Right" : "Left"}`] = `${$layout.left.size}px`;
			return css;
		});
		return () => h("div", {
			class: "q-page-container",
			style: style.value
		}, hSlot(slots.default));
	}
});
var usePageStickyProps = {
	position: {
		type: String,
		default: "bottom-right",
		validator: (v) => [
			"top-right",
			"top-left",
			"bottom-right",
			"bottom-left",
			"top",
			"right",
			"bottom",
			"left"
		].includes(v)
	},
	offset: {
		type: Array,
		validator: (v) => v.length === 2
	},
	expand: Boolean
};
({ ...usePageStickyProps }), { ...usePageStickyProps.offset };
({ ...useDarkProps });
var { passive: passive$1 } = listenOpts;
var QPopupProxy_default = /*#__PURE__*/ createComponent({
	name: "QPopupProxy",
	props: {
		...useAnchorProps,
		breakpoint: {
			type: [String, Number],
			default: 450
		}
	},
	emits: ["show", "hide"],
	setup(props, { slots, emit, attrs }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const showing = ref(false);
		const popupRef = ref(null);
		const breakpoint = computed(() => Number.parseInt(props.breakpoint, 10));
		const { canShow } = useAnchor({
			showing,
			avoidEmit: true
		});
		function getType() {
			return $q.screen.width < breakpoint.value || $q.screen.height < breakpoint.value ? "dialog" : "menu";
		}
		const type = ref(getType());
		const popupProps = computed(() => type.value === "menu" ? { maxHeight: "99vh" } : {});
		watch(() => getType(), (val) => {
			if (!showing.value) type.value = val;
		});
		function onShow(evt) {
			showing.value = true;
			emit("show", evt);
		}
		function onHide(evt) {
			showing.value = false;
			type.value = getType();
			emit("hide", evt);
		}
		Object.assign(proxy, {
			show(evt) {
				if (canShow(evt)) popupRef.value.show(evt);
			},
			hide(evt) {
				popupRef.value.hide(evt);
			},
			toggle(evt) {
				popupRef.value.toggle(evt);
			}
		});
		injectProp(proxy, "currentComponent", () => ({
			type: type.value,
			ref: popupRef.value
		}));
		return () => {
			const data = {
				ref: popupRef,
				...popupProps.value,
				...attrs,
				onShow,
				onHide
			};
			let component;
			if (type.value === "dialog") component = QDialog_default;
			else {
				component = QMenu_default;
				Object.assign(data, {
					target: props.target,
					contextMenu: props.contextMenu,
					noParentEvent: true,
					separateClosePopup: true
				});
			}
			return h(component, data, slots.default);
		};
	}
});
var dragType = {
	MIN: 0,
	RANGE: 1,
	MAX: 2
};
var emptyModel = {
	min: null,
	max: null
};
var QRange_default = /*#__PURE__*/ createComponent({
	name: "QRange",
	props: {
		...useSliderProps,
		modelValue: {
			type: Object,
			default: () => ({
				min: null,
				max: null
			}),
			validator: (v) => "min" in v && "max" in v
		},
		dragRange: Boolean,
		dragOnlyRange: Boolean,
		leftLabelColor: String,
		leftLabelTextColor: String,
		rightLabelColor: String,
		rightLabelTextColor: String,
		leftLabelValue: [String, Number],
		rightLabelValue: [String, Number],
		leftThumbColor: String,
		rightThumbColor: String
	},
	emits: useSliderEmits,
	setup(props, { emit }) {
		const { proxy: { $q } } = getCurrentInstance();
		const modelProp = computed(() => props.modelValue || emptyModel);
		const { state, methods } = useSlider({
			updateValue,
			updatePosition,
			getDragging,
			formAttrs: computed(() => ({
				type: "hidden",
				name: props.name,
				value: `${modelProp.value.min}|${modelProp.value.max}`
			}))
		});
		const rootRef = ref(null);
		const curMinRatio = ref(0);
		const curMaxRatio = ref(0);
		const model = ref({
			min: 0,
			max: 0
		});
		function normalizeModel() {
			model.value.min = modelProp.value.min === null ? state.innerMin.value : between(modelProp.value.min, state.innerMin.value, state.innerMax.value);
			model.value.max = modelProp.value.max === null ? state.innerMax.value : between(modelProp.value.max, state.innerMin.value, state.innerMax.value);
		}
		watch(() => `${modelProp.value.min}|${modelProp.value.max}|${state.innerMin.value}|${state.innerMax.value}`, normalizeModel);
		normalizeModel();
		const modelMinRatio = computed(() => methods.convertModelToRatio(model.value.min));
		const modelMaxRatio = computed(() => methods.convertModelToRatio(model.value.max));
		const ratioMin = computed(() => state.active.value ? curMinRatio.value : modelMinRatio.value);
		const ratioMax = computed(() => state.active.value ? curMaxRatio.value : modelMaxRatio.value);
		const selectionBarStyle = computed(() => {
			const acc = {
				[state.positionProp.value]: `${100 * ratioMin.value}%`,
				[state.sizeProp.value]: `${100 * (ratioMax.value - ratioMin.value)}%`
			};
			if (props.selectionImg !== void 0) acc.backgroundImage = `url(${props.selectionImg}) !important`;
			return acc;
		});
		const trackContainerEvents = computed(() => {
			if (!state.editable.value) return {};
			if ($q.platform.is.mobile) return { onClick: methods.onMobileClick };
			const evt = { onMousedown: methods.onActivate };
			if (props.dragRange || props.dragOnlyRange) Object.assign(evt, {
				onFocus: () => {
					state.focus.value = "both";
				},
				onBlur: methods.onBlur,
				onKeydown,
				onKeyup: methods.onKeyup
			});
			return evt;
		});
		function getEvents(side) {
			return !$q.platform.is.mobile && state.editable.value && !props.dragOnlyRange ? {
				onFocus: () => {
					state.focus.value = side;
				},
				onBlur: methods.onBlur,
				onKeydown,
				onKeyup: methods.onKeyup
			} : {};
		}
		const thumbTabindex = computed(() => props.dragOnlyRange ? null : state.tabindex.value);
		const trackContainerTabindex = computed(() => !$q.platform.is.mobile && (props.dragRange || props.dragOnlyRange) ? state.tabindex.value : null);
		const minThumbRef = ref(null);
		const minEvents = computed(() => getEvents("min"));
		const getMinThumb = methods.getThumbRenderFn({
			focusValue: "min",
			getNodeData: () => ({
				ref: minThumbRef,
				key: "tmin",
				...minEvents.value,
				tabindex: thumbTabindex.value
			}),
			ratio: ratioMin,
			label: computed(() => props.leftLabelValue !== void 0 ? props.leftLabelValue : model.value.min),
			thumbColor: computed(() => props.leftThumbColor || props.thumbColor || props.color),
			labelColor: computed(() => props.leftLabelColor || props.labelColor),
			labelTextColor: computed(() => props.leftLabelTextColor || props.labelTextColor)
		});
		const maxEvents = computed(() => getEvents("max"));
		const getMaxThumb = methods.getThumbRenderFn({
			injectFormInput: false,
			focusValue: "max",
			getNodeData: () => ({
				...maxEvents.value,
				key: "tmax",
				tabindex: thumbTabindex.value
			}),
			ratio: ratioMax,
			label: computed(() => props.rightLabelValue !== void 0 ? props.rightLabelValue : model.value.max),
			thumbColor: computed(() => props.rightThumbColor || props.thumbColor || props.color),
			labelColor: computed(() => props.rightLabelColor || props.labelColor),
			labelTextColor: computed(() => props.rightLabelTextColor || props.labelTextColor)
		});
		function updateValue(change) {
			if (model.value.min !== modelProp.value.min || model.value.max !== modelProp.value.max) emit("update:modelValue", { ...model.value });
			if (change) emit("change", { ...model.value });
		}
		function getDragging(event) {
			const { left, top, width, height } = rootRef.value.getBoundingClientRect(), sensitivity = props.dragOnlyRange ? 0 : props.vertical ? minThumbRef.value.offsetHeight / (2 * height) : minThumbRef.value.offsetWidth / (2 * width);
			const dragging = {
				left,
				top,
				width,
				height,
				valueMin: model.value.min,
				valueMax: model.value.max,
				ratioMin: modelMinRatio.value,
				ratioMax: modelMaxRatio.value
			};
			const ratio = methods.getDraggingRatio(event, dragging);
			if (!props.dragOnlyRange && ratio < dragging.ratioMin + sensitivity) dragging.type = dragType.MIN;
			else if (props.dragOnlyRange || ratio < dragging.ratioMax - sensitivity) if (props.dragRange || props.dragOnlyRange) {
				dragging.type = dragType.RANGE;
				Object.assign(dragging, {
					offsetRatio: ratio,
					offsetModel: methods.convertRatioToModel(ratio),
					rangeValue: dragging.valueMax - dragging.valueMin,
					rangeRatio: dragging.ratioMax - dragging.ratioMin
				});
			} else dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
			else dragging.type = dragType.MAX;
			return dragging;
		}
		function updatePosition(event, dragging = state.dragging.value) {
			let pos;
			const ratio = methods.getDraggingRatio(event, dragging);
			const localModel = methods.convertRatioToModel(ratio);
			switch (dragging.type) {
				case dragType.MIN:
					if (ratio <= dragging.ratioMax) {
						pos = {
							minR: ratio,
							maxR: dragging.ratioMax,
							min: localModel,
							max: dragging.valueMax
						};
						state.focus.value = "min";
					} else {
						pos = {
							minR: dragging.ratioMax,
							maxR: ratio,
							min: dragging.valueMax,
							max: localModel
						};
						state.focus.value = "max";
					}
					break;
				case dragType.MAX:
					if (ratio >= dragging.ratioMin) {
						pos = {
							minR: dragging.ratioMin,
							maxR: ratio,
							min: dragging.valueMin,
							max: localModel
						};
						state.focus.value = "max";
					} else {
						pos = {
							minR: ratio,
							maxR: dragging.ratioMin,
							min: localModel,
							max: dragging.valueMin
						};
						state.focus.value = "min";
					}
					break;
				case dragType.RANGE: {
					const ratioDelta = ratio - dragging.offsetRatio, minR = between(dragging.ratioMin + ratioDelta, state.innerMinRatio.value, state.innerMaxRatio.value - dragging.rangeRatio), modelDelta = localModel - dragging.offsetModel, min = between(dragging.valueMin + modelDelta, state.innerMin.value, state.innerMax.value - dragging.rangeValue);
					pos = {
						minR,
						maxR: minR + dragging.rangeRatio,
						min: state.roundValueFn.value(min),
						max: state.roundValueFn.value(min + dragging.rangeValue)
					};
					state.focus.value = "both";
					break;
				}
			}
			model.value = model.value.min === null || model.value.max === null ? {
				min: pos.min ?? props.min,
				max: pos.max ?? props.max
			} : {
				min: pos.min,
				max: pos.max
			};
			if (!props.snap || props.step === 0) {
				curMinRatio.value = pos.minR;
				curMaxRatio.value = pos.maxR;
			} else {
				curMinRatio.value = methods.convertModelToRatio(model.value.min);
				curMaxRatio.value = methods.convertModelToRatio(model.value.max);
			}
		}
		function onKeydown(evt) {
			if (!keyCodes$2.includes(evt.keyCode)) return;
			stopAndPrevent(evt);
			const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state.keyStep.value, offset = ([
				34,
				37,
				40
			].includes(evt.keyCode) ? -1 : 1) * (state.isReversed.value ? -1 : 1) * (props.vertical ? -1 : 1) * stepVal;
			if (state.focus.value === "both") {
				const interval = model.value.max - model.value.min;
				const min = between(state.roundValueFn.value(model.value.min + offset), state.innerMin.value, state.innerMax.value - interval);
				model.value = {
					min,
					max: state.roundValueFn.value(min + interval)
				};
			} else if (!state.focus.value) return;
			else {
				const which = state.focus.value;
				model.value = {
					...model.value,
					[which]: between(state.roundValueFn.value(model.value[which] + offset), which === "min" ? state.innerMin.value : model.value.min, which === "max" ? state.innerMax.value : model.value.max)
				};
			}
			updateValue();
		}
		return () => {
			const content = methods.getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, (node) => {
				node.push(getMinThumb(), getMaxThumb());
			});
			return h("div", {
				ref: rootRef,
				class: "q-range " + state.classes.value + (modelProp.value.min === null || modelProp.value.max === null ? " q-slider--no-value" : ""),
				...state.attributes.value,
				"aria-valuenow": modelProp.value.min + "|" + modelProp.value.max
			}, content);
		};
	}
});
({
	...useSizeProps,
	...useFormProps
});
/**
* We are using a sub-component to avoid unnecessary re-renders
* of the QScrollArea content when the scrollbars are interacted with.
*/
var ScrollAreaControls_default = /*#__PURE__*/ createComponent({
	props: [
		"store",
		"barStyle",
		"verticalBarStyle",
		"horizontalBarStyle"
	],
	setup(props) {
		return () => [
			h("div", {
				class: props.store.scroll.vertical.barClass.value,
				style: [props.barStyle, props.verticalBarStyle],
				"aria-hidden": "true",
				onMousedown: props.store.onVerticalMousedown
			}),
			h("div", {
				class: props.store.scroll.horizontal.barClass.value,
				style: [props.barStyle, props.horizontalBarStyle],
				"aria-hidden": "true",
				onMousedown: props.store.onHorizontalMousedown
			}),
			withDirectives(h("div", {
				ref: props.store.scroll.vertical.ref,
				class: props.store.scroll.vertical.thumbClass.value,
				style: props.store.scroll.vertical.style.value,
				"aria-hidden": "true"
			}), props.store.thumbVertDir),
			withDirectives(h("div", {
				ref: props.store.scroll.horizontal.ref,
				class: props.store.scroll.horizontal.thumbClass.value,
				style: props.store.scroll.horizontal.style.value,
				"aria-hidden": "true"
			}), props.store.thumbHorizDir)
		];
	}
});
var axisList = ["vertical", "horizontal"];
var dirProps = {
	vertical: {
		offset: "offsetY",
		scroll: "scrollTop",
		dir: "down",
		dist: "y"
	},
	horizontal: {
		offset: "offsetX",
		scroll: "scrollLeft",
		dir: "right",
		dist: "x"
	}
};
var panOpts = {
	prevent: true,
	mouse: true,
	mouseAllDir: true
};
var getMinThumbSize = (size) => size >= 250 ? 50 : Math.ceil(size / 5);
function isValidAxis(axis, methodName) {
	if (axisList.includes(axis)) return true;
	console.error(`[QScrollArea]: wrong first param of ${methodName} (vertical/horizontal)`);
	return false;
}
var QScrollArea_default = /*#__PURE__*/ createComponent({
	name: "QScrollArea",
	props: {
		...useDarkProps,
		thumbStyle: Object,
		verticalThumbStyle: Object,
		horizontalThumbStyle: Object,
		barStyle: [
			Array,
			String,
			Object
		],
		verticalBarStyle: [
			Array,
			String,
			Object
		],
		horizontalBarStyle: [
			Array,
			String,
			Object
		],
		verticalOffset: {
			type: Array,
			default: () => [0, 0]
		},
		horizontalOffset: {
			type: Array,
			default: () => [0, 0]
		},
		contentStyle: [
			Array,
			String,
			Object
		],
		contentActiveStyle: [
			Array,
			String,
			Object
		],
		delay: {
			type: [String, Number],
			default: 1e3
		},
		visible: {
			type: Boolean,
			default: null
		},
		tabindex: [String, Number],
		onScroll: Function
	},
	setup(props, { slots, emit }) {
		const tempShowing = ref(false);
		const panning = ref(false);
		const hover = ref(false);
		const container = {
			vertical: ref(0),
			horizontal: ref(0)
		};
		const scroll = {
			vertical: {
				ref: ref(null),
				position: ref(0),
				size: ref(0)
			},
			horizontal: {
				ref: ref(null),
				position: ref(0),
				size: ref(0)
			}
		};
		const { proxy } = getCurrentInstance();
		const isDark = useDark(props, proxy.$q);
		let timer = null, panRefPos;
		const targetRef = ref(null);
		const classes = computed(() => "q-scrollarea" + (isDark.value ? " q-scrollarea--dark" : ""));
		Object.assign(container, {
			verticalInner: computed(() => container.vertical.value - props.verticalOffset[0] - props.verticalOffset[1]),
			horizontalInner: computed(() => container.horizontal.value - props.horizontalOffset[0] - props.horizontalOffset[1])
		});
		scroll.vertical.percentage = computed(() => {
			const diff = scroll.vertical.size.value - container.vertical.value;
			if (diff <= 0) return 0;
			const p = between(scroll.vertical.position.value / diff, 0, 1);
			return Math.round(p * 1e4) / 1e4;
		});
		scroll.vertical.thumbHidden = computed(() => !(props.visible === null ? hover.value : props.visible) && !tempShowing.value && !panning.value || scroll.vertical.size.value <= container.vertical.value + 1);
		scroll.vertical.thumbStart = computed(() => props.verticalOffset[0] + scroll.vertical.percentage.value * (container.verticalInner.value - scroll.vertical.thumbSize.value));
		scroll.vertical.thumbSize = computed(() => Math.round(between(container.verticalInner.value * container.verticalInner.value / scroll.vertical.size.value, getMinThumbSize(container.verticalInner.value), container.verticalInner.value)));
		scroll.vertical.style = computed(() => ({
			...props.thumbStyle,
			...props.verticalThumbStyle,
			top: `${scroll.vertical.thumbStart.value}px`,
			height: `${scroll.vertical.thumbSize.value}px`,
			right: `${props.horizontalOffset[1]}px`
		}));
		scroll.vertical.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (scroll.vertical.thumbHidden.value ? " q-scrollarea__thumb--invisible" : ""));
		scroll.vertical.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (scroll.vertical.thumbHidden.value ? " q-scrollarea__bar--invisible" : ""));
		scroll.horizontal.percentage = computed(() => {
			const diff = scroll.horizontal.size.value - container.horizontal.value;
			if (diff <= 0) return 0;
			const p = between(getHorizontalLogicalPosition(scroll.horizontal.position.value) / diff, 0, 1);
			return Math.round(p * 1e4) / 1e4;
		});
		scroll.horizontal.thumbHidden = computed(() => !(props.visible === null ? hover.value : props.visible) && !tempShowing.value && !panning.value || scroll.horizontal.size.value <= container.horizontal.value + 1);
		scroll.horizontal.thumbStart = computed(() => props.horizontalOffset[proxy.$q.lang.rtl ? 1 : 0] + scroll.horizontal.percentage.value * (container.horizontalInner.value - scroll.horizontal.thumbSize.value));
		scroll.horizontal.thumbSize = computed(() => Math.round(between(container.horizontalInner.value * container.horizontalInner.value / scroll.horizontal.size.value, getMinThumbSize(container.horizontalInner.value), container.horizontalInner.value)));
		scroll.horizontal.style = computed(() => ({
			...props.thumbStyle,
			...props.horizontalThumbStyle,
			[proxy.$q.lang.rtl ? "right" : "left"]: `${scroll.horizontal.thumbStart.value}px`,
			width: `${scroll.horizontal.thumbSize.value}px`,
			bottom: `${props.verticalOffset[1]}px`
		}));
		scroll.horizontal.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (scroll.horizontal.thumbHidden.value ? " q-scrollarea__thumb--invisible" : ""));
		scroll.horizontal.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (scroll.horizontal.thumbHidden.value ? " q-scrollarea__bar--invisible" : ""));
		const mainStyle = computed(() => scroll.vertical.thumbHidden.value && scroll.horizontal.thumbHidden.value ? props.contentStyle : props.contentActiveStyle);
		function getScroll() {
			const info = {};
			axisList.forEach((axis) => {
				const data = scroll[axis];
				Object.assign(info, {
					[axis + "Position"]: data.position.value,
					[axis + "Percentage"]: data.percentage.value,
					[axis + "Size"]: data.size.value,
					[axis + "ContainerSize"]: container[axis].value,
					[axis + "ContainerInnerSize"]: container[axis + "Inner"].value
				});
			});
			return info;
		}
		const emitScroll = debounce(() => {
			const info = getScroll();
			info.ref = proxy;
			emit("scroll", info);
		}, 0);
		function localSetScrollPosition(axis, offset, duration) {
			if (!isValidAxis(axis, "setScrollPosition")) return;
			(axis === "vertical" ? setVerticalScrollPosition : setHorizontalScrollPosition)(targetRef.value, offset, duration);
		}
		function updateContainer({ height, width }) {
			let change = false;
			if (container.vertical.value !== height) {
				container.vertical.value = height;
				change = true;
			}
			if (container.horizontal.value !== width) {
				container.horizontal.value = width;
				change = true;
			}
			if (change) startTimer();
		}
		function updateScroll({ position }) {
			let change = false;
			if (scroll.vertical.position.value !== position.top) {
				scroll.vertical.position.value = position.top;
				change = true;
			}
			if (scroll.horizontal.position.value !== position.left) {
				scroll.horizontal.position.value = position.left;
				change = true;
			}
			if (change) startTimer();
		}
		function updateScrollSize({ height, width }) {
			if (scroll.horizontal.size.value !== width) {
				scroll.horizontal.size.value = width;
				startTimer();
			}
			if (scroll.vertical.size.value !== height) {
				scroll.vertical.size.value = height;
				startTimer();
			}
		}
		function onPanThumb(e, axis) {
			const data = scroll[axis];
			if (e.isFirst) {
				if (data.thumbHidden.value) return;
				panRefPos = axis === "horizontal" ? getHorizontalLogicalPosition(data.position.value) : data.position.value;
				panning.value = true;
			} else if (!panning.value) return;
			if (e.isFinal) panning.value = false;
			const dProp = dirProps[axis];
			const multiplier = (data.size.value - container[axis].value) / (container[axis + "Inner"].value - data.thumbSize.value);
			const distance = e.distance[dProp.dist];
			const direction = (e.direction === dProp.dir ? 1 : -1) * (axis === "horizontal" && proxy.$q.lang.rtl ? -1 : 1);
			const pos = panRefPos + direction * distance * multiplier;
			setScroll(axis === "horizontal" ? getHorizontalNativePosition(pos) : pos, axis);
		}
		function onMousedown(evt, axis) {
			const data = scroll[axis];
			if (!data.thumbHidden.value) {
				const isHorizontalRtl = axis === "horizontal" && proxy.$q.lang.rtl;
				const startOffset = axis === "vertical" ? props.verticalOffset[0] : props.horizontalOffset[isHorizontalRtl ? 1 : 0];
				const offset = (isHorizontalRtl ? container.horizontal.value - evt.offsetX : evt[dirProps[axis].offset]) - startOffset;
				const thumbStart = data.thumbStart.value - startOffset;
				if (offset < thumbStart || offset > thumbStart + data.thumbSize.value) {
					const percentage = between((offset - data.thumbSize.value / 2) / (container[axis + "Inner"].value - data.thumbSize.value), 0, 1);
					setScroll(isHorizontalRtl ? getHorizontalNativePosition(percentage * Math.max(0, data.size.value - container[axis].value)) : percentage * Math.max(0, data.size.value - container[axis].value), axis);
				}
				if (data.ref.value !== null) data.ref.value.dispatchEvent(new MouseEvent(evt.type, evt));
			}
		}
		function startTimer() {
			tempShowing.value = true;
			if (timer !== null) clearTimeout(timer);
			timer = setTimeout(() => {
				timer = null;
				tempShowing.value = false;
			}, props.delay);
			if (props.onScroll !== void 0) emitScroll();
		}
		function setScroll(offset, axis) {
			targetRef.value[dirProps[axis].scroll] = offset;
		}
		function getHorizontalLogicalPosition(position, rtl = proxy.$q.lang.rtl) {
			if (!rtl) return position;
			return rtlHasScrollBug ? Math.max(0, scroll.horizontal.size.value - container.horizontal.value) - position : -position;
		}
		function getHorizontalNativePosition(position, rtl = proxy.$q.lang.rtl) {
			if (!rtl) return position;
			return rtlHasScrollBug ? Math.max(0, scroll.horizontal.size.value - container.horizontal.value) - position : -position;
		}
		let mouseEventTimer = null;
		function onMouseenter() {
			if (mouseEventTimer !== null) clearTimeout(mouseEventTimer);
			mouseEventTimer = setTimeout(() => {
				mouseEventTimer = null;
				hover.value = true;
			}, proxy.$q.platform.is.ios ? 50 : 0);
		}
		function onMouseleave() {
			if (mouseEventTimer !== null) {
				clearTimeout(mouseEventTimer);
				mouseEventTimer = null;
			}
			hover.value = false;
		}
		let scrollPosition = null;
		watch(() => proxy.$q.lang.rtl, (rtl, oldRtl) => {
			if (targetRef.value !== null) setHorizontalScrollPosition(targetRef.value, getHorizontalNativePosition(getHorizontalLogicalPosition(scroll.horizontal.position.value, oldRtl), rtl));
		});
		onDeactivated(() => {
			scrollPosition = {
				top: scroll.vertical.position.value,
				left: scroll.horizontal.position.value
			};
		});
		onActivated(() => {
			if (scrollPosition === null) return;
			const scrollTarget = targetRef.value;
			if (scrollTarget !== null) {
				setHorizontalScrollPosition(scrollTarget, scrollPosition.left);
				setVerticalScrollPosition(scrollTarget, scrollPosition.top);
			}
		});
		onBeforeUnmount(emitScroll.cancel);
		Object.assign(proxy, {
			getScrollTarget: () => targetRef.value,
			getScroll,
			getScrollPosition: () => ({
				top: scroll.vertical.position.value,
				left: scroll.horizontal.position.value
			}),
			getScrollPercentage: () => ({
				top: scroll.vertical.percentage.value,
				left: scroll.horizontal.percentage.value
			}),
			setScrollPosition: localSetScrollPosition,
			setScrollPercentage(axis, percentage, duration) {
				if (!isValidAxis(axis, "setScrollPercentage")) return;
				const offset = percentage * (scroll[axis].size.value - container[axis].value);
				localSetScrollPosition(axis, axis === "horizontal" ? getHorizontalNativePosition(offset) : offset, duration);
			}
		});
		const store = {
			scroll,
			thumbVertDir: [[
				TouchPan_default,
				(e) => {
					onPanThumb(e, "vertical");
				},
				void 0,
				{
					vertical: true,
					...panOpts
				}
			]],
			thumbHorizDir: [[
				TouchPan_default,
				(e) => {
					onPanThumb(e, "horizontal");
				},
				void 0,
				{
					horizontal: true,
					...panOpts
				}
			]],
			onVerticalMousedown(evt) {
				onMousedown(evt, "vertical");
			},
			onHorizontalMousedown(evt) {
				onMousedown(evt, "horizontal");
			}
		};
		return () => h("div", {
			class: classes.value,
			onMouseenter,
			onMouseleave
		}, [
			h("div", {
				ref: targetRef,
				class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
				tabindex: props.tabindex !== void 0 ? props.tabindex : void 0
			}, [h("div", {
				class: "q-scrollarea__content absolute",
				style: mainStyle.value
			}, hMergeSlot(slots.default, [h(QResizeObserver_default, {
				debounce: 0,
				onResize: updateScrollSize
			})])), h(QScrollObserver_default, {
				axis: "both",
				onScroll: updateScroll
			})]),
			h(QResizeObserver_default, {
				debounce: 0,
				onResize: updateContainer
			}),
			h(ScrollAreaControls_default, {
				store,
				barStyle: props.barStyle,
				verticalBarStyle: props.verticalBarStyle,
				horizontalBarStyle: props.horizontalBarStyle
			})
		]);
	}
});
var aggBucketSize = 1e3;
var scrollToEdges = [
	"start",
	"center",
	"end",
	"start-force",
	"center-force",
	"end-force"
];
var filterProto = Array.prototype.filter;
var setOverflowAnchor = __QUASAR_SSR__ || window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop : function setOverflowAnchor(contentEl, index) {
	if (contentEl === null) return;
	if (contentEl._qOverflowAnimationFrame !== void 0) cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
	contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
		if (contentEl === null) return;
		contentEl._qOverflowAnimationFrame = void 0;
		const children = contentEl.children || [];
		filterProto.call(children, (el) => el.dataset && el.dataset.qVsAnchor !== void 0).forEach((el) => {
			delete el.dataset.qVsAnchor;
		});
		const el = children[index];
		if (el?.dataset) el.dataset.qVsAnchor = "";
	});
};
function sumFn(acc, item) {
	return acc + item;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
	const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal ? "offsetWidth" : "offsetHeight", details = {
		scrollStart: 0,
		scrollViewSize: -stickyStart - stickyEnd,
		scrollMaxSize: 0,
		offsetStart: -stickyStart,
		offsetEnd: -stickyEnd
	};
	if (horizontal) {
		if (parent === window) {
			details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
			details.scrollViewSize += document.documentElement.clientWidth;
		} else {
			details.scrollStart = parentCalc.scrollLeft;
			details.scrollViewSize += parentCalc.clientWidth;
		}
		details.scrollMaxSize = parentCalc.scrollWidth;
		if (rtl) details.scrollStart = (rtlHasScrollBug ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
	} else {
		if (parent === window) {
			details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
			details.scrollViewSize += document.documentElement.clientHeight;
		} else {
			details.scrollStart = parentCalc.scrollTop;
			details.scrollViewSize += parentCalc.clientHeight;
		}
		details.scrollMaxSize = parentCalc.scrollHeight;
	}
	if (beforeRef !== null) {
		for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) if (!el.classList.contains("q-virtual-scroll--skip")) details.offsetStart += el[propElSize];
	}
	if (afterRef !== null) {
		for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) if (!el.classList.contains("q-virtual-scroll--skip")) details.offsetEnd += el[propElSize];
	}
	if (child !== parent) {
		const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
		if (horizontal) {
			details.offsetStart += childRect.left - parentRect.left;
			details.offsetEnd -= childRect.width;
		} else {
			details.offsetStart += childRect.top - parentRect.top;
			details.offsetEnd -= childRect.height;
		}
		if (parent !== window) details.offsetStart += details.scrollStart;
		details.offsetEnd += details.scrollMaxSize - details.offsetStart;
	}
	return details;
}
function setScroll(parent, scroll, horizontal, rtl) {
	if (scroll === "end") scroll = (parent === window ? document.body : parent)[horizontal ? "scrollWidth" : "scrollHeight"];
	if (parent === window) if (horizontal) {
		if (rtl) scroll = (rtlHasScrollBug ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
		window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
	} else window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
	else if (horizontal) {
		if (rtl) scroll = (rtlHasScrollBug ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
		parent.scrollLeft = scroll;
	} else parent.scrollTop = scroll;
}
function sumSize(sizeAgg, size, from, to) {
	if (from >= to) return 0;
	const lastTo = size.length, fromAgg = Math.floor(from / aggBucketSize), toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
	let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
	if (from % aggBucketSize !== 0) total -= size.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
	if (to % aggBucketSize !== 0 && to !== lastTo) total -= size.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
	return total;
}
var commonVirtScrollProps = {
	virtualScrollSliceSize: {
		type: [Number, String],
		default: 10
	},
	virtualScrollSliceRatioBefore: {
		type: [Number, String],
		default: 1
	},
	virtualScrollSliceRatioAfter: {
		type: [Number, String],
		default: 1
	},
	virtualScrollItemSize: {
		type: [Number, String],
		default: 24
	},
	virtualScrollStickySizeStart: {
		type: [Number, String],
		default: 0
	},
	virtualScrollStickySizeEnd: {
		type: [Number, String],
		default: 0
	},
	tableColspan: [Number, String]
};
var commonVirtScrollPropsList = Object.keys(commonVirtScrollProps);
var useVirtualScrollProps = {
	virtualScrollHorizontal: Boolean,
	onVirtualScroll: Function,
	...commonVirtScrollProps
};
function useVirtualScroll({ virtualScrollLength, getVirtualScrollTarget, getVirtualScrollEl, virtualScrollItemSizeComputed }) {
	const { props, emit, proxy } = getCurrentInstance();
	const { $q } = proxy;
	let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
	const virtualScrollPaddingBefore = ref(0);
	const virtualScrollPaddingAfter = ref(0);
	const virtualScrollSliceSizeComputed = ref({});
	const beforeRef = ref(null);
	const afterRef = ref(null);
	const contentRef = ref(null);
	const virtualScrollSliceRange = ref({
		from: 0,
		to: 0
	});
	const colspanAttr = computed(() => props.tableColspan !== void 0 ? props.tableColspan : 100);
	if (virtualScrollItemSizeComputed === void 0) virtualScrollItemSizeComputed = computed(() => props.virtualScrollItemSize);
	const needsReset = computed(() => virtualScrollItemSizeComputed.value + ";" + props.virtualScrollHorizontal);
	watch(computed(() => needsReset.value + ";" + props.virtualScrollSliceRatioBefore + ";" + props.virtualScrollSliceRatioAfter), () => {
		setVirtualScrollSize();
	});
	watch(needsReset, reset);
	function reset() {
		localResetVirtualScroll(prevToIndex, true);
	}
	function refresh(toIndex) {
		localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
	}
	function scrollTo(toIndex, edge) {
		const scrollEl = getVirtualScrollTarget();
		if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
		const scrollDetails = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd);
		if (localScrollViewSize !== scrollDetails.scrollViewSize) setVirtualScrollSize(scrollDetails.scrollViewSize);
		setVirtualScrollSliceRange(scrollEl, scrollDetails, Math.min(virtualScrollLength.value - 1, Math.max(0, Number.parseInt(toIndex, 10) || 0)), 0, scrollToEdges.includes(edge) ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start");
	}
	function localOnVirtualScrollEvt() {
		const scrollEl = getVirtualScrollTarget();
		if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) return;
		const scrollDetails = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
		if (prevScrollStart === scrollDetails.scrollStart) return;
		if (scrollDetails.scrollMaxSize <= 0) {
			setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
			return;
		}
		if (localScrollViewSize !== scrollDetails.scrollViewSize) setVirtualScrollSize(scrollDetails.scrollViewSize);
		updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
		const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
		if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
			setVirtualScrollSliceRange(scrollEl, scrollDetails, listLastIndex, scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn, 0));
			return;
		}
		let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset = listOffset;
		if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
			listOffset -= virtualScrollPaddingBefore.value;
			toIndex = virtualScrollSliceRange.value.from;
			offset = listOffset;
		} else for (let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
			listOffset -= virtualScrollSizesAgg[j];
			toIndex += aggBucketSize;
		}
		while (listOffset > 0 && toIndex < listLastIndex) {
			listOffset -= virtualScrollSizes[toIndex];
			if (listOffset > -scrollDetails.scrollViewSize) {
				toIndex++;
				offset = listOffset;
			} else offset = virtualScrollSizes[toIndex] + listOffset;
		}
		setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset);
	}
	function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset, align) {
		const alignForce = typeof align === "string" && align.includes("-force");
		const alignEnd = alignForce ? align.replace("-force", "") : align;
		const alignRange = alignEnd !== void 0 ? alignEnd : "start";
		let from = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to = from + virtualScrollSliceSizeComputed.value.total;
		if (to > virtualScrollLength.value) {
			to = virtualScrollLength.value;
			from = Math.max(0, to - virtualScrollSliceSizeComputed.value.total);
		}
		prevScrollStart = scrollDetails.scrollStart;
		const rangeChanged = from !== virtualScrollSliceRange.value.from || to !== virtualScrollSliceRange.value.to;
		if (!rangeChanged && alignEnd === void 0) {
			emitScroll(toIndex);
			return;
		}
		const { activeElement } = document;
		const contentEl = contentRef.value;
		if (rangeChanged && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement)) {
			contentEl.addEventListener("focusout", onBlurRefocusFn);
			setTimeout(() => {
				contentEl?.removeEventListener("focusout", onBlurRefocusFn);
			}, 0);
		}
		setOverflowAnchor(contentEl, toIndex - from);
		const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;
		if (rangeChanged) {
			const tempTo = to >= virtualScrollSliceRange.value.from && from <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to;
			virtualScrollSliceRange.value = {
				from,
				to: tempTo
			};
			virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, from);
			virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
			requestAnimationFrame(() => {
				if (virtualScrollSliceRange.value.to !== to && prevScrollStart === scrollDetails.scrollStart) {
					virtualScrollSliceRange.value = {
						from: virtualScrollSliceRange.value.from,
						to
					};
					virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
				}
			});
		}
		requestAnimationFrame(() => {
			if (prevScrollStart !== scrollDetails.scrollStart) return;
			if (rangeChanged) updateVirtualScrollSizes(from);
			const sizeAfter = virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
			let scrollPosition = posStart + offset;
			if (alignEnd !== void 0) {
				const sizeDiff = sizeAfter - sizeBefore;
				const scrollStart = scrollDetails.scrollStart + sizeDiff;
				scrollPosition = !alignForce && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
			}
			prevScrollStart = scrollPosition;
			setScroll(scrollEl, scrollPosition, props.virtualScrollHorizontal, $q.lang.rtl);
			emitScroll(toIndex);
		});
	}
	function updateVirtualScrollSizes(from) {
		const contentEl = contentRef.value;
		if (contentEl) {
			const children = filterProto.call(contentEl.children, (el) => el.classList && !el.classList.contains("q-virtual-scroll--skip")), childrenLength = children.length, sizeFn = props.virtualScrollHorizontal ? (el) => el.getBoundingClientRect().width : (el) => el.offsetHeight;
			let index = from, size, diff;
			for (let i = 0; i < childrenLength;) {
				size = sizeFn(children[i]);
				i++;
				while (i < childrenLength && children[i].classList.contains("q-virtual-scroll--with-prev")) {
					size += sizeFn(children[i]);
					i++;
				}
				diff = size - virtualScrollSizes[index];
				if (diff !== 0) {
					virtualScrollSizes[index] += diff;
					virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
				}
				index++;
			}
		}
	}
	function onBlurRefocusFn() {
		contentRef.value?.focus({ preventScroll: true });
	}
	function localResetVirtualScroll(toIndex, fullReset) {
		const defaultSize = Number(virtualScrollItemSizeComputed.value);
		if (fullReset || !Array.isArray(virtualScrollSizes)) virtualScrollSizes = [];
		const oldVirtualScrollSizesLength = virtualScrollSizes.length;
		virtualScrollSizes.length = virtualScrollLength.value;
		for (let i = virtualScrollLength.value - 1; i >= oldVirtualScrollSizesLength; i--) virtualScrollSizes[i] = defaultSize;
		const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize);
		virtualScrollSizesAgg = [];
		for (let j = 0; j <= jMax; j++) {
			let size = 0;
			const iMax = Math.min((j + 1) * aggBucketSize, virtualScrollLength.value);
			for (let i = j * aggBucketSize; i < iMax; i++) size += virtualScrollSizes[i];
			virtualScrollSizesAgg.push(size);
		}
		prevToIndex = -1;
		prevScrollStart = void 0;
		virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
		virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
		if (toIndex >= 0) {
			updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
			nextTick(() => {
				scrollTo(toIndex);
			});
		} else onVirtualScrollEvt();
	}
	function setVirtualScrollSize(scrollViewSize) {
		if (scrollViewSize === void 0 && typeof window !== "undefined") {
			const scrollEl = getVirtualScrollTarget();
			if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) scrollViewSize = getScrollDetails(scrollEl, getVirtualScrollEl(), beforeRef.value, afterRef.value, props.virtualScrollHorizontal, $q.lang.rtl, props.virtualScrollStickySizeStart, props.virtualScrollStickySizeEnd).scrollViewSize;
		}
		localScrollViewSize = scrollViewSize;
		const virtualScrollSliceRatioBefore = Number.parseFloat(props.virtualScrollSliceRatioBefore) || 0;
		const virtualScrollSliceRatioAfter = Number.parseFloat(props.virtualScrollSliceRatioAfter) || 0;
		const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
		const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
		const baseSize = Math.max(1, view, Math.ceil((props.virtualScrollSliceSize > 0 ? props.virtualScrollSliceSize : 10) / multiplier));
		virtualScrollSliceSizeComputed.value = {
			total: Math.ceil(baseSize * multiplier),
			start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
			center: Math.ceil(baseSize * (.5 + virtualScrollSliceRatioBefore)),
			end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
			view
		};
	}
	function padVirtualScroll(tag, content) {
		const paddingSize = props.virtualScrollHorizontal ? "width" : "height";
		const style = { ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px" };
		return [
			tag === "tbody" ? h(tag, {
				class: "q-virtual-scroll__padding",
				key: "before",
				ref: beforeRef
			}, [h("tr", [h("td", {
				style: {
					[paddingSize]: `${virtualScrollPaddingBefore.value}px`,
					...style
				},
				colspan: colspanAttr.value
			})])]) : h(tag, {
				class: "q-virtual-scroll__padding",
				key: "before",
				ref: beforeRef,
				style: {
					[paddingSize]: `${virtualScrollPaddingBefore.value}px`,
					...style
				}
			}),
			h(tag, {
				class: "q-virtual-scroll__content",
				key: "content",
				ref: contentRef,
				tabindex: -1
			}, content.flat()),
			tag === "tbody" ? h(tag, {
				class: "q-virtual-scroll__padding",
				key: "after",
				ref: afterRef
			}, [h("tr", [h("td", {
				style: {
					[paddingSize]: `${virtualScrollPaddingAfter.value}px`,
					...style
				},
				colspan: colspanAttr.value
			})])]) : h(tag, {
				class: "q-virtual-scroll__padding",
				key: "after",
				ref: afterRef,
				style: {
					[paddingSize]: `${virtualScrollPaddingAfter.value}px`,
					...style
				}
			})
		];
	}
	function emitScroll(index) {
		if (prevToIndex !== index) {
			if (props.onVirtualScroll !== void 0) emit("virtualScroll", {
				index,
				from: virtualScrollSliceRange.value.from,
				to: virtualScrollSliceRange.value.to - 1,
				direction: index < prevToIndex ? "decrease" : "increase",
				ref: proxy
			});
			prevToIndex = index;
		}
	}
	setVirtualScrollSize();
	const onVirtualScrollEvt = debounce(localOnVirtualScrollEvt, $q.platform.is.ios ? 120 : 35);
	onBeforeMount(() => {
		setVirtualScrollSize();
	});
	let shouldActivate = false;
	onDeactivated(() => {
		shouldActivate = true;
	});
	onActivated(() => {
		if (!shouldActivate) return;
		const scrollEl = getVirtualScrollTarget();
		if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) setScroll(scrollEl, prevScrollStart, props.virtualScrollHorizontal, $q.lang.rtl);
		else scrollTo(prevToIndex);
	});
	if (!__QUASAR_SSR__) onBeforeUnmount(() => {
		onVirtualScrollEvt.cancel();
	});
	Object.assign(proxy, {
		scrollTo,
		reset,
		refresh
	});
	return {
		virtualScrollSliceRange,
		virtualScrollSliceSizeComputed,
		setVirtualScrollSize,
		onVirtualScrollEvt,
		localResetVirtualScroll,
		padVirtualScroll,
		scrollTo,
		reset,
		refresh
	};
}
var validateNewValueMode = (v) => [
	"add",
	"add-unique",
	"toggle"
].includes(v);
var reEscapeList = ".*+?^${}()|[]\\";
var fieldPropsList = Object.keys(useFieldProps);
function getPropValueFn(userPropName, defaultPropName) {
	if (typeof userPropName === "function") return userPropName;
	const propName = userPropName !== void 0 ? userPropName : defaultPropName;
	return (opt) => opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
var QSelect_default = /*#__PURE__*/ createComponent({
	name: "QSelect",
	inheritAttrs: false,
	props: {
		...useVirtualScrollProps,
		...useFormProps,
		...useFieldProps,
		modelValue: { required: true },
		multiple: Boolean,
		displayValue: [String, Number],
		displayValueHtml: Boolean,
		dropdownIcon: String,
		options: {
			type: Array,
			default: () => []
		},
		optionValue: [Function, String],
		optionLabel: [Function, String],
		optionDisable: [Function, String],
		hideSelected: Boolean,
		hideDropdownIcon: Boolean,
		fillInput: Boolean,
		maxValues: [Number, String],
		optionsDense: Boolean,
		optionsDark: {
			type: Boolean,
			default: null
		},
		optionsSelectedClass: String,
		optionsHtml: Boolean,
		optionsCover: Boolean,
		menuShrink: Boolean,
		menuAnchor: String,
		menuSelf: String,
		menuOffset: Array,
		popupContentClass: String,
		popupContentStyle: [
			String,
			Array,
			Object
		],
		popupNoRouteDismiss: Boolean,
		useInput: Boolean,
		useChips: Boolean,
		newValueMode: {
			type: String,
			validator: validateNewValueMode
		},
		mapOptions: Boolean,
		emitValue: Boolean,
		disableTabSelection: Boolean,
		inputDebounce: {
			type: [Number, String],
			default: 500
		},
		inputClass: [
			Array,
			String,
			Object
		],
		inputStyle: [
			Array,
			String,
			Object
		],
		tabindex: {
			type: [String, Number],
			default: 0
		},
		autocomplete: String,
		transitionShow: {},
		transitionHide: {},
		transitionDuration: {},
		behavior: {
			type: String,
			validator: (v) => [
				"default",
				"menu",
				"dialog"
			].includes(v),
			default: "default"
		},
		virtualScrollItemSize: useVirtualScrollProps.virtualScrollItemSize.type,
		onNewValue: Function,
		onFilter: Function
	},
	emits: [
		...useFieldEmits,
		"add",
		"remove",
		"inputValue",
		"keyup",
		"keypress",
		"keydown",
		"popupShow",
		"popupHide",
		"filterAbort"
	],
	setup(props, { slots, emit }) {
		const { proxy } = getCurrentInstance();
		const { $q } = proxy;
		const menu = ref(false);
		const dialog = ref(false);
		const optionIndex = ref(-1);
		const inputValue = ref("");
		const dialogFieldFocused = ref(false);
		const innerLoadingIndicator = ref(false);
		let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
		const inputRef = ref(null);
		const targetRef = ref(null);
		const menuRef = ref(null);
		const dialogRef = ref(null);
		const menuContentRef = ref(null);
		const nameProp = useFormInputNameAttr(props);
		const onComposition = useKeyComposition(onInput);
		const virtualScrollLength = computed(() => Array.isArray(props.options) ? props.options.length : 0);
		const { virtualScrollSliceRange, virtualScrollSliceSizeComputed, localResetVirtualScroll, padVirtualScroll, onVirtualScrollEvt, scrollTo, setVirtualScrollSize } = useVirtualScroll({
			virtualScrollLength,
			getVirtualScrollTarget,
			getVirtualScrollEl,
			virtualScrollItemSizeComputed: computed(() => props.virtualScrollItemSize === void 0 ? props.optionsDense ? 24 : 48 : props.virtualScrollItemSize)
		});
		const state = useFieldState();
		const innerValue = computed(() => {
			const mapNull = props.mapOptions && !props.multiple, val = props.modelValue !== void 0 && (props.modelValue !== null || mapNull) ? props.multiple && Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue] : [];
			if (props.mapOptions && Array.isArray(props.options)) {
				const cache = props.mapOptions && innerValueCache !== void 0 ? innerValueCache : [];
				const values = val.map((v) => getOption(v, cache));
				return props.modelValue === null && mapNull ? values.filter((v) => v !== null) : values;
			}
			return val;
		});
		const innerFieldProps = computed(() => {
			const acc = {};
			fieldPropsList.forEach((key) => {
				const val = props[key];
				if (val !== void 0) acc[key] = val;
			});
			return acc;
		});
		const isOptionsDark = computed(() => props.optionsDark === null ? state.isDark.value : props.optionsDark);
		const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
		const computedInputClass = computed(() => {
			let cls = "q-field__input q-placeholder col";
			if (props.hideSelected || innerValue.value.length === 0) return [cls, props.inputClass];
			cls += " q-field__input--padding";
			return props.inputClass === void 0 ? cls : [cls, props.inputClass];
		});
		const menuContentClass = computed(() => (props.virtualScrollHorizontal ? "q-virtual-scroll--horizontal" : "") + (props.popupContentClass ? " " + props.popupContentClass : ""));
		const noOptions = computed(() => virtualScrollLength.value === 0);
		const selectedString = computed(() => innerValue.value.map((opt) => getOptionLabel.value(opt)).join(", "));
		const ariaCurrentValue = computed(() => props.displayValue !== void 0 ? props.displayValue : selectedString.value);
		const needsHtmlFn = computed(() => props.optionsHtml ? () => true : (opt) => opt?.html === true);
		const valueAsHtml = computed(() => props.displayValueHtml || props.displayValue === void 0 && (props.optionsHtml || innerValue.value.some(needsHtmlFn.value)));
		const tabindex = computed(() => state.focused.value ? props.tabindex : -1);
		const comboboxAttrs = computed(() => {
			const attrs = {
				tabindex: props.tabindex,
				role: "combobox",
				"aria-label": props.label,
				"aria-readonly": props.readonly ? "true" : "false",
				"aria-autocomplete": props.useInput ? "list" : "none",
				"aria-expanded": menu.value ? "true" : "false",
				"aria-controls": `${state.targetUid.value}_lb`
			};
			if (optionIndex.value >= 0) attrs["aria-activedescendant"] = `${state.targetUid.value}_${optionIndex.value}`;
			return attrs;
		});
		const listboxAttrs = computed(() => ({
			id: `${state.targetUid.value}_lb`,
			role: "listbox",
			"aria-multiselectable": props.multiple ? "true" : "false"
		}));
		const selectedScope = computed(() => innerValue.value.map((opt, i) => ({
			index: i,
			opt,
			html: needsHtmlFn.value(opt),
			selected: true,
			removeAtIndex: removeAtIndexAndFocus,
			toggleOption,
			tabindex: tabindex.value
		})));
		const optionScope = computed(() => {
			if (virtualScrollLength.value === 0) return [];
			const { from, to } = virtualScrollSliceRange.value;
			return props.options.slice(from, to).map((opt, i) => {
				const disable = isOptionDisabled.value(opt) === true;
				const active = isOptionSelected(opt);
				const index = from + i;
				const itemProps = {
					clickable: true,
					active,
					activeClass: computedOptionsSelectedClass.value,
					manualFocus: true,
					focused: false,
					disable,
					tabindex: -1,
					dense: props.optionsDense,
					dark: isOptionsDark.value,
					role: "option",
					"aria-selected": active ? "true" : "false",
					id: `${state.targetUid.value}_${index}`,
					onClick: () => {
						toggleOption(opt);
					}
				};
				if (!disable) {
					if (optionIndex.value === index) itemProps.focused = true;
					if ($q.platform.is.desktop) itemProps.onMousemove = () => {
						if (menu.value) setOptionIndex(index);
					};
				}
				return {
					index,
					opt,
					html: needsHtmlFn.value(opt),
					label: getOptionLabel.value(opt),
					selected: itemProps.active,
					focused: itemProps.focused,
					toggleOption,
					setOptionIndex,
					itemProps
				};
			});
		});
		const dropdownArrowIcon = computed(() => props.dropdownIcon !== void 0 ? props.dropdownIcon : $q.iconSet.arrow.dropdown);
		const squaredMenu = computed(() => !props.optionsCover && !props.outlined && !props.standout && !props.borderless && !props.rounded);
		const computedOptionsSelectedClass = computed(() => props.optionsSelectedClass !== void 0 ? props.optionsSelectedClass : props.color !== void 0 ? `text-${props.color}` : "");
		const getOptionValue = computed(() => getPropValueFn(props.optionValue, "value"));
		const getOptionLabel = computed(() => getPropValueFn(props.optionLabel, "label"));
		const isOptionDisabled = computed(() => getPropValueFn(props.optionDisable, "disable"));
		const innerOptionsValue = computed(() => innerValue.value.map(getOptionValue.value));
		const inputControlEvents = computed(() => {
			const evt = {
				onInput,
				onChange: onComposition,
				onKeydown: onTargetKeydown,
				onKeyup: onTargetAutocomplete,
				onKeypress: onTargetKeypress,
				onFocus: selectInputText,
				onClick(e) {
					if (hasDialog) stop(e);
				}
			};
			evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
			return evt;
		});
		watch(innerValue, (val) => {
			innerValueCache = val;
			if (props.useInput && props.fillInput && !props.multiple && !state.innerLoading.value && (!dialog.value && !menu.value || !hasValue.value)) {
				if (!userInputValue) resetInputValue();
				if (dialog.value || menu.value) filter("");
			}
		}, { immediate: true });
		watch(() => props.fillInput, resetInputValue);
		watch(menu, updateMenu);
		watch(virtualScrollLength, rerenderMenu);
		function getEmittingOptionValue(opt) {
			return props.emitValue ? getOptionValue.value(opt) : opt;
		}
		function removeAtIndex(index) {
			if (index !== -1 && index < innerValue.value.length) if (props.multiple) {
				const model = [...props.modelValue];
				emit("remove", {
					index,
					value: model.splice(index, 1)[0]
				});
				emit("update:modelValue", model);
			} else emit("update:modelValue", null);
		}
		function removeAtIndexAndFocus(index) {
			removeAtIndex(index);
			state.focus();
		}
		function add(opt, unique) {
			const val = getEmittingOptionValue(opt);
			if (!props.multiple) {
				if (props.fillInput) updateInputValue(getOptionLabel.value(opt), true, true);
				emit("update:modelValue", val);
				return;
			}
			if (innerValue.value.length === 0) {
				emit("add", {
					index: 0,
					value: val
				});
				emit("update:modelValue", props.multiple ? [val] : val);
				return;
			}
			if (unique && isOptionSelected(opt)) return;
			if (props.maxValues !== void 0 && props.modelValue.length >= props.maxValues) return;
			const model = [...props.modelValue];
			emit("add", {
				index: model.length,
				value: val
			});
			model.push(val);
			emit("update:modelValue", model);
		}
		function toggleOption(opt, keepOpen) {
			if (!state.editable.value || opt === void 0 || isOptionDisabled.value(opt) === true) return;
			const optValue = getOptionValue.value(opt);
			if (!props.multiple) {
				if (!keepOpen) {
					updateInputValue(props.fillInput ? getOptionLabel.value(opt) : "", true, true);
					hidePopup();
				}
				targetRef.value?.focus();
				if (innerValue.value.length === 0 || !isDeepEqual(getOptionValue.value(innerValue.value[0]), optValue)) emit("update:modelValue", props.emitValue ? optValue : opt);
				return;
			}
			if (!hasDialog || dialogFieldFocused.value) state.focus();
			selectInputText();
			if (innerValue.value.length === 0) {
				const val = props.emitValue ? optValue : opt;
				emit("add", {
					index: 0,
					value: val
				});
				emit("update:modelValue", props.multiple ? [val] : val);
				return;
			}
			const model = [...props.modelValue], index = innerOptionsValue.value.findIndex((v) => isDeepEqual(v, optValue));
			if (index !== -1) emit("remove", {
				index,
				value: model.splice(index, 1)[0]
			});
			else {
				if (props.maxValues !== void 0 && model.length >= props.maxValues) return;
				const val = props.emitValue ? optValue : opt;
				emit("add", {
					index: model.length,
					value: val
				});
				model.push(val);
			}
			emit("update:modelValue", model);
		}
		function setOptionIndex(index) {
			if (!$q.platform.is.desktop) return;
			const val = index !== -1 && index < virtualScrollLength.value ? index : -1;
			if (optionIndex.value !== val) optionIndex.value = val;
		}
		function moveOptionSelection(localOffset = 1, skipInputValue) {
			if (menu.value) {
				let index = optionIndex.value;
				do
					index = normalizeToInterval(index + localOffset, -1, virtualScrollLength.value - 1);
				while (index !== -1 && index !== optionIndex.value && isOptionDisabled.value(props.options[index]) === true);
				if (optionIndex.value !== index) {
					setOptionIndex(index);
					scrollTo(index);
					if (!skipInputValue && props.useInput && props.fillInput) setInputValue(index >= 0 ? getOptionLabel.value(props.options[index]) : defaultInputValue, true);
				}
			}
		}
		function getOption(value, valueCache) {
			const fn = (opt) => isDeepEqual(getOptionValue.value(opt), value);
			return props.options.find(fn) || valueCache.find(fn) || value;
		}
		function isOptionSelected(opt) {
			const val = getOptionValue.value(opt);
			return innerOptionsValue.value.find((v) => isDeepEqual(v, val)) !== void 0;
		}
		function selectInputText(e) {
			if (props.useInput && targetRef.value !== null && (e === void 0 || targetRef.value === e.target && e.target.value === selectedString.value)) targetRef.value.select();
		}
		function onTargetKeyup(e) {
			if (isKeyCode(e, 27) && menu.value) {
				stop(e);
				hidePopup();
				resetInputValue();
			}
			emit("keyup", e);
		}
		function onTargetAutocomplete(e) {
			const { value } = e.target;
			if (e.keyCode !== void 0) {
				onTargetKeyup(e);
				return;
			}
			e.target.value = "";
			if (filterTimer !== null) {
				clearTimeout(filterTimer);
				filterTimer = null;
			}
			if (inputValueTimer !== null) {
				clearTimeout(inputValueTimer);
				inputValueTimer = null;
			}
			resetInputValue();
			if (typeof value === "string" && value.length !== 0) {
				const needle = value.toLocaleLowerCase();
				const findFn = (extractFn) => {
					const option = props.options.find((opt) => String(extractFn.value(opt)).toLocaleLowerCase() === needle);
					if (option === void 0) return false;
					if (innerValue.value.includes(option)) hidePopup();
					else toggleOption(option);
					return true;
				};
				const fillFn = (afterFilter) => {
					if (!findFn(getOptionValue) && !afterFilter && !findFn(getOptionLabel)) filter(value, true, () => fillFn(true));
				};
				fillFn();
			} else state.clearValue(e);
		}
		function onTargetKeypress(e) {
			emit("keypress", e);
		}
		function onTargetKeydown(e) {
			emit("keydown", e);
			if (shouldIgnoreKey(e)) return;
			const newValueModeValid = inputValue.value.length !== 0 && (props.newValueMode !== void 0 || props.onNewValue !== void 0);
			const tabShouldSelect = !e.shiftKey && !props.disableTabSelection && !props.multiple && (optionIndex.value !== -1 || newValueModeValid);
			if (e.keyCode === 27) {
				prevent(e);
				return;
			}
			if (e.keyCode === 9 && !tabShouldSelect) {
				closeMenu();
				return;
			}
			if (e.target === void 0 || e.target.id !== state.targetUid.value || !state.editable.value) return;
			if (e.keyCode === 40 && !state.innerLoading.value && !menu.value) {
				stopAndPrevent(e);
				showPopup();
				return;
			}
			if (e.keyCode === 8 && (props.useChips || props.clearable) && !props.hideSelected && inputValue.value.length === 0) {
				if (props.multiple && Array.isArray(props.modelValue)) removeAtIndex(props.modelValue.length - 1);
				else if (!props.multiple && props.modelValue !== null) emit("update:modelValue", null);
				return;
			}
			if ((e.keyCode === 35 || e.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
				stopAndPrevent(e);
				optionIndex.value = -1;
				moveOptionSelection(e.keyCode === 36 ? 1 : -1, props.multiple);
			}
			if ((e.keyCode === 33 || e.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
				stopAndPrevent(e);
				optionIndex.value = Math.max(-1, Math.min(virtualScrollLength.value, optionIndex.value + (e.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view));
				moveOptionSelection(e.keyCode === 33 ? 1 : -1, props.multiple);
			}
			if (e.keyCode === 38 || e.keyCode === 40) {
				stopAndPrevent(e);
				moveOptionSelection(e.keyCode === 38 ? -1 : 1, props.multiple);
			}
			const optionsLength = virtualScrollLength.value;
			if (searchBuffer === void 0 || searchBufferExp < Date.now()) searchBuffer = "";
			if (optionsLength > 0 && !props.useInput && e.key !== void 0 && e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey && (e.keyCode !== 32 || searchBuffer.length !== 0)) {
				if (!menu.value) showPopup(e);
				const char = e.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
				searchBufferExp = Date.now() + 1500;
				if (!keyRepeat) {
					stopAndPrevent(e);
					searchBuffer += char;
				}
				const searchRe = new RegExp("^" + [...searchBuffer].map((l) => reEscapeList.includes(l) ? "\\" + l : l).join(".*"), "i");
				let index = optionIndex.value;
				if (keyRepeat || index < 0 || !searchRe.test(getOptionLabel.value(props.options[index]))) do
					index = normalizeToInterval(index + 1, -1, optionsLength - 1);
				while (index !== optionIndex.value && (isOptionDisabled.value(props.options[index]) === true || !searchRe.test(getOptionLabel.value(props.options[index]))));
				if (optionIndex.value !== index) nextTick(() => {
					setOptionIndex(index);
					scrollTo(index);
					if (index >= 0 && props.useInput && props.fillInput) setInputValue(getOptionLabel.value(props.options[index]), true);
				});
				return;
			}
			if (e.keyCode !== 13 && (e.keyCode !== 32 || props.useInput || searchBuffer !== "") && (e.keyCode !== 9 || !tabShouldSelect)) return;
			if (e.keyCode !== 9) stopAndPrevent(e);
			if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
				toggleOption(props.options[optionIndex.value]);
				return;
			}
			if (newValueModeValid) {
				const done = (val, mode) => {
					if (mode) {
						if (!validateNewValueMode(mode)) return;
					} else mode = props.newValueMode;
					updateInputValue("", !props.multiple, true);
					if (val === void 0 || val === null) return;
					(mode === "toggle" ? toggleOption : add)(val, mode === "add-unique");
					if (!props.multiple) {
						targetRef.value?.focus();
						hidePopup();
					}
				};
				if (props.onNewValue !== void 0) emit("newValue", inputValue.value, done);
				else done(inputValue.value);
				if (!props.multiple) return;
			}
			if (menu.value) closeMenu();
			else if (!state.innerLoading.value) showPopup();
		}
		function getVirtualScrollEl() {
			return hasDialog ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
		}
		function getVirtualScrollTarget() {
			return getVirtualScrollEl();
		}
		function getSelection() {
			if (props.hideSelected) return [];
			if (slots["selected-item"] !== void 0) return selectedScope.value.map((scope) => slots["selected-item"](scope));
			if (slots.selected !== void 0) return [slots.selected()].flat();
			if (props.useChips) return selectedScope.value.map((scope, i) => h(QChip_default, {
				key: "option-" + i,
				removable: state.editable.value && isOptionDisabled.value(scope.opt) !== true,
				dense: true,
				textColor: props.color,
				tabindex: tabindex.value,
				onRemove() {
					scope.removeAtIndex(i);
				}
			}, () => h("span", {
				class: "ellipsis",
				[scope.html ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
			})));
			return [h("span", {
				class: "ellipsis",
				[valueAsHtml.value ? "innerHTML" : "textContent"]: ariaCurrentValue.value
			})];
		}
		function getAllOptions() {
			if (noOptions.value) return slots["no-option"] !== void 0 ? slots["no-option"]({ inputValue: inputValue.value }) : void 0;
			const fn = slots.option !== void 0 ? slots.option : (scope) => h(QItem_default, {
				key: scope.index,
				...scope.itemProps
			}, () => h(QItemSection_default, () => h(QItemLabel_default, () => h("span", { [scope.html ? "innerHTML" : "textContent"]: scope.label }))));
			let options = padVirtualScroll("div", optionScope.value.map(fn));
			if (slots["before-options"] !== void 0) options = [slots["before-options"](), ...options].flat();
			return hMergeSlot(slots["after-options"], options);
		}
		function getInput(fromDialog, isTarget) {
			const attrs = isTarget ? {
				...comboboxAttrs.value,
				...state.splitAttrs.attributes.value
			} : void 0;
			const data = {
				ref: isTarget ? targetRef : void 0,
				key: "i_t",
				class: computedInputClass.value,
				style: props.inputStyle,
				value: inputValue.value !== void 0 ? inputValue.value : "",
				type: "search",
				...attrs,
				id: isTarget ? state.targetUid.value : void 0,
				maxlength: props.maxlength,
				autocomplete: props.autocomplete,
				"data-autofocus": fromDialog === true || props.autofocus || void 0,
				disabled: props.disable,
				readonly: props.readonly,
				...inputControlEvents.value
			};
			if (!fromDialog && hasDialog) if (Array.isArray(data.class)) data.class = [...data.class, "no-pointer-events"];
			else data.class += " no-pointer-events";
			return h("input", data);
		}
		function onInput(e) {
			if (filterTimer !== null) {
				clearTimeout(filterTimer);
				filterTimer = null;
			}
			if (inputValueTimer !== null) {
				clearTimeout(inputValueTimer);
				inputValueTimer = null;
			}
			if (e?.target?.qComposing) return;
			setInputValue(e.target.value || "");
			userInputValue = true;
			defaultInputValue = inputValue.value;
			if (!state.focused.value && (!hasDialog || dialogFieldFocused.value)) state.focus();
			if (props.onFilter !== void 0) filterTimer = setTimeout(() => {
				filterTimer = null;
				filter(inputValue.value);
			}, props.inputDebounce);
		}
		function setInputValue(val, emitImmediately) {
			if (inputValue.value !== val) {
				if (inputValueTimer !== null) {
					clearTimeout(inputValueTimer);
					inputValueTimer = null;
				}
				inputValue.value = val;
				if (emitImmediately || props.inputDebounce === 0 || props.inputDebounce === "0") emit("inputValue", val);
				else inputValueTimer = setTimeout(() => {
					inputValueTimer = null;
					emit("inputValue", val);
				}, props.inputDebounce);
			}
		}
		function updateInputValue(val, noFiltering, internal) {
			userInputValue = internal !== true;
			if (props.useInput) {
				setInputValue(val, true);
				if (noFiltering || userInputValue) defaultInputValue = val;
				if (!noFiltering) filter(val);
			}
		}
		function filter(val, keepClosed, afterUpdateFn) {
			if (props.onFilter === void 0 || !keepClosed && !state.focused.value) return;
			if (state.innerLoading.value) emit("filterAbort");
			else {
				state.innerLoading.value = true;
				innerLoadingIndicator.value = true;
			}
			if (val !== "" && !props.multiple && innerValue.value.length !== 0 && !userInputValue && val === getOptionLabel.value(innerValue.value[0])) val = "";
			const localFilterId = setTimeout(() => {
				if (menu.value) menu.value = false;
			}, 10);
			if (filterId !== null) clearTimeout(filterId);
			filterId = localFilterId;
			emit("filter", val, (fn, afterFn) => {
				if ((keepClosed || state.focused.value) && filterId === localFilterId) {
					clearTimeout(filterId);
					if (typeof fn === "function") fn();
					innerLoadingIndicator.value = false;
					nextTick(() => {
						state.innerLoading.value = false;
						if (state.editable.value) if (keepClosed) {
							if (menu.value) hidePopup();
						} else if (menu.value) updateMenu(true);
						else menu.value = true;
						if (typeof afterFn === "function") nextTick(() => {
							afterFn(proxy);
						});
						if (typeof afterUpdateFn === "function") nextTick(() => {
							afterUpdateFn(proxy);
						});
					});
				}
			}, () => {
				if (state.focused.value && filterId === localFilterId) {
					clearTimeout(filterId);
					state.innerLoading.value = false;
					innerLoadingIndicator.value = false;
				}
				if (menu.value) menu.value = false;
			});
		}
		function getMenu() {
			return h(QMenu_default, {
				ref: menuRef,
				class: menuContentClass.value,
				style: props.popupContentStyle,
				modelValue: menu.value,
				fit: !props.menuShrink,
				cover: props.optionsCover && !noOptions.value && !props.useInput,
				anchor: props.menuAnchor,
				self: props.menuSelf,
				offset: props.menuOffset,
				dark: isOptionsDark.value,
				noParentEvent: true,
				noRefocus: true,
				noFocus: true,
				noRouteDismiss: props.popupNoRouteDismiss,
				square: squaredMenu.value,
				transitionShow: props.transitionShow,
				transitionHide: props.transitionHide,
				transitionDuration: props.transitionDuration,
				separateClosePopup: true,
				...listboxAttrs.value,
				onScrollPassive: onVirtualScrollEvt,
				onBeforeShow: onControlPopupShow,
				onBeforeHide: onMenuBeforeHide,
				onShow: onMenuShow
			}, getAllOptions);
		}
		function onMenuBeforeHide(e) {
			onControlPopupHide(e);
			closeMenu();
		}
		function onMenuShow() {
			setVirtualScrollSize();
		}
		function onDialogFieldFocus(e) {
			stop(e);
			targetRef.value?.focus();
			dialogFieldFocused.value = true;
			window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
		}
		function onDialogFieldBlur(e) {
			stop(e);
			nextTick(() => {
				dialogFieldFocused.value = false;
			});
		}
		function getDialog() {
			const content = [h(QField_default, {
				class: `col-auto ${state.fieldClass.value}`,
				...innerFieldProps.value,
				for: state.targetUid.value,
				dark: isOptionsDark.value,
				square: true,
				loading: innerLoadingIndicator.value,
				itemAligned: false,
				filled: true,
				stackLabel: inputValue.value.length !== 0,
				...state.splitAttrs.listeners.value,
				onFocus: onDialogFieldFocus,
				onBlur: onDialogFieldBlur
			}, {
				...slots,
				rawControl: () => state.getControl(true),
				before: void 0,
				after: void 0
			})];
			if (menu.value) content.push(h("div", {
				ref: menuContentRef,
				class: menuContentClass.value + " scroll",
				style: props.popupContentStyle,
				...listboxAttrs.value,
				onClick: prevent,
				onScrollPassive: onVirtualScrollEvt
			}, getAllOptions()));
			return h(QDialog_default, {
				ref: dialogRef,
				modelValue: dialog.value,
				position: props.useInput ? "top" : void 0,
				transitionShow: transitionShowComputed,
				transitionHide: props.transitionHide,
				transitionDuration: props.transitionDuration,
				noRouteDismiss: props.popupNoRouteDismiss,
				onBeforeShow: onControlPopupShow,
				onBeforeHide: onDialogBeforeHide,
				onHide: onDialogHide,
				onShow: onDialogShow
			}, () => h("div", { class: "q-select__dialog" + (isOptionsDark.value ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value ? " q-select__dialog--focused" : "") }, content));
		}
		function onDialogBeforeHide(e) {
			onControlPopupHide(e);
			if (dialogRef.value !== null) dialogRef.value.__updateRefocusTarget(state.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child"));
			state.focused.value = false;
		}
		function onDialogHide(e) {
			hidePopup();
			if (!state.focused.value) emit("blur", e);
			resetInputValue();
		}
		function onDialogShow() {
			const el = document.activeElement;
			if ((el === null || el.id !== state.targetUid.value) && targetRef.value !== null && targetRef.value !== el) targetRef.value.focus();
			setVirtualScrollSize();
		}
		function closeMenu() {
			if (dialog.value) return;
			optionIndex.value = -1;
			if (menu.value) menu.value = false;
			if (!state.focused.value) {
				if (filterId !== null) {
					clearTimeout(filterId);
					filterId = null;
				}
				if (state.innerLoading.value) {
					emit("filterAbort");
					state.innerLoading.value = false;
					innerLoadingIndicator.value = false;
				}
			}
		}
		function showPopup(e) {
			if (!state.editable.value) return;
			if (hasDialog) {
				state.onControlFocusin(e);
				dialog.value = true;
				nextTick(() => {
					state.focus();
				});
			} else state.focus();
			if (props.onFilter !== void 0) filter(inputValue.value);
			else if (!noOptions.value || slots["no-option"] !== void 0) menu.value = true;
		}
		function hidePopup() {
			dialog.value = false;
			closeMenu();
		}
		function resetInputValue() {
			if (props.useInput) updateInputValue(!props.multiple && props.fillInput && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "", true, true);
		}
		function updateMenu(show) {
			let localOptionIndex = -1;
			if (show) {
				if (innerValue.value.length !== 0) {
					const val = getOptionValue.value(innerValue.value[0]);
					localOptionIndex = props.options.findIndex((v) => isDeepEqual(getOptionValue.value(v), val));
				}
				localResetVirtualScroll(localOptionIndex);
			}
			setOptionIndex(localOptionIndex);
		}
		function rerenderMenu(newLength, oldLength) {
			if (menu.value && !state.innerLoading.value) {
				localResetVirtualScroll(-1, true);
				nextTick(() => {
					if (menu.value && !state.innerLoading.value) if (newLength > oldLength) localResetVirtualScroll();
					else updateMenu(true);
				});
			}
		}
		function updateMenuPosition() {
			if (!dialog.value) menuRef.value?.updatePosition();
		}
		function onControlPopupShow(e) {
			if (e !== void 0) stop(e);
			emit("popupShow", e);
			state.hasPopupOpen = true;
			state.onControlFocusin(e);
		}
		function onControlPopupHide(e) {
			if (e !== void 0) stop(e);
			emit("popupHide", e);
			state.hasPopupOpen = false;
			state.onControlFocusout(e);
		}
		function updatePreState() {
			hasDialog = !$q.platform.is.mobile && props.behavior !== "dialog" ? false : props.behavior !== "menu" && (props.useInput ? slots["no-option"] !== void 0 || props.onFilter !== void 0 || !noOptions.value : true);
			transitionShowComputed = $q.platform.is.ios && hasDialog && props.useInput ? "fade" : props.transitionShow;
		}
		onBeforeUpdate(updatePreState);
		onUpdated(updateMenuPosition);
		updatePreState();
		onBeforeUnmount(() => {
			if (filterTimer !== null) clearTimeout(filterTimer);
			if (inputValueTimer !== null) clearTimeout(inputValueTimer);
		});
		Object.assign(proxy, {
			showPopup,
			hidePopup,
			removeAtIndex,
			add,
			toggleOption,
			getOptionIndex: () => optionIndex.value,
			setOptionIndex,
			moveOptionSelection,
			filter,
			updateMenuPosition,
			updateInputValue,
			isOptionSelected,
			getEmittingOptionValue,
			isOptionDisabled: (...args) => isOptionDisabled.value(...args) === true,
			getOptionValue: (...args) => getOptionValue.value(...args),
			getOptionLabel: (...args) => getOptionLabel.value(...args)
		});
		Object.assign(state, {
			innerValue,
			fieldClass: computed(() => `q-select q-field--auto-height q-select--with${props.useInput ? "" : "out"}-input q-select--with${props.useChips ? "" : "out"}-chips q-select--${props.multiple ? "multiple" : "single"}`),
			inputRef,
			targetRef,
			hasValue,
			showPopup,
			floatingLabel: computed(() => !props.hideSelected && hasValue.value || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled(props.displayValue)),
			getControlChild: () => {
				if (state.editable.value && (dialog.value || !noOptions.value || slots["no-option"] !== void 0)) return hasDialog ? getDialog() : getMenu();
				else if (state.hasPopupOpen) state.hasPopupOpen = false;
			},
			controlEvents: {
				onFocusin(e) {
					state.onControlFocusin(e);
				},
				onFocusout(e) {
					state.onControlFocusout(e, () => {
						resetInputValue();
						closeMenu();
					});
				},
				onClick(e) {
					prevent(e);
					if (!hasDialog && menu.value) {
						closeMenu();
						targetRef.value?.focus();
						return;
					}
					showPopup(e);
				}
			},
			getControl: (fromDialog) => {
				const child = getSelection();
				const isTarget = fromDialog === true || !dialog.value || !hasDialog;
				if (props.useInput) child.push(getInput(fromDialog, isTarget));
				else if (state.editable.value) {
					const attrs = isTarget ? comboboxAttrs.value : void 0;
					child.push(h("input", {
						ref: isTarget ? targetRef : void 0,
						key: "d_t",
						class: "q-select__focus-target",
						id: isTarget ? state.targetUid.value : void 0,
						value: ariaCurrentValue.value,
						readonly: true,
						"data-autofocus": fromDialog === true || props.autofocus || void 0,
						...attrs,
						onKeydown: onTargetKeydown,
						onKeyup: onTargetKeyup,
						onKeypress: onTargetKeypress
					}));
					if (isTarget && typeof props.autocomplete === "string" && props.autocomplete.length !== 0) child.push(h("input", {
						class: "q-select__autocomplete-input",
						autocomplete: props.autocomplete,
						tabindex: -1,
						onKeyup: onTargetAutocomplete
					}));
				}
				if (nameProp.value !== void 0 && !props.disable && innerOptionsValue.value.length !== 0) {
					const opts = innerOptionsValue.value.map((value) => h("option", {
						value,
						selected: true
					}));
					child.push(h("select", {
						class: "hidden",
						name: nameProp.value,
						multiple: props.multiple
					}, opts));
				}
				return h("div", {
					class: "q-field__native row items-center",
					...props.useInput || !isTarget ? void 0 : state.splitAttrs.attributes.value,
					...state.splitAttrs.listeners.value
				}, child);
			},
			getInnerAppend: () => !props.loading && !innerLoadingIndicator.value && !props.hideDropdownIcon ? [h(QIcon_default, {
				class: "q-select__dropdown-icon" + (menu.value ? " rotate-180" : ""),
				name: dropdownArrowIcon.value
			})] : null
		});
		return useField(state);
	}
});
var skeletonTypes = [
	"text",
	"rect",
	"circle",
	"QBtn",
	"QBadge",
	"QChip",
	"QToolbar",
	"QCheckbox",
	"QRadio",
	"QToggle",
	"QSlider",
	"QRange",
	"QInput",
	"QAvatar"
];
var skeletonAnimations = [
	"wave",
	"pulse",
	"pulse-x",
	"pulse-y",
	"fade",
	"blink",
	"none"
];
var QSkeleton_default = /*#__PURE__*/ createComponent({
	name: "QSkeleton",
	props: {
		...useDarkProps,
		tag: {
			type: String,
			default: "div"
		},
		type: {
			type: String,
			validator: (v) => skeletonTypes.includes(v),
			default: "rect"
		},
		animation: {
			type: String,
			validator: (v) => skeletonAnimations.includes(v),
			default: "wave"
		},
		animationSpeed: {
			type: [String, Number],
			default: 1500
		},
		square: Boolean,
		bordered: Boolean,
		size: String,
		width: String,
		height: String
	},
	setup(props, { slots }) {
		const isDark = useDark(props, getCurrentInstance().proxy.$q);
		const style = computed(() => {
			const size = props.size !== void 0 ? [props.size, props.size] : [props.width, props.height];
			return {
				"--q-skeleton-speed": `${props.animationSpeed}ms`,
				width: size[0],
				height: size[1]
			};
		});
		const classes = computed(() => `q-skeleton q-skeleton--${isDark.value ? "dark" : "light"} q-skeleton--type-${props.type}` + (props.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${props.animation}` : "") + (props.square ? " q-skeleton--square" : "") + (props.bordered ? " q-skeleton--bordered" : ""));
		return () => h(props.tag, {
			class: classes.value,
			style: style.value
		}, hSlot(slots.default));
	}
});
({ ...useDarkProps });
var QSpace_default = /*#__PURE__*/ createComponent({
	name: "QSpace",
	setup() {
		const space = h("div", { class: "q-space" });
		return () => space;
	}
});
({ ...useDarkProps });
({ ...usePanelChildProps });
({
	...useDarkProps,
	...usePanelProps
});
var QTh_default = /*#__PURE__*/ createComponent({
	name: "QTh",
	props: {
		props: Object,
		autoWidth: Boolean
	},
	emits: ["click"],
	setup(props, { slots, emit }) {
		const vm = getCurrentInstance();
		const { proxy: { $q } } = vm;
		const onClick = (evt) => {
			emit("click", evt);
		};
		const onKeyup = (evt, col) => {
			if (evt.key === "Enter" || evt.key === " ") {
				props.props.sort(col);
				onClick(evt);
				evt.preventDefault();
			}
		};
		return () => {
			if (props.props === void 0) return h("th", {
				class: props.autoWidth ? "q-table--col-auto-width" : "",
				onClick
			}, hSlot(slots.default));
			let col, child;
			const name = vm.vnode.key;
			if (name !== null) {
				col = props.props.colsMap[name];
				if (col === void 0) return;
			} else col = props.props.col;
			if (col.sortable) {
				const action = col.align === "right" ? "unshift" : "push";
				child = hUniqueSlot(slots.default, []);
				child[action](h(QIcon_default, {
					class: col.__iconClass,
					name: $q.iconSet.table.arrowUp
				}));
			} else child = hSlot(slots.default);
			const data = {
				class: col.__thClass + (props.autoWidth ? " q-table--col-auto-width" : ""),
				style: col.headerStyle,
				onClick: (evt) => {
					if (col.sortable) props.props.sort(col);
					onClick(evt);
				}
			};
			if (col.sortable) {
				data.tabindex = 0;
				data["aria-sort"] = col.__ariaSort;
				data.onKeydown = (evt) => {
					if (evt.key === " ") evt.preventDefault();
				};
				data.onKeyup = (evt) => {
					onKeyup(evt, col);
				};
			}
			return h("th", data, child);
		};
	}
});
function getTableMiddle(props, content) {
	return h("div", props, [h("table", { class: "q-table" }, content)]);
}
var comps = {
	list: QList_default,
	table: QMarkupTable_default
};
var typeOptions = [
	"list",
	"table",
	"__qtable"
];
var QVirtualScroll_default = /*#__PURE__*/ createComponent({
	name: "QVirtualScroll",
	props: {
		...useVirtualScrollProps,
		type: {
			type: String,
			default: "list",
			validator: (v) => typeOptions.includes(v)
		},
		items: {
			type: Array,
			default: () => []
		},
		itemsFn: Function,
		itemsSize: Number,
		scrollTarget: scrollTargetProp
	},
	setup(props, { slots, attrs }) {
		let localScrollTarget;
		const rootRef = ref(null);
		const virtualScrollLength = computed(() => props.itemsSize >= 0 && props.itemsFn !== void 0 ? Number.parseInt(props.itemsSize, 10) : Array.isArray(props.items) ? props.items.length : 0);
		const { virtualScrollSliceRange, localResetVirtualScroll, padVirtualScroll, onVirtualScrollEvt } = useVirtualScroll({
			virtualScrollLength,
			getVirtualScrollTarget,
			getVirtualScrollEl
		});
		const virtualScrollScope = computed(() => {
			if (virtualScrollLength.value === 0) return [];
			const mapFn = (item, i) => ({
				index: virtualScrollSliceRange.value.from + i,
				item
			});
			return props.itemsFn === void 0 ? props.items.slice(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to).map(mapFn) : props.itemsFn(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to - virtualScrollSliceRange.value.from).map(mapFn);
		});
		const classes = computed(() => "q-virtual-scroll q-virtual-scroll" + (props.virtualScrollHorizontal ? "--horizontal" : "--vertical") + (props.scrollTarget !== void 0 ? "" : " scroll"));
		const attributes = computed(() => props.scrollTarget !== void 0 ? {} : { tabindex: 0 });
		watch(virtualScrollLength, () => {
			localResetVirtualScroll();
		});
		watch(() => props.scrollTarget, () => {
			unconfigureScrollTarget();
			configureScrollTarget();
		});
		function getVirtualScrollEl() {
			const el = rootRef.value;
			return el === null ? null : el.$el || el;
		}
		function getVirtualScrollTarget() {
			return localScrollTarget;
		}
		function configureScrollTarget() {
			const el = getVirtualScrollEl();
			if (el === null) return;
			localScrollTarget = getScrollTarget(el, props.scrollTarget);
			localScrollTarget.addEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
		}
		function unconfigureScrollTarget() {
			if (localScrollTarget !== void 0) {
				localScrollTarget.removeEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
				localScrollTarget = void 0;
			}
		}
		function __getVirtualChildren() {
			let child = padVirtualScroll(props.type === "list" ? "div" : "tbody", virtualScrollScope.value.map(slots.default));
			if (slots.before !== void 0) child = slots.before().concat(child);
			return hMergeSlot(slots.after, child);
		}
		onBeforeMount(() => {
			localResetVirtualScroll();
		});
		onMounted(() => {
			configureScrollTarget();
		});
		onActivated(() => {
			configureScrollTarget();
		});
		onDeactivated(() => {
			unconfigureScrollTarget();
		});
		onBeforeUnmount(() => {
			unconfigureScrollTarget();
		});
		return () => {
			if (slots.default === void 0) {
				console.error("QVirtualScroll: default scoped slot is required for rendering");
				return;
			}
			return props.type === "__qtable" ? getTableMiddle({
				ref: rootRef,
				class: "q-table__middle " + classes.value
			}, __getVirtualChildren()) : h(comps[props.type], {
				...attrs,
				ref: rootRef,
				class: [attrs.class, classes.value],
				...attributes.value
			}, __getVirtualChildren);
		};
	}
});
function sortDate(a, b) {
	return new Date(a) - new Date(b);
}
var useTableSortProps = {
	sortMethod: Function,
	binaryStateSort: Boolean,
	columnSortOrder: {
		type: String,
		validator: (v) => v === "ad" || v === "da",
		default: "ad"
	}
};
function useTableSort(props, computedPagination, colList, setPagination) {
	const columnToSort = computed(() => {
		const { sortBy } = computedPagination.value;
		return sortBy ? colList.value.find((def) => def.name === sortBy) || null : null;
	});
	const computedSortMethod = computed(() => props.sortMethod !== void 0 ? props.sortMethod : (data, sortBy, descending) => {
		const col = colList.value.find((def) => def.name === sortBy);
		if (col === void 0 || col.field === void 0) return data;
		const dir = descending ? -1 : 1, val = typeof col.field === "function" ? (v) => col.field(v) : (v) => v[col.field];
		return data.sort((a, b) => {
			let A = val(a), B = val(b);
			if (col.rawSort !== void 0) return col.rawSort(A, B, a, b) * dir;
			if (A === null || A === void 0) return -1 * dir;
			if (B === null || B === void 0) return Number(dir);
			if (col.sort !== void 0) return col.sort(A, B, a, b) * dir;
			if (isNumber(A) && isNumber(B)) return (A - B) * dir;
			if (isDate(A) && isDate(B)) return sortDate(A, B) * dir;
			if (typeof A === "boolean" && typeof B === "boolean") return (A - B) * dir;
			[A, B] = [A, B].map((s) => String(s).toLocaleString().toLowerCase());
			return A < B ? -1 * dir : A === B ? 0 : dir;
		});
	});
	function sort(col) {
		let sortOrder = props.columnSortOrder;
		if (isObject(col)) {
			if (col.sortOrder) sortOrder = col.sortOrder;
			col = col.name;
		} else {
			const def = colList.value.find((item) => item.name === col);
			if (def?.sortOrder) sortOrder = def.sortOrder;
		}
		let { sortBy, descending } = computedPagination.value;
		if (sortBy !== col) {
			sortBy = col;
			descending = sortOrder === "da";
		} else if (props.binaryStateSort) descending = !descending;
		else if (descending) if (sortOrder === "ad") sortBy = null;
		else descending = false;
		else if (sortOrder === "ad") descending = true;
		else sortBy = null;
		setPagination({
			sortBy,
			descending,
			page: 1
		});
	}
	return {
		columnToSort,
		computedSortMethod,
		sort
	};
}
var useTableFilterProps = {
	filter: [String, Object],
	filterMethod: Function
};
function useTableFilter(props, setPagination) {
	const computedFilterMethod = computed(() => props.filterMethod !== void 0 ? props.filterMethod : (rows, terms, cols, cellValue) => {
		const lowerTerms = terms ? terms.toLowerCase() : "";
		return rows.filter((row) => cols.some((col) => {
			const val = String(cellValue(col, row));
			return (val === "undefined" || val === "null" ? "" : val.toLowerCase()).includes(lowerTerms);
		}));
	});
	watch(() => props.filter, () => {
		nextTick(() => {
			setPagination({ page: 1 }, true);
		});
	}, { deep: true });
	return { computedFilterMethod };
}
function samePagination(oldPag, newPag) {
	for (const prop in newPag) if (newPag[prop] !== oldPag[prop]) return false;
	return true;
}
function fixPagination(p) {
	if (p.page < 1) p.page = 1;
	if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) p.rowsPerPage = 0;
	return p;
}
var useTablePaginationProps = {
	pagination: Object,
	rowsPerPageOptions: {
		type: Array,
		default: () => [
			5,
			7,
			10,
			15,
			20,
			25,
			50,
			0
		]
	},
	"onUpdate:pagination": [Function, Array]
};
function useTablePaginationState(vm, getCellValue) {
	const { props, emit } = vm;
	const innerPagination = ref({
		sortBy: null,
		descending: false,
		page: 1,
		rowsPerPage: props.rowsPerPageOptions.length !== 0 ? props.rowsPerPageOptions[0] : 5,
		...props.pagination
	});
	const computedPagination = computed(() => {
		return fixPagination(props["onUpdate:pagination"] !== void 0 ? {
			...innerPagination.value,
			...props.pagination
		} : innerPagination.value);
	});
	const isServerSide = computed(() => computedPagination.value.rowsNumber !== void 0);
	function sendServerRequest(pagination) {
		requestServerInteraction({
			pagination,
			filter: props.filter
		});
	}
	function requestServerInteraction(prop = {}) {
		nextTick(() => {
			emit("request", {
				pagination: prop.pagination === void 0 ? computedPagination.value : prop.pagination,
				filter: prop.filter === void 0 ? props.filter : prop.filter,
				getCellValue
			});
		});
	}
	function setPagination(val, forceServerRequest) {
		const newPagination = fixPagination({
			...computedPagination.value,
			...val
		});
		if (samePagination(computedPagination.value, newPagination)) {
			if (isServerSide.value && forceServerRequest) sendServerRequest(newPagination);
			return;
		}
		if (isServerSide.value) {
			sendServerRequest(newPagination);
			return;
		}
		if (props.pagination !== void 0 && props["onUpdate:pagination"] !== void 0) emit("update:pagination", newPagination);
		else innerPagination.value = newPagination;
	}
	return {
		innerPagination,
		computedPagination,
		isServerSide,
		requestServerInteraction,
		setPagination
	};
}
function useTablePagination$1(vm, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber) {
	const { props, emit, proxy: { $q } } = vm;
	const computedRowsNumber = computed(() => isServerSide.value ? computedPagination.value.rowsNumber || 0 : filteredSortedRowsNumber.value);
	const firstRowIndex = computed(() => {
		const { page, rowsPerPage } = computedPagination.value;
		return (page - 1) * rowsPerPage;
	});
	const lastRowIndex = computed(() => {
		const { page, rowsPerPage } = computedPagination.value;
		return page * rowsPerPage;
	});
	const isFirstPage = computed(() => computedPagination.value.page === 1);
	const pagesNumber = computed(() => computedPagination.value.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(computedRowsNumber.value / computedPagination.value.rowsPerPage)));
	const isLastPage = computed(() => lastRowIndex.value === 0 ? true : computedPagination.value.page >= pagesNumber.value);
	const computedRowsPerPageOptions = computed(() => {
		return (props.rowsPerPageOptions.includes(innerPagination.value.rowsPerPage) ? props.rowsPerPageOptions : [innerPagination.value.rowsPerPage, ...props.rowsPerPageOptions]).map((count) => ({
			label: count === 0 ? $q.lang.table.allRows : String(count),
			value: count
		}));
	});
	watch(pagesNumber, (newLastPage, oldLastPage) => {
		if (newLastPage === oldLastPage) return;
		const currentPage = computedPagination.value.page;
		if (newLastPage && !currentPage) setPagination({ page: 1 });
		else if (newLastPage < currentPage) setPagination({ page: newLastPage });
	});
	function firstPage() {
		setPagination({ page: 1 });
	}
	function prevPage() {
		const { page } = computedPagination.value;
		if (page > 1) setPagination({ page: page - 1 });
	}
	function nextPage() {
		const { page, rowsPerPage } = computedPagination.value;
		if (lastRowIndex.value > 0 && page * rowsPerPage < computedRowsNumber.value) setPagination({ page: page + 1 });
	}
	function lastPage() {
		setPagination({ page: pagesNumber.value });
	}
	if (props["onUpdate:pagination"] !== void 0) emit("update:pagination", { ...computedPagination.value });
	return {
		firstRowIndex,
		lastRowIndex,
		isFirstPage,
		isLastPage,
		pagesNumber,
		computedRowsPerPageOptions,
		computedRowsNumber,
		firstPage,
		prevPage,
		nextPage,
		lastPage
	};
}
var useTableRowSelectionProps = {
	selection: {
		type: String,
		default: "none",
		validator: (v) => [
			"single",
			"multiple",
			"none"
		].includes(v)
	},
	selected: {
		type: Array,
		default: () => []
	}
};
var useTableRowSelectionEmits = ["update:selected", "selection"];
function useTableRowSelection(props, emit, computedRows, getRowKey) {
	const selectedKeys = computed(() => new Set(props.selected.map(getRowKey.value)));
	const hasSelectionMode = computed(() => props.selection !== "none");
	const singleSelection = computed(() => props.selection === "single");
	const multipleSelection = computed(() => props.selection === "multiple");
	const allRowsSelected = computed(() => computedRows.value.length !== 0 && computedRows.value.every((row) => selectedKeys.value.has(getRowKey.value(row))));
	const someRowsSelected = computed(() => !allRowsSelected.value && computedRows.value.some((row) => selectedKeys.value.has(getRowKey.value(row))));
	const rowsSelectedNumber = computed(() => props.selected.length);
	function isRowSelected(key) {
		return selectedKeys.value.has(key);
	}
	function clearSelection() {
		emit("update:selected", []);
	}
	function updateSelection(keys, rows, added, evt) {
		emit("selection", {
			rows,
			added,
			keys,
			evt
		});
		emit("update:selected", singleSelection.value ? added ? rows : [] : added ? [...props.selected, ...rows] : props.selected.filter((row) => !keys.includes(getRowKey.value(row))));
	}
	return {
		hasSelectionMode,
		singleSelection,
		multipleSelection,
		allRowsSelected,
		someRowsSelected,
		rowsSelectedNumber,
		isRowSelected,
		clearSelection,
		updateSelection
	};
}
function getVal(val) {
	return Array.isArray(val) ? [...val] : [];
}
var useTableRowExpandProps = { expanded: Array };
var useTableRowExpandEmits = ["update:expanded"];
function useTableRowExpand(props, emit) {
	const innerExpanded = ref(getVal(props.expanded));
	watch(() => props.expanded, (val) => {
		innerExpanded.value = getVal(val);
	});
	function isRowExpanded(key) {
		return innerExpanded.value.includes(key);
	}
	function setExpanded(val) {
		if (props.expanded !== void 0) emit("update:expanded", val);
		else innerExpanded.value = val;
	}
	function updateExpanded(key, add) {
		const target = [...innerExpanded.value];
		const index = target.indexOf(key);
		if (add) {
			if (index === -1) {
				target.push(key);
				setExpanded(target);
			}
		} else if (index !== -1) {
			target.splice(index, 1);
			setExpanded(target);
		}
	}
	return {
		isRowExpanded,
		setExpanded,
		updateExpanded
	};
}
var useTableColumnSelectionProps = { visibleColumns: Array };
function useTableColumnSelection(props, computedPagination, hasSelectionMode) {
	const colList = computed(() => {
		if (props.columns !== void 0) return props.columns;
		const row = props.rows[0];
		return row !== void 0 ? Object.keys(row).map((name) => ({
			name,
			label: name.toUpperCase(),
			field: name,
			align: isNumber(row[name]) ? "right" : "left",
			sortable: true
		})) : [];
	});
	const computedCols = computed(() => {
		const { sortBy, descending } = computedPagination.value;
		return (props.visibleColumns !== void 0 ? colList.value.filter((col) => col.required || props.visibleColumns.includes(col.name)) : colList.value).map((col) => {
			const align = col.align || "right";
			const alignClass = `text-${align}`;
			return {
				...col,
				align,
				__iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
				__ariaSort: col.sortable === true ? col.name === sortBy ? descending ? "descending" : "ascending" : "none" : void 0,
				__thClass: alignClass + (col.headerClasses !== void 0 ? " " + col.headerClasses : "") + (col.sortable ? " sortable" : "") + (col.name === sortBy ? ` sorted ${descending ? "sort-desc" : ""}` : ""),
				__tdStyle: col.style !== void 0 ? typeof col.style !== "function" ? () => col.style : col.style : () => null,
				__tdClass: col.classes !== void 0 ? typeof col.classes !== "function" ? () => alignClass + " " + col.classes : (row) => alignClass + " " + col.classes(row) : () => alignClass
			};
		});
	});
	return {
		colList,
		computedCols,
		computedColsMap: computed(() => {
			const names = Object.create(null);
			computedCols.value.forEach((col) => {
				names[col.name] = col;
			});
			return names;
		}),
		computedColspan: computed(() => props.tableColspan !== void 0 ? props.tableColspan : computedCols.value.length + (hasSelectionMode.value ? 1 : 0))
	};
}
var bottomClass = "q-table__bottom row items-center";
var virtScrollPassthroughProps = {};
commonVirtScrollPropsList.forEach((p) => {
	virtScrollPassthroughProps[p] = {};
});
function getCellValue(col, row) {
	const val = typeof col.field === "function" ? col.field(row) : row[col.field];
	return col.format !== void 0 ? col.format(val, row) : val;
}
var QTable_default = /*#__PURE__*/ createComponent({
	name: "QTable",
	props: {
		rows: {
			type: Array,
			required: true
		},
		rowKey: {
			type: [String, Function],
			default: "id"
		},
		columns: Array,
		loading: Boolean,
		iconFirstPage: String,
		iconPrevPage: String,
		iconNextPage: String,
		iconLastPage: String,
		title: String,
		hideHeader: Boolean,
		grid: Boolean,
		gridHeader: Boolean,
		dense: Boolean,
		flat: Boolean,
		bordered: Boolean,
		square: Boolean,
		separator: {
			type: String,
			default: "horizontal",
			validator: (v) => [
				"horizontal",
				"vertical",
				"cell",
				"none"
			].includes(v)
		},
		wrapCells: Boolean,
		virtualScroll: Boolean,
		virtualScrollTarget: {},
		...virtScrollPassthroughProps,
		noDataLabel: String,
		noResultsLabel: String,
		loadingLabel: String,
		selectedRowsLabel: Function,
		rowsPerPageLabel: String,
		paginationLabel: Function,
		color: {
			type: String,
			default: "grey-8"
		},
		titleClass: [
			String,
			Array,
			Object
		],
		tableStyle: [
			String,
			Array,
			Object
		],
		tableClass: [
			String,
			Array,
			Object
		],
		tableHeaderStyle: [
			String,
			Array,
			Object
		],
		tableHeaderClass: [
			String,
			Array,
			Object
		],
		tableRowStyleFn: Function,
		tableRowClassFn: Function,
		cardContainerClass: [
			String,
			Array,
			Object
		],
		cardContainerStyle: [
			String,
			Array,
			Object
		],
		cardStyle: [
			String,
			Array,
			Object
		],
		cardClass: [
			String,
			Array,
			Object
		],
		cardStyleFn: Function,
		cardClassFn: Function,
		hideBottom: Boolean,
		hideSelectedBanner: Boolean,
		hideNoData: Boolean,
		hidePagination: Boolean,
		onRowClick: Function,
		onRowDblclick: Function,
		onRowContextmenu: Function,
		...useDarkProps,
		...useFullscreenProps,
		...useTableColumnSelectionProps,
		...useTableFilterProps,
		...useTablePaginationProps,
		...useTableRowExpandProps,
		...useTableRowSelectionProps,
		...useTableSortProps
	},
	emits: [
		"request",
		"virtualScroll",
		...useFullscreenEmits,
		...useTableRowExpandEmits,
		...useTableRowSelectionEmits
	],
	setup(props, { slots, emit }) {
		const vm = getCurrentInstance();
		const { proxy: { $q } } = vm;
		const isDark = useDark(props, $q);
		const { inFullscreen, toggleFullscreen } = useFullscreen();
		const getRowKey = computed(() => typeof props.rowKey === "function" ? props.rowKey : (row) => row[props.rowKey]);
		const rootRef = ref(null);
		const virtScrollRef = ref(null);
		const hasVirtScroll = computed(() => !props.grid && props.virtualScroll);
		const cardDefaultClass = computed(() => " q-table__card" + (isDark.value ? " q-table__card--dark q-dark" : "") + (props.square ? " q-table--square" : "") + (props.flat ? " q-table--flat" : "") + (props.bordered ? " q-table--bordered" : ""));
		const containerClass = computed(() => `q-table__container q-table--${props.separator}-separator column no-wrap` + (props.grid ? " q-table--grid" : cardDefaultClass.value) + (isDark.value ? " q-table--dark" : "") + (props.dense ? " q-table--dense" : "") + (props.wrapCells ? "" : " q-table--no-wrap") + (inFullscreen.value ? " fullscreen scroll" : ""));
		const rootContainerClass = computed(() => containerClass.value + (props.loading ? " q-table--loading" : ""));
		watch([
			() => props.tableStyle,
			() => props.tableClass,
			() => props.tableHeaderStyle,
			() => props.tableHeaderClass,
			containerClass
		], () => {
			if (hasVirtScroll.value) virtScrollRef.value?.reset();
		}, { deep: true });
		const { innerPagination, computedPagination, isServerSide, requestServerInteraction, setPagination } = useTablePaginationState(vm, getCellValue);
		const { computedFilterMethod } = useTableFilter(props, setPagination);
		const { isRowExpanded, setExpanded, updateExpanded } = useTableRowExpand(props, emit);
		const filteredSortedRows = computed(() => {
			let rows = props.rows;
			if (isServerSide.value || rows.length === 0) return rows;
			const { sortBy, descending } = computedPagination.value;
			if (props.filter) rows = computedFilterMethod.value(rows, props.filter, computedCols.value, getCellValue);
			if (columnToSort.value !== null) rows = computedSortMethod.value(props.rows === rows ? [...rows] : rows, sortBy, descending);
			return rows;
		});
		const filteredSortedRowsNumber = computed(() => filteredSortedRows.value.length);
		const computedRows = computed(() => {
			let rows = filteredSortedRows.value;
			if (isServerSide.value) return rows;
			const { rowsPerPage } = computedPagination.value;
			if (rowsPerPage !== 0) if (firstRowIndex.value === 0 && props.rows !== rows) {
				if (rows.length > lastRowIndex.value) rows = rows.slice(0, lastRowIndex.value);
			} else rows = rows.slice(firstRowIndex.value, lastRowIndex.value);
			return rows;
		});
		const { hasSelectionMode, singleSelection, multipleSelection, allRowsSelected, someRowsSelected, rowsSelectedNumber, isRowSelected, clearSelection, updateSelection } = useTableRowSelection(props, emit, computedRows, getRowKey);
		const { colList, computedCols, computedColsMap, computedColspan } = useTableColumnSelection(props, computedPagination, hasSelectionMode);
		const { columnToSort, computedSortMethod, sort } = useTableSort(props, computedPagination, colList, setPagination);
		const { firstRowIndex, lastRowIndex, isFirstPage, isLastPage, pagesNumber, computedRowsPerPageOptions, computedRowsNumber, firstPage, prevPage, nextPage, lastPage } = useTablePagination$1(vm, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber);
		const nothingToDisplay = computed(() => computedRows.value.length === 0);
		const virtProps = computed(() => {
			const acc = {};
			commonVirtScrollPropsList.forEach((p) => {
				acc[p] = props[p];
			});
			if (acc.virtualScrollItemSize === void 0) acc.virtualScrollItemSize = props.dense ? 28 : 48;
			return acc;
		});
		function resetVirtualScroll() {
			if (hasVirtScroll.value) virtScrollRef.value.reset();
		}
		function getBody() {
			if (props.grid) return getGridBody();
			const header = props.hideHeader ? null : getTHead;
			if (hasVirtScroll.value) {
				const topRow = slots["top-row"];
				const bottomRow = slots["bottom-row"];
				const virtSlots = { default: (slotProps) => getTBodyTR(slotProps.item, slots.body, slotProps.index) };
				if (topRow !== void 0) {
					const topContent = h("tbody", topRow({ cols: computedCols.value }));
					virtSlots.before = header === null ? () => topContent : () => [header(), topContent];
				} else if (header !== null) virtSlots.before = header;
				if (bottomRow !== void 0) virtSlots.after = () => h("tbody", bottomRow({ cols: computedCols.value }));
				return h(QVirtualScroll_default, {
					ref: virtScrollRef,
					class: props.tableClass,
					style: props.tableStyle,
					...virtProps.value,
					scrollTarget: props.virtualScrollTarget,
					items: computedRows.value,
					type: "__qtable",
					tableColspan: computedColspan.value,
					onVirtualScroll: onVScroll
				}, virtSlots);
			}
			const child = [getTBody()];
			if (header !== null) child.unshift(header());
			return getTableMiddle({
				class: ["q-table__middle scroll", props.tableClass],
				style: props.tableStyle
			}, child);
		}
		function scrollTo(toIndex, edge) {
			if (virtScrollRef.value !== null) {
				virtScrollRef.value.scrollTo(toIndex, edge);
				return;
			}
			toIndex = Math.max(0, Number.parseInt(toIndex, 10) || 0);
			const rowEl = rootRef.value.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
			if (rowEl !== null) {
				const scrollTarget = rootRef.value.querySelector(".q-table__middle.scroll");
				const offsetTop = rowEl.offsetTop - (props.virtualScrollStickySizeStart || 0);
				const direction = offsetTop < scrollTarget.scrollTop ? "decrease" : "increase";
				scrollTarget.scrollTop = offsetTop;
				emit("virtualScroll", {
					index: toIndex,
					from: 0,
					to: innerPagination.value.rowsPerPage - 1,
					direction
				});
			}
		}
		function onVScroll(info) {
			emit("virtualScroll", info);
		}
		function getProgress() {
			return [h(QLinearProgress_default, {
				class: "q-table__linear-progress",
				color: props.color,
				dark: isDark.value,
				indeterminate: true,
				trackColor: "transparent"
			})];
		}
		function getTBodyTR(row, bodySlot, pageIndex) {
			const key = getRowKey.value(row), selected = isRowSelected(key);
			if (bodySlot !== void 0) {
				const cfg = {
					key,
					row,
					pageIndex,
					__trClass: selected ? "selected" : ""
				};
				if (props.tableRowStyleFn !== void 0) cfg.__trStyle = props.tableRowStyleFn(row);
				if (props.tableRowClassFn !== void 0) {
					const cls = props.tableRowClassFn(row);
					if (cls) cfg.__trClass = `${cls} ${cfg.__trClass}`;
				}
				return bodySlot(getBodyScope(cfg));
			}
			const bodyCell = slots["body-cell"], child = computedCols.value.map((col) => {
				const bodyCellCol = slots[`body-cell-${col.name}`], slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
				return slot !== void 0 ? slot(getBodyCellScope({
					key,
					row,
					pageIndex,
					col
				})) : h("td", {
					class: col.__tdClass(row),
					style: col.__tdStyle(row)
				}, getCellValue(col, row));
			});
			if (hasSelectionMode.value) {
				const slot = slots["body-selection"];
				const content = slot !== void 0 ? slot(getBodySelectionScope({
					key,
					row,
					pageIndex
				})) : [h(QCheckbox_default, {
					modelValue: selected,
					color: props.color,
					dark: isDark.value,
					dense: props.dense,
					"onUpdate:modelValue": (adding, evt) => {
						updateSelection([key], [row], adding, evt);
					}
				})];
				child.unshift(h("td", { class: "q-table--col-auto-width" }, content));
			}
			const data = {
				key,
				class: { selected }
			};
			if (props.onRowClick !== void 0) {
				data.class["cursor-pointer"] = true;
				data.onClick = (evt) => {
					emit("rowClick", evt, row, pageIndex);
				};
			}
			if (props.onRowDblclick !== void 0) {
				data.class["cursor-pointer"] = true;
				data.onDblclick = (evt) => {
					emit("rowDblclick", evt, row, pageIndex);
				};
			}
			if (props.onRowContextmenu !== void 0) {
				data.class["cursor-pointer"] = true;
				data.onContextmenu = (evt) => {
					emit("rowContextmenu", evt, row, pageIndex);
				};
			}
			if (props.tableRowStyleFn !== void 0) data.style = props.tableRowStyleFn(row);
			if (props.tableRowClassFn !== void 0) {
				const cls = props.tableRowClassFn(row);
				if (cls) data.class[cls] = true;
			}
			return h("tr", data, child);
		}
		function getTBody() {
			const body = slots.body, topRow = slots["top-row"], bottomRow = slots["bottom-row"];
			const child = computedRows.value.map((row, pageIndex) => getTBodyTR(row, body, pageIndex));
			return h("tbody", [
				topRow?.({ cols: computedCols.value }),
				...child,
				bottomRow?.({ cols: computedCols.value })
			].flat());
		}
		function getBodyScope(data) {
			injectBodyCommonScope(data);
			data.cols = data.cols.map((col) => injectProp({ ...col }, "value", () => getCellValue(col, data.row)));
			return data;
		}
		function getBodyCellScope(data) {
			injectBodyCommonScope(data);
			injectProp(data, "value", () => getCellValue(data.col, data.row));
			return data;
		}
		function getBodySelectionScope(data) {
			injectBodyCommonScope(data);
			return data;
		}
		function injectBodyCommonScope(data) {
			Object.assign(data, {
				cols: computedCols.value,
				colsMap: computedColsMap.value,
				sort,
				rowIndex: firstRowIndex.value + data.pageIndex,
				color: props.color,
				dark: isDark.value,
				dense: props.dense
			});
			if (hasSelectionMode.value) injectProp(data, "selected", () => isRowSelected(data.key), (adding, evt) => {
				updateSelection([data.key], [data.row], adding, evt);
			});
			injectProp(data, "expand", () => isRowExpanded(data.key), (adding) => {
				updateExpanded(data.key, adding);
			});
		}
		const marginalsScope = computed(() => ({
			pagination: computedPagination.value,
			pagesNumber: pagesNumber.value,
			isFirstPage: isFirstPage.value,
			isLastPage: isLastPage.value,
			firstPage,
			prevPage,
			nextPage,
			lastPage,
			inFullscreen: inFullscreen.value,
			toggleFullscreen
		}));
		function getTopDiv() {
			const top = slots.top, topLeft = slots["top-left"], topRight = slots["top-right"], topSelection = slots["top-selection"], hasSelection = hasSelectionMode.value && topSelection !== void 0 && rowsSelectedNumber.value > 0, topClass = "q-table__top relative-position row items-center";
			if (top !== void 0) return h("div", { class: topClass }, [top(marginalsScope.value)]);
			let child;
			if (hasSelection) child = [topSelection(marginalsScope.value)].flat();
			else {
				child = [];
				if (topLeft !== void 0) child.push(h("div", { class: "q-table__control" }, [topLeft(marginalsScope.value)]));
				else if (props.title) child.push(h("div", { class: "q-table__control" }, [h("div", { class: ["q-table__title", props.titleClass] }, props.title)]));
			}
			if (topRight !== void 0) child.push(h("div", { class: "q-table__separator col" }), h("div", { class: "q-table__control" }, [topRight(marginalsScope.value)]));
			if (child.length === 0) return;
			return h("div", { class: topClass }, child);
		}
		const headerSelectedValue = computed(() => someRowsSelected.value ? null : allRowsSelected.value);
		function getTHead() {
			const child = getTHeadTR();
			if (props.loading && slots.loading === void 0) child.push(h("tr", { class: "q-table__progress" }, [h("th", {
				class: "relative-position",
				colspan: computedColspan.value
			}, getProgress())]));
			return h("thead", child);
		}
		function getTHeadTR() {
			const header = slots.header, headerCell = slots["header-cell"];
			if (header !== void 0) return [header(getHeaderScope({ header: true }))].flat();
			const child = computedCols.value.map((col) => {
				const headerCellCol = slots[`header-cell-${col.name}`], slot = headerCellCol !== void 0 ? headerCellCol : headerCell, slotProps = getHeaderScope({ col });
				return slot !== void 0 ? slot(slotProps) : h(QTh_default, {
					key: col.name,
					props: slotProps
				}, () => col.label);
			});
			if (singleSelection.value && !props.grid) child.unshift(h("th", { class: "q-table--col-auto-width" }, " "));
			else if (multipleSelection.value) {
				const slot = slots["header-selection"];
				const content = slot !== void 0 ? slot(getHeaderScope({})) : [h(QCheckbox_default, {
					color: props.color,
					modelValue: headerSelectedValue.value,
					dark: isDark.value,
					dense: props.dense,
					"onUpdate:modelValue": onMultipleSelectionSet
				})];
				child.unshift(h("th", { class: "q-table--col-auto-width" }, content));
			}
			return [h("tr", {
				class: props.tableHeaderClass,
				style: props.tableHeaderStyle
			}, child)];
		}
		function getHeaderScope(data) {
			Object.assign(data, {
				cols: computedCols.value,
				sort,
				colsMap: computedColsMap.value,
				color: props.color,
				dark: isDark.value,
				dense: props.dense
			});
			if (multipleSelection.value) injectProp(data, "selected", () => headerSelectedValue.value, onMultipleSelectionSet);
			return data;
		}
		function onMultipleSelectionSet(val) {
			if (someRowsSelected.value) val = false;
			updateSelection(computedRows.value.map(getRowKey.value), computedRows.value, val);
		}
		const navIcon = computed(() => {
			const ico = [
				props.iconFirstPage || $q.iconSet.table.firstPage,
				props.iconPrevPage || $q.iconSet.table.prevPage,
				props.iconNextPage || $q.iconSet.table.nextPage,
				props.iconLastPage || $q.iconSet.table.lastPage
			];
			return $q.lang.rtl ? ico.reverse() : ico;
		});
		function getBottomDiv() {
			if (props.hideBottom) return;
			if (nothingToDisplay.value) {
				if (props.hideNoData) return;
				const message = props.loading ? props.loadingLabel || $q.lang.table.loading : props.filter ? props.noResultsLabel || $q.lang.table.noResults : props.noDataLabel || $q.lang.table.noData;
				const noData = slots["no-data"];
				return h("div", { class: "q-table__bottom row items-center q-table__bottom--nodata" }, noData !== void 0 ? [noData({
					message,
					icon: $q.iconSet.table.warning,
					filter: props.filter
				})] : [h(QIcon_default, {
					class: "q-table__bottom-nodata-icon",
					name: $q.iconSet.table.warning
				}), message]);
			}
			const bottom = slots.bottom;
			if (bottom !== void 0) return h("div", { class: bottomClass }, [bottom(marginalsScope.value)]);
			const child = !props.hideSelectedBanner && hasSelectionMode.value && rowsSelectedNumber.value > 0 ? [h("div", { class: "q-table__control" }, [h("div", [(props.selectedRowsLabel || $q.lang.table.selectedRecords)(rowsSelectedNumber.value)])])] : [];
			if (!props.hidePagination) return h("div", { class: "q-table__bottom row items-center justify-end" }, getPaginationDiv(child));
			if (child.length !== 0) return h("div", { class: bottomClass }, child);
		}
		function onPagSelection(pag) {
			setPagination({
				page: 1,
				rowsPerPage: pag.value
			});
		}
		function getPaginationDiv(child) {
			let control;
			const { rowsPerPage } = computedPagination.value, paginationLabel = props.paginationLabel || $q.lang.table.pagination, paginationSlot = slots.pagination, hasOpts = props.rowsPerPageOptions.length > 1;
			child.push(h("div", { class: "q-table__separator col" }));
			if (hasOpts) child.push(h("div", { class: "q-table__control" }, [h("span", { class: "q-table__bottom-item" }, [props.rowsPerPageLabel || $q.lang.table.recordsPerPage]), h(QSelect_default, {
				class: "q-table__select inline q-table__bottom-item",
				color: props.color,
				modelValue: rowsPerPage,
				options: computedRowsPerPageOptions.value,
				displayValue: rowsPerPage === 0 ? $q.lang.table.allRows : rowsPerPage,
				dark: isDark.value,
				borderless: true,
				dense: true,
				optionsDense: true,
				optionsCover: true,
				"onUpdate:modelValue": onPagSelection
			})]));
			if (paginationSlot !== void 0) control = paginationSlot(marginalsScope.value);
			else {
				control = [h("span", rowsPerPage !== 0 ? { class: "q-table__bottom-item" } : {}, [rowsPerPage ? paginationLabel(firstRowIndex.value + 1, Math.min(lastRowIndex.value, computedRowsNumber.value), computedRowsNumber.value) : paginationLabel(1, filteredSortedRowsNumber.value, computedRowsNumber.value)])];
				if (rowsPerPage !== 0 && pagesNumber.value > 1) {
					const btnProps = {
						color: props.color,
						round: true,
						dense: true,
						flat: true
					};
					if (props.dense) btnProps.size = "sm";
					if (pagesNumber.value > 2) control.push(h(QBtn_default, {
						key: "pgFirst",
						...btnProps,
						icon: navIcon.value[0],
						disable: isFirstPage.value,
						"aria-label": $q.lang.pagination.first,
						onClick: firstPage
					}));
					control.push(h(QBtn_default, {
						key: "pgPrev",
						...btnProps,
						icon: navIcon.value[1],
						disable: isFirstPage.value,
						"aria-label": $q.lang.pagination.prev,
						onClick: prevPage
					}), h(QBtn_default, {
						key: "pgNext",
						...btnProps,
						icon: navIcon.value[2],
						disable: isLastPage.value,
						"aria-label": $q.lang.pagination.next,
						onClick: nextPage
					}));
					if (pagesNumber.value > 2) control.push(h(QBtn_default, {
						key: "pgLast",
						...btnProps,
						icon: navIcon.value[3],
						disable: isLastPage.value,
						"aria-label": $q.lang.pagination.last,
						onClick: lastPage
					}));
				}
			}
			child.push(h("div", { class: "q-table__control" }, control));
			return child;
		}
		function getGridHeader() {
			return h("div", { class: "q-table__middle" }, props.gridHeader ? [h("table", { class: "q-table" }, [getTHead(h)])] : props.loading && slots.loading === void 0 ? getProgress(h) : void 0);
		}
		function getGridBody() {
			const item = slots.item !== void 0 ? slots.item : (scope) => {
				const child = scope.cols.map((col) => h("div", { class: "q-table__grid-item-row" }, [h("div", { class: "q-table__grid-item-title" }, [col.label]), h("div", { class: "q-table__grid-item-value" }, [col.value])]));
				if (hasSelectionMode.value) {
					const slot = slots["body-selection"];
					const content = slot !== void 0 ? slot(scope) : [h(QCheckbox_default, {
						modelValue: scope.selected,
						color: props.color,
						dark: isDark.value,
						dense: props.dense,
						"onUpdate:modelValue": (adding, evt) => {
							updateSelection([scope.key], [scope.row], adding, evt);
						}
					})];
					child.unshift(h("div", { class: "q-table__grid-item-row" }, content), h(QSeparator_default, { dark: isDark.value }));
				}
				const data = {
					class: ["q-table__grid-item-card" + cardDefaultClass.value, props.cardClass],
					style: props.cardStyle
				};
				if (props.cardStyleFn !== void 0) data.style = [data.style, props.cardStyleFn(scope.row)];
				if (props.cardClassFn !== void 0) {
					const cls = props.cardClassFn(scope.row);
					if (cls) data.class[0] += ` ${cls}`;
				}
				if (props.onRowClick !== void 0 || props.onRowDblclick !== void 0 || props.onRowContextmenu !== void 0) {
					data.class[0] += " cursor-pointer";
					if (props.onRowClick !== void 0) data.onClick = (evt) => {
						emit("rowClick", evt, scope.row, scope.pageIndex);
					};
					if (props.onRowDblclick !== void 0) data.onDblclick = (evt) => {
						emit("rowDblclick", evt, scope.row, scope.pageIndex);
					};
					if (props.onRowContextmenu !== void 0) data.onContextmenu = (evt) => {
						emit("rowContextmenu", evt, scope.row, scope.pageIndex);
					};
				}
				return h("div", { class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (scope.selected ? " q-table__grid-item--selected" : "") }, [h("div", data, child)]);
			};
			return h("div", {
				class: ["q-table__grid-content row", props.cardContainerClass],
				style: props.cardContainerStyle
			}, computedRows.value.map((row, pageIndex) => item(getBodyScope({
				key: getRowKey.value(row),
				row,
				pageIndex
			}))));
		}
		Object.assign(vm.proxy, {
			requestServerInteraction,
			setPagination,
			firstPage,
			prevPage,
			nextPage,
			lastPage,
			isRowSelected,
			clearSelection,
			isRowExpanded,
			setExpanded,
			sort,
			resetVirtualScroll,
			scrollTo,
			getCellValue: (colName, row) => {
				const col = computedColsMap.value[colName];
				if (col !== void 0) return getCellValue(col, row);
			}
		});
		injectMultipleProps(vm.proxy, {
			filteredSortedRows: () => filteredSortedRows.value,
			computedRows: () => computedRows.value,
			computedRowsNumber: () => computedRowsNumber.value
		});
		return () => {
			const child = [getTopDiv()];
			const data = {
				ref: rootRef,
				class: rootContainerClass.value
			};
			if (props.grid) child.push(getGridHeader());
			else Object.assign(data, {
				class: [data.class, props.cardClass],
				style: props.cardStyle
			});
			child.push(getBody(), getBottomDiv());
			if (props.loading && slots.loading !== void 0) child.push(slots.loading());
			return h("div", data, child);
		};
	}
});
var QTr_default = /*#__PURE__*/ createComponent({
	name: "QTr",
	props: {
		props: Object,
		noHover: Boolean
	},
	setup(props, { slots }) {
		const classes = computed(() => "q-tr" + (props.props === void 0 || props.props.header ? "" : " " + props.props.__trClass) + (props.noHover ? " q-tr--no-hover" : ""));
		return () => h("tr", {
			style: props.props?.__trStyle,
			class: classes.value
		}, hSlot(slots.default));
	}
});
var QTd_default = /*#__PURE__*/ createComponent({
	name: "QTd",
	props: {
		props: Object,
		autoWidth: Boolean,
		noHover: Boolean
	},
	setup(props, { slots }) {
		const vm = getCurrentInstance();
		const classes = computed(() => "q-td" + (props.autoWidth ? " q-table--col-auto-width" : "") + (props.noHover ? " q-td--no-hover" : "") + " ");
		return () => {
			if (props.props === void 0) return h("td", { class: classes.value }, hSlot(slots.default));
			const name = vm.vnode.key;
			const col = (props.props.colsMap !== void 0 ? props.props.colsMap[name] : null) || props.props.col;
			if (col === void 0) return;
			const { row } = props.props;
			return h("td", {
				class: classes.value + col.__tdClass(row),
				style: col.__tdStyle(row)
			}, hSlot(slots.default));
		};
	}
});
var QRouteTab_default = /*#__PURE__*/ createComponent({
	name: "QRouteTab",
	props: {
		...useRouterLinkProps,
		...useTabProps
	},
	emits: useTabEmits,
	setup(props, { slots, emit }) {
		const routeData = useRouterLink({ useDisableForRouterLinkProps: false });
		const { renderTab, $tabs } = useTab(props, slots, emit, {
			exact: computed(() => props.exact),
			...routeData
		});
		watch(() => `${props.name} | ${props.exact} | ${(routeData.resolvedLink.value || {}).href}`, $tabs.verifyRouteModel);
		return () => renderTab(routeData.linkTag.value, routeData.linkAttrs.value);
	}
});
({
	...useDarkProps,
	...useFormProps,
	...useDatetimeProps
}), { ...useDatetimeProps.mask };
({ ...useDarkProps });
({ ...useDarkProps });
({
	...useDarkProps,
	...useFileProps
});
[...useFileEmits];
var trueFn = () => true;
function getEmitsObject(emitsArray) {
	const emitsObject = {};
	emitsArray.forEach((val) => {
		emitsObject[val] = trueFn;
	});
	return emitsObject;
}
({ ...useRatioProps });
var { passive } = listenOpts;
new RegExp(`^([\\d+]+|${Object.keys({
	esc: 27,
	tab: 9,
	enter: 13,
	space: 32,
	up: 38,
	left: 37,
	right: 39,
	down: 40,
	delete: [8, 46]
}).join("|")})$`, "i");
function getCssVar(propName, element = document.body) {
	if (typeof propName !== "string") throw new TypeError("Expected a string as propName");
	if (!(element instanceof Element)) throw new TypeError("Expected a DOM element");
	return getComputedStyle(element).getPropertyValue(`--q-${propName}`).trim() || null;
}
client.is.mobile && (client.is.nativeMobile || client.is.winphone || client.is.safari || client.is.webkit || client.is.vivaldi);
var prefixes = {};
function assignFn(fn) {
	Object.assign(Plugin, {
		request: fn,
		exit: fn,
		toggle: fn
	});
}
function getFullscreenElement() {
	return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function updateEl() {
	const newEl = Plugin.activeEl = Plugin.isActive ? getFullscreenElement() : null;
	changeGlobalNodesTarget(newEl === null || newEl === document.documentElement ? document.body : newEl);
}
function togglePluginState() {
	Plugin.isActive = !Plugin.isActive;
	updateEl();
}
function promisify(target, fn) {
	try {
		const res = target[fn]();
		return res === void 0 ? Promise.resolve() : res;
	} catch (err) {
		return Promise.reject(err);
	}
}
var Plugin = /*#__PURE__*/ createReactivePlugin({
	isActive: false,
	activeEl: null
}, {
	isCapable: false,
	install({ $q }) {
		$q.fullscreen = this;
	}
});
prefixes.request = [
	"requestFullscreen",
	"msRequestFullscreen",
	"mozRequestFullScreen",
	"webkitRequestFullscreen"
].find((request) => document.documentElement[request] !== void 0);
Plugin.isCapable = prefixes.request !== void 0;
if (!Plugin.isCapable) assignFn(() => Promise.reject(/* @__PURE__ */ new Error("Not capable")));
else {
	Object.assign(Plugin, {
		request(target) {
			const el = target || document.documentElement;
			const { activeEl } = Plugin;
			if (el === activeEl) return Promise.resolve();
			return (activeEl !== null && el.contains(activeEl) ? Plugin.exit() : Promise.resolve()).finally(() => promisify(el, prefixes.request));
		},
		exit() {
			return Plugin.isActive ? promisify(document, prefixes.exit) : Promise.resolve();
		},
		toggle(target) {
			return Plugin.isActive ? Plugin.exit() : Plugin.request(target);
		}
	});
	prefixes.exit = [
		"exitFullscreen",
		"msExitFullscreen",
		"mozCancelFullScreen",
		"webkitExitFullscreen"
	].find((exit) => document[exit]);
	Plugin.isActive = Boolean(getFullscreenElement());
	if (Plugin.isActive) updateEl();
	[
		"onfullscreenchange",
		"onmsfullscreenchange",
		"onwebkitfullscreenchange"
	].forEach((evt) => {
		document[evt] = togglePluginState;
	});
}
var Plugin$1 = /*#__PURE__*/ createReactivePlugin({ appVisible: true }, { install({ $q }) {
	injectProp($q, "appVisible", () => this.appVisible);
} });
{
	let prop, evt;
	if (document.hidden !== void 0) {
		prop = "hidden";
		evt = "visibilitychange";
	} else if (document.msHidden !== void 0) {
		prop = "msHidden";
		evt = "msvisibilitychange";
	} else if (document.webkitHidden !== void 0) {
		prop = "webkitHidden";
		evt = "webkitvisibilitychange";
	}
	if (evt && document[prop] !== void 0) {
		const update = () => {
			Plugin$1.appVisible = !document[prop];
		};
		document.addEventListener(evt, update, false);
	}
}
({ ...useDarkProps });
function stringifyCookieValue(value) {
	return encodeURIComponent(value === Object(value) ? JSON.stringify(value) : String(value));
}
function read(string) {
	if (string === "") return string;
	if (string.indexOf("\"") === 0) string = string.slice(1, -1).replaceAll(String.raw`\"`, "\"").replaceAll(String.raw`\\`, "\\");
	try {
		string = decodeURIComponent(string.replaceAll("+", " "));
	} catch {
		return;
	}
	try {
		const parsed = JSON.parse(string);
		if (parsed === Object(parsed) || Array.isArray(parsed)) string = parsed;
	} catch {}
	return string;
}
var numberUnitRE = /(\d+)([dhms])/g;
var numberUnitMultiplierMap = {
	d: 86400,
	h: 3600,
	m: 60,
	s: 1
};
function parseExpireToSeconds(str) {
	let totalSeconds = 0;
	let hasMatch = false;
	const matches = str.matchAll(numberUnitRE);
	for (const match of matches) {
		hasMatch = true;
		const value = Number.parseInt(match[1], 10);
		const unit = match[2];
		totalSeconds += value * numberUnitMultiplierMap[unit];
	}
	if (hasMatch) return totalSeconds;
	const timestamp = Date.parse(str);
	return Number.isNaN(timestamp) ? void 0 : Math.round((timestamp - Date.now()) / 1e3);
}
function set(key, val, opts = {}, ssr) {
	let maxAge;
	let isDeletion = false;
	if (opts.expires !== void 0) {
		if (Number.isFinite(opts.expires)) maxAge = Math.round(opts.expires * 86400);
		else if (opts.expires instanceof Date) {
			const timestamp = opts.expires.getTime();
			if (Number.isFinite(timestamp)) maxAge = Math.round((timestamp - Date.now()) / 1e3);
		} else if (typeof opts.expires === "string") maxAge = parseExpireToSeconds(opts.expires);
		if (maxAge !== void 0) isDeletion = maxAge <= 0;
	}
	const keyValue = `${encodeURIComponent(key)}=${stringifyCookieValue(val)}`;
	const cookie = [
		keyValue,
		maxAge !== void 0 ? `; Max-Age=${maxAge}` : "",
		opts.path ? `; Path=${opts.path}` : "",
		opts.domain ? `; Domain=${opts.domain}` : "",
		opts.sameSite ? `; SameSite=${opts.sameSite}` : "",
		opts.httpOnly ? "; HttpOnly" : "",
		opts.secure ? "; Secure" : "",
		opts.other ? `; ${opts.other}` : ""
	].join("");
	if (ssr) {
		if (ssr.req.qCookies) ssr.req.qCookies.push(cookie);
		else ssr.req.qCookies = [cookie];
		ssr.res.setHeader("Set-Cookie", ssr.req.qCookies);
		let all = ssr.req.headers.cookie || "";
		if (maxAge !== void 0 && isDeletion) {
			const encodedKey = encodeURIComponent(key);
			all = all.split("; ").filter((entry) => entry.split("=", 1)[0] !== encodedKey).join("; ");
		} else all = all ? `${keyValue}; ${all}` : keyValue;
		ssr.req.headers.cookie = all;
	} else document.cookie = cookie;
}
function get(key, ssr) {
	const cookieSource = ssr ? ssr.req.headers : document, cookies = cookieSource.cookie ? cookieSource.cookie.split("; ") : [], l = cookies.length;
	let result = key ? null : {}, i = 0, parts, name, cookie;
	for (; i < l; i++) {
		parts = cookies[i].split("=");
		try {
			name = decodeURIComponent(parts.shift());
		} catch {
			continue;
		}
		cookie = parts.join("=");
		if (!key) result[name] = cookie;
		else if (key === name) {
			result = read(cookie) ?? null;
			break;
		}
	}
	return result;
}
function remove(key, options, ssr) {
	set(key, "", {
		expires: -1,
		...options
	}, ssr);
}
function has(key, ssr) {
	return get(key, ssr) !== null;
}
function getObject(ssr) {
	return {
		get: (key) => get(key, ssr),
		set: (key, val, opts) => set(key, val, opts, ssr),
		has: (key) => has(key, ssr),
		remove: (key, options) => remove(key, options, ssr),
		getAll: () => get(null, ssr)
	};
}
var Plugin$2 = { install({ $q, ssrContext }) {
	$q.cookies = this;
} };
if (__QUASAR_SSR__) Plugin$2.parseSSR = (ssrContext) => {
	if (ssrContext !== void 0) return getObject(ssrContext);
};
Object.assign(Plugin$2, getObject());
({ ...useDarkProps });
ref(null);
String.raw`\u003C`, String.raw`\u003E`, String.raw`\u0026`, String.raw`\u2028`, String.raw`\u2029`;
function encode(value) {
	if (isDate(value)) return "__q_date|" + value.getTime();
	if (isRegexp(value)) return "__q_expr|" + value.source;
	if (typeof value === "number") return "__q_numb|" + value;
	if (typeof value === "boolean") return "__q_bool|" + (value ? "1" : "0");
	if (typeof value === "string") return "__q_strn|" + value;
	if (typeof value === "function") return "__q_strn|" + value.toString();
	if (value === Object(value)) return "__q_objt|" + JSON.stringify(value);
	return value;
}
var numberRE = /^-?\d+$/;
function decode(value) {
	if (value.length < 9) return value;
	const type = value.slice(0, 8);
	const source = value.slice(9);
	switch (type) {
		case "__q_date": return new Date(numberRE.test(source) ? Number.parseInt(source, 10) : source);
		case "__q_expr": return new RegExp(source);
		case "__q_numb": return Number(source);
		case "__q_bool": return Boolean(source === "1");
		case "__q_strn": return String(source);
		case "__q_objt": return JSON.parse(source);
		default: return value;
	}
}
function getEmptyStorage() {
	return {
		has: () => false,
		hasItem: () => false,
		getLength: () => 0,
		getItem: () => null,
		getIndex: () => null,
		getKey: () => null,
		getAll: () => ({}),
		getAllKeys: () => [],
		set: noop,
		setItem: noop,
		remove: noop,
		removeItem: noop,
		clear: noop,
		isEmpty: () => true
	};
}
function getStorage(type) {
	const webStorage = window[type + "Storage"], get = (key) => {
		const item = webStorage.getItem(key);
		return item ? decode(item) : null;
	};
	const hasItem = (key) => webStorage.getItem(key) !== null;
	const setItem = (key, value) => {
		webStorage.setItem(key, encode(value));
	};
	const removeItem = (key) => {
		webStorage.removeItem(key);
	};
	return {
		has: hasItem,
		hasItem,
		getLength: () => webStorage.length,
		getItem: get,
		getIndex: (index) => index < webStorage.length ? get(webStorage.key(index)) : null,
		getKey: (index) => index < webStorage.length ? webStorage.key(index) : null,
		getAll: () => {
			let key;
			const result = {}, len = webStorage.length;
			for (let i = 0; i < len; i++) {
				key = webStorage.key(i);
				result[key] = get(key);
			}
			return result;
		},
		getAllKeys: () => {
			const result = [], len = webStorage.length;
			for (let i = 0; i < len; i++) result.push(webStorage.key(i));
			return result;
		},
		set: setItem,
		setItem,
		remove: removeItem,
		removeItem,
		clear: () => {
			webStorage.clear();
		},
		isEmpty: () => webStorage.length === 0
	};
}
var storage$1 = !client.has.webStorage ? getEmptyStorage() : getStorage("local");
var Plugin$8 = {
	install({ $q }) {
		$q.localStorage = storage$1;
	},
	...storage$1
};
({ ...!client.has.webStorage ? getEmptyStorage() : getStorage("session") });
function useDialogPluginComponent() {
	const { emit, proxy } = getCurrentInstance();
	const dialogRef = ref(null);
	function show() {
		dialogRef.value.show();
	}
	function hide() {
		dialogRef.value.hide();
	}
	function onDialogOK(payload) {
		emit("ok", payload);
		hide();
	}
	function onDialogHide() {
		emit("hide");
	}
	Object.assign(proxy, {
		show,
		hide
	});
	return {
		dialogRef,
		onDialogHide,
		onDialogOK,
		onDialogCancel: hide
	};
}
var emits = ["ok", "hide"];
useDialogPluginComponent.emits = emits;
useDialogPluginComponent.emitsObject = getEmitsObject(emits);
/**
* Returns the $q instance.
* Equivalent to `this.$q` inside templates.
*/
function useQuasar() {
	return inject("_q_");
}
//#endregion
//#region ../../../../node_modules/uuid/dist/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
//#endregion
//#region ../../../../node_modules/uuid/dist/validate.js
function validate(uuid) {
	return typeof uuid === "string" && regex_default.test(uuid);
}
//#endregion
//#region ../../../../node_modules/uuid/dist/parse.js
function parse(uuid) {
	if (!validate(uuid)) throw TypeError("Invalid UUID");
	let v;
	return Uint8Array.of((v = parseInt(uuid.slice(0, 8), 16)) >>> 24, v >>> 16 & 255, v >>> 8 & 255, v & 255, (v = parseInt(uuid.slice(9, 13), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(14, 18), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(19, 23), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255, v / 4294967296 & 255, v >>> 24 & 255, v >>> 16 & 255, v >>> 8 & 255, v & 255);
}
//#endregion
//#region src/helpers/colors.ts
var { lighten: lighten$1 } = colors_default;
var baseColor = typeof document === "undefined" ? "#F2209E" : getCssVar("primary") ?? "#F2209E";
var USER_COLORS = [
	"#242DDD",
	"#2457CD",
	"#2490DD",
	"#252CDC",
	"#253ECB",
	"#25AAC8",
	"#25C3AC",
	"#26A0BF",
	"#27B675",
	"#2BA19D",
	"#394FD0",
	"#3987D0",
	"#39A0D0",
	"#3A0CA3",
	"#3F37C9",
	"#4361EE",
	"#4895EF",
	"#4CC9F0",
	"#4F25CB",
	"#553ACF",
	"#5EB098",
	"#5F8FE4",
	"#5F9FE4",
	"#61BD7C",
	"#61BDBA",
	"#655FE4",
	"#6981C9",
	"#6997C9",
	"#6F6AC8",
	"#7209B7",
	"#7339D0",
	"#73C0E3",
	"#7499E3",
	"#75CDB6",
	"#7787E4",
	"#78A3DF",
	"#79D0D9",
	"#7AA3E5",
	"#7AD0A1",
	"#7CA6D2",
	"#7D24DD",
	"#7DBEE6",
	"#7ED1C1",
	"#80B6A0",
	"#82CC89",
	"#865EE5",
	"#86D192",
	"#98BAA5",
	"#A1D08F",
	"#AC5FE4",
	"#ADBCA7",
	"#B5179E",
	"#BD34C9",
	"#BED092",
	"#CE57BD",
	"#F2209E"
];
function getUserColor(userId) {
	return USER_COLORS[(typeof userId === "number" ? userId : validate(userId) ? parse(userId)[0] : String(userId).charCodeAt(0)) % (USER_COLORS.length - 1)];
}
function getColor(index) {
	return lighten$1(baseColor, Math.max(-100, -15 * index));
}
function rgbaColor(color, opacity) {
	const colorString = color.charAt(0) === "#" ? color.substring(1, 7) : color;
	if (colorString.length === 6) return `rgba(${parseInt(colorString.substring(0, 2), 16)}, ${parseInt(colorString.substring(2, 4), 16)}, ${parseInt(colorString.substring(4, 6), 16)}, ${opacity})`;
	return colorString;
}
function setPrimaryColor(value) {
	const customColors = {
		accent: lighten$1(value, -15),
		primary: value,
		primary05op: colors_default.changeAlpha(value, .5),
		primaryLighter: colors_default.changeAlpha(value, .2)
	};
	setCssVar("accent", customColors.accent);
	setCssVar("primary", customColors.primary);
	setCssVar("primary-fixed", customColors.primary);
	setCssVar("primary-05op", customColors.primary05op);
	setCssVar("primary-05op-fixed", customColors.primary05op);
	setCssVar("primary-lighter", customColors.primaryLighter);
}
//#endregion
//#region src/helpers/numbers.ts
function roundNumberToPrecision(number, precision = 3) {
	return Number(parseFloat(String(number)).toPrecision(precision));
}
function roundToStep(number, step) {
	if (step === 0) return number;
	return roundNumberToPrecision(Math.floor(roundNumberToPrecision(number / step)) * step);
}
function truncateNumber(number, decimals) {
	const factor = Math.pow(10, decimals);
	return Math.trunc(number * factor) / factor;
}
//#endregion
//#region src/helpers/validation/parameterScalarNumericValidation.ts
function scalarNumericBoundsFromDefinition(def) {
	const maxValue = def.exclusiveMaximum ?? def.maximum;
	const hasMaxValue = maxValue != null;
	const maxValueExclusive = def.exclusiveMaximum != null;
	const minValue = def.minimum ?? def.exclusiveMinimum;
	return {
		hasMaxValue,
		hasMinValue: minValue != null,
		maxValue,
		maxValueExclusive,
		minValue,
		minValueExclusive: def.exclusiveMinimum != null
	};
}
/** Numeric, integer, and min/max rules for integer scalar parameters. */
function appendIntegerScalarValidation(builder, bounds) {
	return builder.numeric.integer.minValueIf(bounds.hasMinValue, bounds.minValue, !bounds.minValueExclusive).maxValueIf(bounds.hasMaxValue, bounds.maxValue, !bounds.maxValueExclusive);
}
/** Numeric, decimal, and min/max rules for float scalar parameters. */
function appendFloatScalarValidation(builder, bounds) {
	return builder.numeric.decimal.minValueIf(bounds.hasMinValue, bounds.minValue, !bounds.minValueExclusive).maxValueIf(bounds.hasMaxValue, bounds.maxValue, !bounds.maxValueExclusive);
}
//#endregion
//#region src/helpers/validation/rules.ts
function maxValueRaw(min, inclusive) {
	return inclusive ? (value) => !helpers.req(value) || +value <= +toValue(min) : (value) => !helpers.req(value) || +value < +toValue(min);
}
function minValueRaw(min, inclusive) {
	return inclusive ? (value) => !helpers.req(value) || +value >= +toValue(min) : (value) => !helpers.req(value) || +value > +toValue(min);
}
function conditional(condition, rule) {
	if (rule instanceof Function) return rule;
	else return {
		...rule,
		$validator: (value, siblingState, vm) => !toValue(condition) || rule.$validator(value, siblingState, vm)
	};
}
function maxValue(max, inclusive) {
	return {
		$message: ({ $params }) => `The maximum value allowed is ${toValue($params.max)}`,
		$params: { max },
		$validator: maxValueRaw(max, inclusive)
	};
}
function minValue(min, inclusive) {
	return {
		$message: ({ $params }) => `The minimum value allowed is ${toValue($params.min)}`,
		$params: { min },
		$validator: minValueRaw(min, inclusive)
	};
}
function minCharCountRaw(min, regex) {
	return (value) => !helpers.req(value) || (value.match(regex) ?? []).length >= toValue(min);
}
function minCharsCountRaw(min, regexes) {
	return (value) => !helpers.req(value) || regexes.every((regex) => (value.match(regex) ?? []).length >= toValue(min));
}
//#endregion
//#region src/helpers/validation/ValidationBuilder.ts
var ValidationBuilder = class ValidationBuilder {
	constructor(i18nPath, label, i18n) {
		if (i18nPath) this._i18nPath = i18nPath;
		if (label) this._label = label;
		if (i18n) this._i18n = i18n;
		this._rules = {};
	}
	get label() {
		if (this._i18nPath) return this.t(this._i18nPath);
		if (this._label) return this._label;
		return this.t("rvai-base.general.inputs.field");
	}
	static withLabel(label, i18n) {
		return new ValidationBuilder(void 0, label, i18n);
	}
	static $t(i18nPath, i18n) {
		return new ValidationBuilder(i18nPath, void 0, i18n);
	}
	addRule(key, rule) {
		this._rules[key] = rule;
	}
	get arrayRequired() {
		this._rules.required = {
			$message: this.t("rvai-base.validation.isRequired", [this.label]),
			$validator: (value) => Array.isArray(value) && !!value.length
		};
		return this;
	}
	arrayRequiredIf(condition) {
		this._rules.required = {
			$message: this.t("rvai-base.validation.isRequired", [this.label]),
			$params: { condition },
			$validator: (value) => !toValue(condition) || Array.isArray(value) && !!value.length
		};
		return this;
	}
	custom(fn, i18nMessagePath, i18nParams = [], key = "custom") {
		this.rules[key] = helpers.withMessage(() => this.t(i18nMessagePath, "value" in i18nParams ? i18nParams.value : i18nParams), fn);
		return this;
	}
	customAsync(fn, messageI18nOrRef, i18nParams = [], key = "customAsync") {
		this._rules[key] = helpers.withAsync({
			$message: typeof messageI18nOrRef === "string" ? this.t(messageI18nOrRef, toValue(i18nParams)) : messageI18nOrRef,
			$validator: fn
		});
		return this;
	}
	customError(i18nMessagePath) {
		this._rules.customError = {
			$message: i18nMessagePath ? this.t(i18nMessagePath, [this.label]) : "",
			$params: { i18nMessagePath },
			$validator: (value) => !helpers.req(value) || !i18nMessagePath
		};
		return this;
	}
	customErrorWithMismatches(regEx, findSymbolsRegex, textPath) {
		this._rules.customErrorWithMismatches = helpers.withMessage((v) => {
			const notAllowedSymbols = distinct(v.$model.split(findSymbolsRegex)).join("");
			return this.t(textPath, [this.label, notAllowedSymbols]);
		}, { $validator: helpers.regex(regEx) });
		return this;
	}
	get decimal() {
		this._rules.decimal = helpers.withMessage(this.t("rvai-base.validation.decimal", [this.label]), decimal);
		return this;
	}
	decimalIf(condition) {
		this._rules.decimal = {
			$message: this.t("rvai-base.validation.decimal", [this.label]),
			$params: { condition },
			$validator: (value) => !helpers.req(value) || !toValue(condition) || Number.isFinite(Number(value))
		};
		return this;
	}
	get dnsLabel() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.dnsLabel", [this.label]),
			$validator: helpers.regex(/^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/)
		};
		return this;
	}
	get email() {
		this._rules.email = helpers.withMessage(this.t("rvai-base.validation.email"), email);
		return this;
	}
	equalTo(equalTo) {
		this._rules.equalTo = {
			$message: () => this.t("rvai-base.validation.equalTo", [this.label, equalTo]),
			$params: { equalTo },
			$validator: (value) => !helpers.req(value) || !equalTo || value === equalTo
		};
		return this;
	}
	if(condition) {
		return new IfValidationBuilder(this, condition, this._i18nPath, this._label, this._i18n);
	}
	get integer() {
		this._rules.integer = helpers.withMessage(this.t("rvai-base.validation.integer", [this.label]), integer);
		return this;
	}
	integerIf(condition) {
		this._rules.integer = {
			$message: this.t("rvai-base.validation.integer", [this.label]),
			$params: { condition },
			$validator: (value) => !helpers.req(value) || !toValue(condition) || Number.isInteger(Number(value))
		};
		return this;
	}
	maxLength(max) {
		if (max == null) return this;
		this._rules.maxLength = helpers.withMessage(this.t("rvai-base.validation.maxLength", [this.label, max]), maxLength(max));
		return this;
	}
	maxValue(max, inclusive = true) {
		if (max == null) return this;
		this._rules.max = this._maxValue(max, inclusive);
		return this;
	}
	maxValueIf(condition, max, inclusive = true) {
		if (max == null) return this;
		this._rules.max = conditional(condition, this._maxValue(max, inclusive));
		return this;
	}
	minLowerCaseCount(min, i18nPath = "rvai-base.validation.minLowerCaseCount") {
		this._rules.minLowerCaseCount = {
			$message: this.t(i18nPath, [this.label, min], { plural: min }),
			$params: { min },
			$validator: minCharCountRaw(min, /[a-z]/g)
		};
		return this;
	}
	minNumberCount(min, i18nPath = "rvai-base.validation.minNumberCount") {
		this._rules.minNumberCount = {
			$message: this.t(i18nPath, [this.label, min], { plural: min }),
			$params: { min },
			$validator: minCharCountRaw(min, /[0-9]/g)
		};
		return this;
	}
	minSpecialCount(min, i18nPath = "rvai-base.validation.minSpecialCount") {
		this._rules.minSpecialCount = {
			$message: this.t(i18nPath, [this.label, min], { plural: min }),
			$params: { min },
			$validator: minCharCountRaw(min, /[!"#$%'()*+,\-./:;<=>?@\\[\]^_`{|}~\s]/g)
		};
		return this;
	}
	minUpperAndLowerCaseCount(min, i18nPath = "rvai-base.validation.minUpperAndLowerCaseCount") {
		this._rules.minUpperAndLowerCaseCount = {
			$message: this.t(i18nPath, [this.label, min], { plural: min }),
			$params: { min },
			$validator: minCharsCountRaw(min, [/[a-z]/g, /[A-Z]/g])
		};
		return this;
	}
	minUpperCaseCount(min, i18nPath = "rvai-base.validation.minUpperCaseCount") {
		this._rules.minUpperCaseCount = {
			$message: this.t(i18nPath, [this.label, min], { plural: min }),
			$params: { min },
			$validator: minCharCountRaw(min, /[A-Z]/g)
		};
		return this;
	}
	minLength(min, i18nPath = "rvai-base.validation.minLength") {
		if (min == null) return this;
		this._rules.minLength = helpers.withMessage(this.t(i18nPath, [this.label, min]), minLength(min));
		return this;
	}
	minValue(min, inclusive = true) {
		if (min == null) return this;
		this._rules.min = this._minValue(min, inclusive);
		return this;
	}
	minValueIf(condition, min, inclusive = true) {
		if (min == null) return this;
		this._rules.min = conditional(condition, this._minValue(min, inclusive));
		return this;
	}
	get numbersOnly() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.numbers", [this.label]),
			$validator: helpers.regex(/^[0-9]*$/)
		};
		return this;
	}
	get numeric() {
		this._rules.numeric = {
			$message: this.t("rvai-base.validation.numeric", [this.label]),
			$validator: helpers.regex(/^-?\d*(\.\d+)?$/)
		};
		return this;
	}
	oneOfRegexes(regExes) {
		this._rules.oneOfRegexes = {
			$message: this.t("rvai-base.validation.mustBeValid", [this.label]),
			$params: { regExes },
			$validator: (value) => !helpers.req(value) || !regExes.length || regExes.some((regex) => regex.test(value))
		};
		return this;
	}
	regex(regEx, textPath = "rvai-base.validation.mustBeValid") {
		this._rules.regex = {
			$message: this.t(textPath, [this.label]),
			$validator: helpers.regex(regEx)
		};
		return this;
	}
	get required() {
		this._rules.required = {
			$message: this.t("rvai-base.validation.isRequired", [this.label]),
			$validator: (value) => !!helpers.req(value)
		};
		return this;
	}
	requiredIf(condition) {
		this._rules.required = {
			$message: this.t("rvai-base.validation.isRequired", [this.label]),
			$params: { condition },
			$validator: (value) => !toValue(condition) || !!helpers.req(value)
		};
		return this;
	}
	requiredUnless(condition) {
		this._rules.required = helpers.withMessage(this.t("rvai-base.validation.isRequired", [this.label]), requiredUnless(() => !!toValue(condition)));
		return this;
	}
	get rules() {
		return this._rules;
	}
	sameAs(i18nPath, val) {
		this._rules.sameAs = {
			$message: this.t("rvai-base.validation.sameAs", [this.label, this.t(i18nPath)]),
			$params: { val },
			$validator: (value) => !helpers.req(value) || value === val
		};
		return this;
	}
	get slug() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.slug", [this.label]),
			$validator: helpers.regex(/^[a-z0-9]+(?:[-_.][a-z0-9]+)*$/)
		};
		return this;
	}
	uniqueValue(values) {
		const isUnique = (value) => {
			return !toValue(values).filter(Boolean).map((s) => typeof s === "string" ? s.toLowerCase() : s).includes(typeof value === "string" ? value.toLowerCase() : value);
		};
		this._rules.unique = {
			$message: this.t("rvai-base.validation.isUnique", [this.label]),
			$params: { values },
			$validator: (value) => !helpers.req(value) || isUnique(value)
		};
		return this;
	}
	get url() {
		this._rules.url = {
			$message: this.t("rvai-base.validation.url", [this.label]),
			$validator: helpers.regex(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/)
		};
		return this;
	}
	get withoutSpaces() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.withoutSpaces", [this.label]),
			$validator: helpers.regex(/^[^\s]*$/)
		};
		return this;
	}
	get wordsAndNumbers() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.wordsAndNumbers", [this.label]),
			$validator: helpers.regex(/^[a-zA-Z0-9]*$/)
		};
		return this;
	}
	get wordsWithoutSpaces() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.wordsWithoutSpaces", [this.label]),
			$validator: helpers.regex(/^[a-zA-Z0-9_-]*$/)
		};
		return this;
	}
	get wordsWithSpaces() {
		this._rules.regex = {
			$message: this.t("rvai-base.validation.wordsWithSpaces", [this.label]),
			$validator: helpers.regex(/^[a-zA-Z0-9_\- ]*$/)
		};
		return this;
	}
	_maxValue(max, inclusive) {
		const message = inclusive ? "rvai-base.validation.maxValue" : "rvai-base.validation.maxValueExclusive";
		return helpers.withMessage(this.t(message, [this.label, max]), maxValue(max, inclusive));
	}
	_minValue(min, inclusive) {
		const message = inclusive ? "rvai-base.validation.minValue" : "rvai-base.validation.minValueExclusive";
		return helpers.withMessage(this.t(message, [this.label, min]), minValue(min, inclusive));
	}
	t(key, params, options) {
		return this.i18n.t(key, params, {
			...options,
			missingWarn: false
		});
	}
	get i18n() {
		return this._i18n ?? ValidationBuilder.i18n;
	}
};
var IfValidationBuilder = class extends ValidationBuilder {
	constructor(builder, condition, i18nPath, label, i18n) {
		super(i18nPath, label, i18n);
		this.builder = builder;
		this.condition = condition;
	}
	end() {
		Object.entries(this._rules).forEach(([key, rule]) => {
			this.builder.addRule(`if_${key}`, conditional(this.condition, rule));
		});
		return this.builder;
	}
};
//#endregion
//#region src/composables/useChartDatasets.ts
var lineStyles = {
	dashed: { borderDash: [5, 4] },
	"dashed-long-with-offset": {
		borderDash: [10, 3],
		borderDashOffset: 5
	},
	dotted: {
		borderCapStyle: "round",
		borderDash: [0, 4]
	},
	"dotted-loosely": {
		borderCapStyle: "round",
		borderDash: [0, 10]
	},
	solid: {}
};
function buildGradient(ctx, chartArea, color) {
	const rgbColor = colors_default.textToRgb(color);
	const rgbColorString = `${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}`;
	const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
	gradient.addColorStop(0, `rgba(${rgbColorString}, 0)`);
	gradient.addColorStop(.3, `rgba(${rgbColorString}, 0.3)`);
	gradient.addColorStop(.5, `rgba(${rgbColorString}, 0.5)`);
	gradient.addColorStop(.8, `rgba(${rgbColorString}, 0.8)`);
	gradient.addColorStop(1, `rgba(${rgbColorString}, 1)`);
	return gradient;
}
function useChartDatasets({ chartRef, params }) {
	return computed(() => {
		const { chart, entries, fill, interpolate, relativeTime } = params.value;
		return entries.map((entry) => {
			const color = toValue(params.value.colors)[entry.key];
			const lineStyle = lineStyles[entry.lineStyle ?? "solid"];
			let chartData;
			if (chart.timeAxis && relativeTime && entry.data.length) {
				const x0 = new Date(entry.data[0]?.[chart.xAxis]).getTime();
				chartData = entry.data.map((x) => ({
					...x,
					[chart.xAxis]: new Date(x[chart.xAxis]).getTime() - x0 || 0
				}));
			} else chartData = entry.data;
			let height;
			let width;
			let gradient;
			return {
				borderCapStyle: lineStyle?.borderCapStyle,
				borderColor: entry.opacity ? rgbaColor(color, entry.opacity) : color,
				borderDash: lineStyle?.borderDash,
				borderDashOffset: lineStyle?.borderDashOffset,
				borderWidth: 2,
				data: chartData,
				fill,
				label: entry.name,
				pointBackgroundColor: color,
				pointBorderColor: color,
				pointRadius: (context) => {
					return context.dataIndex === context.dataset.data.length - 1 ? 4 : 0;
				},
				...interpolate && { cubicInterpolationMode: "monotone" },
				...fill && { backgroundColor: (ctx) => {
					const { chartArea } = ctx.chart;
					const chartWidth = chartArea.right - chartArea.left;
					const chartHeight = chartArea.bottom - chartArea.top;
					if (!chartWidth || !chartHeight) return color;
					if (!gradient || width !== chartWidth || height !== chartHeight) gradient = buildGradient(chartRef.value.getContext("2d"), chartArea, color);
					return gradient;
				} }
			};
		});
	});
}
//#endregion
//#region src/domain/ChartDefinition.ts
var ChartDefinition = class {
	constructor(params) {
		Object.assign(this, params);
	}
};
//#endregion
//#region src/domain/ChartEntry.ts
var ChartEntry = class {
	constructor(params) {
		Object.assign(this, params);
	}
};
//#endregion
//#region src/domain/ConfusionMatrixData.ts
var NULL_CLASS_ID = "null";
var UNKNOWN_CLASS_ID = "999";
var { lighten, luminosity } = colors_default;
var ConfusionMatrixData = class ConfusionMatrixData {
	constructor(matrix, options) {
		this.includeIgnoreClassInMetricCalculation = !!options?.includeIgnoreClassInMetricCalculation;
		this.matrix = matrix ?? {};
		this.transposed = this.buildTransposed(matrix);
		this.classes1 = Object.keys(this.matrix);
		this.classes2 = Object.keys(this.transposed);
		this.maxValue = this.buildMaxValue(this.matrix);
		this.metrics1 = this.buildMetrics(this.matrix);
		this.metrics2 = this.buildMetrics(this.transposed);
		this.metricTotal = this.buildMetricTotal(this.matrix);
		this.percentages = this.buildPercentages(this.matrix);
		this.styles = this.buildStyles(this.matrix, this.maxValue);
		this.stylesDarkMode = this.buildStyles(this.matrix, this.maxValue, true);
		markRaw(this);
	}
	getClasses1() {
		return distinct([...this.classes1, ...this.classes2.filter((x) => !this.ignoreClass(x))]);
	}
	getClasses2() {
		return distinct([...this.classes2, ...this.classes1.filter((x) => !this.ignoreClass(x))]);
	}
	getValue(id1, id2) {
		return this.matrix[id1]?.[id2] || 0;
	}
	getMetric1(id) {
		if (this.ignoreClass(id)) return "-";
		return this.round(this.metrics1[id]);
	}
	getMetric2(id) {
		if (this.ignoreClass(id)) return "-";
		return this.round(this.metrics2[id]);
	}
	getMetricTotal() {
		return this.round(this.metricTotal);
	}
	getOutliers() {
		return Object.entries(this.matrix).flatMap(([source1, others]) => {
			return Object.entries(others).map(([source2, count]) => {
				return count && source1 !== source2 ? {
					source1,
					source2
				} : null;
			}).filter(Boolean);
		});
	}
	getPercentage(id1, id2) {
		return `${this.round(this.percentages[id1]?.[id2], 2)}%`;
	}
	getStyle(id1, id2, isDark = false) {
		if (isDark) return this.stylesDarkMode[id1]?.[id2] ?? {};
		return this.styles[id1]?.[id2] ?? {};
	}
	getTransposed() {
		return new ConfusionMatrixData(this.transposed);
	}
	getValues1(id) {
		return this.matrix[id] ?? {};
	}
	getValues2(id) {
		return this.transposed[id] ?? {};
	}
	toRaw() {
		return this.matrix;
	}
	buildMaxValue(matrix) {
		if (!matrix) return 0;
		return Object.values(matrix).reduce((max, items) => {
			return Object.values(items).reduce((max, value) => {
				return value > max ? value : max;
			}, max);
		}, 0);
	}
	getObjectValuesSum(object, classId) {
		let entries = Object.entries(object);
		if (!this.includeIgnoreClassInMetricCalculation) entries = entries.filter(([k]) => this.unknownClass(classId) || !this.ignoreClass(k));
		return entries.reduce((acc, [, value]) => acc + value, 0);
	}
	buildMetrics(matrix) {
		if (!matrix) return {};
		return mapToObject(matrix, (values, id) => {
			const actual = values[id] ?? 0;
			const sum = this.getObjectValuesSum(values, id);
			return sum ? actual / sum : 0;
		}, (_, id) => !this.nullClass(id));
	}
	buildMetricTotal(matrix) {
		if (!matrix) return 0;
		let sum = 0;
		let actual = 0;
		Object.entries(matrix).filter(([id]) => this.includeIgnoreClassInMetricCalculation || !this.ignoreClass(id)).forEach(([id, values]) => {
			actual += values[id] ?? 0;
			sum += this.getObjectValuesSum(values, id);
		});
		return sum ? actual / sum : 0;
	}
	buildPercentages(matrix) {
		if (!matrix) return {};
		let sum = 0;
		Object.entries(matrix).forEach(([, values]) => {
			sum += Object.entries(values).reduce((acc, [, value]) => acc + value, 0);
		});
		return mapToObject(matrix, (entries) => mapToObject(entries, (value) => sum ? value / sum : 0));
	}
	buildStyles(matrix, max, isDark = false) {
		if (!matrix || !max) return {};
		return mapToObject(matrix, (entries) => mapToObject(entries, (value) => {
			let k = 100 * (1 - value / this.maxValue);
			if (value > 0) k = Math.min(98, k);
			const color = lighten(this.maxColor(isDark), isDark ? Math.abs(k - 100) : k);
			return {
				"background-color": color,
				color: luminosity(color) < .5 ? "white" : "inherit"
			};
		}));
	}
	buildTransposed(matrix) {
		if (!matrix) return {};
		const transposed = {};
		for (const [k, obj] of Object.entries(matrix)) for (const [l, value] of Object.entries(obj)) if (l in transposed) transposed[l][k] = value;
		else transposed[l] = { [k]: value };
		return transposed;
	}
	maxColor(isDark = false) {
		try {
			if (isDark) return getCssVar("dark-fixed") ?? "#353C54";
			return getCssVar("black-1-fixed") ?? "#1F2641";
		} catch {
			return "#1F2641";
		}
	}
	ignoreClass(id) {
		return this.nullClass(id) || this.unknownClass(id);
	}
	nullClass(id) {
		return id === NULL_CLASS_ID;
	}
	unknownClass(id) {
		return id === "999";
	}
	round(value, decimal = 0, defaultValue = "0") {
		return value ? (100 * value).toLocaleString(void 0, { maximumFractionDigits: decimal }) : defaultValue;
	}
};
//#endregion
//#region src/domain/CookiesPolicy.ts
var CookiesPolicy = /* @__PURE__ */ function(CookiesPolicy) {
	CookiesPolicy["All"] = "all";
	CookiesPolicy["Required"] = "required";
	return CookiesPolicy;
}({});
//#endregion
//#region src/domain/CredibilityScore.ts
var CredibilityScore = /* @__PURE__ */ function(CredibilityScore) {
	CredibilityScore[CredibilityScore["TestPrediction"] = .4] = "TestPrediction";
	CredibilityScore[CredibilityScore["ModelAnnotation"] = .5] = "ModelAnnotation";
	CredibilityScore[CredibilityScore["ManualAnnotation"] = .6] = "ManualAnnotation";
	return CredibilityScore;
}({});
var CredibilityScoreThreshold = /* @__PURE__ */ function(CredibilityScoreThreshold) {
	CredibilityScoreThreshold[CredibilityScoreThreshold["All"] = 0] = "All";
	CredibilityScoreThreshold[CredibilityScoreThreshold["DatasetCreation"] = .5] = "DatasetCreation";
	CredibilityScoreThreshold[CredibilityScoreThreshold["ImportDetailsInferenceAnnotation"] = .4] = "ImportDetailsInferenceAnnotation";
	CredibilityScoreThreshold[CredibilityScoreThreshold["LabelCenter"] = .5] = "LabelCenter";
	CredibilityScoreThreshold[CredibilityScoreThreshold["LabelCenterWithInferenceResults"] = .4] = "LabelCenterWithInferenceResults";
	CredibilityScoreThreshold[CredibilityScoreThreshold["TestCenter"] = .4] = "TestCenter";
	return CredibilityScoreThreshold;
}({});
//#endregion
//#region src/domain/darkMode.ts
var DARK_MODE_LOCAL_STORAGE_KEY = "darkMode";
//#endregion
//#region src/domain/DetailsDataType.ts
var DetailsDataType = /* @__PURE__ */ function(DetailsDataType) {
	DetailsDataType["Classes"] = "Classes";
	DetailsDataType["Color"] = "Color";
	DetailsDataType["Custom"] = "Custom";
	DetailsDataType["Link"] = "Link";
	DetailsDataType["List"] = "List";
	DetailsDataType["Text"] = "Text";
	DetailsDataType["TextWrap"] = "TextWrap";
	return DetailsDataType;
}({});
//#endregion
//#region src/domain/FieldVisibility.ts
var FieldVisibility = class FieldVisibility {
	constructor(params) {
		this.fields = params.fields;
		this._hideable = params.hideable == null ? true : !!params.hideable;
		this.key = params.key;
		this.label = params.label;
		this._visible = params.visible == null ? true : !!params.visible;
	}
	clone() {
		return new FieldVisibility({
			fields: this.fields.map((v) => v.clone()),
			hideable: this.hideable,
			key: this.key,
			label: this.label,
			visible: this.visible
		});
	}
	get hideable() {
		return this.fields.length ? this.fields.some((v) => v.hideable) : !!this._hideable;
	}
	get visible() {
		return this.fields.length ? this.fields.some((v) => v.visible) : !!this._visible;
	}
	set visible(visible) {
		if (this._hideable) if (this.fields.length) this.fields = this.fields.map((v) => {
			v.visible = visible;
			return v;
		});
		else this._visible = visible;
	}
	isFieldVisible(key) {
		return !!this.fields.find((v) => v.key === key || v.isFieldVisible(key))?.visible;
	}
	static getVisibleKeys(field) {
		if (!field.visible) return [field.key];
		return field.fields.flatMap(FieldVisibility.getVisibleKeys);
	}
	serialize() {
		if (!this.visible) return [this.key];
		return this.fields.flatMap((f) => f.serialize());
	}
	static fromQueryParams(params, hiddenNames) {
		const visible = hiddenNames.includes(params.key) ? false : params.visible;
		return new FieldVisibility({
			...params,
			fields: params.fields.map((v) => FieldVisibility.fromQueryParams({
				...v,
				visible
			}, hiddenNames)),
			visible
		});
	}
};
//#endregion
//#region src/domain/History.ts
function isHistoryRouteMeta(meta) {
	if (!meta) return false;
	return "track" in meta;
}
//#endregion
//#region src/domain/keyboard.ts
var KEY_0 = "0";
var KEY_1 = "1";
var KEY_2 = "2";
var KEY_3 = "3";
var KEY_4 = "4";
var KEY_5 = "5";
var KEY_6 = "6";
var KEY_7 = "7";
var KEY_8 = "8";
var KEY_9 = "9";
var KEY_A_LOWER = "a";
var KEY_A_UPPER = "A";
var KEY_ALT = "Alt";
var KEY_ARROW_DOWN = "ArrowDown";
var KEY_ARROW_LEFT = "ArrowLeft";
var KEY_ARROW_RIGHT = "ArrowRight";
var KEY_ARROW_UP = "ArrowUp";
var KEY_B_LOWER = "b";
var KEY_B_UPPER = "B";
var KEY_BACKSPACE = "Backspace";
var KEY_C_LOWER = "c";
var KEY_C_UPPER = "C";
var KEY_CONTROL = "Control";
var KEY_D_LOWER = "d";
var KEY_D_UPPER = "D";
var KEY_DEL = "Del";
var KEY_DELETE = "Delete";
var KEY_E_UPPER = "E";
var KEY_ENTER = "Enter";
var KEY_EQUAL = "=";
var KEY_ESC = "Esc";
var KEY_ESCAPE = "Escape";
var KEY_F_LOWER = "f";
var KEY_F_UPPER = "F";
var KEY_F1 = "F1";
var KEY_G_LOWER = "g";
var KEY_G_UPPER = "G";
var KEY_I_UPPER = "I";
var KEY_L_LOWER = "l";
var KEY_L_UPPER = "L";
var KEY_M_UPPER = "M";
var KEY_META = "Meta";
var KEY_MINUS = "-";
var KEY_O_UPPER = "O";
var KEY_P_LOWER = "p";
var KEY_P_UPPER = "P";
var KEY_PLUS = "+";
var KEY_R_LOWER = "r";
var KEY_R_UPPER = "R";
var KEY_SHIFT = "Shift";
var KEY_SPACE = " ";
var KEY_S_LOWER = "s";
var KEY_S_UPPER = "S";
var KEY_TAB = "Tab";
var KEY_T_LOWER = "t";
var KEY_T_UPPER = "T";
var KEY_V_LOWER = "v";
var KEY_V_UPPER = "V";
var KEY_W_UPPER = "W";
var KEY_Y_UPPER = "Y";
var KEY_X_LOWER = "x";
var KEY_X_UPPER = "X";
var KEY_Z_CODE = "KeyZ";
var KEY_Z_LOWER = "z";
var KEY_Z_UPPER = "Z";
var PAPER_KEY_SHIFT = "shift";
var PAPER_KEY_SPACE = "space";
//#endregion
//#region src/domain/Layout.ts
var Layout = /* @__PURE__ */ function(Layout) {
	Layout["Default"] = "default";
	Layout["Full"] = "full";
	Layout["LeftOnly"] = "leftOnly";
	Layout["RightOnly"] = "rightOnly";
	Layout["Split"] = "split";
	return Layout;
}({});
function isLayoutRouteMeta(meta) {
	if (!meta) return false;
	return "allowedLayouts" in meta || "full" in meta;
}
//#endregion
//#region src/domain/PipelineHealth.ts
var PipelineHealthStatus = /* @__PURE__ */ function(PipelineHealthStatus) {
	PipelineHealthStatus["Critical"] = "CRITICAL";
	PipelineHealthStatus["Failing"] = "FAILING";
	PipelineHealthStatus["Healthy"] = "HEALTHY";
	PipelineHealthStatus["Overpowered"] = "OVERPOWERED";
	PipelineHealthStatus["Unbalanced"] = "UNBALANCED";
	PipelineHealthStatus["Underpowered"] = "UNDERPOWERED";
	PipelineHealthStatus["Unknown"] = "UNKNOWN";
	return PipelineHealthStatus;
}({});
var ReplicaStatus = /* @__PURE__ */ function(ReplicaStatus) {
	ReplicaStatus["Error"] = "ERROR";
	ReplicaStatus["Queued"] = "QUEUED";
	ReplicaStatus["Running"] = "RUNNING";
	ReplicaStatus["Starting"] = "STARTING";
	ReplicaStatus["Unknown"] = "UNKNOWN";
	return ReplicaStatus;
}({});
//#endregion
//#region src/domain/RowActionsVisibility.ts
var RowActionsVisibility = /* @__PURE__ */ function(RowActionsVisibility) {
	RowActionsVisibility["HiddenUntilHover"] = "HiddenUntilHover";
	RowActionsVisibility["NoActions"] = "NoActions";
	RowActionsVisibility["Visible"] = "Visible";
	return RowActionsVisibility;
}({});
//#endregion
//#region src/domain/RvaiExceptions.ts
var CancelAsync = class extends Error {};
var HttpsProtocolMismatch = class extends Error {};
var NotFound = class extends Error {};
var Unauthorized = class extends Error {};
var RvaiExceptions = {
	CancelAsync,
	HttpsProtocolMismatch,
	NotFound,
	Unauthorized
};
//#endregion
//#region src/domain/SortFields.ts
var SortOrders = /* @__PURE__ */ function(SortOrders) {
	SortOrders["Asc"] = "asc";
	SortOrders["Desc"] = "desc";
	return SortOrders;
}({});
var SortType = /* @__PURE__ */ function(SortType) {
	SortType["Date"] = "date";
	return SortType;
}({});
//#endregion
//#region src/domain/table.ts
var TableFilterType = /* @__PURE__ */ function(TableFilterType) {
	TableFilterType["Date"] = "date";
	TableFilterType["FreeText"] = "freeText";
	TableFilterType["List"] = "list";
	TableFilterType["Number"] = "number";
	TableFilterType["Single"] = "single";
	return TableFilterType;
}({});
var ShapesNoData = /* @__PURE__ */ function(ShapesNoData) {
	ShapesNoData["Horizontal"] = "horizontal";
	ShapesNoData["Square"] = "square";
	return ShapesNoData;
}({});
//#endregion
//#region src/composables/useDarkMode.ts
function useDarkMode() {
	const $q = useQuasar();
	function initialize(value) {
		if (value != null) $q.dark.set(value);
		else $q.dark.set(Plugin$8.getItem("darkMode") || false);
	}
	function set(value) {
		$q.dark.set(value);
		Plugin$8.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
	}
	function toggle() {
		$q.dark.toggle();
		Plugin$8.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
	}
	return {
		initialize,
		isDark: computed(() => $q.dark.isActive),
		set,
		toggle
	};
}
//#endregion
//#region src/composables/useChartOptions.ts
var TWO_DAYS_IN_MS = 1728e5;
function isTimeRangeLargerThan2Days(params) {
	const { min, max } = params;
	return min && max && max - min > TWO_DAYS_IN_MS;
}
function formatDuration(value) {
	const total = value / 1e3;
	const hours = Math.floor(total / 3600);
	const minutes = Math.floor(total / 60 % 60);
	const seconds = total % 60;
	return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
function useChartOptions({ customTooltip, params, tooltipLines }) {
	const { isDark } = useDarkMode();
	return computed(() => {
		const { chart } = params.value;
		let xAxisLabel = chart.labels?.[chart.xAxis] || chart.xAxis;
		if (chart.xAxisUnit) xAxisLabel += ` (${chart.xAxisUnit})`;
		let yAxisLabel = chart.labels?.[chart.yAxis] || chart.yAxis;
		if (chart.yAxisUnit) yAxisLabel += ` (${chart.yAxisUnit})`;
		const labelColor = isDark.value ? getCssVar("white-fixed") ?? "#FFFFFF" : getCssVar("grey-1-fixed") ?? "#485374";
		const xAxisTicksConfig = {
			autoSkipPadding: 30,
			maxRotation: params.value.labelMaxRotation,
			maxTicksLimit: params.value.xAxisMaxTicksLimit
		};
		const options = {
			animation: false,
			interaction: {
				axis: "xy",
				intersect: false,
				mode: "nearest"
			},
			maintainAspectRatio: params.value.maintainAspectRatio,
			parsing: {
				xAxisKey: chart.xAxis,
				yAxisKey: chart.yAxis
			},
			plugins: { tooltip: {
				callbacks: {
					label: (item) => {
						return [item.dataset.label ?? "", ...tooltipLines.value[item.datasetIndex]?.[item.dataIndex] ?? []];
					},
					title: () => ""
				},
				enabled: false,
				external: customTooltip
			} },
			responsive: true,
			scales: {
				xAxis: {
					ticks: xAxisTicksConfig,
					title: {
						color: labelColor,
						display: params.value.showAxisLabels,
						font: {
							lineHeight: "18px",
							size: 12,
							weight: "600"
						},
						text: xAxisLabel
					},
					type: "linear"
				},
				yAxis: {
					beginAtZero: true,
					title: {
						color: labelColor,
						display: params.value.showAxisLabels,
						font: {
							lineHeight: "18px",
							size: 12,
							weight: "600"
						},
						text: yAxisLabel
					}
				}
			}
		};
		if (chart.timeAxis) options.scales = {
			...options.scales,
			xAxis: {
				...options.scales?.xAxis,
				...params.value.relativeTime ? { ticks: {
					...xAxisTicksConfig,
					callback: (value) => formatDuration(value)
				} } : {
					...params.value.max ? { max: params.value.max } : {},
					...params.value.min ? { min: params.value.min } : {},
					ticks: xAxisTicksConfig,
					time: {
						displayFormats: Object.assign({
							hour: "MMM d HH:mm",
							minute: "HH:mm",
							second: "HH:mm:ss",
							week: "MMM d"
						}, params.value.xAxisTimeDisplayFormats),
						...isTimeRangeLargerThan2Days(params.value) ? { minUnit: "hour" } : {}
					},
					type: "time"
				}
			}
		};
		return options;
	});
}
//#endregion
//#region src/composables/useChartTooltip.ts
var OFFSET = 10;
var SCROLLBAR_OFFSET = 15;
function useChartTooltip(chart, caret) {
	const tooltipGhostRef = useTemplateRef("tooltipGhost");
	const style = ref({
		height: "0px",
		left: "0px",
		overflow: "auto",
		top: "0px",
		width: "0px"
	});
	const timeout = ref(null);
	function getXDeviation() {
		const offsetWidth = getTooltipWidth();
		if (caret.value.x <= offsetWidth / 2) return offsetWidth / 2 + OFFSET;
		if (chart.value.width - caret.value.x <= offsetWidth / 2) return -offsetWidth / 2 + -10;
		return 0;
	}
	function getLeft() {
		if (!tooltipGhostRef.value || !chart) return 0;
		return chart.value.position.x + caret.value.x + getXDeviation();
	}
	function getTop() {
		if (!tooltipGhostRef.value || !chart) return 0;
		return chart.value.position.y + caret.value.y + OFFSET;
	}
	function updateTooltipSizeAndPosition() {
		if (!tooltipGhostRef.value || !chart.value) return;
		style.value = {
			height: `${getTooltipHeight()}px`,
			left: `${getLeft()}px`,
			overflow: getTooltipHeight() < tooltipGhostRef.value.offsetHeight ? "auto" : "hidden",
			top: `${getTop()}px`,
			width: `${getTooltipWidth()}px`
		};
	}
	function getTooltipWidth() {
		return tooltipGhostRef.value.offsetWidth + SCROLLBAR_OFFSET;
	}
	function getTooltipHeight() {
		return Math.min(tooltipGhostRef.value.offsetHeight, getMaxHeight());
	}
	function getMaxHeight() {
		return window.innerHeight - chart.value.top - caret.value.y - OFFSET;
	}
	watch([chart, caret], () => {
		timeout.value = window.setTimeout(() => {
			updateTooltipSizeAndPosition();
		}, 1);
	}, {
		deep: true,
		immediate: true
	});
	onUnmounted(() => {
		if (timeout.value) window.clearTimeout(timeout.value);
	});
	return { style };
}
//#endregion
//#region src/composables/useCollapsed.ts
var state$1 = reactive({});
function useCollapsed(name, value) {
	if (state$1[name] === void 0) state$1[name] = value === void 0 ? true : value;
	const collapsed = toRef(state$1, name);
	function toggleCollapsed() {
		state$1[name] = !state$1[name];
	}
	return {
		collapsed,
		toggleCollapsed
	};
}
//#endregion
//#region src/components/Tooltip.vue?vue&type=script&lang.ts
var Tooltip_vue_vue_type_script_lang_default = defineComponent({
	name: "Tooltip",
	components: { QTooltip: QTooltip_default },
	inheritAttrs: false,
	props: {
		/**
		* Automatically hide after a time when manually triggered
		*/
		autoHide: {
			default: void 0,
			type: Number
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Two values setting the starting position or anchor point of the Tooltip relative to its target
		*/
		anchor: {
			type: String,
			default: "bottom middle"
		},
		/**
		* Render arrow (bottom|left|right|top)
		*/
		arrow: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* The maximum width of the Tooltip; Size in CSS units, including unit name
		*/
		maxWidth: {
			type: String,
			default: "400px"
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Boolean,
			default: void 0
		},
		/**
		* An array of two numbers to offset the Tooltip horizontally and vertically in pixels
		*/
		offset: {
			type: Array,
			default: () => [14, 14]
		},
		/**
		* Two values setting the Tooltip's own position relative to its target
		*/
		self: {
			type: String,
			default: "top middle"
		},
		/**
		* Configure a target element to trigger Tooltip toggle; 'true' means it enables the parent DOM element, 'false' means it disables attaching events to any DOM elements; By using a String (CSS selector) it attaches the events to the specified DOM element (if it exists)
		*/
		target: {
			type: [Boolean, String],
			default: true
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const tooltipRef = ref(null);
		const timeout = ref(null);
		const arrowClass = computed(() => {
			switch (props.arrow) {
				case "bottom": return "rv-tooltip__arrow rv-tooltip__arrow--bottom";
				case "left": return "rv-tooltip__arrow rv-tooltip__arrow--left";
				case "right": return "rv-tooltip__arrow rv-tooltip__arrow--right";
				case "top": return "rv-tooltip__arrow rv-tooltip__arrow--top";
				default: return;
			}
		});
		function show(evt) {
			tooltipRef.value?.show(evt);
			if (timeout.value) window.clearTimeout(timeout.value);
			if (props.autoHide) timeout.value = window.setTimeout(() => {
				tooltipRef.value?.hide();
			}, props.autoHide);
		}
		function onUpdate(value) {
			emit("update:modelValue", value);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			arrowClass,
			onUpdate,
			show,
			tooltipRef
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/Tooltip.vue
function _sfc_render$97(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QTooltip = resolveComponent("QTooltip");
	return openBlock(), createBlock(_component_QTooltip, mergeProps(_ctx.dataAttrs, {
		ref: "tooltipRef",
		anchor: _ctx.anchor,
		class: ["rv-tooltip q-pa-sm text-overline shadow-6", [_ctx.arrowClass, _ctx.$props.class]],
		"data-automation": _ctx.buildId(),
		delay: 500,
		fit: true,
		"max-width": _ctx.maxWidth,
		"model-value": _ctx.modelValue,
		offset: _ctx.offset,
		self: _ctx.self,
		target: _ctx.target,
		"transition-hide": "fade",
		"transition-show": "fade",
		"onUpdate:modelValue": _ctx.onUpdate
	}), {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 3
	}, 16, [
		"anchor",
		"class",
		"data-automation",
		"max-width",
		"model-value",
		"offset",
		"self",
		"target",
		"onUpdate:modelValue"
	]);
}
var Tooltip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Tooltip_vue_vue_type_script_lang_default, [["render", _sfc_render$97]]);
//#endregion
//#region src/components/Button.vue?vue&type=script&lang.ts
var COLORS = [
	"accent",
	"black-1",
	"grey-1",
	"grey-2",
	"info",
	"negative",
	"positive",
	"primary",
	"primary-fixed",
	"warning",
	"white-fixed"
];
var SIZES$2 = [
	"xs",
	"sm",
	"md",
	"lg"
];
var Button_vue_vue_type_script_lang_default = defineComponent({
	name: "RvButton",
	components: {
		QBtn: QBtn_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Label or content alignment
		*/
		align: {
			type: String,
			default: "center",
			validator: (v) => [
				"left",
				"right",
				"center",
				"around",
				"between",
				"evenly"
			].includes(v)
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Color name for component from the Quasar Color Palette
		*/
		color: {
			type: String,
			default: void 0,
			validator: (v) => COLORS.includes(v)
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Native <a> link href attribute; Has priority over the 'to' and 'replace' props
		*/
		href: {
			type: String,
			default: void 0
		},
		/**
		* Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
		*/
		icon: {
			type: String,
			default: void 0
		},
		/**
		* Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
		*/
		iconRight: {
			type: String,
			default: void 0
		},
		/**
		* The text that will be shown on the button
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Put button into loading state (displays a QSpinner -- can be overridden by using a 'loading' slot)
		*/
		loading: {
			type: Boolean,
			default: false
		},
		/**
		* Render button in secondary mode
		*/
		secondary: {
			type: Boolean,
			default: false
		},
		/**
		* Size in standard size name (xs|sm|md|lg)
		*/
		size: {
			type: String,
			default: "md",
			validator: (v) => SIZES$2.includes(v)
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Native <a> link target attribute; Use it only with 'to' or 'href' props
		*/
		target: {
			type: String,
			default: void 0
		},
		/**
		* Render button in tertiary mode
		*/
		tertiary: {
			type: Boolean,
			default: false
		},
		/**
		* Overrides text color (if needed); Color name from the Quasar Color Palette
		*/
		textColor: {
			type: String,
			default: void 0
		},
		/**
		* Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
		*/
		to: {
			type: [Object, String],
			default: void 0
		},
		/**
		* The text that will be shown on the button tooltip
		*/
		tooltip: {
			type: String,
			default: void 0
		},
		/**
		* 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
		*/
		type: {
			type: String,
			default: "button"
		}
	},
	emits: ["click"],
	setup(props, { emit, slots }) {
		const buttonColor = computed(() => {
			if (props.secondary && !hasLabel.value && !props.color) return "black-1";
			return props.color ?? "primary";
		});
		const hasLabel = computed(() => props.label != null && props.label !== "");
		const onClick = throttle((event) => emit("click", event), 200, { trailing: false });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			buttonColor,
			hasLabel,
			onClick,
			slots
		};
	}
});
//#endregion
//#region src/components/Button.vue
function _sfc_render$96(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QBtn = resolveComponent("QBtn");
	return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
		align: _ctx.align,
		class: ["rv-button", [
			_ctx.$props.class,
			`rv-button--${_ctx.size}`,
			{ "rv-button--icon-only": !_ctx.hasLabel }
		]],
		color: _ctx.buttonColor,
		"data-automation": _ctx.buildId(),
		disable: _ctx.disable,
		flat: _ctx.tertiary,
		href: _ctx.href,
		icon: _ctx.icon,
		"icon-right": _ctx.iconRight,
		label: _ctx.label,
		loading: _ctx.loading,
		"no-caps": "",
		outline: _ctx.secondary,
		ripple: false,
		style: _ctx.style,
		target: _ctx.target,
		"text-color": _ctx.textColor,
		to: _ctx.to,
		type: _ctx.type,
		onClick: _ctx.onClick
	}), createSlots({ _: 2 }, [_ctx.tooltip ? {
		name: "default",
		fn: withCtx(() => [createVNode(_component_Tooltip, { "data-automation": _ctx.buildId("tooltip") }, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tooltip), 1)]),
			_: 1
		}, 8, ["data-automation"])]),
		key: "0"
	} : void 0, renderList(_ctx.slots, (_, name) => {
		return {
			name,
			fn: withCtx((slotData) => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)])
		};
	})]), 1040, [
		"align",
		"class",
		"color",
		"data-automation",
		"disable",
		"flat",
		"href",
		"icon",
		"icon-right",
		"label",
		"loading",
		"outline",
		"style",
		"target",
		"text-color",
		"to",
		"type",
		"onClick"
	]);
}
var Button_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Button_vue_vue_type_script_lang_default, [["render", _sfc_render$96], ["__scopeId", "data-v-397cc32d"]]);
//#endregion
//#region src/components/ClickableArea.vue?vue&type=script&lang.ts
var ClickableArea_vue_vue_type_script_lang_default = defineComponent({
	name: "ClickableArea",
	components: { QBtn: QBtn_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Changes background color on hover
		*/
		hoverable: {
			type: Boolean,
			default: true
		},
		/**
		* Native <a> link href attribute; Has priority over the 'to' and 'replace' props
		*/
		href: {
			type: String,
			default: void 0
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Native <a> link target attribute; Use it only with 'to' or 'href' props
		*/
		target: {
			type: String,
			default: void 0
		},
		/**
		* Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
		*/
		to: {
			type: [Object, String],
			default: void 0
		},
		/**
		* 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
		*/
		type: {
			type: String,
			default: "button"
		}
	},
	emits: [
		"click",
		"dragend",
		"dragleave",
		"dragover",
		"dragstart",
		"drop"
	],
	setup(props, { emit }) {
		const onClick = throttle((event) => emit("click", event), 200, { trailing: false });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			onClick
		};
	}
});
//#endregion
//#region src/components/ClickableArea.vue
function _sfc_render$95(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QBtn = resolveComponent("QBtn");
	return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
		class: ["rv-clickable-area", [_ctx.$props.class, { "rv-clickable-area--hoverable": _ctx.hoverable && !_ctx.disable }]],
		"data-automation": _ctx.buildId(),
		disable: _ctx.disable,
		href: _ctx.href,
		"no-caps": "",
		ripple: false,
		style: _ctx.style,
		target: _ctx.target,
		to: _ctx.to,
		type: _ctx.type,
		onClick: _ctx.onClick,
		onDragend: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dragend", $event)),
		onDragleave: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("dragleave", $event)),
		onDragover: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("dragover", $event)),
		onDragstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("dragstart", $event)),
		onDrop: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("drop", $event))
	}), {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 16, [
		"class",
		"data-automation",
		"disable",
		"href",
		"style",
		"target",
		"to",
		"type",
		"onClick"
	]);
}
var ClickableArea_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ClickableArea_vue_vue_type_script_lang_default, [["render", _sfc_render$95], ["__scopeId", "data-v-35f5def3"]]);
//#endregion
//#region src/components/Checkbox.vue?vue&type=script&lang.ts
var SIZES$1 = [
	"xs",
	"sm",
	"md"
];
var Checkbox_vue_vue_type_script_lang_default = defineComponent({
	name: "Checkbox",
	components: {
		ClickableArea: ClickableArea_default,
		QCheckbox: QCheckbox_default,
		QIcon: QIcon_default,
		QMenu: QMenu_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Used to align the checkbox with other components (including option group)
		*/
		aligned: {
			type: Boolean,
			default: false
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Label to display along the component
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
		*/
		modelValue: {
			type: [Boolean, Array],
			default: void 0
		},
		/**
		* Size in standard size name (xs|sm|md)
		*/
		size: {
			type: String,
			default: void 0,
			validator: (v) => SIZES$1.includes(v)
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Works when model ('value') is Array. It tells the component which value should add/remove when ticked/unticked
		*/
		val: {
			type: null,
			default: void 0
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const showMenu = ref(false);
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			showMenu,
			value
		};
	}
});
//#endregion
//#region src/components/Checkbox.vue
var _hoisted_1$96 = { class: "rv-checkbox-wrapper row items-center" };
function _sfc_render$94(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QCheckbox = resolveComponent("QCheckbox");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_ClickableArea = resolveComponent("ClickableArea");
	return openBlock(), createElementBlock("div", _hoisted_1$96, [createVNode(_component_QCheckbox, mergeProps({
		..._ctx.dataAttrs,
		...!!_ctx.$attrs.onClick && { onClick: _ctx.$attrs.onClick }
	}, {
		modelValue: _ctx.value,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
		class: ["rv-checkbox", [
			_ctx.$props.class,
			`rv-checkbox--${_ctx.size}`,
			{
				"rv-checkbox--aligned": _ctx.aligned,
				"rv-checkbox--with-menu": _ctx.$slots["menu"]
			}
		]],
		"data-automation": _ctx.buildId(),
		dense: _ctx.dense,
		disable: _ctx.disable,
		label: _ctx.label,
		size: _ctx.size,
		style: _ctx.style,
		val: _ctx.val
	}), {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 16, [
		"modelValue",
		"class",
		"data-automation",
		"dense",
		"disable",
		"label",
		"size",
		"style",
		"val"
	]), _ctx.$slots["menu"] ? (openBlock(), createBlock(_component_ClickableArea, {
		key: 0,
		class: normalizeClass(["rv-checkbox__menu-icon-wrapper cursor-pointer flex items-center", [`rv-checkbox__menu-icon-wrapper--${_ctx.size}`]]),
		"data-automation": "checkbox__menu-icon-wrapper",
		disable: _ctx.disable
	}, {
		default: withCtx(() => [createVNode(_component_QIcon, {
			"data-automation": "checkbox__menu-icon",
			name: "mdi-menu-down",
			size: "15px"
		}), createVNode(_component_QMenu, {
			modelValue: _ctx.showMenu,
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.showMenu = $event),
			"auto-close": "",
			"data-automation": "checkbox__menu",
			self: "top left"
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "menu", {}, void 0, true)]),
			_: 3
		}, 8, ["modelValue"])]),
		_: 3
	}, 8, ["class", "disable"])) : createCommentVNode("", true)]);
}
var Checkbox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Checkbox_vue_vue_type_script_lang_default, [["render", _sfc_render$94], ["__scopeId", "data-v-662c8dba"]]);
//#endregion
//#region src/components/ScrollArea.vue?vue&type=script&lang.ts
var ScrollArea_vue_vue_type_script_lang_default = defineComponent({
	name: "ScrollArea",
	components: { QScrollArea: QScrollArea_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "scrollArea"
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Removes horizontal scroll
		*/
		noHorizontal: {
			type: Boolean,
			default: false
		},
		/**
		* Force render the content as a normal div
		*/
		noScroll: {
			type: Boolean,
			default: false
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Manually control the visibility of the scrollbar; Overrides default mouse over/leave behavior
		*/
		visible: {
			type: Boolean,
			default: void 0
		}
	},
	emits: ["scroll"],
	setup(props, { emit }) {
		const scrollAreaRef = ref();
		const bottomVisible = ref(true);
		const topVisible = ref(true);
		function onScroll(event) {
			emit("scroll", event);
			const { verticalContainerSize, verticalPosition, verticalSize } = event;
			topVisible.value = !verticalPosition;
			bottomVisible.value = verticalSize - verticalContainerSize === verticalPosition;
		}
		function setScrollPosition(axis, offset, duration = 0) {
			if (scrollAreaRef.value) scrollAreaRef.value.setScrollPosition(axis, offset, duration);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			bottomVisible,
			onScroll,
			scrollAreaRef,
			setScrollPosition,
			topVisible
		};
	}
});
//#endregion
//#region src/components/ScrollArea.vue
var _hoisted_1$95 = ["data-automation"];
function _sfc_render$93(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QScrollArea = resolveComponent("QScrollArea");
	return !_ctx.noScroll ? (openBlock(), createBlock(_component_QScrollArea, mergeProps({ key: 0 }, {
		..._ctx.dataAttrs,
		..._ctx.$props.visible != null && { visible: _ctx.$props.visible }
	}, {
		ref: "scrollAreaRef",
		class: ["scroll-area", [_ctx.$props.class, { "scroll-area--no-horizontal": _ctx.noHorizontal }]],
		"data-automation": _ctx.buildId(),
		style: _ctx.style,
		onScroll: _ctx.onScroll
	}), {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 16, [
		"class",
		"data-automation",
		"style",
		"onScroll"
	])) : (openBlock(), createElementBlock("div", {
		key: 1,
		class: normalizeClass(["scroll-area", _ctx.$props.class]),
		"data-automation": _ctx.buildId(),
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 14, _hoisted_1$95));
}
var ScrollArea_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScrollArea_vue_vue_type_script_lang_default, [["render", _sfc_render$93], ["__scopeId", "data-v-b4e771c5"]]);
//#endregion
//#region src/components/Dialog.vue?vue&type=script&lang.ts
var Dialog_vue_vue_type_script_lang_default = defineComponent({
	name: "RvDialog",
	components: {
		QCard: QCard_default,
		QCardActions: QCardActions_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		QResizeObserver: QResizeObserver_default,
		RvButton: Button_default,
		ScrollArea: ScrollArea_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "dialog"
		},
		/**
		* Render an empty q-dialog component
		*/
		empty: {
			type: Boolean,
			default: false
		},
		/**
		* Show close dialog button on the top
		*/
		hideCloseButton: {
			type: Boolean,
			default: false
		},
		/**
		* Dialog width
		*/
		width: {
			type: String,
			default: "400px"
		}
	},
	emits: [...useDialogPluginComponent.emits, "on-cancel"],
	setup(props) {
		const { dialogRef, onDialogHide } = useDialogPluginComponent();
		const contentRef = ref();
		const contentHeight = ref(0);
		const contentHeightStyle = computed(() => `${contentHeight.value}px`);
		function hide() {
			dialogRef.value?.hide();
		}
		function onResize(dimensions) {
			contentHeight.value = dimensions.height;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			contentHeightStyle,
			contentRef,
			dialogRef,
			hide,
			onDialogHide,
			onResize
		};
	}
});
//#endregion
//#region src/components/Dialog.vue
var _hoisted_1$94 = { ref: "contentRef" };
function _sfc_render$92(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_QCardActions = resolveComponent("QCardActions");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	return openBlock(), createBlock(_component_QDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId()
	}, _ctx.$attrs, {
		style: {
			"--dialog-width": _ctx.width,
			"--dialog-content-height": _ctx.contentHeightStyle
		},
		onHide: _ctx.onDialogHide
	}), {
		default: withCtx(() => [_ctx.empty ? renderSlot(_ctx.$slots, "default", {}, void 0, true, 0) : (openBlock(), createBlock(_component_QCard, {
			key: 1,
			class: "rv-dialog column no-wrap"
		}, {
			default: withCtx(() => [
				!_ctx.hideCloseButton ? (openBlock(), createBlock(_component_QCardSection, {
					key: 0,
					class: "q-pb-none flex justify-end"
				}, {
					default: withCtx(() => [createVNode(_component_RvButton, {
						class: "no-padding",
						color: "black-1",
						"data-automation": _ctx.buildId("close"),
						icon: "mdi-close",
						tertiary: "",
						onClick: _ctx.hide
					}, null, 8, ["data-automation", "onClick"])]),
					_: 1
				})) : createCommentVNode("", true),
				createVNode(_component_QCardSection, {
					class: "q-pt-none row justify-center items-center",
					"data-automation": _ctx.buildId("title")
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "title", {}, void 0, true)]),
					_: 3
				}, 8, ["data-automation"]),
				createVNode(_component_QCardSection, {
					class: "rv-dialog__content q-px-md q-py-none",
					"data-automation": _ctx.buildId("content")
				}, {
					default: withCtx(() => [createVNode(_component_ScrollArea, {
						class: "full-height",
						"data-automation": _ctx.buildId("scroll")
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_1$94, [createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 512)]),
						_: 3
					}, 8, ["data-automation"])]),
					_: 3
				}, 8, ["data-automation"]),
				createVNode(_component_QCardActions, {
					class: "row q-pa-md flex justify-end",
					"data-automation": _ctx.buildId("actions")
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "actions", {}, void 0, true)]),
					_: 3
				}, 8, ["data-automation"])
			]),
			_: 3
		}))]),
		_: 3
	}, 16, [
		"data-automation",
		"style",
		"onHide"
	]);
}
var Dialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Dialog_vue_vue_type_script_lang_default, [["render", _sfc_render$92], ["__scopeId", "data-v-2ee0d6fc"]]);
//#endregion
//#region src/components/EllipsisText.vue?vue&type=script&lang.ts
var EllipsisText_vue_vue_type_script_lang_default = defineComponent({
	name: "EllipsisText",
	components: { Tooltip: Tooltip_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Show 3dots at the beginning
		* @type {Boolean}
		*/
		reverse: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		tooltipClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Text displayed inside the component
		*/
		text: {
			type: [String, Number],
			default: void 0
		},
		/**
		* To keep spaces between working in text
		*/
		textWithSpaces: {
			type: Boolean,
			default: false
		},
		/**
		* Tooltip is shown by default when overflowing text, or always shown when passing this property
		*/
		tooltip: {
			type: [String],
			default: void 0
		}
	},
	setup(props) {
		const containerRef = ref(null);
		const contentRef = ref(null);
		const overflowed = ref(false);
		const textContent = computed(() => {
			return props.text ?? contentRef.value?.innerText ?? "";
		});
		function checkWidth() {
			overflowed.value = !!containerRef.value && !!contentRef.value && contentRef.value.offsetWidth > containerRef.value.offsetWidth;
		}
		onMounted(checkWidth);
		watchEffect(() => {
			if (!containerRef.value) return;
			const observer = new ResizeObserver(checkWidth);
			observer.observe(containerRef.value);
			onWatcherCleanup(() => observer.disconnect());
		});
		watch(() => props.text, () => {
			nextTick(checkWidth);
		}, { immediate: true });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			containerRef,
			contentRef,
			overflowed,
			textContent
		};
	}
});
//#endregion
//#region src/components/EllipsisText.vue
var _hoisted_1$93 = ["data-automation"];
var _hoisted_2$75 = { ref: "contentRef" };
var _hoisted_3$58 = { key: 0 };
var _hoisted_4$36 = { key: 1 };
function _sfc_render$91(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		ref: "containerRef",
		class: normalizeClass(["rv-ellipsis-text ellipsis", [{
			"rv-ellipsis-text--overflowed": _ctx.overflowed,
			"rv-ellipsis-text--reverse": _ctx.reverse,
			"rv-ellipsis-text--with-spaces": _ctx.textWithSpaces
		}, _ctx.$props.class]]),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("span", _hoisted_2$75, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.text), 1)], true)], 512), _ctx.overflowed || _ctx.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
		key: 0,
		anchor: "bottom middle",
		class: normalizeClass(["rv-ellipsis-text__tooltip", _ctx.tooltipClass]),
		"data-automation": _ctx.buildId("tooltip"),
		self: "center middle"
	}, {
		default: withCtx(() => [_ctx.overflowed ? (openBlock(), createElementBlock("div", _hoisted_3$58, toDisplayString(_ctx.textContent), 1)) : createCommentVNode("", true), _ctx.tooltip ? (openBlock(), createElementBlock("div", _hoisted_4$36, toDisplayString(_ctx.tooltip), 1)) : createCommentVNode("", true)]),
		_: 1
	}, 8, ["class", "data-automation"])) : createCommentVNode("", true)], 10, _hoisted_1$93);
}
var EllipsisText_default = /*#__PURE__*/ _plugin_vue_export_helper_default(EllipsisText_vue_vue_type_script_lang_default, [["render", _sfc_render$91], ["__scopeId", "data-v-98660f21"]]);
//#endregion
//#region src/components/Input.vue?vue&type=script&lang.ts
var Input_vue_vue_type_script_lang_default = defineComponent({
	name: "RvInput",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QInput: QInput_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Hint for input autofill feature
		*/
		autocomplete: {
			type: String,
			default: void 0
		},
		/**
		* Focus field on initial component render
		*/
		autofocus: {
			type: Boolean,
			default: false
		},
		/**
		* Focus field on initial component render
		*/
		autogrow: {
			type: Boolean,
			default: false
		},
		/**
		* Enables bottom slots ('error', 'hint', 'counter')
		*/
		bottomSlots: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to the component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Debounce amount (in milliseconds) when updating model
		*/
		debounce: {
			type: [String, Number],
			default: 200
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Forcefully hides the error icon, always.
		*/
		hideErrorIcon: {
			type: Boolean,
			default: false
		},
		/**
		* Helper (hint) text which gets placed below your wrapped form component
		*/
		hint: {
			type: String,
			default: void 0
		},
		/**
		* Render info icon with tooltip. Can be used as an "info-text" property or as a slot
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: "rv-input__info-text"
		},
		/**
		* Classes applied to the input
		* @type {[Array, Object, String]}
		*/
		inputClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* The text that will be shown above the input
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Maximum value for the input
		*/
		max: {
			type: Number,
			default: void 0
		},
		/**
		* Minimum value for the input
		*/
		min: {
			type: Number,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: [Number, String],
			default: void 0
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Text that appears in the form control when it has no value set
		*/
		placeholder: {
			type: String,
			default: void 0
		},
		/**
		* Put component in readonly mode
		*/
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		* Specifies the visible height of a text area
		*/
		rows: {
			type: Number,
			default: 6
		},
		/**
		* Option to show or hide the error
		*/
		showError: {
			type: Boolean,
			default: true
		},
		/**
		* Option to show or hide the error icon. Only applies if showError is false.
		*/
		showErrorIcon: {
			type: Boolean,
			default: false
		},
		/**
		* Option to show or hide the error
		*/
		showErrorMessage: {
			type: Boolean,
			default: true
		},
		/**
		* Show error as a tooltip of the valid icon (if enabled)
		*/
		showErrorAsTooltip: {
			default: false,
			type: Boolean
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Option to show or hide the validation
		*/
		showValid: {
			type: Boolean,
			default: true
		},
		/**
		* The text to be displayed at the end inside the input
		*/
		suffix: {
			type: String,
			default: void 0
		},
		/**
		* Global attribute indicates that its element can be focused, and where it participates in sequential keyboard navigation
		*/
		tabindex: {
			type: String,
			default: void 0
		},
		/**
		* A string specifying the type of control to render
		*/
		type: {
			type: String,
			default: "text"
		},
		/**
		* Validation for the component
		*/
		validation: {
			type: Object,
			default: void 0
		}
	},
	emits: [
		"blur",
		"change",
		"focus",
		"keydown",
		"keypress",
		"keyup",
		"paste",
		"update:modelValue"
	],
	setup(props, { emit }) {
		const slots = useSlots();
		const { t } = useI18n();
		const input = ref(null);
		const errorTooltipRef = ref(null);
		const focused = ref(false);
		const { classRef, error, errorMessage, isValidated, onBlur: onValidationBlur } = useValidation(props);
		const hasValidation = computed(() => props.showValid && isValidated.value && props.modelValue || props.showError && error.value);
		const bottomSlotNames = computed(() => [
			"error",
			"hint",
			"counter"
		].filter((name) => props.bottomSlots && slots[name]));
		const isTextarea = computed(() => props.type === "textarea");
		const maxLength = computed(() => {
			if (!props.validation) return;
			return props.validation.maxLength?.$params.max;
		});
		function blur() {
			input.value?.blur();
		}
		function onBlur(...args) {
			onValidationBlur();
			focused.value = false;
			emit("blur", ...args);
		}
		function onChange(...args) {
			emit("change", ...args);
		}
		function onFocus(...args) {
			emit("focus", ...args);
			focused.value = true;
		}
		function onKeydown(...args) {
			emit("keydown", ...args);
		}
		function onKeypress(...args) {
			emit("keypress", ...args);
		}
		function onKeyup(...args) {
			emit("keyup", ...args);
		}
		function onPaste(...args) {
			emit("paste", ...args);
		}
		function onUpdate(value) {
			emit("update:modelValue", value);
		}
		if (props.showErrorAsTooltip) watch(errorMessage, (value, prevValue) => {
			if (value && value !== prevValue) nextTick(() => {
				errorTooltipRef.value?.show();
			});
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			blur,
			bottomSlotNames,
			classRef,
			error,
			errorMessage,
			errorTooltipRef,
			focused,
			hasValidation,
			input,
			isTextarea,
			isValidated,
			maxLength,
			onBlur,
			onChange,
			onFocus,
			onKeydown,
			onKeypress,
			onKeyup,
			onPaste,
			onUpdate,
			t
		};
	}
});
//#endregion
//#region src/components/Input.vue
var _hoisted_1$92 = ["data-automation"];
var _hoisted_2$74 = { class: "row no-wrap items-center full-width" };
var _hoisted_3$57 = ["data-automation"];
function _sfc_render$90(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QInput = resolveComponent("QInput");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["rv-input", [_ctx.classRef, {
			"rv-input--dense": _ctx.dense,
			"rv-input--disabled": _ctx.disable || _ctx.readonly,
			"rv-input--error": !!((_ctx.showError || _ctx.showErrorIcon) && _ctx.error),
			"rv-input--textarea": _ctx.isTextarea
		}]],
		"data-automation": _ctx.buildId()
	}), [
		_ctx.label ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["rv-input__label flex justify-between items-center", _ctx.labelClass])
		}, [createElementVNode("span", _hoisted_2$74, [
			createVNode(_component_EllipsisText, {
				class: "text-subtitle3",
				"data-automation": _ctx.buildId("label"),
				text: _ctx.label
			}, null, 8, ["data-automation", "text"]),
			_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "q-ml-xs",
				"data-automation": _ctx.buildId("optional")
			}, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_3$57)) : createCommentVNode("", true),
			_ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
				key: 1,
				class: "q-ml-xs info-icon",
				color: "black-1",
				"data-automation": _ctx.buildId("icon-info"),
				name: "info",
				size: "16px"
			}, {
				default: withCtx(() => [createVNode(_component_Tooltip, {
					anchor: "top middle",
					class: normalizeClass(_ctx.infoTextClass),
					"data-automation": _ctx.buildId("tooltip"),
					self: "bottom middle"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
					_: 3
				}, 8, ["class", "data-automation"])]),
				_: 3
			}, 8, ["data-automation"])) : createCommentVNode("", true)
		]), renderSlot(_ctx.$slots, "label-append", {}, void 0, true)], 2)) : createCommentVNode("", true),
		createVNode(_component_QInput, {
			ref: "input",
			autocomplete: _ctx.autocomplete,
			autofocus: _ctx.autofocus,
			autogrow: _ctx.autogrow,
			"bottom-slots": _ctx.bottomSlots,
			debounce: _ctx.debounce,
			dense: "",
			disable: _ctx.disable || _ctx.readonly,
			error: _ctx.showError && _ctx.error,
			"error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
			"hide-bottom-space": "",
			hint: _ctx.hint,
			"input-class": _ctx.inputClass,
			max: _ctx.max,
			min: _ctx.min,
			"model-value": _ctx.modelValue,
			"no-error-icon": "",
			placeholder: _ctx.placeholder,
			rows: _ctx.autogrow ? void 0 : _ctx.rows,
			standout: "",
			suffix: _ctx.suffix,
			tabindex: _ctx.tabindex,
			type: _ctx.type,
			onBlur: _ctx.onBlur,
			onChange: _ctx.onChange,
			onFocus: _ctx.onFocus,
			onKeydown: _ctx.onKeydown,
			onKeypress: _ctx.onKeypress,
			onKeyup: _ctx.onKeyup,
			onPaste: _ctx.onPaste,
			"onUpdate:modelValue": _ctx.onUpdate
		}, createSlots({
			append: withCtx((slotData) => [renderSlot(_ctx.$slots, "append", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)]),
			prepend: withCtx((slotData) => [renderSlot(_ctx.$slots, "prepend", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)]),
			_: 2
		}, [_ctx.showValid && _ctx.isValidated && _ctx.modelValue ? {
			name: "after",
			fn: withCtx(() => [createVNode(_component_QIcon, {
				key: "valid",
				color: "positive",
				"data-automation": _ctx.buildId("icon-valid"),
				name: "mdi-check-circle"
			}, null, 8, ["data-automation"])]),
			key: "0"
		} : !_ctx.hideErrorIcon && (_ctx.showError || _ctx.showErrorIcon) && _ctx.error ? {
			name: "after",
			fn: withCtx(() => [createVNode(_component_QIcon, {
				key: "error",
				color: "negative",
				"data-automation": _ctx.buildId("icon-error"),
				name: "mdi-close-circle"
			}, {
				default: withCtx(() => [_ctx.showErrorAsTooltip ? (openBlock(), createBlock(_component_Tooltip, {
					key: 0,
					ref: "errorTooltipRef",
					anchor: "bottom middle",
					"auto-hide": 3e3,
					class: normalizeClass(_ctx.infoTextClass),
					offset: [0, 4],
					self: "top middle"
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.errorMessage), 1)]),
					_: 1
				}, 8, ["class"])) : createCommentVNode("", true)]),
				_: 1
			}, 8, ["data-automation"])]),
			key: "1"
		} : void 0, renderList(_ctx.bottomSlotNames, (name) => {
			return {
				name,
				fn: withCtx((slotData) => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)])
			};
		})]), 1032, [
			"autocomplete",
			"autofocus",
			"autogrow",
			"bottom-slots",
			"debounce",
			"disable",
			"error",
			"error-message",
			"hint",
			"input-class",
			"max",
			"min",
			"model-value",
			"placeholder",
			"rows",
			"suffix",
			"tabindex",
			"type",
			"onBlur",
			"onChange",
			"onFocus",
			"onKeydown",
			"onKeypress",
			"onKeyup",
			"onPaste",
			"onUpdate:modelValue"
		]),
		renderSlot(_ctx.$slots, "after", {
			focused: _ctx.focused,
			validation: _ctx.validation
		}, void 0, true),
		_ctx.isTextarea && _ctx.maxLength ? (openBlock(), createElementBlock("div", {
			key: 1,
			class: normalizeClass(["rv-input__description text-grey-1", { "rv-input__description--validated": _ctx.hasValidation }])
		}, toDisplayString(_ctx.t("rvai-base.general.inputs.maxCharacters", _ctx.maxLength)), 3)) : createCommentVNode("", true)
	], 16, _hoisted_1$92);
}
var Input_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Input_vue_vue_type_script_lang_default, [["render", _sfc_render$90], ["__scopeId", "data-v-6dec0c3b"]]);
//#endregion
//#region src/composables/useSidebar.ts
function useSidebar() {
	const instance = getCurrentInstance();
	if (!instance) throw new Error("No component");
	const { emit } = instance;
	const { dialogRef, onDialogCancel, onDialogHide, onDialogOK } = useDialogPluginComponent();
	const saving = ref(false);
	function onError() {
		saving.value = false;
	}
	function onSave(data) {
		saving.value = true;
		emit("ok", {
			data,
			onDone: () => {
				if (dialogRef?.value) onDialogCancel();
			},
			onError
		});
	}
	return {
		dialogRef,
		onCancel: onDialogCancel,
		onError,
		onHide: onDialogHide,
		onOK: onDialogOK,
		onSave,
		saving
	};
}
useSidebar.emits = useDialogPluginComponent.emits;
//#endregion
//#region src/components/ConfirmDialog.vue?vue&type=script&lang.ts
var ConfirmDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "ConfirmDialog",
	components: {
		Checkbox: Checkbox_default,
		QIcon: QIcon_default,
		QSpace: QSpace_default,
		RvButton: Button_default,
		RvDialog: Dialog_default,
		RvInput: Input_default
	},
	props: {
		/**
		* Text displayed on the confirmation button
		*/
		actionLabel: {
			type: String,
			default: () => useI18n().t("rvai-base.general.actions.confirm")
		},
		/**
		* When set, the user must type this text (case-insensitive) before the
		* confirm button is enabled.
		*/
		confirmationText: {
			type: String,
			default: void 0
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "confirmDialog"
		},
		/**
		* Display "Don't show again" checkbox
		*/
		withDontShowAgain: {
			type: Boolean,
			default: false
		},
		/**
		* Text displayed on the cancel button
		*/
		cancelLabel: {
			type: String,
			default: () => useI18n().t("rvai-base.general.actions.cancel")
		},
		/**
		* Main text
		*/
		message: {
			type: String,
			required: true
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: () => useI18n().t("rvai-base.general.titles.sure")
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { dialogRef, onOK } = useSidebar();
		const dontShowAgain = ref(false);
		const typedConfirmationText = ref("");
		const isConfirmationTextMatched = computed(() => typedConfirmationText.value.trim().toLowerCase() === (props.confirmationText ?? "").trim().toLowerCase());
		function ok(confirmed) {
			const payload = { confirmed };
			if (props.withDontShowAgain) payload.dontShowAgain = dontShowAgain.value;
			onOK(payload);
		}
		function cancel() {
			ok(false);
		}
		function confirm() {
			if (props.confirmationText && !isConfirmationTextMatched.value) return;
			ok(true);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			cancel,
			confirm,
			dialogRef,
			dontShowAgain,
			isConfirmationTextMatched,
			t,
			typedConfirmationText
		};
	}
});
//#endregion
//#region src/components/ConfirmDialog.vue
var _hoisted_1$91 = ["data-automation"];
var _hoisted_2$73 = ["innerHTML"];
function _sfc_render$89(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_i18n_t = resolveComponent("i18n-t");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_RvDialog = resolveComponent("RvDialog");
	return openBlock(), createBlock(_component_RvDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId()
	}, toHandlers(_ctx.$attrs)), {
		title: withCtx(() => [createVNode(_component_QIcon, {
			color: "grey-2",
			"data-automation": _ctx.buildId("icon-error"),
			name: "error",
			size: "33px"
		}, null, 8, ["data-automation"]), createElementVNode("span", {
			class: "rv-confirm-dialog__title text-subtitle1 text-center q-ml-sm",
			"data-automation": _ctx.buildId("label")
		}, toDisplayString(_ctx.title), 9, _hoisted_1$91)]),
		default: withCtx(() => [
			createElementVNode("div", { innerHTML: _ctx.$sanitize(_ctx.message) }, null, 8, _hoisted_2$73),
			_ctx.confirmationText ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_i18n_t, {
				class: "text-center q-mt-sm q-mb-none",
				keypath: "rvai-base.dialogs.confirmation.typeToConfirm",
				tag: "p"
			}, {
				value: withCtx(() => [createElementVNode("strong", null, toDisplayString(_ctx.confirmationText), 1)]),
				_: 1
			}), createVNode(_component_RvInput, {
				modelValue: _ctx.typedConfirmationText,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.typedConfirmationText = $event),
				autofocus: "",
				class: "q-mt-sm",
				"data-automation": _ctx.buildId("confirmationInput"),
				onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => _ctx.confirm(), ["enter"]))
			}, null, 8, ["modelValue", "data-automation"])], 64)) : createCommentVNode("", true),
			renderSlot(_ctx.$slots, "default", {}, void 0, true)
		]),
		actions: withCtx(() => [
			_ctx.withDontShowAgain ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_Checkbox, {
				modelValue: _ctx.dontShowAgain,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.dontShowAgain = $event),
				"data-automation": _ctx.buildId("dontShowAgain"),
				label: _ctx.t("rvai-base.dialogs.confirmation.dontShowAgain")
			}, null, 8, [
				"modelValue",
				"data-automation",
				"label"
			]), createVNode(_component_QSpace)], 64)) : createCommentVNode("", true),
			createVNode(_component_RvButton, {
				class: "rv-confirm-dialog__cancel-btn",
				"data-automation": _ctx.buildId("cancel"),
				label: _ctx.cancelLabel,
				secondary: "",
				size: "sm",
				onClick: _cache[3] || (_cache[3] = ($event) => _ctx.cancel())
			}, null, 8, ["data-automation", "label"]),
			createVNode(_component_RvButton, {
				class: "rv-confirm-dialog__confirm-btn",
				color: "primary",
				"data-automation": _ctx.buildId("confirm"),
				disable: _ctx.confirmationText ? !_ctx.isConfirmationTextMatched : false,
				label: _ctx.actionLabel,
				size: "sm",
				onClick: _cache[4] || (_cache[4] = ($event) => _ctx.confirm())
			}, null, 8, [
				"data-automation",
				"disable",
				"label"
			])
		]),
		_: 3
	}, 16, ["data-automation"]);
}
var ConfirmDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ConfirmDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$89], ["__scopeId", "data-v-d4d91a48"]]);
//#endregion
//#region src/composables/useConfirmDialog.ts
function useConfirmDialog() {
	const $q = useQuasar();
	const dialog = ref(void 0);
	function onConfirm(params) {
		return new Promise((resolve) => {
			dialog.value = $q.dialog({
				component: ConfirmDialog_default,
				componentProps: params,
				persistent: params.persistent
			}).onOk(({ confirmed, dontShowAgain }) => {
				if ("withDontShowAgain" in params && params.withDontShowAgain) resolve({
					confirmed,
					dontShowAgain
				});
				else resolve(confirmed);
			}).onCancel(() => {
				resolve(void 0);
			});
		});
	}
	return {
		dialog,
		onConfirm
	};
}
//#endregion
//#region src/composables/useCookiesPolicy.ts
var COOKIES_POLICY = "cookiesPolicy";
var cookiesPolicy = ref(Plugin$8.getItem(COOKIES_POLICY) ?? null);
function useCookiesPolicy() {
	const allowOptionalCookies = computed(() => cookiesPolicy.value === CookiesPolicy.All);
	const hasCookiesPolicy = computed(() => !!cookiesPolicy.value);
	function setCookiesPolicy(value) {
		cookiesPolicy.value = value;
		Plugin$8.set(COOKIES_POLICY, value);
	}
	return {
		allowOptionalCookies,
		cookiesPolicy: readonly(cookiesPolicy),
		hasCookiesPolicy,
		setCookiesPolicy
	};
}
//#endregion
//#region ../../../../node_modules/es-errors/type.js
var require_type = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./type')} */
	module.exports = TypeError;
}));
//#endregion
//#region __vite-browser-external
var require___vite_browser_external = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = {};
}));
//#endregion
//#region ../../../../node_modules/object-inspect/index.js
var require_object_inspect = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var hasMap = typeof Map === "function" && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === "function" && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var weakMapHas = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap.prototype.has : null;
	var weakSetHas = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet.prototype.has : null;
	var weakRefDeref = typeof WeakRef === "function" && WeakRef.prototype ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
	var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
		return O.__proto__;
	} : null);
	function addNumericSeparator(num, str) {
		if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) return str;
		var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
		if (typeof num === "number") {
			var int = num < 0 ? -$floor(-num) : $floor(num);
			if (int !== num) {
				var intStr = String(int);
				var dec = $slice.call(str, intStr.length + 1);
				return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
			}
		}
		return $replace.call(str, sepRegex, "$&_");
	}
	var utilInspect = require___vite_browser_external();
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	var quotes = {
		__proto__: null,
		"double": "\"",
		single: "'"
	};
	var quoteREs = {
		__proto__: null,
		"double": /(["\\])/g,
		single: /(['\\])/g
	};
	module.exports = function inspect_(obj, options, depth, seen) {
		var opts = options || {};
		if (has(opts, "quoteStyle") && !has(quotes, opts.quoteStyle)) throw new TypeError("option \"quoteStyle\" must be \"single\" or \"double\"");
		if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError("option \"maxStringLength\", if provided, must be a positive integer, Infinity, or `null`");
		var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
		if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
		if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError("option \"indent\" must be \"\\t\", an integer > 0, or `null`");
		if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError("option \"numericSeparator\", if provided, must be `true` or `false`");
		var numericSeparator = opts.numericSeparator;
		if (typeof obj === "undefined") return "undefined";
		if (obj === null) return "null";
		if (typeof obj === "boolean") return obj ? "true" : "false";
		if (typeof obj === "string") return inspectString(obj, opts);
		if (typeof obj === "number") {
			if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
			var str = String(obj);
			return numericSeparator ? addNumericSeparator(obj, str) : str;
		}
		if (typeof obj === "bigint") {
			var bigIntStr = String(obj) + "n";
			return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
		}
		var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
		if (typeof depth === "undefined") depth = 0;
		if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
		var indent = getIndent(opts, depth);
		if (typeof seen === "undefined") seen = [];
		else if (indexOf(seen, obj) >= 0) return "[Circular]";
		function inspect(value, from, noIndent) {
			if (from) {
				seen = $arrSlice.call(seen);
				seen.push(from);
			}
			if (noIndent) {
				var newOpts = { depth: opts.depth };
				if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
				return inspect_(value, newOpts, depth + 1, seen);
			}
			return inspect_(value, opts, depth + 1, seen);
		}
		if (typeof obj === "function" && !isRegExp(obj)) {
			var name = nameOf(obj);
			var keys = arrObjKeys(obj, inspect);
			return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
		}
		if (isSymbol(obj)) {
			var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
			return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
		}
		if (isElement(obj)) {
			var s = "<" + $toLowerCase.call(String(obj.nodeName));
			var attrs = obj.attributes || [];
			for (var i = 0; i < attrs.length; i++) s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
			s += ">";
			if (obj.childNodes && obj.childNodes.length) s += "...";
			s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
			return s;
		}
		if (isArray(obj)) {
			if (obj.length === 0) return "[]";
			var xs = arrObjKeys(obj, inspect);
			if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
			return "[ " + $join.call(xs, ", ") + " ]";
		}
		if (isError(obj)) {
			var parts = arrObjKeys(obj, inspect);
			if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
			if (parts.length === 0) return "[" + String(obj) + "]";
			return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
		}
		if (typeof obj === "object" && customInspect) {
			if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, { depth: maxDepth - depth });
			else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
		}
		if (isMap(obj)) {
			var mapParts = [];
			if (mapForEach) mapForEach.call(obj, function(value, key) {
				mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
			});
			return collectionOf("Map", mapSize.call(obj), mapParts, indent);
		}
		if (isSet(obj)) {
			var setParts = [];
			if (setForEach) setForEach.call(obj, function(value) {
				setParts.push(inspect(value, obj));
			});
			return collectionOf("Set", setSize.call(obj), setParts, indent);
		}
		if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
		if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
		if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
		if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
		if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
		if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
		if (isString(obj)) return markBoxed(inspect(String(obj)));
		if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
		if (typeof globalThis !== "undefined" && obj === globalThis || typeof global !== "undefined" && obj === global) return "{ [object globalThis] }";
		if (!isDate(obj) && !isRegExp(obj)) {
			var ys = arrObjKeys(obj, inspect);
			var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
			var protoTag = obj instanceof Object ? "" : "null prototype";
			var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
			var tag = (isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "") + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
			if (ys.length === 0) return tag + "{}";
			if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
			return tag + "{ " + $join.call(ys, ", ") + " }";
		}
		return String(obj);
	};
	function wrapQuotes(s, defaultStyle, opts) {
		var quoteChar = quotes[opts.quoteStyle || defaultStyle];
		return quoteChar + s + quoteChar;
	}
	function quote(s) {
		return $replace.call(String(s), /"/g, "&quot;");
	}
	function canTrustToString(obj) {
		return !toStringTag || !(typeof obj === "object" && (toStringTag in obj || typeof obj[toStringTag] !== "undefined"));
	}
	function isArray(obj) {
		return toStr(obj) === "[object Array]" && canTrustToString(obj);
	}
	function isDate(obj) {
		return toStr(obj) === "[object Date]" && canTrustToString(obj);
	}
	function isRegExp(obj) {
		return toStr(obj) === "[object RegExp]" && canTrustToString(obj);
	}
	function isError(obj) {
		return toStr(obj) === "[object Error]" && canTrustToString(obj);
	}
	function isString(obj) {
		return toStr(obj) === "[object String]" && canTrustToString(obj);
	}
	function isNumber(obj) {
		return toStr(obj) === "[object Number]" && canTrustToString(obj);
	}
	function isBoolean(obj) {
		return toStr(obj) === "[object Boolean]" && canTrustToString(obj);
	}
	function isSymbol(obj) {
		if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
		if (typeof obj === "symbol") return true;
		if (!obj || typeof obj !== "object" || !symToString) return false;
		try {
			symToString.call(obj);
			return true;
		} catch (e) {}
		return false;
	}
	function isBigInt(obj) {
		if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
		try {
			bigIntValueOf.call(obj);
			return true;
		} catch (e) {}
		return false;
	}
	var hasOwn = Object.prototype.hasOwnProperty || function(key) {
		return key in this;
	};
	function has(obj, key) {
		return hasOwn.call(obj, key);
	}
	function toStr(obj) {
		return objectToString.call(obj);
	}
	function nameOf(f) {
		if (f.name) return f.name;
		var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
		if (m) return m[1];
		return null;
	}
	function indexOf(xs, x) {
		if (xs.indexOf) return xs.indexOf(x);
		for (var i = 0, l = xs.length; i < l; i++) if (xs[i] === x) return i;
		return -1;
	}
	function isMap(x) {
		if (!mapSize || !x || typeof x !== "object") return false;
		try {
			mapSize.call(x);
			try {
				setSize.call(x);
			} catch (s) {
				return true;
			}
			return x instanceof Map;
		} catch (e) {}
		return false;
	}
	function isWeakMap(x) {
		if (!weakMapHas || !x || typeof x !== "object") return false;
		try {
			weakMapHas.call(x, weakMapHas);
			try {
				weakSetHas.call(x, weakSetHas);
			} catch (s) {
				return true;
			}
			return x instanceof WeakMap;
		} catch (e) {}
		return false;
	}
	function isWeakRef(x) {
		if (!weakRefDeref || !x || typeof x !== "object") return false;
		try {
			weakRefDeref.call(x);
			return true;
		} catch (e) {}
		return false;
	}
	function isSet(x) {
		if (!setSize || !x || typeof x !== "object") return false;
		try {
			setSize.call(x);
			try {
				mapSize.call(x);
			} catch (m) {
				return true;
			}
			return x instanceof Set;
		} catch (e) {}
		return false;
	}
	function isWeakSet(x) {
		if (!weakSetHas || !x || typeof x !== "object") return false;
		try {
			weakSetHas.call(x, weakSetHas);
			try {
				weakMapHas.call(x, weakMapHas);
			} catch (s) {
				return true;
			}
			return x instanceof WeakSet;
		} catch (e) {}
		return false;
	}
	function isElement(x) {
		if (!x || typeof x !== "object") return false;
		if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
		return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
	}
	function inspectString(str, opts) {
		if (str.length > opts.maxStringLength) {
			var remaining = str.length - opts.maxStringLength;
			var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
			return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
		}
		var quoteRE = quoteREs[opts.quoteStyle || "single"];
		quoteRE.lastIndex = 0;
		return wrapQuotes($replace.call($replace.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, lowbyte), "single", opts);
	}
	function lowbyte(c) {
		var n = c.charCodeAt(0);
		var x = {
			8: "b",
			9: "t",
			10: "n",
			12: "f",
			13: "r"
		}[n];
		if (x) return "\\" + x;
		return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
	}
	function markBoxed(str) {
		return "Object(" + str + ")";
	}
	function weakCollectionOf(type) {
		return type + " { ? }";
	}
	function collectionOf(type, size, entries, indent) {
		var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
		return type + " (" + size + ") {" + joinedEntries + "}";
	}
	function singleLineValues(xs) {
		for (var i = 0; i < xs.length; i++) if (indexOf(xs[i], "\n") >= 0) return false;
		return true;
	}
	function getIndent(opts, depth) {
		var baseIndent;
		if (opts.indent === "	") baseIndent = "	";
		else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
		else return null;
		return {
			base: baseIndent,
			prev: $join.call(Array(depth + 1), baseIndent)
		};
	}
	function indentedJoin(xs, indent) {
		if (xs.length === 0) return "";
		var lineJoiner = "\n" + indent.prev + indent.base;
		return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
	}
	function arrObjKeys(obj, inspect) {
		var isArr = isArray(obj);
		var xs = [];
		if (isArr) {
			xs.length = obj.length;
			for (var i = 0; i < obj.length; i++) xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
		}
		var syms = typeof gOPS === "function" ? gOPS(obj) : [];
		var symMap;
		if (hasShammedSymbols) {
			symMap = {};
			for (var k = 0; k < syms.length; k++) symMap["$" + syms[k]] = syms[k];
		}
		for (var key in obj) {
			if (!has(obj, key)) continue;
			if (isArr && String(Number(key)) === key && key < obj.length) continue;
			if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue;
			else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
			else xs.push(key + ": " + inspect(obj[key], obj));
		}
		if (typeof gOPS === "function") {
			for (var j = 0; j < syms.length; j++) if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
		}
		return xs;
	}
}));
//#endregion
//#region ../../../../node_modules/side-channel-list/index.js
var require_side_channel_list = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var inspect = require_object_inspect();
	var $TypeError = require_type();
	/** @type {import('./list.d.ts').listGetNode} */
	var listGetNode = function(list, key, isDelete) {
		/** @type {typeof list | NonNullable<(typeof list)['next']>} */
		var prev = list;
		/** @type {(typeof list)['next']} */
		var curr;
		for (; (curr = prev.next) != null; prev = curr) if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				curr.next = list.next;
				list.next = curr;
			}
			return curr;
		}
	};
	/** @type {import('./list.d.ts').listGet} */
	var listGet = function(objects, key) {
		if (!objects) return;
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	/** @type {import('./list.d.ts').listSet} */
	var listSet = function(objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) node.value = value;
		else objects.next = {
			key,
			next: objects.next,
			value
		};
	};
	/** @type {import('./list.d.ts').listHas} */
	var listHas = function(objects, key) {
		if (!objects) return false;
		return !!listGetNode(objects, key);
	};
	/** @type {import('./list.d.ts').listDelete} */
	var listDelete = function(objects, key) {
		if (objects) return listGetNode(objects, key, true);
	};
	/** @type {import('.')} */
	module.exports = function getSideChannelList() {
		/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
		/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
		/** @type {Channel} */
		var channel = {
			assert: function(key) {
				if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
			},
			"delete": function(key) {
				var deletedNode = listDelete($o, key);
				if (deletedNode && $o && !$o.next) $o = void 0;
				return !!deletedNode;
			},
			get: function(key) {
				return listGet($o, key);
			},
			has: function(key) {
				return listHas($o, key);
			},
			set: function(key, value) {
				if (!$o) $o = { next: void 0 };
				listSet($o, key, value);
			}
		};
		return channel;
	};
}));
//#endregion
//#region ../../../../node_modules/es-object-atoms/index.js
var require_es_object_atoms = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('.')} */
	module.exports = Object;
}));
//#endregion
//#region ../../../../node_modules/es-errors/index.js
var require_es_errors = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('.')} */
	module.exports = Error;
}));
//#endregion
//#region ../../../../node_modules/es-errors/eval.js
var require_eval = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./eval')} */
	module.exports = EvalError;
}));
//#endregion
//#region ../../../../node_modules/es-errors/range.js
var require_range = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./range')} */
	module.exports = RangeError;
}));
//#endregion
//#region ../../../../node_modules/es-errors/ref.js
var require_ref = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./ref')} */
	module.exports = ReferenceError;
}));
//#endregion
//#region ../../../../node_modules/es-errors/syntax.js
var require_syntax = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;
}));
//#endregion
//#region ../../../../node_modules/es-errors/uri.js
var require_uri = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./uri')} */
	module.exports = URIError;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/abs.js
var require_abs = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./abs')} */
	module.exports = Math.abs;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/floor.js
var require_floor = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./floor')} */
	module.exports = Math.floor;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/max.js
var require_max = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./max')} */
	module.exports = Math.max;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/min.js
var require_min = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./min')} */
	module.exports = Math.min;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/pow.js
var require_pow = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./pow')} */
	module.exports = Math.pow;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/round.js
var require_round = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./round')} */
	module.exports = Math.round;
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/isNaN.js
var require_isNaN = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};
}));
//#endregion
//#region ../../../../node_modules/math-intrinsics/sign.js
var require_sign = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var $isNaN = require_isNaN();
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) return number;
		return number < 0 ? -1 : 1;
	};
}));
//#endregion
//#region ../../../../node_modules/gopd/gOPD.js
var require_gOPD = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;
}));
//#endregion
//#region ../../../../node_modules/gopd/index.js
var require_gopd = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('.')} */
	var $gOPD = require_gOPD();
	if ($gOPD) try {
		$gOPD([], "length");
	} catch (e) {
		$gOPD = null;
	}
	module.exports = $gOPD;
}));
//#endregion
//#region ../../../../node_modules/es-define-property/index.js
var require_es_define_property = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) try {
		$defineProperty({}, "a", { value: 1 });
	} catch (e) {
		$defineProperty = false;
	}
	module.exports = $defineProperty;
}));
//#endregion
//#region ../../../../node_modules/has-symbols/shams.js
var require_shams = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./shams')} */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
		if (typeof Symbol.iterator === "symbol") return true;
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol("test");
		var symObj = Object(sym);
		if (typeof sym === "string") return false;
		if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
		if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) return false;
		if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
		if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) return false;
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
		if (typeof Object.getOwnPropertyDescriptor === "function") {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
		}
		return true;
	};
}));
//#endregion
//#region ../../../../node_modules/has-symbols/index.js
var require_has_symbols = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var origSymbol = typeof Symbol !== "undefined" && Symbol;
	var hasSymbolSham = require_shams();
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== "function") return false;
		if (typeof Symbol !== "function") return false;
		if (typeof origSymbol("foo") !== "symbol") return false;
		if (typeof Symbol("bar") !== "symbol") return false;
		return hasSymbolSham();
	};
}));
//#endregion
//#region ../../../../node_modules/get-proto/Reflect.getPrototypeOf.js
var require_Reflect_getPrototypeOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
}));
//#endregion
//#region ../../../../node_modules/get-proto/Object.getPrototypeOf.js
var require_Object_getPrototypeOf = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = require_es_object_atoms().getPrototypeOf || null;
}));
//#endregion
//#region ../../../../node_modules/function-bind/implementation.js
var require_implementation = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = "[object Function]";
	var concatty = function concatty(a, b) {
		var arr = [];
		for (var i = 0; i < a.length; i += 1) arr[i] = a[i];
		for (var j = 0; j < b.length; j += 1) arr[j + a.length] = b[j];
		return arr;
	};
	var slicy = function slicy(arrLike, offset) {
		var arr = [];
		for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) arr[j] = arrLike[i];
		return arr;
	};
	var joiny = function(arr, joiner) {
		var str = "";
		for (var i = 0; i < arr.length; i += 1) {
			str += arr[i];
			if (i + 1 < arr.length) str += joiner;
		}
		return str;
	};
	module.exports = function bind(that) {
		var target = this;
		if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
		var args = slicy(arguments, 1);
		var bound;
		var binder = function() {
			if (this instanceof bound) {
				var result = target.apply(this, concatty(args, arguments));
				if (Object(result) === result) return result;
				return this;
			}
			return target.apply(that, concatty(args, arguments));
		};
		var boundLength = max(0, target.length - args.length);
		var boundArgs = [];
		for (var i = 0; i < boundLength; i++) boundArgs[i] = "$" + i;
		bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
		if (target.prototype) {
			var Empty = function Empty() {};
			Empty.prototype = target.prototype;
			bound.prototype = new Empty();
			Empty.prototype = null;
		}
		return bound;
	};
}));
//#endregion
//#region ../../../../node_modules/function-bind/index.js
var require_function_bind = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var implementation = require_implementation();
	module.exports = Function.prototype.bind || implementation;
}));
//#endregion
//#region ../../../../node_modules/call-bind-apply-helpers/functionCall.js
var require_functionCall = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;
}));
//#endregion
//#region ../../../../node_modules/call-bind-apply-helpers/functionApply.js
var require_functionApply = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;
}));
//#endregion
//#region ../../../../node_modules/call-bind-apply-helpers/reflectApply.js
var require_reflectApply = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
}));
//#endregion
//#region ../../../../node_modules/call-bind-apply-helpers/actualApply.js
var require_actualApply = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var bind = require_function_bind();
	var $apply = require_functionApply();
	var $call = require_functionCall();
	/** @type {import('./actualApply')} */
	module.exports = require_reflectApply() || bind.call($call, $apply);
}));
//#endregion
//#region ../../../../node_modules/call-bind-apply-helpers/index.js
var require_call_bind_apply_helpers = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var bind = require_function_bind();
	var $TypeError = require_type();
	var $call = require_functionCall();
	var $actualApply = require_actualApply();
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== "function") throw new $TypeError("a function is required");
		return $actualApply(bind, $call, args);
	};
}));
//#endregion
//#region ../../../../node_modules/dunder-proto/get.js
var require_get = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var callBind = require_call_bind_apply_helpers();
	var gOPD = require_gopd();
	var hasProtoAccessor;
	try {
		hasProtoAccessor = [].__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") throw e;
	}
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, "__proto__");
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === "function" ? callBind([desc.get]) : typeof $getPrototypeOf === "function" ? function getDunder(value) {
		return $getPrototypeOf(value == null ? value : $Object(value));
	} : false;
}));
//#endregion
//#region ../../../../node_modules/get-proto/index.js
var require_get_proto = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var reflectGetProto = require_Reflect_getPrototypeOf();
	var originalGetProto = require_Object_getPrototypeOf();
	var getDunderProto = require_get();
	/** @type {import('.')} */
	module.exports = reflectGetProto ? function getProto(O) {
		return reflectGetProto(O);
	} : originalGetProto ? function getProto(O) {
		if (!O || typeof O !== "object" && typeof O !== "function") throw new TypeError("getProto: not an object");
		return originalGetProto(O);
	} : getDunderProto ? function getProto(O) {
		return getDunderProto(O);
	} : null;
}));
//#endregion
//#region ../../../../node_modules/hasown/index.js
var require_hasown = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	/** @type {import('.')} */
	module.exports = require_function_bind().call(call, $hasOwn);
}));
//#endregion
//#region ../../../../node_modules/get-intrinsic/index.js
var require_get_intrinsic = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var undefined;
	var $Object = require_es_object_atoms();
	var $Error = require_es_errors();
	var $EvalError = require_eval();
	var $RangeError = require_range();
	var $ReferenceError = require_ref();
	var $SyntaxError = require_syntax();
	var $TypeError = require_type();
	var $URIError = require_uri();
	var abs = require_abs();
	var floor = require_floor();
	var max = require_max();
	var min = require_min();
	var pow = require_pow();
	var round = require_round();
	var sign = require_sign();
	var $Function = Function;
	var getEvalledConstructor = function(expressionSyntax) {
		try {
			return $Function("\"use strict\"; return (" + expressionSyntax + ").constructor;")();
		} catch (e) {}
	};
	var $gOPD = require_gopd();
	var $defineProperty = require_es_define_property();
	var throwTypeError = function() {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD ? function() {
		try {
			arguments.callee;
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				return $gOPD(arguments, "callee").get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}() : throwTypeError;
	var hasSymbols = require_has_symbols()();
	var getProto = require_get_proto();
	var $ObjectGPO = require_Object_getPrototypeOf();
	var $ReflectGPO = require_Reflect_getPrototypeOf();
	var $apply = require_functionApply();
	var $call = require_functionCall();
	var needsEval = {};
	var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
	var INTRINSICS = {
		__proto__: null,
		"%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
		"%Array%": Array,
		"%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
		"%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		"%AsyncFromSyncIteratorPrototype%": undefined,
		"%AsyncFunction%": needsEval,
		"%AsyncGenerator%": needsEval,
		"%AsyncGeneratorFunction%": needsEval,
		"%AsyncIteratorPrototype%": needsEval,
		"%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
		"%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
		"%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
		"%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
		"%Boolean%": Boolean,
		"%DataView%": typeof DataView === "undefined" ? undefined : DataView,
		"%Date%": Date,
		"%decodeURI%": decodeURI,
		"%decodeURIComponent%": decodeURIComponent,
		"%encodeURI%": encodeURI,
		"%encodeURIComponent%": encodeURIComponent,
		"%Error%": $Error,
		"%eval%": eval,
		"%EvalError%": $EvalError,
		"%Float16Array%": typeof Float16Array === "undefined" ? undefined : Float16Array,
		"%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
		"%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
		"%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
		"%Function%": $Function,
		"%GeneratorFunction%": needsEval,
		"%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
		"%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
		"%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
		"%isFinite%": isFinite,
		"%isNaN%": isNaN,
		"%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		"%JSON%": typeof JSON === "object" ? JSON : undefined,
		"%Map%": typeof Map === "undefined" ? undefined : Map,
		"%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
		"%Math%": Math,
		"%Number%": Number,
		"%Object%": $Object,
		"%Object.getOwnPropertyDescriptor%": $gOPD,
		"%parseFloat%": parseFloat,
		"%parseInt%": parseInt,
		"%Promise%": typeof Promise === "undefined" ? undefined : Promise,
		"%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
		"%RangeError%": $RangeError,
		"%ReferenceError%": $ReferenceError,
		"%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
		"%RegExp%": RegExp,
		"%Set%": typeof Set === "undefined" ? undefined : Set,
		"%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
		"%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
		"%String%": String,
		"%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
		"%Symbol%": hasSymbols ? Symbol : undefined,
		"%SyntaxError%": $SyntaxError,
		"%ThrowTypeError%": ThrowTypeError,
		"%TypedArray%": TypedArray,
		"%TypeError%": $TypeError,
		"%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
		"%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
		"%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
		"%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
		"%URIError%": $URIError,
		"%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
		"%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
		"%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet,
		"%Function.prototype.call%": $call,
		"%Function.prototype.apply%": $apply,
		"%Object.defineProperty%": $defineProperty,
		"%Object.getPrototypeOf%": $ObjectGPO,
		"%Math.abs%": abs,
		"%Math.floor%": floor,
		"%Math.max%": max,
		"%Math.min%": min,
		"%Math.pow%": pow,
		"%Math.round%": round,
		"%Math.sign%": sign,
		"%Reflect.getPrototypeOf%": $ReflectGPO
	};
	if (getProto) try {
		null.error;
	} catch (e) {
		INTRINSICS["%Error.prototype%"] = getProto(getProto(e));
	}
	var doEval = function doEval(name) {
		var value;
		if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
		else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
		else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
		else if (name === "%AsyncGenerator%") {
			var fn = doEval("%AsyncGeneratorFunction%");
			if (fn) value = fn.prototype;
		} else if (name === "%AsyncIteratorPrototype%") {
			var gen = doEval("%AsyncGenerator%");
			if (gen && getProto) value = getProto(gen.prototype);
		}
		INTRINSICS[name] = value;
		return value;
	};
	var LEGACY_ALIASES = {
		__proto__: null,
		"%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
		"%ArrayPrototype%": ["Array", "prototype"],
		"%ArrayProto_entries%": [
			"Array",
			"prototype",
			"entries"
		],
		"%ArrayProto_forEach%": [
			"Array",
			"prototype",
			"forEach"
		],
		"%ArrayProto_keys%": [
			"Array",
			"prototype",
			"keys"
		],
		"%ArrayProto_values%": [
			"Array",
			"prototype",
			"values"
		],
		"%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
		"%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
		"%AsyncGeneratorPrototype%": [
			"AsyncGeneratorFunction",
			"prototype",
			"prototype"
		],
		"%BooleanPrototype%": ["Boolean", "prototype"],
		"%DataViewPrototype%": ["DataView", "prototype"],
		"%DatePrototype%": ["Date", "prototype"],
		"%ErrorPrototype%": ["Error", "prototype"],
		"%EvalErrorPrototype%": ["EvalError", "prototype"],
		"%Float32ArrayPrototype%": ["Float32Array", "prototype"],
		"%Float64ArrayPrototype%": ["Float64Array", "prototype"],
		"%FunctionPrototype%": ["Function", "prototype"],
		"%Generator%": ["GeneratorFunction", "prototype"],
		"%GeneratorPrototype%": [
			"GeneratorFunction",
			"prototype",
			"prototype"
		],
		"%Int8ArrayPrototype%": ["Int8Array", "prototype"],
		"%Int16ArrayPrototype%": ["Int16Array", "prototype"],
		"%Int32ArrayPrototype%": ["Int32Array", "prototype"],
		"%JSONParse%": ["JSON", "parse"],
		"%JSONStringify%": ["JSON", "stringify"],
		"%MapPrototype%": ["Map", "prototype"],
		"%NumberPrototype%": ["Number", "prototype"],
		"%ObjectPrototype%": ["Object", "prototype"],
		"%ObjProto_toString%": [
			"Object",
			"prototype",
			"toString"
		],
		"%ObjProto_valueOf%": [
			"Object",
			"prototype",
			"valueOf"
		],
		"%PromisePrototype%": ["Promise", "prototype"],
		"%PromiseProto_then%": [
			"Promise",
			"prototype",
			"then"
		],
		"%Promise_all%": ["Promise", "all"],
		"%Promise_reject%": ["Promise", "reject"],
		"%Promise_resolve%": ["Promise", "resolve"],
		"%RangeErrorPrototype%": ["RangeError", "prototype"],
		"%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
		"%RegExpPrototype%": ["RegExp", "prototype"],
		"%SetPrototype%": ["Set", "prototype"],
		"%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
		"%StringPrototype%": ["String", "prototype"],
		"%SymbolPrototype%": ["Symbol", "prototype"],
		"%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
		"%TypedArrayPrototype%": ["TypedArray", "prototype"],
		"%TypeErrorPrototype%": ["TypeError", "prototype"],
		"%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
		"%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
		"%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
		"%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
		"%URIErrorPrototype%": ["URIError", "prototype"],
		"%WeakMapPrototype%": ["WeakMap", "prototype"],
		"%WeakSetPrototype%": ["WeakSet", "prototype"]
	};
	var bind = require_function_bind();
	var hasOwn = require_hasown();
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g;
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
		else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
		var result = [];
		$replace(string, rePropName, function(match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
		});
		return result;
	};
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = "%" + alias[0] + "%";
		}
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) value = doEval(intrinsicName);
			if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
			return {
				alias,
				name: intrinsicName,
				value
			};
		}
		throw new $SyntaxError("intrinsic " + name + " does not exist!");
	};
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
		if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError("\"allowMissing\" argument must be a boolean");
		if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
		var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if ((first === "\"" || first === "'" || first === "`" || last === "\"" || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
			if (part === "constructor" || !isOwn) skipFurtherCaching = true;
			intrinsicBaseName += "." + part;
			intrinsicRealName = "%" + intrinsicBaseName + "%";
			if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
			else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
					return;
				}
				if ($gOPD && i + 1 >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
					if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
					else value = value[part];
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
				if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
			}
		}
		return value;
	};
}));
//#endregion
//#region ../../../../node_modules/call-bound/index.js
var require_call_bound = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var GetIntrinsic = require_get_intrinsic();
	var callBindBasic = require_call_bind_apply_helpers();
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic("%String.prototype.indexOf%")]);
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBindBasic([intrinsic]);
		return intrinsic;
	};
}));
//#endregion
//#region ../../../../node_modules/side-channel-map/index.js
var require_side_channel_map = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var GetIntrinsic = require_get_intrinsic();
	var callBound = require_call_bound();
	var inspect = require_object_inspect();
	var $TypeError = require_type();
	var $Map = GetIntrinsic("%Map%", true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
	var $mapGet = callBound("Map.prototype.get", true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
	var $mapSet = callBound("Map.prototype.set", true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapHas = callBound("Map.prototype.has", true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapDelete = callBound("Map.prototype.delete", true);
	/** @type {<K, V>(thisArg: Map<K, V>) => number} */
	var $mapSize = callBound("Map.prototype.size", true);
	/** @type {import('.')} */
	module.exports = !!$Map && function getSideChannelMap() {
		/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
		/** @type {Map<K, V> | undefined} */ var $m;
		/** @type {Channel} */
		var channel = {
			assert: function(key) {
				if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
			},
			"delete": function(key) {
				if ($m) {
					var result = $mapDelete($m, key);
					if ($mapSize($m) === 0) $m = void 0;
					return result;
				}
				return false;
			},
			get: function(key) {
				if ($m) return $mapGet($m, key);
			},
			has: function(key) {
				if ($m) return $mapHas($m, key);
				return false;
			},
			set: function(key, value) {
				if (!$m) $m = new $Map();
				$mapSet($m, key, value);
			}
		};
		return channel;
	};
}));
//#endregion
//#region ../../../../node_modules/side-channel-weakmap/index.js
var require_side_channel_weakmap = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var GetIntrinsic = require_get_intrinsic();
	var callBound = require_call_bound();
	var inspect = require_object_inspect();
	var getSideChannelMap = require_side_channel_map();
	var $TypeError = require_type();
	var $WeakMap = GetIntrinsic("%WeakMap%", true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
	var $weakMapGet = callBound("WeakMap.prototype.get", true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
	var $weakMapSet = callBound("WeakMap.prototype.set", true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapHas = callBound("WeakMap.prototype.has", true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapDelete = callBound("WeakMap.prototype.delete", true);
	/** @type {import('.')} */
	module.exports = $WeakMap ? function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;
		/** @type {Channel} */
		var channel = {
			assert: function(key) {
				if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
			},
			"delete": function(key) {
				if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
					if ($wm) return $weakMapDelete($wm, key);
				} else if (getSideChannelMap) {
					if ($m) return $m["delete"](key);
				}
				return false;
			},
			get: function(key) {
				if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
					if ($wm) return $weakMapGet($wm, key);
				}
				return $m && $m.get(key);
			},
			has: function(key) {
				if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
					if ($wm) return $weakMapHas($wm, key);
				}
				return !!$m && $m.has(key);
			},
			set: function(key, value) {
				if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
					if (!$wm) $wm = new $WeakMap();
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) $m = getSideChannelMap();
					/** @type {NonNullable<typeof $m>} */ $m.set(key, value);
				}
			}
		};
		return channel;
	} : getSideChannelMap;
}));
//#endregion
//#region ../../../../node_modules/side-channel/index.js
var require_side_channel = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var $TypeError = require_type();
	var inspect = require_object_inspect();
	var getSideChannelList = require_side_channel_list();
	var getSideChannelMap = require_side_channel_map();
	var makeChannel = require_side_channel_weakmap() || getSideChannelMap || getSideChannelList;
	/** @type {import('.')} */
	module.exports = function getSideChannel() {
		/** @typedef {ReturnType<typeof getSideChannel>} Channel */
		/** @type {Channel | undefined} */ var $channelData;
		/** @type {Channel} */
		var channel = {
			assert: function(key) {
				if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + (key && Object(key) === key ? "the given object key" : inspect(key)));
			},
			"delete": function(key) {
				return !!$channelData && $channelData["delete"](key);
			},
			get: function(key) {
				return $channelData && $channelData.get(key);
			},
			has: function(key) {
				return !!$channelData && $channelData.has(key);
			},
			set: function(key, value) {
				if (!$channelData) $channelData = makeChannel();
				$channelData.set(key, value);
			}
		};
		return channel;
	};
}));
//#endregion
//#region ../../../../node_modules/qs/lib/formats.js
var require_formats = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	var Format = {
		RFC1738: "RFC1738",
		RFC3986: "RFC3986"
	};
	module.exports = {
		"default": Format.RFC3986,
		formatters: {
			RFC1738: function(value) {
				return replace.call(value, percentTwenties, "+");
			},
			RFC3986: function(value) {
				return String(value);
			}
		},
		RFC1738: Format.RFC1738,
		RFC3986: Format.RFC3986
	};
}));
//#endregion
//#region ../../../../node_modules/qs/lib/utils.js
var require_utils = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var formats = require_formats();
	var getSideChannel = require_side_channel();
	var defineProperty = require_es_define_property();
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	var overflowChannel = getSideChannel();
	var markOverflow = function markOverflow(obj, maxIndex) {
		overflowChannel.set(obj, maxIndex);
		return obj;
	};
	var isOverflow = function isOverflow(obj) {
		return overflowChannel.has(obj);
	};
	var getMaxIndex = function getMaxIndex(obj) {
		return overflowChannel.get(obj);
	};
	var setMaxIndex = function setMaxIndex(obj, maxIndex) {
		overflowChannel.set(obj, maxIndex);
	};
	var hexTable = function() {
		var array = [];
		for (var i = 0; i < 256; ++i) array[array.length] = "%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase();
		return array;
	}();
	var compactQueue = function compactQueue(queue) {
		while (queue.length > 1) {
			var item = queue.pop();
			var obj = item.obj[item.prop];
			if (isArray(obj)) {
				var compacted = [];
				for (var j = 0; j < obj.length; ++j) if (typeof obj[j] !== "undefined") compacted[compacted.length] = obj[j];
				item.obj[item.prop] = compacted;
			}
		}
	};
	var arrayToObject = function arrayToObject(source, options) {
		var obj = options && options.plainObjects ? { __proto__: null } : {};
		for (var i = 0; i < source.length; ++i) if (typeof source[i] !== "undefined") obj[i] = source[i];
		return obj;
	};
	var setProperty = function setProperty(obj, key, value) {
		if (key === "__proto__" && defineProperty) defineProperty(obj, key, {
			configurable: true,
			enumerable: true,
			value,
			writable: true
		});
		else obj[key] = value;
	};
	var merge = function merge(target, source, options) {
		if (!source) return target;
		if (typeof source !== "object" && typeof source !== "function") {
			if (isArray(target)) {
				var nextIndex = target.length;
				if (options && typeof options.arrayLimit === "number" && nextIndex >= options.arrayLimit) {
					if (options.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
					return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
				}
				target[nextIndex] = source;
			} else if (target && typeof target === "object") {
				if (isOverflow(target)) {
					var newIndex = getMaxIndex(target) + 1;
					target[newIndex] = source;
					setMaxIndex(target, newIndex);
				} else if (options && options.strictMerge) return [target, source];
				else if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
			} else return [target, source];
			return target;
		}
		if (!target || typeof target !== "object") {
			if (isOverflow(source)) {
				var sourceKeys = Object.keys(source);
				var result = options && options.plainObjects ? {
					__proto__: null,
					0: target
				} : { 0: target };
				for (var m = 0; m < sourceKeys.length; m++) {
					var oldKey = parseInt(sourceKeys[m], 10);
					result[oldKey + 1] = source[sourceKeys[m]];
				}
				return markOverflow(result, getMaxIndex(source) + 1);
			}
			var combined = [target].concat(source);
			if (options && typeof options.arrayLimit === "number" && combined.length > options.arrayLimit) {
				if (options.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				return markOverflow(arrayToObject(combined, options), combined.length - 1);
			}
			return combined;
		}
		var mergeTarget = target;
		if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
		if (isArray(target) && isArray(source)) {
			source.forEach(function(item, i) {
				if (has.call(target, i)) {
					var targetItem = target[i];
					if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
					else target[target.length] = item;
				} else target[i] = item;
			});
			if (options && typeof options.arrayLimit === "number" && target.length > options.arrayLimit) {
				if (options.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				return markOverflow(arrayToObject(target, options), target.length - 1);
			}
			return target;
		}
		return Object.keys(source).reduce(function(acc, key) {
			var value = source[key];
			if (has.call(acc, key)) setProperty(acc, key, merge(acc[key], value, options));
			else setProperty(acc, key, value);
			if (isOverflow(source) && !isOverflow(acc)) markOverflow(acc, getMaxIndex(source));
			if (isOverflow(acc)) {
				var keyNum = parseInt(key, 10);
				if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) setMaxIndex(acc, keyNum);
			}
			return acc;
		}, mergeTarget);
	};
	var assign = function assignSingleSource(target, source) {
		return Object.keys(source).reduce(function(acc, key) {
			setProperty(acc, key, source[key]);
			return acc;
		}, target);
	};
	var decode = function(str, defaultDecoder, charset) {
		var strWithoutPlus = str.replace(/\+/g, " ");
		if (charset === "iso-8859-1") return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
		try {
			return decodeURIComponent(strWithoutPlus);
		} catch (e) {
			return strWithoutPlus;
		}
	};
	var limit = 1024;
	module.exports = {
		arrayToObject,
		assign,
		combine: function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
			if (isOverflow(a)) {
				if (throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + arrayLimit + " element" + (arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				var bValues = isArray(b) ? b : [b];
				var newIndex = getMaxIndex(a);
				for (var i = 0; i < bValues.length; ++i) {
					newIndex += 1;
					a[newIndex] = bValues[i];
				}
				setMaxIndex(a, newIndex);
				return a;
			}
			var result = [].concat(a, b);
			if (result.length > arrayLimit) {
				if (throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + arrayLimit + " element" + (arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				return markOverflow(arrayToObject(result, { plainObjects }), result.length - 1);
			}
			return result;
		},
		compact: function compact(value) {
			var queue = [{
				obj: { o: value },
				prop: "o"
			}];
			var refs = getSideChannel();
			for (var i = 0; i < queue.length; ++i) {
				var item = queue[i];
				var obj = item.obj[item.prop];
				var keys = Object.keys(obj);
				for (var j = 0; j < keys.length; ++j) {
					var key = keys[j];
					var val = obj[key];
					if (typeof val === "object" && val !== null && !refs.has(val)) {
						queue[queue.length] = {
							obj,
							prop: key
						};
						refs.set(val, true);
					}
				}
			}
			compactQueue(queue);
			return value;
		},
		decode,
		encode: function encode(str, defaultEncoder, charset, kind, format) {
			if (str.length === 0) return str;
			var string = str;
			if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
			else if (typeof str !== "string") string = String(str);
			if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
				return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
			});
			var out = "";
			for (var j = 0; j < string.length; j += limit) {
				var segment = string.length >= limit ? string.slice(j, j + limit) : string;
				if (j + limit < string.length) {
					var last = segment.charCodeAt(segment.length - 1);
					if (last >= 55296 && last <= 56319) {
						segment = segment.slice(0, -1);
						j -= 1;
					}
				}
				var arr = [];
				for (var i = 0; i < segment.length; ++i) {
					var c = segment.charCodeAt(i);
					if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (c === 40 || c === 41)) {
						arr[arr.length] = segment.charAt(i);
						continue;
					}
					if (c < 128) {
						arr[arr.length] = hexTable[c];
						continue;
					}
					if (c < 2048) {
						arr[arr.length] = hexTable[192 | c >> 6] + hexTable[128 | c & 63];
						continue;
					}
					if (c < 55296 || c >= 57344) {
						arr[arr.length] = hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
						continue;
					}
					i += 1;
					c = 65536 + ((c & 1023) << 10 | segment.charCodeAt(i) & 1023);
					arr[arr.length] = hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
				}
				out += arr.join("");
			}
			return out;
		},
		isBuffer: function isBuffer(obj) {
			if (!obj || typeof obj !== "object") return false;
			return !!(obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj));
		},
		isOverflow,
		isRegExp: function isRegExp(obj) {
			return Object.prototype.toString.call(obj) === "[object RegExp]";
		},
		markOverflow,
		maybeMap: function maybeMap(val, fn) {
			if (isArray(val)) {
				var mapped = [];
				for (var i = 0; i < val.length; i += 1) mapped[mapped.length] = fn(val[i]);
				return mapped;
			}
			return fn(val);
		},
		merge
	};
}));
//#endregion
//#region ../../../../node_modules/qs/lib/stringify.js
var require_stringify = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getSideChannel = require_side_channel();
	var utils = require_utils();
	var formats = require_formats();
	var has = Object.prototype.hasOwnProperty;
	var arrayPrefixGenerators = {
		brackets: function brackets(prefix) {
			return prefix + "[]";
		},
		comma: "comma",
		indices: function indices(prefix, key) {
			return prefix + "[" + key + "]";
		},
		repeat: function repeat(prefix) {
			return prefix;
		}
	};
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function(arr, valueOrArray) {
		push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	var toISO = Date.prototype.toISOString;
	var defaultFormat = formats["default"];
	var defaults = {
		addQueryPrefix: false,
		allowDots: false,
		allowEmptyArrays: false,
		arrayFormat: "indices",
		charset: "utf-8",
		charsetSentinel: false,
		commaRoundTrip: false,
		delimiter: "&",
		depth: Infinity,
		encode: true,
		encodeDotInKeys: false,
		encoder: utils.encode,
		encodeValuesOnly: false,
		filter: void 0,
		format: defaultFormat,
		formatter: formats.formatters[defaultFormat],
		indices: false,
		serializeDate: function serializeDate(date) {
			return toISO.call(date);
		},
		skipNulls: false,
		strictNullHandling: false
	};
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
		return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
	};
	var sentinel = {};
	var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
		var obj = object;
		if (currentDepth > depth) throw new RangeError("Input depth exceeded depth option of " + depth);
		var tmpSc = sideChannel;
		var step = 0;
		var findFlag = false;
		while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
			var pos = tmpSc.get(object);
			step += 1;
			if (typeof pos !== "undefined") if (pos === step) throw new RangeError("Cyclic object value");
			else findFlag = true;
			if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
		}
		obj = typeof filter === "function" ? filter(prefix, obj) : obj;
		if (obj instanceof Date) obj = serializeDate(obj);
		else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
			if (value instanceof Date) return serializeDate(value);
			return value;
		});
		if (obj === null) {
			if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix);
			obj = "";
		}
		if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
			if (encoder) return [formatter(encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format)) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))];
			return [formatter(prefix) + "=" + formatter(String(obj))];
		}
		var values = [];
		if (typeof obj === "undefined") return values;
		var objKeys;
		if (generateArrayPrefix === "comma" && isArray(obj)) {
			if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, function(v) {
				return v == null ? v : encoder(v);
			});
			objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
		} else if (isArray(filter)) objKeys = filter;
		else {
			var keys = Object.keys(obj);
			objKeys = sort ? keys.sort(sort) : keys;
		}
		var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, "%2E") : String(prefix);
		var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
		if (allowEmptyArrays && isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return adjustedPrefix + "[]";
		for (var j = 0; j < objKeys.length; ++j) {
			var key = objKeys[j];
			var value = typeof key === "object" && key && typeof key.value !== "undefined" ? key.value : obj[key];
			if (skipNulls && value === null) continue;
			var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, "%2E") : String(key);
			var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
			sideChannel.set(object, step);
			var valueSideChannel = getSideChannel();
			valueSideChannel.set(sentinel, sideChannel);
			pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
		}
		return values;
	};
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
		if (!opts) return defaults;
		if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
		if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
		if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
		var charset = opts.charset || defaults.charset;
		if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
		var format = formats["default"];
		if (typeof opts.format !== "undefined") {
			if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
			format = opts.format;
		}
		var formatter = formats.formatters[format];
		var filter = defaults.filter;
		if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
		var arrayFormat;
		if (opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
		else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
		else arrayFormat = defaults.arrayFormat;
		if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
		var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
		return {
			addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
			allowDots,
			allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
			arrayFormat,
			charset,
			charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
			commaRoundTrip: !!opts.commaRoundTrip,
			delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
			depth: typeof opts.depth === "number" ? opts.depth : defaults.depth,
			encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
			encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
			encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
			encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
			filter,
			format,
			formatter,
			serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
			skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
			sort: typeof opts.sort === "function" ? opts.sort : null,
			strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
		};
	};
	module.exports = function(object, opts) {
		var obj = object;
		var options = normalizeStringifyOptions(opts);
		var objKeys;
		var filter;
		if (typeof options.filter === "function") {
			filter = options.filter;
			obj = filter("", obj);
		} else if (isArray(options.filter)) {
			filter = options.filter;
			objKeys = filter;
		}
		var keys = [];
		if (typeof obj !== "object" || obj === null) return "";
		var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
		var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
		if (!objKeys) objKeys = Object.keys(obj);
		if (options.sort) objKeys.sort(options.sort);
		var sideChannel = getSideChannel();
		for (var i = 0; i < objKeys.length; ++i) {
			var key = objKeys[i];
			if (typeof key === "undefined" || key === null) continue;
			var value = obj[key];
			if (options.skipNulls && value === null) continue;
			pushToArray(keys, stringify(value, options.encodeDotInKeys ? String(key).replace(/\./g, "%2E") : String(key), generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
		}
		var joined = keys.join(options.delimiter);
		var prefix = options.addQueryPrefix === true ? "?" : "";
		if (options.charsetSentinel) if (options.charset === "iso-8859-1") prefix += "utf8=%26%2310003%3B" + options.delimiter;
		else prefix += "utf8=%E2%9C%93" + options.delimiter;
		return joined.length > 0 ? prefix + joined : "";
	};
}));
//#endregion
//#region ../../../../node_modules/qs/lib/parse.js
var require_parse = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var utils = require_utils();
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	var defaults = {
		allowDots: false,
		allowEmptyArrays: false,
		allowPrototypes: false,
		allowSparse: false,
		arrayLimit: 20,
		charset: "utf-8",
		charsetSentinel: false,
		comma: false,
		decodeDotInKeys: false,
		decoder: utils.decode,
		delimiter: "&",
		depth: 5,
		duplicates: "combine",
		ignoreQueryPrefix: false,
		interpretNumericEntities: false,
		parameterLimit: 1e3,
		parseArrays: true,
		plainObjects: false,
		strictDepth: false,
		strictMerge: true,
		strictNullHandling: false,
		throwOnLimitExceeded: false
	};
	var interpretNumericEntities = function(str) {
		return str.replace(/&#(\d+);/g, function($0, numberStr) {
			return String.fromCharCode(parseInt(numberStr, 10));
		});
	};
	var parseArrayValue = function(val, options, currentArrayLength) {
		if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
			if (options.throwOnLimitExceeded) {
				var commaCount = 0;
				var commaIndex = val.indexOf(",");
				while (commaIndex > -1) {
					commaCount += 1;
					if (commaCount >= options.arrayLimit) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
					commaIndex = val.indexOf(",", commaIndex + 1);
				}
			}
			return val.split(",");
		}
		if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
		return val;
	};
	var isoSentinel = "utf8=%26%2310003%3B";
	var charsetSentinel = "utf8=%E2%9C%93";
	var parseValues = function parseQueryStringValues(str, options) {
		var obj = { __proto__: null };
		var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
		cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
		var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
		var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== "undefined" ? limit + 1 : limit);
		if (options.throwOnLimitExceeded && typeof limit !== "undefined" && parts.length > limit) throw new RangeError("Parameter limit exceeded. Only " + limit + " parameter" + (limit === 1 ? "" : "s") + " allowed.");
		var skipIndex = -1;
		var i;
		var charset = options.charset;
		if (options.charsetSentinel) {
			for (i = 0; i < parts.length; ++i) if (parts[i].indexOf("utf8=") === 0) {
				if (parts[i] === charsetSentinel) charset = "utf-8";
				else if (parts[i] === isoSentinel) charset = "iso-8859-1";
				skipIndex = i;
				i = parts.length;
			}
		}
		for (i = 0; i < parts.length; ++i) {
			if (i === skipIndex) continue;
			var part = parts[i];
			var bracketEqualsPos = part.indexOf("]=");
			var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
			var key;
			var val;
			if (pos === -1) {
				key = options.decoder(part, defaults.decoder, charset, "key");
				val = options.strictNullHandling ? null : "";
			} else {
				key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
				if (key !== null) val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options, isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
					return options.decoder(encodedVal, defaults.decoder, charset, "value");
				});
			}
			if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(String(val));
			if (part.indexOf("[]=") > -1) val = isArray(val) ? [val] : val;
			if (options.comma && isArray(val) && val.length > options.arrayLimit) val = utils.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
			if (key !== null) {
				var existing = has.call(obj, key);
				if (existing && (options.duplicates === "combine" || part.indexOf("[]=") > -1)) obj[key] = utils.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
				else if (!existing || options.duplicates === "last") obj[key] = val;
			}
		}
		return obj;
	};
	var parseObject = function(chain, val, options, valuesParsed) {
		var currentArrayLength = 0;
		if (chain.length > 0 && chain[chain.length - 1] === "[]") {
			var parentKey = chain.slice(0, -1).join("");
			currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
		}
		var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);
		for (var i = chain.length - 1; i >= 0; --i) {
			var obj;
			var root = chain[i];
			if (root === "[]" && options.parseArrays) if (utils.isOverflow(leaf)) obj = leaf;
			else obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : utils.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
			else {
				obj = options.plainObjects ? { __proto__: null } : {};
				var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
				var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
				var index = parseInt(decodedRoot, 10);
				var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
				if (!options.parseArrays && decodedRoot === "") obj = { 0: leaf };
				else if (isValidArrayIndex && index < options.arrayLimit) {
					obj = [];
					obj[index] = leaf;
				} else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				else if (isValidArrayIndex) {
					obj[index] = leaf;
					utils.markOverflow(obj, index);
				} else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
			}
			leaf = obj;
		}
		return leaf;
	};
	var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
		var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, "[$1]") : originalKey;
		if (options.depth <= 0) {
			if (!options.plainObjects && has.call(Object.prototype, key)) {
				if (!options.allowPrototypes) return;
			}
			return [key];
		}
		var segments = [];
		var first = key.indexOf("[");
		var parent = first >= 0 ? key.slice(0, first) : key;
		if (parent) {
			if (!options.plainObjects && has.call(Object.prototype, parent)) {
				if (!options.allowPrototypes) return;
			}
			segments[segments.length] = parent;
		}
		var n = key.length;
		var open = first;
		var collected = 0;
		while (open >= 0 && collected < options.depth) {
			var level = 1;
			var i = open + 1;
			var close = -1;
			while (i < n && close < 0) {
				var cu = key.charCodeAt(i);
				if (cu === 91) level += 1;
				else if (cu === 93) {
					level -= 1;
					if (level === 0) close = i;
				}
				i += 1;
			}
			if (close < 0) {
				segments[segments.length] = "[" + key.slice(open) + "]";
				return segments;
			}
			var seg = key.slice(open, close + 1);
			var content = seg.slice(1, -1);
			if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) return;
			segments[segments.length] = seg;
			collected += 1;
			open = key.indexOf("[", close + 1);
		}
		if (open >= 0) {
			if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
			segments[segments.length] = "[" + key.slice(open) + "]";
		}
		return segments;
	};
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
		if (!givenKey) return;
		var keys = splitKeyIntoSegments(givenKey, options);
		if (!keys) return;
		return parseObject(keys, val, options, valuesParsed);
	};
	var normalizeParseOptions = function normalizeParseOptions(opts) {
		if (!opts) return defaults;
		if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
		if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
		if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
		if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
		if (typeof opts.throwOnLimitExceeded !== "undefined" && typeof opts.throwOnLimitExceeded !== "boolean") throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
		var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
		var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
		if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
		return {
			allowDots: typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots,
			allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
			allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
			allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
			arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
			charset,
			charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
			comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
			decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
			decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
			delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
			depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
			duplicates,
			ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
			interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
			parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
			parseArrays: opts.parseArrays !== false,
			plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
			strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : defaults.strictDepth,
			strictMerge: typeof opts.strictMerge === "boolean" ? !!opts.strictMerge : defaults.strictMerge,
			strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling,
			throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === "boolean" ? opts.throwOnLimitExceeded : false
		};
	};
	module.exports = function(str, opts) {
		var options = normalizeParseOptions(opts);
		if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? { __proto__: null } : {};
		var tempObj = typeof str === "string" ? parseValues(str, options) : str;
		var obj = options.plainObjects ? { __proto__: null } : {};
		var keys = Object.keys(tempObj);
		for (var i = 0; i < keys.length; ++i) {
			var key = keys[i];
			var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
			obj = utils.merge(obj, newObj, options);
		}
		if (options.allowSparse === true) return obj;
		return utils.compact(obj);
	};
}));
//#endregion
//#region src/composables/useQueryParams.ts
var import_lib = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var stringify = require_stringify();
	var parse = require_parse();
	module.exports = {
		formats: require_formats(),
		parse,
		stringify
	};
})))());
function useQueryParams() {
	const route = useRoute();
	const router = useRouter();
	const queryParams = computed(() => route.query);
	function parseQuery(v, options) {
		return import_lib.default.parse(v, {
			arrayLimit: 100,
			...options
		});
	}
	function setQuery(v) {
		const newQueries = { ...queryParams.value };
		Object.entries(v).forEach(([key, value]) => {
			if (value == null || value === "") delete newQueries[key];
			else newQueries[key] = stringifyQuery(value);
		});
		router.replace({ query: newQueries });
	}
	function stringifyQuery(v) {
		return typeof v === "string" || typeof v === "number" || typeof v === "boolean" ? v.toString() : import_lib.default.stringify(v, { encode: false });
	}
	return {
		parseQuery,
		queryParams,
		setQuery,
		stringifyQuery
	};
}
//#endregion
//#region src/composables/useFieldsVisibility.ts
var FieldsVisibility = Symbol("Fields visibility dependency");
var HIDDEN_FIELDS_QUERY = "hiddenFields";
function buildFieldsVisibility(config) {
	const $q = useQuasar();
	const { parseQuery, queryParams, setQuery } = useQueryParams();
	const hiddenFields = computed(() => {
		return Object.values(parseQuery(queryParams.value[HIDDEN_FIELDS_QUERY] ?? ""));
	});
	const fields = ref(buildObject(config, (v) => v.key, (v) => FieldVisibility.fromQueryParams(v, hiddenFields.value)));
	function isVisible(section, key) {
		const sectionField = fields.value[section];
		if (!sectionField) return false;
		return key ? sectionField.isFieldVisible(key) : sectionField.visible;
	}
	function onOpenFieldsDialog() {
		$q.dialog({
			component: FieldsVisibilityDialog_default,
			componentProps: { fields: fields.value }
		}).onOk((data) => {
			fields.value = data;
			setQuery({ [HIDDEN_FIELDS_QUERY]: Object.values(data).flatMap((v) => v.serialize()) });
		});
	}
	function setFields(data) {
		fields.value = buildObject(data, (v) => v.key, (v) => FieldVisibility.fromQueryParams(v, hiddenFields.value));
	}
	return {
		fields,
		isVisible,
		onOpenFieldsDialog,
		setFields
	};
}
function provideFieldsVisibility(config) {
	const composable = buildFieldsVisibility(config);
	provide(FieldsVisibility, composable);
	return composable;
}
function useFieldsVisibility() {
	const composable = inject(FieldsVisibility, void 0);
	if (!composable) throw new Error("Fields visibility was not registered. Make sure you used 'provideFieldsVisibility'");
	return composable;
}
//#endregion
//#region src/components/InfoDialog.vue?vue&type=script&lang.ts
var InfoDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "InfoDialog",
	components: {
		QIcon: QIcon_default,
		RvButton: Button_default,
		RvDialog: Dialog_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "infoDialog"
		},
		/**
		* Text displayed on the confirmation button
		*/
		actionLabel: {
			type: String,
			default: () => useI18n().t("rvai-base.general.actions.ok")
		},
		/**
		* Flag to hide close button
		*/
		hasCloseButton: {
			type: Boolean,
			default: true
		},
		/**
		* Main text
		*/
		message: {
			type: String,
			required: true
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		const { dialogRef, onOK } = useSidebar();
		function confirm() {
			onOK(true);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			confirm,
			dialogRef
		};
	}
});
//#endregion
//#region src/components/InfoDialog.vue
var _hoisted_1$90 = ["data-automation"];
var _hoisted_2$72 = ["innerHTML"];
function _sfc_render$88(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_RvDialog = resolveComponent("RvDialog");
	return openBlock(), createBlock(_component_RvDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId(),
		"hide-close-button": !_ctx.hasCloseButton
	}, toHandlers(_ctx.$attrs)), createSlots({
		default: withCtx(() => [createElementVNode("div", { class: normalizeClass(["row no-wrap items-start q-pb-none", _ctx.title ? "justify-start" : "justify-center"]) }, [!_ctx.title ? (openBlock(), createBlock(_component_QIcon, {
			key: 0,
			color: "grey-2",
			"data-automation": _ctx.buildId("icon-error"),
			name: "error",
			size: "32px"
		}, null, 8, ["data-automation"])) : createCommentVNode("", true), createElementVNode("div", {
			class: "rv-info-dialog__context flex items-center q-ml-sm",
			innerHTML: _ctx.$sanitize(_ctx.message)
		}, null, 8, _hoisted_2$72)], 2)]),
		actions: withCtx(() => [createVNode(_component_RvButton, {
			color: "primary",
			"data-automation": _ctx.buildId("confirm"),
			label: _ctx.actionLabel,
			size: "sm",
			onClick: _cache[0] || (_cache[0] = ($event) => _ctx.confirm())
		}, null, 8, ["data-automation", "label"])]),
		_: 2
	}, [_ctx.title ? {
		name: "title",
		fn: withCtx(() => [createVNode(_component_QIcon, {
			color: "grey-2",
			"data-automation": _ctx.buildId("icon-error"),
			name: "error",
			size: "33px"
		}, null, 8, ["data-automation"]), createElementVNode("span", {
			class: "rv-info-dialog__title text-subtitle1 text-center q-ml-sm",
			"data-automation": _ctx.buildId("title")
		}, toDisplayString(_ctx.title), 9, _hoisted_1$90)]),
		key: "0"
	} : void 0]), 1040, ["data-automation", "hide-close-button"]);
}
var InfoDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InfoDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$88], ["__scopeId", "data-v-39e37d2f"]]);
//#endregion
//#region src/composables/useInfoDialog.ts
function useInfoDialog() {
	const $q = useQuasar();
	function onConfirm(params) {
		return new Promise((resolve) => {
			$q.dialog({
				component: InfoDialog_default,
				componentProps: params,
				persistent: params.persistent
			}).onOk((confirmed) => {
				resolve(confirmed);
			});
		});
	}
	return { onConfirm };
}
//#endregion
//#region src/composables/useLayout.ts
var LS_LAYOUT = "LS_LAYOUT";
function buildLayoutStore(allowOptionalCookies, defaultLayout = Layout.Default) {
	const { navigation } = useOptionsReadOnly();
	const route = useRoute();
	const loaded = Plugin$8.getItem(LS_LAYOUT) || {};
	const availableLayouts = ref([]);
	const collapsedNavigationbar = ref(loaded.collapsedNavigationbar ?? false);
	const collapsedNavigationbarAfterAnimation = ref(loaded.collapsedNavigationbar ?? false);
	const hasRightContent = ref(true);
	const layout = ref(loaded.layout ?? defaultLayout);
	const savedLayouts = ref(/* @__PURE__ */ new Map());
	const showOverlay = ref(false);
	const smallScreen = ref(false);
	const isSidebarAnimationInprogress = ref(false);
	const isDefaultLayout = computed(() => layout.value === Layout.Default);
	const isFullLayout = computed(() => layout.value === Layout.Full);
	const isLeftOnlyLayout = computed(() => layout.value === Layout.LeftOnly);
	const isRightOnlyLayout = computed(() => layout.value === Layout.RightOnly);
	const isSplitLayout = computed(() => layout.value === Layout.Split);
	const showLeftSidebar = computed(() => {
		return isDefaultLayout.value || isLeftOnlyLayout.value || isSplitLayout.value;
	});
	const showRightSidebar = computed(() => {
		return isDefaultLayout.value || isRightOnlyLayout.value || isSplitLayout.value;
	});
	function ensureRightVisible() {
		switch (layout.value) {
			case Layout.Full: return setLayout(Layout.RightOnly);
			case Layout.Split: return setLayout(Layout.Split);
			case Layout.LeftOnly: return setLayout(Layout.Default);
		}
	}
	function saveLayout() {
		if (!allowOptionalCookies.value) return;
		const saved = {
			collapsedNavigationbar: collapsedNavigationbar.value ?? false,
			layout: layout.value ?? defaultLayout
		};
		Plugin$8.set(LS_LAYOUT, saved);
	}
	function setHasRightContent(value) {
		hasRightContent.value = value;
		if (!value && layout.value !== Layout.LeftOnly) setLayout(Layout.LeftOnly);
	}
	function setAvailableLayouts(layouts) {
		availableLayouts.value = layouts;
		if (!layouts.includes(layout.value)) setLayout(layouts[0]);
	}
	function setLayout(value) {
		if (!hasRightContent.value && value !== Layout.LeftOnly) return;
		layout.value = value;
		saveLayout();
	}
	function setSmallScreen(value) {
		smallScreen.value = value;
	}
	function toggleNavigationBar(value) {
		collapsedNavigationbar.value = value == null ? !collapsedNavigationbar.value : value;
		saveLayout();
	}
	function toggleShowOverlay(value) {
		showOverlay.value = value == null ? !showOverlay.value : value;
	}
	function watchRoute(defaultLayouts) {
		watch(() => route.name, () => {
			const layouts = isLayoutRouteMeta(route.meta) && route.meta.allowedLayouts || defaultLayouts;
			hasRightContent.value = true;
			setAvailableLayouts(layouts);
			if (!navigation.saveLayoutOnRouteChange) return;
			const routeName = typeof route.name === "string" ? route.name : window.location.pathname;
			const savedLayout = savedLayouts.value.get(routeName);
			if (savedLayout) setLayout(savedLayout);
		}, { immediate: true });
	}
	function toggleRightSidebar() {
		switch (layout.value) {
			case Layout.Default: return setLayout(Layout.LeftOnly);
			case Layout.LeftOnly: return setLayout(Layout.Default);
			case Layout.RightOnly: return setLayout(Layout.Full);
			case Layout.Full: return setLayout(Layout.RightOnly);
		}
	}
	watch(collapsedNavigationbar, async (collapsed) => {
		isSidebarAnimationInprogress.value = true;
		if (navigation.delayOnSidebarToggle) {
			await wait(navigation.delayOnSidebarToggle);
			collapsedNavigationbarAfterAnimation.value = collapsed;
		} else collapsedNavigationbarAfterAnimation.value = collapsed;
		isSidebarAnimationInprogress.value = false;
	});
	watch(layout, (value) => {
		if (!navigation.saveLayoutOnRouteChange) return;
		const routeName = typeof route.name === "string" ? route.name : window.location.pathname;
		savedLayouts.value.set(routeName, value);
	});
	return {
		availableLayouts,
		collapsedNavigationbar,
		collapsedNavigationbarAfterAnimation,
		ensureRightVisible,
		hasRightContent,
		isDefaultLayout,
		isFullLayout,
		isLeftOnlyLayout,
		isRightOnlyLayout,
		isSidebarAnimationInprogress,
		isSplitLayout,
		layout,
		setAvailableLayouts,
		setHasRightContent,
		setLayout,
		setSmallScreen,
		showLeftSidebar,
		showOverlay,
		showRightSidebar,
		smallScreen,
		toggleNavigationBar,
		toggleRightSidebar,
		toggleShowOverlay,
		watchRoute
	};
}
var LayoutStore = "LayoutStore dependency";
function provideLayoutStore({ defaultLayout = Layout.Default, persistent = ref(true) } = {}) {
	const composable = buildLayoutStore(persistent, defaultLayout);
	provide(LayoutStore, composable);
	return composable;
}
function useLayout() {
	return inject(LayoutStore);
}
//#endregion
//#region src/composables/useLogo.ts
function useLogo() {
	const { navigation } = useOptionsReadOnly();
	const logoMain = computed(() => {
		return navigation.logoOptions?.main ?? "/rvai-base/logos.svg#main";
	});
	const logoRegular = computed(() => {
		return navigation.logoOptions?.regular ?? "/rvai-base/logos.svg#regular";
	});
	return {
		customLogoSrc: computed(() => {
			return navigation.logoOptions?.customLogoSrc;
		}),
		logoAlignClasses: computed(() => {
			return `flex justify-${navigation.logoOptions?.align ?? "center"}`;
		}),
		logoMain,
		logoRegular
	};
}
//#endregion
//#region src/composables/useNavigationHistory.ts
var initialState = () => ({
	backClicked: false,
	previousRoutes: []
});
var state = reactive(initialState());
function useNavigationHistory(defaultRoute, directRoute) {
	const { t } = useI18n();
	const { navigation: { backButtonLabels = {}, homeRoute } } = useOptionsReadOnly();
	const router = useRouter();
	const labels = {
		...backButtonLabels,
		..."default" in backButtonLabels ? {} : { get default() {
			return t("rvai-base.general.backBtn.default");
		} }
	};
	const fallbackRoute = defaultRoute ?? homeRoute ?? "/";
	const previousRoute = computed(() => {
		return state.previousRoutes[state.previousRoutes.length - 1] ?? fallbackRoute;
	});
	function getLabel(route) {
		const defaultKey = "default";
		const key = typeof route === "string" ? route : "name" in route ? route.name : void 0;
		return labels[key ?? defaultKey] ?? labels[defaultKey];
	}
	function getPreviousPageLabel() {
		if (directRoute) return getLabel(directRoute);
		const lastFrom = state.previousRoutes[state.previousRoutes.length - 1];
		if (!lastFrom?.name) return getLabel(fallbackRoute);
		else return getLabel(lastFrom);
	}
	function goToRoute(route) {
		router.push(typeof route === "string" ? { name: route } : route);
	}
	function goToPreviousPage() {
		state.backClicked = true;
		if (directRoute) {
			goToRoute(directRoute);
			return;
		}
		const lastFrom = state.previousRoutes.pop();
		if (!lastFrom) goToRoute(fallbackRoute);
		else goToRoute(lastFrom);
	}
	return {
		getPreviousPageLabel,
		goToPreviousPage,
		previousRoute
	};
}
var navigationHistoryGuard = (to, from) => {
	if (to.name !== from.name) {
		const initialRoute = !from.name && from.path === "/";
		if (!state.backClicked && !(isHistoryRouteMeta(from.meta) && from.meta.track === false) && !initialRoute) state.previousRoutes = [...state.previousRoutes, from];
		state.backClicked = false;
	}
};
//#endregion
//#region src/composables/usePagination.ts
var PAGE_SIZE = 50;
function buildPaginationComposable(params) {
	const { t } = useI18n();
	const { onConfirm } = useInfoDialog();
	const currentPage = ref(params?.initialCurrentPage ?? 1);
	const newPage = ref("");
	const pageSize = ref(params?.initialPageSize ?? PAGE_SIZE);
	const totalCount = ref(0);
	const canNavigate = computed(() => {
		return pageCount.value > 1;
	});
	const pageValue = computed(() => {
		const page = currentPage.value;
		return String(page);
	});
	const hasNextPage = computed(() => {
		return currentPage.value < pageCount.value;
	});
	const hasPreviousPage = computed(() => {
		return currentPage.value > 1;
	});
	const pageCount = computed(() => {
		return Math.ceil((totalCount.value || 1) / pageSize.value);
	});
	function goToFirstPage() {
		currentPage.value = 1;
	}
	function goToLastPage() {
		currentPage.value = pageCount.value;
	}
	function goToNextPage() {
		goToPage(currentPage.value + 1);
	}
	function goToPage(pageRaw) {
		if (pageRaw === "") return false;
		const newPage = Number(pageRaw);
		if (isNaN(newPage) || newPage < 1 || newPage > pageCount.value) return false;
		currentPage.value = newPage;
		return true;
	}
	function goToPreviousPage() {
		goToPage(currentPage.value - 1);
	}
	async function onBlur() {
		if (newPage.value === "") return;
		const page = newPage.value;
		newPage.value = "";
		if (!goToPage(page)) await onConfirm({
			actionLabel: t("rvai-base.general.actions.ok"),
			dataAutomation: "noPageDialog",
			hasCloseButton: false,
			message: t("rvai-base.components.pagination.noPage", {
				max: pageCount.value,
				min: 1,
				page
			}),
			persistent: true
		});
	}
	function setPageSize(value) {
		pageSize.value = value;
	}
	function setTotalCount(value) {
		totalCount.value = value;
		if (currentPage.value > pageCount.value) goToFirstPage();
	}
	return {
		canNavigate,
		currentPage: readonly(currentPage),
		goToFirstPage,
		goToLastPage,
		goToNextPage,
		goToPage,
		goToPreviousPage,
		hasNextPage,
		hasPreviousPage,
		newPage,
		onBlur,
		pageCount,
		pageSize: readonly(pageSize),
		pageValue,
		setPageSize,
		setTotalCount,
		totalCount: readonly(totalCount)
	};
}
var Pagination = "Pagination dependency";
function providePagination(params) {
	const composable = buildPaginationComposable(params);
	provide(Pagination, composable);
	return composable;
}
function usePagination() {
	const paginationComposable = inject(Pagination);
	if (!paginationComposable) throw new Error("The pagination was not registered. Make sure you used \"providePagination\".");
	return paginationComposable;
}
//#endregion
//#region src/composables/usePaletteColorsCache.ts
var { getPaletteColor } = colors_default;
var colorCache = /* @__PURE__ */ new Map();
function usePaletteColorsCache() {
	const { isDark } = useDarkMode();
	function getPaletteColorCache(color) {
		let cachedColor = colorCache.get(color);
		if (!cachedColor) {
			cachedColor = getPaletteColor(color);
			colorCache.set(color, cachedColor);
		}
		return cachedColor;
	}
	watch(isDark, () => {
		colorCache.clear();
	});
	return { getPaletteColorCache };
}
//#endregion
//#region src/composables/useRightPanelSize.ts
var PANEL_DEFAULT_SIZE = 324;
var PANEL_MAX_SIZE = 768;
var SPLIT_VIEW_MIN_SCREEN_WIDTH = 1439;
function useRightPanelSize(params) {
	const { minScreenWidth = SPLIT_VIEW_MIN_SCREEN_WIDTH, panelDefaultSize = PANEL_DEFAULT_SIZE, panelGap = 0, panelMaxSize = PANEL_MAX_SIZE } = params ?? {};
	const { isSplitLayout, layout } = useLayout();
	const rightPanelWidth = ref(panelDefaultSize);
	function setRightPanelWidth(screenWidth) {
		const panelWidth = isSplitLayout.value && screenWidth > minScreenWidth ? Math.round(Math.min(screenWidth * .4 + panelGap, panelMaxSize + panelGap)) : panelDefaultSize;
		rightPanelWidth.value = panelWidth;
	}
	watch(layout, () => {
		setRightPanelWidth(window.innerWidth);
	});
	return {
		rightPanelWidth,
		setRightPanelWidth
	};
}
//#endregion
//#region src/composables/useScrollNavigation.ts
function useScrollNavigation(config) {
	let ticking = false;
	const currentPosition = ref();
	const navigation = computed(() => {
		const pos = currentPosition.value;
		if (pos) return config.value.map((n) => ({
			...n,
			active: n.to === pos.to
		}));
		else return config.value;
	});
	const navigationTops = computed(() => navigation.value.map((n) => {
		const top = document.getElementById(n.to)?.offsetTop ?? 0;
		return {
			to: n.to,
			top
		};
	}));
	function handleScroll() {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				currentPosition.value = navigationTops.value.filter((n) => n.top >= Math.floor(window.scrollY))[0];
				ticking = false;
			});
			ticking = true;
		}
	}
	function scrollTo(value) {
		const top = document.getElementById(value)?.offsetTop ?? 0;
		currentPosition.value = navigationTops.value.find((v) => v.top === top);
		window.scrollTo({
			behavior: "smooth",
			top
		});
	}
	onMounted(async () => {
		window.addEventListener("scroll", handleScroll);
	});
	onUnmounted(() => {
		window.removeEventListener("scroll", handleScroll);
	});
	return {
		navigation,
		scrollTo
	};
}
//#endregion
//#region src/composables/useSidebarHelpers.ts
function useSidebarHelpers() {
	const $q = useQuasar();
	function openSidebar(options) {
		return $q.dialog(options);
	}
	return { openSidebar };
}
//#endregion
//#region src/composables/useStepSidebar.ts
function buildStepSidebarComposable() {
	const stack = shallowRef([]);
	const currentStep = computed(() => {
		return stack.value.length ? stack.value[stack.value.length - 1] : null;
	});
	const isDefaultStep = computed(() => {
		return !stack.value.length;
	});
	const showBackButton = computed(() => {
		return !isDefaultStep.value;
	});
	function isCurrentStep(step) {
		return currentStep.value === step;
	}
	function onBack() {
		nextTick(() => {
			stack.value = stack.value.slice(0, -1);
		});
	}
	function onReset() {
		nextTick(() => {
			stack.value = [];
		});
	}
	function pushStep(step) {
		stack.value = [...stack.value, step];
	}
	return {
		currentStep,
		isCurrentStep,
		isDefaultStep,
		onBack,
		onReset,
		pushStep,
		showBackButton,
		stack
	};
}
var UseStepSidebarSymbol = "UseStepSidebar";
function provideStepSidebar() {
	const composable = buildStepSidebarComposable();
	provide(UseStepSidebarSymbol, composable);
	return composable;
}
function useStepSidebar() {
	const composable = inject(UseStepSidebarSymbol);
	if (!composable) throw new Error("Could not inject `UseStepSidebarComposable`. Did you forget `provideStepSidebar`?");
	return composable;
}
//#endregion
//#region src/composables/useTable/tableFiltering/useClientTableFiltering.ts
function getFilterValue(row, col) {
	const { field, filterableField } = col;
	if (!filterableField) return void 0;
	const computedField = filterableField === true ? field : filterableField;
	if (!computedField) return void 0;
	return typeof computedField === "function" ? computedField(row) : row[computedField];
}
function isFilterable$1(col) {
	return !!col.filterableField && !!col.filterType && col.filterType !== TableFilterType.FreeText;
}
function isSearchable$1(col) {
	return !!col.filterableField;
}
function matchesFilterValue(filter, value) {
	switch (filter.type) {
		case TableFilterType.Date: {
			const dt = value instanceof Date ? value : parseISO(value);
			if (!isValid(dt)) return false;
			const [, endHours] = filter.value.end.split(" ");
			const [, startHours] = filter.value.start.split(" ");
			const endDate = endHours ? filter.value.end : `${filter.value.end} 23:59:59`;
			const startDate = startHours ? filter.value.start : `${filter.value.start} 00:00:00`;
			if (filter.value.start && !filter.value.end) return isAfter(dt, new Date(startDate));
			else if (filter.value.end && !filter.value.start) return isBefore(dt, new Date(endDate));
			else return isWithinInterval(dt, {
				end: new Date(endDate),
				start: new Date(startDate)
			});
		}
		case TableFilterType.Number:
			if (typeof value !== "number") return false;
			if (filter.min != null && filter.min > value) return false;
			if (filter.max != null && filter.max < value) return false;
			return true;
		case TableFilterType.List: return filter.value.includes(value);
		case TableFilterType.Single: return filter.value === value;
	}
}
function matchesSearchValue(needle, value) {
	if (typeof value !== "string" && typeof value !== "number") return false;
	return value.toString().toLocaleLowerCase().includes(needle);
}
function useClientTableFiltering(columns, rows, refineFilteredRows) {
	const options = useOptionsReadOnly();
	const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
	const filterableColumns = computed(() => columns.value.filter(isFilterable$1));
	const searchableColumns = computed(() => columns.value.filter(isSearchable$1));
	const { parseQuery, queryParams, setQuery } = useQueryParams();
	const { filters: queryFilters, search: querySearch } = queryParams.value;
	const filters = reactive({
		search: queryParamsFilters.value ? querySearch : void 0,
		values: queryParamsFilters.value && queryFilters ? parseQuery(queryFilters.replaceAll("+", "%2B")) : {}
	});
	const filterOptions = computed(() => {
		return buildObject(filterableColumns.value, (col) => col.name, (col) => buildFilterOption(col, toValue(rows)));
	});
	const filterOptionsOpenedByDefault = ref([]);
	const hasFilters = computed(() => !isEmptyPlainObject(filters.values));
	const hasSearchQueryFilter = computed(() => !!filters.search);
	const hasFilterableValues = computed(() => !isEmptyPlainObject(visibleFilterOptions.value));
	const search = computed({
		get() {
			return filters.search;
		},
		set(value) {
			filters.search = value;
		}
	});
	const searchable = computed(() => !!searchableColumns.value.length);
	const visibleColumns = computed(() => {
		return columns.value.map((c) => c.name);
	});
	const visibleFilterOptions = computed(() => filterObject(filterOptions.value, (option, key) => visibleColumns.value.includes(key) && (key in filters.values || option.hasOptions)));
	function buildFilterOption(col, rows) {
		if (!col.filterType) throw new Error("Cannot build filter config for unknown type");
		switch (col.filterType) {
			case TableFilterType.Date: {
				const values = rows.map((row) => {
					return getFilterValue(row, col);
				}).filter(Boolean);
				return {
					beforeOptions: col.filterBeforeOptions,
					hasOptions: values.length > 1,
					key: col.name,
					label: col.filterName,
					options: [],
					type: TableFilterType.Date
				};
			}
			case TableFilterType.Number: {
				const numberValues = rows.flatMap((row) => {
					const value = getFilterValue(row, col);
					return Array.isArray(value) ? value : [value];
				}).filter((x) => x != null);
				const min = Math.min(...numberValues);
				const max = Math.max(...numberValues);
				return {
					hasOptions: min !== max && min !== Infinity,
					key: col.name,
					label: col.filterName,
					max,
					min,
					step: col.filterStep,
					type: TableFilterType.Number
				};
			}
			case TableFilterType.List:
			case TableFilterType.Single: {
				const grouped = rows.flatMap((row) => {
					const value = getFilterValue(row, col);
					return Array.isArray(value) ? value : [value];
				}).filter(Boolean).reduce((acc, curr) => {
					if (curr) acc[curr] = (acc[curr] || 0) + 1;
					return acc;
				}, {});
				const options = Object.entries(grouped).map(([value, count]) => ({
					count,
					label: value || "",
					value
				})).sort((a, b) => col.filterOptionsSorting === SortOrders.Desc ? naturalSort(b.label, a.label) : naturalSort(a.label, b.label));
				return {
					hasOptions: options.length > 1,
					key: col.name,
					label: col.filterName,
					options,
					type: col.filterType
				};
			}
			default: throw new Error(`Cannot build filter config for type ${col.filterType}`);
		}
	}
	function getFilteredRows(options) {
		const refine = options?.refine ?? true;
		const skipColumn = options?.skipColumn;
		let result = [...toValue(rows)];
		Object.values(filters.values).forEach((filter) => {
			if (!filter) return;
			if (skipColumn && filter.key === skipColumn) return;
			const col = columns.value.find((c) => c.name === filter.key);
			if (!col) return;
			result = result.filter((row) => {
				const rowValue = getFilterValue(row, col);
				return Array.isArray(rowValue) ? rowValue.some((x) => matchesFilterValue(filter, x)) : matchesFilterValue(filter, rowValue);
			});
		});
		const needle = (filters.search || "").toLocaleLowerCase();
		if (needle) result = result.filter((row) => {
			return searchableColumns.value.some((col) => {
				const rowValue = getFilterValue(row, col);
				if (!rowValue) return false;
				return Array.isArray(rowValue) ? rowValue.some((x) => matchesSearchValue(needle, x)) : matchesSearchValue(needle, rowValue);
			});
		});
		return refine && refineFilteredRows ? refineFilteredRows(result, toValue(rows)) : result;
	}
	function resetFilters() {
		filters.values = {};
	}
	function resetSearchQuery() {
		filters.search = void 0;
	}
	function updateFilters(filter, value) {
		if (!value) {
			delete filters.values[filter.key];
			return;
		}
		if (filter.type !== value.type) throw new Error(filter.type);
		filters.values[filter.key] = value;
	}
	if (queryParamsFilters.value) {
		watch(filters, () => {
			setQuery({
				filters: isEmptyPlainObject(filters.values) ? void 0 : filters.values,
				search: filters.search
			});
		});
		watch(queryParams, (query) => {
			if (isEmptyPlainObject(query)) {
				filters.search = void 0;
				filters.values = {};
			}
		});
	}
	return {
		filterOptions,
		filterOptionsOpenedByDefault,
		filters,
		getFilteredRows,
		hasFilterableValues,
		hasFilters,
		hasSearchQueryFilter,
		initializeFilters: async () => {},
		resetFilters,
		resetSearchQuery,
		search,
		searchable,
		updateFilters,
		visibleFilterOptions
	};
}
//#endregion
//#region src/composables/useTable/tableFiltering/useServerTableFiltering.ts
var MAX_CONCURRENT_REQUESTS = 10;
function isFilterable(col) {
	return !!col.filterableField && !!col.filterType && col.filterType !== TableFilterType.FreeText;
}
function isSearchable(col) {
	return !!col.filterableField;
}
function buildDefaultFilter(col) {
	return {
		hasOptions: false,
		key: col.name,
		label: col.filterName,
		options: [],
		type: col.filterType
	};
}
function useServerTableFiltering(columns, onRequestFilters) {
	const options = useOptionsReadOnly();
	const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
	const filterableColumns = computed(() => columns.value.filter(isFilterable));
	const searchableColumns = computed(() => columns.value.filter(isSearchable));
	const { parseQuery, queryParams, setQuery } = useQueryParams();
	const { filters: queryFilters, search: querySearch } = queryParams.value;
	const filters = reactive({
		search: queryParamsFilters.value ? querySearch : void 0,
		values: queryParamsFilters.value && queryFilters ? parseQuery(queryFilters) : {}
	});
	const filterOptions = ref({});
	const filterOptionsOpenedByDefault = ref([]);
	const hasFilters = computed(() => !isEmptyPlainObject(filters.values));
	const hasSearchQueryFilter = computed(() => !!filters.search);
	const hasFilterableValues = computed(() => !isEmptyPlainObject(visibleFilterOptions.value));
	const search = computed({
		get() {
			return filters.search;
		},
		set(value) {
			filters.search = value;
		}
	});
	const searchable = computed(() => !!searchableColumns.value.length);
	const visibleColumns = computed(() => {
		return columns.value.map((c) => c.name);
	});
	const visibleFilterOptions = computed(() => {
		return Object.keys(filterOptions.value).filter((key) => visibleColumns.value.includes(key) && (key in filters.values || filterOptions.value[key].hasOptions)).reduce((obj, key) => {
			return {
				...obj,
				[key]: filterOptions.value[key]
			};
		}, {});
	});
	async function initializeFilters() {
		filterOptions.value = await buildObjectAsync(filterableColumns.value, (col) => col.name, async (col) => await onRequestFilters(col) ?? buildDefaultFilter(col), MAX_CONCURRENT_REQUESTS);
	}
	function getFilteredRows() {
		throw new Error("Unsupported operation");
	}
	function resetFilters() {
		filters.values = {};
	}
	function resetSearchQuery() {
		filters.search = void 0;
	}
	function updateFilters(filter, value) {
		if (!value) {
			delete filters.values[filter.key];
			return;
		}
		if (filter.type !== value.type) throw new Error(filter.type);
		filters.values[filter.key] = value;
	}
	if (queryParamsFilters.value) {
		watch(filters, () => {
			setQuery({
				filters: isEmptyPlainObject(filters.values) ? void 0 : filters.values,
				search: filters.search
			});
		});
		watch(queryParams, (query) => {
			if (isEmptyPlainObject(query)) {
				filters.search = void 0;
				filters.values = {};
			}
		});
	}
	return {
		filterOptions: computed(() => filterOptions.value),
		filterOptionsOpenedByDefault,
		filters,
		getFilteredRows,
		hasFilterableValues,
		hasFilters,
		hasSearchQueryFilter,
		initializeFilters,
		resetFilters,
		resetSearchQuery,
		search,
		searchable,
		updateFilters,
		visibleFilterOptions
	};
}
//#endregion
//#region src/composables/useTable/tableSelecting/useTableSelecting.ts
function useCommonSelecting({ initialSelectedRows, isImmutable, rowKey, visibleRows }) {
	const allSelectedRef = ref(initialSelectedRows ? [...initialSelectedRows] : []);
	const lastSelected = ref();
	const selecting = ref(false);
	const selectableRows = computed(() => {
		return visibleRows.value.filter((r) => !isImmutable(r));
	});
	function difference(arr1, arr2) {
		return arr1.filter((a) => !includes(arr2, a));
	}
	function equals(arr1, arr2) {
		if (arr1.some((a) => !includes(arr2, a))) return false;
		if (arr2.some((a) => !includes(arr1, a))) return false;
		return true;
	}
	function includes(arr, value) {
		return arr.some((x) => rowsEqual(x, value));
	}
	function rowsEqual(a, b) {
		return a[rowKey] === b[rowKey];
	}
	function setSelecting(v) {
		selecting.value = v;
	}
	function toggleSelected(row, range = false) {
		const currentSelection = allSelectedRef.value;
		const lastItem = lastSelected.value;
		const visibleItems = visibleRows.value;
		const isSelected = includes(currentSelection, row);
		const lastIndex = lastItem ? visibleItems.findIndex((x) => rowsEqual(x, lastItem)) : -1;
		let selected;
		if (!range || lastIndex < 0) selected = isSelected ? difference(currentSelection, [row]) : [...currentSelection, row];
		else {
			const rowIndex = visibleItems.findIndex((x) => rowsEqual(x, row));
			const affected = visibleItems.slice(Math.min(rowIndex, lastIndex), Math.max(rowIndex, lastIndex) + 1).filter((r) => !isImmutable(r));
			const nonAffected = difference(currentSelection, affected);
			selected = isSelected ? nonAffected : [...nonAffected, ...affected];
		}
		allSelectedRef.value = selected;
		lastSelected.value = row;
		setSelecting(!!selected.length);
	}
	function toggleSelecting() {
		setSelecting(!selecting.value);
		allSelectedRef.value = [];
	}
	return {
		allSelectedRef,
		difference,
		equals,
		includes,
		lastSelected,
		rowsEqual,
		selectableRows,
		selecting,
		setSelecting,
		toggleSelected,
		toggleSelecting
	};
}
//#endregion
//#region src/composables/useTable/tableSelecting/useFilteredSelecting.ts
function useFilteredSelecting({ initialSelectedRows, isImmutable, resultRows, rowKey, visibleRows }) {
	const { allSelectedRef, difference, equals, includes, rowsEqual, selectableRows, selecting, setSelecting, toggleSelected, toggleSelecting } = useCommonSelecting({
		initialSelectedRows,
		isImmutable,
		rowKey,
		visibleRows
	});
	const filteredSelected = ref([]);
	const allSelected = computed({
		get() {
			return allSelectedRef.value;
		},
		set(value) {
			const added = difference(value, allSelectedRef.value);
			const removed = difference(allSelectedRef.value, value);
			filteredSelected.value = difference(filteredSelected.value, removed).concat(added);
			allSelectedRef.value = value;
			if (value.length) selecting.value = true;
		}
	});
	const allSelectedValue = computed(() => {
		if (!allSelected.value.length) return false;
		else if (selectableRows.value.length === allSelected.value.length) return true;
		else return null;
	});
	function clearSelection() {
		allSelected.value = [];
	}
	function toggleAll(value) {
		setSelecting(!!value);
		allSelected.value = value ? selectableRows.value : [];
	}
	function updateSelected() {
		const results = [...toValue(resultRows)];
		allSelectedRef.value = allSelectedRef.value.filter((x) => includes(results, x)).map((x) => results.find((r) => rowsEqual(r, x)) || x);
		filteredSelected.value = allSelectedRef.value.filter((x) => includes(visibleRows.value, x)).filter((x) => !isImmutable(x));
	}
	function updateSelection(selected) {
		if (equals(selected, filteredSelected.value)) return;
		allSelectedRef.value = allSelectedRef.value.filter((x) => includes(selected, x));
		filteredSelected.value = allSelectedRef.value.filter((x) => includes(selected, x)).filter((x) => !isImmutable(x));
	}
	watch(allSelectedRef, () => {
		filteredSelected.value = allSelectedRef.value.filter((x) => includes(visibleRows.value, x)).filter((x) => !isImmutable(x));
	});
	return {
		allSelected,
		allSelectedValue,
		clearSelection,
		filteredSelected,
		selectableRows,
		selecting,
		setSelecting,
		toggleAll,
		toggleSelected,
		toggleSelecting,
		updateSelected,
		updateSelection
	};
}
//#endregion
//#region src/composables/useTable/tableSelecting/useUnfilteredSelecting.ts
function useUnfilteredSelecting(visibleRows, rowKey, isImmutable) {
	const { allSelectedRef, difference, equals, includes, rowsEqual, selectableRows, selecting, setSelecting, toggleSelected, toggleSelecting } = useCommonSelecting({
		isImmutable,
		rowKey,
		visibleRows
	});
	const allSelected = computed({
		get() {
			return allSelectedRef.value;
		},
		set(value) {
			allSelectedRef.value = value;
			if (value.length) selecting.value = true;
		}
	});
	const filteredSelected = computed(() => allSelected.value);
	const allSelectedValue = computed(() => {
		const visibleSelected = selectableRows.value.filter((r) => includes(allSelected.value, r));
		if (visibleSelected.length === 0) return false;
		else if (visibleSelected.length === selectableRows.value.length) return true;
		else return null;
	});
	function clearSelection() {
		allSelected.value = [];
	}
	function toggleAll(value) {
		if (value) allSelected.value = mergeArraysByKey(allSelected.value, selectableRows.value, rowKey);
		else allSelected.value = difference(allSelected.value, selectableRows.value);
	}
	function updateSelected() {
		allSelectedRef.value = allSelectedRef.value.map((x) => visibleRows.value.find((r) => rowsEqual(r, x)) || x);
	}
	function updateSelection(selected) {
		if (equals(selected, filteredSelected.value)) return;
		allSelectedRef.value = allSelectedRef.value.filter((x) => includes(selected, x));
	}
	return {
		allSelected,
		allSelectedValue,
		clearSelection,
		filteredSelected,
		selectableRows,
		selecting,
		setSelecting,
		toggleAll,
		toggleSelected,
		toggleSelecting,
		updateSelected,
		updateSelection
	};
}
//#endregion
//#region src/composables/useTable/useTableCardsSorting.ts
function useTableCardsSorting(columns) {
	const { t } = useI18n();
	return {
		selectedItem: ref(null),
		sortableItems: computed(() => {
			return columns.value.filter((c) => c.sortable).reduce((acc, val) => val.filterType === TableFilterType.Date ? [
				...acc,
				{
					descending: false,
					get label() {
						return val.i18nSortNameAsc ? t(val.i18nSortNameAsc) : `${t("rvai-base.general.text.first")} ${val.label.toLowerCase()}`;
					},
					name: val.name,
					value: val.name + SortOrders.Asc
				},
				{
					descending: true,
					get label() {
						return val.i18nSortNameDesc ? t(val.i18nSortNameDesc) : `${t("rvai-base.general.text.last")} ${val.label.toLowerCase()}`;
					},
					name: val.name,
					value: val.name + SortOrders.Desc
				}
			] : [
				...acc,
				{
					descending: false,
					get label() {
						return val.i18nSortNameAsc ? t(val.i18nSortNameAsc) : `${val.label} ${t("rvai-base.general.text.sortAsc")}`;
					},
					name: val.name,
					value: val.name + SortOrders.Asc
				},
				{
					descending: true,
					get label() {
						return val.i18nSortNameDesc ? t(val.i18nSortNameDesc) : `${val.label} ${t("rvai-base.general.text.sortDesc")}`;
					},
					name: val.name,
					value: val.name + SortOrders.Desc
				}
			], []);
		})
	};
}
//#endregion
//#region src/composables/useTable/useTableCarousel.ts
function useTableCarousel({ data, hasActionColumn, isEnabled, isSelectionEnabled, minColumnWidth = 200 }) {
	const CHECKBOX_WIDTH = isSelectionEnabled ? 40 : 0;
	const FIXED_COLUMNS_WIDTH = 64 + (hasActionColumn ? 56 : 0) + CHECKBOX_WIDTH;
	const FIRST_COLUMN_WIDTH = minColumnWidth;
	const MIN_WIDTH = minColumnWidth;
	const isCarouselCalculationsEnabled = ref(true);
	const isCarouselEnabled = ref(isEnabled);
	const currentColumnIndex = ref(0);
	const tableWidth = ref(0);
	const totalWidth = ref(0);
	const cols = computed(() => {
		let cols = Math.min(Math.floor(totalWidth.value / MIN_WIDTH), data.value.length);
		do
			if (totalWidth.value / cols >= MIN_WIDTH) break;
		while (--cols > 1);
		return Math.max(1, cols);
	});
	const colWidth = computed(() => {
		return `${totalWidth.value / cols.value}px`;
	});
	const disableNextButton = computed(() => currentColumnIndex.value + cols.value >= data.value.length);
	const disablePreviousButton = computed(() => !currentColumnIndex.value);
	const transformOffsetLeft = computed(() => currentColumnIndex.value * parseFloat(colWidth.value));
	const visibleColumnsCount = computed(() => Math.floor((tableWidth.value - CHECKBOX_WIDTH - FIRST_COLUMN_WIDTH) / parseFloat(colWidth.value)));
	function setCarouselCalculationsEnabled(val) {
		isCarouselCalculationsEnabled.value = val;
	}
	function setTableCarousel(val) {
		isCarouselEnabled.value = val;
	}
	function nextColumn() {
		currentColumnIndex.value++;
	}
	function prevColumn() {
		currentColumnIndex.value--;
	}
	function onResize({ width }) {
		if (!isCarouselCalculationsEnabled.value) return;
		totalWidth.value = Math.max(0, width - FIXED_COLUMNS_WIDTH);
		tableWidth.value = width;
	}
	watch(visibleColumnsCount, (curr, prev) => {
		const scrollableColumns = data.value.length - 1;
		const hasColumnsCountIncreased = curr > prev;
		const hasEmptySpace = curr > scrollableColumns - currentColumnIndex.value;
		if (prev !== -Infinity && hasColumnsCountIncreased && hasEmptySpace) currentColumnIndex.value -= curr - prev;
	});
	watch(() => data.value.length, (currentLength, prevLength) => {
		const wasDataDecreased = currentLength < prevLength;
		const scrollableColumns = currentLength - 1;
		const hasEmptySpace = visibleColumnsCount.value > scrollableColumns - currentColumnIndex.value;
		if (wasDataDecreased && hasEmptySpace) currentColumnIndex.value -= currentColumnIndex.value + visibleColumnsCount.value - scrollableColumns;
	});
	return {
		cols,
		colWidth,
		currentColumnIndex,
		disableNextButton,
		disablePreviousButton,
		isCarouselEnabled,
		nextColumn,
		onResize,
		prevColumn,
		setCarouselCalculationsEnabled,
		setTableCarousel,
		totalWidth,
		transformOffsetLeft
	};
}
//#endregion
//#region src/composables/useTable/useTableConfig.ts
var LS_KEY = "LS_TABLE_CONFIG";
function useTableConfig(tableId) {
	function getConfig() {
		return { grid: (Plugin$8.getItem(LS_KEY)?.[tableId])?.grid ?? void 0 };
	}
	function setConfig(update) {
		const config = Plugin$8.getItem(LS_KEY);
		Plugin$8.set(LS_KEY, {
			...config,
			[tableId]: {
				...config?.[tableId],
				...update
			}
		});
	}
	return {
		getConfig,
		setConfig
	};
}
//#endregion
//#region src/composables/useTable/useTablePagination.ts
function useTablePagination() {
	function paginateRows(rows, pagination) {
		const { page = 1, rowsPerPage = 0 } = pagination;
		const startRow = (page - 1) * rowsPerPage;
		const fetchCount = rowsPerPage === 0 ? rows.length : rowsPerPage;
		return rows.slice(startRow, startRow + fetchCount);
	}
	return { paginateRows };
}
//#endregion
//#region src/composables/useTable/useTableSorting.ts
function compareBoolean(a, b) {
	return +a - +b;
}
function compareNumber(a, b) {
	return a - b;
}
function defaultCompare(a, b) {
	return a > b ? 1 : a < b ? -1 : 0;
}
function getSortValue(row, col) {
	const { field, sortableField } = col;
	const computedField = sortableField || field;
	if (!computedField) return "";
	return typeof computedField === "function" ? computedField(row) : row[computedField];
}
function useTableSorting(columns) {
	function sortRows(rows, { descending, sortBy }) {
		const result = [...rows];
		if (!sortBy) return result;
		const col = columns.value.find((c) => c.name === sortBy);
		if (!col) return result;
		result.sort((a, b) => {
			const x = descending ? getSortValue(b, col) : getSortValue(a, col);
			const y = descending ? getSortValue(a, col) : getSortValue(b, col);
			if (x == null && y == null) return 0;
			if (x == null) return 1;
			if (y == null) return -1;
			if (typeof x !== typeof y) return 0;
			switch (typeof x) {
				case "boolean": return compareBoolean(x, y);
				case "number": return compareNumber(x, y);
				case "string": return naturalSort(x, y);
				default: return defaultCompare(x, y);
			}
		});
		return result;
	}
	return { sortRows };
}
//#endregion
//#region src/composables/useTable/index.ts
function buildTableComposable({ carousel, columns, defaultRowsPerPage = 0, enableSelection = true, hasRowActions = true, immutableKey, initialSelectedRows, isImmutable, isRowDisabled: isRowDisabledParam, isRowVisible, rowDisabledTooltip: rowDisabledTooltipParam, onServerRequest, onServerRequestFilter, refineFilteredRows, rowKey, rows: data, tableId, totalRows: totalRowsValue, visibleColumnNames }) {
	if (onServerRequest && totalRowsValue == null) console.warn("Make sure to provide `totalRows` when using server side pagination");
	const { t } = useI18n();
	const options = useOptionsReadOnly();
	const { queryParams, setQuery } = useQueryParams();
	const tableRef = ref(null);
	const rows = ref([]);
	const selectionScope = ref([]);
	const filterResults = ref([]);
	const serverLoading = ref(false);
	const isRowDisabled = (row) => isRowDisabledParam?.(row) ?? false;
	const rowDisabledTooltip = (row) => rowDisabledTooltipParam?.(row);
	const isRowImmutable = (row) => {
		if (isRowDisabled(row)) return true;
		if (isImmutable) return isImmutable(row);
		if (immutableKey) return !!row[immutableKey];
		return false;
	};
	const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
	const visibleColumns = computed(() => {
		const columnsValue = "value" in columns ? columns.value : columns;
		return visibleColumnNames?.value.length ? columnsValue.filter((c) => visibleColumnNames.value.includes(c.name)) : columnsValue;
	});
	const translatedColumns = computed(() => visibleColumns.value.map((c) => {
		c.label = "i18nLabel" in c ? c.i18nLabel ? t(c.i18nLabel) : "" : c.label;
		c.filterName = c.i18nFilterName ? t(c.i18nFilterName) : c.label;
		return c;
	}));
	const { filterOptions, filterOptionsOpenedByDefault, filters, getFilteredRows, hasFilterableValues, hasFilters, hasSearchQueryFilter, initializeFilters, resetFilters, resetSearchQuery, search, searchable, updateFilters, visibleFilterOptions } = onServerRequestFilter ? useServerTableFiltering(translatedColumns, onServerRequestFilter) : useClientTableFiltering(translatedColumns, data, refineFilteredRows);
	const { paginateRows } = useTablePagination();
	const { allSelected, allSelectedValue, clearSelection, filteredSelected, selectableRows, selecting, toggleAll, toggleSelected, toggleSelecting, updateSelected, updateSelection } = onServerRequestFilter ? useUnfilteredSelecting(rows, rowKey, isRowImmutable) : useFilteredSelecting({
		initialSelectedRows,
		isImmutable: isRowImmutable,
		rowKey,
		resultRows: filterResults,
		visibleRows: selectionScope
	});
	const { sortRows } = useTableSorting(translatedColumns);
	const { selectedItem, sortableItems } = useTableCardsSorting(translatedColumns);
	const { cols: carouselColumns, colWidth, disableNextButton, disablePreviousButton, isCarouselEnabled, nextColumn, onResize, prevColumn, setCarouselCalculationsEnabled, setTableCarousel, totalWidth, transformOffsetLeft } = useTableCarousel({
		data: translatedColumns,
		hasActionColumn: hasRowActions,
		isEnabled: carousel?.enableCarousel ?? options.tables.carousel ?? true,
		isSelectionEnabled: enableSelection,
		minColumnWidth: carousel?.minColumnWidth
	});
	const { getConfig, setConfig } = useTableConfig(tableId);
	const { desc, sortBy } = queryParams.value;
	const pagination = ref({
		descending: !!(queryParamsFilters.value && sortBy && desc),
		page: 1,
		rowsNumber: 0,
		rowsPerPage: defaultRowsPerPage,
		sortBy: queryParamsFilters.value ? sortBy : void 0
	});
	const totalRows = computed(() => {
		return totalRowsValue == null ? rows.value.length : toValue(totalRowsValue);
	});
	const hasNoData = computed(() => {
		return onServerRequest ? !totalRows.value : !data.value.length;
	});
	async function onRequest(props) {
		if (onServerRequest) try {
			serverLoading.value = true;
			const result = await onServerRequest(props.pagination, { ...props.filter });
			pagination.value.rowsNumber = result.rowsNumber;
			rows.value = [...result.rows];
			selectionScope.value = rows.value;
		} finally {
			serverLoading.value = false;
		}
		else {
			const filtered = getFilteredRows();
			pagination.value.rowsNumber = filtered.length;
			const sorted = sortRows(filtered, props.pagination);
			const paginated = paginateRows(sorted, props.pagination);
			rows.value = paginated;
			const matched = getFilteredRows({ refine: false });
			const hiddenMatched = isRowVisible ? matched.filter((row) => !isRowVisible(row)) : [];
			filterResults.value = [...filtered, ...hiddenMatched];
			selectionScope.value = [...paginated, ...hiddenMatched];
		}
		pagination.value.descending = props.pagination.descending;
		pagination.value.page = props.pagination.page;
		pagination.value.rowsPerPage = props.pagination.rowsPerPage;
		pagination.value.sortBy = props.pagination.sortBy;
		updateSelected();
	}
	if (!onServerRequest) onMounted(() => {
		watch(data, () => {
			tableRef.value?.requestServerInteraction({ pagination: {
				...pagination.value,
				sortBy: pagination.value.sortBy ?? void 0
			} });
		}, { immediate: true });
	});
	if (queryParamsFilters.value) {
		watch(() => [pagination.value.sortBy, pagination.value.descending], ([sortBy, desc]) => {
			setQuery({
				desc: sortBy && desc ? true : void 0,
				sortBy
			});
		});
		watch(queryParams, (query) => {
			if (isEmptyPlainObject(query)) {
				pagination.value.descending = false;
				pagination.value.sortBy = void 0;
			}
		});
	}
	return {
		allSelected,
		allSelectedValue,
		carouselColumns,
		clearSelection,
		columns: translatedColumns,
		colWidth,
		disableNextButton,
		disablePreviousButton,
		enableSelection,
		filteredSelected,
		filterOptions,
		filterOptionsOpenedByDefault,
		filters,
		getConfig,
		hasFilterableValues,
		hasFilters,
		hasNoData,
		hasRowActions,
		hasSearchQueryFilter,
		initializeFilters,
		isCarouselEnabled,
		isRowDisabled,
		isRowImmutable,
		nextColumn,
		onRequest,
		onResize,
		pagination,
		prevColumn,
		resetFilters,
		resetSearchQuery,
		rowDisabledTooltip,
		rowKey,
		rows,
		search,
		searchable,
		selectableRows,
		selectedItem,
		selecting,
		serverLoading,
		setCarouselCalculationsEnabled,
		setConfig,
		setTableCarousel,
		sortableItems,
		tableRef,
		toggleAll,
		toggleSelected,
		toggleSelecting,
		totalRows,
		totalWidth,
		transformOffsetLeft,
		updateFilters,
		updateSelection,
		visibleFilterOptions
	};
}
var Table = "Table dependency";
function provideTable(params) {
	const composable = buildTableComposable(params);
	provide(Table, composable);
	return composable;
}
function useTable() {
	const tableComposable = inject(Table);
	if (!tableComposable) throw new Error("The table was not registered. Make sure you used \"provideTable\".");
	return tableComposable;
}
//#endregion
//#region src/composables/useTreeTable.ts
/**
* Turns a parent/child list into one flat list of rows for a table: every
* parent is followed by its children. A collapsed parent keeps its children in
* the list but flagged `hidden`, so filters and selection still count them
* while the table leaves them unrendered. Also reports, per row, whether it's a
* parent or a child and who its parent is. The caller owns which parents are
* open through the `expanded` ref.
*
* Columns are {@link TreeTableColumn}s, which say how to read a value from a
* parent row versus a child row.
*/
function useTreeTable(params) {
	const { expanded } = params;
	function rowKey() {
		return toValue(params.rowKey);
	}
	function rowId(row) {
		return row[rowKey()];
	}
	function parentId(row) {
		return row[rowKey()];
	}
	function childrenOf(row) {
		return params.getChildren?.(row);
	}
	function isExpanded(id) {
		return expanded.value.includes(id);
	}
	function toggle(id) {
		expanded.value = isExpanded(id) ? expanded.value.filter((value) => value !== id) : [...expanded.value, id];
	}
	const columns = computed(() => toValue(params.columns) ?? []);
	const { sortRows } = useTableSorting(computed(() => columns.value.map((column) => ({
		...column,
		field: column.childField,
		sortableField: column.childField
	}))));
	function sortedChildren(children) {
		const sort = toValue(params.sort);
		if (!sort?.sortBy) return children;
		return sortRows(children, {
			descending: sort.descending,
			sortBy: sort.sortBy
		});
	}
	const flattened = computed(() => {
		const rows = [];
		const meta = /* @__PURE__ */ new Map();
		const emptyIds = /* @__PURE__ */ new Set();
		for (const parent of toValue(params.rows)) {
			const children = childrenOf(parent);
			meta.set(rowId(parent), {
				hasChildren: (children?.length ?? 0) > 0,
				hidden: false,
				isChild: false,
				parentRow: null
			});
			rows.push(parent);
			if (!(params.canExpand?.(parent) ?? true)) continue;
			const collapsed = !isExpanded(parentId(parent));
			let childRows = children ? sortedChildren(children) : [];
			if (params.getChildren && childRows.length === 0) {
				const emptyId = `${String(rowId(parent))}::empty`;
				emptyIds.add(emptyId);
				childRows = [{ [rowKey()]: emptyId }];
			}
			for (const child of childRows) {
				meta.set(rowId(child), {
					hasChildren: false,
					hidden: collapsed,
					isChild: true,
					parentRow: parent
				});
				rows.push(child);
			}
		}
		return {
			emptyIds,
			meta,
			rows
		};
	});
	function isEmptyPlaceholder(row) {
		return flattened.value.emptyIds.has(rowId(row));
	}
	function cellValue(column, row) {
		const meta = flattened.value.meta.get(rowId(row));
		if (!meta || isEmptyPlaceholder(row)) return void 0;
		const accessor = meta.isChild ? column.childField : column.field;
		if (accessor == null) return void 0;
		return typeof accessor === "function" ? accessor(row) : row[accessor];
	}
	function filterValue(column, row) {
		const meta = flattened.value.meta.get(rowId(row));
		if (!meta || isEmptyPlaceholder(row)) return "";
		const accessor = meta.isChild ? column.childFilterableField : column.filterableField;
		if (accessor === true) return String(cellValue(column, row) ?? "");
		if (accessor == null) return "";
		if (typeof accessor === "function") return accessor(row);
		return String(row[accessor] ?? "");
	}
	const groupSortColumns = computed(() => columns.value.map((column) => {
		const wrapped = { ...column };
		wrapped.field = (row) => cellValue(column, row);
		if (column.filterableField != null || column.childFilterableField != null) wrapped.filterableField = (row) => filterValue(column, row);
		const accessor = column.sortableField ?? column.field;
		if (column.sortable !== false && accessor != null) wrapped.sortableField = (row) => {
			const target = flattened.value.meta.get(rowId(row))?.parentRow ?? row;
			return typeof accessor === "function" ? accessor(target) : target[accessor];
		};
		return wrapped;
	}));
	const tableRows = computed(() => flattened.value.rows);
	function metaOf(row) {
		return flattened.value.meta.get(rowId(row));
	}
	return {
		groupSortColumns,
		isExpanded,
		metaOf,
		tableRows,
		toggle
	};
}
/**
* Keeps every matched row plus its parents, so a matching child never shows up
* without its parent (even when the parent itself didn't match). Returns them
* in the same order as `all`.
*/
function keepAncestors(matched, all, parentOf) {
	const keep = new Set(matched);
	for (const row of matched) {
		let parent = parentOf(row);
		while (parent && !keep.has(parent)) {
			keep.add(parent);
			parent = parentOf(parent);
		}
	}
	return all.filter((row) => keep.has(row));
}
//#endregion
//#region src/composables/useValidation.ts
function useValidation(props) {
	const { class: classRef, validation } = toRefs(props);
	const error = computed(() => {
		return !validation.value?.$pending && validation.value?.$error;
	});
	const errorMessage = computed(() => {
		if (!validation.value) return void 0;
		if (!validation.value.$error) return void 0;
		return validation.value.$errors[0]?.$message;
	});
	const isValidated = computed(() => {
		if (!validation.value) return false;
		return validation.value.$dirty && !validation.value.$invalid;
	});
	function onBlur() {
		validation.value?.$touch();
	}
	return {
		classRef,
		error,
		errorMessage,
		isValidated,
		onBlur
	};
}
//#endregion
//#region src/components/FieldsVisibilityDialog/FieldsVisibilityDialogSection.vue?vue&type=script&lang.ts
var FieldsVisibilityDialogSection_vue_vue_type_script_lang_default = defineComponent({
	name: "FieldsVisibilityDialogSection",
	components: { Checkbox: Checkbox_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Section item element that can be set hidden/visible
		*/
		sectionItem: {
			required: true,
			type: Object
		}
	},
	setup(props) {
		function isSectionVisible(item) {
			if (!item.fields.length) return !!item.visible;
			if (item.fields.every((v) => v.visible)) return true;
			else if (item.fields.every((v) => !v.visible)) return false;
			else return null;
		}
		function onToggleSection(field) {
			field.visible = !field.visible;
		}
		return {
			...useAutomation(props.dataAutomation),
			isSectionVisible,
			onToggleSection
		};
	}
});
//#endregion
//#region src/components/FieldsVisibilityDialog/FieldsVisibilityDialogSection.vue
var _hoisted_1$89 = ["data-automation"];
var _hoisted_2$71 = { class: "text-body3" };
var _hoisted_3$56 = { class: "text-body3" };
function _sfc_render$87(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection", true);
	return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
		class: "visibility-section text-black-1 q-pb-sm",
		"data-automation": _ctx.buildId()
	}, [createVNode(_component_Checkbox, {
		dense: "",
		disable: !_ctx.sectionItem.hideable,
		"model-value": _ctx.isSectionVisible(_ctx.sectionItem),
		size: "md",
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.onToggleSection(_ctx.sectionItem))
	}, {
		default: withCtx(() => [createElementVNode("div", _hoisted_2$71, toDisplayString(_ctx.sectionItem.label), 1)]),
		_: 1
	}, 8, ["disable", "model-value"])], 8, _hoisted_1$89), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sectionItem.fields, (field) => {
		return openBlock(), createElementBlock("div", {
			key: field.label,
			class: "visibility-section__fields q-mb-sm"
		}, [field.fields.length ? (openBlock(), createBlock(_component_FieldsVisibilityDialogSection, {
			key: 0,
			"section-item": field
		}, null, 8, ["section-item"])) : (openBlock(), createBlock(_component_Checkbox, {
			key: 1,
			modelValue: field.visible,
			"onUpdate:modelValue": ($event) => field.visible = $event,
			dense: "",
			disable: !field.hideable,
			size: "md"
		}, {
			default: withCtx(() => [createElementVNode("div", _hoisted_3$56, toDisplayString(field.label), 1)]),
			_: 2
		}, 1032, [
			"modelValue",
			"onUpdate:modelValue",
			"disable"
		]))]);
	}), 128))], 64);
}
//#endregion
//#region src/components/FieldsVisibilityDialog/FieldsVisibilityDialog.vue?vue&type=script&lang.ts
var FieldsVisibilityDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "FieldsVisibilityDialog",
	components: {
		Checkbox: Checkbox_default,
		FieldsVisibilityDialogSection: /* @__PURE__ */ _plugin_vue_export_helper_default(FieldsVisibilityDialogSection_vue_vue_type_script_lang_default, [["render", _sfc_render$87], ["__scopeId", "data-v-0476d004"]]),
		RvButton: Button_default,
		RvDialog: Dialog_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Section item element that can be set hidden/visible
		*/
		fields: {
			required: true,
			type: Object
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { dialogRef, onCancel, onOK } = useSidebar();
		const data = ref(Object.entries(props.fields).reduce((acc, [key, v]) => ({
			...acc,
			[key]: v.clone()
		}), {}));
		const allSelected = computed(() => {
			const values = Object.values(data.value);
			if (values.every((v) => v.fields.length ? v.fields.every((v) => v.visible) : v.visible)) return true;
			else if (values.every((v) => v.fields.length ? v.fields.every((v) => !v.visible) : !v.visible)) return false;
			else return null;
		});
		function onToggleAll(visible) {
			data.value = Object.entries(data.value).reduce((acc, [key, v]) => {
				v.visible = visible;
				return {
					...acc,
					[key]: v
				};
			}, {});
		}
		return {
			...useAutomation(props.dataAutomation),
			allSelected,
			data,
			dialogRef,
			onCancel,
			onOK,
			onToggleAll,
			t
		};
	}
});
//#endregion
//#region src/components/FieldsVisibilityDialog/FieldsVisibilityDialog.vue
var _hoisted_1$88 = { class: "text-subtitle1 q-ml-sm text-black-1" };
var _hoisted_2$70 = { class: "row q-pb-sm" };
var _hoisted_3$55 = { class: "text-body3" };
function _sfc_render$86(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_RvDialog = resolveComponent("RvDialog");
	return openBlock(), createBlock(_component_RvDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId()
	}, toHandlers(_ctx.$attrs)), {
		title: withCtx(() => [createElementVNode("span", _hoisted_1$88, toDisplayString(_ctx.t("rvai-base.general.text.showRows")), 1)]),
		default: withCtx(() => [createElementVNode("div", _hoisted_2$70, [createVNode(_component_Checkbox, {
			dense: "",
			"model-value": _ctx.allSelected,
			size: "md",
			"onUpdate:modelValue": _ctx.onToggleAll
		}, {
			default: withCtx(() => [createElementVNode("div", _hoisted_3$55, toDisplayString(_ctx.t("rvai-base.general.text.allRows")), 1)]),
			_: 1
		}, 8, ["model-value", "onUpdate:modelValue"])]), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.data, (item) => {
			return openBlock(), createElementBlock("div", {
				key: item.label,
				class: "col q-pb-sm"
			}, [createVNode(_component_FieldsVisibilityDialogSection, { "section-item": item }, null, 8, ["section-item"])]);
		}), 128))]),
		actions: withCtx(() => [createVNode(_component_RvButton, {
			label: _ctx.t("rvai-base.general.actions.cancel"),
			secondary: "",
			size: "sm",
			onClick: _ctx.onCancel
		}, null, 8, ["label", "onClick"]), createVNode(_component_RvButton, {
			color: "primary",
			label: _ctx.t("rvai-base.general.actions.save"),
			size: "sm",
			onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onOK(_ctx.data))
		}, null, 8, ["label"])]),
		_: 1
	}, 16, ["data-automation"]);
}
var FieldsVisibilityDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FieldsVisibilityDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$86], ["__scopeId", "data-v-87e3af74"]]);
//#endregion
//#region src/components/ActionButton.vue?vue&type=script&lang.ts
var iconStyles = {
	md: {
		iconSize: "1.5rem",
		size: "32px"
	},
	sm: {
		iconSize: "1rem",
		size: "24px"
	}
};
var ActionButton_vue_vue_type_script_lang_default = defineComponent({
	name: "ActionButton",
	components: {
		QBtn: QBtn_default,
		QIcon: QIcon_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Applies to the shortcut 'position: absolute'
		*/
		absoluteShortcut: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
		*/
		icon: {
			type: String,
			default: void 0
		},
		/**
		* Icon size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
		*/
		iconSize: {
			type: String,
			default: void 0
		},
		/**
		* Shows indicator circle in top right corner of the icon
		*/
		indicator: {
			type: Boolean,
			default: false
		},
		/**
		* Adds an optional text to the indicator in the top right
		*/
		indicatorLabel: {
			type: String,
			default: void 0
		},
		/**
		* Put component in selected mode
		*/
		selected: {
			type: Boolean,
			default: false
		},
		/**
		* The text below the button
		*/
		shortcut: {
			type: String,
			default: void 0
		},
		/**
		* Condition that meets whether the shortcut will be shown
		*/
		showShortcuts: {
			type: Boolean,
			default: false
		},
		/**
		* Size in standard size name (sm|md)
		*/
		size: {
			type: String,
			default: "md"
		},
		/**
		* The text that will be shown on the button tooltip; Can be used as a "tooltip" property or as a slot
		*/
		tooltip: {
			type: String,
			default: void 0
		}
	},
	emits: ["click"],
	setup(props, { emit }) {
		const { isDark } = useDarkMode();
		const onClick = throttle((event) => emit("click", event), 200, { trailing: false });
		const iconStyle = computed(() => {
			const style = iconStyles[props.size];
			if (props.iconSize) style.iconSize = props.iconSize;
			return style;
		});
		const textColor = computed(() => {
			if (props.disable) return "grey-2";
			if (props.selected) return isDark.value ? "white--dark" : "primary";
			return "black-1";
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			iconStyle,
			isDark,
			onClick,
			textColor
		};
	}
});
//#endregion
//#region src/components/ActionButton.vue
var _hoisted_1$87 = ["data-automation"];
var _hoisted_2$69 = ["data-automation"];
var _hoisted_3$54 = ["data-automation"];
function _sfc_render$85(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QBtn = resolveComponent("QBtn");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: "action relative-position flex column items-center",
		"data-automation": _ctx.buildId(),
		style: { "--size": _ctx.iconStyle.size }
	}), [createVNode(_component_QBtn, {
		class: normalizeClass(_ctx.$props.class),
		color: _ctx.isDark ? "primary-05op" : "grey-6",
		"data-automation": _ctx.buildId("button"),
		disable: _ctx.disable,
		flat: !_ctx.selected,
		style: normalizeStyle(_ctx.style),
		"text-color": _ctx.textColor,
		unelevated: "",
		onClick: _ctx.onClick
	}, {
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default", {}, void 0, true),
			_ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
				key: 0,
				name: _ctx.icon,
				size: _ctx.iconStyle.iconSize
			}, null, 8, ["name", "size"])) : createCommentVNode("", true),
			_ctx.indicator ? (openBlock(), createElementBlock("div", {
				key: 1,
				class: normalizeClass(["indicator", { "label row justify-center items-center": !!_ctx.indicatorLabel }])
			}, [_ctx.indicatorLabel ? (openBlock(), createElementBlock("span", {
				key: 0,
				"data-automation": _ctx.buildId("indicator-label")
			}, toDisplayString(_ctx.indicatorLabel), 9, _hoisted_2$69)) : createCommentVNode("", true)], 2)) : createCommentVNode("", true),
			_ctx.tooltip || _ctx.$slots.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
				key: 2,
				"data-automation": _ctx.buildId("tooltip"),
				offset: [14, 4]
			}, {
				default: withCtx(() => [_ctx.tooltip ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createTextVNode(toDisplayString(_ctx.tooltip), 1)], 64)) : renderSlot(_ctx.$slots, "tooltip", {}, void 0, true, 1)]),
				_: 3
			}, 8, ["data-automation"])) : createCommentVNode("", true)
		]),
		_: 3
	}, 8, [
		"class",
		"color",
		"data-automation",
		"disable",
		"flat",
		"style",
		"text-color",
		"onClick"
	]), _ctx.showShortcuts && (_ctx.shortcut || _ctx.$slots.shortcut) ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["action__shortcut text-caption text-grey-2", { "absolute-center": _ctx.absoluteShortcut }]),
		"data-automation": _ctx.buildId("shortcut")
	}, [_ctx.shortcut ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createTextVNode(toDisplayString(_ctx.shortcut), 1)], 64)) : renderSlot(_ctx.$slots, "shortcut", {}, void 0, true, 1)], 10, _hoisted_3$54)) : createCommentVNode("", true)], 16, _hoisted_1$87);
}
var ActionButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ActionButton_vue_vue_type_script_lang_default, [["render", _sfc_render$85], ["__scopeId", "data-v-d992ada4"]]);
//#endregion
//#region src/components/AutoHeight.vue?vue&type=script&lang.ts
var AutoHeight_vue_vue_type_script_lang_default = defineComponent({
	name: "AutoHeight",
	components: { QResizeObserver: QResizeObserver_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		offset: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const height = ref(0);
		const heightStyle = computed(() => ({ height: `${height.value - props.offset}px` }));
		function onResize(dimensions) {
			height.value = dimensions.height;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			heightStyle,
			onResize
		};
	}
});
//#endregion
//#region src/components/AutoHeight.vue
var _hoisted_1$86 = ["data-automation"];
function _sfc_render$84(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	return openBlock(), createElementBlock("div", { "data-automation": _ctx.buildId() }, [createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]), renderSlot(_ctx.$slots, "default", { heightStyle: _ctx.heightStyle })], 8, _hoisted_1$86);
}
var AutoHeight_default = /*#__PURE__*/ _plugin_vue_export_helper_default(AutoHeight_vue_vue_type_script_lang_default, [["render", _sfc_render$84]]);
//#endregion
//#region src/components/Avatar/avatarConfig.ts
var FONT_SIZE_MAP = {
	lg: "18px",
	md: "12px",
	sm: "10px",
	xl: "60px",
	xs: "7px"
};
var SIZE_MAP = {
	lg: "44px",
	md: "30px",
	sm: "24px",
	xl: "120px",
	xs: "18px"
};
var ICON_SIZE_MAP = {
	lg: "25px",
	md: "18px",
	sm: "14px",
	xl: "84px",
	xs: "10px"
};
//#endregion
//#region src/components/Avatar/Avatar.vue?vue&type=script&lang.ts
var DEFAULT_PRIMARY = "#F2209E";
var SIZES = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl"
];
var DEFAULT_SIZE = "sm";
var COLOR_BLACK = getCssVar("black-1-fixed") ?? "#1F2641";
var COLOR_GREY = getCssVar("grey-2") ?? "#97A1BF";
var COLOR_WHITE = getCssVar("white-fixed") ?? "#FFFFFF";
var __default__$5 = defineComponent({
	name: "Avatar",
	components: {
		QAvatar: QAvatar_default,
		QIcon: QIcon_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Color name for component from the Quasar Color Palette or HEX color
		*/
		backgroundColor: {
			type: String,
			default: ""
		},
		/**
		* Color name for component from the Quasar Color Palette or HEX color
		*/
		borderColor: {
			type: String,
			default: "white"
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Render component in hidable state based on boolean value if passed
		*/
		hidden: {
			type: Boolean,
			default: void 0
		},
		/**
		* Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
		*/
		icon: {
			type: String,
			default: void 0
		},
		/**
		* The avatar image to be displayed. If missing, it display the initials.
		*/
		image: {
			type: String,
			default: void 0
		},
		/**
		* The text displayed in the component
		*/
		initials: {
			type: String,
			default: void 0
		},
		/**
		* The first 2 letters are displayed in the component
		*/
		label: {
			type: String,
			default: ""
		},
		/**
		* Prevent display of "initials", show full "label"
		*/
		noInitial: {
			type: Boolean,
			default: false
		},
		/**
		* Render a diagonal line
		*/
		crossed: {
			type: Boolean,
			default: false
		},
		/**
		* Render logo
		*/
		showLogo: {
			type: Boolean,
			default: false
		},
		/**
		* Render tooltip
		*/
		showTooltip: {
			type: Boolean,
			default: true
		},
		/**
		* Size in standard size name (xs|sm|md|lg|xl)
		*/
		size: {
			type: String,
			default: DEFAULT_SIZE,
			validator: (v) => SIZES.includes(v)
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Text color name for component from the Quasar Color Palette
		*/
		textColor: {
			type: String,
			default: ""
		},
		/**
		* UUID must be passed in tables for the correct display of tooltips
		*/
		uuid: {
			type: [Number, String],
			default: void 0
		}
	},
	emits: ["click"],
	setup(props, { emit }) {
		const { isDark } = useDarkMode();
		const { getPaletteColorCache } = usePaletteColorsCache();
		const isPrimaryOverridden = getCssVar("primary")?.toUpperCase() !== DEFAULT_PRIMARY;
		const avatarSize = computed(() => {
			return SIZE_MAP[props.size] ?? SIZE_MAP[DEFAULT_SIZE];
		});
		const fontSize = computed(() => {
			return FONT_SIZE_MAP[props.size] ?? FONT_SIZE_MAP[DEFAULT_SIZE];
		});
		const iconSize = computed(() => {
			return ICON_SIZE_MAP[props.size] ?? ICON_SIZE_MAP[DEFAULT_SIZE];
		});
		const hidable = computed(() => typeof props.hidden === "boolean");
		const initialsValue = computed(() => {
			if (props.initials) return props.initials;
			const [label] = (props.label ?? "").split("@");
			try {
				const initials = label.replace(/\([^)]*\)/g, "").replace(/[-_]/g, " ").replace(/\B([A-Z])/g, " $1").match(/\b\w/g) || [];
				return (initials.length > 1 ? (initials.shift() ?? "") + (initials.pop() ?? "") : label.substring(0, 2)).toUpperCase();
			} catch {
				return label.substring(0, 2).toUpperCase();
			}
		});
		const computedBorderColor = computed(() => isHexColor(props.borderColor) ? props.borderColor : getPaletteColorCache(props.borderColor));
		const styles = computed(() => {
			let background;
			if (props.disable) background = COLOR_GREY;
			else if (!isPrimaryOverridden && props.uuid && !props.showLogo && !props.image) background = getUserColor(props.uuid);
			const backgroundProps = props.backgroundColor ? isHexColor(props.backgroundColor) ? props.backgroundColor : getPaletteColorCache(props.backgroundColor) : void 0;
			const defaultBackgroundColor = isDark.value ? COLOR_WHITE : COLOR_BLACK;
			const defaultColor = isDark.value ? COLOR_BLACK : COLOR_WHITE;
			return {
				background: backgroundProps ?? background ?? defaultBackgroundColor,
				color: backgroundProps || background ? COLOR_WHITE : defaultColor
			};
		});
		function isHexColor(color) {
			return /^#([0-9a-f]{3}){1,2}$/i.test(color);
		}
		function onClick(event) {
			if (props.disable) return;
			emit("click", event);
		}
		return {
			...useAutomation(props.dataAutomation),
			avatarSize,
			computedBorderColor,
			fontSize,
			hidable,
			iconSize,
			initialsValue,
			onClick,
			styles
		};
	}
});
var __injectCSSVars__$5 = () => {
	useCssVars((_ctx) => ({ "aa4e3546": _ctx.computedBorderColor }));
};
var __setup__$5 = __default__$5.setup;
__default__$5.setup = __setup__$5 ? (props, ctx) => {
	__injectCSSVars__$5();
	return __setup__$5(props, ctx);
} : __injectCSSVars__$5;
//#endregion
//#region src/components/Avatar/Avatar.vue
var _hoisted_1$85 = ["data-automation"];
var _hoisted_2$68 = ["data-automation"];
var _hoisted_3$53 = ["data-automation"];
function _sfc_render$83(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QAvatar = resolveComponent("QAvatar");
	return openBlock(), createElementBlock("div", {
		class: "rv-avatar-wrapper",
		"data-automation": _ctx.buildId("wrapper")
	}, [createVNode(_component_QAvatar, mergeProps({ class: ["rv-avatar text-weight-medium", [_ctx.$props.class, { "rv-avatar--hidable": _ctx.hidable }]] }, _ctx.dataAttrs, {
		"data-automation": _ctx.buildId(),
		"font-size": _ctx.fontSize,
		icon: _ctx.icon,
		size: _ctx.avatarSize,
		style: [_ctx.styles, _ctx.style],
		"text-color": _ctx.textColor,
		onClick: _ctx.onClick
	}), {
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default", {}, () => [_ctx.hidden ? (openBlock(), createBlock(_component_QIcon, {
				key: 0,
				class: "rv-avatar__hidden",
				name: "rvai-base:eye-off",
				size: _ctx.iconSize
			}, null, 8, ["size"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [_ctx.hidable ? (openBlock(), createBlock(_component_QIcon, {
				key: 0,
				class: "rv-avatar__visible hidden",
				name: "rvai-base:eye",
				size: _ctx.iconSize
			}, null, 8, ["size"])) : createCommentVNode("", true), _ctx.image ? (openBlock(), createElementBlock("div", {
				key: 1,
				class: "rv-avatar__image",
				"data-automation": _ctx.buildId("image"),
				style: normalizeStyle({ "background-image": `url(${_ctx.image})` })
			}, null, 12, _hoisted_2$68)) : _ctx.showLogo ? (openBlock(), createBlock(_component_QIcon, {
				key: 2,
				class: "rv-avatar__content",
				"data-automation": _ctx.buildId("logo"),
				name: "rvai-base:robovision",
				size: _ctx.iconSize
			}, null, 8, ["data-automation", "size"])) : (openBlock(), createElementBlock("div", {
				key: 3,
				class: "rv-avatar__content",
				"data-automation": _ctx.buildId("label")
			}, toDisplayString(_ctx.noInitial ? _ctx.label : _ctx.initialsValue), 9, _hoisted_3$53))], 64))], true),
			renderSlot(_ctx.$slots, "extra", {}, void 0, true),
			createElementVNode("span", { class: normalizeClass({ "rv-avatar--crossed": _ctx.crossed }) }, null, 2),
			_ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
				key: 0,
				anchor: "bottom middle",
				"data-automation": _ctx.buildId("tooltip"),
				self: "center middle"
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			}, 8, ["data-automation"])) : createCommentVNode("", true)
		]),
		_: 3
	}, 16, [
		"class",
		"data-automation",
		"font-size",
		"icon",
		"size",
		"style",
		"text-color",
		"onClick"
	])], 8, _hoisted_1$85);
}
var Avatar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__$5, [["render", _sfc_render$83], ["__scopeId", "data-v-3d2fd545"]]);
//#endregion
//#region src/components/BackButton.vue?vue&type=script&lang.ts
var BackButton_vue_vue_type_script_lang_default = defineComponent({
	name: "BackButton",
	components: {
		QIcon: QIcon_default,
		RvButton: Button_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		collapseWithLeftSidebar: {
			type: Boolean,
			default: false
		},
		defaultRoute: {
			type: [Object, String],
			default: void 0
		},
		directRoute: {
			type: [Object, String],
			default: void 0
		}
	},
	setup(props) {
		const { showLeftSidebar } = useLayout();
		const { getPreviousPageLabel, goToPreviousPage } = useNavigationHistory(props.defaultRoute, props.directRoute);
		const collapse = computed(() => {
			return props.collapseWithLeftSidebar && !showLeftSidebar.value;
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			collapse,
			goToPreviousPage,
			label: getPreviousPageLabel()
		};
	}
});
//#endregion
//#region src/components/BackButton.vue
var _hoisted_1$84 = ["data-automation"];
var _hoisted_2$67 = {
	key: 0,
	class: "text-no-wrap"
};
function _sfc_render$82(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["bg-white rounded-borders q-py-md", {
			"q-px-lg": !_ctx.collapse,
			"flex items-center justify-center": _ctx.collapse
		}]),
		"data-automation": _ctx.buildId("wrapper")
	}, [createVNode(_component_RvButton, {
		align: "left",
		class: "no-padding",
		"data-automation": _ctx.buildId(),
		size: "sm",
		tertiary: "",
		onClick: _ctx.goToPreviousPage
	}, {
		default: withCtx(() => [createVNode(_component_QIcon, {
			class: normalizeClass({ "q-mr-sm": !_ctx.collapse }),
			name: "mdi-chevron-left",
			size: "1.5rem"
		}, {
			default: withCtx(() => [_ctx.collapse ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			})) : createCommentVNode("", true)]),
			_: 1
		}, 8, ["class"]), !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_2$67, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true)]),
		_: 1
	}, 8, ["data-automation", "onClick"])], 10, _hoisted_1$84);
}
var BackButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(BackButton_vue_vue_type_script_lang_default, [["render", _sfc_render$82]]);
//#endregion
//#region src/components/Bullet.vue?vue&type=script&lang.ts
var Bullet_vue_vue_type_script_lang_default = defineComponent({
	name: "Bullet",
	components: { Tooltip: Tooltip_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Css color of the bullet border.
		*/
		borderColor: {
			type: String,
			default: void 0
		},
		/**
		* Color name for component
		*/
		color: {
			type: String,
			default: ""
		},
		/**
		* Render a diagonal line
		*/
		crossed: {
			type: Boolean,
			default: false
		},
		/**
		* Render tooltip
		*/
		isTooltipShown: {
			type: Boolean,
			default: true
		},
		/**
		* Render label before bullet
		*/
		label: {
			type: [Number, String],
			default: void 0
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Render a plus sign inside component and hides the label
		*/
		more: {
			type: Boolean,
			default: false
		},
		/**
		* Render a plus sign inside component, shows label if any
		*/
		moreWithLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Disable rendering a border with a contrasting color
		*/
		noContrastBorder: {
			type: Boolean,
			default: false
		},
		/**
		* Show bullet as a circle block
		*/
		rounded: {
			type: Boolean,
			default: false
		},
		/**
		* Wrapper size (in px)
		*/
		size: {
			type: [Number, String],
			default: 8
		},
		/**
		* Can be used as a "tooltip" property or as a slot
		*/
		tooltip: {
			type: String,
			default: void 0
		},
		/**
		* Two values setting the starting position or anchor point of the Tooltip relative to its target
		*/
		tooltipAnchor: {
			type: String,
			default: "bottom middle"
		},
		/**
		* The maximum width of the Tooltip; Size in CSS units, including unit name
		*/
		tooltipMaxWidth: {
			type: String,
			default: "400px"
		},
		/**
		* Two values setting the Tooltip's own position relative to its target
		*/
		tooltipSelf: {
			type: String,
			default: "center middle"
		},
		/**
		* Render a bracket indicator around the bullet
		*/
		withIndicator: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { isDark } = useDarkMode();
		const containerSize = computed(() => {
			let size = parseInt(props.size.toString());
			if (!props.rounded) size = Math.round(size * Math.SQRT2);
			if (props.withIndicator) size += 4 + size % 2;
			return size;
		});
		const moreBullet = computed(() => props.more || props.moreWithLabel);
		const contrastBorderColor = computed(() => {
			if (props.borderColor) {
				if (props.borderColor.startsWith("#")) return props.borderColor;
				return getCssVar(props.borderColor) ?? void 0;
			}
			if (props.noContrastBorder) return resolvedColor.value;
			return getContrastColor(resolvedColor.value, isDark.value ? "transparent" : getCssVar("grey-1") ?? void 0, isDark.value ? getCssVar("grey-1") ?? void 0 : "transparent");
		});
		const resolvedColor = computed(() => {
			if (props.color.startsWith("#")) return props.color;
			return getCssVar(props.color) ?? getCssVar("grey-1");
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			containerSize,
			contrastBorderColor,
			moreBullet,
			resolvedColor,
			t
		};
	}
});
//#endregion
//#region src/components/Bullet.vue
var _hoisted_1$83 = ["data-automation"];
var _hoisted_2$66 = ["data-automation"];
var _hoisted_3$52 = ["data-automation"];
var _hoisted_4$35 = ["data-automation"];
var _hoisted_5$29 = {
	key: 0,
	class: "plus"
};
var _hoisted_6$17 = {
	key: 1,
	class: "crossed"
};
var _hoisted_7$14 = {
	key: 2,
	class: "content-block"
};
var _hoisted_8$10 = ["data-automation"];
function _sfc_render$81(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		class: "flex inline items-center justify-center no-wrap text-center vertical-middle",
		"data-automation": _ctx.buildId(),
		style: normalizeStyle({
			"--container-size": `${_ctx.containerSize}px`,
			"--size": `${_ctx.size}px`
		})
	}, [_ctx.label != null && !_ctx.more ? (openBlock(), createElementBlock("span", {
		key: 0,
		class: normalizeClass(["text-body3 text-grey-1 q-mr-xs", _ctx.labelClass]),
		"data-automation": _ctx.buildId("label")
	}, toDisplayString(_ctx.label), 11, _hoisted_2$66)) : createCommentVNode("", true), createElementVNode("div", {
		class: "bullet__container relative-position flex items-center justify-center",
		"data-automation": _ctx.buildId("bullet__container")
	}, [
		createElementVNode("div", {
			class: normalizeClass(["bullet inline-block", {
				"bullet--crossed": _ctx.crossed,
				"bullet--more": _ctx.moreBullet,
				"rounded": _ctx.rounded
			}]),
			"data-automation": _ctx.buildId("bullet__container--bullet"),
			style: normalizeStyle({
				..._ctx.color && { backgroundColor: _ctx.resolvedColor },
				"border": `1px solid ${_ctx.contrastBorderColor} !important`
			})
		}, null, 14, _hoisted_4$35),
		_ctx.moreBullet ? (openBlock(), createElementBlock("div", _hoisted_5$29, toDisplayString(_ctx.t("rvai-base.general.symbols.plus")), 1)) : _ctx.crossed ? (openBlock(), createElementBlock("div", _hoisted_6$17)) : createCommentVNode("", true),
		_ctx.$slots["content"] ? (openBlock(), createElementBlock("div", _hoisted_7$14, [renderSlot(_ctx.$slots, "content", {}, void 0, true)])) : createCommentVNode("", true),
		_ctx.withIndicator ? (openBlock(), createElementBlock("div", {
			key: 3,
			"data-automation": _ctx.buildId("bullet-indicator")
		}, [..._cache[0] || (_cache[0] = [
			createElementVNode("div", { class: "bullet-indicator bullet-indicator--top-left" }, null, -1),
			createElementVNode("div", { class: "bullet-indicator bullet-indicator--top-right" }, null, -1),
			createElementVNode("div", { class: "bullet-indicator bullet-indicator--bottom-left" }, null, -1),
			createElementVNode("div", { class: "bullet-indicator bullet-indicator--bottom-right" }, null, -1)
		])], 8, _hoisted_8$10)) : createCommentVNode("", true),
		_ctx.isTooltipShown && (_ctx.tooltip || _ctx.moreBullet || _ctx.$slots["tooltip"]) ? (openBlock(), createBlock(_component_Tooltip, {
			key: 4,
			anchor: _ctx.tooltipAnchor,
			"data-automation": _ctx.buildId("tooltip"),
			"max-width": _ctx.tooltipMaxWidth,
			self: _ctx.tooltipSelf
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "tooltip", {}, void 0, true), !_ctx.$slots["tooltip"] ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createTextVNode(toDisplayString(_ctx.moreBullet ? _ctx.label : _ctx.tooltip), 1)], 64)) : createCommentVNode("", true)]),
			_: 3
		}, 8, [
			"anchor",
			"data-automation",
			"max-width",
			"self"
		])) : createCommentVNode("", true)
	], 8, _hoisted_3$52)], 12, _hoisted_1$83);
}
var Bullet_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Bullet_vue_vue_type_script_lang_default, [["render", _sfc_render$81], ["__scopeId", "data-v-b54363c0"]]);
//#endregion
//#region src/components/BarChart.vue?vue&type=script&lang.ts
var HISTOGRAM_DEFAULT_SIZE = 276;
var LABEL_MAX_WIDTH = 140;
var MIN_SPACING = 100;
var ROW_DEFAULT_MIN_HEIGHT = 8;
var ROW_DETAILED_MIN_HEIGHT = 20;
var BarChart_vue_vue_type_script_lang_default = defineComponent({
	name: "Histogram",
	components: {
		Bullet: Bullet_default,
		QInnerLoading: QInnerLoading_default,
		QResizeObserver: QResizeObserver_default,
		QSpace: QSpace_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Displays all info in a row (classNames, percentages, etc)
		*/
		detailed: {
			type: Boolean,
			default: false
		},
		/**
		* Bar height
		*/
		barHeight: {
			type: Number,
			default: void 0
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Class distribution data
		*/
		entries: {
			type: Array,
			required: true
		},
		/**
		* Displays class names and percentages
		*/
		full: {
			type: Boolean,
			default: false
		},
		/**
		* Displays spinner
		*/
		loading: {
			type: Boolean,
			default: false
		},
		/**
		* Component max height
		*/
		maxHeight: {
			type: Number,
			default: void 0
		},
		/**
		* Emits 'update:selected' with row.id, when true
		*/
		selectable: {
			type: Boolean,
			default: false
		},
		/**
		* v-model:selected; allows handling selected class
		*/
		selected: {
			type: String,
			default: void 0
		},
		/**
		* Shows class name or class id
		*/
		showName: {
			type: Boolean,
			default: false
		},
		/**
		* Histogram size ('sm' | 'md')
		*/
		size: {
			type: String,
			default: "sm"
		}
	},
	emits: ["update:selected"],
	setup(props, { emit }) {
		const histogramRef = ref(null);
		const availableWidth = ref(0);
		const { t } = useI18n();
		const barMargin = computed(() => props.detailed ? 2 : 1);
		const rowMinHeight = computed(() => props.detailed ? ROW_DETAILED_MIN_HEIGHT : ROW_DEFAULT_MIN_HEIGHT);
		const rowHeight = computed(() => {
			return Math.max(histogramSize.value / props.entries.length - barMargin.value - (props.detailed ? barMargin.value : 0), rowMinHeight.value);
		});
		const computedBarHeight = computed(() => props.barHeight ?? Math.max(rowHeight.value, ROW_DEFAULT_MIN_HEIGHT));
		const isContentScrollable = computed(() => {
			return rowHeight.value <= rowMinHeight.value;
		});
		const histogramSize = computed(() => props.maxHeight || histogramRef.value?.offsetHeight || HISTOGRAM_DEFAULT_SIZE);
		const maxCount = computed(() => Math.max(...props.entries.map((c) => c.count)));
		const countLimit = computed(() => last(stepsValues.value) ?? 0);
		const entriesWithSize = computed(() => {
			const max = props.full ? countLimit.value : maxCount.value;
			return props.entries.map((c) => {
				const size = max ? 100 * (c.count / max) : 0;
				return {
					...c,
					size: `${size}%`
				};
			});
		});
		const labelWidth = computed(() => {
			if (props.full) return 24;
			return (computedBarHeight.value >= 16 ? 8 : 4) * 2;
		});
		const hasSquareBackground = computed(() => !props.full && props.size === "sm");
		const stepsValues = computed(() => {
			if (!availableWidth.value) return [];
			const stepPow = 10 ** Math.max(0, Math.floor(Math.log10(maxCount.value)));
			const maxSteps = Math.max(1, Math.floor(availableWidth.value / MIN_SPACING));
			const minStepSize = maxCount.value / maxSteps;
			const stepSize = Math.ceil(minStepSize / stepPow) * stepPow;
			const stepsCount = Math.max(1, Math.ceil(maxCount.value / stepSize));
			return Array.from({ length: stepsCount + 1 }).map((_, index) => index * stepSize);
		});
		const steps = computed(() => {
			if (!countLimit.value) return [];
			return stepsValues.value.map((s) => [String(s), `${100 * s / countLimit.value}%`]);
		});
		const stepsBars = computed(() => {
			return steps.value.map((p) => p[1]);
		});
		function getBulletSize() {
			return computedBarHeight.value >= 16 || props.full || props.detailed ? 8 : 4;
		}
		function isSelected(row) {
			return props.selected === row.id;
		}
		function isAnnotated(row) {
			return !["null", null].includes(row.id);
		}
		function isEmpty(row) {
			return [""].includes(row.id);
		}
		function onClick(row) {
			if (!props.selectable) return;
			if (isSelected(row)) emit("update:selected", void 0);
			else emit("update:selected", row.id);
		}
		function onResize({ width }) {
			availableWidth.value = width - LABEL_MAX_WIDTH;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			barMargin,
			computedBarHeight,
			entriesWithSize,
			getBulletSize,
			hasSquareBackground,
			histogramRef,
			histogramSize,
			isAnnotated,
			isContentScrollable,
			isEmpty,
			isSelected,
			labelWidth,
			onClick,
			onResize,
			steps,
			stepsBars,
			t
		};
	}
});
//#endregion
//#region src/components/BarChart.vue
var _hoisted_1$82 = ["data-automation"];
var _hoisted_2$65 = ["data-automation", "onClick"];
var _hoisted_3$51 = {
	key: 2,
	class: "ellipsis"
};
var _hoisted_4$34 = { class: "full-width" };
var _hoisted_5$28 = ["data-automation"];
var _hoisted_6$16 = {
	key: 0,
	class: "histogram__values row no-wrap items-center q-mx-sm"
};
var _hoisted_7$13 = ["data-automation"];
var _hoisted_8$9 = ["data-automation"];
var _hoisted_9$8 = {
	key: 1,
	class: "histogram__pct-bar-wrapper"
};
var _hoisted_10$5 = ["data-automation"];
var _hoisted_11$5 = ["data-automation"];
var _hoisted_12$4 = { class: "histogram__pct-wrapper relative-position col-grow text-right q-pa-xs q-mt-md" };
var _hoisted_13$4 = ["data-automation"];
function _sfc_render$80(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QInnerLoading = resolveComponent("QInnerLoading");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	const _component_Bullet = resolveComponent("Bullet");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		ref: "histogramRef",
		class: normalizeClass(["histogram relative-position row no-wrap", [_ctx.$props.class, {
			"bg-grey-5--light bg-grey-1--dark": !_ctx.full && !_ctx.detailed,
			"histogram--custom-height": _ctx.maxHeight,
			"histogram--full": _ctx.full,
			"histogram--min-height": _ctx.loading,
			"histogram--square": _ctx.hasSquareBackground
		}]]),
		"data-automation": _ctx.buildId(),
		style: normalizeStyle({ "--histogram-size": `${_ctx.histogramSize}px` })
	}, [createVNode(_component_QInnerLoading, {
		class: "z-top",
		color: "primary",
		"data-automation": _ctx.buildId("loading"),
		showing: _ctx.loading
	}, null, 8, ["data-automation", "showing"]), createElementVNode("div", {
		class: normalizeClass(["histogram__wrapper relative-position col", { "histogram__wrapper--scrollable": _ctx.isContentScrollable }]),
		style: normalizeStyle({ "--bar-height": `${_ctx.computedBarHeight}px` })
	}, [
		_ctx.full || _ctx.detailed ? (openBlock(), createBlock(_component_QResizeObserver, {
			key: 0,
			onResize: _ctx.onResize
		}, null, 8, ["onResize"])) : createCommentVNode("", true),
		(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entriesWithSize, (entry) => {
			return openBlock(), createElementBlock("div", {
				key: entry.id,
				class: normalizeClass(["histogram__entry row no-wrap", {
					"cursor-pointer": _ctx.selectable,
					"histogram__entry--full": _ctx.full,
					"histogram__entry--detailed": _ctx.detailed,
					"histogram__entry--selected": _ctx.isSelected(entry)
				}]),
				"data-automation": _ctx.buildId(`entry-${entry.id}`),
				style: normalizeStyle({
					"--bar-margin": `${_ctx.barMargin}px`,
					"--color": entry.color,
					"--entries-count": _ctx.entries.length,
					"--entry-min-height": _ctx.full || _ctx.detailed ? "20px" : `${_ctx.barHeight}px`,
					"--entry-size": entry.size
				}),
				onClick: ($event) => _ctx.onClick(entry)
			}, [
				createElementVNode("div", {
					class: normalizeClass(["histogram__label row items-center text-small text-bold col-fixed", [
						{ "histogram__label--full q-pr-sm": _ctx.full || _ctx.detailed },
						{ "q-ml-sm": _ctx.detailed },
						_ctx.full || _ctx.detailed || _ctx.isAnnotated(entry) ? "q-pr-sm" : "q-pr-xs"
					]]),
					style: normalizeStyle({ ...!_ctx.full && !_ctx.detailed && { width: `${_ctx.labelWidth}px` } })
				}, [createElementVNode("div", {
					class: "row items-center no-wrap zero-min-width",
					style: normalizeStyle({ fontSize: _ctx.full || _ctx.detailed ? "inherit" : "6px" })
				}, [
					_ctx.isAnnotated(entry) ? (openBlock(), createBlock(_component_Bullet, {
						key: 0,
						class: "col-fixed q-mr-xs",
						color: entry.color,
						crossed: _ctx.isEmpty(entry),
						"data-automation": _ctx.buildId("bullet"),
						size: _ctx.getBulletSize()
					}, null, 8, [
						"color",
						"crossed",
						"data-automation",
						"size"
					])) : createCommentVNode("", true),
					entry.id === "null" ? (openBlock(), createElementBlock("div", {
						key: 1,
						style: normalizeStyle({ width: `${_ctx.labelWidth}px` })
					}, null, 4)) : createCommentVNode("", true),
					_ctx.full || _ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_3$51, toDisplayString(_ctx.showName ? entry.name : entry.id === "null" ? _ctx.t("rvai-base.components.histogram.noLabel") : entry.id), 1)) : createCommentVNode("", true)
				], 4)], 6),
				createElementVNode("div", _hoisted_4$34, [createElementVNode("div", {
					class: normalizeClass(["histogram__bar relative-position z-fab", {
						"histogram__bar--none": !_ctx.isAnnotated(entry),
						"histogram__bar--empty": _ctx.isEmpty(entry)
					}]),
					"data-automation": _ctx.buildId(`entry__bar--${entry.id}`)
				}, null, 10, _hoisted_5$28)]),
				_ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_6$16, [
					createElementVNode("div", {
						class: "histogram__count text-bold",
						"data-automation": _ctx.buildId(`entry__count--${entry.id}`)
					}, toDisplayString(entry.count), 9, _hoisted_7$13),
					createVNode(_component_QSpace),
					createElementVNode("div", {
						class: "histogram__percentage q-ml-xs row items-center justify-end",
						"data-automation": _ctx.buildId(`entry__percentage--${entry.id}`)
					}, toDisplayString(entry.pct), 9, _hoisted_8$9)
				])) : createCommentVNode("", true),
				_ctx.$slots["tooltip"] ? (openBlock(), createBlock(_component_Tooltip, {
					key: 1,
					anchor: "center left",
					"data-automation": _ctx.buildId("tooltip"),
					offset: [_ctx.full ? -150 : -20, 0],
					self: "center left"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "tooltip", { entry }, void 0, true)]),
					_: 2
				}, 1032, ["data-automation", "offset"])) : createCommentVNode("", true)
			], 14, _hoisted_2$65);
		}), 128)),
		_ctx.full ? (openBlock(), createElementBlock("div", _hoisted_9$8, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stepsBars, (left, index) => {
			return openBlock(), createElementBlock("div", {
				key: index,
				class: "histogram__pct-bar",
				"data-automation": _ctx.buildId(`bar-${index}`),
				style: normalizeStyle({ "left": left })
			}, null, 12, _hoisted_10$5);
		}), 128))])) : createCommentVNode("", true),
		_ctx.full ? (openBlock(), createElementBlock("div", {
			key: 2,
			class: "histogram__footer",
			"data-automation": _ctx.buildId("footer")
		}, [createElementVNode("div", _hoisted_12$4, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps, ([count, left], index) => {
			return openBlock(), createElementBlock("div", {
				key: index,
				class: "histogram__pct text-bold text-grey-1",
				"data-automation": _ctx.buildId(`step-${index}`),
				style: normalizeStyle({ "left": left })
			}, toDisplayString(count), 13, _hoisted_13$4);
		}), 128))])], 8, _hoisted_11$5)) : createCommentVNode("", true)
	], 6)], 14, _hoisted_1$82);
}
var BarChart_default = /*#__PURE__*/ _plugin_vue_export_helper_default(BarChart_vue_vue_type_script_lang_default, [["render", _sfc_render$80], ["__scopeId", "data-v-a5447bb7"]]);
//#endregion
//#region src/components/Separator.vue?vue&type=script&lang.ts
var Separator_vue_vue_type_script_lang_default = defineComponent({
	name: "Separator",
	inheritAtttrs: false,
	components: { QSeparator: QSeparator_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "separator"
		},
		/**
		* Dark theme color name for component from the Quasar Color Palette
		*/
		colorDark: {
			type: String,
			default: "grey-2--dark"
		},
		/**
		* Light theme color name for component from the Quasar Color Palette
		*/
		colorLight: {
			type: String,
			default: "grey-3--light"
		},
		/**
		* If set to true, the separator will be vertical
		*/
		vertical: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { isDark } = useDarkMode();
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			isDark
		};
	}
});
//#endregion
//#region src/components/Separator.vue
function _sfc_render$79(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QSeparator = resolveComponent("QSeparator");
	return openBlock(), createBlock(_component_QSeparator, {
		color: _ctx.isDark ? _ctx.colorDark : _ctx.colorLight,
		"data-automation": _ctx.buildId(),
		vertical: _ctx.vertical
	}, null, 8, [
		"color",
		"data-automation",
		"vertical"
	]);
}
var Separator_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Separator_vue_vue_type_script_lang_default, [["render", _sfc_render$79]]);
//#endregion
//#region src/components/Card.vue?vue&type=script&lang.ts
var Card_vue_vue_type_script_lang_default = defineComponent({
	name: "Card",
	components: {
		QMenu: QMenu_default,
		RvButton: Button_default,
		Separator: Separator_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Separator animated on hover,
		* if false - only when component is clickable
		*/
		alwaysAnimated: {
			type: Boolean,
			default: true
		},
		/**
		* Text displayed in description
		*/
		description: {
			type: String,
			default: ""
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: ""
		},
		/**
		* Equivalent to Vue Router <router-link> 'to' property
		*/
		to: {
			type: [Object, String],
			default: void 0
		}
	},
	setup(props) {
		const headerHover = ref(false);
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			headerHover,
			RouterLink
		};
	}
});
//#endregion
//#region src/components/Card.vue
var _hoisted_1$81 = ["data-automation"];
var _hoisted_2$64 = { class: "column" };
var _hoisted_3$50 = ["data-automation"];
var _hoisted_4$33 = ["data-automation"];
function _sfc_render$78(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QMenu = resolveComponent("QMenu");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Separator = resolveComponent("Separator");
	return openBlock(), createElementBlock("div", {
		class: "rounded-borders bg-grey-5 q-pa-md",
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", { class: normalizeClass(["card column relative-position", { "card--animated": _ctx.alwaysAnimated }]) }, [
		_ctx.$slots["actions"] || _ctx.$slots["header"] || _ctx.title || _ctx.description ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to && !_ctx.$slots["content"] ? _ctx.RouterLink : "div"), {
			key: 0,
			class: normalizeClass(["card__header row justify-between items-start q-pa-md", {
				"card__header--animated": _ctx.to && !_ctx.$slots["content"] && !_ctx.$slots["actions"] && !_ctx.$slots["header"],
				"card__header--clickable": _ctx.to && !_ctx.$slots["content"]
			}]),
			to: _ctx.to,
			onMouseout: _cache[1] || (_cache[1] = ($event) => _ctx.headerHover = false),
			onMouseover: _cache[2] || (_cache[2] = ($event) => _ctx.headerHover = true)
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, () => [createElementVNode("div", _hoisted_2$64, [createElementVNode("div", {
				class: "text-subtitle3 text-black-1",
				"data-automation": _ctx.buildId("title")
			}, toDisplayString(_ctx.title), 9, _hoisted_3$50), createElementVNode("div", { "data-automation": _ctx.buildId("description") }, toDisplayString(_ctx.description), 9, _hoisted_4$33)])], true), _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_RvButton, {
				key: 0,
				class: "card__dots no-padding absolute",
				color: "grey-1",
				"data-automation": _ctx.buildId("actions"),
				icon: "mdi-dots-horizontal",
				tertiary: "",
				onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop", "prevent"]))
			}, {
				default: withCtx(() => [createVNode(_component_QMenu, { "auto-close": "" }, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "actions", {}, void 0, true)]),
					_: 3
				})]),
				_: 3
			}, 8, ["data-automation"])) : createCommentVNode("", true)]),
			_: 3
		}, 40, ["class", "to"])) : createCommentVNode("", true),
		_ctx.$slots["content"] ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
			key: 1,
			class: "card__content",
			to: _ctx.to
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "content", {}, void 0, true)]),
			_: 3
		}, 8, ["to"])) : createCommentVNode("", true),
		_ctx.$slots["bottom"] ? (openBlock(), createBlock(_component_Separator, {
			key: 2,
			class: "card__separator q-mx-md",
			color: "grey-3"
		})) : createCommentVNode("", true),
		_ctx.$slots["bottom"] ? (openBlock(), createElementBlock("div", {
			key: 3,
			class: "card__content-bottom",
			onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["stop", "prevent"]))
		}, [renderSlot(_ctx.$slots, "bottom", {}, void 0, true)])) : createCommentVNode("", true)
	], 2)], 8, _hoisted_1$81);
}
var Card_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Card_vue_vue_type_script_lang_default, [["render", _sfc_render$78], ["__scopeId", "data-v-54432239"]]);
//#endregion
//#region src/components/CardImage.vue?vue&type=script&lang.ts
var CardImage_vue_vue_type_script_lang_default = defineComponent({
	name: "CardImage",
	components: {
		QImg: QImg_default,
		QSkeleton: QSkeleton_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Component height
		*/
		height: {
			type: String,
			default: "101px"
		},
		/**
		* An image for a specific project type
		*/
		imageUrl: {
			type: String,
			default: void 0
		},
		/**
		* Render skeleton
		*/
		loading: {
			type: Boolean,
			default: false
		},
		/**
		* Default image. Shown when "imageUrl" and "thumbnailUrl" do not exist.
		* Or when both of them are loaded with error.
		*/
		noImageUrl: {
			type: String,
			required: true
		},
		/**
		* Default image.Thumbnail for dataset
		*/
		thumbnailUrl: {
			type: String,
			default: null
		}
	},
	setup(props) {
		const thumbnailError = ref(false);
		const backgroundColor = computed(() => props.imageUrl ? "var(--q-grey-5-fixed)" : "var(--q-grey-5)");
		const backgroundImage = computed(() => {
			if (props.thumbnailUrl || props.imageUrl) return void 0;
			return `url("${props.noImageUrl}")`;
		});
		function onThumbnailError() {
			thumbnailError.value = true;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			backgroundColor,
			backgroundImage,
			onThumbnailError,
			thumbnailError
		};
	}
});
//#endregion
//#region src/components/CardImage.vue
var _hoisted_1$80 = ["data-automation"];
function _sfc_render$77(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QImg = resolveComponent("QImg");
	const _component_QSkeleton = resolveComponent("QSkeleton");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: "card-image relative-position",
		"data-automation": _ctx.buildId(),
		style: {
			"background-color": _ctx.backgroundColor,
			"background-image": _ctx.backgroundImage,
			"height": _ctx.height
		}
	}), [_ctx.thumbnailUrl && !_ctx.thumbnailError ? (openBlock(), createBlock(_component_QImg, {
		key: 0,
		"data-automation": _ctx.buildId("thumbnailImage"),
		fit: "cover",
		height: _ctx.height,
		src: _ctx.thumbnailUrl,
		onError: _ctx.onThumbnailError
	}, null, 8, [
		"data-automation",
		"height",
		"src",
		"onError"
	])) : _ctx.imageUrl ? (openBlock(), createBlock(_component_QImg, {
		key: 1,
		"data-automation": _ctx.buildId("image"),
		"error-src": _ctx.noImageUrl,
		fit: "contain",
		height: _ctx.height,
		src: _ctx.imageUrl
	}, null, 8, [
		"data-automation",
		"error-src",
		"height",
		"src"
	])) : createCommentVNode("", true), _ctx.loading ? (openBlock(), createBlock(_component_QSkeleton, {
		key: 2,
		class: "absolute-full",
		"data-automation": _ctx.buildId("skeleton"),
		square: ""
	}, null, 8, ["data-automation"])) : createCommentVNode("", true)], 16, _hoisted_1$80);
}
var CardImage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CardImage_vue_vue_type_script_lang_default, [["render", _sfc_render$77], ["__scopeId", "data-v-8858407a"]]);
//#endregion
//#region src/components/CardItem.vue?vue&type=script&lang.ts
var __default__$4 = defineComponent({
	name: "CardItem",
	components: {
		QIcon: QIcon_default,
		QMenu: QMenu_default,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Background color name for component from the Quasar Color Palette
		*/
		backgroundColor: {
			type: String,
			default: "grey-5"
		},
		/**
		* Text displayed in description
		*/
		description: {
			type: String,
			default: ""
		},
		/**
		* Allow to hover component via prop
		*/
		forceHover: {
			type: Boolean,
			default: false
		},
		/**
		* Showing without padding and disabled padding
		*/
		inline: {
			type: Boolean,
			default: false
		},
		/**
		* Hide arrow right icon
		*/
		hideIcon: {
			type: Boolean,
			default: false
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: ""
		},
		/**
		* Equivalent to Vue Router <router-link> 'to' property
		*/
		to: {
			type: [Object, String],
			default: void 0
		}
	},
	setup(props) {
		const borderColor = computed(() => props.backgroundColor ? getCssVar(props.backgroundColor) ?? "transparent" : "transparent");
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			borderColor,
			RouterLink
		};
	}
});
var __injectCSSVars__$4 = () => {
	useCssVars((_ctx) => ({ "v8aae5146": _ctx.borderColor }));
};
var __setup__$4 = __default__$4.setup;
__default__$4.setup = __setup__$4 ? (props, ctx) => {
	__injectCSSVars__$4();
	return __setup__$4(props, ctx);
} : __injectCSSVars__$4;
//#endregion
//#region src/components/CardItem.vue
var _hoisted_1$79 = ["data-automation"];
var _hoisted_2$63 = ["data-automation"];
var _hoisted_3$49 = { class: "column" };
var _hoisted_4$32 = ["data-automation"];
var _hoisted_5$27 = ["data-automation"];
function _sfc_render$76(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QMenu = resolveComponent("QMenu");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QIcon = resolveComponent("QIcon");
	return openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
		class: normalizeClass(["card-item row justify-between items-center no-wrap rounded-borders", {
			"card-item--force-hover": _ctx.forceHover,
			"card-item--animated-border q-pa-md": !_ctx.inline,
			[`bg-${_ctx.backgroundColor}`]: !!_ctx.backgroundColor
		}]),
		"data-automation": _ctx.buildId(),
		to: _ctx.to
	}, {
		default: withCtx(() => [
			createElementVNode("div", {
				class: "row items-center col",
				"data-automation": _ctx.buildId("content-wrapper")
			}, [renderSlot(_ctx.$slots, "prepend", {}, void 0, true), createElementVNode("div", {
				class: "card-item__content col",
				"data-automation": _ctx.buildId("content")
			}, [renderSlot(_ctx.$slots, "content", {}, () => [createElementVNode("div", _hoisted_3$49, [createElementVNode("div", {
				class: "text-subtitle3 text-black-1",
				"data-automation": _ctx.buildId("title")
			}, toDisplayString(_ctx.title), 9, _hoisted_4$32), createElementVNode("div", { "data-automation": _ctx.buildId("description") }, toDisplayString(_ctx.description), 9, _hoisted_5$27)])], true)], 8, _hoisted_2$63)], 8, _hoisted_1$79),
			_ctx.$slots["actions"] ? (openBlock(), createBlock(_component_RvButton, {
				key: 0,
				class: "card-item__dots self-start",
				color: "black-1",
				"data-automation": _ctx.buildId("actions"),
				icon: "mdi-dots-horizontal",
				tertiary: "",
				onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop", "prevent"]))
			}, {
				default: withCtx(() => [createVNode(_component_QMenu, { "auto-close": "" }, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "actions", {}, void 0, true)]),
					_: 3
				})]),
				_: 3
			}, 8, ["data-automation"])) : createCommentVNode("", true),
			!_ctx.hideIcon && !_ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QIcon, {
				key: 1,
				class: "card-item__chevron",
				color: "black-1",
				"data-automation": _ctx.buildId("chevron-icon"),
				name: "mdi-chevron-right",
				size: "24px"
			}, null, 8, ["data-automation"])) : createCommentVNode("", true)
		]),
		_: 3
	}, 8, [
		"class",
		"data-automation",
		"to"
	]);
}
var CardItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__$4, [["render", _sfc_render$76], ["__scopeId", "data-v-88f954b4"]]);
//#endregion
//#region src/components/Carousel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$78 = ["data-automation"];
var _hoisted_2$62 = ["data-automation"];
var _hoisted_3$48 = ["data-automation"];
var _hoisted_4$31 = ["data-automation"];
var _hoisted_5$26 = ["data-automation"];
//#endregion
//#region src/components/Carousel.vue
var Carousel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Carousel",
	props: {
		alignLeft: {
			type: Boolean,
			default: false
		},
		backgroundColor: { default: "white" },
		class: {},
		dataAutomation: {},
		draggable: {
			type: Boolean,
			default: false
		},
		draggableItemKey: { default: "id" },
		fixedSlideWidth: {},
		gap: { default: 16 },
		items: {},
		maxWidthPerSlide: { default: 608 },
		minWidthPerSlide: { default: 260 },
		showControls: {
			type: Boolean,
			default: true
		},
		singleSampleUsesAllSpace: {
			type: Boolean,
			default: false
		},
		transitionTime: { default: "0.5s" }
	},
	emits: ["reorder", "resize"],
	setup(__props, { expose: __expose, emit: __emit }) {
		useCssVars((_ctx) => ({ "v213382d7": justifyContent.value }));
		const emit = __emit;
		const { buildId, dataAttrs } = useAutomation(computed(() => __props.dataAutomation));
		const { isDark } = useDarkMode();
		const carouselObserverWidth = ref(0);
		const carouselRef = useTemplateRef("carouselRef");
		const carouselWidth = ref(void 0);
		const currentIndex = ref(0);
		const justifyContent = ref("normal");
		const slideMaxWidth = ref(__props.maxWidthPerSlide);
		const slidesLeftSpace = ref(void 0);
		const slidesPerPage = ref(1);
		const slidesRef = ref(null);
		const slideWidth = ref(0);
		const draggedItem = ref();
		const sortedItems = computed({
			get() {
				return __props.items;
			},
			set(value) {
				emit("reorder", value, draggedItem.value);
			}
		});
		const hidedButtons = computed(() => slidesPerPage.value === __props.items.length);
		const disablePreviousButton = computed(() => !currentIndex.value);
		const disableNextButton = computed(() => currentIndex.value === __props.items.length - slidesPerPage.value);
		const translatePosition = computed(() => currentIndex.value * (slideWidth.value + __props.gap));
		const slideMinWidth = computed(() => __props.fixedSlideWidth ?? __props.minWidthPerSlide);
		function calcCarouselWithFixedSlides() {
			if (!carouselRef.value || !__props.fixedSlideWidth) return;
			const availableSlidesPerPage = Math.floor((carouselRef.value.offsetWidth + __props.gap) / (__props.fixedSlideWidth + __props.gap));
			const hasHiddenSlides = availableSlidesPerPage < __props.items.length;
			slidesPerPage.value = hasHiddenSlides ? availableSlidesPerPage : __props.items.length;
			slideWidth.value = __props.fixedSlideWidth;
			justifyContent.value = hasHiddenSlides || __props.alignLeft ? "normal" : "center";
			const freeSpace = carouselRef.value.offsetWidth - availableSlidesPerPage * slideWidth.value - __props.gap * (availableSlidesPerPage - 1);
			carouselWidth.value = hasHiddenSlides ? carouselRef.value.offsetWidth - freeSpace : void 0;
			slidesLeftSpace.value = hasHiddenSlides ? freeSpace / 2 : void 0;
		}
		function calcSlideMaxWidth() {
			if (carouselRef.value) if (__props.items.length === 1 && __props.singleSampleUsesAllSpace) slideMaxWidth.value = carouselRef.value.offsetWidth;
			else {
				const maxWidth = carouselRef.value.offsetWidth / 2 - __props.gap / 2;
				slideMaxWidth.value = maxWidth >= __props.minWidthPerSlide ? maxWidth : __props.maxWidthPerSlide;
			}
		}
		function calcSlideWidth() {
			if (carouselRef.value) {
				const slidesPerPageWithoutSpaces = Math.floor(carouselRef.value.offsetWidth / __props.minWidthPerSlide);
				const spacesWidth = __props.gap * (slidesPerPageWithoutSpaces - 1);
				const slidesPerPageWithSpaces = Math.floor(carouselRef.value.offsetWidth / (__props.minWidthPerSlide + spacesWidth));
				slidesPerPage.value = slidesPerPageWithSpaces > __props.items.length ? __props.items.length : slidesPerPageWithSpaces;
				slideWidth.value = Math.floor((carouselRef.value.offsetWidth - (slidesPerPage.value - 1) * __props.gap) / slidesPerPage.value);
			} else slideWidth.value = 0;
		}
		function onNext() {
			if (currentIndex.value !== __props.items.length - slidesPerPage.value) currentIndex.value += 1;
		}
		function onPrev() {
			if (currentIndex.value !== 0) currentIndex.value -= 1;
		}
		function resizeSlide(width) {
			emit("resize");
			calcSlideMaxWidth();
			if (__props.fixedSlideWidth) calcCarouselWithFixedSlides();
			else calcSlideWidth();
			if (!width || width !== carouselObserverWidth.value) {
				currentIndex.value = 0;
				if (width) carouselObserverWidth.value = width;
			}
		}
		function onStart(e) {
			draggedItem.value = e.data;
		}
		const resizeObserver = new ResizeObserver((entry) => resizeSlide(entry[0]?.contentRect.width));
		watch(() => __props.fixedSlideWidth, () => {
			resizeSlide();
		});
		watch(() => __props.items.length, () => {
			resizeSlide();
		});
		onMounted(() => {
			resizeSlide();
			if (carouselRef.value) resizeObserver.observe(carouselRef.value);
		});
		onUnmounted(() => {
			resizeObserver.disconnect();
		});
		__expose({
			carouselRef,
			disableNextButton,
			disablePreviousButton,
			onNext,
			onPrev,
			slideWidth,
			translatePosition
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", mergeProps(unref(dataAttrs), {
				ref_key: "carouselRef",
				ref: carouselRef,
				class: ["rv-carousel relative-position", [_ctx.$props.class, `bg-${__props.backgroundColor}`]],
				"data-automation": unref(buildId)()
			}), [createElementVNode("div", {
				class: "rv-carousel__slides relative-position",
				"data-automation": unref(buildId)("slides"),
				style: normalizeStyle({
					...!__props.alignLeft && carouselWidth.value && { width: `${carouselWidth.value}px` },
					...!__props.alignLeft && slidesLeftSpace.value && { marginLeft: `${slidesLeftSpace.value}px` }
				})
			}, [createVNode(unref(QTabs_default), {
				class: "rv-carousel__tabs",
				shrink: "",
				stretch: ""
			}, {
				default: withCtx(() => [__props.draggable ? (openBlock(), createBlock(unref(VueDraggable), {
					key: 0,
					ref_key: "slidesRef",
					ref: slidesRef,
					modelValue: sortedItems.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => sortedItems.value = $event),
					class: "row no-wrap items-center self-stretch hide-scrollbar",
					"data-automation": unref(buildId)("slides--draggable"),
					style: normalizeStyle({
						transform: `translate(-${translatePosition.value}px, 0)`,
						transition: __props.transitionTime
					}),
					onStart
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(sortedItems.value, (item, index) => {
						return openBlock(), createElementBlock("div", {
							key: item?.[__props.draggableItemKey] ?? index,
							class: normalizeClass(["rv-carousel__slide rv-carousel__slide--draggable", { "rv-carousel__slide--draggable__dark": unref(isDark) }]),
							"data-automation": unref(buildId)(`slide${index}`),
							style: normalizeStyle({
								"margin-right": index === sortedItems.value.length - 1 ? 0 : `${__props.gap}px`,
								"max-width": `${slideWidth.value ?? slideMaxWidth.value}px`,
								"min-width": `${slideWidth.value ?? slideMinWidth.value}px`,
								width: `${slideWidth.value ?? slideWidth.value}px`
							})
						}, [renderSlot(_ctx.$slots, "slide", {
							index,
							item
						}, void 0, true)], 14, _hoisted_3$48);
					}), 128))]),
					_: 3
				}, 8, [
					"modelValue",
					"data-automation",
					"style"
				])) : (openBlock(), createElementBlock("div", {
					key: 1,
					ref_key: "slidesRef",
					ref: slidesRef,
					class: "row no-wrap items-center self-stretch hide-scrollbar",
					style: normalizeStyle({
						transform: `translate(-${translatePosition.value}px, 0)`,
						transition: __props.transitionTime
					})
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
					return openBlock(), createElementBlock("div", {
						key: index,
						class: "rv-carousel__slide",
						"data-automation": unref(buildId)(`slide${index}`),
						style: normalizeStyle({
							"margin-right": index === __props.items.length - 1 ? 0 : `${__props.gap}px`,
							"max-width": `${slideWidth.value ?? slideMaxWidth.value}px`,
							"min-width": `${slideWidth.value ?? slideMinWidth.value}px`,
							width: `${slideWidth.value ?? slideWidth.value}px`
						})
					}, [renderSlot(_ctx.$slots, "slide", {
						index,
						item
					}, void 0, true)], 12, _hoisted_4$31);
				}), 128))], 4))]),
				_: 3
			})], 12, _hoisted_2$62), __props.showControls ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "rv-carousel__control flex row space-between full-width",
				"data-automation": unref(buildId)("control")
			}, [createVNode(unref(QBtn_default), {
				class: normalizeClass(["rv-carousel__button rv-carousel__button--left", { hidden: hidedButtons.value }]),
				color: "white",
				"data-automation": unref(buildId)("prev"),
				dense: "",
				disabled: disablePreviousButton.value,
				icon: "chevron_left",
				"text-color": "black-1",
				onClick: onPrev,
				onDragover: onPrev
			}, null, 8, [
				"class",
				"data-automation",
				"disabled"
			]), createVNode(unref(QBtn_default), {
				class: normalizeClass(["rv-carousel__button rv-carousel__button--right", { hidden: hidedButtons.value }]),
				color: "white",
				"data-automation": unref(buildId)("next"),
				dense: "",
				disabled: disableNextButton.value,
				icon: "chevron_right",
				"text-color": "black-1",
				onClick: onNext,
				onDragover: onNext
			}, null, 8, [
				"class",
				"data-automation",
				"disabled"
			])], 8, _hoisted_5$26)) : createCommentVNode("", true)], 16, _hoisted_1$78);
		};
	}
}), [["__scopeId", "data-v-ffc14817"]]);
//#endregion
//#region src/components/ChartLineIndicator.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$77 = ["data-automation", "stroke"];
//#endregion
//#region src/components/ChartLineIndicator.vue
var ChartLineIndicator_default = /* @__PURE__ */ defineComponent({
	__name: "ChartLineIndicator",
	props: {
		color: {
			required: true,
			type: String
		},
		dataAutomation: {
			default: "chart-line-indicator",
			type: String
		},
		lineStyle: {
			default: "solid",
			type: String
		}
	},
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("svg", {
				class: normalizeClass(["chart-line-indicator", `chart-line-indicator--${__props.lineStyle}`]),
				"data-automation": unref(buildId)(),
				stroke: __props.color,
				viewBox: "0 0 16 2",
				xmlns: "http://www.w3.org/2000/svg"
			}, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M0,1 H 100" }, null, -1)])], 10, _hoisted_1$77);
		};
	}
});
//#endregion
//#region src/components/ChartTooltipContent.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$76 = ["data-automation"];
var _hoisted_2$61 = { key: 0 };
//#endregion
//#region src/components/ChartTooltipContent.vue
var ChartTooltipContent_default = /* @__PURE__ */ defineComponent({
	__name: "ChartTooltipContent",
	props: {
		dataAutomation: {
			default: "chart-tooltip-content",
			type: String
		},
		items: {
			default: void 0,
			type: Array
		}
	},
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("table", {
				class: "chart-tooltip-content q-ma-none",
				"data-automation": unref(buildId)()
			}, [createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, itemIndex) => {
				return openBlock(), createElementBlock(Fragment, { key: itemIndex }, [(openBlock(true), createElementBlock(Fragment, null, renderList(item.lines, (line, lineIndex) => {
					return openBlock(), createElementBlock("tr", { key: `${line}-${lineIndex}` }, [createElementVNode("td", null, [lineIndex == 0 ? (openBlock(), createBlock(ChartLineIndicator_default, {
						key: 0,
						color: item.color,
						"data-automation": unref(buildId)("indicator"),
						"line-style": item.lineStyle
					}, null, 8, [
						"color",
						"data-automation",
						"line-style"
					])) : createCommentVNode("", true)]), createElementVNode("td", null, [item.highlightedLineIndices?.includes(lineIndex) ? (openBlock(), createElementBlock("b", _hoisted_2$61, toDisplayString(line), 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(toDisplayString(line), 1)], 64))])]);
				}), 128))], 64);
			}), 128))])], 8, _hoisted_1$76);
		};
	}
});
//#endregion
//#region src/components/ChartTooltip.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$75 = ["data-automation"];
var _hoisted_2$60 = ["data-automation"];
//#endregion
//#region src/components/ChartTooltip.vue
var ChartTooltip_default = /* @__PURE__ */ defineComponent({
	__name: "ChartTooltip",
	props: {
		caret: {
			default: () => ({
				x: 0,
				y: 0
			}),
			type: Object
		},
		chart: {
			default: void 0,
			type: Object
		},
		dataAutomation: {
			default: "chart-tooltip",
			type: String
		},
		items: {
			default: void 0,
			type: Array
		}
	},
	setup(__props) {
		const props = __props;
		const { caret, chart } = toRefs(props);
		const { buildId } = useAutomation(props.dataAutomation);
		const { style } = useChartTooltip(chart, caret);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", null, [createElementVNode("div", {
				ref: "tooltipGhost",
				class: "chart-tooltip chart-tooltip--ghost",
				"data-automation": unref(buildId)("ghost")
			}, [createVNode(ChartTooltipContent_default, {
				"data-automation": unref(buildId)("ghost-content"),
				items: __props.items
			}, null, 8, ["data-automation", "items"])], 8, _hoisted_1$75), createElementVNode("div", {
				class: "chart-tooltip",
				"data-automation": unref(buildId)(),
				style: normalizeStyle(unref(style))
			}, [createVNode(ChartTooltipContent_default, { items: __props.items }, null, 8, ["items"])], 12, _hoisted_2$60)]);
		};
	}
});
//#endregion
//#region src/components/Chart.vue?vue&type=script&lang.ts
Chart.register(Filler, LinearScale, LineController, LineElement, PointElement, TimeScale, Tooltip);
var Chart_vue_vue_type_script_lang_default = defineComponent({
	name: "Chart",
	components: {
		Bullet: Bullet_default,
		ChartTooltip: ChartTooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		chart: {
			type: Object,
			required: true
		},
		entries: {
			type: Array,
			default: () => []
		},
		interpolate: {
			default: false,
			type: Boolean
		},
		fill: {
			type: Boolean,
			default: false
		},
		fullHeight: {
			type: Boolean,
			default: false
		},
		maintainAspectRatio: {
			type: Boolean,
			default: false
		},
		max: {
			type: Object,
			default: void 0
		},
		min: {
			type: Object,
			default: void 0
		},
		noLegend: {
			type: Boolean,
			default: false
		},
		relativeTime: {
			type: Boolean,
			default: false
		},
		/**
		* Maximum rotation for tick labels when rotating to condense labels. Note: Rotation doesn't occur until necessary. Note: Only applicable to horizontal scales.
		* https://www.chartjs.org/docs/3.5.1/axes/cartesian/#common-tick-options-to-all-cartesian-axes
		* @default 50
		*/
		labelMaxRotation: {
			type: Number,
			default: 50
		},
		showAxisLabels: {
			type: Boolean,
			default: false
		},
		xAxisTimeDisplayFormats: {
			default: void 0,
			type: Object
		},
		xAxisMaxTicksLimit: {
			default: void 0,
			type: Number
		},
		/**
		* Allows adding custom formatting for each tooltip field value. Useful in situations where we don't want to modify the entry's data.
		*
		* Example use cases:
		*  - A field that is used as an axis value but contains large numbers that we want to format inside the tooltip (eg. 2,000,000).
		*  - Formatting data of all the entries causes performance issues.
		*/
		tooltipFieldFormat: {
			default: void 0,
			type: Object
		},
		/**
		* Allows specifying fields to be rendered in bold.
		*/
		tooltipHighlightedFields: {
			default: () => [],
			type: Array
		},
		/**
		* Allows specifying fields order for the tooltip (listed fields will be on top, rest will be sorted alphabetically).
		*/
		tooltipPinnedFields: {
			default: () => [],
			type: Array
		},
		width: {
			type: String,
			default: "200"
		}
	},
	setup(props) {
		const { isDark } = useDarkMode();
		const chartRef = ref(null);
		const show = computed(() => props.entries.length);
		let chartInstance;
		const isShowTooltip = ref(false);
		const tooltipData = ref(null);
		const colors = computed(() => {
			return props.entries.reduce((acc, entry, index) => ({
				...acc,
				[entry.key]: entry.color || getColor(index)
			}), {});
		});
		const datasets = useChartDatasets({
			chartRef,
			params: computed(() => ({
				chart: props.chart,
				colors,
				entries: props.entries,
				fill: props.fill,
				interpolate: props.interpolate,
				relativeTime: props.relativeTime
			}))
		});
		const tooltipEntries = computed(() => {
			const { chart } = props;
			return props.entries.map((entry) => {
				const entryIgnoredFields = entry.ignoreTooltipFields ?? [];
				return entry.data.map((data) => {
					return [...Object.entries(data).map(([key, value]) => ({
						key,
						label: chart.labels?.[key] ?? key,
						value
					})).filter((field) => !entryIgnoredFields.includes(field.key)), ...entry.extraFields ?? []].sort((itemA, itemB) => {
						const indexA = props.tooltipPinnedFields.indexOf(itemA.key);
						const indexB = props.tooltipPinnedFields.indexOf(itemB.key);
						if (indexA !== -1 && indexB !== -1) return indexA - indexB;
						if (indexA !== -1) return -1;
						if (indexB !== -1) return 1;
						return itemA.label.localeCompare(itemB.label);
					});
				});
			});
		});
		const tooltipHighlightedLineIndices = computed(() => tooltipEntries.value.map((dataset) => dataset.map((dataPoint) => dataPoint.map((field, index) => [field, index]).filter(([field]) => props.tooltipHighlightedFields.includes(field.key)).map(([, index]) => index + 1))));
		const tooltipLines = computed(() => tooltipEntries.value.map((dataset, datasetIndex) => dataset.map((dataPoint) => dataPoint.map((field) => {
			if (props.tooltipFieldFormat?.[field.key]) return `${field.label}: ${props.tooltipFieldFormat[field.key](field.value)}`;
			if (field.value instanceof Date) {
				if (props.relativeTime) {
					const firstTime = tooltipEntries.value[datasetIndex][0].find((f) => f.key === field.key).value;
					return firstTime && `${field.label}: ${formatInterval(firstTime, field.value)}`;
				}
				return `${field.label}: ${formatDate$1(field.value, DateTemplates.Long)}`;
			}
			return `${field.label}: ${String(field.value)}`;
		}))));
		const legend = computed(() => {
			return props.entries.map((entry) => ({
				color: colors.value[entry.key],
				key: entry.key,
				name: entry.name
			}));
		});
		const options = useChartOptions({
			customTooltip,
			params: computed(() => ({
				chart: props.chart,
				labelMaxRotation: props.labelMaxRotation,
				maintainAspectRatio: props.maintainAspectRatio,
				max: props.max,
				min: props.min,
				relativeTime: props.relativeTime,
				showAxisLabels: props.showAxisLabels,
				xAxisMaxTicksLimit: props.xAxisMaxTicksLimit,
				xAxisTimeDisplayFormats: props.xAxisTimeDisplayFormats
			})),
			tooltipLines
		});
		function customTooltip({ chart, tooltip }) {
			if (!isShowTooltip.value) return;
			if (!tooltip.body?.length) {
				tooltipData.value = null;
				return;
			}
			tooltipData.value = {
				caret: {
					x: tooltip.caretX,
					y: tooltip.caretY
				},
				chart: {
					height: chart.height,
					position: {
						x: chart.canvas.offsetLeft,
						y: chart.canvas.offsetTop
					},
					top: chart.canvas.getBoundingClientRect().top,
					width: chart.width
				},
				items: tooltip.body.map((body, index) => ({
					color: tooltip.labelColors[index].backgroundColor.toString(),
					highlightedLineIndices: tooltipHighlightedLineIndices.value[tooltip.dataPoints[index].datasetIndex][index],
					lines: body.lines,
					lineStyle: props.entries[tooltip.dataPoints[index].datasetIndex].lineStyle
				}))
			};
		}
		function onMouseEnter() {
			isShowTooltip.value = true;
		}
		function onMouseLeave() {
			isShowTooltip.value = false;
			tooltipData.value = null;
		}
		onMounted(async () => {
			if (!chartRef.value) return;
			Chart.defaults.color = isDark.value ? getCssVar("white-fixed") ?? "#FFFFFF" : getCssVar("grey-1-fixed") ?? "#485374";
			Chart.defaults.borderColor = isDark.value ? getCssVar("grey-1-fixed") ?? "#485374" : getCssVar("grey-3-fixed") ?? "#DADDE3";
			const config = {
				data: { datasets: datasets.value },
				options: options.value,
				type: "line"
			};
			chartInstance = new Chart(chartRef.value, config);
		});
		watch([datasets, options], ([newDatasets, newOptions]) => {
			if (!chartInstance) return;
			chartInstance.options = newOptions;
			chartInstance.data.datasets = newDatasets;
			chartInstance.update();
		});
		onUnmounted(() => {
			if (chartInstance) chartInstance.destroy();
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			chartRef,
			isShowTooltip,
			legend,
			onMouseEnter,
			onMouseLeave,
			show,
			tooltipData
		};
	}
});
//#endregion
//#region src/components/Chart.vue
var _hoisted_1$74 = ["data-automation"];
var _hoisted_2$59 = ["data-automation"];
var _hoisted_3$47 = ["data-automation", "width"];
var _hoisted_4$30 = ["data-automation"];
var _hoisted_5$25 = ["data-automation"];
var _hoisted_6$15 = ["data-automation"];
function _sfc_render$75(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ChartTooltip = resolveComponent("ChartTooltip");
	const _component_Bullet = resolveComponent("Bullet");
	return openBlock(), createElementBlock("div", {
		class: "tensorboard-chart",
		"data-automation": _ctx.buildId()
	}, [withDirectives(createElementVNode("div", {
		class: normalizeClass(["relative-position", { "full-height": _ctx.fullHeight }]),
		"data-automation": _ctx.buildId("container"),
		onMouseenter: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseEnter && _ctx.onMouseEnter(...args)),
		onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args))
	}, [createElementVNode("canvas", {
		ref: "chartRef",
		"data-automation": _ctx.buildId("canvas"),
		height: "200",
		width: _ctx.width
	}, null, 8, _hoisted_3$47), withDirectives(createVNode(_component_ChartTooltip, {
		caret: _ctx.tooltipData?.caret,
		chart: _ctx.tooltipData?.chart,
		items: _ctx.tooltipData?.items
	}, null, 8, [
		"caret",
		"chart",
		"items"
	]), [[vShow, _ctx.isShowTooltip && _ctx.tooltipData]])], 42, _hoisted_2$59), [[vShow, _ctx.show]]), !_ctx.noLegend ? (openBlock(), createElementBlock("div", {
		key: 0,
		"data-automation": _ctx.buildId("legend")
	}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.legend, (item) => {
		return openBlock(), createElementBlock("div", {
			key: item.key,
			class: "inline flex no-wrap items-center text-small q-mr-sm",
			"data-automation": _ctx.buildId(`item__${item.key}`)
		}, [createVNode(_component_Bullet, {
			color: item.color,
			"data-automation": _ctx.buildId(`item__${item.key}__bullet`)
		}, null, 8, ["color", "data-automation"]), createElementVNode("div", {
			class: "q-ml-xs",
			"data-automation": _ctx.buildId(`item__${item.key}__label`)
		}, toDisplayString(item.name), 9, _hoisted_6$15)], 8, _hoisted_5$25);
	}), 128))], 8, _hoisted_4$30)) : createCommentVNode("", true)], 8, _hoisted_1$74);
}
var Chart_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Chart_vue_vue_type_script_lang_default, [["render", _sfc_render$75]]);
//#endregion
//#region src/components/Chip.vue?vue&type=script&lang.ts
var Chip_vue_vue_type_script_lang_default = defineComponent({
	name: "Chip",
	components: { QIcon: QIcon_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Color name for component from the Quasar Color Palette
		*/
		backgroundColor: {
			type: String,
			default: ""
		},
		/**
		* Border applied to component
		*/
		bordered: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Icon color as a Quasar variable (primary|dark|grey-1)
		*/
		iconColor: {
			type: String,
			default: ""
		},
		/**
		* Icon name
		*/
		iconName: {
			type: String,
			default: ""
		},
		/**
		* Shows icons, if defined, on the right
		*/
		iconRight: {
			type: Boolean,
			default: false
		},
		/**
		* The text that will be shown on the button
		*/
		label: {
			type: String,
			required: true
		},
		/**
		* Render chip in primary mode
		*/
		primary: {
			type: Boolean,
			default: true
		},
		/**
		* Render chip in secondary mode
		*/
		secondary: {
			type: Boolean,
			default: false
		},
		/**
		* Size in standard size name (sm|md)
		*/
		size: {
			type: String,
			default: "sm"
		},
		/**
		* Text color name for component from the Quasar Color Palette
		*/
		textColor: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		const isCustom = computed(() => props.backgroundColor || props.textColor);
		const isPrimary = computed(() => props.primary && !props.secondary && !isCustom.value);
		const isSecondary = computed(() => props.secondary && !isCustom.value);
		const textClass = computed(() => props.textColor ? `text-${props.textColor}` : "");
		const backgroundClass = computed(() => props.backgroundColor ? `bg-${props.backgroundColor}` : "");
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			backgroundClass,
			isPrimary,
			isSecondary,
			textClass
		};
	}
});
//#endregion
//#region src/components/Chip.vue
var _hoisted_1$73 = ["data-automation"];
function _sfc_render$74(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["rv-chip", [
			{
				"rv-chip--bordered": _ctx.bordered,
				"rv-chip--primary": _ctx.isPrimary,
				"rv-chip--secondary": _ctx.isSecondary,
				"rv-chip--sm": _ctx.size === "sm",
				"rv-chip--md": _ctx.size === "md"
			},
			_ctx.backgroundClass,
			_ctx.textClass,
			_ctx.$props.class
		]],
		"data-automation": _ctx.buildId()
	}), [
		_ctx.iconName && !_ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
			key: 0,
			class: "rv-chip__icon rv-chip__icon--left",
			color: _ctx.iconColor,
			"data-automation": _ctx.buildId("icon"),
			name: _ctx.iconName
		}, null, 8, [
			"color",
			"data-automation",
			"name"
		])) : createCommentVNode("", true),
		createElementVNode("span", null, toDisplayString(_ctx.label), 1),
		_ctx.iconName && _ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "rv-chip__icon rv-chip__icon--right",
			color: _ctx.iconColor,
			"data-automation": _ctx.buildId("icon"),
			name: _ctx.iconName
		}, null, 8, [
			"color",
			"data-automation",
			"name"
		])) : createCommentVNode("", true)
	], 16, _hoisted_1$73);
}
var Chip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Chip_vue_vue_type_script_lang_default, [["render", _sfc_render$74], ["__scopeId", "data-v-b4177217"]]);
//#endregion
//#region src/components/CircularProgress.vue?vue&type=script&lang.ts
var CircularProgress_vue_vue_type_script_lang_default = defineComponent({
	name: "CircularProgress",
	components: { QCircularProgress: QCircularProgress_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Color name for the arc progress from the Quasar Color Palette
		*/
		color: {
			type: String,
			default: "primary"
		},
		/**
		* Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
		*/
		fontSize: {
			type: String,
			default: "1em"
		},
		/**
		* Put component into 'indeterminate' state; Ignores 'value' prop
		*/
		indeterminate: {
			type: Boolean,
			default: false
		},
		/**
		* Maximum value defining 100% progress made (must be higher than 'min')
		*/
		max: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value defining 'no progress' (must be lower than 'max')
		*/
		min: {
			type: Number,
			default: 0
		},
		/**
		* Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
		* Make sure the text has enough space to be displayed inside the component
		*/
		showValue: {
			type: Boolean,
			default: false
		},
		/**
		* Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
		*/
		size: {
			type: String,
			default: "1em"
		},
		/**
		* Thickness of progress arc as a ratio (0.0 < x < 1.0) of component size
		*/
		thickness: {
			type: Number,
			default: .2
		},
		/**
		* Color name for the track of the component from the Quasar Color Palette
		*/
		trackColor: {
			type: String,
			default: void 0
		},
		/**
		* Current progress (must be between min/max)
		*/
		value: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const { isDark } = useDarkMode();
		const trackColorComputed = computed(() => {
			if (props.trackColor) return props.trackColor;
			return isDark.value ? "grey-1--dark" : "grey-3--light";
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			trackColorComputed
		};
	}
});
//#endregion
//#region src/components/CircularProgress.vue
function _sfc_render$73(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QCircularProgress = resolveComponent("QCircularProgress");
	return openBlock(), createBlock(_component_QCircularProgress, {
		class: normalizeClass(["rv-circular-progress text-primary--light text-white--dark text-center", _ctx.$props.class]),
		color: _ctx.color,
		"data-automation": _ctx.buildId(),
		"font-size": _ctx.fontSize,
		indeterminate: _ctx.indeterminate,
		max: _ctx.max,
		min: _ctx.min,
		"show-value": _ctx.showValue,
		size: _ctx.size,
		thickness: _ctx.thickness,
		"track-color": _ctx.trackColorComputed,
		value: _ctx.value
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 3
	}, 8, [
		"class",
		"color",
		"data-automation",
		"font-size",
		"indeterminate",
		"max",
		"min",
		"show-value",
		"size",
		"thickness",
		"track-color",
		"value"
	]);
}
var CircularProgress_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CircularProgress_vue_vue_type_script_lang_default, [["render", _sfc_render$73]]);
//#endregion
//#region src/components/ColorPicker.vue?vue&type=script&lang.ts
var ColorPicker_vue_vue_type_script_lang_default = defineComponent({
	name: "ColorPicker",
	components: {
		QColor: QColor_default,
		RvInput: Input_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* v-model
		*/
		modelValue: {
			type: String,
			required: true
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const hexColorInput = computed({
			get() {
				return props.modelValue.startsWith("#") ? props.modelValue.substring(1).toUpperCase() : props.modelValue.toUpperCase();
			},
			set(value) {
				const valueWithoutHashtag = value.startsWith("#") ? value?.slice(1) : value;
				if (valueWithoutHashtag.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) emit("update:modelValue", `#${valueWithoutHashtag}`);
			}
		});
		const red = computed({
			get() {
				return colors_default.hexToRgb(props.modelValue).r;
			},
			set(value) {
				setRGB(value, "r");
			}
		});
		const green = computed({
			get() {
				return colors_default.hexToRgb(props.modelValue).g;
			},
			set(value) {
				setRGB(value, "g");
			}
		});
		const blue = computed({
			get() {
				return colors_default.hexToRgb(props.modelValue).b;
			},
			set(value) {
				setRGB(value, "b");
			}
		});
		function setRGB(value, key) {
			const rgb = colors_default.hexToRgb(props.modelValue);
			if (value > 255 || value.toString().match(/\D/g)) rgb[key] = 255;
			else rgb[key] = value;
			emit("update:modelValue", colors_default.rgbToHex(rgb));
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			blue,
			green,
			hexColorInput,
			red,
			t
		};
	}
});
//#endregion
//#region src/components/ColorPicker.vue
var _hoisted_1$72 = ["data-automation"];
var _hoisted_2$58 = { class: "q-pb-md flex no-wrap inputs" };
function _sfc_render$72(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QColor = resolveComponent("QColor");
	const _component_RvInput = resolveComponent("RvInput");
	return openBlock(), createElementBlock("div", {
		class: "bg-white",
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", { style: normalizeStyle({ "--color": _ctx.modelValue }) }, [createVNode(_component_QColor, {
		"data-automation": _ctx.buildId("color-picker"),
		"format-model": "hex",
		"model-value": _ctx.modelValue,
		"no-footer": "",
		"no-header": "",
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
	}, null, 8, ["data-automation", "model-value"])], 4), createElementVNode("div", _hoisted_2$58, [
		createVNode(_component_RvInput, {
			modelValue: _ctx.hexColorInput,
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.hexColorInput = $event),
			class: "color__input color__input--hex",
			"data-automation": _ctx.buildId("hex"),
			label: _ctx.t("rvai-base.components.colorPicker.hex"),
			"no-error-icon": ""
		}, null, 8, [
			"modelValue",
			"data-automation",
			"label"
		]),
		createVNode(_component_RvInput, {
			modelValue: _ctx.red,
			"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.red = $event),
			class: "color__input",
			"data-automation": _ctx.buildId("red"),
			label: _ctx.t("rvai-base.components.colorPicker.rgb.r")
		}, null, 8, [
			"modelValue",
			"data-automation",
			"label"
		]),
		createVNode(_component_RvInput, {
			modelValue: _ctx.green,
			"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.green = $event),
			class: "color__input",
			"data-automation": _ctx.buildId("green"),
			label: _ctx.t("rvai-base.components.colorPicker.rgb.g")
		}, null, 8, [
			"modelValue",
			"data-automation",
			"label"
		]),
		createVNode(_component_RvInput, {
			modelValue: _ctx.blue,
			"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.blue = $event),
			class: "color__input",
			"data-automation": _ctx.buildId("blue"),
			label: _ctx.t("rvai-base.components.colorPicker.rgb.b")
		}, null, 8, [
			"modelValue",
			"data-automation",
			"label"
		])
	])], 8, _hoisted_1$72);
}
var ColorPicker_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ColorPicker_vue_vue_type_script_lang_default, [["render", _sfc_render$72], ["__scopeId", "data-v-161838b3"]]);
//#endregion
//#region src/components/ColorPickerInput.vue?vue&type=script&lang.ts
var ColorPickerInput_vue_vue_type_script_lang_default = defineComponent({
	name: "ColorPickerInput",
	components: {
		ColorPicker: ColorPicker_default,
		QIcon: QIcon_default,
		QPopupProxy: QPopupProxy_default,
		RvInput: Input_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Render info icon with tooltip
		*/
		infoText: {
			default: void 0,
			type: String
		},
		/**
		* The text that will be shown above the input
		*/
		label: {
			default: void 0,
			type: String
		},
		/**
		* v-model
		*/
		modelValue: {
			default: null,
			type: String
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const color = computed({
			get() {
				if (!props.modelValue) return "";
				return `#${(props.modelValue.startsWith("#") ? props.modelValue?.substring(1) : props.modelValue).toUpperCase()}`;
			},
			set(value) {
				if (value === "") {
					emit("update:modelValue", "");
					return;
				}
				const valueWithoutHashtag = value?.startsWith("#") ? value?.substring(1) : value;
				if (valueWithoutHashtag?.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) emit("update:modelValue", `#${valueWithoutHashtag}`);
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			color
		};
	}
});
//#endregion
//#region src/components/ColorPickerInput.vue
var _hoisted_1$71 = ["data-automation"];
var _hoisted_2$57 = ["data-automation"];
function _sfc_render$71(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvInput = resolveComponent("RvInput");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_ColorPicker = resolveComponent("ColorPicker");
	const _component_QPopupProxy = resolveComponent("QPopupProxy");
	return openBlock(), createElementBlock("div", {
		class: "row no-wrap",
		"data-automation": _ctx.buildId()
	}, [
		createVNode(_component_RvInput, {
			modelValue: _ctx.color,
			"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.color = $event),
			class: "full-width",
			"data-automation": _ctx.buildId("input"),
			"info-text": _ctx.infoText,
			label: _ctx.label,
			"show-optional-label": _ctx.showOptionalLabel
		}, createSlots({ _: 2 }, [!!_ctx.color ? {
			name: "prepend",
			fn: withCtx(() => [createElementVNode("div", {
				class: "color-picker__color-indicator",
				"data-automation": _ctx.buildId("color-indicator"),
				style: normalizeStyle(`background-color: ${_ctx.color}`)
			}, null, 12, _hoisted_2$57)]),
			key: "0"
		} : void 0]), 1032, [
			"modelValue",
			"data-automation",
			"info-text",
			"label",
			"show-optional-label"
		]),
		!!_ctx.color ? (openBlock(), createBlock(_component_QIcon, {
			key: 0,
			class: "color-picker__success",
			color: "positive",
			"data-automation": _ctx.buildId("success"),
			name: "mdi-check-circle",
			size: "24px"
		}, null, 8, ["data-automation"])) : createCommentVNode("", true),
		createVNode(_component_QPopupProxy, {
			class: "color-picker__popup q-pa-md",
			"data-automation": _ctx.buildId("popup"),
			"no-focus": "",
			offset: [0, 5]
		}, {
			default: withCtx(() => [createVNode(_component_ColorPicker, {
				key: "colorPicker",
				modelValue: _ctx.color,
				"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.color = $event),
				class: "color-picker__component",
				"data-automation": _ctx.buildId("component")
			}, null, 8, ["modelValue", "data-automation"])]),
			_: 1
		}, 8, ["data-automation"])
	], 8, _hoisted_1$71);
}
var ColorPickerInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ColorPickerInput_vue_vue_type_script_lang_default, [["render", _sfc_render$71], ["__scopeId", "data-v-56107070"]]);
//#endregion
//#region src/components/ColorPickerV2.vue?vue&type=script&lang.ts
var __default__$3 = defineComponent({
	name: "ColorPicker",
	components: {
		ActionButton: ActionButton_default,
		QColor: QColor_default,
		QMenu: QMenu_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: void 0,
			type: String
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			default: false,
			type: Boolean
		},
		/**
		* v-model
		*/
		modelValue: {
			required: true,
			type: String
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			value
		};
	}
});
var __injectCSSVars__$3 = () => {
	useCssVars((_ctx) => ({ "v4bd23360": _ctx.value }));
};
var __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? (props, ctx) => {
	__injectCSSVars__$3();
	return __setup__$3(props, ctx);
} : __injectCSSVars__$3;
//#endregion
//#region src/components/ColorPickerV2.vue
var _hoisted_1$70 = ["data-automation"];
var _hoisted_2$56 = ["data-automation"];
function _sfc_render$70(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QColor = resolveComponent("QColor");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_ActionButton = resolveComponent("ActionButton");
	return openBlock(), createElementBlock("div", {
		class: "color-picker",
		"data-automation": _ctx.buildId()
	}, [createVNode(_component_ActionButton, {
		"data-automation": _ctx.buildId("button"),
		disable: _ctx.disable,
		selected: "",
		tertiary: ""
	}, {
		default: withCtx(() => [createElementVNode("div", {
			class: "color-picker__indicator",
			"data-automation": _ctx.buildId("indicator")
		}, null, 8, _hoisted_2$56), createVNode(_component_QMenu, {
			anchor: "top left",
			"auto-close": "",
			offset: [0, 0],
			self: "top left"
		}, {
			default: withCtx(() => [createVNode(_component_QColor, {
				modelValue: _ctx.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
				class: "color-picker__palette q-pa-sm",
				"data-automation": _ctx.buildId("palette"),
				"default-view": "palette",
				"no-footer": "",
				"no-header": ""
			}, null, 8, ["modelValue", "data-automation"])]),
			_: 1
		})]),
		_: 1
	}, 8, ["data-automation", "disable"])], 8, _hoisted_1$70);
}
var ColorPickerV2_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__$3, [["render", _sfc_render$70], ["__scopeId", "data-v-4f737bce"]]);
//#endregion
//#region src/components/CombinedInputs.vue?vue&type=script&lang.ts
var CombinedInputs_vue_vue_type_script_lang_default = defineComponent({
	name: "CombinedInputs",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		RvInput: Input_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Render text below first input
		*/
		hint: {
			type: String,
			default: "Length x width"
		},
		/**
		* Render info icon with tooltip. Can be used as an "info-text" property or as a slot
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: "rv-combined-inputs__info-text"
		},
		/**
		* Render text above first input
		*/
		label: {
			type: String,
			required: true
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Text that appears in the form control when it has no value set
		*/
		placeholders: {
			type: Array,
			default: () => []
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Text displayed between inputs
		*/
		separator: {
			type: String,
			default: "X"
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* v-model for inputs
		*/
		modelValue: {
			type: Array,
			required: true
		},
		/**
		* Validation rules
		*/
		validation: {
			type: Array,
			default: void 0
		}
	},
	emits: ["update:model-value"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const { isDark } = useDarkMode();
		const valuesRef = ref(props.modelValue);
		const error = computed(() => {
			return props.validation?.some((v) => v?.$error);
		});
		const errorMessage = computed(() => {
			if (!props.validation) return void 0;
			if (props.validation.every((v) => !v.$error)) return void 0;
			return props.validation.map((v) => v.$errors[0]?.$message).filter(Boolean)[0];
		});
		const isValidated = computed(() => {
			if (!props.validation) return false;
			return props.validation.every((v) => v.$dirty && !v.$invalid);
		});
		function onUpdate(value, index) {
			const updated = [...props.modelValue];
			updated[index] = value;
			valuesRef.value = updated;
			emit("update:model-value", updated);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			error,
			errorMessage,
			isDark,
			isValidated,
			onUpdate,
			t,
			values: valuesRef
		};
	}
});
//#endregion
//#region src/components/CombinedInputs.vue
var _hoisted_1$69 = ["data-automation"];
var _hoisted_2$55 = { class: "row no-wrap items-center full-width" };
var _hoisted_3$46 = {
	key: 0,
	class: "q-ml-xs"
};
var _hoisted_4$29 = { class: "rv-combined-inputs row justify-between no-wrap align-center" };
var _hoisted_5$24 = {
	key: 0,
	class: "rv-combined-inputs__separator flex items-center q-px-sm"
};
var _hoisted_6$14 = ["data-automation"];
var _hoisted_7$12 = { class: "q-field__bottom" };
var _hoisted_8$8 = ["data-automation"];
var _hoisted_9$7 = { class: "q-field__bottom" };
function _sfc_render$69(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvInput = resolveComponent("RvInput");
	return openBlock(), createElementBlock("div", { "data-automation": _ctx.buildId() }, [createElementVNode("div", { class: normalizeClass(["rv-combined-inputs__field", { "rv-combined-inputs--disabled": _ctx.disable }]) }, [
		_ctx.label ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["rv-combined-inputs__label flex justify-between items-center", _ctx.labelClass])
		}, [createElementVNode("span", _hoisted_2$55, [
			createVNode(_component_EllipsisText, {
				class: "text-subtitle3",
				"data-automation": _ctx.buildId("label"),
				text: _ctx.label
			}, null, 8, ["data-automation", "text"]),
			_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$46, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
			_ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
				key: 1,
				class: "q-ml-xs info-icon",
				color: "black-1",
				"data-automation": _ctx.buildId("icon-info"),
				name: "info",
				size: "16px"
			}, {
				default: withCtx(() => [createVNode(_component_Tooltip, {
					anchor: "top middle",
					class: normalizeClass(_ctx.infoTextClass),
					self: "bottom middle"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
					_: 3
				}, 8, ["class"])]),
				_: 3
			}, 8, ["data-automation"])) : createCommentVNode("", true)
		]), renderSlot(_ctx.$slots, "label-append", {}, void 0, true)], 2)) : createCommentVNode("", true),
		createElementVNode("div", _hoisted_4$29, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value, index) => {
			return openBlock(), createElementBlock(Fragment, { key: index }, [index ? (openBlock(), createElementBlock("span", _hoisted_5$24, toDisplayString(_ctx.separator), 1)) : createCommentVNode("", true), createVNode(_component_RvInput, {
				"data-automation": _ctx.buildId(index.toString()),
				disable: _ctx.disable,
				"model-value": value,
				placeholder: _ctx.placeholders[index],
				"onUpdate:modelValue": ($event) => _ctx.onUpdate($event, index)
			}, null, 8, [
				"data-automation",
				"disable",
				"model-value",
				"placeholder",
				"onUpdate:modelValue"
			])], 64);
		}), 128)), _ctx.isValidated ? (openBlock(), createBlock(_component_QIcon, {
			key: "valid",
			class: "rv-combined-inputs__icon q-pl-sm",
			color: "positive",
			"data-automation": _ctx.buildId("icon-valid"),
			name: "mdi-check-circle",
			size: "24px"
		}, null, 8, ["data-automation"])) : _ctx.error ? (openBlock(), createBlock(_component_QIcon, {
			key: "error",
			class: "rv-combined-inputs__icon q-pl-sm",
			color: "negative",
			"data-automation": _ctx.buildId("icon-error"),
			name: "mdi-close-circle",
			size: "24px"
		}, null, 8, ["data-automation"])) : createCommentVNode("", true)]),
		_ctx.error ? (openBlock(), createElementBlock("div", {
			key: 1,
			class: "q-field--dense q-field--error",
			"data-automation": _ctx.buildId("error")
		}, [createElementVNode("div", _hoisted_7$12, toDisplayString(_ctx.errorMessage), 1)], 8, _hoisted_6$14)) : _ctx.hint ? (openBlock(), createElementBlock("div", {
			key: 2,
			class: normalizeClass(["q-field--dense q-field--hint", { "q-field--dark": _ctx.isDark }]),
			"data-automation": _ctx.buildId("hint")
		}, [createElementVNode("div", _hoisted_9$7, toDisplayString(_ctx.hint), 1)], 10, _hoisted_8$8)) : createCommentVNode("", true)
	], 2)], 8, _hoisted_1$69);
}
var CombinedInputs_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CombinedInputs_vue_vue_type_script_lang_default, [["render", _sfc_render$69], ["__scopeId", "data-v-43ada02d"]]);
//#endregion
//#region src/components/ConfusionMatrix.vue?vue&type=script&lang.ts
var DETAILED_ROW_MIN_HEIGHT = 24;
var ConfusionMatrix_vue_vue_type_script_lang_default = defineComponent({
	name: "ConfusionMatrix",
	components: {
		Avatar: Avatar_default,
		Bullet: Bullet_default,
		EllipsisText: EllipsisText_default,
		QResizeObserver: QResizeObserver_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		classes: {
			type: Array,
			required: true
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Detailed mode; Show like in full mode
		*/
		detailed: {
			type: Boolean,
			default: false
		},
		/**
		* Matrix model
		*/
		matrix: {
			type: Object,
			required: true
		},
		/**
		* Set max visible rows; if not set - visible all rows
		*/
		maxVisibleRows: {
			type: Number,
			default: void 0
		},
		/**
		* Allows to select multiple cells when 'command' or 'ctrl' is pressed
		*/
		multipleSelection: {
			type: Boolean,
			default: false
		},
		/**
		* Overrides colors for current user avatar
		*/
		overrideCurrentUserAvatar: {
			type: Boolean,
			default: false
		},
		/**
		* v-model:selected; allows handling selected entry
		*/
		/**
		* Overrides the default header label for the "no annotations" column/row
		*/
		noAnnotationLabel: {
			type: String,
			default: () => useI18n().t("rvai-base.components.confusionMatrix.noAnnotation")
		},
		selected: {
			type: Object,
			default: void 0
		},
		/**
		* Emits 'update:selected' with source ids, when true
		*/
		selectable: {
			type: Boolean,
			default: false
		},
		/**
		* Shows class name or class id
		*/
		showClassName: {
			type: Boolean,
			default: false
		},
		/**
		* Shows 'Match' text
		*/
		showMatchWord: {
			type: Boolean,
			default: false
		},
		/**
		* Data source 1
		*/
		source1: {
			type: Object,
			required: true
		},
		/**
		* Data source 2
		*/
		source2: {
			type: Object,
			required: true
		},
		/**
		* Always render borders between cells
		*/
		withBorders: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:selected"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const { isDark } = useDarkMode();
		const confusionMatrixRef = ref(null);
		const confusionMatrixTableRef = ref(null);
		const contentWidth = ref(0);
		const matrixWidth = ref(confusionMatrixRef.value?.offsetWidth ?? 0);
		const matrixHeight = ref(confusionMatrixRef.value?.offsetHeight ?? 0);
		const tableHeight = ref(confusionMatrixTableRef.value?.offsetHeight ?? 0);
		const reduced = ref(false);
		const classes1 = computed(() => {
			return props.matrix.getClasses1().map(getClass).filter(Boolean).sort(sortClasses);
		});
		const classes2 = computed(() => {
			return props.matrix.getClasses2().map(getClass).filter(Boolean).sort(sortClasses);
		});
		const cssVars = computed(() => {
			return {
				...props.maxVisibleRows && { "--max-rows": 2 + props.maxVisibleRows },
				"--matrix-cell-width": `${matrixCellWidth.value}px`,
				"--matrix-row-height": `${matrixRowHeight.value}px`,
				"--matrix-size": `${matrixWidth.value}px`
			};
		});
		const hasSquareBackground = computed(() => props.dense || props.detailed);
		const matrixCellWidth = computed(() => matrixWidth.value / (classes1.value.length + 2));
		const matrixRowHeight = computed(() => {
			return Math.max((props.detailed ? tableHeight.value : matrixHeight.value) / (classes2.value.length + (props.detailed ? 3 : 2)), props.detailed ? DETAILED_ROW_MIN_HEIGHT : 0);
		});
		const renderBorders = computed(() => matrixWidth.value / classes2.value.length > 30);
		function getClass(id) {
			const clazz = props.classes.find((c) => c.id === id);
			if (clazz) return clazz;
			return {
				color: "#ff0000",
				id,
				name: id === "null" ? props.noAnnotationLabel : id
			};
		}
		function getClassName(clazz) {
			if (clazz.id === "null") return props.noAnnotationLabel;
			return props.showClassName ? clazz.name ?? clazz.id : clazz.id;
		}
		function isSelected(id1, id2) {
			if (!props.selected || !props.selected.length) return false;
			return props.selected.some((x) => x.source1 === id1 && x.source2 === id2);
		}
		let maxTableWidth = 0;
		function calculateMatrixSize() {
			const count = classes2.value.length;
			if (!count) return;
			const fixed = props.dense ? 64 : 200;
			const limit = props.dense ? 16 : 100;
			const cellWidth = (contentWidth.value - fixed) / count;
			const tableWidth = confusionMatrixTableRef.value?.offsetWidth ?? 0;
			tableHeight.value = confusionMatrixTableRef.value?.offsetHeight ?? 0;
			if (tableWidth > contentWidth.value) maxTableWidth = tableWidth > maxTableWidth ? tableWidth : maxTableWidth;
			reduced.value = cellWidth < limit || contentWidth.value < maxTableWidth;
			matrixWidth.value = confusionMatrixRef.value?.offsetWidth ?? 0;
			matrixHeight.value = confusionMatrixRef.value?.offsetHeight ?? 0;
		}
		function onResize({ width }) {
			contentWidth.value = width;
			calculateMatrixSize();
		}
		function select(event, id1, id2) {
			if (!props.selectable) return;
			if (isSelected(id1, id2)) emit("update:selected", props.multipleSelection && (event.metaKey || event.ctrlKey) ? props.selected?.filter((x) => !(x.source1 === id1 && x.source2 === id2)) : void 0);
			else emit("update:selected", props.multipleSelection && (event.metaKey || event.ctrlKey) ? [...props.selected ?? [], {
				source1: id1 || void 0,
				source2: id2 || void 0
			}] : [{
				source1: id1 || void 0,
				source2: id2 || void 0
			}]);
		}
		function selectAllOutliers() {
			if (!props.selectable) return;
			emit("update:selected", props.matrix.getOutliers());
		}
		function deselectAllOutliers() {
			emit("update:selected", props.selected?.filter((cell) => cell.source1 === cell.source2));
		}
		function sortClasses(a, b) {
			if (a.id === "null" && b.id !== "null") return -1;
			if (b.id === "null" && a.id !== "null") return 1;
			if (a.id === "999" && b.id !== "999") return -1;
			if (b.id === "999" && a.id !== "999") return 1;
			return naturalSort(a.name, b.name);
		}
		function generateCSV() {
			return `${[
				"",
				props.source2.name,
				...(classes1.value ?? []).map((item) => getClassName(item)),
				t("rvai-base.components.confusionMatrix.matchPercentage")
			].map((value) => value.toString().replace(/,/g, ".")).join(",")}\n${[
				props.source1.name,
				"",
				...(classes1.value ?? []).map((item) => item.id === "null" || item.id === null ? "" : item.id),
				""
			].map((value) => value.toString().replace(/,/g, ".")).join(",")}\n${classes2.value.map((class2) => {
				return [
					getClassName(class2),
					class2.id === "null" || class2.id === null ? "" : class2.id,
					...classes1.value.map((class1) => props.matrix.getValue(class2.id, class1.id)),
					props.matrix.getMetric1(class2.id)
				].map((value) => value.toString().replace(/,/g, ".")).join(",");
			}).join("\n")}\n${[
				t("rvai-base.components.confusionMatrix.matchPercentage"),
				"",
				...(classes1.value ?? []).map((item) => props.matrix.getMetric2(item.id)),
				props.matrix.getMetricTotal()
			].map((value) => value.toString().replace(/,/g, ".")).join(",")}`;
		}
		watch(() => props.detailed, (value, prevValue) => {
			if (prevValue && !value) {
				maxTableWidth = 0;
				calculateMatrixSize();
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			classes1,
			classes2,
			confusionMatrixRef,
			confusionMatrixTableRef,
			cssVars,
			deselectAllOutliers,
			generateCSV,
			getClassName,
			hasSquareBackground,
			isDark,
			isSelected,
			NULL_CLASS_ID,
			onResize,
			reduced,
			renderBorders,
			select,
			selectAllOutliers,
			t
		};
	}
});
//#endregion
//#region src/components/ConfusionMatrix.vue
var _hoisted_1$68 = ["data-automation"];
var _hoisted_2$54 = { class: "col-auto q-py-xs" };
var _hoisted_3$45 = { class: "row no-wrap items-center text-bold" };
var _hoisted_4$28 = ["data-automation"];
var _hoisted_5$23 = {
	key: 0,
	class: "confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--left"
};
var _hoisted_6$13 = { class: "row items-center text-bold no-wrap" };
var _hoisted_7$11 = { class: "q-ml-sm zero-min-width" };
var _hoisted_8$7 = ["data-automation", "onClick"];
var _hoisted_9$6 = { class: "flex inline items-center no-wrap" };
var _hoisted_10$4 = ["data-automation"];
var _hoisted_11$4 = { class: "confusion-matrix__cell-wrapper" };
var _hoisted_12$3 = ["data-automation"];
var _hoisted_13$3 = ["onClick"];
var _hoisted_14$2 = ["data-automation"];
var _hoisted_15$2 = ["data-automation", "onClick"];
var _hoisted_16$1 = {
	key: 0,
	class: "confusion-matrix__cell--null"
};
var _hoisted_17$1 = {
	key: 1,
	class: "confusion-matrix__cell-value q-px-xs"
};
var _hoisted_18$1 = { class: "row no-wrap items-center q-mt-sm" };
var _hoisted_19$1 = { class: "row no-wrap items-center q-mt-sm" };
var _hoisted_20 = {
	key: 0,
	class: "confusion-matrix__cell--null"
};
var _hoisted_21 = { class: "confusion-matrix__cell-wrapper confusion-matrix__cell-value text-bold" };
var _hoisted_22 = {
	key: 0,
	class: "confusion-matrix__cell confusion-matrix__cell--left text-bold"
};
var _hoisted_23 = ["data-automation"];
var _hoisted_24 = {
	key: 0,
	class: "confusion-matrix__cell--null"
};
var _hoisted_25 = { class: "confusion-matrix__cell-value" };
var _hoisted_26 = { class: "confusion-matrix__cell-wrapper text-bold" };
function _sfc_render$68(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Avatar = resolveComponent("Avatar");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	const _component_Bullet = resolveComponent("Bullet");
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		ref: "confusionMatrixRef",
		class: normalizeClass(["confusion-matrix bg-white text-small text-grey-1", {
			"confusion-matrix--borders-x": _ctx.withBorders,
			"confusion-matrix--borders-y": _ctx.renderBorders || _ctx.withBorders,
			"confusion-matrix--dense": _ctx.dense,
			"confusion-matrix--superdense": _ctx.dense && _ctx.reduced,
			"confusion-matrix--selectable": _ctx.selectable,
			"confusion-matrix--square": _ctx.hasSquareBackground
		}]),
		"data-automation": _ctx.buildId(),
		style: normalizeStyle(_ctx.cssVars)
	}, [!_ctx.dense ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["confusion-matrix__before row justify-center full-width bg-white", { "q-pb-xs": _ctx.detailed }])
	}, [createElementVNode("div", _hoisted_2$54, [renderSlot(_ctx.$slots, "source2", {}, () => [createElementVNode("div", _hoisted_3$45, [createVNode(_component_Avatar, {
		"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
		"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
		"data-automation": _ctx.buildId("source2"),
		initials: _ctx.source2.initials,
		label: _ctx.source2.name,
		"show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
		"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
		uuid: _ctx.source2.id
	}, null, 8, [
		"background-color",
		"border-color",
		"data-automation",
		"initials",
		"label",
		"show-logo",
		"text-color",
		"uuid"
	]), createVNode(_component_EllipsisText, {
		class: "q-ml-sm",
		"data-automation": _ctx.buildId("source2__label"),
		text: _ctx.source2.name
	}, null, 8, ["data-automation", "text"])])], true)])], 2)) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["confusion-matrix__wrapper", { "confusion-matrix__wrapper--detailed": _ctx.detailed }]) }, [createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]), createElementVNode("div", {
		ref: "confusionMatrixTableRef",
		class: "confusion-matrix__table",
		"data-automation": _ctx.buildId("table")
	}, [
		!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["confusion-matrix__header bg-grey-5 text-bold", { "confusion-matrix__header--detailed": _ctx.detailed }])
		}, [
			!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_5$23, [!_ctx.dense ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }])
			}, [renderSlot(_ctx.$slots, "source1", {}, () => [createElementVNode("div", _hoisted_6$13, [createVNode(_component_Avatar, {
				"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
				"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
				"data-automation": _ctx.buildId("source1"),
				initials: _ctx.source1.initials,
				label: _ctx.source1.name,
				"show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
				"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
				uuid: _ctx.source1.id
			}, null, 8, [
				"background-color",
				"border-color",
				"data-automation",
				"initials",
				"label",
				"show-logo",
				"text-color",
				"uuid"
			]), createElementVNode("div", _hoisted_7$11, [createVNode(_component_EllipsisText, {
				"data-automation": _ctx.buildId("source1__label"),
				text: _ctx.source1.name
			}, null, 8, ["data-automation", "text"])])])], true)], 2)) : createCommentVNode("", true)])) : createCommentVNode("", true),
			(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
				return openBlock(), createElementBlock("div", {
					key: class2.id,
					class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header", {
						"confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
						"confusion-matrix__cell--selected": _ctx.isSelected(void 0, class2.id)
					}]),
					"data-automation": _ctx.buildId(`cell--header-${class2.id}`),
					onClick: ($event) => _ctx.select($event, void 0, class2.id)
				}, [createElementVNode("div", _hoisted_9$6, [
					class2.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
						key: 0,
						class: normalizeClass(["col-fixed", { "q-mr-xs": !_ctx.reduced && !_ctx.dense && class2.id !== _ctx.NULL_CLASS_ID }]),
						color: class2.color,
						"data-automation": _ctx.buildId(`cell--header-${class2.id}__bullet`),
						size: "8"
					}, null, 8, [
						"class",
						"color",
						"data-automation"
					])) : createCommentVNode("", true),
					!_ctx.reduced && !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
						key: 1,
						"data-automation": _ctx.buildId(`cell--header-${class2.id}__label`),
						text: _ctx.getClassName(class2)
					}, null, 8, ["data-automation", "text"])) : class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
						key: 2,
						"data-automation": _ctx.buildId(`cell--header-${class2.id}__label`)
					}, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_10$4)) : createCommentVNode("", true),
					_ctx.reduced || _ctx.dense ? (openBlock(), createBlock(_component_Tooltip, {
						key: 3,
						"data-automation": _ctx.buildId(`cell--header-${class2.id}__tooltip`)
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.getClassName(class2)), 1)]),
						_: 2
					}, 1032, ["data-automation"])) : createCommentVNode("", true)
				])], 10, _hoisted_8$7);
			}), 128)),
			createElementVNode("div", { class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }]) }, [createElementVNode("div", _hoisted_11$4, toDisplayString(!_ctx.dense && !_ctx.detailed ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 1)], 2)
		], 2)) : createCommentVNode("", true),
		(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes1, (class1, index1) => {
			return openBlock(), createElementBlock("div", {
				key: class1.id,
				class: normalizeClass(["confusion-matrix__row", { "confusion-matrix__row--last": index1 + 1 === _ctx.classes1.length }]),
				"data-automation": _ctx.buildId(`row-${class1.id}`)
			}, [
				!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--left text-bold", { "confusion-matrix__cell--selected": _ctx.isSelected(class1.id, void 0) }]),
					onClick: ($event) => _ctx.select($event, class1.id, void 0)
				}, [createElementVNode("div", { class: normalizeClass(["confusion-matrix__cell-wrapper flex inline items-center no-wrap", { "q-ml-sm": _ctx.detailed }]) }, [class1.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
					key: 0,
					class: normalizeClass(["col-fixed", { "q-mr-xs": !_ctx.dense && class1.id !== _ctx.NULL_CLASS_ID }]),
					color: class1.color,
					"data-automation": _ctx.buildId(`row-${class1.id}__bullet`),
					size: "8"
				}, null, 8, [
					"class",
					"color",
					"data-automation"
				])) : createCommentVNode("", true), !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
					key: 1,
					"data-automation": _ctx.buildId(`row-${class1.id}__label`),
					text: _ctx.getClassName(class1)
				}, null, 8, ["data-automation", "text"])) : class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
					key: 2,
					"data-automation": _ctx.buildId(`row-${class1.id}__label`)
				}, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_14$2)) : createCommentVNode("", true)], 2)], 10, _hoisted_13$3)) : createCommentVNode("", true),
				(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
					return openBlock(), createElementBlock("div", {
						key: class2.id,
						class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--content", {
							"confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
							"confusion-matrix__cell--selected": _ctx.isSelected(class1.id, class2.id)
						}]),
						"data-automation": _ctx.buildId(`cell--content-${class2.id}`),
						style: normalizeStyle(_ctx.matrix.getStyle(class1.id, class2.id, _ctx.isDark)),
						onClick: ($event) => _ctx.select($event, class1.id, class2.id)
					}, [
						class1.id === _ctx.NULL_CLASS_ID || class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_16$1)) : createCommentVNode("", true),
						!_ctx.dense ? (openBlock(), createElementBlock("div", _hoisted_17$1, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id) || "-"), 1)) : createCommentVNode("", true),
						createVNode(_component_Tooltip, {
							anchor: "center middle",
							"data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip`),
							self: "center left"
						}, {
							default: withCtx(() => [
								createElementVNode("div", null, [createElementVNode("strong", null, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id)), 1), createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.matrix.getPercentage(class1.id, class2.id)])), 1)]),
								createElementVNode("div", _hoisted_18$1, [createVNode(_component_Avatar, {
									"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
									"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
									"data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-avatar`),
									initials: _ctx.source2.initials,
									label: _ctx.source2.name,
									"show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
									"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
									uuid: _ctx.source2.id
								}, null, 8, [
									"background-color",
									"border-color",
									"data-automation",
									"initials",
									"label",
									"show-logo",
									"text-color",
									"uuid"
								]), createVNode(_component_EllipsisText, {
									class: "q-ml-sm",
									"data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-label`),
									text: _ctx.getClassName(class2)
								}, null, 8, ["data-automation", "text"])]),
								createElementVNode("div", _hoisted_19$1, [createVNode(_component_Avatar, {
									"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
									"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
									"data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-avatar`),
									initials: _ctx.source1.initials,
									label: _ctx.source1.name,
									"show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
									"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
									uuid: _ctx.source1.id
								}, null, 8, [
									"background-color",
									"border-color",
									"data-automation",
									"initials",
									"label",
									"show-logo",
									"text-color",
									"uuid"
								]), createVNode(_component_EllipsisText, {
									class: "q-ml-sm",
									"data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-label`),
									text: _ctx.getClassName(class1)
								}, null, 8, ["data-automation", "text"])])
							]),
							_: 2
						}, 1032, ["data-automation"])
					], 14, _hoisted_15$2);
				}), 128)),
				!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
				}, [class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_20)) : createCommentVNode("", true), createElementVNode("div", _hoisted_21, toDisplayString(_ctx.matrix.getMetric1(class1.id)), 1)], 2)) : createCommentVNode("", true)
			], 10, _hoisted_12$3);
		}), 128)),
		!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
			key: 1,
			class: normalizeClass(["confusion-matrix__footer bg-white", { "confusion-matrix__footer--detailed": _ctx.detailed }])
		}, [
			!_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_22, [createElementVNode("div", { class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }]) }, toDisplayString(!_ctx.dense && !_ctx.detailed || _ctx.showMatchWord ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 3)])) : createCommentVNode("", true),
			(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
				return openBlock(), createElementBlock("div", {
					key: class2.id,
					class: normalizeClass(["confusion-matrix__cell text-bold", { "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length }]),
					"data-automation": _ctx.buildId(`cell-${class2.id}`)
				}, [class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_24)) : createCommentVNode("", true), createElementVNode("div", _hoisted_25, toDisplayString(_ctx.matrix.getMetric2(class2.id)), 1)], 10, _hoisted_23);
			}), 128)),
			createElementVNode("div", { class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }]) }, [createElementVNode("div", _hoisted_26, toDisplayString(_ctx.matrix.getMetricTotal()), 1)], 2)
		], 2)) : createCommentVNode("", true)
	], 8, _hoisted_4$28)], 2)], 14, _hoisted_1$68);
}
var ConfusionMatrix_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ConfusionMatrix_vue_vue_type_script_lang_default, [["render", _sfc_render$68], ["__scopeId", "data-v-ddd35428"]]);
//#endregion
//#region src/components/CookiesDialog.vue?vue&type=script&lang.ts
var Steps = /* @__PURE__ */ function(Steps) {
	Steps["Action"] = "action";
	Steps["Info"] = "info";
	return Steps;
}(Steps || {});
var CookiesDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "CookiesDialog",
	components: {
		QCard: QCard_default,
		QCardActions: QCardActions_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		QIcon: QIcon_default,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "cookiesDialog"
		},
		/**
		* Provide cookies label for accept button
		*/
		cookiesAcceptBtn: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies label for reject button
		*/
		cookiesRejectBtn: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies title
		*/
		cookiesTitle: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies URL to open in the iframe
		*/
		cookiesUrl: {
			type: String,
			required: true
		},
		/**
		* Provide cookies dialog width
		*/
		cookiesWidth: {
			type: String,
			default: "420px"
		}
	},
	emits: [...useDialogPluginComponent.emits, "set-cookies-policy"],
	setup(props) {
		const { t } = useI18n();
		const { dialogRef, onDialogCancel, onDialogHide, onDialogOK } = useDialogPluginComponent();
		const { hasCookiesPolicy, setCookiesPolicy } = useCookiesPolicy();
		const currentStep = ref("action");
		function onAccept() {
			setCookiesPolicy(CookiesPolicy.All);
			onDialogOK();
		}
		function onReject() {
			setCookiesPolicy(CookiesPolicy.Required);
			onDialogOK();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			CookiesPolicy,
			currentStep,
			dialogRef,
			hasCookiesPolicy,
			onAccept,
			onCancel: onDialogCancel,
			onHide: onDialogHide,
			onReject,
			setCookiesPolicy,
			Steps,
			t
		};
	}
});
//#endregion
//#region src/components/CookiesDialog.vue
var _hoisted_1$67 = { class: "text-subtitle1 q-ml-sm" };
var _hoisted_2$53 = ["data-automation"];
var _hoisted_3$44 = ["data-automation", "src"];
function _sfc_render$67(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_i18n_t = resolveComponent("i18n-t");
	const _component_QCardActions = resolveComponent("QCardActions");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	const _directive_quasar_variables = resolveDirective("quasar-variables");
	return openBlock(), createBlock(_component_QDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId(),
		maximized: _ctx.currentStep === _ctx.Steps.Info,
		persistent: !_ctx.hasCookiesPolicy
	}, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
		default: withCtx(() => [_ctx.currentStep === _ctx.Steps.Action ? (openBlock(), createBlock(_component_QCard, {
			key: 0,
			class: "rv-cookies-actions-dialog column no-wrap",
			"data-automation": _ctx.buildId("card1"),
			style: normalizeStyle({ width: _ctx.cookiesWidth })
		}, {
			default: withCtx(() => [
				_ctx.hasCookiesPolicy ? (openBlock(), createBlock(_component_QCardSection, {
					key: 0,
					class: "q-pb-none flex justify-end"
				}, {
					default: withCtx(() => [createVNode(_component_RvButton, {
						"data-automation": _ctx.buildId("close1"),
						icon: "mdi-close",
						tertiary: "",
						onClick: _ctx.onCancel
					}, null, 8, ["data-automation", "onClick"])]),
					_: 1
				})) : createCommentVNode("", true),
				createVNode(_component_QCardSection, { class: normalizeClass(["row justify-center items-center", { "q-pt-none": _ctx.hasCookiesPolicy }]) }, {
					default: withCtx(() => [createVNode(_component_QIcon, {
						color: "black-1",
						"data-automation": _ctx.buildId("icon-cookie"),
						name: "rvai-base:cookie",
						size: "36px"
					}, null, 8, ["data-automation"]), createElementVNode("span", _hoisted_1$67, toDisplayString(_ctx.cookiesTitle || _ctx.t("rvai-base.policiesAndLicenses.titles.cookies")), 1)]),
					_: 1
				}, 8, ["class"]),
				createVNode(_component_QCardSection, { class: "rv-cookies-actions-dialog__content q-px-md q-py-none" }, {
					default: withCtx(() => [createVNode(_component_i18n_t, { keypath: "rvai-base.policiesAndLicenses.text.cookies" }, {
						here: withCtx(() => [createElementVNode("a", {
							class: "rv-cookies-actions-dialog__content--btn cursor-pointer",
							"data-automation": _ctx.buildId("btn-info"),
							onClick: _cache[0] || (_cache[0] = ($event) => _ctx.currentStep = _ctx.Steps.Info)
						}, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.actions.cookies.here")), 9, _hoisted_2$53)]),
						_: 1
					})]),
					_: 1
				}),
				createVNode(_component_QCardActions, { class: "row q-pa-md flex justify-end" }, {
					default: withCtx(() => [createVNode(_component_RvButton, {
						"data-automation": _ctx.buildId("reject"),
						label: _ctx.cookiesRejectBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.reject"),
						secondary: "",
						onClick: _ctx.onReject
					}, null, 8, [
						"data-automation",
						"label",
						"onClick"
					]), createVNode(_component_RvButton, {
						color: "primary",
						"data-automation": _ctx.buildId("accept"),
						label: _ctx.cookiesAcceptBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.accept"),
						onClick: _ctx.onAccept
					}, null, 8, [
						"data-automation",
						"label",
						"onClick"
					])]),
					_: 1
				})
			]),
			_: 1
		}, 8, ["data-automation", "style"])) : createCommentVNode("", true), _ctx.currentStep === _ctx.Steps.Info ? (openBlock(), createBlock(_component_QCard, {
			key: 1,
			class: "rv-cookies-info-dialog column no-wrap",
			"data-automation": _ctx.buildId("card2")
		}, {
			default: withCtx(() => [createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
				default: withCtx(() => [createVNode(_component_RvButton, {
					"data-automation": _ctx.buildId("close2"),
					icon: "mdi-close",
					tertiary: "",
					onClick: _cache[1] || (_cache[1] = ($event) => _ctx.currentStep = _ctx.Steps.Action)
				}, null, 8, ["data-automation"])]),
				_: 1
			}), createVNode(_component_QCardSection, { class: "full-width full-height" }, {
				default: withCtx(() => [withDirectives(createElementVNode("iframe", {
					"data-automation": _ctx.buildId("iframe"),
					frameborder: "0",
					height: "100%",
					src: _ctx.cookiesUrl,
					width: "100%"
				}, null, 8, _hoisted_3$44), [[_directive_quasar_variables]])]),
				_: 1
			})]),
			_: 1
		}, 8, ["data-automation"])) : createCommentVNode("", true)]),
		_: 1
	}, 16, [
		"data-automation",
		"maximized",
		"persistent",
		"onHide"
	]);
}
var CookiesDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CookiesDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$67], ["__scopeId", "data-v-92fcbcd8"]]);
//#endregion
//#region src/components/CopyContentBtn.vue?vue&type=script&lang.ts
var CopyContentBtn_vue_vue_type_script_lang_default = defineComponent({
	name: "CopyContentBtn",
	components: {
		RvButton: Button_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		color: {
			type: String,
			default: "primary"
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in 'flat' design
		*/
		flat: {
			type: Boolean,
			default: true
		},
		/**
		* Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
		*/
		icon: {
			type: String,
			default: "mdi-content-copy"
		},
		/**
		* Text displayed next to icon
		*/
		label: {
			type: String,
			default: ""
		},
		/**
		* Hides icon
		*/
		noIcon: {
			type: Boolean,
			default: true
		},
		/**
		* Render button in secondary mode
		*/
		secondary: {
			type: Boolean,
			default: false
		},
		/**
		* Shows default label after copying (by default 5000ms, can be changed with time-after-copying property)
		*/
		showDefaultLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Size in standard size name (xs|sm|md|lg)
		*/
		size: {
			type: String,
			default: "md"
		},
		/**
		* The time in ms after which 'Copied' changes to default label. By default 5000ms.
		*/
		timeAfterCopying: {
			type: Number,
			default: 5e3
		},
		/**
		* Text copied to clipboard
		*/
		value: {
			type: String,
			required: true
		}
	},
	emits: ["click"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const copied = ref(false);
		const currentIcon = computed(() => {
			return props.noIcon || copied.value ? void 0 : props.icon;
		});
		const currentLabel = computed(() => {
			return copied.value ? t("rvai-base.components.copyContentButton.copied") : props.label;
		});
		async function copyToClipboard() {
			try {
				if ("clipboard" in navigator) navigator.clipboard.writeText(props.value);
				const node = createNode(props.value);
				document.body.appendChild(node);
				const selection = getSelection();
				if (!selection) throw new Error();
				selection.removeAllRanges();
				const range = document.createRange();
				range.selectNodeContents(node);
				selection.addRange(range);
				document.execCommand("copy");
				selection.removeAllRanges();
				document.body.removeChild(node);
				copied.value = true;
				if (props.showDefaultLabel) {
					await wait(props.timeAfterCopying);
					copied.value = false;
				}
			} catch (e) {
				console.error("Failed to copy to clipboard", e);
			} finally {
				emit("click");
			}
		}
		function createNode(text) {
			const node = document.createElement("pre");
			node.style.height = "1px";
			node.style.position = "fixed";
			node.style.top = "5px";
			node.style.width = "1px";
			node.textContent = text;
			return node;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			copied,
			copyToClipboard,
			currentIcon,
			currentLabel,
			t
		};
	}
});
//#endregion
//#region src/components/CopyContentBtn.vue
function _sfc_render$66(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createBlock(_component_RvButton, mergeProps(_ctx.dataAttrs, {
		class: ["copy-content-btn cursor-pointer", _ctx.$props.class],
		color: _ctx.disable ? "grey-2" : _ctx.color,
		"data-automation": _ctx.buildId(),
		disable: _ctx.disable,
		icon: _ctx.currentIcon,
		label: _ctx.currentLabel,
		secondary: _ctx.secondary,
		size: _ctx.size,
		tertiary: _ctx.flat,
		onClick: _cache[0] || (_cache[0] = () => _ctx.copyToClipboard())
	}), {
		default: withCtx(() => [!_ctx.disable && !_ctx.copied ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.components.copyContentButton.copy")), 1)]),
			_: 1
		})) : createCommentVNode("", true)]),
		_: 1
	}, 16, [
		"class",
		"color",
		"data-automation",
		"disable",
		"icon",
		"label",
		"secondary",
		"size",
		"tertiary"
	]);
}
var CopyContentBtn_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CopyContentBtn_vue_vue_type_script_lang_default, [["render", _sfc_render$66]]);
//#endregion
//#region src/components/DatePicker.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$66 = ["data-automation"];
var _hoisted_2$52 = { class: "rv-date" };
var _hoisted_3$43 = ["data-automation"];
var _hoisted_4$27 = {
	class: "q-mt-md q-mb-sm",
	style: {
		"margin-left": "13px",
		"margin-right": "13px"
	}
};
var _hoisted_5$22 = {
	class: "flex flex-row no-wrap",
	style: {
		"margin-left": "11px",
		"margin-right": "11px"
	}
};
var _hoisted_6$12 = { class: "q-px-sm flex items-center" };
var _hoisted_7$10 = { class: "q-px-sm flex items-center" };
var DATE_FORMAT = "yyyy-MM-dd";
var DATE_WITH_FULL_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
var DATE_WITH_TIME_FORMAT = "yyyy-MM-dd HH:mm";
//#endregion
//#region src/components/DatePicker.vue
var DatePicker_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DatePicker",
	props: /*@__PURE__*/ mergeModels({
		clearable: {
			type: Boolean,
			default: true
		},
		dataAutomation: { default: void 0 },
		dense: {
			type: Boolean,
			default: false
		},
		label: { default: "" },
		locale: { default: void 0 },
		optionalLabel: { default: "" },
		options: {
			type: Function,
			default: () => true
		},
		placeholder: { default: "" },
		showHint: {
			type: Boolean,
			default: true
		},
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		validationError: { default: "" },
		validationErrorShownWhen: { default: "focused" },
		withSeconds: {
			type: Boolean,
			default: true
		},
		withTime: {
			type: Boolean,
			default: false
		},
		withValidation: {
			type: Boolean,
			default: false
		},
		wrapperClass: { default: void 0 }
	}, {
		"modelValue": { default: "" },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["update:original-value"], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		useCssVars((_ctx) => ({ "v6d1b3038": messagesColor.value }));
		const DATE_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/g;
		const DATE_WITH_FULL_TIME_FORMAT_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/g;
		const DATE_WITH_TIME_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9])$/g;
		const props = __props;
		/**
		* v-model has 'YYYY-MM-DD HH:mm:ss' format (or 'YYYY-MM-DD HH:mm' if withSeconds is false), otherwise 'YYYY-MM-DD'
		**/
		const model = useModel(__props, "modelValue");
		const emit = __emit;
		const { t } = useI18n();
		const isFocused = ref(false);
		const originalData = ref(model.value);
		const popupRef = ref(null);
		const inputRef = ref(null);
		const defaultLocale = {
			days: t("rvai-base.components.datePicker.days").split("_"),
			daysShort: t("rvai-base.components.datePicker.daysShort").split("_"),
			firstDayOfWeek: 0,
			months: t("rvai-base.components.datePicker.months").toUpperCase().split("_"),
			monthsShort: t("rvai-base.components.datePicker.monthsShort").toUpperCase().split("_")
		};
		const dateFormat = computed(() => {
			if (!props.withTime) return DATE_FORMAT;
			return props.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
		});
		const regex = computed(() => {
			if (!props.withTime) return DATE_REGEX;
			return props.withSeconds ? DATE_WITH_FULL_TIME_FORMAT_REGEX : DATE_WITH_TIME_REGEX;
		});
		const hours = ref("");
		function parseTimeComponents(value) {
			const res = {
				hours: "",
				minutes: "",
				seconds: ""
			};
			if (!value) return res;
			const [_date, time] = value.split(" ");
			if (!time) return res;
			const [hours, minutes, seconds] = time.split(":");
			res.hours = hours ?? "";
			res.minutes = minutes ?? "";
			res.seconds = props.withSeconds ? seconds ?? "" : "";
			return res;
		}
		function hoursBlur() {
			const v = hours.value ?? "00";
			const [dates, time] = getCurrent().split(" ");
			const timeArray = time.split(":");
			const minutesString = timeArray[1] ?? "00";
			const secondsString = props.withSeconds ? timeArray[2] ?? "00" : "";
			const regex1 = /^[0-9]$/gi;
			const regex2 = /^[0][1-9]$/gi;
			const regex3 = /^[0][1][0-9]$/gi;
			const regex4 = /^[0][2][0-3]$/gi;
			const regex5 = /^[2][0-3]$/gi;
			const regex6 = /^[1][0-9]$/gi;
			const regex7 = /^[0]+$/gi;
			const regex8 = /^[0][0][1-9]$/gi;
			const timeFormat = props.withSeconds ? `:${secondsString}` : "";
			const setModelHours = (hours) => {
				model.value = `${dates} ${hours}:${minutesString}${timeFormat}`;
			};
			if (Number(v) > 23) setModelHours("23");
			else if (regex1.test(v)) setModelHours(`0${v}`);
			else if (regex2.test(v) || regex5.test(v) || regex6.test(v)) setModelHours(v);
			else if (regex3.test(v) || regex4.test(v) || regex8.test(v)) setModelHours(v.substring(1, 3));
			else if (regex7.test(v)) setModelHours("00");
		}
		const minutes = ref("");
		function minutesBlur() {
			const minutesValue = minutes.value ?? "00";
			const [dates, time] = getCurrent().split(" ");
			const timeArray = time.split(":");
			const hoursString = timeArray[0] ?? "00";
			const secondsString = props.withSeconds ? timeArray[2] ?? "00" : "";
			const singleDigitRegex = /^[0-9]$/gi;
			const zeroAndSingleDigitRegex = /^[0][1-9]$/gi;
			const zeroAndDoubleDigitRegex = /^[0][0-5][0-9]$/gi;
			const fullDoubleDigitRegex = /^[1-5][0-9]$/gi;
			const allZeroesRegex = /^[0]+$/gi;
			const doubleZeroAndDigitRegex = /^[0][0][1-9]$/gi;
			const timeFormat = props.withSeconds ? `:${secondsString}` : "";
			const dateHH = `${dates} ${hoursString}`;
			const setModelMinutes = (hours) => {
				model.value = `${dateHH}:${hours}${timeFormat}`;
			};
			if (Number(minutesValue) > 60) setModelMinutes("59");
			else if (singleDigitRegex.test(minutesValue)) setModelMinutes(`0${minutesValue}`);
			else if (zeroAndSingleDigitRegex.test(minutesValue) || fullDoubleDigitRegex.test(minutesValue)) setModelMinutes(`${minutesValue}`);
			else if (zeroAndDoubleDigitRegex.test(minutesValue) || doubleZeroAndDigitRegex.test(minutesValue)) setModelMinutes(`${minutesValue.substring(1, 3)}`);
			else if (allZeroesRegex.test(minutesValue)) setModelMinutes("00");
		}
		const seconds = ref("");
		function secondsBlur() {
			const secondsValue = seconds.value ?? "00";
			const [dates, time] = getCurrent().split(" ");
			const timeArray = time.split(":");
			const hoursString = timeArray[0] ?? "00";
			const minutesString = timeArray[1] ?? "00";
			const regex1 = /^[0-9]$/gi;
			const regex2 = /^[0][1-9]$/gi;
			const regex3 = /^[0][0-5][0-9]$/gi;
			const regex4 = /^[1-5][0-9]$/gi;
			const regex5 = /^[0]+$/gi;
			const regex6 = /^[0][0][1-9]$/gi;
			const setModelSeconds = (seconds) => {
				model.value = `${dates} ${hoursString}:${minutesString}:${seconds}`;
			};
			if (Number(secondsValue) > 60) setModelSeconds("59");
			else if (regex1.test(secondsValue)) setModelSeconds(`0${secondsValue}`);
			else if (regex2.test(secondsValue) || regex4.test(secondsValue)) setModelSeconds(secondsValue);
			else if (regex3.test(secondsValue) || regex6.test(secondsValue)) setModelSeconds(secondsValue.substring(1, 3));
			else if (regex5.test(secondsValue)) setModelSeconds("00");
		}
		const date = computed({
			get() {
				return model.value;
			},
			set(value) {
				if (!props.clearable && !value) return;
				if (!value) {
					model.value = "";
					return;
				}
				const v = getDateValue(value);
				if (!props.options(v)) return;
				if (v.length !== mask.value.length) return;
				if (new RegExp(regex.value).test(v)) model.value = v;
				if (popupRef.value && !props.withTime) {
					popupRef.value.hide();
					inputRef.value?.blur();
				}
			}
		});
		const mask = computed(() => {
			if (!props.withTime) return "YYYY-MM-DD";
			return props.withSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
		});
		const messagesColor = computed(() => props.withValidation && v$.value.$invalid ? "var(--q-negative)" : "var(--q-grey-1)");
		const shouldShowPassedValidationError = computed(() => {
			if (props.validationErrorShownWhen === "focused") return isFocused.value;
			return props.validationError !== "";
		});
		const v$ = useVuelidate(computed(() => {
			return { originalData: ValidationBuilder.withLabel("Datepicker").custom((value) => !value || new RegExp(regex.value).test(value), t("rvai-base.components.datePicker.wrongFormat")).customError(shouldShowPassedValidationError.value ? props.validationError : "").rules };
		}), { originalData }, { $autoDirty: true });
		/**
		* Returns time value in format 'HH:mm:ss' or 'HH:mm'
		* If some time components are missing, returns empty string
		*/
		function getTimeValue() {
			if (!hours.value || !minutes.value || props.withSeconds && !seconds.value) return "";
			return props.withSeconds ? `${hours.value}:${minutes.value}:${seconds.value}` : `${hours.value}:${minutes.value}`;
		}
		function getDateValue(value) {
			const time = getTimeValue();
			return time && value.split(" ")[1] !== time ? `${value.split(" ")[0]} ${time}` : value;
		}
		function getCurrent() {
			const today = startOfToday();
			const fullTimeFormat = props.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
			if (model.value) {
				const parsed = parse$1(model.value, dateFormat.value, today);
				if (isValid(parsed)) return format(parsed, fullTimeFormat);
			}
			return format(today, fullTimeFormat);
		}
		function onBeforeHide() {
			if (!props.withTime) return;
			const curr = parseTimeComponents(model.value);
			if (hours.value !== curr.hours) hoursBlur();
			if (minutes.value !== curr.minutes) minutesBlur();
			if (props.withSeconds && seconds.value !== curr.seconds) secondsBlur();
		}
		function isValidValue(v) {
			return v.length === mask.value.length && new RegExp(regex.value).test(v) && props.options(v);
		}
		function updateValueOnBlur() {
			const v = originalData.value;
			if (!isValidValue(v)) {
				originalData.value = model.value;
				return;
			}
			model.value = v;
		}
		function onBlur() {
			isFocused.value = false;
			updateValueOnBlur();
		}
		function onFocus() {
			isFocused.value = true;
		}
		function resetDate() {
			originalData.value = "";
			model.value = "";
		}
		watch(model, (value) => {
			originalData.value = value;
			const time = parseTimeComponents(value);
			hours.value = time.hours;
			minutes.value = time.minutes;
			seconds.value = time.seconds;
		}, { immediate: true });
		watch(originalData, () => {
			emit("update:original-value", originalData.value);
		}, { immediate: true });
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["rv-date-picker", [__props.wrapperClass, { "rv-date-picker--dense": __props.dense }]]),
				"data-automation": unref(buildId)()
			}, [createVNode(Input_default, {
				ref_key: "inputRef",
				ref: inputRef,
				modelValue: originalData.value,
				"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => originalData.value = $event),
				"data-automation": unref(buildId)("date"),
				hint: __props.showHint ? mask.value : void 0,
				label: __props.label,
				maxlength: "0",
				"optional-label": __props.optionalLabel,
				placeholder: __props.placeholder,
				"show-optional-label": __props.showOptionalLabel,
				"show-valid": false,
				validation: __props.withValidation ? unref(v$).originalData : void 0,
				onBlur,
				onFocus
			}, {
				append: withCtx(() => [createVNode(unref(QIcon_default), {
					class: "cursor-pointer",
					color: "grey-1",
					"data-automation": unref(buildId)("icon-calendar"),
					name: "rvai-base:calendar"
				}, {
					default: withCtx(() => [createVNode(unref(QPopupProxy_default), {
						ref_key: "popupRef",
						ref: popupRef,
						offset: [0, 5],
						onBeforeHide
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_2$52, [createVNode(unref(QDate_default), {
							modelValue: date.value,
							"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => date.value = $event),
							class: "rv-date",
							"data-automation": unref(buildId)("date-picker"),
							locale: __props.locale ?? defaultLocale,
							mask: mask.value,
							minimal: "",
							options: __props.options,
							"years-in-month-view": false
						}, {
							default: withCtx(() => [__props.withTime ? (openBlock(), createElementBlock("div", {
								key: 0,
								class: "border-top",
								"data-automation": unref(buildId)("with-time")
							}, [renderSlot(_ctx.$slots, "time-input-label", {}, () => [createElementVNode("div", _hoisted_4$27, toDisplayString(unref(t)("rvai-base.components.datePicker.selectTime")), 1)], true), createElementVNode("div", _hoisted_5$22, [
								createVNode(Input_default, {
									modelValue: hours.value,
									"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => hours.value = $event),
									"data-automation": unref(buildId)("hours"),
									maxlength: "3",
									placeholder: unref(t)("rvai-base.components.datePicker.hh"),
									onBlur: hoursBlur
								}, null, 8, [
									"modelValue",
									"data-automation",
									"placeholder"
								]),
								createElementVNode("div", _hoisted_6$12, toDisplayString(unref(t)("rvai-base.general.symbols.semicolon")), 1),
								createVNode(Input_default, {
									modelValue: minutes.value,
									"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => minutes.value = $event),
									"data-automation": unref(buildId)("minutes"),
									maxlength: "3",
									placeholder: unref(t)("rvai-base.components.datePicker.mm"),
									onBlur: minutesBlur
								}, null, 8, [
									"modelValue",
									"data-automation",
									"placeholder"
								]),
								__props.withSeconds ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", _hoisted_7$10, toDisplayString(unref(t)("rvai-base.general.symbols.semicolon")), 1), createVNode(Input_default, {
									modelValue: seconds.value,
									"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => seconds.value = $event),
									"data-automation": unref(buildId)("seconds"),
									maxlength: "3",
									placeholder: unref(t)("rvai-base.components.datePicker.ss"),
									onBlur: secondsBlur
								}, null, 8, [
									"modelValue",
									"data-automation",
									"placeholder"
								])], 64)) : createCommentVNode("", true)
							])], 8, _hoisted_3$43)) : createCommentVNode("", true)]),
							_: 3
						}, 8, [
							"modelValue",
							"data-automation",
							"locale",
							"mask",
							"options"
						])])]),
						_: 3
					}, 512)]),
					_: 3
				}, 8, ["data-automation"]), __props.clearable && __props.modelValue ? (openBlock(), createBlock(unref(QIcon_default), {
					key: 0,
					class: "cursor-pointer",
					color: "grey-1",
					"data-automation": unref(buildId)("icon-close"),
					name: "rvai-base:close",
					onClick: resetDate
				}, null, 8, ["data-automation"])) : createCommentVNode("", true)]),
				_: 3
			}, 8, [
				"modelValue",
				"data-automation",
				"hint",
				"label",
				"optional-label",
				"placeholder",
				"show-optional-label",
				"validation"
			])], 10, _hoisted_1$66);
		};
	}
}), [["__scopeId", "data-v-79705e97"]]);
//#endregion
//#region src/components/DoubleCircularProgress.vue?vue&type=script&lang.ts
var OUTER_THICKNESS_DEFAULT_VALUE = .2;
var DoubleCircularProgress_vue_vue_type_script_lang_default = defineComponent({
	name: "DoubleCircularProgress",
	components: { CircularProgress: CircularProgress_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "double-circular-progress"
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
		*/
		fontSize: {
			type: String,
			default: "8px"
		},
		/**
		* Color name for the inner arc progress from the Quasar Color Palette
		*/
		innerColor: {
			type: String,
			default: "grey-2"
		},
		/**
		* Put inner component into 'indeterminate' state; Ignores 'value' prop
		*/
		innerIndeterminate: {
			type: Boolean,
			default: false
		},
		/**
		* Maximum value for inner circle defining 100% progress made (must be higher than 'min')
		*/
		innerMax: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value for inner circle defining 'no progress' (must be lower than 'max')
		*/
		innerMin: {
			type: Number,
			default: 0
		},
		/**
		* Inner component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
		*/
		innerSize: {
			type: String,
			default: void 0
		},
		/**
		* Thickness of inner progress arc as a ratio (0.0 < x < 1.0) of component size
		*/
		innerThickness: {
			type: Number,
			default: void 0
		},
		/**
		* Color name for the inner track of the component from the Quasar Color Palette
		*/
		innerTrackColor: {
			type: String,
			default: void 0
		},
		/**
		* Current progress for inner component (must be between min/max)
		*/
		innerValue: {
			type: Number,
			default: 0
		},
		/**
		* Color name for the outer arc progress from the Quasar Color Palette
		*/
		outerColor: {
			type: String,
			default: "primary"
		},
		/**
		* Put outer component into 'indeterminate' state; Ignores 'value' prop
		*/
		outerIndeterminate: {
			type: Boolean,
			default: false
		},
		/**
		* Maximum value for outer circle defining 100% progress made (must be higher than 'min')
		*/
		outerMax: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value for outer circle defining 'no progress' (must be lower than 'max')
		*/
		outerMin: {
			type: Number,
			default: 0
		},
		/**
		* Outer component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
		*/
		outerSize: {
			type: String,
			default: "50px"
		},
		/**
		* Thickness of outer progress arc as a ratio (0.0 < x < 1.0) of component size
		*/
		outerThickness: {
			type: Number,
			default: void 0
		},
		/**
		* Color name for the outer track of the component from the Quasar Color Palette
		*/
		outerTrackColor: {
			type: String,
			default: void 0
		},
		/**
		* Current progress for outer component  (must be between min/max)
		*/
		outerValue: {
			type: Number,
			default: 0
		},
		/**
		* Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
		* Make sure the text has enough space to be displayed inside the component
		*/
		showValue: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { isDark } = useDarkMode();
		const innerSizeComputed = computed(() => {
			return props.innerSize ?? `${Math.ceil(parseInt(props.outerSize) - parseInt(props.outerSize) * outerThicknessComputed.value)}px`;
		});
		const innerThicknessComputed = computed(() => {
			const innerThickness = parseInt(props.outerSize) * outerThicknessComputed.value / parseInt(innerSizeComputed.value);
			return props.innerThickness ?? innerThickness;
		});
		const innerTrackColorComputed = computed(() => {
			if (props.innerTrackColor) return props.innerTrackColor;
			return isDark.value ? "grey-1--dark" : "grey-3--light";
		});
		const outerThicknessComputed = computed(() => {
			return props.outerThickness ?? OUTER_THICKNESS_DEFAULT_VALUE;
		});
		const outerTrackColorComputed = computed(() => {
			if (props.outerTrackColor) return props.outerTrackColor;
			return isDark.value ? "grey-1--dark" : "grey-3--light";
		});
		const percentage = computed(() => {
			const innerPercentage = Math.round(props.innerValue / props.innerMax * 100);
			const outerPercentage = Math.round(props.outerValue / props.outerMax * 100);
			return Math.max(innerPercentage, outerPercentage);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			innerSizeComputed,
			innerThicknessComputed,
			innerTrackColorComputed,
			outerThicknessComputed,
			outerTrackColorComputed,
			percentage
		};
	}
});
//#endregion
//#region src/components/DoubleCircularProgress.vue
function _sfc_render$65(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_CircularProgress = resolveComponent("CircularProgress");
	return openBlock(), createBlock(_component_CircularProgress, {
		class: normalizeClass(_ctx.$props.class),
		color: _ctx.outerColor,
		"data-automation": _ctx.buildId(),
		indeterminate: _ctx.outerIndeterminate,
		max: _ctx.outerMax,
		min: _ctx.outerMin,
		"show-value": "",
		size: _ctx.outerSize,
		thickness: _ctx.outerThicknessComputed,
		"track-color": _ctx.outerTrackColorComputed,
		value: _ctx.outerValue
	}, {
		default: withCtx(() => [createVNode(_component_CircularProgress, {
			color: _ctx.innerColor,
			"data-automation": _ctx.buildId("inner"),
			"font-size": _ctx.fontSize,
			indeterminate: _ctx.innerIndeterminate,
			max: _ctx.innerMax,
			min: _ctx.innerMin,
			"show-value": _ctx.showValue,
			size: _ctx.innerSizeComputed,
			thickness: _ctx.innerThicknessComputed,
			"track-color": _ctx.innerTrackColorComputed,
			value: _ctx.innerValue
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "default", { percentage: _ctx.percentage })]),
			_: 3
		}, 8, [
			"color",
			"data-automation",
			"font-size",
			"indeterminate",
			"max",
			"min",
			"show-value",
			"size",
			"thickness",
			"track-color",
			"value"
		])]),
		_: 3
	}, 8, [
		"class",
		"color",
		"data-automation",
		"indeterminate",
		"max",
		"min",
		"size",
		"thickness",
		"track-color",
		"value"
	]);
}
var DoubleCircularProgress_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DoubleCircularProgress_vue_vue_type_script_lang_default, [["render", _sfc_render$65]]);
//#endregion
//#region src/components/ButtonDropdown.vue
var ButtonDropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "ButtonDropdown",
	props: {
		align: { default: "center" },
		autoClose: {
			type: Boolean,
			default: false
		},
		class: { default: void 0 },
		color: { default: "primary" },
		dataAutomation: { default: void 0 },
		disable: {
			type: Boolean,
			default: false
		},
		icon: { default: void 0 },
		iconRight: { default: void 0 },
		label: { default: void 0 },
		loading: {
			type: [Boolean, null],
			default: false
		},
		secondary: {
			type: Boolean,
			default: false
		},
		size: { default: "md" },
		style: { default: void 0 },
		tertiary: {
			type: Boolean,
			default: false
		},
		textColor: { default: void 0 },
		tooltip: { default: void 0 }
	},
	setup(__props, { expose: __expose }) {
		const slots = useSlots();
		const props = __props;
		const dropdown = useTemplateRef("dropdown");
		__expose({ dropdown });
		const { buildId, dataAttrs } = useAutomation(computed(() => props.dataAutomation));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(QBtnDropdown_default), mergeProps({
				ref_key: "dropdown",
				ref: dropdown
			}, unref(dataAttrs), {
				align: __props.align,
				"auto-close": __props.autoClose,
				class: ["rv-button-dropdown", [
					props.class,
					`rv-button-dropdown--${__props.size}`,
					{ "rv-button-dropdown--icon-only": !__props.label }
				]],
				color: __props.color,
				"data-automation": unref(buildId)(),
				disable: __props.disable,
				flat: __props.tertiary,
				icon: __props.icon,
				"icon-right": __props.iconRight,
				label: __props.label,
				loading: __props.loading,
				"no-caps": "",
				outline: __props.secondary,
				ripple: false,
				style: __props.style,
				"text-color": __props.textColor
			}), createSlots({ _: 2 }, [__props.tooltip ? {
				name: "label",
				fn: withCtx(() => [createVNode(Tooltip_default, { "data-automation": unref(buildId)("tooltip") }, {
					default: withCtx(() => [createTextVNode(toDisplayString(__props.tooltip), 1)]),
					_: 1
				}, 8, ["data-automation"])]),
				key: "0"
			} : void 0, renderList(unref(slots), (_, name) => {
				return {
					name,
					fn: withCtx((slotData) => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)])
				};
			})]), 1040, [
				"align",
				"auto-close",
				"class",
				"color",
				"data-automation",
				"disable",
				"flat",
				"icon",
				"icon-right",
				"label",
				"loading",
				"outline",
				"style",
				"text-color"
			]);
		};
	}
}), [["__scopeId", "data-v-010e4085"]]);
//#endregion
//#region src/components/Validation.vue?vue&type=script&lang.ts
var Validation_vue_vue_type_script_lang_default = defineComponent({
	name: "Validation",
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		validation: {
			type: Object,
			default: void 0
		}
	},
	setup(props) {
		const { classRef, error, errorMessage } = useValidation(props);
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			classRef,
			error,
			errorMessage
		};
	}
});
//#endregion
//#region src/components/Validation.vue
var _hoisted_1$65 = ["data-automation"];
var _hoisted_2$51 = { class: "q-field--dense q-field--error" };
var _hoisted_3$42 = ["data-automation"];
function _sfc_render$64(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "rv-validation",
		"data-automation": _ctx.buildId()
	}, [renderSlot(_ctx.$slots, "default", {}, void 0, true), createElementVNode("div", _hoisted_2$51, [_ctx.error ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["q-field__bottom", _ctx.classRef]),
		"data-automation": _ctx.buildId("error"),
		role: "alert"
	}, toDisplayString(_ctx.errorMessage), 11, _hoisted_3$42)) : createCommentVNode("", true)])], 8, _hoisted_1$65);
}
var Validation_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Validation_vue_vue_type_script_lang_default, [["render", _sfc_render$64], ["__scopeId", "data-v-c4b1d2e6"]]);
//#endregion
//#region src/components/Dropzone.vue?vue&type=script&lang.ts
var Dropzone_vue_vue_type_script_lang_default = defineComponent({
	name: "Dropzone",
	components: {
		QIcon: QIcon_default,
		Validation: Validation_default
	},
	props: {
		/**
		* Allowed extensions (.tgz|.jpg|.png etc.)
		*/
		allowedExtensions: {
			type: Array,
			default: void 0
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Indicates that only directories should be available to be selected by the user in the file picker interface.
		*/
		directory: {
			type: Boolean,
			default: false
		},
		/**
		* Indicates that dropzone is disabled.
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Empty state title
		*/
		emptyTitle: {
			type: String,
			default: void 0
		},
		/**
		* Allowed number of files, if multiple is true
		*/
		maxFiles: {
			type: Number,
			default: 1e3
		},
		/**
		* The maximum allowed size of the combined files (in bytes)
		*/
		maxSize: {
			type: Number,
			default: void 0
		},
		/**
		* Model value - always an array, even if multiple is false
		*/
		modelValue: {
			type: Array,
			required: true
		},
		/**
		* Allows to select more than one file
		*/
		multiple: {
			type: Boolean,
			default: true
		},
		/**
		* Makes the selection of files optional. If false, will return a validation error if empty.
		*/
		optional: {
			type: Boolean,
			default: false
		}
	},
	emits: ["clear", "update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const inputRef = ref();
		const dragging = ref(false);
		const isDisabled = computed(() => {
			if (error.value) return true;
			if (!props.multiple && !!props.modelValue.length) return true;
			return props.disable;
		});
		const error = computed(() => {
			if (!v$.value.$error) return void 0;
			return v$.value.$errors[0]?.$message;
		});
		const extensions = computed(() => {
			return props.allowedExtensions?.join(", ");
		});
		const hasData = computed(() => {
			return !!props.modelValue.length;
		});
		const icon = computed(() => {
			if (error.value) return "mdi-alert-circle-outline";
			else if (hasData.value) return "mdi-check-circle";
			else return "rvai-base:arrow-circle-up";
		});
		const title = computed(() => {
			if (error.value) return t("rvai-base.components.dropzone.errorTitle");
			else if (hasData.value) return t("rvai-base.components.dropzone.dataTitle", props.modelValue.length);
			else if (props.emptyTitle) return props.emptyTitle;
			else if (props.dense) return t("rvai-base.components.dropzone.denseTitle");
			else return t("rvai-base.components.dropzone.emptyTitle", props.multiple ? props.maxFiles : 1);
		});
		const totalFileSize = computed(() => {
			return props.modelValue.reduce((acc, f) => acc + f.size, 0);
		});
		const v$ = useVuelidate(computed(() => ({ value: ValidationBuilder.$t("rvai-base.general.text.theValue").custom((files) => {
			const maxFiles = props.multiple ? props.maxFiles : 1;
			return files.length <= maxFiles;
		}, "rvai-base.components.dropzone.validation.maxFiles", [props.multiple ? props.maxFiles : 1], "maxFiles").custom((files) => {
			const { allowedExtensions } = props;
			if (!allowedExtensions?.length) return true;
			return files.every((f) => allowedExtensions.some((ext) => f.name.toLowerCase().endsWith(ext)));
		}, "rvai-base.components.dropzone.validation.fileExtensions", [], "fileExtensions").custom(() => {
			const { maxSize } = props;
			if (!maxSize) return true;
			return totalFileSize.value <= maxSize;
		}, "rvai-base.components.dropzone.validation.maxSize", computed(() => [formatBytes(totalFileSize.value, 3), formatBytes(props.maxSize ?? 0, 3)]), "maxSize").rules })), computed(() => ({ value: props.modelValue })), { $autoDirty: true });
		const vRequired$ = useVuelidate(computed(() => ({ value: ValidationBuilder.$t("rvai-base.general.text.theValue").arrayRequiredIf(!props.optional).rules })), computed(() => ({ value: props.modelValue })), { $autoDirty: true });
		function onChange(files) {
			if (!files.length) return;
			emit("update:modelValue", [...props.modelValue, ...files]);
		}
		function onClear() {
			emit("update:modelValue", []);
			emit("clear");
		}
		function onClick() {
			if (isDisabled.value) return;
			inputRef.value?.click();
		}
		function onDragLeave(e) {
			e.preventDefault();
			e.stopPropagation();
			dragging.value = false;
		}
		function onDragOver(e) {
			e.preventDefault();
			e.stopPropagation();
			if (isDisabled.value) return;
			dragging.value = true;
		}
		async function onDrop(e) {
			e.preventDefault();
			e.stopPropagation();
			dragging.value = false;
			if (!e.dataTransfer || isDisabled.value) return;
			try {
				const files = await getFiles(e.dataTransfer.items);
				onChange(props.multiple ? files : [files[0]]);
			} catch (error) {
				console.error(error);
			}
		}
		function onFilesChanged(e) {
			const input = e.target;
			onChange(Array.from(input?.files ?? []));
			input.value = "";
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			dragging,
			error,
			extensions,
			hasData,
			icon,
			inputRef,
			isDisabled,
			onClear,
			onClick,
			onDragLeave,
			onDragOver,
			onDrop,
			onFilesChanged,
			t,
			title,
			v$,
			vRequired$
		};
	}
});
//#endregion
//#region src/components/Dropzone.vue
var _hoisted_1$64 = ["data-automation"];
var _hoisted_2$50 = ["data-automation"];
var _hoisted_3$41 = ["data-automation"];
var _hoisted_4$26 = ["data-automation"];
var _hoisted_5$21 = ["data-automation"];
var _hoisted_6$11 = { class: "dropzone__link" };
var _hoisted_7$9 = ["data-automation"];
var _hoisted_8$6 = ["data-automation"];
var _hoisted_9$5 = { class: "dropzone__link" };
var _hoisted_10$3 = ["data-automation"];
var _hoisted_11$3 = ["data-automation"];
var _hoisted_12$2 = { class: "text-small" };
var _hoisted_13$2 = [
	"accept",
	"data-automation",
	"multiple",
	"webkitdirectory"
];
function _sfc_render$63(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_i18n_t = resolveComponent("i18n-t");
	const _component_Validation = resolveComponent("Validation");
	return openBlock(), createBlock(_component_Validation, {
		"data-automation": _ctx.buildId("validation"),
		validation: _ctx.vRequired$.value
	}, {
		default: withCtx(() => [createElementVNode("div", {
			class: normalizeClass(["dropzone column no-wrap items-center bg-white rounded-borders text-center q-pa-lg", {
				"cursor-pointer": !_ctx.isDisabled,
				"dropzone--dragging": _ctx.dragging,
				"dropzone--disabled text-grey-2": _ctx.disable
			}]),
			"data-automation": _ctx.buildId(),
			onClick: _cache[4] || (_cache[4] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
			onDragenter: _cache[5] || (_cache[5] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
			onDragleave: _cache[6] || (_cache[6] = (...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args)),
			onDragover: _cache[7] || (_cache[7] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
			onDrop: _cache[8] || (_cache[8] = (...args) => _ctx.onDrop && _ctx.onDrop(...args))
		}, [
			createVNode(_component_QIcon, {
				class: "dropzone__icon q-mb-md",
				"data-automation": _ctx.buildId("icon"),
				name: _ctx.icon,
				size: "40px"
			}, null, 8, ["data-automation", "name"]),
			createElementVNode("div", {
				class: "text-subtitle2 text-black-1",
				"data-automation": _ctx.buildId("title")
			}, toDisplayString(_ctx.title), 9, _hoisted_2$50),
			_ctx.error ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
				class: "text-small",
				"data-automation": _ctx.buildId("error")
			}, toDisplayString(_ctx.error), 9, _hoisted_3$41), createElementVNode("div", {
				class: "text-small q-mt-sm",
				"data-automation": _ctx.buildId("description")
			}, [createElementVNode("span", {
				class: "cursor-pointer dropzone__link",
				onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
			}, toDisplayString(_ctx.t("rvai-base.components.dropzone.retry")), 1)], 8, _hoisted_4$26)], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
				_ctx.hasData ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.multiple ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [!_ctx.dense ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("maxFiles")
				}, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.maxFiles)), 9, _hoisted_5$21)) : createCommentVNode("", true), createVNode(_component_i18n_t, {
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("description"),
					keypath: "rvai-base.components.dropzone.dataDescription",
					scope: "global",
					tag: "div"
				}, {
					default: withCtx(() => [createElementVNode("span", _hoisted_6$11, toDisplayString(_ctx.t("rvai-base.components.dropzone.addMore")), 1), createElementVNode("span", {
						class: "dropzone__link",
						onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
					}, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearAll")), 1)]),
					_: 1
				}, 8, ["data-automation"])], 64)) : (openBlock(), createElementBlock("div", {
					key: 1,
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("description")
				}, [createElementVNode("span", {
					class: "cursor-pointer dropzone__link",
					onClick: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
				}, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearFile")), 1)], 8, _hoisted_7$9))], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [!_ctx.dense ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("maxFiles")
				}, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.multiple ? _ctx.maxFiles : 1)), 9, _hoisted_8$6)) : createCommentVNode("", true), !_ctx.dense ? (openBlock(), createBlock(_component_i18n_t, {
					key: 1,
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("description"),
					keypath: "rvai-base.components.dropzone.emptyDescription",
					scope: "global",
					tag: "div"
				}, {
					default: withCtx(() => [createElementVNode("span", _hoisted_9$5, toDisplayString(_ctx.t("rvai-base.components.dropzone.uploadFromComputer")), 1)]),
					_: 1
				}, 8, ["data-automation"])) : createCommentVNode("", true)], 64)),
				_ctx.allowedExtensions && !_ctx.dense ? (openBlock(), createElementBlock("div", {
					key: 2,
					class: "text-small q-mt-sm",
					"data-automation": _ctx.buildId("extensions")
				}, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.allowedExtensions.join(", ")])), 9, _hoisted_10$3)) : createCommentVNode("", true),
				_ctx.dragging ? (openBlock(), createElementBlock("div", {
					key: 3,
					class: "dropzone__drag column no-wrap justify-center items-center q-mt-sm",
					"data-automation": _ctx.buildId("dragging")
				}, [
					createElementVNode("div", { class: normalizeClass(["dropzone__drag__icon col-fixed", [_ctx.dense ? "q-mb-md" : "q-mb-lg", { "dropzone__drag__icon--dense": _ctx.dense }]]) }, [createVNode(_component_QIcon, {
						color: "white",
						name: "rvai-base:file-copy",
						size: _ctx.dense ? "22px" : "32px"
					}, null, 8, ["size"])], 2),
					createElementVNode("div", { class: normalizeClass(["text-subtitle2 text-black-1", { "q-mb-sm": !_ctx.dense }]) }, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragTitle")), 3),
					createElementVNode("div", _hoisted_12$2, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragDescription")), 1)
				], 8, _hoisted_11$3)) : createCommentVNode("", true)
			], 64)),
			createElementVNode("input", {
				ref: "inputRef",
				accept: _ctx.extensions,
				class: "hidden",
				"data-automation": _ctx.buildId("input"),
				multiple: _ctx.multiple,
				type: "file",
				webkitdirectory: _ctx.directory,
				onChange: _cache[3] || (_cache[3] = (...args) => _ctx.onFilesChanged && _ctx.onFilesChanged(...args))
			}, null, 40, _hoisted_13$2)
		], 42, _hoisted_1$64)]),
		_: 1
	}, 8, ["data-automation", "validation"]);
}
var Dropzone_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Dropzone_vue_vue_type_script_lang_default, [["render", _sfc_render$63], ["__scopeId", "data-v-3311582a"]]);
//#endregion
//#region src/components/Select.vue?vue&type=script&lang.ts
var Select_vue_vue_type_script_lang_default = defineComponent({
	name: "RvSelect",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		QSelect: QSelect_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: true,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Show label inside element
		*/
		caption: {
			type: String,
			default: void 0
		},
		/**
		* Show clear button
		*/
		clearable: {
			type: Boolean,
			default: false
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Override default selection string, if not using 'selected' slot/scoped slot and if not using 'use-chips' prop
		*/
		displayValue: {
			type: [Number, String],
			default: void 0
		},
		/**
		* Update model with the value of the selected option instead of the whole option
		*/
		emitValue: {
			type: Boolean,
			default: false
		},
		/**
		* Fills the input with current value; Useful along with 'hide-selected'; Does NOT works along with 'multiple' selection
		*/
		fillInput: {
			type: Boolean,
			default: false
		},
		/**
		* Hides selection; Use the underlying input tag to hold the label (instead of showing it to the right of the input) of the selected option; Only works for non 'multiple' Selects
		*/
		hideSelected: {
			type: Boolean,
			default: false
		},
		/**
		* Helper (hint) text which gets placed below your wrapped form component
		*/
		hint: {
			type: String,
			default: void 0
		},
		/**
		* Adds info icon and shows the text on hover
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: "rv-select__info-text"
		},
		/**
		* Debounce the input model update with an amount of milliseconds
		*/
		inputDebounce: {
			type: [Number, String],
			default: 500
		},
		/**
		* A text label that will “float” up above the input field, once the field gets focus
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Try to map labels of model from 'options' Array; has a small performance penalty; If you are using emit-value you will probably need to use map-options to display the label text in the select field rather than the value;  Refer to the 'Affecting model' section above
		*/
		mapOptions: {
			type: Boolean,
			default: false
		},
		/**
		* Model of the component; Must be Array if using 'multiple' prop; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: [
				Array,
				Number,
				Object,
				String,
				Boolean
			],
			default: void 0
		},
		/**
		* Allow multiple selection; Model must be Array
		*/
		multiple: {
			type: Boolean,
			default: false
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionLabel: {
			type: String,
			default: "label"
		},
		/**
		* Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionValue: {
			type: String,
			default: "value"
		},
		/**
		* Available options that the user can select from. For best performance freeze the list of options.
		*/
		options: {
			type: [
				Number,
				Object,
				String,
				Boolean
			],
			default: () => []
		},
		/**
		* Dense mode for options list; occupies less space
		*/
		optionsDense: {
			type: Boolean,
			default: false
		},
		/**
		* A text that is shown in the select input when no value is selected
		* It is not used when `displayValue` is set to truthy value
		* (Because we still have legacy code that uses displayValue prop to simulate placeholder)
		*/
		placeholder: {
			type: String,
			default: ""
		},
		/**
		* Class definitions to be attributed to the popup content
		*/
		popupContentClass: {
			type: String,
			default: "rv-select__menu"
		},
		/**
		* Put component in readonly mode
		*/
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		* Shows label before select
		*/
		showLabelBefore: {
			type: Boolean,
			default: false
		},
		/**
		* Shows optional label after base label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Use an input tag where users can type
		*/
		useInput: {
			type: Boolean,
			default: false
		},
		/**
		* Validation for the component
		*/
		validation: {
			type: Object,
			default: void 0
		}
	},
	emits: [
		"filter",
		"input-value",
		"on-popup-hide",
		"on-popup-show",
		"update:modelValue"
	],
	setup(props, { emit, slots }) {
		const { t } = useI18n();
		const { classRef, error, errorMessage, isValidated, onBlur } = useValidation(props);
		const selectRef = ref(null);
		const showCaption = ref(!!props.caption);
		const optionWidth = computed(() => {
			return (selectRef.value?.$el.offsetWidth ?? 0) - 64;
		});
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		const placeholderIsShown = computed(() => Boolean(props.displayValue == null && !value.value && props.placeholder));
		const actualDisplayValue = computed(() => placeholderIsShown.value ? props.placeholder : props.displayValue);
		function onFilter(...args) {
			emit("filter", ...args);
		}
		function onInput(value) {
			emit("input-value", value);
		}
		function onPopupHide() {
			showCaption.value = true;
			emit("on-popup-hide");
		}
		function onPopupShow() {
			showCaption.value = false;
			emit("on-popup-show");
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			actualDisplayValue,
			classRef,
			error,
			errorMessage,
			isValidated,
			onBlur,
			onFilter,
			onInput,
			onPopupHide,
			onPopupShow,
			optionWidth,
			placeholderIsShown,
			showCaption,
			slots,
			t,
			value
		};
	}
});
//#endregion
//#region src/components/Select.vue
var _hoisted_1$63 = ["data-automation"];
var _hoisted_2$49 = {
	key: 0,
	class: "rv-select__label row no-wrap items-center"
};
var _hoisted_3$40 = {
	key: 0,
	class: "q-ml-xs"
};
var _hoisted_4$25 = { class: "rv-select__label text-black-1 row no-wrap items-center" };
var _hoisted_5$20 = {
	key: 0,
	class: "q-ml-xs"
};
function _sfc_render$62(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_QItem = resolveComponent("QItem");
	const _component_QSelect = resolveComponent("QSelect");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["rv-select", [_ctx.classRef, {
			"rv-select--dense": _ctx.dense,
			"rv-select--disabled": _ctx.disable || _ctx.readonly
		}]]),
		"data-automation": _ctx.buildId()
	}, [!_ctx.showLabelBefore ? (openBlock(), createElementBlock("div", _hoisted_2$49, [
		createVNode(_component_EllipsisText, {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("label")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
			_: 1
		}, 8, ["data-automation"]),
		_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$40, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
		_ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "q-ml-xs info-icon",
			color: "black-1",
			"data-automation": _ctx.buildId("icon-info"),
			name: "info",
			size: "16px"
		}, {
			default: withCtx(() => [createVNode(_component_Tooltip, {
				anchor: "top middle",
				class: normalizeClass(_ctx.infoTextClass),
				self: "bottom middle"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
				_: 3
			}, 8, ["class"])]),
			_: 3
		}, 8, ["data-automation"])) : createCommentVNode("", true)
	])) : createCommentVNode("", true), createVNode(_component_QSelect, mergeProps({
		ref: "selectRef",
		modelValue: _ctx.value,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
		class: _ctx.placeholderIsShown ? "q-field--placeholder" : void 0,
		clearable: _ctx.clearable,
		"data-automation": _ctx.buildId("select"),
		dense: "",
		disable: _ctx.disable || _ctx.readonly,
		"display-value": _ctx.actualDisplayValue,
		"emit-value": _ctx.emitValue,
		error: _ctx.error,
		"error-message": _ctx.errorMessage,
		"fill-input": _ctx.fillInput,
		"hide-bottom-space": "",
		"hide-selected": _ctx.hideSelected,
		hint: _ctx.hint,
		"input-debounce": _ctx.inputDebounce,
		"map-options": _ctx.mapOptions,
		multiple: _ctx.multiple,
		"no-error-icon": "",
		"option-label": _ctx.optionLabel,
		"option-value": _ctx.optionValue,
		options: _ctx.options,
		"options-dense": _ctx.optionsDense,
		"popup-content-class": _ctx.popupContentClass,
		standout: "",
		"use-input": _ctx.useInput,
		"v-model": _ctx.modelValue,
		"virtual-scroll-slice-size": 100
	}, { [toHandlerKey(_ctx.useInput && `filter`)]: _ctx.onFilter }, { [toHandlerKey(_ctx.useInput && `inputValue`)]: _ctx.onInput }, {
		onBlur: _ctx.onBlur,
		onPopupHide: _ctx.onPopupHide,
		onPopupShow: _ctx.onPopupShow
	}), createSlots({
		option: withCtx(({ itemProps, opt, selected }) => [createVNode(_component_QItem, mergeProps(itemProps, { "data-automation": _ctx.buildId(`option-${opt[_ctx.optionLabel] || opt}`) }), {
			default: withCtx(() => [createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
				default: withCtx(() => [createVNode(_component_QItemLabel, { class: "q-item__label" }, {
					default: withCtx(() => [createVNode(_component_EllipsisText, {
						style: normalizeStyle({ "width": `${_ctx.optionWidth}px` }),
						text: opt[_ctx.optionLabel] || opt
					}, null, 8, ["style", "text"])]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024), createVNode(_component_QItemSection, { side: "" }, {
				default: withCtx(() => [selected ? (openBlock(), createBlock(_component_QIcon, {
					key: 0,
					class: "rv-select__option--icon",
					color: "grey-1",
					name: "mdi-check",
					size: "18px"
				})) : createCommentVNode("", true)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1040, ["data-automation"])]),
		_: 2
	}, [
		_ctx.modelValue == null && _ctx.caption && _ctx.showCaption ? {
			name: "selected",
			fn: withCtx(() => [createVNode(_component_EllipsisText, {
				class: "rv-select__caption flex items-center",
				"data-automation": _ctx.buildId("caption"),
				text: _ctx.caption
			}, null, 8, ["data-automation", "text"])]),
			key: "0"
		} : void 0,
		_ctx.isValidated && (Array.isArray(_ctx.modelValue) ? _ctx.modelValue.length : _ctx.modelValue != null) ? {
			name: "after",
			fn: withCtx(() => [createVNode(_component_QIcon, {
				key: "valid",
				class: "rv-select__after--icon",
				color: "positive",
				"data-automation": _ctx.buildId("icon-valid"),
				name: "mdi-check-circle"
			}, null, 8, ["data-automation"])]),
			key: "1"
		} : _ctx.error ? {
			name: "after",
			fn: withCtx(() => [createVNode(_component_QIcon, {
				key: "error",
				class: "rv-select__after--icon",
				color: "negative",
				"data-automation": _ctx.buildId("icon-error"),
				name: "mdi-close-circle"
			}, null, 8, ["data-automation"])]),
			key: "2"
		} : void 0,
		_ctx.showLabelBefore ? {
			name: "before",
			fn: withCtx(() => [createElementVNode("div", _hoisted_4$25, [createVNode(_component_EllipsisText, { class: "text-subtitle3" }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			}), _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_5$20, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true)])]),
			key: "3"
		} : void 0,
		renderList(_ctx.slots, (_, name) => {
			return {
				name,
				fn: withCtx((slotData) => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)])
			};
		})
	]), 1040, [
		"modelValue",
		"class",
		"clearable",
		"data-automation",
		"disable",
		"display-value",
		"emit-value",
		"error",
		"error-message",
		"fill-input",
		"hide-selected",
		"hint",
		"input-debounce",
		"map-options",
		"multiple",
		"option-label",
		"option-value",
		"options",
		"options-dense",
		"popup-content-class",
		"use-input",
		"v-model",
		"onBlur",
		"onPopupHide",
		"onPopupShow"
	])], 10, _hoisted_1$63);
}
var Select_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Select_vue_vue_type_script_lang_default, [["render", _sfc_render$62], ["__scopeId", "data-v-fff15ce1"]]);
//#endregion
//#region src/components/Duration.vue?vue&type=script&lang.ts
var Duration_vue_vue_type_script_lang_default = defineComponent({
	name: "Duration",
	components: { RvSelect: Select_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* A text label that will “float” up above the select
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Duration time in seconds
		*/
		modelValue: {
			type: Number,
			required: true
		}
	},
	emits: ["update:modelValue"],
	setup(props) {
		const { t } = useI18n();
		const options = [
			600,
			3600,
			21600,
			86400,
			259200,
			604800,
			2678400,
			-1
		].map((v) => ({
			label: v > 0 ? formatDuration$1(v * 1e3) : t("rvai-base.components.duration.infinite"),
			value: v
		}));
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			options
		};
	}
});
//#endregion
//#region src/components/Duration.vue
function _sfc_render$61(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvSelect = resolveComponent("RvSelect");
	return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.dataAttrs, {
		class: _ctx.$props.class,
		"data-automation": _ctx.buildId(),
		"emit-value": "",
		label: _ctx.label,
		"map-options": "",
		"model-value": _ctx.modelValue,
		options: _ctx.options,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
	}), null, 16, [
		"class",
		"data-automation",
		"label",
		"model-value",
		"options"
	]);
}
var Duration_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Duration_vue_vue_type_script_lang_default, [["render", _sfc_render$61]]);
//#endregion
//#region src/components/EditableText.vue?vue&type=script&lang.ts
var EditableText_vue_vue_type_script_lang_default = defineComponent({
	name: "EditableText",
	components: {
		EllipsisText: EllipsisText_default,
		RvButton: Button_default,
		RvInput: Input_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Initialize the component in edit mode. Focus on the input.
		*/
		defaultEdit: {
			type: Boolean,
			default: false
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in disabled mode(show only plain text)
		*/
		disableEdit: {
			type: Boolean,
			default: false
		},
		/**
		* The value to be displayed.
		*/
		displayValue: {
			type: String,
			default: void 0
		},
		/**
		* Trigger update:model-value always. Without comparing with model-value.
		*/
		emitEveryTime: {
			type: Boolean,
			default: false
		},
		/**
		* Hides the edit button. Edit can still be triggered via ref.
		*/
		hideEdit: {
			type: Boolean,
			default: false
		},
		/**
		* Classes to be applied to the input component
		*/
		inputClass: {
			type: [
				Array,
				String,
				Object
			],
			default: void 0
		},
		/**
		* Show 3dots at the beginning
		* @type {Boolean}
		*/
		reverseEllipsisText: {
			type: Boolean,
			default: false
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
		*/
		modelValue: {
			required: true,
			type: String
		},
		/**
		* Disable update on blur
		*/
		noUpdateOnBlur: {
			type: Boolean,
			default: false
		},
		/**
		* Always shows disabled button
		*/
		showButtonWhenDisabled: {
			type: Boolean,
			default: false
		},
		/**
		* Equivalent to Vue Router <router-link> 'to' property
		*/
		to: {
			type: [Object, String],
			default: void 0
		},
		/**
		* Validation rules for the component
		*/
		validationRules: {
			type: Object,
			default: void 0
		}
	},
	emits: [
		"cancel",
		"edit",
		"update:modelValue"
	],
	setup(props, { emit }) {
		const editing = ref(props.defaultEdit);
		const inputRef = ref(null);
		const newValue = ref(props.modelValue);
		const newValueTrimmed = ref(newValue.value.trim());
		const v$ = useVuelidate$1({ ...props.validationRules && { newValue: props.validationRules } }, { newValue: newValueTrimmed }, { $autoDirty: true });
		function edit() {
			onEditClick();
		}
		function onCancel() {
			editing.value = false;
			newValue.value = props.modelValue;
			emit("cancel");
		}
		function onBlur() {
			if (props.noUpdateOnBlur) onCancel();
			else onSave();
		}
		function onKeyUp(evt) {
			switch (evt.key) {
				case "Enter":
					evt.stopPropagation();
					evt.preventDefault();
					onSave();
					return;
				case "Escape":
					evt.stopPropagation();
					evt.preventDefault();
					return onCancel();
			}
		}
		function onEditClick() {
			v$.value.$reset();
			editing.value = !props.disableEdit;
			emit("edit");
		}
		async function onSave() {
			if (!await v$.value.$validate()) {
				onCancel();
				return;
			}
			editing.value = false;
			if (newValueTrimmed.value !== props.modelValue || props.emitEveryTime) emit("update:modelValue", newValueTrimmed.value);
		}
		watch(() => props.modelValue, (value) => {
			newValue.value = value;
		});
		watch(newValue, (v) => {
			newValueTrimmed.value = v.trim();
		});
		watch(editing, (value) => {
			if (value) document.addEventListener("keyup", onKeyUp);
			else document.removeEventListener("keyup", onKeyUp);
		}, { immediate: true });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			edit,
			editing,
			inputRef,
			newValue,
			onBlur,
			onEditClick,
			onKeyUp,
			RouterLink,
			v$
		};
	}
});
//#endregion
//#region src/components/EditableText.vue
var _hoisted_1$62 = ["data-automation"];
var _hoisted_2$48 = ["data-automation"];
var _hoisted_3$39 = {
	key: 1,
	class: "editable-text__text-block flex items-center no-wrap"
};
function _sfc_render$60(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvInput = resolveComponent("RvInput");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createElementBlock("div", {
		class: "editable-text",
		"data-automation": _ctx.buildId()
	}, [_ctx.editing && !_ctx.disableEdit ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "row no-wrap items-center",
		"data-automation": _ctx.buildId("container"),
		tabindex: "0"
	}, [createVNode(_component_RvInput, {
		ref: "inputRef",
		modelValue: _ctx.newValue,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
		autofocus: "",
		class: "editable-text__input",
		"data-automation": _ctx.buildId("input"),
		dense: _ctx.dense,
		"show-error-as-tooltip": "",
		"show-error-message": false,
		"tab-index": 0,
		validation: _ctx.v$.newValue,
		onBlur: _ctx.onBlur
	}, null, 8, [
		"modelValue",
		"data-automation",
		"dense",
		"validation",
		"onBlur"
	])], 8, _hoisted_2$48)) : (openBlock(), createElementBlock("div", _hoisted_3$39, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
		class: normalizeClass(["editable-text__text q-mr-sm zero-min-width", { "editable-text__text--clickable": !!_ctx.to && !_ctx.disableEdit }]),
		to: _ctx.to
	}, {
		default: withCtx(() => [createVNode(_component_EllipsisText, {
			"data-automation": _ctx.buildId("label"),
			reverse: _ctx.reverseEllipsisText,
			text: _ctx.displayValue == null ? _ctx.modelValue : _ctx.displayValue
		}, null, 8, [
			"data-automation",
			"reverse",
			"text"
		])]),
		_: 1
	}, 8, ["class", "to"])), _ctx.showButtonWhenDisabled ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [!_ctx.hideEdit ? (openBlock(), createBlock(_component_RvButton, {
		key: 0,
		class: "editable-text__edit",
		"data-automation": _ctx.buildId("edit"),
		disable: _ctx.disableEdit,
		icon: "edit",
		size: "sm",
		tertiary: "",
		"text-color": "black-1",
		onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "disabled", {}, void 0, true)]),
		_: 3
	}, 8, [
		"data-automation",
		"disable",
		"onClick"
	])) : createCommentVNode("", true)], 64)) : !_ctx.disableEdit && !_ctx.hideEdit ? (openBlock(), createBlock(_component_RvButton, {
		key: 1,
		class: "editable-text__edit",
		"data-automation": _ctx.buildId("edit"),
		icon: "edit",
		size: "sm",
		tertiary: "",
		"text-color": "black-1",
		onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
	}, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)]))], 8, _hoisted_1$62);
}
var EditableText_default = /*#__PURE__*/ _plugin_vue_export_helper_default(EditableText_vue_vue_type_script_lang_default, [["render", _sfc_render$60], ["__scopeId", "data-v-7bd5ac11"]]);
//#endregion
//#region src/components/Toggle.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$61 = ["data-automation"];
var _hoisted_2$47 = ["data-automation"];
//#endregion
//#region src/components/Toggle.vue
var Toggle_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Toggle",
	props: /*@__PURE__*/ mergeModels({
		class: { default: void 0 },
		dataAutomation: { default: void 0 },
		dense: {
			type: Boolean,
			default: false
		},
		disable: {
			type: Boolean,
			default: false
		},
		falseValue: { default: false },
		infoText: { default: void 0 },
		infoTextClass: { default: "rv-toggle__info-text" },
		infoTextMaxWidth: { default: void 0 },
		label: { default: "" },
		trueValue: { default: true },
		val: { default: void 0 }
	}, {
		"modelValue": { default: void 0 },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const props = __props;
		const value = useModel(__props, "modelValue");
		const attrs = useAttrs();
		const { buildId } = useAutomation(computed(() => props.dataAutomation ?? attrs["data-automation"]));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "rv-toggle row items-center",
				"data-automation": unref(buildId)("wrapper")
			}, [createVNode(unref(QToggle_default), {
				modelValue: value.value,
				"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
				class: normalizeClass(_ctx.$props.class),
				"data-automation": unref(buildId)(),
				dense: __props.dense,
				disable: __props.disable,
				"false-value": __props.falseValue,
				"true-value": __props.trueValue,
				val: __props.val
			}, {
				default: withCtx(() => [__props.label || _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {}, () => [createElementVNode("div", {
					class: "rv-toggle__label text-body3 q-ml-sm row items-center",
					"data-automation": unref(buildId)("label")
				}, [createTextVNode(toDisplayString(__props.label) + " ", 1), __props.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(unref(QIcon_default), {
					key: 0,
					class: "q-ml-xs info-icon",
					color: "black-1",
					"data-automation": unref(buildId)("icon-info"),
					name: "info",
					size: "16px",
					onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
				}, {
					default: withCtx(() => [createVNode(Tooltip_default, {
						anchor: "top middle",
						class: normalizeClass(__props.infoTextClass),
						"data-automation": unref(buildId)("info-tooltip"),
						"max-width": __props.infoTextMaxWidth,
						self: "bottom middle"
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(__props.infoText), 1)], true)]),
						_: 3
					}, 8, [
						"class",
						"data-automation",
						"max-width"
					])]),
					_: 3
				}, 8, ["data-automation"])) : createCommentVNode("", true)], 8, _hoisted_2$47)], true, 0) : createCommentVNode("", true)]),
				_: 3
			}, 8, [
				"modelValue",
				"class",
				"data-automation",
				"dense",
				"disable",
				"false-value",
				"true-value",
				"val"
			])], 8, _hoisted_1$61);
		};
	}
}), [["__scopeId", "data-v-04084ca4"]]);
//#endregion
//#region src/components/ExpansionItem.vue?vue&type=script&lang.ts
var ExpansionItem_vue_vue_type_script_lang_default = defineComponent({
	name: "ExpansionItem",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QSlideTransition: QSlideTransition_default,
		QSpace: QSpace_default,
		Toggle: Toggle_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: void 0,
			type: String
		},
		/**
		* Applies a generic border radius
		*/
		border: {
			default: false,
			type: Boolean
		},
		/**
		* Show header below content when expanded
		*/
		bottomHeader: {
			default: false,
			type: Boolean
		},
		/**
		* Apply custom class(es) to the content
		* @type {[Array, Object, String]}
		*/
		contentClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		/**
		* Puts expansion item into open state on initial render; Overridden by v-model if used
		*/
		defaultOpened: {
			default: false,
			type: Boolean
		},
		/**
		* Disable the expansion item: prevents toggling and disables the toggle control
		*/
		disable: {
			default: false,
			type: Boolean
		},
		/**
		* Apply custom class(es) to the expand icon
		* @type {[Array, Object, String]}
		*/
		expandIconClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		/**
		* Size of the expand icon (e.g. 'xs', 'sm', '12px')
		*/
		expandIconSize: {
			default: "sm",
			type: String
		},
		/**
		* Apply custom class(es) to the header actions
		* @type {[Array, Object, String]}
		*/
		headerActionsClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		/**
		* Apply custom class(es) to the header
		* @type {[Array, Object, String]}
		*/
		headerClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		/**
		* Applies background to all component when title is hovered
		* color name from the Quasar Color Palette
		*/
		hoverBackgroundColor: {
			type: String,
			default: ""
		},
		/**
		* Apply custom class(es) to the icon item section
		* @type {[Array, Object, String]}
		*/
		iconClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		/**
		* Header label (unless using 'header' slot)
		*/
		label: {
			default: void 0,
			type: String
		},
		/**
		* A class that will be passed to the tooltip component of the label
		*/
		labelTooltipClass: {
			default: void 0,
			type: String
		},
		/**
		* Model of the component defining the 'expanded' state; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			default: void 0,
			type: Boolean
		},
		/**
		* Disable animation on hover
		*/
		noHoverAnimation: {
			default: false,
			type: Boolean
		},
		/**
		* Show control on the right
		*/
		rightIcon: {
			default: false,
			type: Boolean
		},
		/**
		* Indicates whether or not the item is toggleable.
		*/
		toggleable: {
			default: true,
			type: Boolean
		},
		/**
		* Time duration to animate hide/show content
		*/
		transitionDuration: {
			default: 400,
			type: Number
		},
		/**
		* Show toggle to control visibility
		*/
		useToggle: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:model-value"],
	setup(props, { emit }) {
		const expanded = ref(false);
		const hovered = ref(false);
		const invertIcon = computed(() => props.rightIcon || props.bottomHeader);
		watchEffect(() => {
			expanded.value = props.modelValue ?? props.defaultOpened;
		});
		function hide() {
			expanded.value = false;
			emit("update:model-value", expanded.value);
		}
		function show() {
			expanded.value = true;
			emit("update:model-value", expanded.value);
		}
		function toggle() {
			if (props.disable) return;
			expanded.value = !expanded.value;
			emit("update:model-value", expanded.value);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			expanded,
			hide,
			hovered,
			invertIcon,
			show,
			toggle
		};
	}
});
//#endregion
//#region src/components/ExpansionItem.vue
var _hoisted_1$60 = ["data-automation"];
var _hoisted_2$46 = ["data-automation"];
var _hoisted_3$38 = { class: "row no-wrap items-center" };
var _hoisted_4$24 = {
	key: 0,
	class: "expansion-item__content-wrapper"
};
var _hoisted_5$19 = ["data-automation"];
function _sfc_render$59(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Toggle = resolveComponent("Toggle");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_QSlideTransition = resolveComponent("QSlideTransition");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["expansion-item column no-wrap", {
			"border-card rounded-borders q-pa-md": _ctx.border,
			"expansion-item--expanded": _ctx.expanded,
			[_ctx.hoverBackgroundColor]: _ctx.hoverBackgroundColor && _ctx.hovered,
			"expansion-item--invert-icon": _ctx.invertIcon,
			"reverse": _ctx.bottomHeader
		}]),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", mergeProps({ class: ["expansion-item__header-wrapper row items-center no-wrap text-subtitle3", [{
		"expansion-item__header-wrapper--animated": !_ctx.noHoverAnimation && _ctx.toggleable && !_ctx.disable,
		"cursor-pointer": _ctx.toggleable && !_ctx.disable,
		"expansion-item__header-wrapper--disabled": _ctx.disable,
		"reverse justify-between": _ctx.rightIcon
	}, _ctx.headerClass]] }, { [toHandlerKey(_ctx.toggleable && `click`)]: _cache[2] || (_cache[2] = (...args) => _ctx.toggle && _ctx.toggle(...args)) }, {
		onMouseout: _cache[3] || (_cache[3] = ($event) => _ctx.hovered = false),
		onMouseover: _cache[4] || (_cache[4] = ($event) => _ctx.hovered = true)
	}), [_ctx.toggleable ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass([_ctx.rightIcon ? "q-ml-sm" : "q-mr-sm", _ctx.iconClass])
	}, [_ctx.useToggle ? (openBlock(), createBlock(_component_Toggle, {
		key: 0,
		modelValue: _ctx.expanded,
		"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => _ctx.expanded = $event), _cache[1] || (_cache[1] = ($event) => _ctx.$emit("update:model-value", $event))],
		"data-automation": _ctx.buildId("toggle"),
		disable: _ctx.disable
	}, null, 8, [
		"modelValue",
		"data-automation",
		"disable"
	])) : (openBlock(), createBlock(_component_QIcon, {
		key: 1,
		"aria-expanded": _ctx.expanded,
		class: normalizeClass([
			"expansion-item__icon",
			{ "expansion-item__icon--rotated": _ctx.expanded },
			_ctx.expandIconClass
		]),
		"data-automation": _ctx.buildId("icon"),
		name: _ctx.invertIcon ? "mdi-chevron-down" : "mdi-chevron-right",
		size: _ctx.expandIconSize
	}, null, 8, [
		"aria-expanded",
		"class",
		"data-automation",
		"name",
		"size"
	]))], 2)) : createCommentVNode("", true), createElementVNode("div", {
		class: "expansion-item__header col zero-min-width",
		"data-automation": _ctx.buildId("header")
	}, [renderSlot(_ctx.$slots, "header", {}, () => [createElementVNode("div", _hoisted_3$38, [
		renderSlot(_ctx.$slots, "label", { expanded: _ctx.expanded }, () => [createVNode(_component_EllipsisText, {
			class: "zero-min-width",
			"data-automation": _ctx.buildId("header__label"),
			text: _ctx.label,
			"tooltip-class": _ctx.labelTooltipClass
		}, null, 8, [
			"data-automation",
			"text",
			"tooltip-class"
		])], true),
		createVNode(_component_QSpace),
		_ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["q-pl-sm", _ctx.headerActionsClass])
		}, [renderSlot(_ctx.$slots, "header-actions", {}, void 0, true)], 2)) : createCommentVNode("", true)
	])], true)], 8, _hoisted_2$46)], 16), createVNode(_component_QSlideTransition, { duration: _ctx.transitionDuration }, {
		default: withCtx(() => [_ctx.expanded ? (openBlock(), createElementBlock("div", _hoisted_4$24, [createElementVNode("div", {
			class: normalizeClass(_ctx.contentClass ?? "q-mt-sm"),
			"data-automation": _ctx.buildId("content")
		}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 10, _hoisted_5$19)])) : createCommentVNode("", true)]),
		_: 3
	}, 8, ["duration"])], 10, _hoisted_1$60);
}
var ExpansionItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ExpansionItem_vue_vue_type_script_lang_default, [["render", _sfc_render$59], ["__scopeId", "data-v-93cfd07c"]]);
//#endregion
//#region src/components/ExpansionList.vue?vue&type=script&lang.ts
var ExpansionList_vue_vue_type_script_lang_default = defineComponent({
	name: "ExpansionList",
	components: { RvButton: Button_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Emits 'show-all' event when "Show all" is clicked
		*/
		emitEvents: {
			type: Boolean,
			default: false
		},
		/**
		* Arrow icon will be shown on the left side of the text
		*/
		iconLeft: {
			type: Boolean,
			default: false
		},
		/**
		* Items to be displayed
		*/
		items: {
			type: [Object, Array],
			required: true
		},
		/**
		* Initial number of items shown
		*/
		limit: {
			type: Number,
			default: 3
		},
		/**
		* Render "Show all" button
		*/
		showAll: {
			type: Boolean,
			default: false
		},
		/**
		* The number of items added when "Show more" is clicked
		*/
		step: {
			type: Number,
			default: 5
		},
		/**
		* Property that defines the unique key of each item (the result must be a primitive, not Object, Array, etc)
		*/
		uniqueField: {
			type: String,
			default: void 0
		}
	},
	emits: ["show-all"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const currentLimit = ref(props.limit);
		const itemsLength = computed(() => {
			return Array.isArray(props.items) ? props.items.length : Object.keys(props.items).length;
		});
		const itemsToShow = computed(() => {
			if (Array.isArray(props.items)) return props.items.slice(0, currentLimit.value);
			else {
				const entries = Object.entries(props.items).slice(0, currentLimit.value);
				return Object.fromEntries(entries);
			}
		});
		function onShowAll() {
			if (props.emitEvents) emit("show-all");
			else currentLimit.value = itemsLength.value;
		}
		function onShowLess() {
			currentLimit.value = props.limit;
		}
		function onShowMore() {
			currentLimit.value += props.step;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			currentLimit,
			itemsLength,
			itemsToShow,
			onShowAll,
			onShowLess,
			onShowMore,
			t
		};
	}
});
//#endregion
//#region src/components/ExpansionList.vue
var _hoisted_1$59 = ["data-automation"];
var _hoisted_2$45 = ["data-automation"];
var _hoisted_3$37 = {
	key: 0,
	class: "expansion-list__action q-my-sm"
};
function _sfc_render$58(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["expansion-list full-width", { "expansion-list--expandable": _ctx.itemsLength > _ctx.limit }]),
		"data-automation": _ctx.buildId()
	}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemsToShow, (item, key) => {
		return openBlock(), createElementBlock("div", {
			key: (_ctx.uniqueField && item[_ctx.uniqueField]) ?? key,
			class: "expansion-list__content",
			"data-automation": _ctx.buildId(`content-${String(key)}`)
		}, [renderSlot(_ctx.$slots, "default", {
			item,
			itemKey: key
		})], 8, _hoisted_2$45);
	}), 128)), _ctx.itemsLength > _ctx.limit ? (openBlock(), createElementBlock("div", _hoisted_3$37, [_ctx.showAll && _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_RvButton, {
		key: 0,
		class: "no-padding full-width items-start",
		color: "black-1",
		"data-automation": _ctx.buildId("show-all"),
		icon: _ctx.iconLeft ? "mdi-chevron-right" : void 0,
		"icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-right",
		label: _ctx.t("rvai-base.general.actions.showAll"),
		size: "sm",
		tertiary: "",
		onClick: _ctx.onShowAll
	}, null, 8, [
		"data-automation",
		"icon",
		"icon-right",
		"label",
		"onClick"
	])) : _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_RvButton, {
		key: 1,
		class: "no-padding full-width items-start",
		color: "black-1",
		"data-automation": _ctx.buildId("show-more"),
		icon: _ctx.iconLeft ? "mdi-chevron-down" : void 0,
		"icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-down",
		label: _ctx.t("rvai-base.general.actions.showMore"),
		size: "sm",
		tertiary: "",
		onClick: _ctx.onShowMore
	}, null, 8, [
		"data-automation",
		"icon",
		"icon-right",
		"label",
		"onClick"
	])) : (openBlock(), createBlock(_component_RvButton, {
		key: 2,
		class: "no-padding full-width items-start",
		color: "black-1",
		"data-automation": _ctx.buildId("show-less"),
		icon: _ctx.iconLeft ? "mdi-chevron-up" : void 0,
		"icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-up",
		label: _ctx.t("rvai-base.general.actions.showLess"),
		size: "sm",
		tertiary: "",
		onClick: _ctx.onShowLess
	}, null, 8, [
		"data-automation",
		"icon",
		"icon-right",
		"label",
		"onClick"
	]))])) : createCommentVNode("", true)], 10, _hoisted_1$59);
}
var ExpansionList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ExpansionList_vue_vue_type_script_lang_default, [["render", _sfc_render$58]]);
//#endregion
//#region src/components/FieldEdit.vue?vue&type=script&lang.ts
var FieldEdit_vue_vue_type_script_lang_default = defineComponent({
	name: "FieldEdit",
	components: {
		EllipsisText: EllipsisText_default,
		QField: QField_default,
		QIcon: QIcon_default,
		QSpace: QSpace_default,
		RvButton: Button_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Render info icon with tooltip. Can be used as an "info-text" property or as a slot
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: "rv-field-edit__info-text"
		},
		/**
		* The text that will be shown on the component
		*/
		label: {
			type: String,
			default: ""
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Model of the component
		* @type {[Array, Object, String]}
		*/
		modelValue: {
			type: [
				Array,
				Boolean,
				Object,
				String,
				Number
			],
			default: void 0
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		readonly: {
			default: false,
			type: Boolean
		},
		/**
		* Shows error message
		*/
		showErrorMessage: {
			type: Boolean,
			default: true
		},
		/**
		* Render optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Validation for the component
		*/
		validation: {
			type: Object,
			default: void 0
		}
	},
	emits: ["on-edit"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const { classRef, error, errorMessage, isValidated } = useValidation(props);
		const editIcon = computed(() => {
			return isEmpty.value ? "mdi-plus" : "mdi-pencil";
		});
		const editLabel = computed(() => {
			return isEmpty.value ? t("rvai-base.general.actions.add") : t("rvai-base.general.actions.edit");
		});
		const isEmpty = computed(() => {
			const value = props.modelValue;
			return Array.isArray(value) ? !value.length : !value;
		});
		function onEdit() {
			emit("on-edit");
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			classRef,
			editIcon,
			editLabel,
			error,
			errorMessage,
			isEmpty,
			isValidated,
			onEdit,
			t
		};
	}
});
//#endregion
//#region src/components/FieldEdit.vue
var _hoisted_1$58 = ["data-automation"];
var _hoisted_2$44 = { class: "row no-wrap items-center full-width" };
var _hoisted_3$36 = {
	key: 0,
	class: "q-ml-xs",
	"data-test": "optional"
};
var _hoisted_4$23 = ["data-automation"];
function _sfc_render$57(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QField = resolveComponent("QField");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["rv-field-edit", [_ctx.classRef, { "rv-field-edit--disabled": _ctx.disable }]],
		"data-automation": _ctx.buildId()
	}), [createElementVNode("div", { class: normalizeClass(["rv-field-edit__label row no-wrap justify-between items-center", _ctx.labelClass]) }, [createElementVNode("div", _hoisted_2$44, [
		renderSlot(_ctx.$slots, "label", {}, () => [createVNode(_component_EllipsisText, {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("label"),
			text: _ctx.label
		}, null, 8, ["data-automation", "text"])], true),
		_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$36, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
		_ctx.infoText || _ctx.$slots["info-text"] ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "q-ml-xs info-icon",
			color: "black-1",
			"data-automation": _ctx.buildId("icon-info"),
			name: "info",
			size: "16px"
		}, {
			default: withCtx(() => [createVNode(_component_Tooltip, {
				anchor: "top middle",
				class: normalizeClass(_ctx.infoTextClass),
				self: "bottom middle"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "info-text", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
				_: 3
			}, 8, ["class"])]),
			_: 3
		}, 8, ["data-automation"])) : createCommentVNode("", true),
		createVNode(_component_QSpace),
		_ctx.isValidated && !_ctx.isEmpty && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
			key: "valid",
			class: "rv-field-edit__status",
			color: "positive",
			"data-automation": _ctx.buildId("icon-valid"),
			name: "mdi-check-circle"
		}, null, 8, ["data-automation"])) : _ctx.error && _ctx.showErrorMessage && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
			key: "error",
			class: "rv-field-edit__status",
			color: "negative",
			"data-automation": _ctx.buildId("icon-error"),
			name: "mdi-close-circle"
		}, null, 8, ["data-automation"])) : createCommentVNode("", true),
		!_ctx.readonly ? (openBlock(), createBlock(_component_RvButton, {
			key: 4,
			class: "q-ml-sm",
			"data-automation": _ctx.buildId("edit"),
			disable: _ctx.disable,
			icon: _ctx.editIcon,
			label: _ctx.editLabel,
			size: "sm",
			tertiary: "",
			onClick: _ctx.onEdit
		}, null, 8, [
			"data-automation",
			"disable",
			"icon",
			"label",
			"onClick"
		])) : createCommentVNode("", true),
		renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
	])], 2), createVNode(_component_QField, {
		class: normalizeClass(["q-pa-none", { "q-pt-sm": !_ctx.isEmpty }]),
		"data-automation": _ctx.buildId("q-field"),
		dense: "",
		error: _ctx.error,
		"error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
		"hide-bottom-space": "",
		"model-value": _ctx.modelValue,
		"no-error-icon": "",
		standout: ""
	}, {
		default: withCtx(() => [createElementVNode("div", {
			class: "full-width",
			"data-automation": _ctx.buildId("default-slot")
		}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 8, _hoisted_4$23)]),
		_: 3
	}, 8, [
		"class",
		"data-automation",
		"error",
		"error-message",
		"model-value"
	])], 16, _hoisted_1$58);
}
var FieldEdit_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FieldEdit_vue_vue_type_script_lang_default, [["render", _sfc_render$57], ["__scopeId", "data-v-e3f426b0"]]);
//#endregion
//#region src/components/FilePicker.vue?vue&type=script&lang.ts
var FilePicker_vue_vue_type_script_lang_default = defineComponent({
	name: "FilePicker",
	components: {
		EllipsisText: EllipsisText_default,
		QFile: QFile_default,
		QIcon: QIcon_default,
		RvButton: Button_default
	},
	props: {
		/**
		* List of all accepted file extentions
		*/
		acceptedFiles: {
			default: void 0,
			type: Array
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: void 0,
			type: String
		},
		/**
		* Value to show in input while file is not selected yet
		*/
		defaultValue: {
			default: "",
			type: String
		},
		/**
		* Set component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Prevent displaying hint below the input
		*/
		hideHint: {
			default: false,
			type: Boolean
		},
		/**
		* Hint text below the input
		*/
		hintText: {
			default: void 0,
			type: String
		},
		/**
		* Label of the input
		*/
		label: {
			default: void 0,
			type: String
		},
		/**
		* Maximum allowed file size
		*/
		maxFileSize: {
			default: void 0,
			type: Number
		},
		/**
		* v-model
		*/
		modelValue: {
			default: void 0,
			type: File
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const inputRef = ref();
		const filename = ref("");
		const validationError = ref("");
		const hasValidationError = computed(() => !!validationError.value);
		const hintTextValue = computed(() => {
			return props.hintText ?? props.acceptedFiles?.map((type) => type.toUpperCase().replace(".", "")).join(", ") ?? "";
		});
		function clear() {
			filename.value = "";
			validationError.value = "";
		}
		function getFormattedFileSize() {
			if (!props.maxFileSize) return;
			const bytes = props.maxFileSize;
			const k = bytes > 0 ? Math.floor(Math.log2(bytes) / 10) : 0;
			const rank = (k > 0 ? "KMGT"[k - 1] : "") + "B";
			return `${Math.floor(bytes / Math.pow(1024, k))}${rank}`;
		}
		function onUpdate(value) {
			emit("update:modelValue", value);
			filename.value = value.name;
			validationError.value = "";
		}
		function onRejected(rejectedEntries) {
			if (rejectedEntries.some((e) => e.failedPropValidation === "accept")) validationError.value = t("rvai-base.validation.wrongFormat");
			else if (rejectedEntries.some((e) => e.failedPropValidation === "max-file-size")) validationError.value = t("rvai-base.validation.fileTooLarge", [getFormattedFileSize()]);
			emit("update:modelValue", null);
			filename.value = rejectedEntries[0].file.name;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			clear,
			filename,
			hasValidationError,
			hintTextValue,
			inputRef,
			onRejected,
			onUpdate,
			t,
			validationError
		};
	}
});
//#endregion
//#region src/components/FilePicker.vue
var _hoisted_1$57 = ["data-automation"];
var _hoisted_2$43 = { class: "row no-wrap items-center full-width" };
var _hoisted_3$35 = ["data-automation"];
var _hoisted_4$22 = ["data-automation"];
var _hoisted_5$18 = { class: "file-picker__filename-container full-width overflow-hidden" };
function _sfc_render$56(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QFile = resolveComponent("QFile");
	return openBlock(), createElementBlock("div", {
		class: "file-picker__container",
		"data-automation": _ctx.buildId()
	}, [renderSlot(_ctx.$slots, "label", {}, () => [createElementVNode("div", _hoisted_2$43, [createElementVNode("div", {
		class: normalizeClass(["text-black-1 text-subtitle3", { "text-grey-2": _ctx.disable }]),
		"data-automation": _ctx.buildId("label")
	}, toDisplayString(_ctx.label), 11, _hoisted_3$35), _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "q-ml-xs",
		"data-automation": _ctx.buildId("optional")
	}, toDisplayString(_ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_4$22)) : createCommentVNode("", true)])], true), createVNode(_component_QFile, {
		ref: "inputRef",
		accept: _ctx.acceptedFiles?.join(","),
		"bg-color": "grey-6",
		borderless: "",
		class: normalizeClass(["file-picker__input ellipsis", { "file-picker__input--disabled": _ctx.disable }]),
		"data-automation": _ctx.buildId("input"),
		disable: _ctx.disable,
		"display-value": "",
		error: !!_ctx.validationError,
		"error-message": _ctx.validationError,
		hint: _ctx.hideHint ? "" : _ctx.hintTextValue,
		"max-file-size": _ctx.maxFileSize,
		"model-value": _ctx.modelValue,
		"no-error-icon": "",
		onRejected: _ctx.onRejected,
		"onUpdate:modelValue": _ctx.onUpdate
	}, {
		default: withCtx(() => [createElementVNode("div", _hoisted_5$18, [createVNode(_component_EllipsisText, {
			class: "text-body3",
			"data-automation": _ctx.buildId("filename"),
			text: _ctx.filename || _ctx.defaultValue
		}, null, 8, ["data-automation", "text"])])]),
		after: withCtx(() => [createVNode(_component_RvButton, {
			"data-automation": _ctx.buildId("browse-files"),
			disable: _ctx.disable,
			label: _ctx.$t("rvai-base.general.actions.browse"),
			secondary: "",
			size: "md",
			type: "a",
			onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.inputRef?.pickFiles(), ["prevent"]))
		}, null, 8, [
			"data-automation",
			"disable",
			"label"
		]), _ctx.validationError ? (openBlock(), createBlock(_component_QIcon, {
			key: 0,
			class: "q-ml-xs",
			color: "negative",
			"data-automation": _ctx.buildId("alert"),
			name: "rvai-base:cancel",
			size: "20px"
		}, null, 8, ["data-automation"])) : !!_ctx.filename ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "q-ml-xs",
			color: "positive",
			"data-automation": _ctx.buildId("success"),
			name: "rvai-base:success",
			size: "20px"
		}, null, 8, ["data-automation"])) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"accept",
		"class",
		"data-automation",
		"disable",
		"error",
		"error-message",
		"hint",
		"max-file-size",
		"model-value",
		"onRejected",
		"onUpdate:modelValue"
	])], 8, _hoisted_1$57);
}
var FilePicker_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FilePicker_vue_vue_type_script_lang_default, [["render", _sfc_render$56], ["__scopeId", "data-v-0627916d"]]);
//#endregion
//#region src/components/NoData.vue?vue&type=script&lang.ts
var NoData_vue_vue_type_script_lang_default = defineComponent({
	name: "NoData",
	components: { QIcon: QIcon_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		iconName: {
			type: String,
			default: ""
		},
		iconSize: {
			type: String,
			default: ""
		},
		iconShape: {
			type: String,
			default: ShapesNoData.Horizontal,
			validator: (v) => Object.values(ShapesNoData).includes(v)
		},
		subtitle: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/NoData.vue
var _hoisted_1$56 = ["data-automation"];
var _hoisted_2$42 = { class: "wrapper column flex-center full-width" };
var _hoisted_3$34 = ["data-automation"];
var _hoisted_4$21 = ["data-automation"];
var _hoisted_5$17 = ["data-automation"];
function _sfc_render$55(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	return openBlock(), createElementBlock("div", mergeProps({
		class: ["rv-no-data text-center flex flex-center", _ctx.$props.class],
		"data-automation": _ctx.buildId()
	}, _ctx.$attrs), [createElementVNode("div", _hoisted_2$42, [
		_ctx.iconName ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["icon-wrapper flex-center", { [_ctx.iconShape]: !_ctx.iconSize }]),
			"data-automation": _ctx.buildId("icon-wrapper")
		}, [createVNode(_component_QIcon, {
			class: normalizeClass(["icon", { "icon--full-size": !_ctx.iconSize }]),
			name: _ctx.iconName,
			size: _ctx.iconSize
		}, null, 8, [
			"class",
			"name",
			"size"
		])], 10, _hoisted_3$34)) : createCommentVNode("", true),
		_ctx.title ? (openBlock(), createElementBlock("div", {
			key: 1,
			class: "text-h1 q-mt-lg",
			"data-automation": _ctx.buildId("title")
		}, toDisplayString(_ctx.title), 9, _hoisted_4$21)) : createCommentVNode("", true),
		_ctx.subtitle ? (openBlock(), createElementBlock("div", {
			key: 2,
			class: "q-mt-md text-body3",
			"data-automation": _ctx.buildId("subtitle")
		}, toDisplayString(_ctx.subtitle), 9, _hoisted_5$17)) : createCommentVNode("", true),
		createElementVNode("div", { class: normalizeClass(["full-width", {
			"q-mt-md": _ctx.title,
			"q-mt-lg": _ctx.subtitle
		}]) }, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 2)
	])], 16, _hoisted_1$56);
}
var NoData_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NoData_vue_vue_type_script_lang_default, [["render", _sfc_render$55], ["__scopeId", "data-v-378b9301"]]);
//#endregion
//#region src/components/Radio.vue?vue&type=script&lang.ts
var Radio_vue_vue_type_script_lang_default = defineComponent({
	name: "Radio",
	components: { QRadio: QRadio_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			type: Boolean,
			default: false
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Label to display along the component
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
		*/
		modelValue: {
			type: [
				Boolean,
				Number,
				String,
				Array
			],
			default: void 0
		},
		/**
		* The actual value of the option with which model value is changed
		*/
		val: {
			type: null,
			default: void 0
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			value
		};
	}
});
//#endregion
//#region src/components/Radio.vue
function _sfc_render$54(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QRadio = resolveComponent("QRadio");
	return openBlock(), createBlock(_component_QRadio, mergeProps(_ctx.dataAttrs, {
		modelValue: _ctx.value,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
		class: ["rv-radio", _ctx.$props.class],
		"data-automation": _ctx.buildId(),
		dense: _ctx.dense,
		disable: _ctx.disable,
		label: _ctx.label,
		val: _ctx.val
	}), {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 16, [
		"modelValue",
		"class",
		"data-automation",
		"dense",
		"disable",
		"label",
		"val"
	]);
}
var Radio_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Radio_vue_vue_type_script_lang_default, [["render", _sfc_render$54], ["__scopeId", "data-v-b5f9518f"]]);
//#endregion
//#region src/components/SortButton.vue?vue&type=script&lang.ts
var SortButton_vue_vue_type_script_lang_default = defineComponent({
	name: "SortButton",
	components: {
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QList: QList_default,
		QMenu: QMenu_default,
		RvButton: Button_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		modelValue: {
			type: Object,
			default: void 0
		},
		sortFields: {
			type: Array,
			required: true
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		function onSort(value) {
			emit("update:modelValue", value);
		}
		onMounted(() => {
			onSort(props.sortFields.find((f) => f.sortByDefault) || props.sortFields[0]);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			onSort,
			t
		};
	}
});
//#endregion
//#region src/components/SortButton.vue
function _sfc_render$53(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItem = resolveComponent("QItem");
	const _component_QList = resolveComponent("QList");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createBlock(_component_RvButton, {
		class: "no-padding",
		color: "black-1",
		"data-automation": _ctx.buildId(),
		icon: "rvai-base:sort-asc",
		tertiary: ""
	}, {
		default: withCtx(() => [createVNode(_component_Tooltip, { "data-automation": _ctx.buildId("tooltip") }, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.sort")), 1)]),
			_: 1
		}, 8, ["data-automation"]), createVNode(_component_QMenu, {
			"auto-close": "",
			class: "sort-menu",
			self: "top right",
			style: { "min-width": "220px" }
		}, {
			default: withCtx(() => [createVNode(_component_QList, { separator: "" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortFields, (item) => {
					return openBlock(), createBlock(_component_QItem, {
						key: item.name,
						clickable: "",
						"data-automation": _ctx.buildId(`item-${String(item.name)}`),
						onClick: ($event) => _ctx.onSort(item)
					}, {
						default: withCtx(() => [createVNode(_component_QItemLabel, { class: "row justify-between items-center full-width" }, {
							default: withCtx(() => [createElementVNode("span", null, toDisplayString(item.label), 1), _ctx.modelValue && item.label === _ctx.modelValue.label ? (openBlock(), createBlock(_component_QIcon, {
								key: 0,
								name: "mdi-check",
								size: "18px"
							})) : createCommentVNode("", true)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, ["data-automation", "onClick"]);
				}), 128))]),
				_: 1
			})]),
			_: 1
		})]),
		_: 1
	}, 8, ["data-automation"]);
}
var SortButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SortButton_vue_vue_type_script_lang_default, [["render", _sfc_render$53]]);
var FilterableList_vue_vue_type_script_lang_default = defineComponent({
	name: "FilterableList",
	components: {
		Checkbox: Checkbox_default,
		EllipsisText: EllipsisText_default,
		NoData: NoData_default,
		QIcon: QIcon_default,
		QInfiniteScroll: QInfiniteScroll_default,
		QIntersection: QIntersection_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		QList: QList_default,
		Radio: Radio_default,
		RvButton: Button_default,
		RvInput: Input_default,
		SortButton: SortButton_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Makes items in the list clickable
		*/
		clickable: {
			type: Boolean,
			default: false
		},
		/**
		* Render custom item in slot #item
		*/
		customItem: {
			type: Boolean,
			default: false
		},
		/**
		* Items to be displayed
		* @type {[Record<string, unknown>]}
		*/
		data: {
			type: Array,
			required: true
		},
		/**
		* On hover the delete icon will be visible
		*/
		deletable: {
			type: Boolean,
			default: false
		},
		/**
		* Hides 'Select all' when 'multiple' property is true
		*/
		hideSelectAll: {
			type: Boolean,
			default: false
		},
		/**
		* Hides checkboxes when 'multiple' property is true
		*/
		hideSelectors: {
			type: Boolean,
			default: false
		},
		/**
		*  Put item in disabled mode when immutableField is presented
		*/
		immutableField: {
			type: String,
			default: void 0
		},
		/**
		*  Predicate version of `immutableField`. When provided, items for
		*  which this returns true are treated as immutable (excluded from
		*  select-all and the all-selected computation, and rendered as
		*  disabled in the default item template).
		*  Use this when the immutable state is derived from external data rather than a
		*  field on the item itself.
		*/
		isItemImmutable: {
			type: Function,
			default: void 0
		},
		/**
		*  Show data partially when scrolling
		*/
		infiniteScrolling: {
			type: Boolean,
			default: false
		},
		/**
		*  Show data partially when scrolling
		*/
		infiniteScrollingSize: {
			type: Number,
			default: 200
		},
		/**
		*  Render the label at the top and search button next to it
		*/
		/**
		*  Classes for infinite scroll wrapper
		*/
		infiniteScrollWrapperClass: {
			type: String,
			default: ""
		},
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: [Array, Object],
			default: void 0
		},
		/**
		* Render checkboxes instead of radio buttons
		*/
		multiple: {
			type: Boolean,
			default: false
		},
		/**
		* Allow to provide slot 'item'
		*/
		nestedKey: {
			type: String,
			default: ""
		},
		/**
		* Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionLabel: {
			type: String,
			default: "label"
		},
		/**
		* Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionValue: {
			type: String,
			default: "value"
		},
		/**
		* Render label as radio button
		*/
		notSelectedOptionLabel: {
			type: String,
			default: ""
		},
		/**
		* Disable select all checkbox
		*/
		selectAllDisabled: {
			type: Boolean,
			default: false
		},
		/**
		* Show tooltip when checkbox disabled
		*/
		selectAllDisabledTooltip: {
			type: String,
			default: ""
		},
		/**
		* Provides the ability to sort data
		*/
		sortFields: {
			type: Array,
			default: null
		},
		/**
		* Custom options to setup in Intl.Collator to sort data
		*/
		sortOptions: {
			type: Object,
			default: void 0
		},
		/**
		* Disable the ability to select items
		*/
		toggable: {
			type: Boolean,
			default: false
		},
		/**
		* Wraps each item with QIntersection
		*/
		withIntersection: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"delete-item",
		"on-click-item",
		"on-sort",
		"update:modelValue"
	],
	setup(props, { emit }) {
		const { t } = useI18n();
		const dataSize = ref(props.infiniteScrollingSize);
		const filter = ref("");
		const infiniteScrollRef = ref();
		const showFilter = ref(false);
		const showSelectorValue = ref(false);
		const sortField = ref();
		const isImmutable = (item) => !!(props.immutableField && item[props.immutableField]) || !!props.isItemImmutable?.(item);
		const allSelected = computed(() => {
			if (Array.isArray(filteredData.value)) {
				if (filteredData.value.filter((item) => !isImmutable(item)).every((item) => !selected.value.includes(item[props.optionValue]))) return false;
				if (filteredData.value.filter((item) => !isImmutable(item)).every((item) => selected.value.includes(item[props.optionValue]))) return true;
				return;
			}
			return false;
		});
		const sortedData = computed(() => {
			if (!sortField.value) return props.data;
			return sortField.value.type === SortType.Date ? sortByDate(props.data, sortField.value.name, sortField.value.order === SortOrders.Asc) : sortByKey(props.data, sortField.value.name, sortField.value.order === SortOrders.Asc, naturalSortWrapper);
		});
		const filteredData = computed(() => {
			const needle = filter.value.toLowerCase();
			return sortedData.value.filter((i) => String(i[props.optionLabel]).toLowerCase().includes(needle));
		});
		const dataToShow = computed(() => {
			return props.infiniteScrolling ? filteredData.value.slice(0, dataSize.value) : filteredData.value;
		});
		const selected = computed(() => {
			if (!props.modelValue) return void 0;
			return Array.isArray(props.modelValue) ? props.modelValue.map((x) => x[props.optionValue]) : props.modelValue[props.optionValue];
		});
		const showSelector = computed(() => !props.hideSelectors && (!props.toggable || showSelectorValue.value));
		function naturalSortWrapper(a, b) {
			return props.sortOptions ? new Intl.Collator(void 0, props.sortOptions).compare(a, b) : naturalSort(a, b);
		}
		function onDeleteItem(itemValue) {
			emit("delete-item", itemValue);
		}
		function onLoad(v, done) {
			if (!props.infiniteScrolling) return;
			if (dataSize.value !== filteredData.value.length) {
				const nextPageSize = v * props.infiniteScrollingSize;
				dataSize.value = nextPageSize > filteredData.value.length ? filteredData.value.length : nextPageSize;
			}
			done();
		}
		function onSelectNone() {
			emit("update:modelValue", null);
		}
		function onSort(v) {
			sortField.value = v;
			resetInfinityScroll();
			emit("on-sort", v);
		}
		function onToggle(value) {
			emit("update:modelValue", Array.isArray(value) ? value.map((v) => props.data.find((x) => x[props.optionValue] === v)) : props.data.find((x) => x[props.optionValue] === value));
		}
		function onToggleAll() {
			const filteredDataValues = filteredData.value.filter((item) => !isImmutable(item)).map((item) => item[props.optionValue]);
			const uniqueValues = distinct([...selected.value, ...filteredDataValues]);
			const hiddenSelectedValues = selected.value.filter((v) => !filteredData.value.some((x) => x[props.optionValue] === v));
			emit("update:modelValue", (allSelected.value ? hiddenSelectedValues : uniqueValues).map((v) => props.data.find((d) => v === d[props.optionValue])));
		}
		function onToggleFilter() {
			showFilter.value = !showFilter.value;
			if (!showFilter.value) resetSearch();
		}
		function onToggleShowSelector() {
			showSelectorValue.value = !showSelectorValue.value;
			if (!showSelectorValue.value) emit("update:modelValue", props.multiple ? [] : void 0);
		}
		function resetInfinityScroll() {
			dataSize.value = props.infiniteScrollingSize;
			infiniteScrollRef.value?.reset();
		}
		function resetSearch() {
			filter.value = "";
			resetInfinityScroll();
		}
		function setFilter(v) {
			filter.value = v;
			resetInfinityScroll();
		}
		watch(() => props.data, () => {
			const selection = props.modelValue;
			if (!selection) return void 0;
			let payload;
			if (Array.isArray(selection)) payload = props.data.filter((v) => selection.some((x) => x[props.optionValue] === v[props.optionValue]));
			else payload = props.data.find((v) => selection[props.optionValue] === v[props.optionValue]);
			emit("update:modelValue", payload);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			allSelected,
			dataToShow,
			filter,
			filteredData,
			infiniteScrollRef,
			isImmutable,
			onDeleteItem,
			onLoad,
			onSelectNone,
			onSort,
			onToggle,
			onToggleAll,
			onToggleFilter,
			onToggleShowSelector,
			resetSearch,
			selected,
			setFilter,
			showFilter,
			showSelector,
			sortedData,
			sortField,
			t
		};
	}
});
//#endregion
//#region src/components/FilterableList.vue
var _hoisted_1$55 = ["data-automation"];
var _hoisted_2$41 = ["data-automation"];
var _hoisted_3$33 = { class: "row no-wrap q-pl-sm" };
var _hoisted_4$20 = { class: "q-mb-lg" };
var _hoisted_5$16 = { class: "text-bold" };
function _sfc_render$52(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_SortButton = resolveComponent("SortButton");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItem = resolveComponent("QItem");
	const _component_Radio = resolveComponent("Radio");
	const _component_QInfiniteScroll = resolveComponent("QInfiniteScroll");
	const _component_NoData = resolveComponent("NoData");
	const _component_QList = resolveComponent("QList");
	return openBlock(), createElementBlock("div", {
		class: "filterable-list",
		"data-automation": _ctx.buildId()
	}, [
		_ctx.label ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: "row no-wrap full-width justify-between q-mb-sm",
			"data-automation": _ctx.buildId("label-wrapper")
		}, [createVNode(_component_EllipsisText, {
			class: "text-subtitle3 text-center text-black-1",
			"data-automation": _ctx.buildId("label"),
			text: _ctx.label
		}, null, 8, ["data-automation", "text"]), createElementVNode("div", _hoisted_3$33, [
			createVNode(_component_RvButton, {
				class: "no-padding",
				color: "black-1",
				"data-automation": _ctx.buildId("search"),
				disable: _ctx.data.length === 0,
				icon: "search",
				tertiary: "",
				tooltip: _ctx.t("rvai-base.general.actions.search"),
				onClick: _ctx.onToggleFilter
			}, null, 8, [
				"data-automation",
				"disable",
				"tooltip",
				"onClick"
			]),
			_ctx.sortFields && _ctx.sortFields.length > 0 ? (openBlock(), createBlock(_component_SortButton, {
				key: 0,
				modelValue: _ctx.sortField,
				"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => _ctx.sortField = $event), _ctx.onSort],
				class: "q-mr-sm",
				"data-automation": _ctx.buildId("sort"),
				disable: _ctx.data.length === 0,
				"sort-fields": _ctx.sortFields
			}, null, 8, [
				"modelValue",
				"data-automation",
				"disable",
				"sort-fields",
				"onUpdate:modelValue"
			])) : createCommentVNode("", true),
			_ctx.toggable ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [!_ctx.showSelector ? (openBlock(), createBlock(_component_RvButton, {
				key: 0,
				color: "black-1",
				"data-automation": _ctx.buildId("multi-select"),
				icon: "rvai-base:multi-select",
				size: "sm",
				tertiary: "",
				tooltip: _ctx.t("rvai-base.general.text.multiselect"),
				onClick: _ctx.onToggleShowSelector
			}, null, 8, [
				"data-automation",
				"tooltip",
				"onClick"
			])) : (openBlock(), createBlock(_component_RvButton, {
				key: 1,
				color: "primary",
				"data-automation": _ctx.buildId("cancel"),
				size: "sm",
				tertiary: "",
				onClick: _ctx.onToggleShowSelector
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.cancel")), 1)]),
				_: 1
			}, 8, ["data-automation", "onClick"]))], 64)) : createCommentVNode("", true)
		])], 8, _hoisted_2$41)) : createCommentVNode("", true),
		_ctx.showFilter ? (openBlock(), createBlock(_component_RvInput, {
			key: 1,
			autofocus: "",
			"data-automation": _ctx.buildId("searchInput"),
			icon: "search",
			"label-class": "q-pb-sm",
			"model-value": _ctx.filter,
			placeholder: _ctx.t("rvai-base.general.actions.search"),
			"onUpdate:modelValue": _ctx.setFilter
		}, {
			prepend: withCtx(() => [createVNode(_component_QIcon, {
				color: "black-1",
				name: "search"
			})]),
			_: 1
		}, 8, [
			"data-automation",
			"model-value",
			"placeholder",
			"onUpdate:modelValue"
		])) : createCommentVNode("", true),
		_ctx.$slots["append-content"] ? renderSlot(_ctx.$slots, "append-content", {}, void 0, true, 2) : createCommentVNode("", true),
		createVNode(_component_QList, { "data-automation": _ctx.buildId("list") }, {
			default: withCtx(() => [
				_ctx.multiple && _ctx.showSelector && _ctx.filteredData.length && !_ctx.hideSelectAll ? (openBlock(), createBlock(_component_QItem, {
					key: 0,
					class: "q-pa-none",
					"data-automation": _ctx.buildId("item-multiple"),
					tag: "label"
				}, {
					default: withCtx(() => [
						_ctx.selectAllDisabledTooltip && _ctx.selectAllDisabled ? (openBlock(), createBlock(_component_Tooltip, {
							key: 0,
							anchor: "center left",
							"data-automation": _ctx.buildId("checkbox-tooltip")
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(_ctx.selectAllDisabledTooltip), 1)]),
							_: 1
						}, 8, ["data-automation"])) : createCommentVNode("", true),
						createVNode(_component_QItemSection, {
							avatar: "",
							class: "filterable-list__checkbox",
							"data-automation": _ctx.buildId("avatar")
						}, {
							default: withCtx(() => [createVNode(_component_Checkbox, {
								"data-automation": _ctx.buildId("checkbox"),
								dense: "",
								disable: _ctx.selectAllDisabled,
								"model-value": _ctx.allSelected,
								"onUpdate:modelValue": _ctx.onToggleAll
							}, null, 8, [
								"data-automation",
								"disable",
								"model-value",
								"onUpdate:modelValue"
							])]),
							_: 1
						}, 8, ["data-automation"]),
						createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
							default: withCtx(() => [createVNode(_component_QItemLabel, {
								class: "text-subtitle3",
								"data-automation": _ctx.buildId("selectAll")
							}, {
								default: withCtx(() => [createVNode(_component_EllipsisText, {
									class: normalizeClass({ "text-grey-2": _ctx.selectAllDisabled }),
									"data-automation": _ctx.buildId("selectAll__label"),
									text: _ctx.t("rvai-base.general.actions.selectAll")
								}, null, 8, [
									"class",
									"data-automation",
									"text"
								])]),
								_: 1
							}, 8, ["data-automation"])]),
							_: 1
						}),
						renderSlot(_ctx.$slots, "select-all", {}, void 0, true)
					]),
					_: 3
				}, 8, ["data-automation"])) : createCommentVNode("", true),
				_ctx.notSelectedOptionLabel ? (openBlock(), createBlock(_component_QItem, {
					key: 1,
					class: "q-pa-none",
					"data-automation": _ctx.buildId("item-not-selected"),
					tag: "label"
				}, {
					default: withCtx(() => [createVNode(_component_QItemSection, {
						avatar: "",
						class: "filterable-list__checkbox"
					}, {
						default: withCtx(() => [createVNode(_component_Radio, {
							dense: "",
							"model-value": _ctx.selected,
							val: void 0,
							"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.onSelectNone())
						}, null, 8, ["model-value"])]),
						_: 1
					}), createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
						default: withCtx(() => [createVNode(_component_QItemLabel, { class: "text-subtitle3" }, {
							default: withCtx(() => [createVNode(_component_EllipsisText, {
								"data-automation": _ctx.buildId("item-not-selected__label"),
								text: _ctx.notSelectedOptionLabel
							}, null, 8, ["data-automation", "text"])]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				}, 8, ["data-automation"])) : createCommentVNode("", true),
				_ctx.$slots["no-data"] && !_ctx.data.length ? renderSlot(_ctx.$slots, "no-data", {}, void 0, true, 2) : createCommentVNode("", true),
				createElementVNode("div", {
					id: "infinite-scroll-wrapper",
					class: normalizeClass(_ctx.infiniteScrollWrapperClass)
				}, [createVNode(_component_QInfiniteScroll, {
					ref: "infiniteScrollRef",
					class: "full-height",
					"data-automation": _ctx.buildId(`infinite-scroll`),
					offset: 250,
					"scroll-target": "#infinite-scroll-wrapper",
					onLoad: _ctx.onLoad
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "items", {
						isFiltering: !!_ctx.filter,
						items: _ctx.dataToShow
					}, () => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataToShow, (item, index) => {
						return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "div"), {
							key: item[_ctx.optionValue],
							style: normalizeStyle([item.height ? `height: ${item.height}px` : ""])
						}, {
							default: withCtx(() => [
								renderSlot(_ctx.$slots, "prepend-item", { item }, void 0, true),
								createVNode(_component_QItem, {
									class: "filterable-list__item-filtered q-pa-none",
									clickable: _ctx.clickable,
									"data-automation": _ctx.buildId(`item-filtered-${index}`),
									tag: _ctx.showSelector && item[_ctx.nestedKey]?.length === 1 ? "label" : void 0,
									onClick: ($event) => _ctx.$emit("on-click-item", item)
								}, {
									default: withCtx(() => [_ctx.nestedKey && item[_ctx.nestedKey].length > 1 || _ctx.customItem ? renderSlot(_ctx.$slots, "item", { item }, void 0, true, 0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [_ctx.showSelector ? (openBlock(), createBlock(_component_QItemSection, {
										key: 0,
										avatar: "",
										class: normalizeClass(["filterable-list__item-checkbox", { "invisible": _ctx.isImmutable(item) }])
									}, {
										default: withCtx(() => [_ctx.multiple ? (openBlock(), createBlock(_component_Checkbox, {
											key: 0,
											"data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__checkbox`),
											dense: "",
											disable: _ctx.isImmutable(item),
											"model-value": _ctx.selected,
											val: item[_ctx.optionValue],
											"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.onToggle($event))
										}, null, 8, [
											"data-automation",
											"disable",
											"model-value",
											"val"
										])) : (openBlock(), createBlock(_component_Radio, {
											key: 1,
											"data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__radio`),
											dense: "",
											disable: _ctx.isImmutable(item),
											"model-value": _ctx.selected,
											val: item[_ctx.optionValue],
											"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onToggle($event))
										}, null, 8, [
											"data-automation",
											"disable",
											"model-value",
											"val"
										]))]),
										_: 2
									}, 1032, ["class"])) : createCommentVNode("", true), createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
										default: withCtx(() => [renderSlot(_ctx.$slots, "label", { item }, () => [createVNode(_component_QItemLabel, { class: "filterable-list__item-label flex no-wrap justify-between" }, {
											default: withCtx(() => [createVNode(_component_EllipsisText, {
												class: "filterable-list__item-text",
												"data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__label`),
												text: item[_ctx.optionLabel]
											}, null, 8, ["data-automation", "text"]), _ctx.deletable ? (openBlock(), createBlock(_component_QIcon, {
												key: 0,
												class: "filterable-list__icon-delete-item cursor-pointer",
												color: "grey-1",
												"data-automation": _ctx.buildId("delete"),
												name: "delete",
												size: "1.5rem",
												onClick: ($event) => _ctx.onDeleteItem(item[_ctx.optionValue])
											}, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)]),
											_: 2
										}, 1024)], true)]),
										_: 2
									}, 1024)], 64))]),
									_: 2
								}, 1032, [
									"clickable",
									"data-automation",
									"tag",
									"onClick"
								]),
								renderSlot(_ctx.$slots, "append-item", { item }, void 0, true)
							]),
							_: 2
						}, 1032, ["style"]);
					}), 128))], true)]),
					_: 3
				}, 8, ["data-automation", "onLoad"])], 2),
				!_ctx.filteredData.length && _ctx.sortedData.length !== 0 ? (openBlock(), createBlock(_component_QItemLabel, {
					key: 3,
					class: "q-py-sm q-mt-lg",
					"data-automation": _ctx.buildId("label-no-data")
				}, {
					default: withCtx(() => [createVNode(_component_NoData, {
						"data-automation": _ctx.buildId("noData"),
						"icon-name": "img:/rvai-base/robot-loupe.svg",
						"icon-size": "170px"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_4$20, [
							createElementVNode("span", _hoisted_5$16, toDisplayString(_ctx.t("rvai-base.general.table.sorry")) + toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1),
							_cache[4] || (_cache[4] = createElementVNode("br", null, null, -1)),
							createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.table.noSearchResult")), 1)
						]), createVNode(_component_RvButton, {
							color: "primary",
							"data-automation": _ctx.buildId("search"),
							label: _ctx.t("rvai-base.general.table.searchAgain"),
							size: "sm",
							onClick: _ctx.resetSearch
						}, null, 8, [
							"data-automation",
							"label",
							"onClick"
						])]),
						_: 1
					}, 8, ["data-automation"])]),
					_: 1
				}, 8, ["data-automation"])) : createCommentVNode("", true)
			]),
			_: 3
		}, 8, ["data-automation"])
	], 8, _hoisted_1$55);
}
var FilterableList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FilterableList_vue_vue_type_script_lang_default, [["render", _sfc_render$52], ["__scopeId", "data-v-914bda04"]]);
//#endregion
//#region src/composables/useNavigation.ts
function useNavigation() {
	const route = useRoute();
	function matchesRouteNames(item) {
		const currentRouteName = "name" in route && typeof route.name === "string" ? route.name : "";
		return item.routeNames?.includes(currentRouteName) || item.to?.name === currentRouteName;
	}
	function matchesRouteQuery(item) {
		const currentQuery = "query" in route ? route.query : void 0;
		if (!currentQuery || !item.matchQuery?.length) return true;
		return item.matchQuery.every((q) => !!item.to?.query && item.to.query[q] === currentQuery[q]);
	}
	function matchesRoute(item) {
		return matchesRouteNames(item) && matchesRouteQuery(item);
	}
	return {
		matchesRoute,
		matchesRouteNames,
		matchesRouteQuery
	};
}
//#endregion
//#region src/components/HeaderNavigationItem.vue?vue&type=script&lang.ts
var HeaderNavigationItem_vue_vue_type_script_lang_default = {
	name: "HeaderNavigationItem",
	props: { item: {
		type: Object,
		required: true
	} },
	setup() {
		const route = useRoute();
		const { matchesRoute } = useNavigation();
		return {
			matchesRoute,
			route
		};
	}
};
//#endregion
//#region src/components/HeaderNavigationItem.vue
var _hoisted_1$54 = {
	class: "row items-center no-wrap",
	"data-automation": "header-navigation-item"
};
function _sfc_render$51(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RouterLink = resolveComponent("RouterLink");
	return openBlock(), createElementBlock("div", _hoisted_1$54, [createVNode(_component_RouterLink, {
		"active-class": $props.item.routeNames || $props.item.matchQuery ? "" : "navigation-item--active",
		class: normalizeClass(["navigation-item text-black-1 text-body3", { "navigation-item--active": $setup.matchesRoute($props.item) }]),
		"data-automation": "header-navigation-item__link",
		to: $setup.matchesRoute($props.item) ? $setup.route : $props.item.to
	}, {
		default: withCtx(() => [createTextVNode(toDisplayString($props.item.label), 1)]),
		_: 1
	}, 8, [
		"active-class",
		"class",
		"to"
	]), (openBlock(), createBlock(resolveDynamicComponent($props.item.component), {
		class: "q-ml-sm",
		"data-automation": "header-navigation-item__component"
	}))]);
}
var HeaderNavigationItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HeaderNavigationItem_vue_vue_type_script_lang_default, [["render", _sfc_render$51], ["__scopeId", "data-v-c599f3e1"]]);
//#endregion
//#region src/components/HeaderNavigationGroupedItems.vue?vue&type=script&lang.ts
var HeaderNavigationGroupedItems_vue_vue_type_script_lang_default = defineComponent({
	name: "HeaderNavigationGroupedItems",
	components: {
		HeaderNavigationItem: HeaderNavigationItem_default,
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		QList: QList_default,
		QMenu: QMenu_default
	},
	props: {
		navigationItems: {
			type: Array,
			default: () => []
		},
		groupLabel: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		const { matchesRoute } = useNavigation();
		const menuOpen = ref(false);
		const activeGroupedItem = computed(() => props.navigationItems.find((item) => matchesRoute(item)));
		const hasSingleItem = computed(() => props.navigationItems.length && props.navigationItems.length === 1);
		return {
			activeGroupedItem,
			hasMultipleItems: computed(() => props.navigationItems.length && props.navigationItems.length > 1),
			hasSingleItem,
			matchesRoute,
			menuOpen
		};
	}
});
//#endregion
//#region src/components/HeaderNavigationGroupedItems.vue
var _hoisted_1$53 = {
	class: "navigation-item cursor-pointer row items-center no-wrap text-black-1 text-body3",
	"data-automation": "header-navigation-grouped-items"
};
var _hoisted_2$40 = {
	class: "header-navigation-item",
	"data-automation": "header-navigation-grouped-items__label"
};
var _hoisted_3$32 = {
	key: 0,
	class: "q-mx-sm",
	"data-automation": "header-navigation-grouped-items__separator"
};
function _sfc_render$50(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_QItem = resolveComponent("QItem");
	const _component_RouterLink = resolveComponent("RouterLink");
	const _component_QList = resolveComponent("QList");
	const _component_QMenu = resolveComponent("QMenu");
	return openBlock(), createElementBlock("div", _hoisted_1$53, [
		_ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", _hoisted_2$40, toDisplayString(_ctx.groupLabel || _ctx.$t("rvai-base.general.text.otherCenters")), 1), _ctx.activeGroupedItem ? (openBlock(), createElementBlock("div", _hoisted_3$32, toDisplayString(_ctx.$t("rvai-base.general.symbols.separator")), 1)) : createCommentVNode("", true)], 64)) : createCommentVNode("", true),
		_ctx.hasMultipleItems && _ctx.activeGroupedItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
			key: 1,
			"data-automation": "header-navigation-grouped-items__active-item",
			item: _ctx.activeGroupedItem
		}, null, 8, ["item"])) : _ctx.hasSingleItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
			key: 2,
			"data-automation": "header-navigation-grouped-items__active-item",
			item: _ctx.navigationItems[0]
		}, null, 8, ["item"])) : createCommentVNode("", true),
		_ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [createVNode(_component_QIcon, {
			"data-automation": "header-navigation-grouped-items__icon",
			name: "arrow_drop_down",
			size: "16px"
		}), createVNode(_component_QMenu, {
			modelValue: _ctx.menuOpen,
			"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
			anchor: "bottom right",
			"auto-close": "",
			"content-style": { width: "220px" },
			"data-automation": "header-navigation-grouped-items__menu",
			self: "top right"
		}, {
			default: withCtx(() => [createVNode(_component_QList, { separator: "" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item) => {
					return openBlock(), createBlock(_component_RouterLink, {
						key: item.label,
						custom: "",
						to: item.to
					}, {
						default: withCtx(({ navigate }) => [createVNode(_component_QItem, {
							clickable: "",
							"data-automation": "header-navigation-grouped-items__menu-item",
							onClick: navigate
						}, {
							default: withCtx(() => [createVNode(_component_QItemSection, { class: "row items-center no-wrap justify-between" }, {
								default: withCtx(() => [createVNode(_component_QItemLabel, { "data-automation": "header-navigation-grouped-items__menu-item-label" }, {
									default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1)]),
									_: 2
								}, 1024), _ctx.matchesRoute(item) ? (openBlock(), createBlock(_component_QIcon, {
									key: 0,
									class: "q-ml-sm",
									color: "grey-1",
									"data-automation": "header-navigation-grouped-items__menu-selected-icon",
									name: "mdi-check",
									size: "16px"
								})) : createCommentVNode("", true)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1032, ["onClick"])]),
						_: 2
					}, 1032, ["to"]);
				}), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])], 64)) : createCommentVNode("", true)
	]);
}
//#endregion
//#region src/components/HeaderNavigationItems.vue?vue&type=script&lang.ts
var HeaderNavigationItems_vue_vue_type_script_lang_default = defineComponent({
	name: "HeaderNavigationItems",
	components: {
		HeaderNavigationGroupedItems: /* @__PURE__ */ _plugin_vue_export_helper_default(HeaderNavigationGroupedItems_vue_vue_type_script_lang_default, [["render", _sfc_render$50], ["__scopeId", "data-v-cce312d8"]]),
		HeaderNavigationItem: HeaderNavigationItem_default,
		Separator: Separator_default
	},
	props: {
		navigationItems: {
			type: Array,
			default: () => []
		},
		groupedItems: {
			type: Array,
			default: () => []
		},
		groupedItemsLabel: {
			type: String,
			default: ""
		}
	}
});
//#endregion
//#region src/components/HeaderNavigationItems.vue
var _hoisted_1$52 = {
	key: 0,
	class: "header-navigation-items row items-center no-wrap",
	"data-automation": "header-navigation-items"
};
function _sfc_render$49(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
	const _component_Separator = resolveComponent("Separator");
	const _component_HeaderNavigationGroupedItems = resolveComponent("HeaderNavigationGroupedItems");
	return _ctx.navigationItems.length || _ctx.groupedItems.length ? (openBlock(), createElementBlock("div", _hoisted_1$52, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item, i) => {
		return openBlock(), createElementBlock(Fragment, { key: item.label }, [createVNode(_component_HeaderNavigationItem, {
			"data-automation": "header-navigation-items__item",
			item
		}, null, 8, ["item"]), i < _ctx.navigationItems.length - 1 ? (openBlock(), createBlock(_component_Separator, {
			key: 0,
			class: "q-mx-md",
			vertical: ""
		})) : createCommentVNode("", true)], 64);
	}), 128)), _ctx.groupedItems.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.navigationItems.length ? (openBlock(), createBlock(_component_Separator, {
		key: 0,
		class: "q-mx-md",
		vertical: ""
	})) : createCommentVNode("", true), createVNode(_component_HeaderNavigationGroupedItems, {
		"data-automation": "header-navigation-items__grouped-items",
		"group-label": _ctx.groupedItemsLabel,
		"navigation-items": _ctx.groupedItems
	}, null, 8, ["group-label", "navigation-items"])], 64)) : createCommentVNode("", true)])) : createCommentVNode("", true);
}
var HeaderNavigationItems_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HeaderNavigationItems_vue_vue_type_script_lang_default, [["render", _sfc_render$49]]);
//#endregion
//#region src/components/HealthIcon.vue?vue&type=script&lang.ts
var HealthIcon_vue_vue_type_script_lang_default = defineComponent({
	name: "HealthIcon",
	components: {
		QIcon: QIcon_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Shows different text for autoscaling deployments
		*/
		autoScalingEnabled: {
			type: Boolean,
			default: false
		},
		/**
		* Pipeline health status
		*/
		healthStatus: {
			type: String,
			default: void 0
		},
		/**
		* Replica status
		*/
		replicaStatus: {
			type: String,
			default: void 0
		},
		/**
		* Apply running styles
		*/
		running: {
			type: Boolean,
			default: false
		},
		/**
		* Icon size
		*/
		size: {
			type: String,
			default: "1.5em"
		},
		/**
		* Shows tooltip
		*/
		showTooltip: {
			type: Boolean,
			default: true
		},
		/**
		* Apply stopped styles
		*/
		stopped: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { t } = useI18n();
		const status = computed(() => props.healthStatus || props.replicaStatus);
		const color = computed(() => {
			switch (status.value) {
				case PipelineHealthStatus.Critical:
				case PipelineHealthStatus.Failing:
				case ReplicaStatus.Error: return "negative";
				case PipelineHealthStatus.Healthy:
				case ReplicaStatus.Starting:
				case ReplicaStatus.Running: return "positive";
				case PipelineHealthStatus.Overpowered:
				case PipelineHealthStatus.Unbalanced:
				case PipelineHealthStatus.Underpowered: return "warning";
				case ReplicaStatus.Queued: return "grey-1";
				case PipelineHealthStatus.Unknown: return "black-1";
				default: return props.stopped ? "grey-2" : props.replicaStatus && props.running ? "positive" : "grey-1";
			}
		});
		const icon = computed(() => {
			switch (status.value) {
				case PipelineHealthStatus.Critical: return "rvai-base:storage-unresponsive";
				case PipelineHealthStatus.Failing:
				case ReplicaStatus.Error: return "rvai-base:storage-failed";
				case ReplicaStatus.Queued: return "rvai-base:storage-queued";
				case PipelineHealthStatus.Healthy:
				case ReplicaStatus.Starting:
				case ReplicaStatus.Running: return "rvai-base:storage-healthy";
				case PipelineHealthStatus.Overpowered: return "rvai-base:storage-overpowered";
				case PipelineHealthStatus.Unbalanced: return "rvai-base:storage-unbalanced";
				case PipelineHealthStatus.Underpowered: return "rvai-base:storage-underpowered";
				case PipelineHealthStatus.Unknown: return "rvai-base:storage-unknown";
				default: return props.running ? props.replicaStatus ? "rvai-base:storage-healthy" : "rvai-base:storage-start" : "rvai-base:storage-stopped";
			}
		});
		const tooltip = computed(() => {
			switch (status.value) {
				case PipelineHealthStatus.Critical: return props.autoScalingEnabled ? t("rvai-base.components.health.autoscalingStatus.critical") : t("rvai-base.components.health.status.critical");
				case PipelineHealthStatus.Failing: return t("rvai-base.components.health.status.failing");
				case PipelineHealthStatus.Healthy: return t("rvai-base.components.health.status.healthy");
				case PipelineHealthStatus.Overpowered: return t("rvai-base.components.health.status.overpowered");
				case PipelineHealthStatus.Underpowered: return t("rvai-base.components.health.status.underpowered");
				case PipelineHealthStatus.Unknown: return t("rvai-base.components.health.status.unknown");
				case ReplicaStatus.Queued: return t("rvai-base.components.health.replicaStatus.queued");
				case ReplicaStatus.Starting: return t("rvai-base.components.health.replicaStatus.starting");
				case ReplicaStatus.Running: return t("rvai-base.components.health.replicaStatus.running");
				case ReplicaStatus.Error: return t("rvai-base.components.health.replicaStatus.error");
				default: return props.stopped ? t("rvai-base.components.health.status.stopped") : props.replicaStatus || t("rvai-base.components.health.status.unknown");
			}
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			color,
			icon,
			tooltip
		};
	}
});
//#endregion
//#region src/components/HealthIcon.vue
var _hoisted_1$51 = ["data-automation"];
function _sfc_render$48(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		class: "health-icon",
		"data-automation": _ctx.buildId()
	}, [createVNode(_component_QIcon, {
		color: _ctx.color,
		name: _ctx.icon,
		size: _ctx.size
	}, null, 8, [
		"color",
		"name",
		"size"
	]), _ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
		key: 0,
		offset: [0, 2]
	}, {
		default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tooltip), 1)]),
		_: 1
	})) : createCommentVNode("", true)], 8, _hoisted_1$51);
}
var HealthIcon_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HealthIcon_vue_vue_type_script_lang_default, [["render", _sfc_render$48], ["__scopeId", "data-v-c2f71db7"]]);
//#endregion
//#region src/components/Histogram.vue?vue&type=script&lang.ts
var UNKNOWN_CLASS = "unknown";
var Histogram_vue_vue_type_script_lang_default = defineComponent({
	name: "Histogram",
	components: {
		Avatar: Avatar_default,
		BarChart: BarChart_default,
		EllipsisText: EllipsisText_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Displays all info in a row (classNames, percentages, etc)
		*/
		detailed: {
			type: Boolean,
			default: false
		},
		/**
		* Bar height
		*/
		barHeight: {
			type: Number,
			default: void 0
		},
		/**
		* Classes applied to the Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Class distribution data
		*/
		classDistribution: {
			type: Object,
			required: true
		},
		/**
		* List of classes
		*/
		classes: {
			type: Array,
			required: true
		},
		/**
		* Displays class names and percentages
		*/
		full: {
			type: Boolean,
			default: false
		},
		/**
		* Displays spinner
		*/
		loading: {
			type: Boolean,
			default: false
		},
		/**
		* Component max height
		*/
		maxHeight: {
			type: Number,
			default: void 0
		},
		/**
		* Overrides colors for current user avatar
		*/
		overrideCurrentUserAvatar: {
			type: Boolean,
			default: false
		},
		/**
		* Emits 'update:selected' with row.id, when true
		*/
		selectable: {
			type: Boolean,
			default: false
		},
		/**
		* v-model:selected; allows handling selected class
		*/
		selected: {
			type: String,
			default: void 0
		},
		/**
		* Shows class name or class id
		*/
		showClassName: {
			type: Boolean,
			default: false
		},
		/**
		* Histogram size ('sm' | 'md')
		*/
		size: {
			type: String,
			default: "sm"
		},
		/**
		* Sort data inside Histogram
		*/
		sort: {
			type: String,
			default: void 0
		},
		/**
		* Sorting order
		*/
		sortAsc: {
			type: Boolean,
			default: true
		},
		/**
		* Shows tooltip with additional information on bar hover
		*/
		source: {
			type: Object,
			default: void 0
		}
	},
	emits: ["update:selected"],
	setup(props) {
		const { t } = useI18n();
		const histogramRef = ref(null);
		const entries = computed(() => {
			const entries = [...props.classDistribution.entries ?? []].filter((e) => e.count !== 0 || !(isNull(e.id) || e.id === ""));
			if (!entries.length) entries.push({
				count: 0,
				id: null
			});
			return entries.map(({ count, id }) => {
				const clazz = id ? props.classes.find((def) => def.id === id) : void 0;
				return {
					color: id ? clazz?.defaultColor ?? "var(--q-primary)" : "#000",
					count,
					id,
					name: isNull(id) ? t("rvai-base.components.histogram.notAnnotated") : id === "" ? t("rvai-base.components.histogram.emptyAnnotation") : clazz?.name ?? t("rvai-base.components.histogram.unknownClass"),
					pct: `${(totalSamples.value ? Math.min(100 * (count / totalSamples.value), 100) : 0).toLocaleString(void 0, { maximumFractionDigits: 2 })}%`
				};
			});
		});
		const entriesSorted = computed(() => {
			return entries.value.toSorted((a, b) => {
				const x = props.sortAsc ? a : b;
				const y = props.sortAsc ? b : a;
				switch (props.sort) {
					case "count": return x.count - y.count;
					default:
						if (isNull(x.id) && !isNull(y.id)) return -1;
						if (isNull(y.id) && !isNull(x.id)) return 1;
						if (x.id === "" && y.id !== "") return -1;
						if (y.id === "" && x.id !== "") return 1;
						if (x.id === UNKNOWN_CLASS && y.id !== UNKNOWN_CLASS) return -1;
						if (y.id === UNKNOWN_CLASS && x.id !== UNKNOWN_CLASS) return 1;
						return naturalSort(x.name, y.name);
				}
			});
		});
		const totalSamples = computed(() => {
			return props.classDistribution.total ?? 0;
		});
		function generateCSV(countAnnotations = false) {
			return `${[
				t("rvai-base.components.histogram.classId"),
				t("rvai-base.components.histogram.className"),
				countAnnotations ? t("rvai-base.components.histogram.annotations") : t("rvai-base.components.histogram.samples"),
				t("rvai-base.components.histogram.percentage")
			].map((value) => value.replace(/,/g, ".")).join(",")}\n${entriesSorted.value.map((entry) => {
				return [
					entry.id ?? "",
					entry.name ?? "",
					entry.count ?? "",
					entry.pct ?? ""
				].map((value) => value.toString().replace(/,/g, ".")).join(",");
			}).join("\n")}`;
		}
		function isNull(id) {
			return id == null || id === "null";
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			entriesSorted,
			generateCSV,
			histogramRef,
			t
		};
	}
});
//#endregion
//#region src/components/Histogram.vue
var _hoisted_1$50 = { class: "column no-wrap q-mt-sm" };
var _hoisted_2$39 = {
	key: 0,
	class: "row items-center q-mb-sm"
};
var _hoisted_3$31 = { class: "row no-wrap" };
function _sfc_render$47(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Avatar = resolveComponent("Avatar");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_rv_bullet = resolveComponent("rv-bullet");
	const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
	const _component_BarChart = resolveComponent("BarChart");
	return openBlock(), createBlock(_component_BarChart, {
		ref: "histogramRef",
		"bar-height": _ctx.barHeight,
		class: normalizeClass(_ctx.$props.class),
		"data-automation": _ctx.buildId(),
		detailed: _ctx.detailed,
		entries: _ctx.entriesSorted,
		full: _ctx.full,
		loading: _ctx.loading,
		"max-height": _ctx.maxHeight,
		selectable: _ctx.selectable,
		selected: _ctx.selected,
		"show-name": _ctx.showClassName,
		size: _ctx.size,
		"sort-asc": _ctx.sortAsc,
		"onUpdate:selected": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:selected", $event))
	}, createSlots({ _: 2 }, [!_ctx.detailed ? {
		name: "tooltip",
		fn: withCtx(({ entry }) => [createElementVNode("div", null, [createElementVNode("strong", null, toDisplayString(entry.count), 1), createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [entry.pct])), 1)]), createElementVNode("div", _hoisted_1$50, [_ctx.source ? (openBlock(), createElementBlock("div", _hoisted_2$39, [createVNode(_component_Avatar, {
			"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
			"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
			"data-automation": _ctx.buildId("avatar"),
			initials: _ctx.source.initials,
			label: _ctx.source.name,
			"show-logo": !_ctx.source.initials && !_ctx.source.isUser,
			"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
			uuid: _ctx.source.id
		}, null, 8, [
			"background-color",
			"border-color",
			"data-automation",
			"initials",
			"label",
			"show-logo",
			"text-color",
			"uuid"
		]), createVNode(_component_EllipsisText, {
			class: "q-ml-sm black-1",
			"data-automation": _ctx.buildId("source"),
			text: _ctx.source.name
		}, null, 8, ["data-automation", "text"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$31, [createVNode(_component_rv_bullet, {
			color: entry.color,
			"data-automation": _ctx.buildId("classColor")
		}, null, 8, ["color", "data-automation"]), createVNode(_component_rv_ellipsis_text, {
			class: "q-ml-xs",
			"data-automation": _ctx.buildId("className"),
			text: entry.name
		}, null, 8, ["data-automation", "text"])])])]),
		key: "0"
	} : void 0]), 1032, [
		"bar-height",
		"class",
		"data-automation",
		"detailed",
		"entries",
		"full",
		"loading",
		"max-height",
		"selectable",
		"selected",
		"show-name",
		"size",
		"sort-asc"
	]);
}
var Histogram_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Histogram_vue_vue_type_script_lang_default, [["render", _sfc_render$47]]);
//#endregion
//#region src/components/HistogramWrapper.vue?vue&type=script&lang.ts
var HistogramWrapper_vue_vue_type_script_lang_default = defineComponent({
	name: "HistogramWrapper",
	components: {
		Avatar: Avatar_default,
		Histogram: Histogram_default,
		QCard: QCard_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		QSpace: QSpace_default,
		RvButton: Button_default,
		RvSelect: Select_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Bar height; Not applied to maximized Histogram
		*/
		barHeight: {
			type: Number,
			default: void 0
		},
		/**
		* Classes applied to the component; Not applied to maximized Histogram
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* List of classes
		*/
		classes: {
			type: Array,
			required: true
		},
		/**
		* Annotations and samples data passed to the component
		*/
		dataStats: {
			type: Object,
			required: true
		},
		/**
		* Default displaying mode
		*/
		defaultMode: {
			type: String,
			default: "samples"
		},
		/**
		* Default displaying split
		*/
		defaultSplit: {
			type: String,
			default: "all"
		},
		/**
		* Hides component title
		*/
		hideTitle: {
			type: Boolean,
			default: false
		},
		/**
		* Overrides colors for current user avatar
		*/
		overrideCurrentUserAvatar: {
			type: Boolean,
			default: false
		},
		/**
		* Histogram size ('sm' | 'md')
		*/
		size: {
			type: String,
			default: "sm"
		},
		/**
		* Shows tooltip with additional information on bar hover
		*/
		source: {
			type: Object,
			default: void 0
		},
		/**
		* Shows class name or class id
		*/
		showClassName: {
			type: Boolean,
			default: false
		},
		/**
		* Shows component footer
		*/
		showFooter: {
			type: Boolean,
			default: false
		},
		/**
		* Adds the ability to switch between annotations and samples
		*/
		showMode: {
			type: Boolean,
			default: false
		},
		/**
		* Apply custom class(es) to the wrapper
		* @type {[Array, Object, String]}
		*/
		wrapperClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		}
	},
	setup(props) {
		const { t } = useI18n();
		const mode = ref(props.defaultMode);
		const open = ref(false);
		const sort = ref("name");
		const sortAsc = ref(true);
		const split = ref(props.defaultSplit);
		const classDistribution = computed(() => {
			return props.dataStats?.[mode.value]?.[split.value];
		});
		const modeOptions = computed(() => {
			return [{
				label: t("rvai-base.components.histogram.modes.annotations"),
				value: "annotations"
			}, {
				label: t("rvai-base.components.histogram.modes.samples"),
				value: "samples"
			}];
		});
		const modeLabel = computed(() => {
			return modeOptions.value.find((x) => x.value === mode.value)?.label ?? "";
		});
		const sortOptions = computed(() => {
			return [{
				label: t("rvai-base.components.histogram.count"),
				value: "count"
			}, {
				label: t("rvai-base.components.histogram.name"),
				value: "name"
			}];
		});
		const splitOptions = computed(() => {
			return [
				{
					label: t("rvai-base.components.histogram.trainingSetup.all"),
					value: "all"
				},
				{
					label: t("rvai-base.components.histogram.trainingSetup.test"),
					value: "test"
				},
				{
					label: t("rvai-base.components.histogram.trainingSetup.validate"),
					value: "validation"
				},
				{
					label: t("rvai-base.components.histogram.trainingSetup.train"),
					value: "train"
				}
			];
		});
		const splitLabel = computed(() => {
			return splitOptions.value.find((x) => x.value === split.value)?.label ?? "";
		});
		function resetSortAsc() {
			sortAsc.value = true;
		}
		function toggleOpen() {
			open.value = !open.value;
		}
		function toggleSortAsc() {
			sortAsc.value = !sortAsc.value;
		}
		function maximize() {
			open.value = true;
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			classDistribution,
			maximize,
			mode,
			modeLabel,
			modeOptions,
			open,
			resetSortAsc,
			sort,
			sortAsc,
			sortOptions,
			split,
			splitLabel,
			splitOptions,
			t,
			toggleOpen,
			toggleSortAsc
		};
	}
});
//#endregion
//#region src/components/HistogramWrapper.vue
var _hoisted_1$49 = ["data-automation"];
var _hoisted_2$38 = ["data-automation"];
var _hoisted_3$30 = { class: "text-body3" };
var _hoisted_4$19 = ["data-automation"];
var _hoisted_5$15 = { key: 0 };
var _hoisted_6$10 = { class: "text-body3" };
var _hoisted_7$8 = { class: "row no-wrap justify-end full-width q-mb-lg" };
var _hoisted_8$5 = {
	key: 0,
	class: "row q-mr-lg"
};
var _hoisted_9$4 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
var _hoisted_10$2 = { class: "row q-mr-lg" };
var _hoisted_11$2 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
var _hoisted_12$1 = { class: "row" };
var _hoisted_13$1 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
var _hoisted_14$1 = { class: "border-card rounded-borders full-width q-px-lg q-py-md" };
var _hoisted_15$1 = {
	key: 0,
	class: "row no-wrap justify-center items-center q-mb-sm"
};
function _sfc_render$46(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QSpace = resolveComponent("QSpace");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Histogram = resolveComponent("Histogram");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_RvSelect = resolveComponent("RvSelect");
	const _component_Avatar = resolveComponent("Avatar");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", mergeProps(_ctx.dataAttrs, {
		class: ["histogram-wrapper", _ctx.wrapperClass],
		"data-automation": _ctx.buildId()
	}), [
		!_ctx.hideTitle ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: "row no-wrap q-mb-sm",
			"data-automation": _ctx.buildId("title")
		}, [
			createElementVNode("div", _hoisted_3$30, [renderSlot(_ctx.$slots, "title", {}, () => [createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1), createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)], true)]),
			createVNode(_component_QSpace),
			createVNode(_component_RvButton, {
				class: "no-padding",
				color: "black-1",
				"data-automation": _ctx.buildId("full"),
				icon: "mdi-fullscreen",
				tertiary: "",
				onClick: _ctx.toggleOpen
			}, null, 8, ["data-automation", "onClick"])
		], 8, _hoisted_2$38)) : createCommentVNode("", true),
		createVNode(_component_Histogram, {
			"bar-height": _ctx.barHeight,
			class: normalizeClass(_ctx.$props.class),
			"class-distribution": _ctx.classDistribution,
			classes: _ctx.classes,
			"data-automation": _ctx.buildId("1"),
			"show-class-name": _ctx.showClassName,
			size: _ctx.size,
			sort: _ctx.sort,
			"sort-asc": _ctx.sortAsc,
			source: _ctx.source
		}, null, 8, [
			"bar-height",
			"class",
			"class-distribution",
			"classes",
			"data-automation",
			"show-class-name",
			"size",
			"sort",
			"sort-asc",
			"source"
		]),
		_ctx.showFooter ? (openBlock(), createElementBlock("div", {
			key: 1,
			class: "text-body3 text-grey-1--light text-grey-2--dark q-mt-sm",
			"data-automation": _ctx.buildId("footer")
		}, [_ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_5$15, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")) + " " + toDisplayString(_ctx.modeLabel), 1)) : createCommentVNode("", true), createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.components.histogram.split")) + " " + toDisplayString(_ctx.splitLabel), 1)], 8, _hoisted_4$19)) : createCommentVNode("", true)
	], 16, _hoisted_1$49), createVNode(_component_QDialog, {
		modelValue: _ctx.open,
		"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.open = $event),
		"data-automation": _ctx.buildId("dialog"),
		"full-height": "",
		"full-width": ""
	}, {
		default: withCtx(() => [createVNode(_component_QCard, { class: "column no-wrap" }, {
			default: withCtx(() => [createVNode(_component_QCardSection, { class: "histogram-wrapper__title q-pb-none row items-center bg-white" }, {
				default: withCtx(() => [
					createElementVNode("div", _hoisted_6$10, [renderSlot(_ctx.$slots, "title", {}, () => [createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1), createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)], true)]),
					createVNode(_component_QSpace),
					createVNode(_component_RvButton, {
						class: "no-padding",
						"data-automation": _ctx.buildId("full-exit"),
						icon: "mdi-fullscreen-exit",
						tertiary: "",
						onClick: _ctx.toggleOpen
					}, null, 8, ["data-automation", "onClick"])
				]),
				_: 3
			}), createVNode(_component_QCardSection, { class: "q-pt-md row" }, {
				default: withCtx(() => [createElementVNode("div", _hoisted_7$8, [
					_ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_8$5, [createElementVNode("div", _hoisted_9$4, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")), 1), createVNode(_component_RvSelect, {
						modelValue: _ctx.mode,
						"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.mode = $event),
						"data-automation": _ctx.buildId("mode"),
						dense: "",
						"emit-value": "",
						"map-options": "",
						options: _ctx.modeOptions,
						"show-checkmark": ""
					}, null, 8, [
						"modelValue",
						"data-automation",
						"options"
					])])) : createCommentVNode("", true),
					createElementVNode("div", _hoisted_10$2, [createElementVNode("div", _hoisted_11$2, toDisplayString(_ctx.t("rvai-base.components.histogram.split")), 1), createVNode(_component_RvSelect, {
						modelValue: _ctx.split,
						"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.split = $event),
						"data-automation": _ctx.buildId("split"),
						dense: "",
						"emit-value": "",
						"map-options": "",
						options: _ctx.splitOptions,
						"show-checkmark": ""
					}, null, 8, [
						"modelValue",
						"data-automation",
						"options"
					])]),
					createElementVNode("div", _hoisted_12$1, [createElementVNode("div", _hoisted_13$1, toDisplayString(_ctx.t("rvai-base.general.table.sortBy")), 1), createVNode(_component_RvSelect, {
						modelValue: _ctx.sort,
						"onUpdate:modelValue": [_cache[2] || (_cache[2] = ($event) => _ctx.sort = $event), _ctx.resetSortAsc],
						"data-automation": _ctx.buildId("sort"),
						dense: "",
						"emit-value": "",
						"map-options": "",
						options: _ctx.sortOptions,
						"show-checkmark": ""
					}, {
						prepend: withCtx(() => [createVNode(_component_RvButton, {
							color: "grey-1",
							"data-automation": _ctx.buildId("sort"),
							icon: _ctx.sortAsc ? "rvai-base:sort-asc" : "rvai-base:sort-desc",
							size: "md",
							tertiary: "",
							onClick: withModifiers(_ctx.toggleSortAsc, ["stop"])
						}, null, 8, [
							"data-automation",
							"icon",
							"onClick"
						])]),
						_: 1
					}, 8, [
						"modelValue",
						"data-automation",
						"options",
						"onUpdate:modelValue"
					])])
				]), createElementVNode("div", _hoisted_14$1, [_ctx.source ? (openBlock(), createElementBlock("div", _hoisted_15$1, [createVNode(_component_Avatar, {
					"background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
					"border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
					label: _ctx.source.name,
					"text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
					uuid: _ctx.source.id
				}, null, 8, [
					"background-color",
					"border-color",
					"label",
					"text-color",
					"uuid"
				]), createElementVNode("div", { class: normalizeClass(["q-ml-sm text-subtitle3", _ctx.source.color ? `text-${_ctx.source.color}` : ""]) }, toDisplayString(_ctx.source.name), 3)])) : createCommentVNode("", true), createVNode(_component_Histogram, {
					class: "full-width",
					"class-distribution": _ctx.classDistribution,
					classes: _ctx.classes,
					"data-automation": _ctx.buildId("2"),
					full: "",
					"show-class-name": _ctx.showClassName,
					sort: _ctx.sort,
					"sort-asc": _ctx.sortAsc,
					source: _ctx.source
				}, null, 8, [
					"class-distribution",
					"classes",
					"data-automation",
					"show-class-name",
					"sort",
					"sort-asc",
					"source"
				])])]),
				_: 1
			})]),
			_: 3
		})]),
		_: 3
	}, 8, ["modelValue", "data-automation"])], 64);
}
var HistogramWrapper_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HistogramWrapper_vue_vue_type_script_lang_default, [["render", _sfc_render$46], ["__scopeId", "data-v-825c1bf0"]]);
//#endregion
//#region src/components/InfoPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$48 = { key: 0 };
var _hoisted_2$37 = ["data-automation"];
var _hoisted_3$29 = ["data-automation"];
var _hoisted_4$18 = ["data-automation"];
//#endregion
//#region src/components/InfoPanel.vue
var InfoPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InfoPanel",
	props: {
		class: { default: void 0 },
		color: { default: "blue" },
		compact: { type: Boolean },
		dataAutomation: { default: "info-panel" },
		icon: { default: "rvai-base:info" },
		iconSize: { default: "20px" },
		label: { default: void 0 },
		localStorageKey: { default: void 0 },
		showCloseButton: {
			type: Boolean,
			default: false
		}
	},
	emits: ["close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isClosed = ref(Plugin$8.getItem(getLocalStorageKey()) ?? false);
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		function getLocalStorageKey() {
			if (!props.localStorageKey) return void 0;
			return `infoPanelClosed.${props.localStorageKey}`;
		}
		function onClose() {
			isClosed.value = true;
			if (props.localStorageKey) Plugin$8.set(getLocalStorageKey(), true);
			emit("close");
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(QSlideTransition_default), null, {
				default: withCtx(() => [!isClosed.value ? (openBlock(), createElementBlock("div", _hoisted_1$48, [createElementVNode("div", {
					class: normalizeClass(["rv-info-panel text-small rounded-borders flex no-wrap", [
						_ctx.$props.class,
						`border-${__props.color} text-${__props.color}`,
						{
							"q-px-md q-py-sm items-center": !__props.compact,
							"q-pa-sm": __props.compact
						}
					]]),
					"data-automation": unref(buildId)()
				}, [
					createVNode(unref(QIcon_default), {
						class: "q-mr-sm",
						color: __props.color,
						"data-automation": unref(buildId)("icon"),
						name: __props.icon,
						size: __props.iconSize
					}, null, 8, [
						"color",
						"data-automation",
						"name",
						"size"
					]),
					createElementVNode("div", {
						class: "info-panel__label",
						"data-automation": unref(buildId)("label")
					}, [renderSlot(_ctx.$slots, "label", {}, () => [createTextVNode(toDisplayString(__props.label), 1)], true)], 8, _hoisted_3$29),
					__props.showCloseButton ? (openBlock(), createElementBlock("div", {
						key: 0,
						class: normalizeClass(["info-panel__close", {
							"q-pl-md": !__props.compact,
							"q-pl-sm": __props.compact
						}]),
						"data-automation": unref(buildId)("close")
					}, [createVNode(Button_default, {
						"aria-label": "Close",
						class: "no-padding",
						color: __props.color,
						icon: "mdi-close",
						tertiary: "",
						onClick: onClose
					}, null, 8, ["color"])], 10, _hoisted_4$18)) : createCommentVNode("", true)
				], 10, _hoisted_2$37)])) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-2a532737"]]);
//#endregion
//#region src/components/LabelerSlider.vue?vue&type=script&lang.ts
var __default__$2 = defineComponent({
	name: "LabelerSlider",
	components: { QSlider: QSlider_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Height of the slider container
		*/
		trackContainerHeight: {
			type: Number,
			default: 26
		},
		/**
		* Flag to hide label
		*/
		label: {
			type: Boolean,
			default: true
		},
		/**
		* Maximum value of the model; Set track's maximum value
		*/
		max: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value of the model; Set track's minimum value
		*/
		min: {
			type: Number,
			default: 0
		},
		/**
		* Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Number,
			required: true
		},
		/**
		* Work in reverse (changes direction)
		*/
		reverse: {
			type: Boolean,
			default: false
		},
		/**
		* Snap on valid values, rather than sliding freely; Suggestion: use with 'step' prop
		*/
		snap: {
			type: Boolean,
			default: false
		},
		/**
		* Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
		*/
		step: {
			type: Number,
			default: 1
		},
		/**
		* Change the arrow direction
		*/
		thumbDown: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props) {
		const LINE_HEIGHT = 2;
		const trackContainerVerticalPadding = computed(() => `${Math.round((props.trackContainerHeight - LINE_HEIGHT) / 2)}px`);
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			trackContainerVerticalPadding
		};
	}
});
var __injectCSSVars__$2 = () => {
	useCssVars((_ctx) => ({ "v214f46d2": _ctx.trackContainerVerticalPadding }));
};
var __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? (props, ctx) => {
	__injectCSSVars__$2();
	return __setup__$2(props, ctx);
} : __injectCSSVars__$2;
//#endregion
//#region src/components/LabelerSlider.vue
function _sfc_render$45(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QSlider = resolveComponent("QSlider");
	return openBlock(), createBlock(_component_QSlider, mergeProps(_ctx.dataAttrs, {
		class: ["rv-labeler-slider", [{ "rv-labeler-slider--down": _ctx.thumbDown }, _ctx.$props.class]],
		"data-automation": _ctx.buildId(),
		label: _ctx.label,
		max: _ctx.max,
		min: _ctx.min,
		"model-value": _ctx.modelValue,
		reverse: _ctx.reverse,
		snap: _ctx.snap,
		step: _ctx.step,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
	}), null, 16, [
		"class",
		"data-automation",
		"label",
		"max",
		"min",
		"model-value",
		"reverse",
		"snap",
		"step"
	]);
}
var LabelerSlider_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__$2, [["render", _sfc_render$45], ["__scopeId", "data-v-71b2ad4d"]]);
//#endregion
//#region src/components/LayoutButton.vue?vue&type=script&lang.ts
var LAYOUT_LOGO = {
	[Layout.Default]: "rvai-base:layout-default",
	[Layout.RightOnly]: "rvai-base:layout-right",
	[Layout.LeftOnly]: "rvai-base:layout-left",
	[Layout.Full]: "rvai-base:layout-full",
	[Layout.Split]: "rvai-base:layout-split"
};
var LayoutButton_vue_vue_type_script_lang_default = defineComponent({
	name: "LayoutButton",
	components: {
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		QList: QList_default,
		QMenu: QMenu_default,
		RvButton: Button_default
	},
	props: { 
	/**
	* Automation ID to easily find element in the DOM by its value
	*/
dataAutomation: {
		type: String,
		default: void 0
	} },
	setup(props) {
		const { t } = useI18n();
		const { availableLayouts, hasRightContent, layout, setLayout } = useLayout();
		const logo = computed(() => {
			return LAYOUT_LOGO[layout.value];
		});
		const options = computed(() => {
			return availableLayouts.value.map((l) => ({
				icon: LAYOUT_LOGO[l],
				label: t(`rvai-base.general.layout.${String(l)}`),
				layout: l
			}));
		});
		const showMenu = computed(() => {
			return availableLayouts.value.length > 2;
		});
		const canChangeLayout = computed(() => {
			return availableLayouts.value.length > 1 && !!hasRightContent.value;
		});
		function onChangeLayout() {
			if (showMenu.value) return;
			const value = availableLayouts.value.find((l) => l !== layout.value) ?? availableLayouts.value[0];
			setLayout(value);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			canChangeLayout,
			layout,
			logo,
			onChangeLayout,
			options,
			setLayout,
			showMenu
		};
	}
});
//#endregion
//#region src/components/LayoutButton.vue
function _sfc_render$44(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_QItem = resolveComponent("QItem");
	const _component_QList = resolveComponent("QList");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createBlock(_component_RvButton, {
		class: "bg-white",
		color: "black-1",
		"data-automation": _ctx.buildId(),
		disable: !_ctx.canChangeLayout,
		icon: _ctx.logo,
		tertiary: "",
		onClick: _ctx.onChangeLayout
	}, {
		default: withCtx(() => [_ctx.showMenu ? (openBlock(), createBlock(_component_QMenu, {
			key: 0,
			anchor: "bottom right",
			"auto-close": "",
			self: "top right"
		}, {
			default: withCtx(() => [createVNode(_component_QList, { separator: "" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (item) => {
					return openBlock(), createBlock(_component_QItem, {
						key: item.layout,
						class: normalizeClass({ "bg-grey-6": item.layout === _ctx.layout }),
						clickable: "",
						"data-automation": _ctx.buildId(`option-${item.layout}`),
						onClick: ($event) => _ctx.setLayout(item.layout)
					}, {
						default: withCtx(() => [createVNode(_component_QItemSection, null, {
							default: withCtx(() => [createVNode(_component_QItemLabel, { class: "text-body-3" }, {
								default: withCtx(() => [createVNode(_component_QIcon, {
									class: "q-mr-sm",
									name: item.icon,
									size: "24px"
								}, null, 8, ["name"]), createTextVNode(" " + toDisplayString(item.label), 1)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, [
						"class",
						"data-automation",
						"onClick"
					]);
				}), 128))]),
				_: 1
			})]),
			_: 1
		})) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"data-automation",
		"disable",
		"icon",
		"onClick"
	]);
}
var LayoutButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(LayoutButton_vue_vue_type_script_lang_default, [["render", _sfc_render$44]]);
//#endregion
//#region src/components/LinearProgress.vue?vue&type=script&lang.ts
var __default__$1 = defineComponent({
	name: "LinearProgress",
	components: { QLinearProgress: QLinearProgress_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Color name for component from the Quasar Color Palette
		*/
		color: {
			type: String,
			default: "primary"
		},
		/**
		* Put component into indeterminate mode
		*/
		indeterminate: {
			type: Boolean,
			default: false
		},
		/**
		* Applies a small standard border-radius for a squared shape of the component
		*/
		rounded: {
			type: Boolean,
			default: true
		},
		/**
		* Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
		*/
		size: {
			type: String,
			default: "8px"
		},
		/**
		* Makes a skew line
		*/
		skew: {
			type: Boolean,
			default: false
		},
		/**
		* Color name for component's track from the Quasar Color Palette
		*/
		trackColor: {
			type: String,
			default: "primary-lighter"
		},
		/**
		* Progress value (0.0 < x < 1.0)
		*/
		value: {
			type: Number,
			default: void 0
		},
		/**
		* Render background track
		*/
		withTrack: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
var __injectCSSVars__$1 = () => {
	useCssVars((_ctx) => ({ "v6479ffb4": _ctx.$props.size }));
};
var __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? (props, ctx) => {
	__injectCSSVars__$1();
	return __setup__$1(props, ctx);
} : __injectCSSVars__$1;
//#endregion
//#region src/components/LinearProgress.vue
function _sfc_render$43(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QLinearProgress = resolveComponent("QLinearProgress");
	return openBlock(), createBlock(_component_QLinearProgress, {
		class: normalizeClass(["rv-linear-progress", {
			"rv-linear-progress--indeterminate": _ctx.indeterminate,
			"rv-linear-progress--no-track": !_ctx.withTrack,
			"rv-linear-progress--skew": _ctx.skew
		}]),
		color: _ctx.color,
		"data-automation": _ctx.buildId(),
		indeterminate: _ctx.indeterminate,
		rounded: _ctx.rounded,
		size: _ctx.size,
		style: normalizeStyle({ "--value": `${_ctx.value * 100}%` }),
		"track-color": _ctx.trackColor
	}, null, 8, [
		"class",
		"color",
		"data-automation",
		"indeterminate",
		"rounded",
		"size",
		"style",
		"track-color"
	]);
}
var LinearProgress_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__$1, [["render", _sfc_render$43], ["__scopeId", "data-v-3225131f"]]);
//#endregion
//#region src/components/LocalUrl.vue
var LocalUrl_default = /* @__PURE__ */ defineComponent({
	__name: "LocalUrl",
	props: {
		data: {
			default: void 0,
			type: Object
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: void 0,
			type: String
		}
	},
	setup(__props) {
		const props = __props;
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		const url = ref(null);
		onUnmounted(() => {
			if (url.value) URL.revokeObjectURL(url.value);
		});
		watch(() => props.data, async (data, prevData) => {
			const blob = data && await Promise.resolve(data);
			if (blob === (prevData && await Promise.resolve(prevData))) return;
			if (url.value) URL.revokeObjectURL(url.value);
			url.value = blob ? URL.createObjectURL(blob) : null;
		}, { immediate: true });
		return (_ctx, _cache) => {
			return url.value ? renderSlot(_ctx.$slots, "default", {
				dataAutomation: unref(buildId)(),
				url: url.value
			}, void 0, void 0, 0) : renderSlot(_ctx.$slots, "empty", { dataAutomation: unref(buildId)("empty") }, void 0, void 0, 1);
		};
	}
});
//#endregion
//#region src/components/Logo.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$47 = ["data-automation", "view-box"];
var _hoisted_2$36 = ["xlink:href"];
var DEFAULT_REGULAR_HEIGHT = "40";
var DEFAULT_REGULAR_WIDTH = "136";
var DEFAULT_MAIN_HEIGHT = "120";
var DEFAULT_MAIN_WIDTH = "153";
//#endregion
//#region src/components/Logo.vue
var Logo_default = /* @__PURE__ */ defineComponent({
	__name: "Logo",
	props: {
		/**
		* Color name for component from the Quasar Color Palette
		*/
		color: {
			default: "black-1",
			type: String
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: "logo",
			type: String
		},
		/**
		* Logo (regular | main)
		*/
		name: {
			default: "regular",
			type: String
		},
		/**
		* Logo size [width, height] -> [100, 50]
		*/
		size: {
			default: void 0,
			type: Array
		},
		/**
		* Source of the user provided logo.
		*/
		src: {
			default: void 0,
			type: String
		},
		/**
		* Styles applied to component
		* @type {[Array, Object, String]}
		*/
		style: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		}
	},
	setup(__props) {
		const props = __props;
		const { customLogoSrc, logoMain, logoRegular } = useLogo();
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		const customSize = computed(() => {
			if (!props.size) return void 0;
			const [width, height] = props.size;
			return {
				"--height": `${height}px`,
				"--width": `${width}px`
			};
		});
		const logo = computed(() => {
			switch (props.name) {
				case "regular": return {
					name: toValue(customLogoSrc.value ? customLogoSrc.value : logoRegular.value),
					size: customSize.value ?? {
						"--height": `${DEFAULT_REGULAR_HEIGHT}px`,
						"--width": `${DEFAULT_REGULAR_WIDTH}px`
					},
					style: {
						height: `${DEFAULT_REGULAR_HEIGHT}px`,
						width: `${DEFAULT_REGULAR_WIDTH}px`
					},
					viewBox: `0 0 ${props.size ? props.size.join(" ") : `${DEFAULT_REGULAR_WIDTH} ${DEFAULT_REGULAR_HEIGHT}`}`
				};
				default: return {
					name: toValue(customLogoSrc.value ? customLogoSrc.value : logoMain.value),
					size: customSize.value ?? {
						"--height": `${DEFAULT_MAIN_HEIGHT}px`,
						"--width": `${DEFAULT_MAIN_WIDTH}px`
					},
					style: {
						height: `${DEFAULT_MAIN_HEIGHT}px`,
						width: `${DEFAULT_MAIN_WIDTH}px`
					},
					viewBox: `0 0 ${props.size ? props.size.join(" ") : `${DEFAULT_MAIN_WIDTH} ${DEFAULT_MAIN_HEIGHT}`}`
				};
			}
		});
		return (_ctx, _cache) => {
			return !!unref(customLogoSrc) ? (openBlock(), createBlock(unref(QImg_default), {
				key: 0,
				"data-automation": unref(buildId)(),
				fit: "contain",
				src: logo.value.name,
				style: normalizeStyle(logo.value.style)
			}, null, 8, [
				"data-automation",
				"src",
				"style"
			])) : (openBlock(), createElementBlock("svg", {
				key: 1,
				class: normalizeClass(["rv-logo", `text-${__props.color}`]),
				"data-automation": unref(buildId)(),
				style: normalizeStyle(logo.value.size),
				"view-box": logo.value.viewBox
			}, [createElementVNode("use", { "xlink:href": logo.value.name }, null, 8, _hoisted_2$36)], 14, _hoisted_1$47));
		};
	}
});
//#endregion
//#region src/components/NavigationTitle.vue?vue&type=script&lang.ts
var NavigationTitle_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationTitle",
	components: {
		Logo: Logo_default,
		RouterLink,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		collapseOverlayWithLeftSidebar: {
			type: Boolean,
			default: false
		},
		homeRoute: {
			type: [Object, String],
			default: void 0
		},
		overlay: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const { logoAlignClasses } = useLogo();
		const { isFullLayout, isSidebarAnimationInprogress, showLeftSidebar, toggleNavigationBar, toggleShowOverlay } = useLayout();
		const collapse = computed(() => {
			return props.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
		});
		function onToggle() {
			if (isSidebarAnimationInprogress.value) return;
			if (props.overlay) toggleShowOverlay();
			else toggleNavigationBar();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			collapse,
			isFullLayout,
			logoAlignClasses,
			onToggle
		};
	}
});
//#endregion
//#region src/components/NavigationTitle.vue
var _hoisted_1$46 = ["data-automation"];
var _hoisted_2$35 = { class: "navigation-bar__icon" };
var _hoisted_3$28 = {
	key: 1,
	class: "navigation-bar__icon"
};
function _sfc_render$42(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Logo = resolveComponent("Logo");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["navigation-bar__header row items-center", {
			"navigation-bar__header--overlay": _ctx.overlay,
			"navigation-bar__header--overlay-collapse": _ctx.collapse
		}]),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", { class: normalizeClass(["navigation-bar__header-item row no-wrap items-center", { "justify-center": _ctx.collapse }]) }, [createElementVNode("div", _hoisted_2$35, [createVNode(_component_RvButton, {
		class: "no-padding",
		color: "black-1",
		"data-automation": _ctx.buildId("menu"),
		icon: "mdi-menu",
		tertiary: "",
		onClick: _ctx.onToggle
	}, null, 8, ["data-automation", "onClick"])]), !_ctx.isFullLayout ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [!_ctx.collapse ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
		key: 0,
		class: normalizeClass(["navigation-bar__label", _ctx.logoAlignClasses]),
		"data-automation": _ctx.buildId("link"),
		to: _ctx.homeRoute
	}, {
		default: withCtx(() => [createVNode(_component_Logo, {
			class: "navigation-bar__logo",
			"data-automation": _ctx.buildId("logo")
		}, null, 8, ["data-automation"])]),
		_: 1
	}, 8, [
		"class",
		"data-automation",
		"to"
	])) : createCommentVNode("", true), !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_3$28)) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)], 2)], 10, _hoisted_1$46);
}
var NavigationTitle_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationTitle_vue_vue_type_script_lang_default, [["render", _sfc_render$42], ["__scopeId", "data-v-2eb458ff"]]);
//#endregion
//#region src/components/NavigationHeader.vue?vue&type=script&lang.ts
var NavigationHeader_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationHeader",
	components: {
		Avatar: Avatar_default,
		EllipsisText: EllipsisText_default,
		HeaderNavigationItems: HeaderNavigationItems_default,
		LayoutButton: LayoutButton_default,
		NavigationTitle: NavigationTitle_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QList: QList_default,
		QMenu: QMenu_default,
		QSpace: QSpace_default,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		back: {
			type: Object,
			default: void 0
		},
		backDirectRoute: {
			type: Object,
			default: void 0
		},
		collapseOverlayWithLeftSidebar: {
			type: Boolean,
			default: false
		},
		iconsWidth: {
			type: String,
			default: "auto"
		},
		ignoreShowRightSidebar: {
			type: Boolean,
			default: false
		},
		navigationItems: {
			type: Array,
			default: () => []
		},
		groupedNavigationItems: {
			type: Array,
			default: () => []
		},
		groupedNavigationLabel: {
			type: String,
			default: ""
		},
		overlay: {
			type: Boolean,
			default: false
		},
		sidebarWidth: {
			type: String,
			default: "300px"
		},
		title: {
			type: String,
			required: true
		}
	},
	setup(props) {
		const options = useOptionsReadOnly();
		const { t } = useI18n();
		const { isFullLayout, showLeftSidebar, showRightSidebar } = useLayout();
		const { goToPreviousPage } = useNavigationHistory(props.back, props.backDirectRoute);
		const menuOpen = ref(false);
		const actionsWidth = computed(() => {
			return showRightSidebar.value && !props.ignoreShowRightSidebar ? props.sidebarWidth : props.iconsWidth;
		});
		const areNotificationsAvailable = computed(() => options.notification.areNotificationsAvailable ?? true);
		const collapse = computed(() => {
			return props.collapseOverlayWithLeftSidebar && !showLeftSidebar.value || isFullLayout.value;
		});
		const homeRoute = computed(() => options.navigation.homeRoute);
		const notificationButton = computed(() => options.notification.component);
		const user = computed(() => toValue(options.session.currentUser));
		function onLogout() {
			if (options.session.onLogout) options.session.onLogout();
		}
		function onViewProfile() {
			if (options.session.onViewProfile) options.session.onViewProfile();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			actionsWidth,
			areNotificationsAvailable,
			collapse,
			goToPreviousPage,
			homeRoute,
			menuOpen,
			notificationButton,
			onLogout,
			onViewProfile,
			options,
			t,
			user
		};
	}
});
//#endregion
//#region src/components/NavigationHeader.vue
var _hoisted_1$45 = ["data-automation"];
var _hoisted_2$34 = ["data-automation"];
var _hoisted_3$27 = {
	key: 1,
	class: "col-fixed"
};
var _hoisted_4$17 = ["data-automation"];
var _hoisted_5$14 = ["data-automation"];
var _hoisted_6$9 = { class: "row no-wrap q-gutter-x-sm" };
var _hoisted_7$7 = ["data-automation"];
var _hoisted_8$4 = { class: "navigation-header__icons row no-wrap justify-end items-center q-gutter-md" };
var _hoisted_9$3 = ["data-automation"];
function _sfc_render$41(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationTitle = resolveComponent("NavigationTitle");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_HeaderNavigationItems = resolveComponent("HeaderNavigationItems");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItem = resolveComponent("QItem");
	const _component_QList = resolveComponent("QList");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_Avatar = resolveComponent("Avatar");
	const _component_LayoutButton = resolveComponent("LayoutButton");
	return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
		class: "navigation-header bg-grey-5 row no-wrap items-center q-px-lg",
		"data-automation": _ctx.buildId()
	}, [
		_ctx.overlay || _ctx.$slots["navigation-title"] ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["navigation-header__left", { "navigation-header__left-collapse": _ctx.collapse }]),
			"data-automation": _ctx.buildId("navigation-title-wrapper")
		}, [renderSlot(_ctx.$slots, "navigation-title", {}, () => [_ctx.overlay ? (openBlock(), createBlock(_component_NavigationTitle, {
			key: 0,
			"collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
			"data-automation": _ctx.buildId("title"),
			"home-route": _ctx.homeRoute,
			overlay: _ctx.overlay
		}, null, 8, [
			"collapse-overlay-with-left-sidebar",
			"data-automation",
			"home-route",
			"overlay"
		])) : createCommentVNode("", true)], true)], 10, _hoisted_2$34)) : createCommentVNode("", true),
		_ctx.back || _ctx.backDirectRoute ? (openBlock(), createElementBlock("div", _hoisted_3$27, [createVNode(_component_RvButton, {
			"data-automation": _ctx.buildId("back"),
			icon: "mdi-chevron-left",
			tertiary: "",
			"text-color": "black-1",
			onClick: withModifiers(_ctx.goToPreviousPage, ["prevent"])
		}, null, 8, ["data-automation", "onClick"])])) : createCommentVNode("", true),
		_ctx.$slots["title"] || _ctx.title ? renderSlot(_ctx.$slots, "title", {}, () => [createVNode(_component_EllipsisText, {
			class: "text-black-1 text-subtitle1",
			"data-automation": _ctx.buildId("title"),
			text: _ctx.title
		}, null, 8, ["data-automation", "text"])], true, 2) : createCommentVNode("", true),
		_ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", {
			key: 3,
			"data-automation": _ctx.buildId("append-title")
		}, [renderSlot(_ctx.$slots, "append-title", {}, void 0, true)], 8, _hoisted_4$17)) : createCommentVNode("", true),
		createVNode(_component_QSpace),
		_ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
			key: 4,
			class: "navigation-header__actions q-ml-md",
			"data-automation": _ctx.buildId("actions")
		}, [createElementVNode("div", _hoisted_6$9, [renderSlot(_ctx.$slots, "actions", {}, void 0, true)])], 8, _hoisted_5$14)) : createCommentVNode("", true),
		_ctx.navigationItems.length ? (openBlock(), createBlock(_component_HeaderNavigationItems, {
			key: 5,
			"data-automation": _ctx.buildId("headerNavigationItems"),
			"grouped-items": _ctx.groupedNavigationItems,
			"grouped-items-label": _ctx.groupedNavigationLabel,
			"navigation-items": _ctx.navigationItems
		}, null, 8, [
			"data-automation",
			"grouped-items",
			"grouped-items-label",
			"navigation-items"
		])) : createCommentVNode("", true),
		createElementVNode("div", {
			class: "navigation-header__right col-fixed q-ml-lg",
			"data-automation": _ctx.buildId("right"),
			style: normalizeStyle({ width: _ctx.navigationItems.length ? "auto" : _ctx.actionsWidth })
		}, [createElementVNode("div", _hoisted_8$4, [
			_ctx.areNotificationsAvailable ? renderSlot(_ctx.$slots, "extra", {}, () => [_ctx.notificationButton ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.notificationButton), { key: 0 })) : createCommentVNode("", true)], true, 0) : createCommentVNode("", true),
			_ctx.user ? (openBlock(), createBlock(_component_Avatar, {
				key: 1,
				"background-color": _ctx.user.isCurrent ? "white" : _ctx.user.userColor,
				"border-color": _ctx.user.isCurrent ? "grey-1" : "white",
				class: "cursor-pointer",
				"data-automation": _ctx.buildId("user"),
				image: _ctx.user.userAvatar,
				initials: _ctx.user.userInitials,
				label: _ctx.user.userName,
				"show-tooltip": !_ctx.menuOpen,
				"text-color": _ctx.user.isCurrent ? "grey-1" : "",
				uuid: _ctx.user.userId
			}, {
				extra: withCtx(() => [createVNode(_component_QMenu, {
					modelValue: _ctx.menuOpen,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
					anchor: "bottom right",
					"auto-close": "",
					"content-style": { width: "220px" },
					self: "top right"
				}, {
					default: withCtx(() => [createVNode(_component_QList, { separator: "" }, {
						default: withCtx(() => [_ctx.options.session.onViewProfile ? (openBlock(), createBlock(_component_QItem, {
							key: 0,
							clickable: "",
							"data-automation": _ctx.buildId("btn-view-profile"),
							onClick: _ctx.onViewProfile
						}, {
							default: withCtx(() => [createVNode(_component_QItemLabel, null, {
								default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.viewProfile")), 1)]),
								_: 1
							})]),
							_: 1
						}, 8, ["data-automation", "onClick"])) : createCommentVNode("", true), createVNode(_component_QItem, {
							clickable: "",
							"data-automation": _ctx.buildId("btn-logout"),
							onClick: _ctx.onLogout
						}, {
							default: withCtx(() => [createVNode(_component_QItemLabel, null, {
								default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.logout")), 1)]),
								_: 1
							})]),
							_: 1
						}, 8, ["data-automation", "onClick"])]),
						_: 1
					})]),
					_: 1
				}, 8, ["modelValue"])]),
				_: 1
			}, 8, [
				"background-color",
				"border-color",
				"data-automation",
				"image",
				"initials",
				"label",
				"show-tooltip",
				"text-color",
				"uuid"
			])) : createCommentVNode("", true),
			createVNode(_component_LayoutButton, { "data-automation": _ctx.buildId("layout") }, null, 8, ["data-automation"])
		])], 12, _hoisted_7$7)
	], 8, _hoisted_1$45), _ctx.$slots["sub-header"] ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "bg-grey-5 q-px-lg q-pb-md text-black-1",
		"data-automation": _ctx.buildId("sub-header")
	}, [renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)], 8, _hoisted_9$3)) : createCommentVNode("", true)], 64);
}
var NavigationHeader_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationHeader_vue_vue_type_script_lang_default, [["render", _sfc_render$41], ["__scopeId", "data-v-b39148e0"]]);
//#endregion
//#region src/components/SpinnerFixed.vue?vue&type=script&lang.ts
var SpinnerFixed_vue_vue_type_script_lang_default = defineComponent({
	name: "SpinnerFixed",
	components: { QSpinner: QSpinner_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "spinnerFixed"
		},
		/**
		* Spinner size
		*/
		size: {
			type: String,
			default: "48px"
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/SpinnerFixed.vue
var _hoisted_1$44 = ["data-automation"];
var _hoisted_2$33 = { class: "spinner-block__background" };
var _hoisted_3$26 = { class: "absolute-center" };
function _sfc_render$40(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QSpinner = resolveComponent("QSpinner");
	return openBlock(), createElementBlock("div", {
		class: "spinner-block flex justify-center",
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", _hoisted_2$33, [createElementVNode("div", _hoisted_3$26, [createVNode(_component_QSpinner, {
		class: "spinner-block__spinner",
		color: "primary",
		size: _ctx.size
	}, null, 8, ["size"])])])], 8, _hoisted_1$44);
}
var SpinnerFixed_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SpinnerFixed_vue_vue_type_script_lang_default, [["render", _sfc_render$40], ["__scopeId", "data-v-6f076497"]]);
//#endregion
//#region src/components/MainContent.vue?vue&type=script&lang.ts
var MainContent_vue_vue_type_script_lang_default = defineComponent({
	name: "MainContent",
	components: {
		NavigationHeader: NavigationHeader_default,
		QDrawer: QDrawer_default,
		QHeader: QHeader_default,
		QPage: QPage_default,
		QResizeObserver: QResizeObserver_default,
		SpinnerFixed: SpinnerFixed_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		back: {
			type: Object,
			default: void 0
		},
		backDirectRoute: {
			type: Object,
			default: void 0
		},
		collapseOverlayWithLeftSidebar: {
			type: Boolean,
			default: false
		},
		contentClass: {
			type: [
				Array,
				Object,
				String
			],
			default: ""
		},
		ignoreShowRightSidebar: {
			type: Boolean,
			default: false
		},
		headerNavigationItems: {
			type: Array,
			default: () => []
		},
		groupedHeaderNavigationItems: {
			type: Array,
			default: () => []
		},
		groupedHeaderNavigationLabel: {
			type: String,
			default: ""
		},
		overlay: {
			type: Boolean,
			default: false
		},
		pageClass: {
			type: [
				Array,
				Object,
				String
			],
			default: "q-pb-lg"
		},
		sidebarWidth: {
			type: String,
			default: "300px"
		},
		showSpinner: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		const { showLeftSidebar, showRightSidebar } = useLayout();
		const { rightPanelWidth, setRightPanelWidth } = useRightPanelSize();
		const collapse = computed(() => {
			return props.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
		});
		const onResize = ({ width }) => {
			setRightPanelWidth(width);
		};
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			collapse,
			onResize,
			rightPanelWidth,
			showRightSidebar
		};
	}
});
//#endregion
//#region src/components/MainContent.vue
var _hoisted_1$43 = ["data-automation"];
var _hoisted_2$32 = { class: "q-pr-lg" };
function _sfc_render$39(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationHeader = resolveComponent("NavigationHeader");
	const _component_QHeader = resolveComponent("QHeader");
	const _component_SpinnerFixed = resolveComponent("SpinnerFixed");
	const _component_QPage = resolveComponent("QPage");
	const _component_QDrawer = resolveComponent("QDrawer");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
		class: "main-content q-px-lg bg-grey-5",
		"data-automation": _ctx.buildId()
	}, [
		createVNode(_component_QHeader, {
			class: "bg-grey-5",
			"height-hint": "72px"
		}, {
			default: withCtx(() => [createVNode(_component_NavigationHeader, {
				back: _ctx.back,
				"back-direct-route": _ctx.backDirectRoute,
				"collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
				"data-automation": _ctx.buildId("header"),
				"grouped-navigation-items": _ctx.groupedHeaderNavigationItems,
				"grouped-navigation-label": _ctx.groupedHeaderNavigationLabel,
				"ignore-show-right-sidebar": _ctx.ignoreShowRightSidebar,
				"navigation-items": _ctx.headerNavigationItems,
				overlay: _ctx.overlay,
				"sidebar-width": _ctx.sidebarWidth,
				title: _ctx.title
			}, createSlots({ _: 2 }, [
				_ctx.$slots["actions"] ? {
					name: "actions",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "actions", {}, void 0, true)]),
					key: "0"
				} : void 0,
				_ctx.$slots["title"] ? {
					name: "title",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "title", {}, void 0, true)]),
					key: "1"
				} : void 0,
				_ctx.$slots["append-title"] ? {
					name: "append-title",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "append-title", {}, void 0, true)]),
					key: "2"
				} : void 0,
				_ctx.$slots["append-breadcrumbs"] ? {
					name: "append-breadcrumbs",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "append-breadcrumbs", {}, void 0, true)]),
					key: "3"
				} : void 0,
				_ctx.$slots["extra"] ? {
					name: "extra",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "extra", {}, void 0, true)]),
					key: "4"
				} : void 0,
				_ctx.$slots["sub-header"] ? {
					name: "sub-header",
					fn: withCtx(() => [renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)]),
					key: "5"
				} : void 0
			]), 1032, [
				"back",
				"back-direct-route",
				"collapse-overlay-with-left-sidebar",
				"data-automation",
				"grouped-navigation-items",
				"grouped-navigation-label",
				"ignore-show-right-sidebar",
				"navigation-items",
				"overlay",
				"sidebar-width",
				"title"
			])]),
			_: 3
		}),
		_ctx.showSpinner ? (openBlock(), createBlock(_component_SpinnerFixed, {
			key: 0,
			"data-automation": _ctx.buildId("spinner")
		}, null, 8, ["data-automation"])) : createCommentVNode("", true),
		createVNode(_component_QPage, {
			class: normalizeClass(["main-content__main-block", _ctx.pageClass]),
			"data-automation": _ctx.buildId("page")
		}, {
			default: withCtx(() => [_ctx.$slots["left-content"] ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(["row no-wrap", { "min-height-inherit": !_ctx.$slots["content-bottom"] }])
			}, [createElementVNode("div", { class: normalizeClass(["main-content__left-content q-mr-lg", { "main-content__left-content--collapse": _ctx.collapse }]) }, [renderSlot(_ctx.$slots, "left-content", {}, void 0, true)], 2), createElementVNode("div", { class: normalizeClass(["main-content__content zero-min-width", _ctx.contentClass]) }, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 2)], 2)) : (openBlock(), createElementBlock("div", {
				key: 1,
				class: normalizeClass(["main-content__content", _ctx.contentClass])
			}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 2)), renderSlot(_ctx.$slots, "content-bottom", {}, void 0, true)]),
			_: 3
		}, 8, ["class", "data-automation"]),
		_ctx.$slots.sidebar ? (openBlock(), createBlock(_component_QDrawer, {
			key: 1,
			breakpoint: 0,
			class: "bg-grey-5",
			"data-automation": _ctx.buildId("drawer"),
			"model-value": _ctx.showRightSidebar,
			side: "right",
			width: _ctx.rightPanelWidth
		}, {
			default: withCtx(() => [createElementVNode("div", _hoisted_2$32, [renderSlot(_ctx.$slots, "sidebar", {}, void 0, true)])]),
			_: 3
		}, 8, [
			"data-automation",
			"model-value",
			"width"
		])) : createCommentVNode("", true),
		renderSlot(_ctx.$slots, "footer", {}, void 0, true)
	], 8, _hoisted_1$43), createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])], 64);
}
var MainContent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(MainContent_vue_vue_type_script_lang_default, [["render", _sfc_render$39], ["__scopeId", "data-v-7dc33dc5"]]);
//#endregion
//#region src/components/MultipleSelect.vue?vue&type=script&lang.ts
function isArrayOfObjects(items) {
	return items.length ? items.every((i) => Object.prototype.toString.call(i).includes("Object")) : false;
}
var MultipleSelect_vue_vue_type_script_lang_default = defineComponent({
	name: "MultipleSelect",
	components: {
		Checkbox: Checkbox_default,
		EllipsisText: EllipsisText_default,
		QChip: QChip_default,
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		RvInput: Input_default,
		RvSelect: Select_default,
		Separator: Separator_default
	},
	inheritAttrs: false,
	props: {
		allSelectedText: {
			default: "",
			type: String
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Update model with the value of the selected option instead of the whole option
		*/
		emitValue: {
			type: Boolean,
			default: false
		},
		/**
		* Adds info icon and shows the text on hover
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* A text label that will “float” up above the input field, once the field gets focus
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Must be Array; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: [
				Number,
				Object,
				String,
				Boolean
			],
			required: true
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionLabel: {
			type: String,
			default: "label"
		},
		/**
		* Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionValue: {
			type: String,
			default: "value"
		},
		/**
		* Available options that the user can select from.
		*/
		options: {
			type: [
				Number,
				Object,
				String,
				Boolean
			],
			default: () => []
		},
		/**
		* Put component in readonly mode
		*/
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		* Shows optional label after base label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Validation for the component
		*/
		validation: {
			type: Object,
			default: void 0
		},
		/**
		* Shows QChips for selected options
		*/
		withChips: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const chips = ref([]);
		const chipsWrapper = ref(null);
		const filter = ref("");
		const selectRef = ref(null);
		const wrapperWidth = ref(0);
		const allSelected = computed(() => {
			if (filteredOptions.value.every((o) => !selectedValues.value.find((v) => v[props.optionValue] === o[props.optionValue]))) return false;
			if (filteredOptions.value.every((o) => !!selectedValues.value.find((v) => v[props.optionValue] === o[props.optionValue]))) return true;
		});
		const componentWidth = computed(() => {
			return selectRef.value?.$el.offsetWidth ?? 0;
		});
		const convertedOptions = computed(() => {
			return isArrayOfObjects(props.options) ? props.options : props.options.map((o) => ({
				[props.optionLabel]: String(o),
				[props.optionValue]: o
			}));
		});
		const filteredOptions = computed(() => {
			const needle = filter.value.toLowerCase();
			return (props.withChips ? distinctByKey([...sortByKey(selectedValues.value, props.optionLabel), ...sortByKey(convertedOptions.value, props.optionLabel)], props.optionLabel) : convertedOptions.value).filter((o) => String(o[props.optionLabel]).toLowerCase().includes(needle));
		});
		const labelWidth = computed(() => {
			return componentWidth.value - 32 - 32;
		});
		const selectedValues = computed({
			get() {
				if (isArrayOfObjects(props.modelValue)) return props.modelValue;
				return props.modelValue.map((v) => {
					const option = convertedOptions.value.find((o) => o[props.optionValue] === v);
					return {
						[props.optionLabel]: option ? option[props.optionLabel] : String(v),
						[props.optionValue]: option ? option[props.optionValue] : String(v)
					};
				});
			},
			set(value) {
				const checkList = props.modelValue.length ? props.modelValue : props.options;
				chips.value = [];
				if (isArrayOfObjects(checkList) && !props.emitValue) emit("update:modelValue", value);
				else emit("update:modelValue", value.map((v) => v[props.optionValue]));
			}
		});
		const shownChipsCount = computed(() => {
			if (allSelected.value) return 0;
			const CHIP_GAP = 4;
			let chipsWidth = 17;
			for (let i = 0; i < chips.value.length; i++) {
				chipsWidth += chips.value[i].clientWidth;
				if (i > 0) chipsWidth += CHIP_GAP;
				if (wrapperWidth.value && chipsWidth > wrapperWidth.value) return i === 0 ? 1 : i;
			}
			return Number.MAX_SAFE_INTEGER;
		});
		function filterSelected(item) {
			selectedValues.value = selectedValues.value.filter((v) => v !== item);
		}
		function getRefElement(element, index) {
			if (element) chips.value[index] = element;
		}
		function onPopupHide() {
			filter.value = "";
		}
		function onToggleAll() {
			const uniqueValues = distinctByKey([...selectedValues.value, ...filteredOptions.value], props.optionValue);
			const hiddenSelectedValues = selectedValues.value.filter((v) => !filteredOptions.value.some((x) => x[props.optionValue] === v[props.optionValue]));
			selectedValues.value = allSelected.value ? hiddenSelectedValues : uniqueValues;
		}
		function resizeSelect() {
			wrapperWidth.value = chipsWrapper.value?.offsetWidth;
		}
		const resizeObserver = new ResizeObserver(resizeSelect);
		onMounted(() => {
			resizeSelect();
			if (chipsWrapper.value) resizeObserver.observe(chipsWrapper.value);
		});
		onUnmounted(() => {
			resizeObserver.disconnect();
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			allSelected,
			chips,
			chipsWrapper,
			componentWidth,
			filter,
			filteredOptions,
			filterSelected,
			getRefElement,
			labelWidth,
			onPopupHide,
			onToggleAll,
			selectedValues,
			selectRef,
			shownChipsCount,
			t
		};
	}
});
//#endregion
//#region src/components/MultipleSelect.vue
var _hoisted_1$42 = { class: "multiple-select__no-items q-ml-md" };
var _hoisted_2$31 = ["data-automation"];
var _hoisted_3$25 = ["data-automation"];
function _sfc_render$38(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItem = resolveComponent("QItem");
	const _component_Separator = resolveComponent("Separator");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_QChip = resolveComponent("QChip");
	const _component_RvSelect = resolveComponent("RvSelect");
	return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.dataAttrs, {
		ref: "selectRef",
		modelValue: _ctx.selectedValues,
		"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.selectedValues = $event),
		class: ["multiple-select", _ctx.$props.class],
		"data-automation": _ctx.buildId(),
		disable: _ctx.disable,
		"info-text": _ctx.infoText,
		label: _ctx.label,
		multiple: "",
		"option-label": _ctx.optionLabel,
		"option-value": _ctx.optionValue,
		"optional-label": _ctx.optionalLabel,
		options: _ctx.filteredOptions,
		readonly: _ctx.readonly,
		"show-optional-label": _ctx.showOptionalLabel,
		validation: _ctx.validation,
		onOnPopupHide: _ctx.onPopupHide
	}), createSlots({ _: 2 }, [
		_ctx.withChips ? {
			name: "option",
			fn: withCtx(({ index, itemProps, opt, selected, toggleOption }) => [createVNode(_component_QItem, mergeProps({ "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}`) }, itemProps), {
				default: withCtx(() => [createVNode(_component_QItemSection, {
					class: "q-pr-sm",
					side: ""
				}, {
					default: withCtx(() => [createVNode(_component_Checkbox, {
						"data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__checkbox`),
						dense: "",
						"model-value": selected,
						"onUpdate:modelValue": ($event) => toggleOption(opt)
					}, null, 8, [
						"data-automation",
						"model-value",
						"onUpdate:modelValue"
					])]),
					_: 2
				}, 1024), createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
					default: withCtx(() => [createVNode(_component_QItemLabel, { class: "q-item__label" }, {
						default: withCtx(() => [createVNode(_component_EllipsisText, {
							"data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__label`),
							style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
							text: opt[_ctx.optionLabel]
						}, null, 8, [
							"data-automation",
							"style",
							"text"
						])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040, ["data-automation"]), selected && index === _ctx.modelValue.length - 1 ? (openBlock(), createBlock(_component_Separator, { key: 0 })) : createCommentVNode("", true)]),
			key: "0"
		} : {
			name: "option",
			fn: withCtx(({ itemProps, opt, selected, toggleOption }) => [createVNode(_component_QItem, mergeProps({ "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}`) }, itemProps), {
				default: withCtx(() => [createVNode(_component_QItemSection, {
					class: "q-pr-sm",
					side: ""
				}, {
					default: withCtx(() => [createVNode(_component_Checkbox, {
						"data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__checkbox`),
						dense: "",
						"model-value": selected,
						"onUpdate:modelValue": ($event) => toggleOption(opt)
					}, null, 8, [
						"data-automation",
						"model-value",
						"onUpdate:modelValue"
					])]),
					_: 2
				}, 1024), createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
					default: withCtx(() => [createVNode(_component_QItemLabel, { class: "q-item__label" }, {
						default: withCtx(() => [createVNode(_component_EllipsisText, {
							"data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__label`),
							style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
							text: opt[_ctx.optionLabel] || opt
						}, null, 8, [
							"data-automation",
							"style",
							"text"
						])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1040, ["data-automation"])]),
			key: "1"
		},
		_ctx.withChips ? {
			name: "no-option",
			fn: withCtx(() => [createVNode(_component_RvInput, {
				modelValue: _ctx.filter,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filter = $event),
				autofocus: "",
				class: "multiple-select__search-input",
				"data-automation": _ctx.buildId("chips"),
				icon: "search",
				placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
				square: "",
				style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
			}, {
				prepend: withCtx(() => [createVNode(_component_QIcon, {
					class: "q-ml-xs q-pr-sm",
					color: "black-1",
					name: "search",
					size: "18px"
				})]),
				_: 1
			}, 8, [
				"modelValue",
				"data-automation",
				"placeholder",
				"style"
			]), createElementVNode("div", _hoisted_1$42, toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)]),
			key: "2"
		} : {
			name: "no-option",
			fn: withCtx(() => [createVNode(_component_QItem, { "data-automation": _ctx.buildId("no-items") }, {
				default: withCtx(() => [createVNode(_component_QItemSection, { class: "text-grey" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)]),
					_: 1
				})]),
				_: 1
			}, 8, ["data-automation"])]),
			key: "3"
		},
		_ctx.withChips ? {
			name: "selected",
			fn: withCtx(() => [
				_ctx.allSelected ? (openBlock(), createBlock(_component_EllipsisText, {
					key: 0,
					class: "text-grey-1",
					"data-automation": _ctx.buildId("selectAll__label"),
					text: _ctx.allSelectedText || _ctx.$t("rvai-base.components.multipleSelect.allItemsSelected")
				}, null, 8, ["data-automation", "text"])) : createCommentVNode("", true),
				createElementVNode("div", {
					ref: "chipsWrapper",
					class: normalizeClass(["row no-wrap full-width overflow-hidden multiple-select__chips-container", { "multiple-select__chips-container--multiple": _ctx.selectedValues.length > 1 }])
				}, [!_ctx.allSelected ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.selectedValues, (item, i) => {
					return openBlock(), createElementBlock("div", {
						key: item[_ctx.optionValue],
						ref_for: true,
						ref: (el) => _ctx.getRefElement(el, i),
						class: normalizeClass(["multiple-select__chip-container", {
							"multiple-select__chip-container--dots": i + 1 === _ctx.shownChipsCount && _ctx.selectedValues.length > 1,
							"hide": i + 1 > _ctx.shownChipsCount
						}]),
						"data-automation": _ctx.buildId(`item-selected-${i}`)
					}, [createVNode(_component_QChip, { outline: "" }, {
						default: withCtx(() => [createVNode(_component_EllipsisText, null, {
							default: withCtx(() => [createTextVNode(toDisplayString(item[_ctx.optionLabel]), 1)]),
							_: 2
						}, 1024), createVNode(_component_QIcon, {
							class: "q-ml-xs",
							name: "mdi-close",
							onClick: withModifiers(($event) => _ctx.filterSelected(item), ["prevent", "stop"])
						}, null, 8, ["onClick"])]),
						_: 2
					}, 1024)], 10, _hoisted_2$31);
				}), 128)) : createCommentVNode("", true)], 2),
				!_ctx.selectedValues.length ? (openBlock(), createBlock(_component_EllipsisText, {
					key: 1,
					class: "text-grey-1",
					"data-automation": _ctx.buildId("selectOption"),
					text: _ctx.t("rvai-base.components.multipleSelect.selectOption")
				}, null, 8, ["data-automation", "text"])) : createCommentVNode("", true)
			]),
			key: "4"
		} : void 0,
		_ctx.withChips ? {
			name: "append",
			fn: withCtx(() => [_ctx.selectedValues.length ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "multiple-select__chip-container",
				"data-automation": _ctx.buildId("selected")
			}, [createVNode(_component_QChip, { outline: "" }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.selectedValues.length) + " ", 1), createVNode(_component_QIcon, {
					class: "q-ml-xs",
					name: "mdi-close",
					onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.selectedValues = [], ["prevent", "stop"]))
				})]),
				_: 1
			})], 8, _hoisted_3$25)) : createCommentVNode("", true)]),
			key: "5"
		} : void 0,
		_ctx.withChips ? {
			name: "before-options",
			fn: withCtx(() => [
				createVNode(_component_RvInput, {
					modelValue: _ctx.filter,
					"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.filter = $event),
					autofocus: "",
					class: "multiple-select__search-input",
					"data-automation": _ctx.buildId("input-search"),
					icon: "search",
					placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
					square: "",
					style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
				}, {
					prepend: withCtx(() => [createVNode(_component_QIcon, {
						class: "q-ml-xs q-pr-sm",
						color: "black-1",
						name: "search",
						size: "18px"
					})]),
					_: 1
				}, 8, [
					"modelValue",
					"data-automation",
					"placeholder",
					"style"
				]),
				createVNode(_component_QItem, {
					clickable: "",
					"data-automation": _ctx.buildId("selectAll"),
					onClick: _ctx.onToggleAll
				}, {
					default: withCtx(() => [createVNode(_component_QItemSection, {
						class: "q-pr-sm",
						side: ""
					}, {
						default: withCtx(() => [createVNode(_component_Checkbox, {
							"data-automation": _ctx.buildId("selectAll__checkbox"),
							dense: "",
							"model-value": _ctx.allSelected,
							style: { "pointer-events": "none" }
						}, null, 8, ["data-automation", "model-value"])]),
						_: 1
					}), createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
						default: withCtx(() => [createVNode(_component_QItemLabel, { class: "q-item__label" }, {
							default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.selectAll")), 1)]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				}, 8, ["data-automation", "onClick"]),
				createVNode(_component_Separator, { color: "grey-3" })
			]),
			key: "6"
		} : void 0
	]), 1040, [
		"modelValue",
		"class",
		"data-automation",
		"disable",
		"info-text",
		"label",
		"option-label",
		"option-value",
		"optional-label",
		"options",
		"readonly",
		"show-optional-label",
		"validation",
		"onOnPopupHide"
	]);
}
var MultipleSelect_default = /*#__PURE__*/ _plugin_vue_export_helper_default(MultipleSelect_vue_vue_type_script_lang_default, [["render", _sfc_render$38], ["__scopeId", "data-v-891c741f"]]);
//#endregion
//#region src/components/NavigationBarLink.vue?vue&type=script&lang.ts
var NavigationBarLink_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationBarLink",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QItem: QItem_default,
		RouterLink,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		alwaysVisible: {
			type: Boolean,
			default: false
		},
		collapsedNavigationbar: {
			type: Boolean,
			required: true
		},
		item: {
			type: Object,
			required: true
		},
		menu: {
			type: Boolean,
			default: false
		},
		transitionDuration: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/NavigationBarLink.vue
var _hoisted_1$41 = [
	"data-automation",
	"href",
	"onClick"
];
var _hoisted_2$30 = { key: 0 };
function _sfc_render$37(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QItem = resolveComponent("QItem");
	const _component_RouterLink = resolveComponent("RouterLink");
	return openBlock(), createBlock(_component_RouterLink, {
		custom: "",
		to: _ctx.item.to
	}, {
		default: withCtx(({ href, navigate, isExactActive }) => [createVNode(_component_QItem, {
			class: normalizeClass(["navigation-item q-pa-none", { "navigation-item--active": isExactActive }]),
			clickable: "",
			"data-automation": _ctx.buildId()
		}, {
			default: withCtx(() => [createElementVNode("a", {
				class: normalizeClass(["navigation q-py-sm q-px-lg row no-wrap items-center full-width", { "navigation--menu": _ctx.menu }]),
				"data-automation": _ctx.buildId("link"),
				href,
				onClick: withModifiers(navigate, ["stop"])
			}, [!_ctx.menu ? (openBlock(), createElementBlock("div", _hoisted_2$30, [_ctx.item.icon ? (openBlock(), createBlock(_component_QIcon, {
				key: 0,
				name: _ctx.item.icon,
				size: "1.5rem"
			}, null, 8, ["name"])) : createCommentVNode("", true), _ctx.item.tooltip && _ctx.collapsedNavigationbar ? (openBlock(), createBlock(_component_Tooltip, {
				key: 1,
				anchor: "center left",
				arrow: "left",
				"data-automation": _ctx.buildId("tooltip"),
				offset: [-40, 0],
				self: "center left"
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.item.tooltip), 1)]),
				_: 1
			}, 8, ["data-automation"])) : createCommentVNode("", true)])) : createCommentVNode("", true), createVNode(_component_EllipsisText, {
				class: normalizeClass(["navigation__label q-ml-lg text-subtitle3", { "q-mr-lg navigation__label--hidden": !_ctx.alwaysVisible && _ctx.collapsedNavigationbar }]),
				"data-automation": _ctx.buildId("label"),
				style: normalizeStyle({
					"--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
					"--transition-delay": `${_ctx.transitionDuration ? Math.max(_ctx.transitionDuration, 300) : 150}ms`
				}),
				text: _ctx.item.label
			}, null, 8, [
				"class",
				"data-automation",
				"style",
				"text"
			])], 10, _hoisted_1$41)]),
			_: 2
		}, 1032, ["class", "data-automation"])]),
		_: 1
	}, 8, ["to"]);
}
var NavigationBarLink_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationBarLink_vue_vue_type_script_lang_default, [["render", _sfc_render$37], ["__scopeId", "data-v-f4ebd805"]]);
//#endregion
//#region src/components/NavigationBarTree.vue?vue&type=script&lang.ts
var itemHeight = 40;
function scrollAreaHeight(items) {
	return items * itemHeight;
}
var NavigationBarTree_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationBarTree",
	components: {
		ExpansionList: ExpansionList_default,
		NavigationBarLink: NavigationBarLink_default,
		QExpansionItem: QExpansionItem_default,
		QItem: QItem_default,
		QList: QList_default,
		QMenu: QMenu_default,
		QSkeleton: QSkeleton_default,
		ScrollArea: ScrollArea_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		collapsedNavigationbar: {
			type: Boolean,
			required: true
		},
		item: {
			type: Object,
			required: true
		},
		transitionDuration: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const { collapsed, toggleCollapsed } = useCollapsed(props.item.label, !props.item.defaultOpen);
		const { currentRoute } = useRouter();
		const showMenu = ref(false);
		const labelClass = computed(() => `ei-${kebabCase(props.item.label)}`);
		const items = computed(() => toValue(props.item.items) ?? []);
		const isActivePath = computed(() => items.value.some((v) => v.to?.name === currentRoute.value.name));
		function toggleExpand() {
			if (props.collapsedNavigationbar) showMenu.value = true;
			else {
				showMenu.value = false;
				toggleCollapsed();
			}
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			collapsed,
			isActivePath,
			items,
			labelClass,
			scrollAreaHeight,
			showMenu,
			toggleExpand
		};
	}
});
//#endregion
//#region src/components/NavigationBarTree.vue
var _hoisted_1$40 = { class: "row items-center q-ml-lg text-subtitle3 text-primary" };
function _sfc_render$36(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QSkeleton = resolveComponent("QSkeleton");
	const _component_QItem = resolveComponent("QItem");
	const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_QList = resolveComponent("QList");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_ExpansionList = resolveComponent("ExpansionList");
	const _component_QExpansionItem = resolveComponent("QExpansionItem");
	return openBlock(), createBlock(_component_QExpansionItem, {
		class: normalizeClass([
			"expand-block",
			"text-subtitle3",
			_ctx.labelClass,
			_ctx.showMenu && "active",
			_ctx.collapsedNavigationbar && "expand-block--hidden"
		]),
		"data-automation": _ctx.buildId(),
		"exact-active-class": "expand-block--active",
		"expand-icon": _ctx.items.length || _ctx.item.loading ? "mdi-chevron-down" : "none",
		icon: _ctx.item.icon,
		label: _ctx.item.label,
		"model-value": !_ctx.collapsed,
		style: normalizeStyle({
			"--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
			"--transition-delay": `${Math.max(_ctx.transitionDuration, 300)}ms`
		}),
		to: _ctx.item.to,
		"onUpdate:modelValue": _ctx.toggleExpand
	}, {
		default: withCtx(() => [_ctx.item.tooltip && _ctx.collapsedNavigationbar && !_ctx.showMenu ? (openBlock(), createBlock(_component_Tooltip, {
			key: 0,
			anchor: "center left",
			arrow: "left",
			"data-automation": _ctx.buildId("tooltip"),
			offset: [-40, 0],
			self: "center left",
			target: `.${_ctx.labelClass} .q-icon`
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.item.tooltip), 1)]),
			_: 1
		}, 8, ["data-automation", "target"])) : createCommentVNode("", true), _ctx.item.loading ? (openBlock(), createBlock(_component_QSkeleton, {
			key: 1,
			class: "q-ml-lg q-mr-md",
			"data-automation": _ctx.buildId("skeleton"),
			square: ""
		}, null, 8, ["data-automation"])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [createVNode(_component_QMenu, {
			modelValue: _ctx.showMenu,
			"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.showMenu = $event),
			anchor: "center right",
			class: normalizeClass(["no-scroll", _ctx.labelClass]),
			self: "top left",
			style: { "width": "220px" },
			target: `.${_ctx.labelClass} .q-icon`
		}, {
			default: withCtx(() => [createVNode(_component_QList, null, {
				default: withCtx(() => [createVNode(_component_QItem, { class: "menu-title q-pa-none bg-white" }, {
					default: withCtx(() => [createElementVNode("div", _hoisted_1$40, toDisplayString(_ctx.item.label), 1)]),
					_: 1
				}), createVNode(_component_ScrollArea, {
					"no-horizontal": "",
					style: normalizeStyle({
						height: `${_ctx.scrollAreaHeight(_ctx.items.length)}px`,
						maxHeight: "65vh"
					})
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (linkItem) => {
						return openBlock(), createBlock(_component_NavigationBarLink, {
							key: linkItem.label,
							"always-visible": "",
							"collapsed-navigationbar": _ctx.collapsedNavigationbar,
							"data-automation": _ctx.buildId(`item-${linkItem.label}`),
							item: linkItem,
							menu: ""
						}, null, 8, [
							"collapsed-navigationbar",
							"data-automation",
							"item"
						]);
					}), 128))]),
					_: 1
				}, 8, ["style"])]),
				_: 1
			})]),
			_: 1
		}, 8, [
			"modelValue",
			"class",
			"target"
		]), createVNode(_component_ExpansionList, {
			class: "expand-block__list",
			"data-automation": _ctx.buildId("subitems"),
			"expansion-action-class": "expand-block__actions",
			items: _ctx.items,
			limit: _ctx.item.maxItems ?? Number.MAX_SAFE_INTEGER
		}, {
			default: withCtx(({ item: linkItem }) => [createVNode(_component_NavigationBarLink, {
				"always-visible": "",
				"collapsed-navigationbar": _ctx.collapsedNavigationbar,
				"data-automation": _ctx.buildId("subitem-link"),
				item: linkItem
			}, null, 8, [
				"collapsed-navigationbar",
				"data-automation",
				"item"
			])]),
			_: 1
		}, 8, [
			"data-automation",
			"items",
			"limit"
		])], 64))]),
		_: 1
	}, 8, [
		"class",
		"data-automation",
		"expand-icon",
		"icon",
		"label",
		"model-value",
		"style",
		"to",
		"onUpdate:modelValue"
	]);
}
var NavigationBarTree_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationBarTree_vue_vue_type_script_lang_default, [["render", _sfc_render$36], ["__scopeId", "data-v-c496fc76"]]);
//#endregion
//#region src/components/NavigationBar.vue?vue&type=script&lang.ts
var NavigationBar_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationBar",
	components: {
		Logo: Logo_default,
		NavigationBarLink: NavigationBarLink_default,
		NavigationBarTree: NavigationBarTree_default,
		QIcon: QIcon_default,
		QList: QList_default,
		QSpace: QSpace_default,
		RouterLink,
		RvButton: Button_default,
		ScrollArea: ScrollArea_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		helpUrl: {
			type: String,
			default: void 0
		},
		homeRoute: {
			type: [Object, String],
			default: void 0
		},
		items: {
			type: Array,
			required: true
		},
		overlay: {
			type: Boolean,
			default: false
		},
		showClose: {
			type: Boolean,
			default: false
		},
		showToggle: {
			type: Boolean,
			default: false
		}
	},
	emits: ["close-overlay"],
	setup(props) {
		const { t } = useI18n();
		const { logoAlignClasses } = useLogo();
		const { collapsedNavigationbar, collapsedNavigationbarAfterAnimation, isSidebarAnimationInprogress, toggleNavigationBar } = useLayout();
		const { currentRoute } = useRouter();
		const { navigation } = useOptionsReadOnly();
		const isCollapsed = computed(() => {
			return !props.overlay && !!collapsedNavigationbar.value;
		});
		const navigationComponent = computed(() => navigation.component);
		const navigationBarItems = computed(() => {
			return toValue(props.items).filter((item) => item?.available !== false).map((v) => {
				const item = v;
				if ("items" in item) {
					const items = toValue(item.items)?.filter((sub) => sub.available !== false);
					return {
						...item,
						items: items?.length ? items : void 0
					};
				} else return item;
			}).filter((item) => item.to || "items" in item && item.items);
		});
		function onToggle() {
			if (isSidebarAnimationInprogress.value) return;
			toggleNavigationBar();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			collapsedNavigationbarAfterAnimation,
			currentRoute,
			isCollapsed,
			logoAlignClasses,
			navigationBarItems,
			navigationComponent,
			onToggle,
			t,
			toggleNavigationBar,
			transitionDuration: navigation.delayOnSidebarToggle
		};
	}
});
//#endregion
//#region src/components/NavigationBar.vue
var _hoisted_1$39 = ["data-automation"];
var _hoisted_2$29 = { class: "navigation-bar__header row items-center" };
var _hoisted_3$24 = { class: "navigation-bar__header-item row no-wrap items-center" };
var _hoisted_4$16 = { class: "navigation-bar__icon" };
var _hoisted_5$13 = { class: "navigation-bar__icon" };
var _hoisted_6$8 = ["data-automation"];
var _hoisted_7$6 = ["data-automation"];
var _hoisted_8$3 = ["href"];
var _hoisted_9$2 = { class: "navigation-bar__label text-subtitle3" };
function _sfc_render$35(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Logo = resolveComponent("Logo");
	const _component_NavigationBarTree = resolveComponent("NavigationBarTree");
	const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
	const _component_QList = resolveComponent("QList");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createElementBlock("div", {
		class: "navigation-bar column no-wrap bg-white full-height",
		"data-automation": _ctx.buildId(),
		style: normalizeStyle({
			"--logo-transition": `opacity ${_ctx.transitionDuration ?? 200}ms ease-out`,
			"--transition-delay": `${_ctx.transitionDuration && _ctx.transitionDuration > 150 ? 0 : 150}ms`
		})
	}, [createElementVNode("div", _hoisted_2$29, [createElementVNode("div", _hoisted_3$24, [
		createElementVNode("div", _hoisted_4$16, [!_ctx.overlay || _ctx.showToggle ? (openBlock(), createBlock(_component_RvButton, {
			key: 0,
			class: "no-padding",
			color: "black-1",
			"data-automation": _ctx.buildId("menu"),
			icon: "mdi-menu",
			tertiary: "",
			onClick: _ctx.onToggle
		}, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)]),
		(openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
			class: normalizeClass(["navigation-bar__logo-wrapper q-py-none q-px-lg", [_ctx.logoAlignClasses, { "navigation-bar__logo-wrapper--hidden": _ctx.isCollapsed }]]),
			"data-automation": _ctx.buildId("link"),
			to: _ctx.homeRoute
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "logo", {}, () => [createVNode(_component_Logo, {
				class: "navigation-bar__logo",
				"data-automation": _ctx.buildId("logo"),
				name: "regular"
			}, null, 8, ["data-automation"])], true)]),
			_: 3
		}, 8, [
			"class",
			"data-automation",
			"to"
		])),
		createElementVNode("div", _hoisted_5$13, [_ctx.showClose && _ctx.overlay ? (openBlock(), createBlock(_component_RvButton, {
			key: 0,
			class: "no-padding",
			color: "black-1",
			"data-automation": _ctx.buildId("close"),
			icon: "mdi-close",
			tertiary: "",
			onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close-overlay"))
		}, null, 8, ["data-automation"])) : createCommentVNode("", true)])
	])]), _ctx.navigationComponent ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.navigationComponent), {
		key: 0,
		collapsed: _ctx.isCollapsed,
		"collapsed-after-animation": _ctx.collapsedNavigationbarAfterAnimation,
		"help-url": _ctx.helpUrl,
		items: _ctx.items
	}, null, 8, [
		"collapsed",
		"collapsed-after-animation",
		"help-url",
		"items"
	])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(_component_ScrollArea, {
		class: "navigation-bar__content fit",
		"data-automation": _ctx.buildId("content"),
		"no-horizontal": ""
	}, {
		default: withCtx(() => [createVNode(_component_QList, { class: normalizeClass({ "navigation-bar__list--active": _ctx.isCollapsed }) }, {
			default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationBarItems, (item) => {
				return openBlock(), createElementBlock(Fragment, { key: item.label }, ["items" in item ? (openBlock(), createBlock(_component_NavigationBarTree, {
					key: 0,
					"collapsed-navigationbar": _ctx.isCollapsed,
					"data-automation": _ctx.buildId(`item-tree-${item.label}`),
					item,
					"transition-duration": _ctx.transitionDuration
				}, null, 8, [
					"collapsed-navigationbar",
					"data-automation",
					"item",
					"transition-duration"
				])) : (openBlock(), createBlock(_component_NavigationBarLink, {
					key: 1,
					"collapsed-navigationbar": _ctx.isCollapsed,
					"data-automation": _ctx.buildId(`item-link-${item.label}`),
					item,
					"transition-duration": _ctx.transitionDuration
				}, null, 8, [
					"collapsed-navigationbar",
					"data-automation",
					"item",
					"transition-duration"
				]))], 64);
			}), 128))]),
			_: 1
		}, 8, ["class"])]),
		_: 1
	}, 8, ["data-automation"]), _ctx.helpUrl ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "navigation-bar__footer row items-center",
		"data-automation": _ctx.buildId("footer")
	}, [createElementVNode("div", { "data-automation": _ctx.buildId("help") }, [createElementVNode("a", {
		class: "navigation-bar__item row no-wrap items-center",
		href: _ctx.helpUrl,
		target: "_blank"
	}, [createVNode(_component_QIcon, {
		class: "navigation-bar__icon",
		name: "mdi-help-circle",
		size: "1.5rem"
	}), createElementVNode("div", _hoisted_9$2, toDisplayString(_ctx.t("rvai-base.general.help.title")), 1)], 8, _hoisted_8$3), createVNode(_component_Tooltip, {
		anchor: "center right",
		arrow: "left",
		"data-automation": _ctx.buildId("help__tooltip"),
		self: "center left"
	}, {
		default: withCtx(() => [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.help.hint")), 1)]),
		_: 1
	}, 8, ["data-automation"])], 8, _hoisted_7$6)], 8, _hoisted_6$8)) : createCommentVNode("", true)], 64))], 12, _hoisted_1$39);
}
var NavigationBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationBar_vue_vue_type_script_lang_default, [["render", _sfc_render$35], ["__scopeId", "data-v-efafead8"]]);
//#endregion
//#region src/components/NavigationBarOverlay.vue?vue&type=script&lang.ts
var NavigationBarOverlay_vue_vue_type_script_lang_default = defineComponent({
	name: "NavigationBarOverlay",
	components: { NavigationBar: NavigationBar_default },
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		items: {
			type: Array,
			required: true
		}
	},
	setup(props) {
		const { showOverlay, toggleShowOverlay } = useLayout();
		const overlayRef = ref(null);
		function closeOverlay() {
			toggleShowOverlay(false);
		}
		onMounted(() => {
			toggleShowOverlay(false);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			closeOverlay,
			overlayRef,
			showOverlay
		};
	}
});
//#endregion
//#region src/components/NavigationBarOverlay.vue
var _hoisted_1$38 = ["data-automation"];
function _sfc_render$34(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationBar = resolveComponent("NavigationBar");
	return withDirectives((openBlock(), createElementBlock("div", {
		ref: "overlayRef",
		class: "navigation-bar-overlay",
		"data-automation": _ctx.buildId()
	}, [createVNode(_component_NavigationBar, mergeProps(_ctx.$attrs, {
		"data-automation": _ctx.buildId("navigationBar"),
		items: _ctx.items,
		overlay: "",
		"show-close": "",
		onCloseOverlay: _ctx.closeOverlay
	}), null, 16, [
		"data-automation",
		"items",
		"onCloseOverlay"
	])], 8, _hoisted_1$38)), [[vShow, _ctx.showOverlay]]);
}
var NavigationBarOverlay_default = /*#__PURE__*/ _plugin_vue_export_helper_default(NavigationBarOverlay_vue_vue_type_script_lang_default, [["render", _sfc_render$34], ["__scopeId", "data-v-5a0051d1"]]);
//#endregion
//#region src/components/OptionGroup.vue?vue&type=script&lang.ts
var OptionGroup_vue_vue_type_script_lang_default = defineComponent({
	name: "OptionGroup",
	components: {
		Checkbox: Checkbox_default,
		EllipsisText: EllipsisText_default,
		QIntersection: QIntersection_default,
		QSpace: QSpace_default,
		Radio: Radio_default,
		Toggle: Toggle_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Replaces `itemClass` when item is disabled.
		*/
		disabledItemClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Option item class
		*/
		itemClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* A text label above the Option Group
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionLabel: {
			type: String,
			default: "label"
		},
		/**
		* Available options that the user can select from.
		*/
		options: {
			type: Array,
			required: true
		},
		/**
		* Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
		*/
		optionValue: {
			type: String,
			default: "value"
		},
		/**
		* Put component in readonly mode
		*/
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		* Adds separator between options
		*/
		separator: {
			type: Boolean,
			default: false
		},
		/**
		* Shows select all checkbox
		*/
		showSelectAll: {
			type: Boolean,
			default: false
		},
		/**
		* Shows selector on hover
		*/
		showSelectorOnHover: {
			type: Boolean,
			default: false
		},
		/**
		* Checkboxes or radio buttons
		*/
		type: {
			type: String,
			default: "checkbox"
		},
		/**
		* Wraps each option with QIntersection
		*/
		withIntersection: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const allSelected = computed(() => {
			if (!Array.isArray(props.modelValue)) return false;
			const total = props.options.length;
			const selected = props.modelValue.length;
			if (total === 0) return false;
			if (total === selected) return true;
			if (selected) return void 0;
			return false;
		});
		function isOptionSelected(option) {
			return selected.value === option[props.optionValue] || Array.isArray(selected.value) && selected.value.includes(option[props.optionValue]);
		}
		function isSeparatorVisible(index) {
			return props.separator && index !== props.options.length - 1;
		}
		const selected = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		function toggleAllSelected(value) {
			emit("update:modelValue", value ? props.options.map((x) => x[props.optionValue]) : []);
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			allSelected,
			isOptionSelected,
			isSeparatorVisible,
			selected,
			t,
			toggleAllSelected
		};
	}
});
//#endregion
//#region src/components/OptionGroup.vue
var _hoisted_1$37 = ["data-automation"];
var _hoisted_2$28 = ["data-automation"];
var _hoisted_3$23 = ["data-automation"];
var _hoisted_4$15 = { class: "rv-option-group__item-selector row justify-center q-mr-sm" };
var _hoisted_5$12 = ["data-automation"];
function _sfc_render$33(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_Radio = resolveComponent("Radio");
	const _component_Toggle = resolveComponent("Toggle");
	return openBlock(), createElementBlock("div", {
		class: "rv-option-group column q-gutter-y-sm",
		"data-automation": _ctx.buildId()
	}, [
		_ctx.label ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["rv-option-group__label row no-wrap items-center full-width", { "rv-option-group__label--disable": _ctx.disable }]),
			"data-automation": _ctx.buildId("label")
		}, [createVNode(_component_EllipsisText, {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("label__text")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
			_: 1
		}, 8, ["data-automation"])], 10, _hoisted_2$28)) : createCommentVNode("", true),
		_ctx.showSelectAll && _ctx.type === "checkbox" ? (openBlock(), createElementBlock("label", {
			key: 1,
			class: normalizeClass(["rv-option-group__item row no-wrap", { "cursor-pointer": !_ctx.disable }]),
			"data-automation": _ctx.buildId("option-select-all")
		}, [createElementVNode("div", _hoisted_4$15, [createVNode(_component_Checkbox, {
			"data-automation": _ctx.buildId("selectAll"),
			dense: "",
			disable: _ctx.disable,
			"model-value": _ctx.allSelected,
			"onUpdate:modelValue": _ctx.toggleAllSelected
		}, null, 8, [
			"data-automation",
			"disable",
			"model-value",
			"onUpdate:modelValue"
		])]), createElementVNode("div", { class: normalizeClass(["rv-option-group__item-label row no-wrap full-width", {
			"border-bottom q-pb-sm": _ctx.separator,
			"rv-option-group__item-label--disable": _ctx.disable
		}]) }, [
			createVNode(_component_EllipsisText, {
				class: normalizeClass(["rv-option-group__text zero-min-width", [_ctx.disable && _ctx.disabledItemClass != null ? _ctx.disabledItemClass : _ctx.itemClass, { "rv-option-group__item-label--disable": _ctx.disable }]]),
				"data-automation": _ctx.buildId("selectAll__label"),
				text: _ctx.t("rvai-base.general.actions.selectAll")
			}, null, 8, [
				"class",
				"data-automation",
				"text"
			]),
			createVNode(_component_QSpace),
			_ctx.$slots["select-all-actions"] ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "q-ml-sm",
				"data-automation": _ctx.buildId("select-all-actions")
			}, [renderSlot(_ctx.$slots, "select-all-actions", {}, void 0, true)], 8, _hoisted_5$12)) : createCommentVNode("", true)
		], 2)], 10, _hoisted_3$23)) : createCommentVNode("", true),
		renderSlot(_ctx.$slots, "before-options", {}, void 0, true),
		(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (opt, index) => {
			return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "label"), {
				key: opt[_ctx.optionValue],
				class: normalizeClass(["rv-option-group__item row no-wrap full-width", {
					"cursor-pointer": !_ctx.disable && !opt.disable && !_ctx.readonly,
					"rv-option-group__item-intersection": _ctx.withIntersection
				}]),
				"data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}`),
				"transition-duration": 0
			}, {
				default: withCtx(() => [createElementVNode("div", { class: normalizeClass(["rv-option-group__item-selector row justify-center q-mr-sm", {
					"rv-option-group__item-selector--toggle": _ctx.type === "toggle",
					"rv-option-group__item-selector--show-on-hover": _ctx.showSelectorOnHover && !_ctx.isOptionSelected(opt)
				}]) }, [!_ctx.readonly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.type === "checkbox" ? (openBlock(), createBlock(_component_Checkbox, {
					key: 0,
					modelValue: _ctx.selected,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selected = $event),
					"data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__checkbox`),
					dense: "",
					disable: !!(_ctx.disable || opt.disable),
					val: opt[_ctx.optionValue]
				}, null, 8, [
					"modelValue",
					"data-automation",
					"disable",
					"val"
				])) : _ctx.type === "radio" ? (openBlock(), createBlock(_component_Radio, {
					key: 1,
					modelValue: _ctx.selected,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.selected = $event),
					"data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__radio`),
					dense: "",
					disable: !!(_ctx.disable || opt.disable),
					val: opt[_ctx.optionValue]
				}, null, 8, [
					"modelValue",
					"data-automation",
					"disable",
					"val"
				])) : _ctx.type === "toggle" ? (openBlock(), createBlock(_component_Toggle, {
					key: 2,
					modelValue: _ctx.selected,
					"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.selected = $event),
					"data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__toggle`),
					disable: !!(_ctx.disable || opt.disable),
					val: opt[_ctx.optionValue]
				}, null, 8, [
					"modelValue",
					"data-automation",
					"disable",
					"val"
				])) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)], 2), createElementVNode("div", { class: normalizeClass(["rv-option-group__item-label row no-wrap items-center", [(_ctx.disable || opt.disable) && _ctx.disabledItemClass != null ? _ctx.disabledItemClass : _ctx.itemClass, {
					"border-bottom": _ctx.isSeparatorVisible(index),
					"q-pb-sm": _ctx.separator || _ctx.type === "toggle",
					"rv-option-group__item-label--disable": _ctx.disable || opt.disable,
					"rv-option-group__item-label--toggle": _ctx.type === "toggle"
				}]]) }, [renderSlot(_ctx.$slots, "label", { option: opt }, () => [
					createVNode(_component_EllipsisText, {
						class: "rv-option-group__text",
						"data-automation": _ctx.buildId("option"),
						"data-automation-value": opt[_ctx.optionValue],
						text: opt[_ctx.optionLabel]
					}, null, 8, [
						"data-automation",
						"data-automation-value",
						"text"
					]),
					createVNode(_component_QSpace),
					renderSlot(_ctx.$slots, "after-label", { option: opt }, void 0, true)
				], true)], 2)]),
				_: 2
			}, 1032, ["class", "data-automation"]);
		}), 128)),
		renderSlot(_ctx.$slots, "after-options", {}, void 0, true)
	], 8, _hoisted_1$37);
}
var OptionGroup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(OptionGroup_vue_vue_type_script_lang_default, [["render", _sfc_render$33], ["__scopeId", "data-v-6b862033"]]);
//#endregion
//#region src/components/Pagination.vue?vue&type=script&lang.ts
var Pagination_vue_vue_type_script_lang_default = defineComponent({
	name: "Bullet",
	components: {
		ActionButton: ActionButton_default,
		RvInput: Input_default,
		RvSelect: Select_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: "pagination",
			type: String
		},
		/**
		* Put navigation buttons into disabled state
		*/
		loading: {
			default: false,
			type: Boolean
		},
		/**
		* Set page size options to make it managable
		*/
		pageSizeOptions: {
			default: () => [],
			type: Array
		}
	},
	setup(props) {
		const { canNavigate, goToFirstPage, goToLastPage, goToNextPage, goToPreviousPage, hasNextPage, hasPreviousPage, newPage, onBlur, pageCount, pageSize, pageValue, setPageSize } = usePagination();
		const input = ref(null);
		const disableInput = computed(() => props.loading || !canNavigate.value);
		const disableNext = computed(() => props.loading || !hasNextPage.value);
		const disablePrevious = computed(() => props.loading || !hasPreviousPage.value);
		const inputWidth = computed(() => {
			return Math.max(String(pageCount.value).length * 8 + 16, 38);
		});
		function onEnter() {
			input.value?.blur();
		}
		function onKeyPress(e) {
			if (!/\d/g.test(e.key)) e.preventDefault();
		}
		function onGlobalKeyUp(e) {
			if (isInputElement(document.activeElement)) return;
			switch (e.key) {
				case KEY_ARROW_LEFT:
					if (hasPreviousPage.value) goToPreviousPage();
					return;
				case KEY_ARROW_RIGHT: if (hasNextPage.value) goToNextPage();
			}
		}
		onMounted(() => {
			document.addEventListener("keyup", onGlobalKeyUp, false);
			if (props.pageSizeOptions.length && !props.pageSizeOptions.includes(pageSize.value)) setPageSize(props.pageSizeOptions[0]);
		});
		onUnmounted(() => {
			document.removeEventListener("keyup", onGlobalKeyUp, false);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			disableInput,
			disableNext,
			disablePrevious,
			goToFirstPage,
			goToLastPage,
			goToNextPage,
			goToPreviousPage,
			input,
			inputWidth,
			newPage,
			onBlur,
			onEnter,
			onKeyPress,
			pageCount,
			pageSize,
			pageValue,
			setPageSize
		};
	}
});
//#endregion
//#region src/components/Pagination.vue
var _hoisted_1$36 = ["data-automation"];
var _hoisted_2$27 = ["data-automation"];
var _hoisted_3$22 = ["data-automation"];
function _sfc_render$32(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_RvSelect = resolveComponent("RvSelect");
	return openBlock(), createElementBlock("div", {
		class: "pagination row no-wrap items-center q-gutter-xs text-grey-1",
		"data-automation": _ctx.buildId(),
		style: normalizeStyle({ "--input-width": `${_ctx.inputWidth}px` })
	}, [
		createVNode(_component_ActionButton, {
			class: "pagination__first-page text-grey-1",
			"data-automation": _ctx.buildId("first-page"),
			disable: _ctx.disablePrevious,
			icon: "mdi-chevron-double-left",
			onClick: _ctx.goToFirstPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createVNode(_component_ActionButton, {
			class: "pagination__previous-page text-grey-1",
			"data-automation": _ctx.buildId("previous-page"),
			disable: _ctx.disablePrevious,
			icon: "mdi-chevron-left",
			onClick: _ctx.goToPreviousPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createElementVNode("div", {
			class: "pagination__current-page row no-wrap items-center",
			"data-automation": _ctx.buildId("current-page")
		}, [createVNode(_component_RvInput, {
			ref: "input",
			modelValue: _ctx.newPage,
			"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newPage = $event),
			class: "pagination__new-page",
			"data-automation": _ctx.buildId("page-input"),
			dense: "",
			disable: _ctx.disableInput,
			"input-class": "pagination__input text-center",
			placeholder: _ctx.pageValue,
			type: "number",
			onBlur: _ctx.onBlur,
			onKeypress: _ctx.onKeyPress,
			onKeyup: withKeys(_ctx.onEnter, ["enter"])
		}, null, 8, [
			"modelValue",
			"data-automation",
			"disable",
			"placeholder",
			"onBlur",
			"onKeypress",
			"onKeyup"
		]), createElementVNode("div", {
			class: normalizeClass(["pagination__page-count text-subtitle3 text-no-wrap q-ml-sm", { "pagination__page-count--disable": _ctx.disableInput }]),
			"data-automation": _ctx.buildId("page-count")
		}, toDisplayString(_ctx.$t("rvai-base.general.symbols.slash")) + " " + toDisplayString(_ctx.pageCount), 11, _hoisted_3$22)], 8, _hoisted_2$27),
		createVNode(_component_ActionButton, {
			class: "pagination__next-page text-grey-1",
			"data-automation": _ctx.buildId("next-page"),
			disable: _ctx.disableNext,
			icon: "mdi-chevron-right",
			onClick: _ctx.goToNextPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createVNode(_component_ActionButton, {
			class: "pagination__last-page text-grey-1",
			"data-automation": _ctx.buildId("last-page"),
			disable: _ctx.disableNext,
			icon: "mdi-chevron-double-right",
			onClick: _ctx.goToLastPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		_ctx.pageSizeOptions.length ? (openBlock(), createBlock(_component_RvSelect, {
			key: 0,
			"data-automation": _ctx.buildId("page-size"),
			"model-value": _ctx.pageSize,
			options: _ctx.pageSizeOptions,
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.setPageSize($event))
		}, null, 8, [
			"data-automation",
			"model-value",
			"options"
		])) : createCommentVNode("", true)
	], 12, _hoisted_1$36);
}
var Pagination_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Pagination_vue_vue_type_script_lang_default, [["render", _sfc_render$32], ["__scopeId", "data-v-2c33d525"]]);
//#endregion
//#region src/components/PrivacyPolicyDialog.vue?vue&type=script&lang.ts
var PrivacyPolicyDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "PrivacyPolicyDialog",
	components: {
		QCard: QCard_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "privacyPolicyDialog"
		},
		/**
		* Provide privacy policy URL to open in the iframe
		*/
		privacyPolicyUrl: {
			type: String,
			required: true
		}
	},
	emits: [...useDialogPluginComponent.emits],
	setup(props) {
		const { dialogRef, onDialogCancel, onDialogHide } = useDialogPluginComponent();
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			dialogRef,
			onCancel: onDialogCancel,
			onHide: onDialogHide
		};
	}
});
//#endregion
//#region src/components/PrivacyPolicyDialog.vue
var _hoisted_1$35 = ["src"];
function _sfc_render$31(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	const _directive_quasar_variables = resolveDirective("quasar-variables");
	return openBlock(), createBlock(_component_QDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId(),
		maximized: ""
	}, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
		default: withCtx(() => [createVNode(_component_QCard, { class: "rv-privacy-policy-dialog column no-wrap" }, {
			default: withCtx(() => [createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
				default: withCtx(() => [createVNode(_component_RvButton, {
					icon: "mdi-close",
					tertiary: "",
					onClick: _ctx.onCancel
				}, null, 8, ["onClick"])]),
				_: 1
			}), createVNode(_component_QCardSection, { class: "full-width full-height" }, {
				default: withCtx(() => [withDirectives(createElementVNode("iframe", {
					frameborder: "0",
					height: "100%",
					src: _ctx.privacyPolicyUrl,
					width: "100%"
				}, null, 8, _hoisted_1$35), [[_directive_quasar_variables]])]),
				_: 1
			})]),
			_: 1
		})]),
		_: 1
	}, 16, ["data-automation", "onHide"]);
}
var PrivacyPolicyDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PrivacyPolicyDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$31]]);
//#endregion
//#region src/components/TermsAndConditionsDialog.vue?vue&type=script&lang.ts
var TermsAndConditionsDialog_vue_vue_type_script_lang_default = defineComponent({
	name: "TermsAndConditionsDialog",
	components: {
		QCard: QCard_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		RvButton: Button_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "termsAndConditionsDialog"
		},
		/**
		* Provide rems and conditions URL to open in the iframe
		*/
		termsAndConditionsUrl: {
			type: String,
			required: true
		}
	},
	emits: [...useDialogPluginComponent.emits],
	setup(props) {
		const { dialogRef, onDialogCancel, onDialogHide } = useDialogPluginComponent();
		const { t } = useI18n();
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			dialogRef,
			onCancel: onDialogCancel,
			onHide: onDialogHide,
			t
		};
	}
});
//#endregion
//#region src/components/TermsAndConditionsDialog.vue
var _hoisted_1$34 = { class: "rv-terms-and-conditions-dialog__subtitle text-subtitle1 full-width" };
var _hoisted_2$26 = ["src"];
function _sfc_render$30(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	const _directive_quasar_variables = resolveDirective("quasar-variables");
	return openBlock(), createBlock(_component_QDialog, mergeProps({
		ref: "dialogRef",
		"data-automation": _ctx.buildId(),
		maximized: ""
	}, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
		default: withCtx(() => [createVNode(_component_QCard, { class: "rv-terms-and-conditions-dialog column no-wrap overflow-hidden" }, {
			default: withCtx(() => [
				createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
					default: withCtx(() => [createVNode(_component_RvButton, {
						icon: "mdi-close",
						tertiary: "",
						onClick: _ctx.onCancel
					}, null, 8, ["onClick"])]),
					_: 1
				}),
				createVNode(_component_QCardSection, { class: "row flex-center q-mx-lg" }, {
					default: withCtx(() => [createElementVNode("span", _hoisted_1$34, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.titles.termsAndConditions")), 1)]),
					_: 1
				}),
				createVNode(_component_QCardSection, { class: "full-width full-height q-mx-lg q-pb-none" }, {
					default: withCtx(() => [withDirectives(createElementVNode("iframe", {
						frameborder: "0",
						height: "100%",
						src: _ctx.termsAndConditionsUrl,
						width: "100%"
					}, null, 8, _hoisted_2$26), [[_directive_quasar_variables]])]),
					_: 1
				})
			]),
			_: 1
		})]),
		_: 1
	}, 16, ["data-automation", "onHide"]);
}
var TermsAndConditionsDialog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TermsAndConditionsDialog_vue_vue_type_script_lang_default, [["render", _sfc_render$30], ["__scopeId", "data-v-6ff9fdbb"]]);
//#endregion
//#region src/components/PoliciesAndLicenses.vue?vue&type=script&lang.ts
var PoliciesAndLicenses_vue_vue_type_script_lang_default = defineComponent({
	name: "PoliciesAndLicenses",
	components: { RvButton: Button_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "policiesAndLicenses"
		},
		/**
		* Provide cookies label for accept button
		*/
		cookiesAcceptBtn: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies label for reject button
		*/
		cookiesRejectBtn: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies title
		*/
		cookiesTitle: {
			type: String,
			default: void 0
		},
		/**
		* Provide cookies URL to open in the iframe
		*/
		cookiesUrl: {
			type: String,
			required: true
		},
		/**
		* Provide cookies dialog width
		*/
		cookiesWidth: {
			type: String,
			default: "420px"
		},
		/**
		* Provide privacy policy URL to open in the iframe
		*/
		privacyPolicyUrl: {
			type: String,
			required: true
		},
		/**
		* Provide rems and conditions URL to open in the iframe
		*/
		termsAndConditionsUrl: {
			type: String,
			required: true
		},
		/**
		* Provide title
		*/
		title: {
			default: void 0,
			type: String
		}
	},
	emits: ["on-title-click"],
	setup(props) {
		const { hasCookiesPolicy } = useCookiesPolicy();
		const $q = useQuasar();
		const { t } = useI18n();
		const options = [
			{
				action: onOpenCookiesDialog,
				title: t("rvai-base.policiesAndLicenses.actions.cookies.open")
			},
			{
				action: onOpenPrivacyPolicyDialog,
				title: t("rvai-base.policiesAndLicenses.actions.privacyPolicy.open")
			},
			{
				action: onOpenTermsAndConditionsDialog,
				title: t("rvai-base.policiesAndLicenses.actions.termsAndConditions.open")
			}
		];
		function onOpenCookiesDialog() {
			$q.dialog({
				component: CookiesDialog_default,
				componentProps: {
					cookiesAcceptBtn: props.cookiesAcceptBtn,
					cookiesRejectBtn: props.cookiesRejectBtn,
					cookiesTitle: props.cookiesTitle,
					cookiesUrl: props.cookiesUrl,
					cookiesWidth: props.cookiesWidth
				}
			});
		}
		function onOpenPrivacyPolicyDialog() {
			$q.dialog({
				component: PrivacyPolicyDialog_default,
				componentProps: { privacyPolicyUrl: props.privacyPolicyUrl }
			});
		}
		function onOpenTermsAndConditionsDialog() {
			$q.dialog({
				component: TermsAndConditionsDialog_default,
				componentProps: { termsAndConditionsUrl: props.termsAndConditionsUrl }
			});
		}
		onMounted(() => {
			if (!hasCookiesPolicy.value) nextTick(onOpenCookiesDialog);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			options,
			t
		};
	}
});
//#endregion
//#region src/components/PoliciesAndLicenses.vue
var _hoisted_1$33 = ["data-automation"];
var _hoisted_2$25 = { class: "text-subtitle3" };
var _hoisted_3$21 = { class: "flex flex-center full-width" };
var _hoisted_4$14 = ["onClick"];
function _sfc_render$29(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["rv-policies-and-licenses flex column items-center full-width", {
			"rv-policies-and-licenses--with-title": _ctx.title,
			"justify-center": !_ctx.title
		}]),
		"data-automation": _ctx.buildId()
	}, [_ctx.title ? (openBlock(), createBlock(_component_RvButton, {
		key: 0,
		class: "q-mt-lg",
		"data-automation": _ctx.buildId("title"),
		size: "md",
		tertiary: "",
		onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-title-click"))
	}, {
		default: withCtx(() => [createElementVNode("span", _hoisted_2$25, toDisplayString(_ctx.title), 1)]),
		_: 1
	}, 8, ["data-automation"])) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$21, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, index) => {
		return openBlock(), createElementBlock(Fragment, { key: option.title }, [createElementVNode("span", {
			class: "rv-policies-and-licenses__action text-body2",
			onClick: option.action
		}, toDisplayString(option.title), 9, _hoisted_4$14), index !== _ctx.options.length - 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.pipe")), 1)], 64)) : createCommentVNode("", true)], 64);
	}), 128))])], 10, _hoisted_1$33);
}
var PoliciesAndLicenses_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PoliciesAndLicenses_vue_vue_type_script_lang_default, [["render", _sfc_render$29], ["__scopeId", "data-v-b411e3c9"]]);
//#endregion
//#region src/components/Range.vue?vue&type=script&lang.ts
var Range_vue_vue_type_script_lang_default = defineComponent({
	name: "Range",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QRange: QRange_default,
		RvInput: Input_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Render info icon with tooltip. Can be used as an "info-text" property or as a slot
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: ""
		},
		/**
		* How many numbers show after comma for float numbers
		* @type {number}
		*/
		inputDecimals: {
			type: Number,
			default: void 0
		},
		/**
		* The text that will be shown above the input
		*/
		label: {
			type: String,
			default: ""
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Maximum value of the model; Set track's maximum value
		*/
		max: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value of the model; Set track's minimum value
		*/
		min: {
			type: Number,
			default: 0
		},
		/**
		* Label to show instead of minimum value
		*/
		minLabel: {
			type: String,
			default: ""
		},
		/**
		* Model of the component of type { min, max } (both values must be between global min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Object,
			required: true
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Shows min and max values around slider
		*/
		showMinMax: {
			type: Boolean,
			default: true
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Popup a label when user clicks/taps on the slider thumb and moves it
		*/
		showPinLabel: {
			type: Boolean,
			default: true
		},
		/**
		* Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
		*/
		step: {
			type: Number,
			default: 1
		},
		/**
		* Allow setting the values via input fields
		*/
		withInput: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const maxValueString = ref(String(props.modelValue.max));
		const minValueString = ref(String(props.modelValue.min));
		function getParsedValue(value) {
			const parsed = props.inputDecimals && value ? truncateNumber(parseFloat(value), props.inputDecimals) : roundToStep(Number(value), props.step);
			if (isNaN(parsed)) return NaN;
			if (parsed < props.min) return props.min;
			if (parsed > props.max) return props.max;
			return parsed;
		}
		function onMinInputBlur() {
			const parsed = getParsedValue(minValueString.value);
			if (isNaN(parsed)) {
				minValueString.value = String(props.modelValue.min);
				return;
			}
			const newModelValue = { ...props.modelValue };
			if (parsed > props.modelValue.max) {
				newModelValue.max = parsed;
				newModelValue.min = props.modelValue.max;
			} else newModelValue.min = parsed;
			emit("update:modelValue", newModelValue);
		}
		function onMaxInputBlur() {
			const parsed = getParsedValue(maxValueString.value);
			if (isNaN(parsed)) {
				maxValueString.value = String(props.modelValue.max);
				return;
			}
			const newModelValue = { ...props.modelValue };
			if (parsed < props.modelValue.min) {
				newModelValue.max = props.modelValue.min;
				newModelValue.min = parsed;
			} else newModelValue.max = parsed;
			emit("update:modelValue", newModelValue);
		}
		watch(() => props.modelValue, (value) => {
			minValueString.value = String(value.min);
			maxValueString.value = String(value.max);
		}, { immediate: true });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			maxValueString,
			minValueString,
			onMaxInputBlur,
			onMinInputBlur
		};
	}
});
//#endregion
//#region src/components/Range.vue
var _hoisted_1$32 = ["data-automation"];
var _hoisted_2$24 = ["data-automation"];
var _hoisted_3$20 = { class: "row no-wrap items-center full-width" };
var _hoisted_4$13 = {
	key: 0,
	class: "q-ml-xs"
};
var _hoisted_5$11 = { class: "row items-center no-wrap" };
var _hoisted_6$7 = { class: "q-mr-md col-fixed" };
var _hoisted_7$5 = { class: "q-ml-md col-fixed" };
function _sfc_render$28(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_QRange = resolveComponent("QRange");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["rv-range", { "rv-range--with-input": _ctx.withInput }],
		"data-automation": _ctx.buildId()
	}), [_ctx.label ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
		"data-automation": _ctx.buildId("label-container")
	}, [createElementVNode("span", _hoisted_3$20, [
		createVNode(_component_EllipsisText, {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("label"),
			text: _ctx.label
		}, null, 8, ["data-automation", "text"]),
		_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$13, toDisplayString(_ctx.optionalLabel || _ctx.$t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
		_ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "q-ml-xs info-icon",
			color: "black-1",
			"data-automation": _ctx.buildId("icon-info"),
			name: "info",
			size: "16px"
		}, {
			default: withCtx(() => [createVNode(_component_Tooltip, {
				anchor: "top middle",
				class: normalizeClass(_ctx.infoTextClass),
				"data-automation": _ctx.buildId("icon-info__tooltip"),
				self: "bottom middle"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
				_: 3
			}, 8, ["class", "data-automation"])]),
			_: 3
		}, 8, ["data-automation"])) : createCommentVNode("", true)
	])], 10, _hoisted_2$24)) : createCommentVNode("", true), createElementVNode("div", _hoisted_5$11, [
		createElementVNode("div", _hoisted_6$7, [_ctx.withInput ? (openBlock(), createBlock(_component_RvInput, {
			key: 0,
			modelValue: _ctx.minValueString,
			"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.minValueString = $event),
			class: "rv-slider__input",
			"data-automation": _ctx.buildId("min-input"),
			disable: _ctx.disable,
			"item-aligned": "center",
			"show-error": false,
			"show-error-message": false,
			"show-valid": false,
			onBlur: _ctx.onMinInputBlur,
			onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
		}, null, 8, [
			"modelValue",
			"data-automation",
			"disable",
			"onBlur"
		])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
			key: 1,
			class: "rv-range__limit text-grey-1",
			"data-automation": _ctx.buildId("min")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)]),
			_: 1
		}, 8, ["data-automation"])) : createCommentVNode("", true)]),
		createVNode(_component_QRange, {
			class: normalizeClass(_ctx.$props.class),
			"data-automation": _ctx.buildId("slider"),
			disable: _ctx.disable,
			label: _ctx.showPinLabel,
			max: _ctx.max,
			min: _ctx.min,
			"model-value": _ctx.modelValue,
			step: _ctx.step,
			"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.$emit("update:modelValue", $event))
		}, null, 8, [
			"class",
			"data-automation",
			"disable",
			"label",
			"max",
			"min",
			"model-value",
			"step"
		]),
		createElementVNode("div", _hoisted_7$5, [_ctx.withInput ? (openBlock(), createBlock(_component_RvInput, {
			key: 0,
			modelValue: _ctx.maxValueString,
			"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.maxValueString = $event),
			class: "rv-slider__input",
			"data-automation": _ctx.buildId("max-input"),
			disable: _ctx.disable,
			"item-aligned": "center",
			"show-error": false,
			"show-error-message": false,
			"show-valid": false,
			onBlur: _ctx.onMaxInputBlur,
			onKeyup: _cache[4] || (_cache[4] = withKeys(($event) => $event.target.blur(), ["enter"]))
		}, null, 8, [
			"modelValue",
			"data-automation",
			"disable",
			"onBlur"
		])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
			key: 1,
			class: "rv-range__limit text-grey-1",
			"data-automation": _ctx.buildId("max")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.max), 1)]),
			_: 1
		}, 8, ["data-automation"])) : createCommentVNode("", true)])
	])], 16, _hoisted_1$32);
}
var Range_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Range_vue_vue_type_script_lang_default, [["render", _sfc_render$28], ["__scopeId", "data-v-3a80790d"]]);
//#endregion
//#region src/components/ScrollNavigation.vue?vue&type=script&lang.ts
var ScrollNavigation_vue_vue_type_script_lang_default = defineComponent({
	name: "ScrollNavigation",
	components: {
		CardItem: CardItem_default,
		QIcon: QIcon_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Elements to be shown as buttons
		*/
		entries: {
			required: true,
			type: Array
		},
		/**
		* Section title
		*/
		title: {
			required: true,
			type: String
		}
	},
	emits: ["on-click"],
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/ScrollNavigation.vue
var _hoisted_1$31 = ["data-automation"];
var _hoisted_2$23 = { class: "q-pl-lg q-pt-lg q-pb-md text-subtitle1" };
function _sfc_render$27(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_CardItem = resolveComponent("CardItem");
	const _component_rv_scroll_area = resolveComponent("rv-scroll-area");
	return openBlock(), createElementBlock("div", {
		class: "scroll-buttons items-start",
		"data-automation": _ctx.buildId(),
		style: normalizeStyle({ "--items": _ctx.entries.length })
	}, [createElementVNode("div", _hoisted_2$23, toDisplayString(_ctx.title), 1), createVNode(_component_rv_scroll_area, {
		class: "scroll-buttons__list",
		"data-automation": _ctx.buildId("scrollArea")
	}, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entries, (entry, index) => {
			return openBlock(), createBlock(_component_CardItem, {
				key: index,
				class: normalizeClass(["scroll-buttons__item", { "scroll-buttons__item--active": entry.active }]),
				"data-automation": _ctx.buildId(`item__${index}`),
				"hide-icon": "",
				title: entry.label,
				onClick: ($event) => _ctx.$emit("on-click", entry.to)
			}, createSlots({ _: 2 }, [entry.icon ? {
				name: "prepend",
				fn: withCtx(() => [createVNode(_component_QIcon, {
					class: "q-mr-md",
					name: entry.icon,
					size: "24px"
				}, null, 8, ["name"])]),
				key: "0"
			} : void 0]), 1032, [
				"class",
				"data-automation",
				"title",
				"onClick"
			]);
		}), 128))]),
		_: 1
	}, 8, ["data-automation"])], 12, _hoisted_1$31);
}
var ScrollNavigation_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScrollNavigation_vue_vue_type_script_lang_default, [["render", _sfc_render$27], ["__scopeId", "data-v-b1bd8d7b"]]);
//#endregion
//#region src/components/SearchInput.vue?vue&type=script&lang.ts
var __default__ = defineComponent({
	name: "SearchInput",
	components: {
		RvButton: Button_default,
		RvInput: Input_default,
		ScrollArea: ScrollArea_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Enables bottom slots ('error', 'hint', 'counter')
		*/
		bottomSlots: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Clear the input when user select a value
		* @type {boolean}
		*/
		clearOnSelect: {
			default: true,
			type: Boolean
		},
		/**
		* Items to be searched
		* @type {[string | number]}
		*/
		data: {
			required: true,
			type: Array
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			default: "searchInput",
			type: String
		},
		/**
		* Dense mode; occupies less space
		*/
		dense: {
			default: false,
			type: Boolean
		},
		/**
		* Disable input element
		*/
		disable: {
			default: false,
			type: Boolean
		},
		/**
		* Helper (hint) text which gets placed below your wrapped form component
		*/
		hint: {
			default: void 0,
			type: String
		},
		/**
		* Max height of scrollable content
		* @type {boolean}
		*/
		maxContentHeight: {
			default: 200,
			type: Number
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			required: true,
			type: String
		},
		/**
		* Text that appears in the input element when it has no value set
		*/
		placeholder: {
			default: () => useI18n().t("rvai-base.general.text.search"),
			type: String
		}
	},
	emits: ["update:modelValue", "select"],
	setup(props, { emit }) {
		const slots = useSlots();
		const { t } = useI18n();
		const inputRef = ref(null);
		const contentHeight = ref(0);
		const scrollAreaRef = ref(null);
		const selectedIndex = ref(void 0);
		const bottomSlotNames = computed(() => {
			return [
				"error",
				"hint",
				"counter"
			].filter((name) => props.bottomSlots && slots[name]);
		});
		const search = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		const contentHeightPx = computed(() => {
			return filteredData.value.length ? `${Math.min(props.maxContentHeight, contentHeight.value)}px` : "auto";
		});
		const sortedData = computed(() => {
			return props.data.toSorted((a, b) => naturalSort(a.value, b.value));
		});
		const filteredData = computed(() => {
			const needle = String(search.value).toLowerCase();
			return needle ? sortedData.value.filter((v) => v.label.toLowerCase().includes(needle) || v.value.toLowerCase().includes(needle)) : [];
		});
		function clear() {
			search.value = "";
			selectedIndex.value = void 0;
		}
		function focus() {
			inputRef.value?.input.focus();
		}
		function handleArrowKey(e) {
			e.preventDefault();
			const isKeyUp = e.key === KEY_ARROW_UP;
			selectedIndex.value = isKeyUp ? Math.max(0, (selectedIndex.value ?? 0) - 1) : Math.min(filteredData.value.length - 1, (selectedIndex.value ?? 0) + 1);
			const el = document.querySelector(`[search-input-item-index="${selectedIndex.value}"]`);
			if (!el) return;
			const offsetTop = el.offsetTop;
			const offsetBottom = offsetTop != null ? offsetTop + el.offsetHeight : 0;
			const rect = el.getBoundingClientRect();
			const visibleAreaHeight = scrollAreaRef.value?.$el.clientHeight;
			const scrollPosition = scrollAreaRef.value?.scrollAreaRef.getScrollPosition().top ?? 0;
			if (rect && offsetTop != null && offsetBottom != null && !!(isKeyUp ? offsetTop < scrollPosition : offsetBottom - scrollPosition > visibleAreaHeight)) scrollAreaRef.value?.setScrollPosition("vertical", isKeyUp ? scrollPosition - rect.height : scrollPosition + rect.height);
		}
		function handleEnter(e) {
			if (selectedIndex.value === void 0) return;
			e.preventDefault();
			emit("select", filteredData.value[selectedIndex.value]);
			if (props.clearOnSelect) clear();
		}
		const onBlur = debounce(clear, 200);
		function onKeyUp(e) {
			switch (e.key) {
				case "Esc":
				case KEY_ESCAPE:
					inputRef.value?.input.blur();
					return;
			}
			if (filteredData.value.length) switch (e.key) {
				case KEY_ARROW_UP:
				case KEY_ARROW_DOWN: return handleArrowKey(e);
				case KEY_ENTER: return handleEnter(e);
			}
		}
		function onMouseSelect(v) {
			emit("select", v);
			clear();
		}
		watch(() => inputRef.value?.focused, (focused, prev) => {
			if (focused && focused !== prev) document.addEventListener("keyup", onKeyUp);
			else document.removeEventListener("keyup", onKeyUp);
		}, { immediate: true });
		watch(filteredData, async (v) => {
			selectedIndex.value = v.length ? 0 : void 0;
			await nextTick();
			const scrollContentHeight = scrollAreaRef.value?.$el.querySelector(".search-input__list")?.clientHeight;
			if (scrollContentHeight != null) contentHeight.value = scrollContentHeight;
		}, { immediate: true });
		onUnmounted(() => {
			document.removeEventListener("keyup", onKeyUp);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			bottomSlotNames,
			clear,
			contentHeightPx,
			filteredData,
			focus,
			inputRef,
			onBlur,
			onKeyUp,
			onMouseSelect,
			scrollAreaRef,
			search,
			selectedIndex,
			t
		};
	}
});
var __injectCSSVars__ = () => {
	useCssVars((_ctx) => ({ "c0d4da8e": _ctx.contentHeightPx }));
};
var __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
	__injectCSSVars__();
	return __setup__(props, ctx);
} : __injectCSSVars__;
//#endregion
//#region src/components/SearchInput.vue
var _hoisted_1$30 = ["data-automation"];
var _hoisted_2$22 = ["data-automation"];
var _hoisted_3$19 = ["data-automation"];
var _hoisted_4$12 = ["data-automation"];
var _hoisted_5$10 = [
	"data-automation",
	"search-input-item-index",
	"onClick"
];
var _hoisted_6$6 = { class: "q-pa-xs q-pl-md" };
function _sfc_render$26(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["search-input relative-position", _ctx.$props.class],
		"data-automation": _ctx.buildId(),
		onKeyUp: _cache[1] || (_cache[1] = (...args) => _ctx.onKeyUp && _ctx.onKeyUp(...args))
	}), [createVNode(_component_RvInput, {
		ref: "inputRef",
		modelValue: _ctx.search,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.search = $event),
		"bottom-slots": _ctx.bottomSlots,
		class: "search-input__input",
		"data-automation": _ctx.buildId("input"),
		dense: _ctx.dense,
		disable: _ctx.disable,
		hint: _ctx.hint,
		icon: "search",
		placeholder: _ctx.placeholder,
		onBlur: _ctx.onBlur,
		onKeyUp: withModifiers(_ctx.onKeyUp, ["stop", "prevent"])
	}, createSlots({
		append: withCtx(() => [_ctx.search ? (openBlock(), createBlock(_component_RvButton, {
			key: 0,
			color: "black-1",
			"data-automation": _ctx.buildId("input__close-btn"),
			icon: "close",
			size: "md",
			tertiary: "",
			onClick: _ctx.clear
		}, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)]),
		_: 2
	}, [renderList(_ctx.bottomSlotNames, (name) => {
		return {
			name,
			fn: withCtx((slotData) => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)])
		};
	})]), 1032, [
		"modelValue",
		"bottom-slots",
		"data-automation",
		"dense",
		"disable",
		"hint",
		"placeholder",
		"onBlur",
		"onKeyUp"
	]), _ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "search-input__list-wrapper bg-white rounded-borders shadow-6 absolute full-width",
		"data-automation": _ctx.buildId("list")
	}, [_ctx.search && !_ctx.filteredData.length ? renderSlot(_ctx.$slots, "noSearchResult", {}, () => [createElementVNode("div", {
		class: "q-pa-xs q-pl-md",
		"data-automation": _ctx.buildId("list__no-match")
	}, toDisplayString(_ctx.t("rvai-base.components.searchInput.noMatches")), 9, _hoisted_3$19)], true, 0) : createCommentVNode("", true), createVNode(_component_ScrollArea, {
		ref: "scrollAreaRef",
		class: "full-height",
		"data-automation": _ctx.buildId("scroll"),
		"no-horizontal": ""
	}, {
		default: withCtx(() => [_ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["search-input__list rounded-borders full-height full-width", { "search-input__list--offset": _ctx.hint }]),
			"data-automation": _ctx.buildId("list")
		}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredData, (item, index) => {
			return openBlock(), createElementBlock("div", {
				key: `${item}-${index}`,
				class: normalizeClass(["search-input__list__item", { "search-input__list__item--selected": index === _ctx.selectedIndex }]),
				"data-automation": _ctx.buildId("list__item"),
				"search-input-item-index": index,
				onClick: ($event) => _ctx.onMouseSelect(item)
			}, [renderSlot(_ctx.$slots, "menuItem", { item }, () => [createElementVNode("div", _hoisted_6$6, toDisplayString(item.label), 1)], true)], 10, _hoisted_5$10);
		}), 128))], 10, _hoisted_4$12)) : createCommentVNode("", true)]),
		_: 3
	}, 8, ["data-automation"])], 8, _hoisted_2$22)) : createCommentVNode("", true)], 16, _hoisted_1$30);
}
var SearchInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(__default__, [["render", _sfc_render$26], ["__scopeId", "data-v-29167daa"]]);
//#endregion
//#region src/components/SectionMessage.vue?vue&type=script&lang.ts
var SectionMessage_vue_vue_type_script_lang_default = defineComponent({
	name: "SectionMessage",
	components: { QIcon: QIcon_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "section-message"
		},
		class: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		color: {
			default: "negative",
			type: String,
			validator: (v) => [
				"blue",
				"negative",
				"positive"
			].includes(v)
		},
		iconName: {
			default: void 0,
			type: String
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/SectionMessage.vue
var _hoisted_1$29 = ["data-automation"];
var _hoisted_2$21 = ["data-automation"];
var _hoisted_3$18 = ["data-automation"];
function _sfc_render$25(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_q_icon = resolveComponent("q-icon");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(_ctx.$props.class),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", {
		class: normalizeClass(`rounded-borders q-px-md q-py-sm flex no-wrap items-center text-white bg-${_ctx.color}`),
		"data-automation": _ctx.buildId("main")
	}, [_ctx.iconName ? (openBlock(), createBlock(_component_q_icon, {
		key: 0,
		class: "q-mr-md",
		color: "white",
		"data-automation": _ctx.buildId("icon"),
		name: _ctx.iconName,
		size: "24px"
	}, null, 8, ["data-automation", "name"])) : createCommentVNode("", true), _ctx.$slots["default"] ? (openBlock(), createElementBlock("div", {
		key: 1,
		"data-automation": _ctx.buildId("message-slot")
	}, [renderSlot(_ctx.$slots, "default")], 8, _hoisted_3$18)) : createCommentVNode("", true)], 10, _hoisted_2$21)], 10, _hoisted_1$29);
}
var SectionMessage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SectionMessage_vue_vue_type_script_lang_default, [["render", _sfc_render$25]]);
//#endregion
//#region src/components/SelectBoolean.vue?vue&type=script&lang.ts
var SelectBoolean_vue_vue_type_script_lang_default = defineComponent({
	name: "SelectBoolean",
	components: { RvSelect: Select_default },
	props: { 
	/**
	* Automation ID to easily find element in the DOM by its value
	*/
dataAutomation: {
		type: String,
		default: void 0
	} },
	setup(props) {
		const { t } = useI18n();
		const options = computed(() => {
			return [{
				label: t("rvai-base.general.text.no"),
				value: false
			}, {
				label: t("rvai-base.general.text.yes"),
				value: true
			}];
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			options
		};
	}
});
//#endregion
//#region src/components/SelectBoolean.vue
function _sfc_render$24(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvSelect = resolveComponent("RvSelect");
	return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.$attrs, {
		"data-automation": _ctx.buildId(),
		"emit-value": "",
		"map-options": "",
		options: _ctx.options
	}), null, 16, ["data-automation", "options"]);
}
var SelectBoolean_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SelectBoolean_vue_vue_type_script_lang_default, [["render", _sfc_render$24]]);
//#endregion
//#region src/components/SpinnerAbsolute.vue?vue&type=script&lang.ts
var SpinnerAbsolute_vue_vue_type_script_lang_default = defineComponent({
	name: "SpinnerAbsolute",
	components: { QSpinner: QSpinner_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "spinnerAbsolute"
		},
		/**
		* Spinner size
		*/
		size: {
			type: String,
			default: "48px"
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/SpinnerAbsolute.vue
var _hoisted_1$28 = ["data-automation"];
var _hoisted_2$20 = { class: "spinner-block__background absolute-full" };
var _hoisted_3$17 = { class: "absolute-center" };
function _sfc_render$23(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QSpinner = resolveComponent("QSpinner");
	return openBlock(), createElementBlock("div", {
		class: "spinner-block flex justify-center",
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", _hoisted_2$20, [createElementVNode("div", _hoisted_3$17, [createVNode(_component_QSpinner, {
		class: "spinner-block__spinner",
		color: "primary",
		size: _ctx.size
	}, null, 8, ["size"])])])], 8, _hoisted_1$28);
}
var SpinnerAbsolute_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SpinnerAbsolute_vue_vue_type_script_lang_default, [["render", _sfc_render$23], ["__scopeId", "data-v-3f9f141d"]]);
//#endregion
//#region src/components/Sidebar.vue?vue&type=script&lang.ts
var Sidebar_vue_vue_type_script_lang_default = defineComponent({
	name: "Sidebar",
	components: {
		Logo: Logo_default,
		QCard: QCard_default,
		QCardActions: QCardActions_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		QSpace: QSpace_default,
		RvButton: Button_default,
		ScrollArea: ScrollArea_default,
		SpinnerAbsolute: SpinnerAbsolute_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Disable back button
		*/
		disableBackBtn: {
			type: Boolean,
			default: false
		},
		/**
		* Disable close button
		*/
		disableCloseBtn: {
			type: Boolean,
			default: false
		},
		/**
		* Focus field on initial component render
		*/
		focusFirstInput: {
			type: Boolean,
			default: true
		},
		/**
		* Hide back button
		*/
		hideBackBtn: {
			type: Boolean,
			default: true
		},
		/**
		* Hide close button
		*/
		hideCloseBtn: {
			type: Boolean,
			default: false
		},
		/**
		* Display loading state
		*/
		loading: {
			type: Boolean,
			default: false
		},
		/**
		* Stick dialog to one of the sides (top, right, bottom or left)
		*/
		position: {
			type: String,
			default: "left"
		},
		/**
		* Display saving state
		*/
		saving: {
			type: Boolean,
			default: false
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: ""
		}
	},
	emits: [
		...useDialogPluginComponent.emits,
		"on-back",
		"on-cancel",
		"on-submit"
	],
	setup(props, { emit }) {
		const { logoAlignClasses } = useLogo();
		const { dialogRef, onDialogCancel, onDialogHide, onDialogOK } = useDialogPluginComponent();
		function cancel() {
			emit("on-cancel");
			onDialogCancel();
		}
		function hide() {
			dialogRef.value?.hide();
		}
		function show() {
			dialogRef.value?.show();
		}
		function onBack() {
			emit("on-back");
		}
		function onSubmit() {
			emit("on-submit");
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			cancel,
			dialogRef,
			hide,
			logoAlignClasses,
			onBack,
			onDialogHide,
			onDialogOK,
			onSubmit,
			show
		};
	}
});
//#endregion
//#region src/components/Sidebar.vue
var _hoisted_1$27 = { class: "sidebar__back" };
var _hoisted_2$19 = { class: "sidebar__cancel" };
var _hoisted_3$16 = ["data-automation"];
var _hoisted_4$11 = ["data-automation"];
var _hoisted_5$9 = ["data-automation"];
function _sfc_render$22(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Logo = resolveComponent("Logo");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_QCardActions = resolveComponent("QCardActions");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	const _directive_focus = resolveDirective("focus");
	const _directive_hotkey = resolveDirective("hotkey");
	return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
		"data-automation": _ctx.buildId(),
		maximized: "",
		"no-backdrop-dismiss": "",
		position: _ctx.position,
		onHide: _ctx.onDialogHide
	}), {
		default: withCtx(() => [withDirectives((openBlock(), createBlock(_component_QCard, { class: "sidebar column no-wrap" }, {
			default: withCtx(() => [
				createVNode(_component_QCardSection, {
					class: "sidebar__header row no-wrap items-center q-px-lg q-pt-md q-pb-lg",
					"data-automation": _ctx.buildId("header")
				}, {
					default: withCtx(() => [
						createElementVNode("div", _hoisted_1$27, [!_ctx.hideBackBtn ? (openBlock(), createBlock(_component_RvButton, {
							key: 0,
							class: "no-padding",
							color: "black-1",
							"data-automation": _ctx.buildId("back"),
							disable: _ctx.disableBackBtn,
							icon: "mdi-chevron-left",
							tertiary: "",
							onClick: _ctx.onBack
						}, null, 8, [
							"data-automation",
							"disable",
							"onClick"
						])) : createCommentVNode("", true)]),
						createElementVNode("div", { class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses]) }, [createVNode(_component_Logo, {
							class: "sidebar__logo",
							"data-automation": _ctx.buildId("logo"),
							name: "regular"
						}, null, 8, ["data-automation"])], 2),
						createElementVNode("div", _hoisted_2$19, [!_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_RvButton, {
							key: 0,
							class: "no-padding",
							color: "black-1",
							"data-automation": _ctx.buildId("cancel"),
							disable: _ctx.disableCloseBtn,
							icon: "mdi-close",
							tertiary: "",
							onClick: _ctx.cancel
						}, null, 8, [
							"data-automation",
							"disable",
							"onClick"
						])) : createCommentVNode("", true)])
					]),
					_: 1
				}, 8, ["data-automation"]),
				_ctx.title ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "sidebar__title text-subtitle1 q-px-lg q-pb-md",
					"data-automation": _ctx.buildId("title")
				}, [createTextVNode(toDisplayString(_ctx.title) + " ", 1), renderSlot(_ctx.$slots, "title-append", {}, void 0, true)], 8, _hoisted_3$16)) : createCommentVNode("", true),
				createVNode(_component_QCardSection, {
					class: "fit q-pa-none relative-position",
					"data-automation": _ctx.buildId("content-wrapper")
				}, {
					default: withCtx(() => [_ctx.loading || _ctx.saving ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
						key: 0,
						"data-automation": _ctx.buildId("spinner")
					}, null, 8, ["data-automation"])) : createCommentVNode("", true), createVNode(_component_ScrollArea, {
						class: "full-height",
						"data-automation": _ctx.buildId("scrollArea")
					}, {
						default: withCtx(() => [createElementVNode("div", {
							class: normalizeClass(["sidebar__content q-pb-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
							"data-automation": _ctx.buildId("content")
						}, [!_ctx.loading ? renderSlot(_ctx.$slots, "default", {}, void 0, true, 0) : createCommentVNode("", true)], 10, _hoisted_4$11)]),
						_: 3
					}, 8, ["data-automation"])]),
					_: 3
				}, 8, ["data-automation"]),
				createVNode(_component_QSpace),
				withDirectives(createVNode(_component_QCardActions, { class: "row q-pa-none z-top" }, {
					default: withCtx(() => [createElementVNode("div", {
						class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
						"data-automation": _ctx.buildId("actions")
					}, [renderSlot(_ctx.$slots, "actions", {}, void 0, true)], 10, _hoisted_5$9)]),
					_: 3
				}, 512), [[vShow, _ctx.$slots.actions]])
			]),
			_: 3
		})), [[_directive_focus, _ctx.focusFirstInput], [_directive_hotkey, { "Enter": _ctx.onSubmit }]])]),
		_: 3
	}, 16, [
		"data-automation",
		"position",
		"onHide"
	]);
}
var Sidebar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Sidebar_vue_vue_type_script_lang_default, [["render", _sfc_render$22], ["__scopeId", "data-v-0fa2e0e9"]]);
//#endregion
//#region src/components/SidebarListClassSlugs.vue?vue&type=script&lang.ts
var SidebarListClassSlugs_vue_vue_type_script_lang_default = defineComponent({
	name: "SidebarListClassSlugs",
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		modelValue: {
			type: Array,
			default: () => []
		},
		/**
		* Shows class name or class id
		*/
		showClassName: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		const { t } = useI18n();
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			t
		};
	}
});
//#endregion
//#region src/components/SidebarListClassSlugs.vue
var _hoisted_1$26 = ["data-automation"];
var _hoisted_2$18 = {
	key: 0,
	class: "sidebar-list-class-slugs__content"
};
var _hoisted_3$15 = ["data-automation"];
var _hoisted_4$10 = { key: 0 };
var _hoisted_5$8 = {
	key: 1,
	class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
var _hoisted_6$5 = {
	key: 0,
	class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
var _hoisted_7$4 = {
	key: 1,
	class: "q-pb-md"
};
function _sfc_render$21(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "sidebar-list-class-slugs",
		"data-automation": _ctx.buildId()
	}, [_ctx.modelValue.length ? (openBlock(), createElementBlock("div", _hoisted_2$18, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (item, index) => {
		return openBlock(), createElementBlock("div", {
			key: item.id,
			class: "inline-block",
			"data-automation": _ctx.buildId(`item-${item.id}`)
		}, [_ctx.showClassName ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
			createTextVNode(toDisplayString(item.name) + " ", 1),
			item.hasDifferentNames ? (openBlock(), createElementBlock("span", _hoisted_4$10, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [item.id])), 1)) : createCommentVNode("", true),
			index < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_5$8, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)
		], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(toDisplayString(item.id) + " ", 1), index < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_6$5, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)], 64))], 8, _hoisted_3$15);
	}), 128))])) : (openBlock(), createElementBlock("div", _hoisted_7$4, toDisplayString(_ctx.t("rvai-base.general.common.none")), 1))], 8, _hoisted_1$26);
}
var SidebarListClassSlugs_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SidebarListClassSlugs_vue_vue_type_script_lang_default, [["render", _sfc_render$21], ["__scopeId", "data-v-0bd0435b"]]);
//#endregion
//#region src/components/SidebarLoading.vue?vue&type=script&lang.ts
var SidebarLoading_vue_vue_type_script_lang_default = defineComponent({
	name: "SidebarLoading",
	components: { QIcon: QIcon_default },
	props: { 
	/**
	* Automation ID to easily find element in the DOM by its value
	*/
dataAutomation: {
		type: String,
		default: void 0
	} },
	setup(props) {
		const { t } = useI18n();
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			t
		};
	}
});
//#endregion
//#region src/components/SidebarLoading.vue
var _hoisted_1$25 = ["data-automation"];
var _hoisted_2$17 = { class: "bg-white absolute-full z-fab" };
var _hoisted_3$14 = { class: "sidebar-loading__content relative-position flex items-center column text-grey-1" };
function _sfc_render$20(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	return openBlock(), createElementBlock("div", {
		class: "sidebar-loading",
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", _hoisted_2$17, [createElementVNode("div", _hoisted_3$14, [
		createVNode(_component_QIcon, {
			color: "grey-2",
			name: "mdi-alert-circle",
			size: "33px"
		}),
		createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loading")), 1),
		createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loadingExtra")), 1)
	])])], 8, _hoisted_1$25);
}
var SidebarLoading_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SidebarLoading_vue_vue_type_script_lang_default, [["render", _sfc_render$20], ["__scopeId", "data-v-abc83384"]]);
//#endregion
//#region src/components/Slider.vue?vue&type=script&lang.ts
var Slider_vue_vue_type_script_lang_default = defineComponent({
	name: "Slider",
	components: {
		EllipsisText: EllipsisText_default,
		QIcon: QIcon_default,
		QSlider: QSlider_default,
		RvInput: Input_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Focus field on initial component render
		*/
		autofocus: {
			type: Boolean,
			default: false
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Debounce amount (in milliseconds) when updating model
		*/
		debounce: {
			type: [String, Number],
			default: 200
		},
		/**
		* Put component in disabled mode
		*/
		disable: {
			type: Boolean,
			default: false
		},
		/**
		* Accept float values when using with-input
		*/
		float: {
			type: Boolean,
			default: false
		},
		/**
		* Render info icon with tooltip. Can be used as an "info-text" property or as a slot
		*/
		infoText: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the info text
		*/
		infoTextClass: {
			type: String,
			default: "rv-slider__info-text"
		},
		/**
		* Classes applied to the input
		* @type {[Array, Object, String]}
		*/
		inputClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* How many numbers show after comma for float numbers
		* @type {number}
		*/
		inputDecimals: {
			type: Number,
			default: void 0
		},
		/**
		* The text that will be shown above the input
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Classes applied to the label
		* @type {[Array, Object, String]}
		*/
		labelClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Override default pin value
		* @type {[Array, Object, String]}
		*/
		pinValue: {
			type: [String, Number],
			default: void 0
		},
		/**
		* Display markers on the track, one for each possible value for the model
		*/
		markers: {
			type: Boolean,
			default: false
		},
		/**
		* Maximum value of the model; Set track's maximum value
		*/
		max: {
			type: Number,
			default: 100
		},
		/**
		* Minimum value of the model; Set track's minimum value
		*/
		min: {
			type: Number,
			default: 0
		},
		/**
		* Label to show instead of minimum value
		*/
		minLabel: {
			type: String,
			default: ""
		},
		/**
		* Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Number,
			required: true
		},
		/**
		* The text that will be shown next to label
		*/
		optionalLabel: {
			type: String,
			default: ""
		},
		/**
		* Text that appears in the form control when it has no value set
		*/
		placeholder: {
			type: String,
			default: void 0
		},
		/**
		* Put component in readonly mode
		*/
		readonly: {
			type: Boolean,
			default: false
		},
		/**
		* Shows min and max values around slider
		*/
		showMinMax: {
			type: Boolean,
			default: true
		},
		/**
		* Show optional label next to label
		*/
		showOptionalLabel: {
			type: Boolean,
			default: false
		},
		/**
		* Flag to show/hide pin on hover
		*/
		showPin: {
			type: Boolean,
			default: true
		},
		/**
		* Classes applied to the slider
		* @type {[Array, Object, String]}
		*/
		sliderClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
		*/
		step: {
			type: Number,
			default: 1
		},
		/**
		* The text to be displayed at the end of max
		*/
		suffix: {
			type: String,
			default: void 0
		},
		/**
		* Renders input next to slider
		*/
		withInput: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const { t } = useI18n();
		const stringValue = ref("");
		function onBlur() {
			let parsed = props.inputDecimals && stringValue.value ? truncateNumber(parseFloat(stringValue.value), props.inputDecimals) : roundToStep(Number(stringValue.value), props.step);
			if (isNaN(parsed)) {
				stringValue.value = props.modelValue.toString();
				return;
			}
			if (parsed < props.min) parsed = props.min;
			if (parsed > props.max) parsed = props.max;
			parsed = props.float ? parsed : ~~parsed;
			if (stringValue.value !== parsed.toString()) stringValue.value = parsed.toString();
			emit("update:modelValue", parsed);
		}
		function onSliderValueChange(event) {
			emit("update:modelValue", event);
		}
		watch(() => props.modelValue, (value) => {
			stringValue.value = String(value);
		}, { immediate: true });
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			onBlur,
			onSliderValueChange: props.debounce ? debounce(onSliderValueChange, Number(props.debounce)) : onSliderValueChange,
			stringValue,
			t
		};
	}
});
//#endregion
//#region src/components/Slider.vue
var _hoisted_1$24 = ["data-automation"];
var _hoisted_2$16 = ["data-automation"];
var _hoisted_3$13 = { class: "row no-wrap items-center full-width" };
var _hoisted_4$9 = {
	key: 0,
	class: "q-ml-xs"
};
var _hoisted_5$7 = { class: "flex justify-between full-width" };
var _hoisted_6$4 = {
	key: 0,
	class: "rv-slider__input-wrapper flex items-center justify-between"
};
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QSlider = resolveComponent("QSlider");
	const _component_RvInput = resolveComponent("RvInput");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: ["rv-slider", [_ctx.$props.class, {
			"rv-slider--disabled": _ctx.disable || _ctx.readonly,
			"rv-slider--with-input": _ctx.withInput
		}]],
		"data-automation": _ctx.buildId()
	}), [_ctx.label ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
		"data-automation": _ctx.buildId("label-container")
	}, [createElementVNode("span", _hoisted_3$13, [
		createVNode(_component_EllipsisText, {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("label"),
			text: _ctx.label
		}, null, 8, ["data-automation", "text"]),
		_ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$9, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
		_ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
			key: 1,
			class: "q-ml-xs info-icon",
			color: "black-1",
			"data-automation": _ctx.buildId("icon-info"),
			name: "info",
			size: "16px"
		}, {
			default: withCtx(() => [createVNode(_component_Tooltip, {
				anchor: "top middle",
				class: normalizeClass(_ctx.infoTextClass),
				self: "bottom middle"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "infoText", {}, () => [createTextVNode(toDisplayString(_ctx.infoText), 1)], true)]),
				_: 3
			}, 8, ["class"])]),
			_: 3
		}, 8, ["data-automation"])) : createCommentVNode("", true)
	]), renderSlot(_ctx.$slots, "label-append", {}, void 0, true)], 10, _hoisted_2$16)) : createCommentVNode("", true), createElementVNode("div", _hoisted_5$7, [createElementVNode("div", { class: normalizeClass(["rv-slider__slider-wrapper row items-center no-wrap", { "q-pr-md": _ctx.withInput }]) }, [
		_ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
			key: 0,
			class: "rv-slider__limit q-mr-md col-fixed text-grey-1",
			"data-automation": _ctx.buildId("limit-min")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)]),
			_: 1
		}, 8, ["data-automation"])) : createCommentVNode("", true),
		createVNode(_component_QSlider, {
			class: normalizeClass(["rv-slider__slider", _ctx.sliderClass]),
			"data-automation": _ctx.buildId("slider"),
			disable: _ctx.disable,
			label: _ctx.showPin,
			"label-value": _ctx.pinValue,
			markers: _ctx.markers,
			max: _ctx.max,
			min: _ctx.min,
			"model-value": _ctx.modelValue,
			readonly: _ctx.readonly,
			step: _ctx.step,
			"onUpdate:modelValue": _ctx.onSliderValueChange
		}, null, 8, [
			"class",
			"data-automation",
			"disable",
			"label",
			"label-value",
			"markers",
			"max",
			"min",
			"model-value",
			"readonly",
			"step",
			"onUpdate:modelValue"
		]),
		_ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
			key: 1,
			class: normalizeClass(["rv-slider__limit q-ml-md col-fixed text-grey-1", { "rv-slider__limit--suffix": _ctx.suffix }]),
			"data-automation": _ctx.buildId("limit-max")
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.max) + " " + toDisplayString(_ctx.suffix), 1)]),
			_: 1
		}, 8, ["class", "data-automation"])) : createCommentVNode("", true)
	], 2), _ctx.withInput ? (openBlock(), createElementBlock("div", _hoisted_6$4, [createVNode(_component_RvInput, {
		modelValue: _ctx.stringValue,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.stringValue = $event),
		autofocus: _ctx.autofocus,
		class: "rv-slider__input",
		"data-automation": _ctx.buildId("input"),
		debounce: _ctx.debounce,
		disable: _ctx.disable,
		"input-class": _ctx.inputClass,
		"item-aligned": "center",
		placeholder: _ctx.placeholder,
		readonly: _ctx.readonly,
		"show-error": false,
		"show-error-message": false,
		"show-valid": false,
		suffix: _ctx.suffix,
		onBlur: _ctx.onBlur,
		onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
	}, null, 8, [
		"modelValue",
		"autofocus",
		"data-automation",
		"debounce",
		"disable",
		"input-class",
		"placeholder",
		"readonly",
		"suffix",
		"onBlur"
	])])) : createCommentVNode("", true)])], 16, _hoisted_1$24);
}
var Slider_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Slider_vue_vue_type_script_lang_default, [["render", _sfc_render$19], ["__scopeId", "data-v-30eb7b5a"]]);
//#endregion
//#region src/components/SortSelect.vue?vue&type=script&lang.ts
var SortSelect_vue_vue_type_script_lang_default = defineComponent({
	name: "SortSelect",
	components: {
		QIcon: QIcon_default,
		QItem: QItem_default,
		QItemLabel: QItemLabel_default,
		QItemSection: QItemSection_default,
		RvSelect: Select_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "sortSelect"
		},
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Object,
			default: null
		},
		/**
		* Available sort options that the user can select from. For best performance freeze the list of options.
		*/
		options: {
			type: Array,
			required: true
		},
		/**
		* Shows label before select
		*/
		showLabelBefore: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:modelValue"],
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/SortSelect.vue
var _hoisted_1$23 = ["data-automation"];
var _hoisted_2$15 = ["data-automation"];
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QItemSection = resolveComponent("QItemSection");
	const _component_QItem = resolveComponent("QItem");
	const _component_RvSelect = resolveComponent("RvSelect");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["rv-sort-select", _ctx.$props.class]),
		"data-automation": _ctx.buildId()
	}, [_ctx.showLabelBefore ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "text-subtitle3 flex flex-center q-mr-sm",
		"data-automation": _ctx.buildId("label")
	}, toDisplayString(_ctx.$t("rvai-base.general.table.sortBy")), 9, _hoisted_2$15)) : createCommentVNode("", true), createVNode(_component_RvSelect, {
		class: "rv-sort-select__select",
		"data-automation": _ctx.buildId("select"),
		dense: "",
		"model-value": _ctx.modelValue,
		options: _ctx.options,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
	}, {
		prepend: withCtx(() => [createVNode(_component_QIcon, {
			color: "grey-1",
			name: "rvai-base:sort-asc",
			size: "sm"
		})]),
		option: withCtx((scope) => [createVNode(_component_QItem, mergeProps(scope.itemProps, { "data-automation": _ctx.buildId(`option-${scope.label}`) }), {
			default: withCtx(() => [createVNode(_component_QItemSection, { class: "rv-sort-select__item-section" }, {
				default: withCtx(() => [createVNode(_component_QItemLabel, null, {
					default: withCtx(() => [createTextVNode(toDisplayString(scope.label), 1)]),
					_: 2
				}, 1024), _ctx.modelValue && _ctx.modelValue.label === scope.label ? (openBlock(), createBlock(_component_QIcon, {
					key: 0,
					color: "grey-1",
					name: "mdi-check",
					size: "18px"
				})) : createCommentVNode("", true)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1040, ["data-automation"])]),
		_: 1
	}, 8, [
		"data-automation",
		"model-value",
		"options"
	])], 10, _hoisted_1$23);
}
var SortSelect_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SortSelect_vue_vue_type_script_lang_default, [["render", _sfc_render$18], ["__scopeId", "data-v-8c252cdf"]]);
//#endregion
//#region src/components/Spinner.vue?vue&type=script&lang.ts
var Spinner_vue_vue_type_script_lang_default = defineComponent({
	name: "Spinner",
	components: { QCircularProgress: QCircularProgress_default },
	props: {
		/**
		* Classes applied to component
		* @type {[Array, Object, String]}
		*/
		class: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: "spinner"
		},
		/**
		* Spinner size
		*/
		size: {
			type: String,
			default: "20px"
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/Spinner.vue
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QCircularProgress = resolveComponent("QCircularProgress");
	return openBlock(), createBlock(_component_QCircularProgress, {
		class: normalizeClass(_ctx.$props.class),
		color: "primary",
		"data-automation": _ctx.dataAutomation,
		indeterminate: "",
		rounded: "",
		size: _ctx.size,
		thickness: .3,
		"track-color": "grey-3"
	}, null, 8, [
		"class",
		"data-automation",
		"size"
	]);
}
var Spinner_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Spinner_vue_vue_type_script_lang_default, [["render", _sfc_render$17]]);
//#endregion
//#region src/components/StatusPanel.vue?vue&type=script&lang.ts
var StatusPanel_vue_vue_type_script_lang_default = defineComponent({
	name: "StatusPanel",
	components: {
		CircularProgress: CircularProgress_default,
		QIcon: QIcon_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Text displayed in title
		*/
		color: {
			type: String,
			default: "primary"
		},
		/**
		* Set 'full-width' class to the component
		*/
		fullWidth: {
			type: Boolean,
			default: false
		},
		/**
		* Text displayed in title
		*/
		icon: {
			type: String,
			default: ""
		},
		/**
		* Text displayed in title
		*/
		iconColor: {
			type: String,
			default: "positive"
		},
		/**
		* Minimum value defining 'no progress' (must be lower than 'max')
		*/
		max: {
			type: [Number, String],
			default: 100
		},
		/**
		* Minimum value defining 'no progress' (must be lower than 'max')
		*/
		min: {
			type: [Number, String],
			default: 0
		},
		/**
		* Text displayed in title
		*/
		title: {
			type: String,
			default: () => useI18n().t("rvai-base.general.text.status")
		},
		/**
		* Text displayed in title
		*/
		text: {
			type: String,
			default: ""
		},
		/**
		* Current progress (must be between min/max)
		*/
		value: {
			type: [Number, String],
			required: true
		}
	},
	setup(props) {
		return { ...useAutomation(computed(() => props.dataAutomation)) };
	}
});
//#endregion
//#region src/components/StatusPanel.vue
var _hoisted_1$22 = ["data-automation"];
var _hoisted_2$14 = { class: "row no-wrap items-center full-width" };
var _hoisted_3$12 = ["data-automation"];
var _hoisted_4$8 = ["data-automation"];
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QIcon = resolveComponent("QIcon");
	const _component_CircularProgress = resolveComponent("CircularProgress");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["status-panel column no-wrap items-center rounded-borders bg-grey-5 q-py-sm q-px-md", { "full-width": _ctx.fullWidth }]),
		"data-automation": _ctx.buildId()
	}, [
		createElementVNode("div", _hoisted_2$14, [createElementVNode("span", {
			class: "text-subtitle3",
			"data-automation": _ctx.buildId("title-text")
		}, toDisplayString(_ctx.title), 9, _hoisted_3$12), _ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
			key: 0,
			class: "q-ml-xs",
			color: _ctx.iconColor,
			"data-automation": _ctx.buildId("title-icon"),
			name: _ctx.icon,
			size: "xs"
		}, null, 8, [
			"color",
			"data-automation",
			"name"
		])) : createCommentVNode("", true)]),
		createVNode(_component_CircularProgress, {
			class: "q-mt-sm q-mb-xs",
			color: _ctx.color,
			"data-automation": _ctx.buildId("progress"),
			max: Number(_ctx.max),
			min: Number(_ctx.min),
			"show-value": "",
			size: "80px",
			"track-color": "grey-3",
			value: Number(_ctx.value)
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
			_: 3
		}, 8, [
			"color",
			"data-automation",
			"max",
			"min",
			"value"
		]),
		_ctx.text ? (openBlock(), createElementBlock("span", {
			key: 0,
			class: "text-small",
			"data-automation": _ctx.buildId("text")
		}, toDisplayString(_ctx.text), 9, _hoisted_4$8)) : createCommentVNode("", true)
	], 10, _hoisted_1$22);
}
var StatusPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(StatusPanel_vue_vue_type_script_lang_default, [["render", _sfc_render$16], ["__scopeId", "data-v-742b1eda"]]);
//#endregion
//#region src/components/SuspenseWithError.vue?vue&type=script&lang.ts
var SuspenseWithError_vue_vue_type_script_lang_default = defineComponent({
	name: "SuspenseWithError",
	components: {
		QImg: QImg_default,
		QInnerLoading: QInnerLoading_default
	},
	setup() {
		const error = ref(false);
		onErrorCaptured((e) => {
			error.value = true;
			console.error(e);
		});
		return { error };
	}
});
//#endregion
//#region src/components/SuspenseWithError.vue
var _hoisted_1$21 = {
	key: 1,
	class: "q-pa-md fit column flex-center"
};
var _hoisted_2$13 = { class: "text-subtitle3" };
var _hoisted_3$11 = { class: "q-mt-sm text-body3" };
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QInnerLoading = resolveComponent("QInnerLoading");
	const _component_QImg = resolveComponent("QImg");
	return !_ctx.error ? (openBlock(), createBlock(Suspense, { key: 0 }, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		fallback: withCtx(() => [createVNode(_component_QInnerLoading, {
			color: "primary",
			showing: true
		})]),
		_: 3
	})) : (openBlock(), createElementBlock("div", _hoisted_1$21, [
		createVNode(_component_QImg, {
			class: "icon",
			src: "rvai-base/not-found.svg",
			width: "75%"
		}),
		createElementVNode("div", _hoisted_2$13, toDisplayString(_ctx.$t("rvai-base.general.errors.title")), 1),
		createElementVNode("div", _hoisted_3$11, toDisplayString(_ctx.$t("rvai-base.general.errors.description")), 1)
	]));
}
var SuspenseWithError_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SuspenseWithError_vue_vue_type_script_lang_default, [["render", _sfc_render$15]]);
//#endregion
//#region src/components/StepSidebar.vue?vue&type=script&lang.ts
var StepSidebar_vue_vue_type_script_lang_default = defineComponent({
	name: "StepSidebar",
	components: {
		Logo: Logo_default,
		QCard: QCard_default,
		QCardSection: QCardSection_default,
		QDialog: QDialog_default,
		QIcon: QIcon_default,
		RvButton: Button_default,
		SuspenseWithError: SuspenseWithError_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		customBackEvent: {
			type: Boolean,
			default: false
		},
		disableCloseBtn: {
			type: Boolean,
			default: false
		},
		hideBackBtn: {
			type: Boolean,
			default: false
		},
		hideCloseBtn: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: "left"
		}
	},
	emits: ["on-back"],
	setup(props, { emit }) {
		const { logoAlignClasses } = useLogo();
		const { dialogRef, onDialogCancel, onDialogHide, onDialogOK } = useDialogPluginComponent();
		const { isCurrentStep, isDefaultStep, onBack, showBackButton, stack } = useStepSidebar();
		function onBackClick() {
			if (props.customBackEvent) emit("on-back");
			else onBack();
		}
		function hide() {
			dialogRef.value?.hide();
		}
		function show() {
			dialogRef.value?.show();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			dialogRef,
			hide,
			isCurrentStep,
			isDefaultStep,
			logoAlignClasses,
			onBackClick,
			onDialogCancel,
			onDialogHide,
			onDialogOK,
			show,
			showBackButton,
			stack
		};
	}
});
//#endregion
//#region src/components/StepSidebar.vue
var _hoisted_1$20 = { class: "sidebar__back" };
var _hoisted_2$12 = { class: "sidebar__cancel" };
var _hoisted_3$10 = ["data-automation"];
var _hoisted_4$7 = ["data-automation"];
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_Logo = resolveComponent("Logo");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_SuspenseWithError = resolveComponent("SuspenseWithError");
	const _component_QCard = resolveComponent("QCard");
	const _component_QDialog = resolveComponent("QDialog");
	return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
		"data-automation": _ctx.buildId(),
		maximized: "",
		"no-backdrop-dismiss": "",
		position: _ctx.position
	}), {
		default: withCtx(() => [createVNode(_component_QCard, { class: "sidebar column no-wrap" }, {
			default: withCtx(() => [
				createVNode(_component_QCardSection, {
					class: "sidebar__header row no-wrap items-center q-pa-md q-pt-md q-pb-lg",
					"data-automation": _ctx.buildId("header")
				}, {
					default: withCtx(() => [
						createElementVNode("div", _hoisted_1$20, [!_ctx.hideBackBtn && _ctx.showBackButton ? (openBlock(), createBlock(_component_RvButton, {
							key: 0,
							class: "no-padding",
							color: "black-1",
							"data-automation": _ctx.buildId("back"),
							icon: "mdi-chevron-left",
							tertiary: "",
							onClick: _ctx.onBackClick
						}, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)]),
						createElementVNode("div", { class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses]) }, [createVNode(_component_Logo, {
							class: "sidebar__logo",
							"data-automation": _ctx.buildId("logo")
						}, null, 8, ["data-automation"])], 2),
						createElementVNode("div", _hoisted_2$12, [!_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_RvButton, {
							key: 0,
							class: "no-padding",
							color: "black-1",
							"data-automation": _ctx.buildId("cancel"),
							disable: _ctx.disableCloseBtn,
							icon: "mdi-close",
							tertiary: "",
							onClick: _ctx.onDialogCancel
						}, null, 8, [
							"data-automation",
							"disable",
							"onClick"
						])) : createCommentVNode("", true)])
					]),
					_: 1
				}, 8, ["data-automation"]),
				withDirectives(createElementVNode("div", {
					class: "column no-wrap full-height",
					"data-automation": _ctx.buildId("content")
				}, [createVNode(_component_SuspenseWithError, null, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
					_: 3
				})], 8, _hoisted_3$10), [[vShow, _ctx.isDefaultStep]]),
				(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stack, (step, index) => {
					return withDirectives((openBlock(), createElementBlock("div", {
						key: index,
						class: "column no-wrap full-height",
						"data-automation": _ctx.buildId(`stack-${step.stepName ?? index}`)
					}, [createVNode(_component_SuspenseWithError, null, {
						default: withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent(step.component), mergeProps({ ref_for: true }, step.componentProps), null, 16))]),
						_: 2
					}, 1024)], 8, _hoisted_4$7)), [[vShow, _ctx.isCurrentStep(step)]]);
				}), 128))
			]),
			_: 3
		})]),
		_: 3
	}, 16, ["data-automation", "position"]);
}
var StepSidebar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(StepSidebar_vue_vue_type_script_lang_default, [["render", _sfc_render$14], ["__scopeId", "data-v-52f17e3a"]]);
//#endregion
//#region src/components/StepSidebarContent.vue?vue&type=script&lang.ts
var StepSidebarContent_vue_vue_type_script_lang_default = defineComponent({
	name: "StepSidebarContent",
	components: {
		QCardActions: QCardActions_default,
		QCardSection: QCardSection_default,
		QSpace: QSpace_default,
		ScrollArea: ScrollArea_default,
		SidebarLoading: SidebarLoading_default,
		SpinnerAbsolute: SpinnerAbsolute_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		contentClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		/**
		* Focus field on initial component render
		*/
		focusFirstInput: {
			type: Boolean,
			default: true
		},
		headerClass: {
			type: [
				Array,
				Object,
				String
			],
			default: void 0
		},
		loading: {
			type: Boolean,
			default: false
		},
		loadingExtended: {
			type: Boolean,
			default: false
		},
		saving: {
			type: Boolean,
			default: false
		},
		step: {
			type: Object,
			default: void 0
		},
		title: {
			type: String,
			default: ""
		}
	},
	emits: ["on-submit"],
	setup(props, { emit }) {
		const titleTextRef = ref(null);
		const titleOverflowed = ref(false);
		function checkTitleOverflow() {
			const el = titleTextRef.value;
			if (!el) return;
			titleOverflowed.value = el.scrollHeight > el.clientHeight;
		}
		onMounted(checkTitleOverflow);
		watchEffect(() => {
			if (!titleTextRef.value) return;
			const observer = new ResizeObserver(checkTitleOverflow);
			observer.observe(titleTextRef.value);
			onWatcherCleanup(() => observer.disconnect());
		});
		function onSubmit() {
			emit("on-submit");
		}
		return {
			onSubmit,
			titleOverflowed,
			titleTextRef,
			...useAutomation(computed(() => props.dataAutomation))
		};
	}
});
//#endregion
//#region src/components/StepSidebarContent.vue
var _hoisted_1$19 = ["data-automation"];
var _hoisted_2$11 = {
	ref: "titleTextRef",
	class: "sidebar__title-text"
};
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
	const _component_SidebarLoading = resolveComponent("SidebarLoading");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_QCardSection = resolveComponent("QCardSection");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_QCardActions = resolveComponent("QCardActions");
	const _directive_focus = resolveDirective("focus");
	const _directive_hotkey = resolveDirective("hotkey");
	return openBlock(), createElementBlock(Fragment, null, [
		renderSlot(_ctx.$slots, "title", {}, () => [_ctx.title || _ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, _ctx.dataAttrs, {
			class: ["sidebar__title row items-center justify-between text-subtitle1 q-px-lg q-pb-md", _ctx.headerClass],
			"data-automation": _ctx.buildId()
		}), [createElementVNode("span", _hoisted_2$11, [createTextVNode(toDisplayString(_ctx.title) + " ", 1), _ctx.titleOverflowed ? (openBlock(), createBlock(_component_Tooltip, {
			key: 0,
			anchor: "bottom middle",
			"data-automation": _ctx.buildId("title-ellipsis-tooltip"),
			self: "center middle"
		}, {
			default: withCtx(() => [createElementVNode("div", null, toDisplayString(_ctx.title), 1)]),
			_: 1
		}, 8, ["data-automation"])) : createCommentVNode("", true)], 512), renderSlot(_ctx.$slots, "append-title", {}, void 0, true)], 16, _hoisted_1$19)) : createCommentVNode("", true)], true),
		withDirectives((openBlock(), createBlock(_component_QCardSection, {
			class: "fit q-pa-none relative-position",
			"data-automation": _ctx.buildId("content")
		}, {
			default: withCtx(() => [
				_ctx.saving || _ctx.loading ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
					key: 0,
					"data-automation": _ctx.buildId("loading")
				}, null, 8, ["data-automation"])) : createCommentVNode("", true),
				_ctx.loadingExtended ? (openBlock(), createBlock(_component_SidebarLoading, {
					key: 1,
					"data-automation": _ctx.buildId("loading-extended")
				}, null, 8, ["data-automation"])) : createCommentVNode("", true),
				createVNode(_component_ScrollArea, {
					class: "full-height",
					"data-automation": _ctx.buildId("scrollArea")
				}, {
					default: withCtx(() => [createElementVNode("div", { class: normalizeClass(["sidebar__content q-pb-md", [_ctx.contentClass, { "disabled no-pointer-events": _ctx.saving || _ctx.loading || _ctx.loadingExtended }]]) }, [!_ctx.loading ? renderSlot(_ctx.$slots, "default", {}, void 0, true, 0) : createCommentVNode("", true)], 2)]),
					_: 3
				}, 8, ["data-automation"])
			]),
			_: 3
		}, 8, ["data-automation"])), [[_directive_focus, _ctx.focusFirstInput], [_directive_hotkey, { "Enter": _ctx.onSubmit }]]),
		createVNode(_component_QSpace),
		_ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QCardActions, {
			key: 0,
			class: "row q-pa-none z-top",
			"data-automation": _ctx.buildId("actions")
		}, {
			default: withCtx(() => [createElementVNode("div", { class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]) }, [renderSlot(_ctx.$slots, "actions", {}, void 0, true)], 2)]),
			_: 3
		}, 8, ["data-automation"])) : createCommentVNode("", true)
	], 64);
}
var StepSidebarContent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(StepSidebarContent_vue_vue_type_script_lang_default, [["render", _sfc_render$13], ["__scopeId", "data-v-8d96abd9"]]);
//#endregion
//#region src/components/TableCard.vue
var TableCard_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "TableCard",
	props: {
		class: { default: void 0 },
		clickableCard: {
			type: Boolean,
			default: false
		},
		customActions: {
			type: Boolean,
			default: false
		},
		dark: {
			type: [Boolean, null],
			default: void 0
		},
		dataAutomation: { default: void 0 },
		row: {},
		selecting: {
			type: Boolean,
			default: false
		}
	},
	emits: ["click", "menuChange"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const menuOpen = ref(false);
		function onMenuChange(open) {
			emit("menuChange", open, props.row);
		}
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(QCard_default), {
				class: normalizeClass(["rv-table-card", [_ctx.$props.class, { "rv-table-card--clickable": __props.clickableCard }]]),
				dark: _ctx.$props.dark,
				"data-automation": unref(buildId)(),
				onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("click", $event))
			}, {
				default: withCtx(() => [
					renderSlot(_ctx.$slots, "cardHeader", {}, void 0, true),
					__props.selecting || _ctx.$slots.cardTitle ? (openBlock(), createBlock(unref(QCardSection_default), {
						key: 0,
						class: "rv-table-card__title row no-wrap items-start q-pb-none"
					}, {
						default: withCtx(() => [__props.selecting ? renderSlot(_ctx.$slots, "select", {}, void 0, true, 0) : createCommentVNode("", true), renderSlot(_ctx.$slots, "cardTitle", {}, void 0, true)]),
						_: 3
					})) : createCommentVNode("", true),
					_ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
						key: 1,
						class: "rv-table-card__actions cursor-pointer",
						onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))
					}, [__props.customActions ? renderSlot(_ctx.$slots, "actions", normalizeProps(guardReactiveProps(__props.row || {})), void 0, true, 0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(Button_default, {
						class: "no-padding",
						color: "grey-1",
						"data-automation": unref(buildId)("dots"),
						icon: "mdi-dots-horizontal",
						tertiary: ""
					}, null, 8, ["data-automation"]), createVNode(unref(QMenu_default), {
						modelValue: menuOpen.value,
						"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => menuOpen.value = $event), onMenuChange],
						"auto-close": ""
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "actions", {}, void 0, true)]),
						_: 3
					}, 8, ["modelValue"])], 64))])) : createCommentVNode("", true),
					createVNode(unref(QCardSection_default), null, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "cardContent", {}, void 0, true)]),
						_: 3
					})
				]),
				_: 3
			}, 8, [
				"class",
				"dark",
				"data-automation"
			]);
		};
	}
}), [["__scopeId", "data-v-ed62ce7b"]]);
//#endregion
//#region src/components/TableFullRowStatus.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$18 = ["data-automation"];
//#endregion
//#region src/components/TableFullRowStatus.vue
var TableFullRowStatus_default = /* @__PURE__ */ defineComponent({
	__name: "TableFullRowStatus",
	props: {
		dataAutomation: { default: "full-row-status" },
		label: { default: null }
	},
	setup(__props) {
		const props = __props;
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("span", {
				class: "text-small-semibold text-grey-1",
				"data-automation": unref(buildId)("label")
			}, toDisplayString(__props.label), 9, _hoisted_1$18), createVNode(Spinner_default, {
				"data-automation": unref(buildId)("spinner"),
				size: "20px"
			}, null, 8, ["data-automation"])], 64);
		};
	}
});
//#endregion
//#region src/components/TableFullRowStatusCell.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$17 = { class: "rv-table__full-row-status" };
//#endregion
//#region src/components/TableFullRowStatusCell.vue
var TableFullRowStatusCell_default = /* @__PURE__ */ defineComponent({
	__name: "TableFullRowStatusCell",
	props: {
		colspan: {},
		dataAutomation: { default: "full-row-status-cell" },
		hasCustomStatus: {
			type: Boolean,
			default: false
		},
		label: { default: null }
	},
	setup(__props) {
		const props = __props;
		const { buildId } = useAutomation(computed(() => props.dataAutomation));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(QTd_default), {
				align: "right",
				class: "rv-table__full-row-status-cell",
				colspan: __props.colspan,
				"data-automation": unref(buildId)()
			}, {
				default: withCtx(() => [createElementVNode("div", _hoisted_1$17, [__props.hasCustomStatus ? renderSlot(_ctx.$slots, "default", {}, void 0, void 0, 0) : (openBlock(), createBlock(TableFullRowStatus_default, {
					key: 1,
					label: __props.label
				}, null, 8, ["label"]))])]),
				_: 3
			}, 8, ["colspan", "data-automation"]);
		};
	}
});
//#endregion
//#region src/components/TablePagination.vue?vue&type=script&lang.ts
var TablePagination_vue_vue_type_script_lang_default = defineComponent({
	name: "TablePagination",
	components: {
		ActionButton: ActionButton_default,
		RvInput: Input_default,
		RvSelect: Select_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Show elements on the center
		*/
		centered: {
			default: false,
			type: Boolean
		},
		/**
		* Hide dropdown to set items per page
		*/
		hidePageSizeSelection: {
			default: false,
			type: Boolean
		},
		rowsPerPageOptions: {
			type: Array,
			default: () => [
				10,
				20,
				50,
				100,
				0
			]
		},
		/**
		* Show with space between table and pagination block§
		*/
		separated: {
			default: false,
			type: Boolean
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { pagination, tableRef } = useTable();
		const newPage = ref("");
		const inputRef = ref();
		const computedRowsPerPageOptions = computed(() => {
			return props.rowsPerPageOptions.map((count) => ({
				label: count === 0 ? "All" : String(count),
				value: count
			}));
		});
		const disableRowsPerPage = computed(() => {
			const min = Math.min(...props.rowsPerPageOptions.filter((c) => !!c));
			return (pagination.value.rowsNumber ?? 0) < min;
		});
		const page = computed(() => pagination.value.page ?? 1);
		const rowsPerPage = computed({
			get() {
				return pagination.value.rowsPerPage ?? 0;
			},
			set(rowsPerPage) {
				setPagination({ rowsPerPage });
			}
		});
		const totalPages = computed(() => {
			const rowsNumber = pagination.value.rowsNumber ?? 0;
			const rowsPerPage = pagination.value.rowsPerPage ?? 0;
			const pages = rowsPerPage ? Math.ceil(rowsNumber / rowsPerPage) : 1;
			return Math.max(pages, 1);
		});
		function firstPage() {
			setPagination({ page: 1 });
		}
		function lastPage() {
			setPagination({ page: totalPages.value });
		}
		function nextPage() {
			if (page.value >= totalPages.value) return;
			setPagination({ page: page.value + 1 });
		}
		function previousPage() {
			if (page.value <= 1) return;
			setPagination({ page: page.value - 1 });
		}
		function setPagination(update) {
			const paginationObject = {
				...pagination.value,
				...update
			};
			tableRef.value?.requestServerInteraction({ pagination: {
				...paginationObject,
				sortBy: paginationObject.sortBy ?? void 0
			} });
		}
		async function onBlur() {
			let value = parseInt(newPage.value, 10);
			newPage.value = "";
			if (isNaN(value) || value === page.value) return;
			value = Math.max(1, Math.min(totalPages.value, value));
			setPagination({ page: value });
		}
		function onEnter() {
			inputRef.value?.blur();
		}
		function onKeyPress(e) {
			if (!/\d/g.test(e.key)) e.preventDefault();
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			computedRowsPerPageOptions,
			disableRowsPerPage,
			firstPage,
			inputRef,
			lastPage,
			newPage,
			nextPage,
			onBlur,
			onEnter,
			onKeyPress,
			page,
			previousPage,
			rowsPerPage,
			t,
			totalPages
		};
	}
});
//#endregion
//#region src/components/TablePagination.vue
var _hoisted_1$16 = ["data-automation"];
var _hoisted_2$10 = ["data-automation"];
var _hoisted_3$9 = ["data-automation"];
var _hoisted_4$6 = { class: "row items-center" };
var _hoisted_5$6 = { class: "text-body3 text-grey-1 block q-mr-md" };
var _hoisted_6$3 = {
	key: 1,
	class: "row items-center no-wrap q-ml-sm"
};
var _hoisted_7$3 = { class: "text-subtitle3 text-grey-1" };
var _hoisted_8$2 = ["data-automation"];
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvSelect = resolveComponent("RvSelect");
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_RvInput = resolveComponent("RvInput");
	return openBlock(), createElementBlock("div", {
		class: "column full-width",
		"data-automation": _ctx.buildId("wrapper")
	}, [_ctx.separated ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: "full-width q-py-sm bg-grey-5",
		"data-automation": _ctx.buildId("separation")
	}, null, 8, _hoisted_2$10)) : createCommentVNode("", true), createElementVNode("div", {
		class: normalizeClass(["table-pagination row full-width bg-white", {
			"justify-center": _ctx.centered,
			"q-py-sm": _ctx.separated
		}]),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", _hoisted_4$6, [!_ctx.hidePageSizeSelection ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("span", _hoisted_5$6, toDisplayString(_ctx.t("rvai-base.general.table.recordPerPage")), 1), createVNode(_component_RvSelect, {
		modelValue: _ctx.rowsPerPage,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.rowsPerPage = $event),
		"data-automation": _ctx.buildId("rowsPerPage"),
		dense: "",
		disable: _ctx.disableRowsPerPage,
		"emit-value": "",
		"map-options": "",
		options: _ctx.computedRowsPerPageOptions,
		"options-dense": ""
	}, null, 8, [
		"modelValue",
		"data-automation",
		"disable",
		"options"
	])], 64)) : createCommentVNode("", true), _ctx.rowsPerPage !== 0 ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
		createVNode(_component_ActionButton, {
			class: "text-grey-1",
			"data-automation": _ctx.buildId("firstPage"),
			disable: _ctx.page === 1,
			icon: "mdi-chevron-double-left",
			size: "md",
			tertiary: "",
			onClick: _ctx.firstPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createVNode(_component_ActionButton, {
			class: "text-grey-1",
			"data-automation": _ctx.buildId("previousPage"),
			disable: _ctx.page === 1,
			icon: "mdi-chevron-left",
			size: "md",
			tertiary: "",
			onClick: _ctx.previousPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createVNode(_component_RvInput, {
			ref: "inputRef",
			modelValue: _ctx.newPage,
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.newPage = $event),
			class: "table-pagination__input q-mx-sm",
			"data-automation": _ctx.buildId("currentPage"),
			disable: _ctx.totalPages <= 1,
			"input-class": "text-center",
			placeholder: String(_ctx.page),
			type: "number",
			onBlur: _ctx.onBlur,
			onKeypress: _ctx.onKeyPress,
			onKeyup: withKeys(_ctx.onEnter, ["enter"])
		}, null, 8, [
			"modelValue",
			"data-automation",
			"disable",
			"placeholder",
			"onBlur",
			"onKeypress",
			"onKeyup"
		]),
		createElementVNode("span", _hoisted_7$3, [createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.slash")) + " ", 1), createElementVNode("span", { "data-automation": _ctx.buildId("totalPage") }, toDisplayString(_ctx.totalPages), 9, _hoisted_8$2)]),
		createVNode(_component_ActionButton, {
			class: "text-grey-1 q-ml-sm",
			"data-automation": _ctx.buildId("nextPage"),
			disable: _ctx.page === _ctx.totalPages,
			icon: "mdi-chevron-right",
			size: "md",
			tertiary: "",
			onClick: _ctx.nextPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		]),
		createVNode(_component_ActionButton, {
			class: "text-grey-1",
			"data-automation": _ctx.buildId("lastPage"),
			disable: _ctx.page === _ctx.totalPages,
			icon: "mdi-chevron-double-right",
			size: "md",
			tertiary: "",
			onClick: _ctx.lastPage
		}, null, 8, [
			"data-automation",
			"disable",
			"onClick"
		])
	])) : createCommentVNode("", true)])], 10, _hoisted_3$9)], 8, _hoisted_1$16);
}
var TablePagination_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TablePagination_vue_vue_type_script_lang_default, [["render", _sfc_render$12], ["__scopeId", "data-v-ef5e40c8"]]);
//#endregion
//#region src/components/TableSortBy.vue?vue&type=script&lang.ts
var TableSortBy_vue_vue_type_script_lang_default = defineComponent({
	name: "TableSortBy",
	components: { SortSelect: SortSelect_default },
	props: { 
	/**
	* Automation ID to easily find element in the DOM by its value
	*/
dataAutomation: {
		type: String,
		default: void 0
	} },
	setup(props) {
		const { t } = useI18n();
		const { pagination, selectedItem, sortableItems, tableRef } = useTable();
		if (pagination.value.sortBy) selectedItem.value = sortableItems.value.find((i) => i.name === pagination.value.sortBy && pagination.value.descending === i.descending);
		else selectedItem.value = null;
		watch(selectedItem, (item) => {
			if (!item) return;
			tableRef.value?.requestServerInteraction({ pagination: {
				...pagination.value,
				descending: item.descending,
				sortBy: item.name
			} });
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			selectedItem,
			sortableItems,
			t
		};
	}
});
//#endregion
//#region src/components/TableSortBy.vue
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_SortSelect = resolveComponent("SortSelect");
	return openBlock(), createBlock(_component_SortSelect, {
		modelValue: _ctx.selectedItem,
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selectedItem = $event),
		class: "rv-table-sort-by row",
		"data-automation": _ctx.buildId(),
		options: _ctx.sortableItems
	}, null, 8, [
		"modelValue",
		"data-automation",
		"options"
	]);
}
var TableSortBy_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TableSortBy_vue_vue_type_script_lang_default, [["render", _sfc_render$11], ["__scopeId", "data-v-c5161c18"]]);
//#endregion
//#region src/components/Table.vue?vue&type=script&lang.ts
var SLOTS_COLUMNS = { "row-actions": {
	label: "",
	name: "actions"
} };
var Table_vue_vue_type_script_lang_default = defineComponent({
	name: "RvTable",
	components: {
		ActionButton: ActionButton_default,
		Checkbox: Checkbox_default,
		NoData: NoData_default,
		QIcon: QIcon_default,
		QMenu: QMenu_default,
		QResizeObserver: QResizeObserver_default,
		QSpace: QSpace_default,
		QTable: QTable_default,
		QTd: QTd_default,
		QTh: QTh_default,
		QTr: QTr_default,
		RvButton: Button_default,
		RvInput: Input_default,
		TableCard: TableCard_default,
		TableFullRowStatusCell: TableFullRowStatusCell_default,
		TablePagination: TablePagination_default,
		TableSortBy: TableSortBy_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		bottomPaginationCentered: {
			type: Boolean,
			default: false
		},
		bottomPaginationSeparated: {
			type: Boolean,
			default: false
		},
		clickableCard: {
			type: Boolean,
			default: false
		},
		defaultGrid: {
			type: Boolean,
			default: false
		},
		fakeSelection: {
			type: Boolean,
			default: false
		},
		fullHeight: {
			type: Boolean,
			default: false
		},
		gridClass: {
			type: Function,
			default: () => String
		},
		gridResponsive: {
			type: Boolean,
			default: true
		},
		hideGridButton: {
			type: Boolean,
			default: false
		},
		hideHeader: {
			type: Boolean,
			default: false
		},
		getRowActionsVisibility: {
			type: Function,
			default: () => RowActionsVisibility.HiddenUntilHover
		},
		hideListButton: {
			type: Boolean,
			default: false
		},
		hidePagination: {
			type: Boolean,
			default: true
		},
		hideRightSidebar: {
			type: Boolean,
			default: true
		},
		hidePageSizeSelection: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			required: true
		},
		/**
		* When it returns a non-null value for a row, the first column stays and
		* every other cell collapses into one status cell. The
		* returned value renders by default as a label next to a spinner. Use the
		* `#full-row-status` slot to render custom content per row. Defaults to
		* a no-op, leaving rendering unchanged. No-op in card view.
		*/
		fullRowStatus: {
			type: Function,
			default: () => null
		},
		noPersistConfig: {
			type: Boolean,
			default: false
		},
		rowsPerPageOptions: {
			type: Array,
			default: void 0
		},
		selected: {
			type: Array,
			default: () => void 0
		},
		selectable: {
			type: Boolean,
			default: true
		},
		selectedTitle: {
			type: String,
			default: ""
		},
		selection: {
			type: String,
			default: "multiple"
		},
		showSelectCount: {
			type: Boolean,
			default: false
		},
		showSortBy: {
			type: Boolean,
			default: false
		},
		showTopPagination: {
			type: Boolean,
			default: false
		},
		virtualScroll: {
			type: Boolean,
			default: true
		},
		withFilters: {
			type: Boolean,
			default: true
		},
		customActions: {
			type: Boolean,
			default: false
		},
		wrapperClass: {
			type: [
				Array,
				String,
				Object
			],
			default: void 0
		},
		tableRowClassFn: {
			type: Function,
			default: void 0
		},
		/**
		* For some strange reason previously we have not passed slot data
		* for cells into the actual <QTd /> and <QTh/> components
		* And it caused `columnConfig.classes` to not properly work.
		*
		* When this property is `true` the old behavior is preserved.
		*
		* Otherwise we pass cell slotData to `QTd` and `QTh` components.
		*
		* If you are adding another usage of Table component
		* please DO NOT pass this property.
		*/
		legacyDisablePropsPassing: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"card-click",
		"menuChange",
		"on-toggle-all",
		"set-columns",
		"set-grid",
		"update:selected"
	],
	setup(props, { emit, slots }) {
		const { t } = useI18n();
		const { allSelected, allSelectedValue, clearSelection, columns, colWidth, disableNextButton, disablePreviousButton, enableSelection, filteredSelected, filters, getConfig, hasFilterableValues, hasFilters, hasNoData, hasRowActions, hasSearchQueryFilter, initializeFilters, isCarouselEnabled, isRowDisabled, isRowImmutable, nextColumn, onRequest, onResize, pagination, prevColumn, resetFilters, resetSearchQuery, rowDisabledTooltip, rowKey, rows, search, searchable, selectableRows, selecting, serverLoading, setCarouselCalculationsEnabled, setConfig, tableRef, toggleAll, toggleSelected, toggleSelecting, totalRows, transformOffsetLeft, updateSelection } = useTable();
		const { isDefaultLayout, showRightSidebar, toggleRightSidebar } = useLayout();
		let scrollTicking = false;
		function getRowClass(row) {
			return [props.tableRowClassFn?.(row) ?? "", isRowDisabled(row) ? "rv-table-row--disabled" : ""].filter(Boolean).join(" ");
		}
		const config = !props.noPersistConfig && getConfig() || void 0;
		const thRefs = ref([]);
		const wrapperRef = ref(null);
		const grid = ref(config?.grid ?? props.defaultGrid);
		const menuOpen = ref(null);
		const isScrolled = ref(false);
		const isScrolledGrid = ref(false);
		const hasVerticalScroll = ref(false);
		const hasScrollbar = ref(false);
		const allColumns = computed(() => {
			return [
				...columns.value,
				...slotsColumns.value,
				isCarouselEnabled.value && {
					label: "",
					name: "carousel-next"
				}
			].filter(Boolean);
		});
		const otherColumns = computed(() => {
			const cellSlots = Object.keys(slots).filter((x) => x.startsWith("body-cell-")).map((x) => x.replace(/^body-cell-/, ""));
			return columns.value.filter((c) => !cellSlots.includes(c.name));
		});
		const fullRowStatusColspan = computed(() => Math.max(allColumns.value.length - 1, 1));
		function hasFullRowStatus(row) {
			return !!props.fullRowStatus(row);
		}
		function fullRowStatusCell(colName, row) {
			if (!hasFullRowStatus(row) || colName === columns.value[0]?.name) return "normal";
			return colName === columns.value[1]?.name ? "anchor" : "hidden";
		}
		const cssVars = computed(() => {
			return {
				"--table-col-width": colWidth.value,
				"--table-transform": `translate(-${transformOffsetLeft.value}px, 0)`
			};
		});
		const filteredRowsCount = computed(() => pagination.value.rowsNumber);
		const hasFilteredRows = computed(() => filteredRowsCount.value !== totalRows.value);
		const hasSelectedRows = computed(() => !!allSelected.value.length);
		const isFiltersPanelOpened = computed(() => isDefaultLayout.value);
		const isLoading = computed(() => props.loading || serverLoading.value);
		const isTableEmpty = computed(() => {
			return hasNoData.value && !isLoading.value || hasNoFiltersResult.value || hasNoSearchQueryResult.value;
		});
		const hasDivider = computed(() => {
			return !disablePreviousButton.value;
		});
		const hasNoFiltersResult = computed(() => {
			return !rows.value.length && !isLoading.value && hasFilters.value;
		});
		const hasNoSearchQueryResult = computed(() => {
			return !rows.value.length && !isLoading.value && hasSearchQueryFilter.value;
		});
		const slotsColumns = computed(() => {
			return Object.keys(SLOTS_COLUMNS).filter((k) => {
				if (k === "row-actions" && !hasRowActions) return false;
				return !!slots[k];
			}).map((k) => SLOTS_COLUMNS[k]);
		});
		const visibleColumns = computed(() => {
			return allColumns.value.map((c) => c.name);
		});
		const checkForScrollbar = () => {
			if (wrapperRef.value) hasScrollbar.value = wrapperRef.value.scrollHeight > wrapperRef.value.clientHeight;
		};
		function hasActionsColumn(columns) {
			return columns.some((v) => v.name === "actions");
		}
		function checkVirtualScrollPresented() {
			const children = tableRef.value?.$el.children;
			if (!children) return false;
			const virtualScrollElement = [...children].find((el) => el.classList.contains("q-virtual-scroll"));
			return virtualScrollElement?.scrollHeight > virtualScrollElement?.clientHeight;
		}
		function onCardClick(row) {
			if (!props.clickableCard) return;
			emit("card-click", row);
		}
		function onCheckboxClick(row, event) {
			if (props.fakeSelection) return;
			toggleSelected(row, event.shiftKey);
		}
		function onClearSelection() {
			clearSelection();
			emit("on-toggle-all", false);
		}
		function onMenuChange(open, row) {
			menuOpen.value = open ? row : null;
			emit("menuChange", open, row);
		}
		function onScrollVirtual(v) {
			isScrolled.value = v.index !== 0;
		}
		function onScrollWrapper() {
			if (!scrollTicking) {
				window.requestAnimationFrame(() => {
					isScrolledGrid.value = !!(wrapperRef.value?.scrollTop && wrapperRef.value?.scrollTop > 0);
					scrollTicking = false;
				});
				scrollTicking = true;
			}
		}
		function onToggleAll(value) {
			toggleAll(value);
			emit("on-toggle-all", value);
		}
		function setThRef(el) {
			if (el) thRefs.value.push(el);
		}
		function showThTooltip(index) {
			const el = thRefs.value[index]?.$el;
			return !!el && el.scrollWidth > el.clientWidth;
		}
		const onVirtualScroll = throttle((event) => {
			if (!event.composedPath().some((el) => el.classList?.contains("q-virtual-scroll"))) return;
			if (event.deltaX > 0 && !disableNextButton.value) nextColumn();
			if (event.deltaX < 0 && !disablePreviousButton.value) prevColumn();
		}, 300, { trailing: false });
		function setGrid(value) {
			grid.value = value;
			setCarouselCalculationsEnabled(!value);
			if (!props.noPersistConfig) setConfig({ grid: grid.value });
			emit("set-grid", value);
		}
		watch(filteredSelected, (value) => {
			emit("update:selected", value);
			nextTick(() => {
				hasVerticalScroll.value = checkVirtualScrollPresented();
			});
		});
		watch(() => props.selected, (value) => {
			if (value) updateSelection(value);
		});
		watch(columns, () => {
			initializeFilters();
		});
		onMounted(() => {
			if (props.selected?.length && !allSelected.value.length) allSelected.value = props.selected;
			tableRef.value?.requestServerInteraction();
			initializeFilters();
			if (!hasNoData.value && showRightSidebar.value && props.hideRightSidebar) toggleRightSidebar();
			if (isCarouselEnabled.value) document.addEventListener("wheel", onVirtualScroll);
			if (grid.value) checkForScrollbar();
		});
		onUpdated(() => {
			if (grid.value) checkForScrollbar();
		});
		onUnmounted(() => {
			if (isCarouselEnabled.value) document.removeEventListener("wheel", onVirtualScroll);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			allColumns,
			allSelected,
			allSelectedValue,
			colWidth,
			cssVars,
			disableNextButton,
			disablePreviousButton,
			enableSelection,
			filteredRowsCount,
			filters,
			fullRowStatusCell,
			fullRowStatusColspan,
			getRowClass,
			grid,
			hasActionsColumn,
			hasDivider,
			hasFilterableValues,
			hasFilteredRows,
			hasFilters,
			hasFullRowStatus,
			hasNoData,
			hasNoFiltersResult,
			hasNoSearchQueryResult,
			hasScrollbar,
			hasSearchQueryFilter,
			hasSelectedRows,
			hasVerticalScroll,
			isCarouselEnabled,
			isFiltersPanelOpened,
			isLoading,
			isRowDisabled,
			isRowImmutable,
			isScrolled,
			isScrolledGrid,
			isTableEmpty,
			menuOpen,
			nextColumn,
			onCardClick,
			onCheckboxClick,
			onClearSelection,
			onMenuChange,
			onRequest,
			onResize,
			onScrollVirtual,
			onScrollWrapper,
			onToggleAll,
			otherColumns,
			pagination,
			prevColumn,
			resetFilters,
			resetSearchQuery,
			RowActionsVisibility,
			rowDisabledTooltip,
			rowKey,
			rows,
			search,
			searchable,
			selectableRows,
			selecting,
			setGrid,
			setThRef,
			showThTooltip,
			slots,
			t,
			tableRef,
			toggleRightSidebar,
			toggleSelecting,
			totalRows,
			visibleColumns,
			wrapperRef
		};
	}
});
//#endregion
//#region src/components/Table.vue
var _hoisted_1$15 = ["data-automation"];
var _hoisted_2$9 = { class: "rv-table__top row no-wrap full-width" };
var _hoisted_3$8 = { class: "rv-table__top-left row no-wrap items-center" };
var _hoisted_4$5 = {
	key: 0,
	class: "rv-table__modes row no-wrap"
};
var _hoisted_5$5 = { class: "rv-table__top__bulk-actions row" };
var _hoisted_6$2 = { class: "row no-wrap q-gutter-x-sm items-center" };
var _hoisted_7$2 = {
	key: 0,
	class: "rv-table__top-inside row no-wrap full-width"
};
var _hoisted_8$1 = {
	key: 1,
	class: "flex full-width justify-between q-px-md q-pb-sm"
};
var _hoisted_9$1 = { class: "flex flex-center" };
var _hoisted_10$1 = {
	key: 0,
	class: "text-body3 text-grey-1"
};
var _hoisted_11$1 = {
	key: 1,
	class: "text-body3 text-grey-1 q-mx-xs"
};
var _hoisted_12 = {
	key: 2,
	class: "text-body3 text-grey-1"
};
var _hoisted_13 = {
	key: 2,
	class: "flex full-width justify-between q-pt-md bg-grey-5"
};
var _hoisted_14 = { class: "flex flex-center" };
var _hoisted_15 = {
	key: 3,
	class: "flex full-width justify-end q-pt-md bg-grey-5"
};
var _hoisted_16 = { class: "rv-table__header__backplate" };
var _hoisted_17 = {
	key: 1,
	class: "rv-table__row-progress absolute",
	style: {
		"right": "64px",
		"top": "19px"
	}
};
var _hoisted_18 = {
	class: "absolute text-bold",
	style: {
		"right": "0",
		"z-index": "2"
	}
};
var _hoisted_19 = {
	class: "row no-wrap flex items-center",
	style: { "height": "32px" }
};
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	const _component_ActionButton = resolveComponent("ActionButton");
	const _component_TablePagination = resolveComponent("TablePagination");
	const _component_RvButton = resolveComponent("RvButton");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_QIcon = resolveComponent("QIcon");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_Checkbox = resolveComponent("Checkbox");
	const _component_TableSortBy = resolveComponent("TableSortBy");
	const _component_TableCard = resolveComponent("TableCard");
	const _component_QTh = resolveComponent("QTh");
	const _component_Tooltip = resolveComponent("Tooltip");
	const _component_QTr = resolveComponent("QTr");
	const _component_QMenu = resolveComponent("QMenu");
	const _component_QTd = resolveComponent("QTd");
	const _component_TableFullRowStatusCell = resolveComponent("TableFullRowStatusCell");
	const _component_QTable = resolveComponent("QTable");
	const _component_NoData = resolveComponent("NoData");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["rv-table__wrapper", [_ctx.wrapperClass, { "rv-table__wrapper--full-height": _ctx.fullHeight }]]),
		"data-automation": _ctx.buildId()
	}, [createElementVNode("div", {
		ref: "wrapperRef",
		class: normalizeClass(["rv-table", {
			"rv-table--carousel": _ctx.isCarouselEnabled,
			"rv-table--grid": _ctx.grid,
			"rv-table--list": !_ctx.grid,
			"rv-table--select": _ctx.selection !== "none",
			"rv-table--shadow": _ctx.grid && _ctx.isScrolledGrid,
			"rv-table--empty": _ctx.isTableEmpty,
			"rv-table--without-selection": !_ctx.enableSelection,
			"rv-table--pagination-separated": _ctx.bottomPaginationSeparated,
			"rv-table--with-scrollbar": _ctx.hasScrollbar,
			"rv-table--full-height": _ctx.fullHeight
		}]),
		style: normalizeStyle(_ctx.cssVars),
		onScroll: _cache[7] || (_cache[7] = (...args) => _ctx.onScrollWrapper && _ctx.onScrollWrapper(...args))
	}, [createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]), createVNode(_component_QTable, mergeProps(_ctx.$attrs, {
		ref: "tableRef",
		pagination: _ctx.pagination,
		"onUpdate:pagination": _cache[5] || (_cache[5] = ($event) => _ctx.pagination = $event),
		selected: _ctx.allSelected,
		"onUpdate:selected": _cache[6] || (_cache[6] = ($event) => _ctx.allSelected = $event),
		"card-container-class": ["rv-table__grid", {
			"rv-table__grid--responsive": _ctx.gridResponsive,
			hidden: !_ctx.totalRows
		}],
		class: ["rv-table__element", { "rv-table--no-margin": !_ctx.totalRows }],
		color: "primary",
		columns: _ctx.allColumns,
		filter: _ctx.filters,
		flat: "",
		grid: _ctx.grid,
		"hide-no-data": "",
		"hide-pagination": _ctx.hidePagination,
		"hide-selected-banner": "",
		loading: _ctx.isLoading,
		"row-key": _ctx.rowKey,
		rows: _ctx.rows,
		"rows-per-page-options": _ctx.rowsPerPageOptions,
		selection: _ctx.selection,
		separator: "none",
		"table-class": [
			_ctx.totalRows ? "rv-table__content" : "rv-table__content--hide",
			_ctx.hasVerticalScroll && "rv-table__content--with-scroll",
			_ctx.hasDivider && "rv-table__content--with-divider"
		],
		"table-header-class": "rv-table__header",
		"table-row-class-fn": _ctx.getRowClass,
		"virtual-scroll": _ctx.virtualScroll,
		"virtual-scroll-sticky-size-start": "56",
		"visible-columns": _ctx.visibleColumns,
		onRequest: _ctx.onRequest,
		onVirtualScroll: _ctx.onScrollVirtual
	}), createSlots({
		item: withCtx((props) => [createVNode(_component_TableCard, {
			class: normalizeClass(_ctx.gridClass(props.row)),
			"clickable-card": !_ctx.isRowImmutable(props.row) && _ctx.clickableCard,
			"custom-actions": _ctx.customActions,
			dark: props.dark,
			"data-automation": _ctx.buildId(`card-${props.row[_ctx.rowKey]}`),
			row: props.row,
			selecting: _ctx.selecting,
			onClick: ($event) => !_ctx.isRowImmutable(props.row) && _ctx.onCardClick(props.row),
			onMenuChange: _ctx.onMenuChange
		}, createSlots({
			select: withCtx(() => [!_ctx.isRowImmutable(props.row) ? (openBlock(), createBlock(_component_Checkbox, {
				key: 0,
				class: "q-mr-sm",
				"data-automation": _ctx.buildId(`card-${props.row[_ctx.rowKey]}__checkbox`),
				dense: "",
				disable: _ctx.fakeSelection,
				"model-value": _ctx.fakeSelection ? true : props.selected,
				onClick: ($event) => _ctx.onCheckboxClick(props.row, $event)
			}, null, 8, [
				"data-automation",
				"disable",
				"model-value",
				"onClick"
			])) : createCommentVNode("", true)]),
			cardHeader: withCtx(() => [renderSlot(_ctx.$slots, "cardHeader", normalizeProps(guardReactiveProps(props || {})))]),
			cardTitle: withCtx(() => [renderSlot(_ctx.$slots, "cardTitle", normalizeProps(guardReactiveProps(props || {})))]),
			cardContent: withCtx(() => [renderSlot(_ctx.$slots, "cardContent", normalizeProps(guardReactiveProps(props || {})))]),
			_: 2
		}, [_ctx.$slots["row-actions"] && _ctx.getRowActionsVisibility(props.row) !== _ctx.RowActionsVisibility.NoActions ? {
			name: "actions",
			fn: withCtx(() => [renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props || {})))]),
			key: "0"
		} : void 0]), 1032, [
			"class",
			"clickable-card",
			"custom-actions",
			"dark",
			"data-automation",
			"row",
			"selecting",
			"onClick",
			"onMenuChange"
		])]),
		header: withCtx((props) => [createVNode(_component_QTr, {
			class: "rv-table__header",
			props
		}, {
			default: withCtx(() => [
				createVNode(_component_QTh, { class: "flex items-center bg-grey-5--light bg-grey-1--dark" }, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "select-all", {}, () => [_ctx.enableSelection ? (openBlock(), createBlock(_component_Checkbox, {
						key: 0,
						"data-automation": _ctx.buildId("selectAll"),
						disable: _ctx.fakeSelection || !_ctx.selectableRows.length,
						"model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
						"onUpdate:modelValue": _ctx.onToggleAll
					}, null, 8, [
						"data-automation",
						"disable",
						"model-value",
						"onUpdate:modelValue"
					])) : createCommentVNode("", true)])]),
					_: 3
				}),
				(openBlock(true), createElementBlock(Fragment, null, renderList(props.cols.filter((v) => v.name !== "actions" && v.name !== "carousel-next"), (col, i) => {
					return openBlock(), createBlock(_component_QTh, {
						key: col.name,
						ref_for: true,
						ref: _ctx.setThRef,
						class: "rv-table__header__column ellipsis",
						props,
						style: normalizeStyle({ ..._ctx.isCarouselEnabled && {
							width: _ctx.colWidth,
							"max-width": _ctx.colWidth,
							"min-width": _ctx.colWidth
						} })
					}, {
						default: withCtx(() => [
							_ctx.$slots[`header-cell-${col.name}`] ? renderSlot(_ctx.$slots, `header-cell-${col.name}`, mergeProps({ ref_for: true }, col || {}), void 0, void 0, 0) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(toDisplayString(col.label), 1)], 64)),
							_ctx.showThTooltip(i) ? (openBlock(), createBlock(_component_Tooltip, {
								key: 2,
								"data-automation": _ctx.buildId("thTooltip")
							}, {
								default: withCtx(() => [createTextVNode(toDisplayString(col.label), 1)]),
								_: 2
							}, 1032, ["data-automation"])) : createCommentVNode("", true),
							_ctx.isCarouselEnabled && i === 0 ? (openBlock(), createBlock(_component_RvButton, {
								key: 3,
								class: "rv-table__header__move-prev rv-table--transition-opacity full-height",
								color: "grey-1",
								"data-automation": _ctx.buildId("prevColumn"),
								disable: _ctx.disablePreviousButton,
								icon: "mdi-chevron-left",
								style: normalizeStyle({ opacity: `${_ctx.disablePreviousButton ? 0 : 1} !important` }),
								tertiary: "",
								onClick: withModifiers(_ctx.prevColumn, ["stop"])
							}, null, 8, [
								"data-automation",
								"disable",
								"style",
								"onClick"
							])) : createCommentVNode("", true)
						]),
						_: 2
					}, 1032, ["props", "style"]);
				}), 128)),
				_ctx.hasActionsColumn(props.cols) ? (openBlock(), createBlock(_component_QTh, {
					key: 0,
					class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__action-column"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "header-cell-actions")]),
					_: 3
				})) : createCommentVNode("", true),
				_ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, {
					key: 1,
					class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__move-next"
				}, {
					default: withCtx(() => [createElementVNode("div", _hoisted_16, [createVNode(_component_RvButton, {
						class: "rv-table__header__move-next__button rv-table--transition-opacity",
						color: "grey-1",
						"data-automation": _ctx.buildId("nextColumn"),
						disable: _ctx.disableNextButton,
						icon: "mdi-chevron-right",
						style: normalizeStyle({ opacity: `${_ctx.disableNextButton ? 0 : 1} !important` }),
						tertiary: "",
						onClick: withModifiers(_ctx.nextColumn, ["stop"])
					}, null, 8, [
						"data-automation",
						"disable",
						"style",
						"onClick"
					])])]),
					_: 1
				})) : createCommentVNode("", true)
			]),
			_: 2
		}, 1032, ["props"]), createVNode(_component_QTr, { class: normalizeClass(["rv-table__header__shadow-column", { "rv-table__header__shadow-column--active": _ctx.isScrolled }]) }, {
			default: withCtx(() => [
				createVNode(_component_QTh),
				(openBlock(true), createElementBlock(Fragment, null, renderList(props.cols.filter((v) => v.name !== "actions"), (col) => {
					return openBlock(), createBlock(_component_QTh, { key: col.name });
				}), 128)),
				_ctx.hasActionsColumn(props.cols) ? (openBlock(), createBlock(_component_QTh, { key: 0 })) : createCommentVNode("", true),
				_ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, { key: 1 })) : createCommentVNode("", true)
			]),
			_: 2
		}, 1032, ["class"])]),
		"body-cell-actions": withCtx((props) => [!_ctx.hasFullRowStatus(props.row) ? (openBlock(), createBlock(_component_QTd, {
			key: 0,
			class: "rv-table__cell rv-table__cell--fixed rv-table__row-actions-wrapper",
			props: _ctx.legacyDisablePropsPassing ? void 0 : props
		}, {
			default: withCtx(() => [_ctx.getRowActionsVisibility(props.row) !== _ctx.RowActionsVisibility.NoActions ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(["rv-table__row-actions cursor-pointer", {
					"rv-table__row-actions--open": _ctx.menuOpen === props.row,
					"rv-table__row-actions-hidden-until-hover": _ctx.getRowActionsVisibility(props.row) == _ctx.RowActionsVisibility.HiddenUntilHover
				}])
			}, [_ctx.customActions ? renderSlot(_ctx.$slots, "row-actions", mergeProps(props, {
				menuOpen: _ctx.menuOpen === props.row,
				onMenuChange: (open) => _ctx.onMenuChange(open, props.row)
			}), void 0, void 0, 0) : (openBlock(), createBlock(_component_RvButton, {
				key: 1,
				class: "no-padding",
				color: "grey-1",
				"data-automation": _ctx.buildId("dots"),
				icon: "mdi-dots-horizontal",
				tertiary: ""
			}, {
				default: withCtx(() => [createVNode(_component_QMenu, {
					anchor: "bottom middle",
					"auto-close": "",
					self: "top middle",
					"onUpdate:modelValue": ($event) => _ctx.onMenuChange($event, props.row)
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props || {})))]),
					_: 2
				}, 1032, ["onUpdate:modelValue"])]),
				_: 2
			}, 1032, ["data-automation"]))], 2)) : createCommentVNode("", true), _ctx.$slots["row-progress"] ? (openBlock(), createElementBlock("div", _hoisted_17, [createElementVNode("div", _hoisted_18, [createElementVNode("div", _hoisted_19, [renderSlot(_ctx.$slots, "row-progress", normalizeProps(guardReactiveProps(props || {})))])])])) : createCommentVNode("", true)]),
			_: 2
		}, 1032, ["props"])) : createCommentVNode("", true)]),
		"body-cell-carousel-next": withCtx((props) => [!_ctx.hasFullRowStatus(props.row) ? (openBlock(), createBlock(_component_QTd, {
			key: 0,
			class: "rv-table__cell rv-table__cell--fixed",
			props: _ctx.legacyDisablePropsPassing ? void 0 : props
		}, null, 8, ["props"])) : createCommentVNode("", true)]),
		"body-selection": withCtx((props) => [_ctx.enableSelection && (!_ctx.isRowImmutable(props.row) || _ctx.isRowDisabled(props.row)) ? (openBlock(), createBlock(_component_Checkbox, {
			key: 0,
			class: "rv-table__body-selection",
			"data-automation": _ctx.buildId(`row-${props.row[_ctx.rowKey]}__checkbox`),
			disable: _ctx.fakeSelection || _ctx.isRowDisabled(props.row),
			"model-value": _ctx.fakeSelection ? true : props.selected,
			onClick: ($event) => _ctx.onCheckboxClick(props.row, $event)
		}, null, 8, [
			"data-automation",
			"disable",
			"model-value",
			"onClick"
		])) : _ctx.enableSelection ? renderSlot(_ctx.$slots, "selection-replacement", { row: props.row }, void 0, void 0, 1) : createCommentVNode("", true)]),
		loading: withCtx(() => [createElementVNode("div", {
			class: "rv-table__loading q-linear-progress__model absolute-full q-linear-progress__model--with-transition q-linear-progress__model--indeterminate",
			style: normalizeStyle({ ...!_ctx.hideHeader && { top: "56px" } })
		}, null, 4)]),
		_: 2
	}, [
		!_ctx.hideHeader ? {
			name: "top",
			fn: withCtx(() => [
				createElementVNode("div", _hoisted_2$9, [
					createElementVNode("div", _hoisted_3$8, [!_ctx.hideGridButton || !_ctx.hideListButton || _ctx.$slots["table-modes"] || !_ctx.hidePagination && _ctx.showTopPagination && _ctx.totalRows ? (openBlock(), createElementBlock("div", _hoisted_4$5, [
						!_ctx.hideGridButton ? (openBlock(), createBlock(_component_ActionButton, {
							key: 0,
							"data-automation": _ctx.buildId("module"),
							icon: "mdi-view-module",
							selected: _ctx.grid,
							tooltip: _ctx.t("rvai-base.general.table.thumbnailsView"),
							onClick: _cache[0] || (_cache[0] = ($event) => _ctx.setGrid(true))
						}, null, 8, [
							"data-automation",
							"selected",
							"tooltip"
						])) : createCommentVNode("", true),
						!_ctx.hideListButton ? (openBlock(), createBlock(_component_ActionButton, {
							key: 1,
							"data-automation": _ctx.buildId("list"),
							icon: "mdi-view-list",
							selected: !_ctx.grid,
							tooltip: _ctx.t("rvai-base.general.table.listView"),
							onClick: _cache[1] || (_cache[1] = ($event) => _ctx.setGrid(false))
						}, null, 8, [
							"data-automation",
							"selected",
							"tooltip"
						])) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "table-modes"),
						!_ctx.hidePagination && _ctx.showTopPagination && _ctx.totalRows ? (openBlock(), createBlock(_component_TablePagination, {
							key: 2,
							"data-automation": _ctx.buildId("paginationTop"),
							"rows-per-page-options": _ctx.rowsPerPageOptions
						}, null, 8, ["data-automation", "rows-per-page-options"])) : createCommentVNode("", true)
					])) : createCommentVNode("", true), createElementVNode("div", _hoisted_5$5, [_ctx.enableSelection && _ctx.selectable && _ctx.grid ? (openBlock(), createBlock(_component_RvButton, {
						key: 0,
						color: "primary",
						"data-automation": _ctx.buildId("select"),
						disable: !_ctx.totalRows,
						icon: _ctx.selecting && _ctx.totalRows ? "mdi-close" : "mdi-content-copy",
						label: _ctx.selecting && _ctx.totalRows ? _ctx.t("rvai-base.general.table.cancel") : _ctx.t("rvai-base.general.table.select"),
						size: "sm",
						tertiary: "",
						onClick: _ctx.toggleSelecting
					}, null, 8, [
						"data-automation",
						"disable",
						"icon",
						"label",
						"onClick"
					])) : createCommentVNode("", true), _ctx.selected?.length ? renderSlot(_ctx.$slots, "actions", {}, void 0, void 0, 1) : createCommentVNode("", true)])]),
					createVNode(_component_QSpace),
					createElementVNode("div", _hoisted_6$2, [_ctx.searchable ? (openBlock(), createBlock(_component_RvInput, {
						key: 0,
						modelValue: _ctx.search,
						"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.search = $event),
						class: "rv-table__search",
						"clear-icon": "mdi-close",
						clearable: "",
						"data-automation": _ctx.buildId("search"),
						dense: "",
						disable: _ctx.hasNoData,
						placeholder: _ctx.t("rvai-base.general.table.search")
					}, {
						prepend: withCtx(() => [createVNode(_component_QIcon, {
							color: "grey-1",
							name: "search"
						})]),
						_: 1
					}, 8, [
						"modelValue",
						"data-automation",
						"disable",
						"placeholder"
					])) : createCommentVNode("", true), _ctx.withFilters ? (openBlock(), createBlock(_component_ActionButton, {
						key: 1,
						"data-automation": _ctx.buildId("sidebar"),
						disable: _ctx.hasNoData || !_ctx.hasFilterableValues,
						icon: "mdi-filter",
						selected: _ctx.isFiltersPanelOpened || _ctx.hasFilters,
						tooltip: _ctx.t("rvai-base.general.table.filter"),
						onClick: _ctx.toggleRightSidebar
					}, null, 8, [
						"data-automation",
						"disable",
						"selected",
						"tooltip",
						"onClick"
					])) : createCommentVNode("", true)]),
					renderSlot(_ctx.$slots, "top-right")
				]),
				_ctx.$slots["top-inside"] && !_ctx.grid ? (openBlock(), createElementBlock("div", _hoisted_7$2, [renderSlot(_ctx.$slots, "top-inside")])) : createCommentVNode("", true),
				!_ctx.grid && _ctx.showSelectCount && _ctx.totalRows && (_ctx.hasSelectedRows || _ctx.hasFilteredRows) ? (openBlock(), createElementBlock("div", _hoisted_8$1, [createElementVNode("div", _hoisted_9$1, [
					_ctx.hasSelectedRows ? (openBlock(), createElementBlock("div", _hoisted_10$1, toDisplayString(_ctx.allSelected.length ? _ctx.t("rvai-base.general.table.selected", [_ctx.allSelected.length, _ctx.totalRows]) : _ctx.t("rvai-base.general.table.total", [_ctx.totalRows])), 1)) : createCommentVNode("", true),
					_ctx.hasSelectedRows && _ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_11$1, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1)) : createCommentVNode("", true),
					_ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString(_ctx.t("rvai-base.general.table.filteredResults", [_ctx.filteredRowsCount, _ctx.totalRows])), 1)) : createCommentVNode("", true),
					_ctx.allSelected.length ? (openBlock(), createBlock(_component_RvButton, {
						key: 3,
						class: "q-ml-xs",
						"data-automation": _ctx.buildId("clear"),
						label: _ctx.t("rvai-base.general.table.clear"),
						size: "sm",
						style: {
							"padding-top": "0",
							"padding-bottom": "0"
						},
						tertiary: "",
						onClick: _cache[3] || (_cache[3] = ($event) => _ctx.onClearSelection())
					}, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)
				])])) : _ctx.grid && _ctx.selecting && _ctx.totalRows ? (openBlock(), createElementBlock("div", _hoisted_13, [createElementVNode("div", _hoisted_14, [createVNode(_component_Checkbox, {
					class: "q-ml-md",
					"data-automation": _ctx.buildId("selectAll"),
					dense: "",
					disable: _ctx.fakeSelection,
					label: _ctx.t("rvai-base.general.table.selected", [_ctx.allSelected.length, _ctx.totalRows]),
					"model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
					"onUpdate:modelValue": _ctx.onToggleAll
				}, null, 8, [
					"data-automation",
					"disable",
					"label",
					"model-value",
					"onUpdate:modelValue"
				]), _ctx.allSelected.length ? (openBlock(), createBlock(_component_RvButton, {
					key: 0,
					class: "q-ml-xs",
					"data-automation": _ctx.buildId("clear"),
					label: _ctx.t("rvai-base.general.table.clear"),
					size: "sm",
					style: {
						"padding-top": "0",
						"padding-bottom": "0"
					},
					tertiary: "",
					onClick: _cache[4] || (_cache[4] = ($event) => _ctx.onClearSelection())
				}, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)]), createVNode(_component_TableSortBy, { "data-automation": _ctx.buildId("sortBy") }, null, 8, ["data-automation"])])) : _ctx.showSortBy && _ctx.grid && _ctx.totalRows && !_ctx.selecting ? (openBlock(), createElementBlock("div", _hoisted_15, [createVNode(_component_TableSortBy, { "data-automation": _ctx.buildId("sortBy") }, null, 8, ["data-automation"])])) : createCommentVNode("", true)
			]),
			key: "0"
		} : void 0,
		renderList(_ctx.otherColumns, (col) => {
			return {
				name: `body-cell-${col.name}`,
				fn: withCtx((slotData) => [_ctx.fullRowStatusCell(col.name, slotData.row) === "anchor" ? (openBlock(), createBlock(_component_TableFullRowStatusCell, {
					key: 0,
					colspan: _ctx.fullRowStatusColspan,
					"has-custom-status": !!_ctx.slots["full-row-status"],
					label: _ctx.fullRowStatus(slotData.row)
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "full-row-status", {
						label: _ctx.fullRowStatus(slotData.row),
						row: slotData.row
					})]),
					_: 2
				}, 1032, [
					"colspan",
					"has-custom-status",
					"label"
				])) : _ctx.fullRowStatusCell(col.name, slotData.row) !== "hidden" ? (openBlock(), createBlock(_component_QTd, {
					key: 1,
					classes: _ctx.legacyDisablePropsPassing ? slotData.col.classes : void 0,
					"data-automation": _ctx.buildId(`td-body-cell-${col.name}`),
					props: _ctx.legacyDisablePropsPassing ? void 0 : slotData,
					style: normalizeStyle(_ctx.legacyDisablePropsPassing ? slotData.col.style : void 0)
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, `body-cell-${col.name}`, normalizeProps(guardReactiveProps(slotData || {})), () => [createTextVNode(toDisplayString(slotData.value ?? ""), 1)]), _ctx.isRowDisabled(slotData.row) && _ctx.rowDisabledTooltip(slotData.row) ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.rowDisabledTooltip(slotData.row)), 1)]),
						_: 2
					}, 1024)) : createCommentVNode("", true)]),
					_: 2
				}, 1032, [
					"classes",
					"data-automation",
					"props",
					"style"
				])) : createCommentVNode("", true)])
			};
		}),
		!_ctx.hidePagination ? {
			name: "bottom",
			fn: withCtx(() => [createVNode(_component_TablePagination, {
				centered: _ctx.bottomPaginationCentered,
				"data-automation": _ctx.buildId("pagination"),
				"hide-page-size-selection": _ctx.hidePageSizeSelection,
				"rows-per-page-options": _ctx.rowsPerPageOptions,
				separated: _ctx.bottomPaginationSeparated
			}, null, 8, [
				"centered",
				"data-automation",
				"hide-page-size-selection",
				"rows-per-page-options",
				"separated"
			])]),
			key: "1"
		} : void 0,
		renderList(_ctx.slots, (_, name) => {
			return {
				name,
				fn: withCtx((slotData) => [String(name).startsWith("body-cell-") ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.fullRowStatusCell(String(name).replace(/^body-cell-/, ""), slotData.row) === "anchor" ? (openBlock(), createBlock(_component_TableFullRowStatusCell, {
					key: `${name}-status`,
					colspan: _ctx.fullRowStatusColspan,
					"has-custom-status": !!_ctx.slots["full-row-status"],
					label: _ctx.fullRowStatus(slotData.row)
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "full-row-status", {
						label: _ctx.fullRowStatus(slotData.row),
						row: slotData.row
					})]),
					_: 2
				}, 1032, [
					"colspan",
					"has-custom-status",
					"label"
				])) : _ctx.fullRowStatusCell(String(name).replace(/^body-cell-/, ""), slotData.row) !== "hidden" ? (openBlock(), createBlock(_component_QTd, {
					key: name,
					classes: _ctx.legacyDisablePropsPassing ? slotData.col.classes : void 0,
					"data-automation": _ctx.buildId(`td-${name}`),
					props: slotData,
					style: normalizeStyle(_ctx.legacyDisablePropsPassing ? slotData.col.style : void 0)
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {}))), _ctx.isRowDisabled(slotData.row) && _ctx.rowDisabledTooltip(slotData.row) ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.rowDisabledTooltip(slotData.row)), 1)]),
						_: 2
					}, 1024)) : createCommentVNode("", true)]),
					_: 2
				}, 1032, [
					"classes",
					"data-automation",
					"props",
					"style"
				])) : createCommentVNode("", true)], 64)) : renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData || {})), void 0, void 0, 1)])
			};
		})
	]), 1040, [
		"pagination",
		"selected",
		"card-container-class",
		"class",
		"columns",
		"filter",
		"grid",
		"hide-pagination",
		"loading",
		"row-key",
		"rows",
		"rows-per-page-options",
		"selection",
		"table-class",
		"table-row-class-fn",
		"virtual-scroll",
		"visible-columns",
		"onRequest",
		"onVirtualScroll"
	])], 38), _ctx.hasNoData && !_ctx.isLoading ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(_ctx.$slots["no-data"] ? "rv-table__no-data" : "hidden")
	}, [renderSlot(_ctx.$slots, "no-data")], 2)) : _ctx.hasNoSearchQueryResult ? (openBlock(), createBlock(_component_NoData, {
		key: 1,
		class: "rv-table__no-data",
		"data-automation": _ctx.buildId("noData"),
		"icon-name": "img:/rvai-base/robot-search.svg",
		title: _ctx.t("rvai-base.tableFields.noQueryResults")
	}, {
		default: withCtx(() => [createVNode(_component_RvButton, {
			color: "primary",
			"data-automation": _ctx.buildId("reset-search"),
			label: _ctx.t("rvai-base.tableFields.clearSearchResults"),
			size: "sm",
			onClick: _ctx.resetSearchQuery
		}, null, 8, [
			"data-automation",
			"label",
			"onClick"
		])]),
		_: 1
	}, 8, ["data-automation", "title"])) : _ctx.hasNoFiltersResult ? (openBlock(), createBlock(_component_NoData, {
		key: 2,
		class: "rv-table__no-data",
		"data-automation": _ctx.buildId("noData"),
		"icon-name": "img:/rvai-base/robot-filters.svg",
		title: _ctx.t("rvai-base.tableFields.noFilteredResults")
	}, {
		default: withCtx(() => [createVNode(_component_RvButton, {
			color: "primary",
			"data-automation": _ctx.buildId("clear-filter"),
			label: _ctx.t("rvai-base.tableFields.clearFilter"),
			size: "sm",
			onClick: _ctx.resetFilters
		}, null, 8, [
			"data-automation",
			"label",
			"onClick"
		])]),
		_: 1
	}, 8, ["data-automation", "title"])) : createCommentVNode("", true)], 10, _hoisted_1$15);
}
var Table_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Table_vue_vue_type_script_lang_default, [["render", _sfc_render$10]]);
//#endregion
//#region src/components/TableFilterItem.vue?vue&type=script&lang.ts
function useDateFilter(filter, filterValueRef) {
	const { updateFilters } = useTable();
	const { t } = useI18n();
	const isDate = filter.value?.type === TableFilterType.Date;
	const originalValueStart = ref("");
	const originalValueEnd = ref("");
	const dateFilter = filter.value;
	const dateFilterOption = ref(void 0);
	const filterValue = filterValueRef.value;
	const dateValue = reactive({
		end: filterValue?.type === TableFilterType.Date ? filterValue.value.end : "",
		start: filterValue?.type === TableFilterType.Date ? filterValue.value.start : ""
	});
	const dateStart = computed({
		get() {
			return dateValue.start;
		},
		set(value) {
			dateValue.start = value;
			setFilters();
		}
	});
	const dateEnd = computed({
		get() {
			return dateValue.end;
		},
		set(value) {
			dateValue.end = value;
			setFilters();
		}
	});
	const showDefaultDateFilter = computed(() => {
		return !dateFilter.beforeOptions?.length || !!dateFilterOption.value && !dateFilterOption.value.hideDefaultFilter;
	});
	function endRestrictions(date) {
		return !dateStart.value || formatToSlash(date) >= formatToSlash(dateStart.value);
	}
	function onUpdateDateFilterOption(value) {
		dateFilterOption.value = value;
		if (value && value.hideDefaultFilter) {
			dateValue.start = formatDate$1(new Date(Date.now() - Number(value.value)));
			dateValue.end = formatDate$1(/* @__PURE__ */ new Date());
		} else {
			dateValue.start = "";
			dateValue.end = "";
		}
		setFilters();
	}
	function setDateFilterOption(start, end) {
		if (!dateFilter.beforeOptions?.length) return;
		if (start && end) {
			const differenceInMs = differenceInMilliseconds(new Date(end), new Date(start));
			const availableOption = dateFilter.beforeOptions.find((o) => o.value === differenceInMs);
			if (start.length > 10 && end.length > 10) {
				onUpdateDateFilterOption(availableOption);
				return;
			}
		}
		dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
	}
	function setFilterByDefaultDateOption() {
		onUpdateDateFilterOption(dateFilter.beforeOptions ? dateFilter.beforeOptions.find((o) => o.selectedByDefault) || dateFilter.beforeOptions[0] : void 0);
	}
	function setFilters() {
		if (!dateValue.start && !dateValue.end) updateFilters(filter.value, void 0);
		else updateFilters(filter.value, {
			key: filter.value.key,
			type: TableFilterType.Date,
			value: {
				end: dateValue.end,
				start: dateValue.start
			}
		});
	}
	function setOriginalValueEnd(value) {
		originalValueEnd.value = value;
	}
	function setOriginalValueStart(value) {
		originalValueStart.value = value;
	}
	function startRestrictions(date) {
		return !dateEnd.value || formatToSlash(date) <= formatToSlash(dateEnd.value);
	}
	function formatToSlash(date) {
		return date.replace(/-/g, "/");
	}
	const v$ = useVuelidate(computed(() => {
		return {
			originalValueEnd: ValidationBuilder.$t("rvai-base.filters.date.endDate").custom((value) => originalValueStart.value && value ? formatToSlash(value) >= formatToSlash(originalValueStart.value) : true, t("rvai-base.filters.errors.endIsEarlier")).rules,
			originalValueStart: ValidationBuilder.$t("rvai-base.filters.date.startDate").custom((value) => value && originalValueEnd.value ? formatToSlash(value) <= formatToSlash(originalValueEnd.value) : true, t("rvai-base.filters.errors.startIsLater")).rules
		};
	}), {
		originalValueEnd,
		originalValueStart
	}, { $autoDirty: true });
	watch(filterValueRef, () => {
		const filterValue = filterValueRef.value;
		dateValue.start = filterValue?.type === TableFilterType.Date ? filterValue.value.start : "";
		dateValue.end = filterValue?.type === TableFilterType.Date ? filterValue.value.end : "";
		if (!filterValue && dateFilter.beforeOptions?.length) dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
	});
	onMounted(() => {
		if (!isDate) return;
		if (!dateFilter.beforeOptions?.length) return;
		if (!filterValueRef.value) setFilterByDefaultDateOption();
		else if (filterValueRef.value.type === TableFilterType.Date && dateFilter.beforeOptions?.length) setDateFilterOption(filterValueRef.value.value.start, filterValueRef.value.value.end);
	});
	return {
		dateEnd,
		dateFilterOption,
		dateStart,
		endRestrictions,
		isDate,
		onUpdateDateFilterOption,
		originalValueEnd,
		originalValueStart,
		setOriginalValueEnd,
		setOriginalValueStart,
		showDefaultDateFilter,
		startRestrictions,
		v$
	};
}
function useListFilter(filter, filterValueRef) {
	const { updateFilters } = useTable();
	return {
		isList: filter.value?.type === TableFilterType.List,
		listValue: computed({
			get() {
				const filterValue = filterValueRef.value;
				return filterValue?.type === TableFilterType.List ? filterValue.value : [];
			},
			set(value) {
				if (!value.length) updateFilters(filter.value, void 0);
				else updateFilters(filter.value, {
					key: filter.value.key,
					type: TableFilterType.List,
					value
				});
			}
		})
	};
}
function useNumberFilter(filter, filterValueRef) {
	const { updateFilters } = useTable();
	const isNumber = filter.value?.type === TableFilterType.Number;
	const numberValue = computed(() => {
		const filterValue = filterValueRef.value;
		return filterValue?.type === TableFilterType.Number ? {
			max: filterValue.max,
			min: filterValue.min
		} : {
			max: null,
			min: null
		};
	});
	const numberRange = computed(() => {
		const { max: maxValue, min: minValue, step } = filter.value;
		if (maxValue == null || minValue == null) return {
			max: null,
			min: null
		};
		const min = step ? Math.floor(minValue / step) * step : Math.floor(minValue);
		return {
			max: step ? Math.ceil(maxValue / step) * step : Math.ceil(maxValue),
			min
		};
	});
	function onUpdateNumber(value) {
		const { max: maxValue, min: minValue } = value;
		const { max: filterMax, min: filterMin } = numberRange.value;
		let max = maxValue;
		let min = minValue;
		if (filterMax != null && filterMin != null && maxValue != null && minValue != null) {
			min = minValue < filterMax ? minValue > filterMin ? minValue : filterMin : filterMax;
			max = maxValue > filterMin ? maxValue < filterMax ? maxValue : filterMax : filterMin;
			if (min > max) min = max;
		}
		updateFilters(filter.value, {
			key: filter.value.key,
			max,
			min,
			type: TableFilterType.Number
		});
	}
	return {
		isNumber,
		numberRange,
		numberValue,
		onUpdateNumber
	};
}
function useSingleFilter(filter, filterValueRef) {
	const { updateFilters } = useTable();
	return {
		isSingle: filter.value?.type === TableFilterType.Single,
		singleValue: computed({
			get() {
				const filterValue = filterValueRef.value;
				return filterValue?.type === TableFilterType.Single ? filterValue.value : void 0;
			},
			set(value) {
				updateFilters(filter.value, {
					key: filter.value.key,
					type: TableFilterType.Single,
					value
				});
			}
		})
	};
}
var TableFilterItem_vue_vue_type_script_lang_default = defineComponent({
	name: "TableFilterItem",
	components: {
		DatePicker: DatePicker_default,
		EllipsisText: EllipsisText_default,
		ExpansionItem: ExpansionItem_default,
		OptionGroup: OptionGroup_default,
		QItemLabel: QItemLabel_default,
		QRange: QRange_default,
		QSpace: QSpace_default,
		RvInput: Input_default,
		RvSelect: Select_default,
		ScrollArea: ScrollArea_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* Puts expansion item into open state on initial render; Overridden by v-model if used
		*/
		defaultOpened: {
			default: false,
			type: Boolean
		},
		filterKey: {
			type: String,
			required: true
		},
		scrollMaxItems: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { filterOptions, filters } = useTable();
		const filter = computed(() => filterOptions.value[props.filterKey]);
		const filterValue = computed(() => filters.values[props.filterKey]);
		const showScroll = computed(() => {
			if (filter.value.type !== TableFilterType.List && filter.value.type !== TableFilterType.Single) return false;
			return props.scrollMaxItems !== 0 && filter.value.options.length > props.scrollMaxItems;
		});
		return {
			filter,
			kebabCase,
			scrollHeight: computed(() => {
				return `${props.scrollMaxItems * 32 - 8}px`;
			}),
			showScroll,
			t,
			...useAutomation(computed(() => props.dataAutomation)),
			...useDateFilter(filter, filterValue),
			...useListFilter(filter, filterValue),
			...useNumberFilter(filter, filterValue),
			...useSingleFilter(filter, filterValue)
		};
	}
});
//#endregion
//#region src/components/TableFilterItem.vue
var _hoisted_1$14 = { class: "q-px-sm flex items-center no-wrap" };
var _hoisted_2$8 = { class: "q-mr-md" };
var _hoisted_3$7 = { class: "q-ml-md" };
var _hoisted_4$4 = { class: "row justify-between items-center q-mb-sm" };
var _hoisted_5$4 = { class: "q-mt-md" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvSelect = resolveComponent("RvSelect");
	const _component_DatePicker = resolveComponent("DatePicker");
	const _component_OptionGroup = resolveComponent("OptionGroup");
	const _component_ScrollArea = resolveComponent("ScrollArea");
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_QSpace = resolveComponent("QSpace");
	const _component_QItemLabel = resolveComponent("QItemLabel");
	const _component_QRange = resolveComponent("QRange");
	const _component_RvInput = resolveComponent("RvInput");
	const _component_ExpansionItem = resolveComponent("ExpansionItem");
	return openBlock(), createBlock(_component_ExpansionItem, mergeProps({ "data-automation": _ctx.buildId() }, _ctx.$attrs, {
		"default-opened": _ctx.defaultOpened,
		label: _ctx.filter.label
	}), {
		default: withCtx(() => [createElementVNode("div", null, [_ctx.isDate ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
			"beforeOptions" in _ctx.filter && _ctx.filter.beforeOptions?.length ? (openBlock(), createBlock(_component_RvSelect, {
				key: 0,
				class: normalizeClass(!_ctx.dateFilterOption || _ctx.dateFilterOption.hideDefaultFilter ? "q-mb-sm" : "q-mb-lg"),
				"data-automation": _ctx.buildId("date-before-options"),
				"model-value": _ctx.dateFilterOption,
				options: _ctx.filter.beforeOptions,
				"onUpdate:modelValue": _ctx.onUpdateDateFilterOption
			}, null, 8, [
				"class",
				"data-automation",
				"model-value",
				"options",
				"onUpdate:modelValue"
			])) : createCommentVNode("", true),
			withDirectives(createVNode(_component_DatePicker, {
				modelValue: _ctx.dateStart,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dateStart = $event),
				"data-automation": _ctx.buildId("start-date"),
				options: _ctx.startRestrictions,
				placeholder: _ctx.t("rvai-base.filters.date.startDate"),
				"validation-error": _ctx.v$.originalValueStart.$error ? _ctx.v$.originalValueStart.$errors[0].$message : "",
				"with-validation": "",
				"wrapper-class": "q-mb-md",
				"onUpdate:originalValue": _ctx.setOriginalValueStart
			}, null, 8, [
				"modelValue",
				"data-automation",
				"options",
				"placeholder",
				"validation-error",
				"onUpdate:originalValue"
			]), [[vShow, _ctx.showDefaultDateFilter]]),
			withDirectives(createVNode(_component_DatePicker, {
				modelValue: _ctx.dateEnd,
				"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.dateEnd = $event),
				"data-automation": _ctx.buildId("end-date"),
				options: _ctx.endRestrictions,
				placeholder: _ctx.t("rvai-base.filters.date.endDate"),
				"validation-error": _ctx.v$.originalValueEnd.$error ? _ctx.v$.originalValueEnd.$errors[0].$message : "",
				"with-validation": "",
				"onUpdate:originalValue": _ctx.setOriginalValueEnd
			}, null, 8, [
				"modelValue",
				"data-automation",
				"options",
				"placeholder",
				"validation-error",
				"onUpdate:originalValue"
			]), [[vShow, _ctx.showDefaultDateFilter]])
		], 64)) : _ctx.isList ? (openBlock(), createBlock(_component_ScrollArea, {
			key: 1,
			"no-horizontal": "",
			"no-scroll": !_ctx.showScroll,
			style: normalizeStyle(_ctx.showScroll && { height: _ctx.scrollHeight })
		}, {
			default: withCtx(() => [createVNode(_component_OptionGroup, {
				modelValue: _ctx.listValue,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.listValue = $event),
				"data-automation": _ctx.buildId("options"),
				options: "options" in _ctx.filter ? _ctx.filter.options : [],
				type: "checkbox"
			}, {
				"after-label": withCtx(({ option }) => [createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)]),
				_: 1
			}, 8, [
				"modelValue",
				"data-automation",
				"options"
			])]),
			_: 1
		}, 8, ["no-scroll", "style"])) : _ctx.isSingle ? (openBlock(), createBlock(_component_ScrollArea, {
			key: 2,
			"no-horizontal": "",
			"no-scroll": !_ctx.showScroll,
			style: normalizeStyle(_ctx.showScroll && { height: _ctx.scrollHeight })
		}, {
			default: withCtx(() => [createVNode(_component_OptionGroup, {
				modelValue: _ctx.singleValue,
				"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.singleValue = $event),
				"data-automation": _ctx.buildId("options"),
				options: "options" in _ctx.filter ? _ctx.filter.options : [],
				type: "radio"
			}, {
				label: withCtx(({ option }) => [createVNode(_component_QItemLabel, {
					class: "row no-wrap full-width text-grey-1",
					"data-automation": _ctx.buildId(`option-single-${_ctx.kebabCase(option.label)}`)
				}, {
					default: withCtx(() => [
						createVNode(_component_EllipsisText, { text: option.label }, null, 8, ["text"]),
						createVNode(_component_QSpace),
						createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)
					]),
					_: 2
				}, 1032, ["data-automation"])]),
				_: 1
			}, 8, [
				"modelValue",
				"data-automation",
				"options"
			])]),
			_: 1
		}, 8, ["no-scroll", "style"])) : _ctx.isNumber ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [createElementVNode("div", _hoisted_1$14, [
			createElementVNode("span", _hoisted_2$8, toDisplayString(_ctx.numberRange.min), 1),
			createVNode(_component_QRange, {
				"data-automation": _ctx.buildId("range"),
				label: "",
				max: _ctx.numberRange.max,
				min: _ctx.numberRange.min,
				"model-value": _ctx.numberValue,
				step: _ctx.filter.step,
				onChange: _ctx.onUpdateNumber
			}, null, 8, [
				"data-automation",
				"max",
				"min",
				"model-value",
				"step",
				"onChange"
			]),
			createElementVNode("span", _hoisted_3$7, toDisplayString(_ctx.numberRange.max), 1)
		]), createElementVNode("div", _hoisted_4$4, [
			createVNode(_component_RvInput, {
				modelValue: _ctx.numberValue.min,
				"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.numberValue.min = $event),
				class: "col-5",
				"data-automation": _ctx.buildId("min"),
				label: _ctx.t("rvai-base.general.inputs.from"),
				onChange: _cache[5] || (_cache[5] = ($event) => _ctx.onUpdateNumber({
					min: Number($event),
					max: _ctx.numberValue.max
				}))
			}, null, 8, [
				"modelValue",
				"data-automation",
				"label"
			]),
			createElementVNode("span", _hoisted_5$4, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1),
			createVNode(_component_RvInput, {
				modelValue: _ctx.numberValue.max,
				"onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.numberValue.max = $event),
				class: "col-5",
				"data-automation": _ctx.buildId("max"),
				label: _ctx.t("rvai-base.general.inputs.until"),
				onChange: _cache[7] || (_cache[7] = ($event) => _ctx.onUpdateNumber({
					min: _ctx.numberValue.min,
					max: Number($event)
				}))
			}, null, 8, [
				"modelValue",
				"data-automation",
				"label"
			])
		])], 64)) : createCommentVNode("", true)])]),
		_: 1
	}, 16, [
		"data-automation",
		"default-opened",
		"label"
	]);
}
var TableFilterItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TableFilterItem_vue_vue_type_script_lang_default, [["render", _sfc_render$9]]);
//#endregion
//#region src/components/TableFilter.vue?vue&type=script&lang.ts
var TableFilter_vue_vue_type_script_lang_default = defineComponent({
	name: "TableFilter",
	components: {
		QList: QList_default,
		RvButton: Button_default,
		TableFilterItem: TableFilterItem_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		/**
		* The maximum number of items to display in a filter item. If set to 0, all items are shown. Default: 0
		*/
		scrollMaxItems: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const { t } = useI18n();
		const { setHasRightContent } = useLayout();
		const { filterOptionsOpenedByDefault, hasFilters, resetFilters, visibleFilterOptions } = useTable();
		function hasValue(option) {
			return option.type === TableFilterType.Number ? option.max !== 0 : option.options.length !== 0;
		}
		function isDateFilter(option) {
			return option.type === TableFilterType.Date;
		}
		watch(visibleFilterOptions, () => {
			setHasRightContent(!!Object.keys(visibleFilterOptions.value).length);
		}, { immediate: true });
		onUnmounted(() => {
			setHasRightContent(true);
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			filterOptionsOpenedByDefault,
			hasFilters,
			hasValue,
			isDateFilter,
			kebabCase,
			resetFilters,
			t,
			visibleFilterOptions
		};
	}
});
//#endregion
//#region src/components/TableFilter.vue
var _hoisted_1$13 = ["data-automation"];
var _hoisted_2$7 = { class: "flex justify-between q-mb-sm" };
var _hoisted_3$6 = { class: "text-subtitle1" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_RvButton = resolveComponent("RvButton");
	const _component_TableFilterItem = resolveComponent("TableFilterItem");
	const _component_QList = resolveComponent("QList");
	return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
		class: "rv-table-filter q-px-lg q-py-md bg-white rounded-borders",
		"data-automation": _ctx.buildId()
	}), [createElementVNode("div", _hoisted_2$7, [createElementVNode("div", _hoisted_3$6, toDisplayString(_ctx.t("rvai-base.general.text.filter")), 1), _ctx.hasFilters ? (openBlock(), createBlock(_component_RvButton, {
		key: 0,
		class: "text-capitalize",
		"data-automation": _ctx.buildId("clear"),
		label: _ctx.t("rvai-base.general.text.clear"),
		size: "sm",
		tertiary: "",
		onClick: _ctx.resetFilters
	}, null, 8, [
		"data-automation",
		"label",
		"onClick"
	])) : createCommentVNode("", true)]), createVNode(_component_QList, null, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.visibleFilterOptions, (option, key) => {
			return openBlock(), createElementBlock(Fragment, { key }, [_ctx.hasValue(option) || _ctx.isDateFilter(option) ? (openBlock(), createBlock(_component_TableFilterItem, {
				key: 0,
				class: "q-py-sm",
				"data-automation": _ctx.buildId(`item-${_ctx.kebabCase(key)}`),
				"default-opened": _ctx.filterOptionsOpenedByDefault.includes(key),
				"filter-key": key,
				"scroll-max-items": _ctx.scrollMaxItems
			}, null, 8, [
				"data-automation",
				"default-opened",
				"filter-key",
				"scroll-max-items"
			])) : createCommentVNode("", true)], 64);
		}), 128))]),
		_: 1
	})], 16, _hoisted_1$13);
}
var TableFilter_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TableFilter_vue_vue_type_script_lang_default, [["render", _sfc_render$8], ["__scopeId", "data-v-969d2a9b"]]);
//#endregion
//#region src/components/TableList.vue?vue&type=script&lang.ts
var TableList_vue_vue_type_script_lang_default = defineComponent({
	name: "TableList",
	components: {
		EllipsisText: EllipsisText_default,
		Tooltip: Tooltip_default
	},
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		disable: {
			type: Boolean,
			default: false
		},
		emptyValue: {
			type: String,
			default: void 0
		},
		multipleRows: {
			type: Boolean,
			default: false
		},
		values: {
			type: Array,
			required: true
		}
	},
	setup(props) {
		const { t } = useI18n();
		const tooltip = computed(() => props.values.slice(1).join(", "));
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			t,
			tooltip
		};
	}
});
//#endregion
//#region src/components/TableList.vue
var _hoisted_1$12 = ["data-automation"];
var _hoisted_2$6 = {
	key: 0,
	class: "rv-table-list cursor-pointer"
};
var _hoisted_3$5 = { class: "show-more" };
var _hoisted_4$3 = { class: "show-more" };
var _hoisted_5$3 = { key: 3 };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_EllipsisText = resolveComponent("EllipsisText");
	const _component_Tooltip = resolveComponent("Tooltip");
	return _ctx.values.length > 1 && !_ctx.multipleRows ? (openBlock(), createElementBlock("span", {
		key: 0,
		class: normalizeClass(["row no-wrap", { "text-grey-2": _ctx.disable }]),
		"data-automation": _ctx.buildId()
	}, [createVNode(_component_EllipsisText, { text: _ctx.values[0] }, null, 8, ["text"]), _ctx.values.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_2$6, [
		createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.symbols.comma") + " "), 1),
		createElementVNode("span", _hoisted_3$5, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
		createVNode(_component_Tooltip, {
			arrow: "top",
			offset: [0, 10]
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tooltip), 1)]),
			_: 1
		})
	])) : createCommentVNode("", true)], 10, _hoisted_1$12)) : _ctx.values.length > 1 && _ctx.multipleRows ? (openBlock(), createElementBlock("div", {
		key: 1,
		class: normalizeClass(["rv-table-list cursor-pointer", { "text-grey-2": _ctx.disable }])
	}, [
		createVNode(_component_EllipsisText, { text: _ctx.values[0] }, null, 8, ["text"]),
		createElementVNode("span", _hoisted_4$3, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
		createVNode(_component_Tooltip, {
			anchor: "bottom left",
			arrow: "top",
			self: "center left"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tooltip), 1)]),
			_: 1
		})
	], 2)) : _ctx.values.length === 1 ? (openBlock(), createElementBlock("span", {
		key: 2,
		class: normalizeClass(["rv-table-list", { "text-grey-2": _ctx.disable }])
	}, [createVNode(_component_EllipsisText, { text: _ctx.values[0] }, null, 8, ["text"])], 2)) : (openBlock(), createElementBlock("span", _hoisted_5$3, toDisplayString(_ctx.emptyValue), 1));
}
var TableList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TableList_vue_vue_type_script_lang_default, [["render", _sfc_render$7], ["__scopeId", "data-v-f9dfed45"]]);
//#endregion
//#region src/components/Tabs.vue
var Tabs_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Tabs",
	props: {
		dataAutomation: {
			default: void 0,
			type: String
		},
		modelValue: {
			default: void 0,
			type: [
				String,
				Number,
				void 0
			]
		},
		optionLabel: {
			default: "label",
			type: String
		},
		options: {
			required: true,
			type: Array
		},
		optionValue: {
			default: "name",
			type: String
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { buildId } = useAutomation(props.dataAutomation);
		const selectedTab = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(QTabs_default), {
				modelValue: selectedTab.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedTab.value = $event),
				class: "tab-container bg-white rounded-borders",
				"data-automation": unref(buildId)(),
				dense: "",
				"indicator-color": "primary",
				"inline-label": "",
				"narrow-indicator": "",
				shrink: "",
				stretch: ""
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
					return openBlock(), createBlock(resolveDynamicComponent(option.to ? unref(QRouteTab_default) : unref(QTab_default)), {
						key: option[__props.optionValue],
						class: "q-px-sm",
						"content-class": "q-px-sm text-body3",
						"data-automation": unref(buildId)(`tab-${option[__props.optionValue]}`),
						exact: option.exact,
						label: option[__props.optionLabel],
						name: option[__props.optionValue],
						"no-caps": "",
						ripple: false,
						to: option.to
					}, null, 8, [
						"data-automation",
						"exact",
						"label",
						"name",
						"to"
					]);
				}), 128))]),
				_: 1
			}, 8, ["modelValue", "data-automation"]);
		};
	}
}), [["__scopeId", "data-v-94338ea0"]]);
//#endregion
//#region src/components/TableChevron.vue
var TableChevron_default = /* @__PURE__ */ defineComponent({
	__name: "TableChevron",
	props: {
		buttonClass: {},
		expanded: { type: Boolean }
	},
	emits: ["toggle"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Button_default, {
				class: normalizeClass(__props.buttonClass),
				color: "black-1",
				icon: __props.expanded ? "mdi-chevron-down" : "mdi-chevron-right",
				size: "md",
				tertiary: "",
				onClick: _cache[0] || (_cache[0] = withModifiers(($event) => emit("toggle"), ["stop"]))
			}, null, 8, ["class", "icon"]);
		};
	}
});
//#endregion
//#region src/components/TreeTable.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = {
	key: 0,
	class: "rv-tree-table__no-children"
};
var _hoisted_2$5 = ["data-automation"];
var _hoisted_3$4 = { class: "text-small-semibold" };
var _hoisted_4$2 = {
	key: 0,
	class: "text-small"
};
var _hoisted_5$2 = {
	key: 1,
	class: "rv-tree-table__node"
};
//#endregion
//#region src/components/TreeTable.vue
var TreeTable_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "TreeTable",
	props: /*@__PURE__*/ mergeModels({
		canExpand: {
			type: Function,
			default: void 0
		},
		childrenLoading: {
			type: Boolean,
			default: false
		},
		columns: {},
		dataAutomation: { default: void 0 },
		expandColumn: {},
		filtersTeleportTo: { default: void 0 },
		getChildren: {},
		getRowActionsVisibility: {
			type: Function,
			default: void 0
		},
		immutableKey: { default: void 0 },
		isImmutable: {
			type: Function,
			default: void 0
		},
		isParentRow: {
			type: Function,
			default: void 0
		},
		isRowDisabled: {
			type: Function,
			default: void 0
		},
		loading: { type: Boolean },
		noChildrenSubtitle: {},
		noChildrenTitle: {},
		noMatchingChildrenSubtitle: {},
		noMatchingChildrenTitle: {},
		rowDisabledTooltip: {
			type: Function,
			default: void 0
		},
		rowKey: {},
		rows: {},
		tableId: {}
	}, {
		"expanded": { default: () => [] },
		"expandedModifiers": {}
	}),
	emits: ["update:expanded"],
	setup(__props) {
		const props = __props;
		const expanded = useModel(__props, "expanded");
		const slots = useSlots();
		const { buildId } = useAutomation(computed(() => props.dataAutomation ?? "tree-table"));
		const filtersTarget = ref(null);
		function getRowId(row) {
			return row[props.rowKey];
		}
		const FILTER_EMPTY_ROW = Symbol("filterEmptyRow");
		const provided = {};
		const tree = useTreeTable({
			canExpand: (row) => props.canExpand?.(row) ?? true,
			columns: () => props.columns,
			expanded,
			getChildren: (row) => props.getChildren(row),
			rowKey: () => props.rowKey,
			rows: () => props.rows,
			sort: () => provided.table?.pagination.value
		});
		const { isExpanded, metaOf, toggle } = tree;
		function isEmptyRow(row) {
			const meta = metaOf(row);
			if (!meta?.isChild || !meta.parentRow) return false;
			return props.getChildren(meta.parentRow).length === 0;
		}
		function isFilterEmptyRow(row) {
			return FILTER_EMPTY_ROW in row;
		}
		function isEmptyStateRow(row) {
			return isEmptyRow(row) || isFilterEmptyRow(row);
		}
		function buildFilterEmptyRow(parent) {
			return {
				...parent,
				[props.rowKey]: `${String(getRowId(parent))}::no-match`,
				[FILTER_EMPTY_ROW]: parent
			};
		}
		function refineFilteredRows(matched, all) {
			const isVisible = (row) => !metaOf(row)?.hidden;
			const visibleAll = all.filter(isVisible);
			const kept = keepAncestors(matched, all, (row) => metaOf(row)?.parentRow ?? null);
			const keptSet = new Set(kept);
			const withEmpties = visibleAll.filter((row) => {
				if (keptSet.has(row)) return true;
				const parent = metaOf(row)?.parentRow;
				return !!parent && isEmptyRow(row) && keptSet.has(parent);
			});
			const parentsWithKeptChild = new Set(withEmpties.map((row) => metaOf(row)).filter((meta) => meta?.isChild).map((meta) => meta?.parentRow));
			const result = [];
			for (const row of withEmpties) {
				result.push(row);
				if (metaOf(row)?.hasChildren && isExpanded(getRowId(row)) && !parentsWithKeptChild.has(row)) result.push(buildFilterEmptyRow(row));
			}
			return result;
		}
		function isRowImmutable(row) {
			if (isEmptyStateRow(row)) return true;
			if (props.isImmutable) return props.isImmutable(row);
			if (props.immutableKey) return !!row[props.immutableKey];
			return false;
		}
		const table = provideTable({
			columns: tree.groupSortColumns,
			isImmutable: isRowImmutable,
			isRowDisabled: (row) => props.isRowDisabled?.(row) ?? false,
			isRowVisible: (row) => !metaOf(row)?.hidden,
			refineFilteredRows,
			rowDisabledTooltip: (row) => props.rowDisabledTooltip?.(row),
			rowKey: props.rowKey,
			rows: tree.tableRows,
			tableId: props.tableId
		});
		provided.table = table;
		function expandAllParents() {
			expanded.value = props.rows.filter((row) => props.canExpand?.(row) ?? true).map((row) => getRowId(row));
		}
		const isFiltering = computed(() => table.hasFilters.value || table.hasSearchQueryFilter.value);
		function getEmptyStateParent(row) {
			if (isFilterEmptyRow(row)) return row[FILTER_EMPTY_ROW];
			return metaOf(row)?.parentRow ?? null;
		}
		function getEmptyStateKey(row) {
			return isFilterEmptyRow(row) ? "no-matching-children" : "no-children";
		}
		function getEmptyStateTitle(row) {
			return isFilterEmptyRow(row) ? props.noMatchingChildrenTitle : props.noChildrenTitle;
		}
		function getEmptyStateSubtitle(row) {
			return isFilterEmptyRow(row) ? props.noMatchingChildrenSubtitle : props.noChildrenSubtitle;
		}
		function resolveRowActionsVisibility(row) {
			if (isEmptyStateRow(row)) return RowActionsVisibility.NoActions;
			return props.getRowActionsVisibility?.(row) ?? RowActionsVisibility.HiddenUntilHover;
		}
		function isChildRow(row) {
			return metaOf(row)?.isChild ?? false;
		}
		function rowHasChildren(row) {
			return metaOf(row)?.hasChildren ?? false;
		}
		function isExpandable(row) {
			const meta = metaOf(row);
			if (!meta || meta.isChild || isEmptyStateRow(row)) return false;
			return props.canExpand?.(row) ?? true;
		}
		function hasParentStyling(row) {
			const meta = metaOf(row);
			if (!meta || meta.isChild || isEmptyStateRow(row)) return false;
			if (props.isParentRow) return props.isParentRow(row);
			return isExpandable(row);
		}
		const attrs = useAttrs();
		const selectionEnabled = computed(() => attrs.selection !== "none");
		function isChevronInSelectionCell(row) {
			return selectionEnabled.value && isRowImmutable(row) && isExpandable(row);
		}
		function showNameChevron(row) {
			return isExpandable(row) && !isChevronInSelectionCell(row);
		}
		function getRowClass(row) {
			const isParent = hasParentStyling(row) && !isFilterEmptyRow(row);
			const classes = [];
			if (isParent) classes.push("rv-tree-table-row--parent");
			if (rowHasChildren(row)) classes.push("rv-tree-table-row--has-children");
			return classes.join(" ");
		}
		const builtInExpandSlot = computed(() => `body-cell-${props.expandColumn}`);
		const forwardedSlots = computed(() => {
			const names = new Set(Object.keys(slots).filter((name) => !name.startsWith("child-")));
			names.add(builtInExpandSlot.value);
			return [...names];
		});
		function getChildRowSlotName(name, row) {
			const childName = `child-${name}`;
			return row && isChildRow(row) && slots[childName] ? childName : name;
		}
		function addTreeMeta(scope) {
			const row = scope?.row;
			if (!row) return scope;
			const meta = metaOf(row);
			return {
				...scope,
				expanded: meta?.hasChildren ? isExpanded(getRowId(row)) : void 0,
				hasChildren: meta?.hasChildren ?? false,
				isChild: meta?.isChild ?? false,
				parentRow: meta?.parentRow ?? null,
				toggleExpand: () => toggle(getRowId(row))
			};
		}
		watch(isFiltering, (filtering) => {
			if (filtering) expandAllParents();
		});
		watch(() => table.allSelectedValue.value, (allSelected) => {
			if (allSelected === true) expandAllParents();
		});
		onMounted(() => {
			if (props.filtersTeleportTo) filtersTarget.value = document.querySelector(props.filtersTeleportTo);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createVNode(Table_default, mergeProps(_ctx.$attrs, {
				"data-automation": unref(buildId)(),
				"get-row-actions-visibility": resolveRowActionsVisibility,
				loading: __props.loading,
				"table-row-class-fn": getRowClass
			}), createSlots({
				"selection-replacement": withCtx(({ row }) => [isExpandable(row) ? (openBlock(), createBlock(TableChevron_default, {
					key: 0,
					"button-class": "q-mx-sm",
					"data-automation": unref(buildId)(`expand-${getRowId(row)}`),
					expanded: unref(isExpanded)(getRowId(row)),
					onToggle: ($event) => unref(toggle)(getRowId(row))
				}, null, 8, [
					"data-automation",
					"expanded",
					"onToggle"
				])) : createCommentVNode("", true)]),
				_: 2
			}, [renderList(forwardedSlots.value, (name) => {
				return {
					name,
					fn: withCtx((scope) => [scope.row && isEmptyStateRow(scope.row) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [builtInExpandSlot.value === name ? (openBlock(), createElementBlock("div", _hoisted_1$11, [__props.childrenLoading ? (openBlock(), createBlock(unref(QSkeleton_default), {
						key: 0,
						"data-automation": unref(buildId)("children-skeleton"),
						height: "16px",
						type: "rect",
						width: "100%"
					}, null, 8, ["data-automation"])) : unref(slots)[getEmptyStateKey(scope.row)] ? renderSlot(_ctx.$slots, getEmptyStateKey(scope.row), { row: getEmptyStateParent(scope.row) }, void 0, true, 1) : (openBlock(), createElementBlock("div", {
						key: 2,
						class: "rv-tree-table__no-children-block text-grey-1",
						"data-automation": unref(buildId)(getEmptyStateKey(scope.row))
					}, [createElementVNode("span", _hoisted_3$4, toDisplayString(getEmptyStateTitle(scope.row)), 1), getEmptyStateSubtitle(scope.row) ? (openBlock(), createElementBlock("span", _hoisted_4$2, toDisplayString(getEmptyStateSubtitle(scope.row)), 1)) : createCommentVNode("", true)], 8, _hoisted_2$5))])) : createCommentVNode("", true)], 64)) : builtInExpandSlot.value === name && scope.row ? (openBlock(), createElementBlock("div", _hoisted_5$2, [showNameChevron(scope.row) ? (openBlock(), createBlock(TableChevron_default, {
						key: 0,
						"data-automation": unref(buildId)(`expand-${getRowId(scope.row)}`),
						expanded: unref(isExpanded)(getRowId(scope.row)),
						onToggle: ($event) => unref(toggle)(getRowId(scope.row))
					}, null, 8, [
						"data-automation",
						"expanded",
						"onToggle"
					])) : createCommentVNode("", true), renderSlot(_ctx.$slots, getChildRowSlotName(name, scope.row), normalizeProps(guardReactiveProps(addTreeMeta(scope))), void 0, true)])) : renderSlot(_ctx.$slots, getChildRowSlotName(name, scope.row), normalizeProps(guardReactiveProps(addTreeMeta(scope))), void 0, true, 2)])
				};
			})]), 1040, ["data-automation", "loading"]), filtersTarget.value ? (openBlock(), createBlock(Teleport, {
				key: 0,
				to: filtersTarget.value
			}, [createVNode(TableFilter_default, { "data-automation": unref(buildId)("filter") }, null, 8, ["data-automation"])], 8, ["to"])) : createCommentVNode("", true)], 64);
		};
	}
}), [["__scopeId", "data-v-9168a58c"]]);
//#endregion
//#region src/components/UsersGroup.vue?vue&type=script&lang.ts
var UsersGroup_vue_vue_type_script_lang_default = defineComponent({
	name: "UsersGroup",
	components: { Avatar: Avatar_default },
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		idKey: {
			type: String,
			required: true
		},
		labelKey: {
			type: String,
			required: true
		},
		maxLength: {
			type: Number,
			default: 10
		},
		overrideCurrentUserAvatar: {
			type: Boolean,
			default: false
		},
		users: {
			type: Array,
			required: true
		}
	},
	setup(props) {
		const { t } = useI18n();
		const filteredUsers = computed(() => {
			return props.users.length > props.maxLength ? props.users.slice(0, props.maxLength - 1) : props.users;
		});
		const hidden = computed(() => {
			return props.users.length - filteredUsers.value.length;
		});
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			filteredUsers,
			hidden,
			t
		};
	}
});
//#endregion
//#region src/components/UsersGroup.vue
var _hoisted_1$10 = ["data-automation"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Avatar = resolveComponent("Avatar");
	return openBlock(), createElementBlock("div", { "data-automation": _ctx.buildId() }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredUsers, (user, index) => {
		return openBlock(), createBlock(_component_Avatar, mergeProps({ key: user[_ctx.idKey] }, { ref_for: true }, _ctx.$attrs, {
			"background-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "white" : user.color,
			"border-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "white",
			class: "users-group__avatar",
			"data-automation": _ctx.buildId(`${user[_ctx.idKey]}`),
			label: user[_ctx.labelKey],
			style: { zIndex: _ctx.filteredUsers.length - index },
			"text-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "",
			uuid: user[_ctx.idKey]
		}), {
			default: withCtx(() => [renderSlot(_ctx.$slots, "default", mergeProps({ ref_for: true }, user || {}), void 0, true)]),
			_: 2
		}, 1040, [
			"background-color",
			"border-color",
			"data-automation",
			"label",
			"style",
			"text-color",
			"uuid"
		]);
	}), 128)), _ctx.hidden ? (openBlock(), createBlock(_component_Avatar, mergeProps({ key: 0 }, _ctx.$attrs, {
		class: "users-group__avatar",
		"data-automation": _ctx.buildId("hidden"),
		label: _ctx.t("rvai-base.general.text.more", [_ctx.hidden]),
		"no-initial": "",
		style: { zIndex: 0 }
	}), null, 16, ["data-automation", "label"])) : createCommentVNode("", true)], 8, _hoisted_1$10);
}
var UsersGroup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(UsersGroup_vue_vue_type_script_lang_default, [["render", _sfc_render$6], ["__scopeId", "data-v-bdba1fc3"]]);
//#endregion
//#region src/components/ValidationTooltip.vue?vue&type=script&lang.ts
var ValidationTooltip_vue_vue_type_script_lang_default = defineComponent({
	name: "ValidationTooltip",
	components: {
		Bullet: Bullet_default,
		Tooltip: Tooltip_default
	},
	inheritAttrs: false,
	props: {
		/**
		* Automation ID to easily find element in the DOM by its value
		*/
		dataAutomation: {
			type: String,
			default: void 0
		},
		exclude: {
			type: Array,
			default: () => []
		},
		/**
		* The text that will be shown above the input
		*/
		label: {
			type: String,
			default: void 0
		},
		/**
		* Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
		*/
		modelValue: {
			type: Boolean,
			default: false
		},
		/**
		* Validation for the component
		*/
		validation: {
			type: Object,
			required: true
		}
	},
	emits: ["update:modelValue"],
	setup(props) {
		const { t } = useI18n();
		const results = computed(() => {
			return Object.entries(props.validation).filter(([key]) => !key.startsWith("$") && !props.exclude.includes(key)).map(([key, rule]) => {
				return {
					key,
					message: rule.$message,
					valid: props.validation.$dirty ? !rule.$invalid : void 0
				};
			});
		});
		function iconColor(valid) {
			if (valid) return "positive";
			else if (valid === false) return "negative";
			else return "grey-1-fixed";
		}
		return {
			...useAutomation(computed(() => props.dataAutomation)),
			iconColor,
			results,
			t
		};
	}
});
//#endregion
//#region src/components/ValidationTooltip.vue
var _hoisted_1$9 = {
	key: 0,
	class: "q-ml-xs"
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Bullet = resolveComponent("Bullet");
	const _component_Tooltip = resolveComponent("Tooltip");
	return openBlock(), createBlock(_component_Tooltip, mergeProps(_ctx.dataAttrs, {
		anchor: "bottom left",
		arrow: "top",
		class: "text-grey-1-fixed text-small",
		"data-automation": _ctx.buildId(),
		"model-value": _ctx.modelValue,
		offset: [0, 4],
		self: "top left",
		"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
	}), {
		default: withCtx(() => [_ctx.label ? (openBlock(), createElementBlock("div", _hoisted_1$9, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.results, (entry) => {
			return openBlock(), createElementBlock("div", {
				key: entry.key,
				class: normalizeClass(["row no-wrap", { "text-negative": entry.valid === false }])
			}, [createVNode(_component_Bullet, {
				class: "q-mx-sm",
				color: _ctx.iconColor(entry.valid),
				"no-contrast-border": "",
				rounded: "",
				size: "4"
			}, null, 8, ["color"]), createTextVNode(" " + toDisplayString(entry.message), 1)], 2);
		}), 128))]),
		_: 1
	}, 16, ["data-automation", "model-value"]);
}
var ValidationTooltip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ValidationTooltip_vue_vue_type_script_lang_default, [["render", _sfc_render$5]]);
//#endregion
//#region src/components/WaferMap/WaferMapWarning.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = ["data-automation"];
//#endregion
//#region src/components/WaferMap/WaferMapWarning.vue
var WaferMapWarning_default = /* @__PURE__ */ defineComponent({
	__name: "WaferMapWarning",
	props: {
		dataAutomation: {
			default: "wafer-map-warning",
			type: String
		},
		fullscreen: {
			default: false,
			type: Boolean
		},
		samplesCount: {
			required: true,
			type: Number
		},
		totalCount: {
			required: true,
			type: Number
		}
	},
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			const _component_q_icon = resolveComponent("q-icon");
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["border-blue text-small rounded-borders q-pa-sm q-mb-md flex no-wrap text-blue", { "items-center": __props.fullscreen }]),
				"data-automation": unref(buildId)()
			}, [createVNode(_component_q_icon, {
				class: "q-mr-sm",
				color: "blue",
				"data-automation": unref(buildId)("icon"),
				name: "mdi-information",
				size: "24px"
			}, null, 8, ["data-automation"]), createElementVNode("div", null, toDisplayString(_ctx.$t("rvai-base.components.waferMap.locationMissing", [__props.totalCount - __props.samplesCount, __props.totalCount])), 1)], 10, _hoisted_1$8);
		};
	}
});
//#endregion
//#region src/assets/wafermapBackground.svg
var wafermapBackground_default = "data:image/svg+xml,%3csvg%20width='1800'%20height='1800'%20viewBox='0%200%201800%201800'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='900'%20cy='900'%20r='900'%20fill='%23F5F6F9'%20/%3e%3c/svg%3e";
//#endregion
//#region src/components/WaferMap/WaferMapChart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$7 = { class: "row full-width row no-wrap justify-end q-mb-md" };
var _hoisted_2$4 = { class: "row no-wrap offset-4 col-4 justify-center items-center" };
var _hoisted_3$3 = { class: "row no-wrap col-4 justify-end" };
var _hoisted_4$1 = {
	key: 0,
	class: "row justify-center"
};
var _hoisted_5$1 = {
	key: 1,
	class: "q-gutter-sm z-top"
};
var _hoisted_6$1 = { class: "absolute-top-right wafer-map__controls__splitview--top z-top q-mr-md" };
var _hoisted_7$1 = {
	key: 0,
	class: "row no-wrap items-center q-mt-sm"
};
var _hoisted_8 = { class: "flex row no-wrap q-mt-sm" };
var _hoisted_9 = { style: { "min-width": "49px" } };
var _hoisted_10 = { style: { "min-width": "49px" } };
var _hoisted_11 = { style: { "min-width": "58px" } };
var canvasSpacing = 32;
var zoomRatio = .4;
//#endregion
//#region src/components/WaferMap/WaferMapChart.vue
var WaferMapChart_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "WaferMapChart",
	props: {
		annotationSources: {
			default: void 0,
			type: Array
		},
		backgroundImage: {
			default: wafermapBackground_default,
			type: String
		},
		dataset: {
			required: true,
			type: Object
		},
		fullscreen: {
			default: false,
			type: Boolean
		},
		isSplitView: {
			default: false,
			type: Boolean
		},
		modelValue: {
			required: true,
			type: Array
		}
	},
	emits: [
		"resetBackground",
		"toggleFullscreen",
		"update:modelValue"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { t } = useI18n();
		const { getPaletteColorCache } = usePaletteColorsCache();
		const greyPaletteColor = getPaletteColorCache("grey-3");
		const primaryPaletteColor = getPaletteColorCache("primary");
		const canvas = ref();
		const disableZoomOut = ref(true);
		const disableResetView = ref(true);
		const scatterplotRef = ref();
		const showTooltip = ref(false);
		const tooltip = ref();
		const mouseMode = ref("panZoom");
		const isSkipSelectionSync = ref(false);
		const canvasClientHeight = ref(canvas.value?.clientHeight);
		__expose({ canvasClientHeight });
		const selection = computed(() => props.modelValue);
		const classesColors = computed(() => props.dataset.classes.map((c) => c.id === "unannotated" ? greyPaletteColor : c.color));
		const classesNames = computed(() => props.dataset.classes.map((c) => c.id === "unannotated" ? t("rvai-base.components.waferMap.notAnnotated") : c.name));
		const points = computed(() => props.dataset.dataPoints);
		const sampleInfo = computed(() => props.dataset.samples);
		const samplesCount = computed(() => props.dataset.samplesCount);
		const totalSampleCount = computed(() => props.dataset.totalCount);
		const showMissingPointsInfo = computed(() => totalSampleCount.value !== samplesCount.value);
		const lassoActive = computed(() => mouseMode.value === "lasso");
		const menuItems = computed(() => [{
			disabled: !selection.value.length,
			label: t("rvai-base.components.waferMap.deselect"),
			onClick: deselectHandler
		}, {
			disabled: disableResetView.value,
			label: t("rvai-base.components.waferMap.resetZoomLevel"),
			onClick: resetView
		}]);
		async function createScatterplotView() {
			const scatterplot = createScatterplot({
				backgroundImage: props.backgroundImage,
				canvas: canvas.value,
				pointSize: 5
			});
			const isMac = window.navigator.userAgent.toLocaleUpperCase().indexOf("MAC") !== -1;
			scatterplot.set({
				colorBy: "w",
				keyMap: {
					alt: "rotate",
					...isMac ? { cmd: "merge" } : { ctrl: "merge" },
					shift: "lasso"
				},
				lassoColor: primaryPaletteColor,
				pointColor: classesColors.value,
				pointColorActive: classesColors.value,
				pointColorHover: classesColors.value
			});
			scatterplot.subscribe("pointOver", pointOverHandler);
			scatterplot.subscribe("pointOut", pointOutHandler);
			scatterplot.subscribe("view", viewHandler);
			scatterplot.subscribe("select", selectHandler);
			scatterplot.subscribe("deselect", deselectHandler);
			scatterplot.subscribe("lassoEnd", () => {
				mouseMode.value = "panZoom";
			});
			scatterplot.get("camera").setScaleBounds([1, Infinity]);
			await scatterplot.draw(points.value);
			scatterplotRef.value = scatterplot;
			updateSelection(props.modelValue);
		}
		function createTooltip(pointIndex) {
			const { height } = scatterplotRef.value.get("canvas").getBoundingClientRect();
			const [x, y] = scatterplotRef.value.getScreenPosition(pointIndex);
			const classIndex = getClassIndex(pointIndex);
			const sampleData = sampleInfo.value?.[pointIndex];
			const tooltipHeight = 94;
			const averagePointSizeInPixels = 10;
			let verticalOffset = -y - tooltipHeight / 4;
			if (Math.abs(verticalOffset) + tooltipHeight > height) verticalOffset = -y + tooltipHeight + averagePointSizeInPixels;
			const offset = [-x, verticalOffset];
			tooltip.value = {
				classColor: classesColors.value?.[classIndex],
				classLabel: classesNames.value?.[classIndex],
				offset,
				sampleName: sampleData?.name,
				sourceData: getSourceData(sampleData?.metadata?.source_id)
			};
			showTooltip.value = true;
		}
		function getClassIndex(pointIndex) {
			return points.value[pointIndex]?.[3];
		}
		function getSourceData(id) {
			if (!id) return;
			return props?.annotationSources?.filter((s) => s.id === id)?.[0];
		}
		function onResize({ height, width }) {
			scatterplotRef.value?.set({
				height: height - canvasSpacing,
				width: width - canvasSpacing
			});
			emit("resetBackground");
		}
		const selectHandler = ({ points }) => {
			const sampleIds = points.map((p) => sampleInfo?.value?.[p]?.id).filter(Boolean);
			isSkipSelectionSync.value = true;
			emit("update:modelValue", sampleIds);
		};
		const deselectHandler = () => {
			emit("update:modelValue", []);
		};
		function pointOutHandler() {
			tooltip.value = null;
			showTooltip.value = false;
		}
		function pointOverHandler(pointIndex) {
			createTooltip(pointIndex);
		}
		function resetView() {
			emit("resetBackground");
			scatterplotRef.value.reset();
		}
		function viewHandler(event) {
			disableZoomOut.value = event.camera.distance[0] === 1 && event.camera.distance[1] === 1;
			disableResetView.value = disableZoomOut.value && event.camera.target[0] === 0 && event.camera.target[1] === 0;
		}
		function zoomIn() {
			const camera = scatterplotRef.value.get("camera");
			const distance = camera.distance[0] - camera.distance[0] * zoomRatio;
			scatterplotRef.value.zoomToLocation(camera.target, distance, { transition: true });
		}
		function zoomOut() {
			const camera = scatterplotRef.value.get("camera");
			const distance = camera.distance[0] / (1 - zoomRatio);
			scatterplotRef.value.zoomToLocation(camera.target, distance < 1 ? distance : 1, { transition: true });
		}
		function updateSelection(value) {
			if (!(sampleInfo.value && scatterplotRef.value)) return;
			const sampleIndices = [];
			for (let i = 0; i < sampleInfo?.value.length; i++) {
				const sample = sampleInfo?.value[i];
				if (sample?.id && value.includes(sample.id)) sampleIndices.push(i);
				if (value.length === sampleIndices.length) break;
			}
			scatterplotRef.value.select(sampleIndices, { preventEvent: true });
		}
		function toggleLasso() {
			mouseMode.value = mouseMode.value === "lasso" ? "panZoom" : "lasso";
		}
		watch(mouseMode, (value) => {
			if (canvas.value) if (value === "lasso") {
				scatterplotRef.value.set({ mouseMode: "lasso" });
				canvas.value.style.cursor = "crosshair";
			} else {
				scatterplotRef.value.set({ mouseMode: "panZoom" });
				canvas.value.style.cursor = "default";
			}
		});
		watch(selection, (value) => {
			if (value.length === 0 || !isSkipSelectionSync.value) updateSelection(value);
			isSkipSelectionSync.value = false;
		});
		watch(() => props.backgroundImage, (backgroundImage) => {
			scatterplotRef.value?.set({ backgroundImage });
		});
		watch(points, (current, prev) => {
			if (!arrayShallowEqual(prev, current)) scatterplotRef?.value.draw(points.value);
		}, { deep: true });
		watch(() => canvas.value?.clientHeight, (height) => {
			canvasClientHeight.value = height;
		}, { immediate: true });
		onUnmounted(() => {
			scatterplotRef.value?.destroy();
		});
		onMounted(async () => {
			await createScatterplotView();
		});
		return (_ctx, _cache) => {
			const _component_i18n_t = resolveComponent("i18n-t");
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
				class: normalizeClass(["canvas-wrapper", { "canvas-wrapper--border q-pa-md rounded-borders": __props.isSplitView }]),
				"data-automation": "wafer-map-chart"
			}, [
				createElementVNode("div", { class: normalizeClass(["wafer-map__controls__container__top", __props.fullscreen ? "wafer-map__controls__container__top--fullscreen" : "absolute-top-right"]) }, [__props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", _hoisted_1$7, [createElementVNode("div", _hoisted_2$4, [createVNode(_component_i18n_t, {
					keypath: "rvai-base.components.waferMap.selectedCount",
					tag: "div"
				}, {
					selectedSamples: withCtx(() => [createElementVNode("strong", null, toDisplayString(selection.value.length), 1)]),
					totalSamples: withCtx(() => [createElementVNode("strong", null, toDisplayString(samplesCount.value), 1)]),
					_: 1
				}), createVNode(Button_default, {
					class: "q-ml-sm",
					"data-automation": "wafer-map__controls__deselect",
					disable: !selection.value.length,
					label: _ctx.$t("rvai-base.components.waferMap.deselect"),
					size: "sm",
					tertiary: "",
					onClick: deselectHandler
				}, null, 8, ["disable", "label"])]), createElementVNode("div", _hoisted_3$3, [createVNode(Button_default, {
					class: "wafer-map__controls__lasso z-top bg-white shadow",
					color: lassoActive.value ? "primary" : "black-1",
					"data-automation": "wafer-map__lasso-select",
					icon: "rvai-base:lasso",
					label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
					size: "sm",
					tertiary: "",
					onClick: withModifiers(toggleLasso, ["stop"])
				}, null, 8, ["color", "label"])])]), showMissingPointsInfo.value ? (openBlock(), createElementBlock("div", _hoisted_4$1, [createVNode(WaferMapWarning_default, {
					fullscreen: "",
					"samples-count": samplesCount.value,
					"total-count": totalSampleCount.value
				}, null, 8, ["samples-count", "total-count"])])) : createCommentVNode("", true)], 64)) : !__props.isSplitView ? (openBlock(), createElementBlock("div", _hoisted_5$1, [createVNode(Button_default, {
					class: normalizeClass(["bg-white shadow", { "bg-grey-6": lassoActive.value }]),
					color: lassoActive.value ? "primary" : "black-1",
					"data-automation": "wafer-map__lasso-select",
					icon: "rvai-base:lasso",
					secondary: "",
					size: "xs",
					onClick: withModifiers(toggleLasso, ["stop"])
				}, {
					default: withCtx(() => [createVNode(Tooltip_default, {
						anchor: "top middle",
						"data-automation": "wafer-map__reset-view--tooltip",
						self: "center end"
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.$t("rvai-base.components.waferMap.makeFreehandSelection")), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["class", "color"]), createVNode(Button_default, {
					class: "bg-white shadow",
					"data-automation": "wafer-map__controls__full-screen",
					icon: "fullscreen",
					secondary: "",
					size: "xs",
					onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
				})])) : createCommentVNode("", true)], 2),
				__props.isSplitView ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(Button_default, {
					class: "absolute-top-left wafer-map__controls__splitview--top wafer-map__controls__lasso bg-white q-ml-md shadow",
					color: lassoActive.value ? "primary" : "black-1",
					"data-automation": "wafer-map__lasso-select",
					icon: "rvai-base:lasso",
					label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
					size: "sm",
					tertiary: "",
					onClick: withModifiers(toggleLasso, ["stop"])
				}, null, 8, ["color", "label"]), createElementVNode("div", _hoisted_6$1, [createVNode(Button_default, {
					class: "wafer-map__controls__deselect bg-white q-mx-sm",
					"data-automation": "wafer-map__controls__deselect",
					disable: !selection.value.length,
					label: _ctx.$t("rvai-base.components.waferMap.deselect"),
					size: "sm",
					tertiary: "",
					onClick: deselectHandler
				}, null, 8, ["disable", "label"]), createVNode(Button_default, {
					class: "bg-white shadow",
					"data-automation": "wafer-map__controls__full-screen",
					icon: "fullscreen",
					secondary: "",
					size: "xs",
					onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
				})])], 64)) : createCommentVNode("", true),
				createElementVNode("canvas", {
					ref_key: "canvas",
					ref: canvas,
					class: "canvas bg-white",
					"data-automation": "wafer-map__canvas"
				}, null, 512),
				createVNode(unref(QResizeObserver_default), { onResize }),
				!!tooltip.value ? (openBlock(), createBlock(Tooltip_default, {
					key: 1,
					modelValue: showTooltip.value,
					"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => showTooltip.value = $event),
					anchor: "top left",
					"data-automation": "wafer-map__data-tooltip",
					"max-width": "170px",
					offset: tooltip.value.offset,
					self: "top middle",
					target: ".canvas"
				}, {
					default: withCtx(() => [
						createElementVNode("strong", null, [createVNode(EllipsisText_default, {
							"data-automation": "sampleName",
							text: tooltip.value.sampleName
						}, null, 8, ["text"])]),
						tooltip.value.sourceData?.id ? (openBlock(), createElementBlock("div", _hoisted_7$1, [createVNode(Avatar_default, {
							"background-color": tooltip.value.sourceData?.isCurrent ? "white" : tooltip.value.sourceData?.color,
							"border-color": tooltip.value.sourceData?.isCurrent ? "grey-1" : void 0,
							"data-automation": "source-avatar",
							label: tooltip.value.sourceData?.name,
							"show-logo": !tooltip.value.sourceData?.isUser,
							size: "sm",
							"text-color": tooltip.value.sourceData?.isCurrent ? "grey-1" : "",
							uuid: tooltip.value.sourceData?.id
						}, null, 8, [
							"background-color",
							"border-color",
							"label",
							"show-logo",
							"text-color",
							"uuid"
						]), createVNode(EllipsisText_default, {
							class: "q-ml-xs",
							"data-automation": "source-name",
							text: tooltip.value.sourceData?.name
						}, null, 8, ["text"])])) : createCommentVNode("", true),
						createElementVNode("div", _hoisted_8, [tooltip.value.sourceData?.id ? (openBlock(), createBlock(Bullet_default, {
							key: 0,
							class: "q-ml-xs",
							color: tooltip.value.classColor,
							"data-automation": "class-color",
							size: "12"
						}, null, 8, ["color"])) : createCommentVNode("", true), createVNode(EllipsisText_default, {
							class: normalizeClass({ "q-ml-sm": tooltip.value.sourceData?.id }),
							"data-automation": "class-name",
							text: tooltip.value.classLabel
						}, null, 8, ["class", "text"])])
					]),
					_: 1
				}, 8, ["modelValue", "offset"])) : createCommentVNode("", true)
			], 2), createElementVNode("div", { class: normalizeClass(["wafer-map__controls__container__bottom absolute-bottom-right column z-top", { "wafer-map__controls__container__bottom--fullscreen": __props.fullscreen || __props.isSplitView }]) }, [
				__props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button_default, {
					key: 0,
					class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
					"data-automation": "wafer-map__reset-view",
					icon: "mdi-refresh",
					secondary: "",
					size: "xs",
					onClick: withModifiers(resetView, ["stop"])
				}, {
					default: withCtx(() => [createVNode(Tooltip_default, {
						anchor: "center left",
						"data-automation": "wafer-map__reset-view--tooltip",
						self: "center right"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_9, toDisplayString(_ctx.$t("rvai-base.components.waferMap.resetZoomLevel")), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["class"])) : (openBlock(), createBlock(Button_default, {
					key: 1,
					class: "bg-white shadow",
					"data-automation": "wafer-map__reset-view",
					icon: "rvai-base:meat-ball",
					secondary: "",
					size: "xs"
				}, {
					default: withCtx(() => [createVNode(unref(QMenu_default), {
						anchor: "bottom left",
						"auto-close": "",
						offset: [4, 0],
						self: "bottom right"
					}, {
						default: withCtx(() => [createVNode(unref(QList_default), { separator: "" }, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(menuItems.value, (menuItem) => {
								return openBlock(), createBlock(unref(QItem_default), {
									key: menuItem.label,
									clickable: "",
									disable: menuItem.disabled,
									onClick: menuItem.onClick
								}, {
									default: withCtx(() => [createVNode(unref(QItemLabel_default), null, {
										default: withCtx(() => [createTextVNode(toDisplayString(menuItem.label), 1)]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1032, ["disable", "onClick"]);
							}), 128))]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				})),
				__props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button_default, {
					key: 2,
					class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
					"data-automation": "wafer-map__zoom-in",
					icon: "mdi-plus",
					secondary: "",
					size: "xs",
					onClick: withModifiers(zoomIn, ["stop"])
				}, {
					default: withCtx(() => [createVNode(Tooltip_default, {
						anchor: "center left",
						"data-automation": "wafer-map__zoom-in--tooltip",
						self: "center right"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_10, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomIn")), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["class"])) : createCommentVNode("", true),
				__props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button_default, {
					key: 3,
					class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md q-mb-md": __props.isSplitView }]),
					"data-automation": "wafer-map__zoom-out",
					disable: disableZoomOut.value,
					icon: "mdi-minus",
					secondary: "",
					size: "xs",
					onClick: withModifiers(zoomOut, ["stop"])
				}, {
					default: withCtx(() => [createVNode(Tooltip_default, {
						anchor: "center left",
						"data-automation": "wafer-map__zoom-out--tooltip",
						self: "center right"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_11, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomOut")), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["class", "disable"])) : createCommentVNode("", true)
			], 2)], 64);
		};
	}
}), [["__scopeId", "data-v-4b5ec1e6"]]);
//#endregion
//#region src/components/WaferMap/WaferMapChartFilters.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$6 = ["data-automation"];
var _hoisted_2$3 = ["data-automation"];
var _hoisted_3$2 = ["data-automation"];
//#endregion
//#region src/components/WaferMap/WaferMapChartFilters.vue
var WaferMapChartFilters_default = /* @__PURE__ */ defineComponent({
	__name: "WaferMapChartFilters",
	props: { dataAutomation: {
		default: "wafer-map-chart-filters",
		type: String
	} },
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "border-card rounded-borders q-mb-md",
				"data-automation": unref(buildId)()
			}, [createVNode(ExpansionItem_default, {
				class: "q-px-lg q-py-md",
				"data-automation": unref(buildId)("expansion-item"),
				"default-opened": "",
				label: _ctx.$t("rvai-base.components.waferMap.chartSpecificFilters"),
				"no-hover-animation": ""
			}, {
				default: withCtx(() => [createElementVNode("div", {
					class: "text-body3",
					"data-automation": unref(buildId)("annotation-source")
				}, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_2$3), createElementVNode("div", {
					class: "text-subtitle3",
					"data-automation": unref(buildId)("last-updated-annotations")
				}, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_3$2)]),
				_: 1
			}, 8, ["data-automation", "label"])], 8, _hoisted_1$6);
		};
	}
});
//#endregion
//#region src/components/WaferMap/WaferMapChartLegend.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$5 = ["data-automation"];
var _hoisted_2$2 = ["data-automation"];
var _hoisted_3$1 = ["data-automation"];
//#endregion
//#region src/components/WaferMap/WaferMapChartLegend.vue
var WaferMapChartLegend_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "WaferMapChartLegend",
	props: {
		classes: {
			required: true,
			type: Array
		},
		dataAutomation: {
			default: "wafer-map-chart-legend",
			type: String
		}
	},
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "border-card rounded-borders",
				"data-automation": unref(buildId)()
			}, [createVNode(ExpansionItem_default, {
				class: "q-px-lg q-py-md full-height",
				"content-class": "full-height q-mt-sm",
				"data-automation": unref(buildId)("expansion-item"),
				"default-opened": "",
				label: _ctx.$t("rvai-base.components.waferMap.annotations"),
				"no-hover-animation": ""
			}, {
				default: withCtx(() => [__props.classes.length ? (openBlock(), createBlock(ScrollArea_default, {
					key: 0,
					class: "annotation-class-item__list full-height col-grow",
					"data-automation": unref(buildId)("annotation-class-item__list"),
					"no-horizontal": ""
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.classes, (annotationClass) => {
						return openBlock(), createElementBlock("div", {
							key: annotationClass.id,
							class: "row no-wrap items-center q-pb-sm",
							"data-automation": unref(buildId)("annotation-class-item")
						}, [createVNode(Bullet_default, {
							class: "q-pr-sm",
							color: annotationClass.color,
							"data-automation": unref(buildId)("annotation-class-item__bullet"),
							"is-tooltip-shown": false,
							size: 8,
							style: normalizeStyle({ visibility: annotationClass.id === "unannotated" ? "hidden" : "visible" })
						}, null, 8, [
							"color",
							"data-automation",
							"style"
						]), createVNode(EllipsisText_default, {
							"data-automation": unref(buildId)("annotation-class-item__name"),
							text: annotationClass.name
						}, null, 8, ["data-automation", "text"])], 8, _hoisted_2$2);
					}), 128))]),
					_: 1
				}, 8, ["data-automation"])) : (openBlock(), createElementBlock("div", {
					key: 1,
					"data-automation": unref(buildId)("no-items")
				}, toDisplayString(_ctx.$t("rvai-base.components.waferMap.noItems")), 9, _hoisted_3$1))]),
				_: 1
			}, 8, ["data-automation", "label"])], 8, _hoisted_1$5);
		};
	}
}), [["__scopeId", "data-v-317d98ed"]]);
//#endregion
//#region src/components/WaferMap/WaferMapError.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = ["data-automation"];
var _hoisted_2$1 = { key: 0 };
//#endregion
//#region src/components/WaferMap/WaferMapError.vue
var WaferMapError_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "WaferMapError",
	props: {
		dataAutomation: {
			default: "wafer-map-error",
			type: String
		},
		loadingFailed: {
			default: false,
			type: Boolean
		}
	},
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "wafer-map-error relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5 text-center",
				"data-automation": unref(buildId)()
			}, [createElementVNode("div", null, toDisplayString(__props.loadingFailed ? _ctx.$t("rvai-base.general.text.loadingFailed") : _ctx.$t("rvai-base.components.waferMap.noPositions")), 1), __props.loadingFailed ? (openBlock(), createElementBlock("div", _hoisted_2$1, toDisplayString(_ctx.$t("rvai-base.components.waferMap.loadingFailedExtra")), 1)) : createCommentVNode("", true)], 8, _hoisted_1$4);
		};
	}
}), [["__scopeId", "data-v-c7dfd97d"]]);
//#endregion
//#region src/components/WaferMap/WaferMapLoader.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = ["data-automation"];
//#endregion
//#region src/components/WaferMap/WaferMapLoader.vue
var WaferMapLoader_default = /* @__PURE__ */ defineComponent({
	__name: "WaferMapLoader",
	props: { dataAutomation: {
		default: "wafer-map-loader",
		type: String
	} },
	setup(__props) {
		const { buildId } = useAutomation(__props.dataAutomation);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5",
				"data-automation": unref(buildId)()
			}, [
				createVNode(unref(QSpinner_default), {
					color: "primary",
					"data-automation": unref(buildId)("spinner"),
					size: "40px"
				}, null, 8, ["data-automation"]),
				createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loading")), 1),
				createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loadingExtra")), 1)
			], 8, _hoisted_1$3);
		};
	}
});
//#endregion
//#region src/components/WaferMap/WaferMap.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$2 = ["data-automation"];
var _hoisted_2 = ["data-automation"];
var _hoisted_3 = ["data-automation"];
var _hoisted_4 = ["data-automation"];
var _hoisted_5 = ["data-automation"];
var _hoisted_6 = ["data-automation"];
var _hoisted_7 = ["data-automation"];
var annotationSourceHeight = 64;
//#endregion
//#region src/components/WaferMap/WaferMap.vue
var WaferMap_default = /* @__PURE__ */ defineComponent({
	__name: "WaferMap",
	props: {
		annotationSources: {
			default: void 0,
			type: Array
		},
		backgroundImage: {
			default: void 0,
			type: String
		},
		dataset: {
			default: () => ({}),
			type: Object
		},
		fullscreen: {
			default: false,
			type: Boolean
		},
		isPartiallyLoaded: {
			default: false,
			type: Boolean
		},
		isSplitView: {
			default: false,
			type: Boolean
		},
		loading: {
			default: false,
			type: Boolean
		},
		loadingFailed: {
			default: false,
			type: Boolean
		},
		modelValue: {
			required: true,
			type: Array
		}
	},
	emits: [
		"resetBackground",
		"resize",
		"toggleFullscreen",
		"update:modelValue"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const wrapperRef = ref();
		const canvasRef = ref();
		const canvasFullscreenRef = ref();
		__expose({
			canvasFullscreenRef,
			canvasRef,
			wrapperRef
		});
		const { buildId } = useAutomation("wafer-map");
		const selection = computed(() => props.modelValue);
		const classes = computed(() => props.dataset?.classes ?? []);
		const warningHeight = computed(() => {
			const blockHeight = props.fullscreen ? 58 : 70;
			return props.isPartiallyLoaded ? blockHeight : 0;
		});
		async function onResize({ width }) {
			emit("resize", {
				annotationSourceHeight,
				warningHeight: warningHeight.value,
				width
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "wrapperRef",
				ref: wrapperRef,
				class: normalizeClass(["full-height bg-white", { "flex no-wrap q-pt-md": __props.fullscreen }]),
				"data-automation": unref(buildId)(),
				style: normalizeStyle({
					"--annotation-source-height": `${annotationSourceHeight}px`,
					"--warning-height": `${warningHeight.value}px`
				})
			}, [createVNode(unref(QResizeObserver_default), { onResize }), __props.loading ? (openBlock(), createBlock(WaferMapLoader_default, { key: 0 })) : __props.loadingFailed || !__props.dataset?.dataPoints?.length ? (openBlock(), createBlock(WaferMapError_default, {
				key: 1,
				"loading-failed": __props.loadingFailed
			}, null, 8, ["loading-failed"])) : __props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [createElementVNode("div", {
				class: "wafer-map__sidepanel column no-wrap",
				"data-automation": unref(buildId)("sidepanel")
			}, [createVNode(WaferMapChartFilters_default), createVNode(WaferMapChartLegend_default, { classes: classes.value }, null, 8, ["classes"])], 8, _hoisted_2), createElementVNode("div", {
				class: normalizeClass(["wafer-map__fullscreen", { "border-card rounded-borders full-width q-pa-md": __props.fullscreen }]),
				"data-automation": unref(buildId)("fullscreen-container")
			}, [createElementVNode("div", {
				class: normalizeClass(["relative-position", __props.isPartiallyLoaded ? "wafer-map__fullscreen--partial" : "wafer-map__fullscreen--full"]),
				"data-automation": unref(buildId)("fullscreen-wrapper")
			}, [createVNode(WaferMapChart_default, {
				ref_key: "canvasFullscreenRef",
				ref: canvasFullscreenRef,
				modelValue: selection.value,
				"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => selection.value = $event), _cache[2] || (_cache[2] = ($event) => emit("update:modelValue", $event))],
				"annotation-sources": __props.annotationSources,
				"background-image": __props.backgroundImage,
				dataset: __props.dataset,
				fullscreen: __props.fullscreen,
				onResetBackground: _cache[1] || (_cache[1] = ($event) => emit("resetBackground"))
			}, null, 8, [
				"modelValue",
				"annotation-sources",
				"background-image",
				"dataset",
				"fullscreen"
			])], 10, _hoisted_4)], 10, _hoisted_3)], 64)) : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
				createElementVNode("div", {
					class: "wafer-map__annotation-source",
					"data-automation": unref(buildId)("annotation-source")
				}, [createElementVNode("div", {
					class: "text-body3",
					"data-automation": unref(buildId)("annotation-source__label")
				}, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_6), createElementVNode("div", {
					class: "text-subtitle3",
					"data-automation": unref(buildId)("annotation-source__last-updated")
				}, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_7)], 8, _hoisted_5),
				__props.isPartiallyLoaded ? (openBlock(), createBlock(WaferMapWarning_default, {
					key: 0,
					fullscreen: __props.fullscreen,
					"samples-count": __props.dataset.samplesCount,
					"total-count": __props.dataset.totalCount
				}, null, 8, [
					"fullscreen",
					"samples-count",
					"total-count"
				])) : createCommentVNode("", true),
				createVNode(WaferMapChart_default, {
					ref_key: "canvasRef",
					ref: canvasRef,
					modelValue: selection.value,
					"onUpdate:modelValue": [_cache[3] || (_cache[3] = ($event) => selection.value = $event), _cache[6] || (_cache[6] = ($event) => emit("update:modelValue", $event))],
					"annotation-sources": __props.annotationSources,
					"background-image": __props.backgroundImage,
					dataset: __props.dataset,
					"is-split-view": __props.isSplitView,
					onResetBackground: _cache[4] || (_cache[4] = ($event) => emit("resetBackground")),
					onToggleFullscreen: _cache[5] || (_cache[5] = ($event) => emit("toggleFullscreen", true))
				}, null, 8, [
					"modelValue",
					"annotation-sources",
					"background-image",
					"dataset",
					"is-split-view"
				])
			], 64))], 14, _hoisted_1$2);
		};
	}
});
//#endregion
//#region src/components/index.ts
var components_exports = /* @__PURE__ */ __exportAll({
	ActionButton: () => ActionButton_default,
	AutoHeight: () => AutoHeight_default,
	Avatar: () => Avatar_default,
	BackButton: () => BackButton_default,
	BarChart: () => BarChart_default,
	Bullet: () => Bullet_default,
	Button: () => Button_default,
	ButtonDropdown: () => ButtonDropdown_default,
	Card: () => Card_default,
	CardImage: () => CardImage_default,
	CardItem: () => CardItem_default,
	Carousel: () => Carousel_default,
	Chart: () => Chart_default,
	ChartLineIndicator: () => ChartLineIndicator_default,
	Checkbox: () => Checkbox_default,
	Chip: () => Chip_default,
	CircularProgress: () => CircularProgress_default,
	ClickableArea: () => ClickableArea_default,
	ColorPicker: () => ColorPicker_default,
	ColorPickerInput: () => ColorPickerInput_default,
	ColorPickerV2: () => ColorPickerV2_default,
	CombinedInputs: () => CombinedInputs_default,
	ConfirmDialog: () => ConfirmDialog_default,
	ConfusionMatrix: () => ConfusionMatrix_default,
	CookiesDialog: () => CookiesDialog_default,
	CopyContentBtn: () => CopyContentBtn_default,
	DatePicker: () => DatePicker_default,
	Dialog: () => Dialog_default,
	DoubleCircularProgress: () => DoubleCircularProgress_default,
	Dropzone: () => Dropzone_default,
	Duration: () => Duration_default,
	EditableText: () => EditableText_default,
	EllipsisText: () => EllipsisText_default,
	ExpansionItem: () => ExpansionItem_default,
	ExpansionList: () => ExpansionList_default,
	FieldEdit: () => FieldEdit_default,
	FieldsVisibilityDialog: () => FieldsVisibilityDialog_default,
	FilePicker: () => FilePicker_default,
	FilterableList: () => FilterableList_default,
	HeaderNavigationItems: () => HeaderNavigationItems_default,
	HealthIcon: () => HealthIcon_default,
	Histogram: () => Histogram_default,
	HistogramWrapper: () => HistogramWrapper_default,
	InfoDialog: () => InfoDialog_default,
	InfoPanel: () => InfoPanel_default,
	Input: () => Input_default,
	LabelerSlider: () => LabelerSlider_default,
	LayoutButton: () => LayoutButton_default,
	LinearProgress: () => LinearProgress_default,
	LocalUrl: () => LocalUrl_default,
	Logo: () => Logo_default,
	MainContent: () => MainContent_default,
	MultipleSelect: () => MultipleSelect_default,
	NavigationBar: () => NavigationBar_default,
	NavigationBarLink: () => NavigationBarLink_default,
	NavigationBarOverlay: () => NavigationBarOverlay_default,
	NavigationBarTree: () => NavigationBarTree_default,
	NavigationHeader: () => NavigationHeader_default,
	NavigationTitle: () => NavigationTitle_default,
	NoData: () => NoData_default,
	OptionGroup: () => OptionGroup_default,
	Pagination: () => Pagination_default,
	PoliciesAndLicenses: () => PoliciesAndLicenses_default,
	PrivacyPolicyDialog: () => PrivacyPolicyDialog_default,
	Radio: () => Radio_default,
	Range: () => Range_default,
	ScrollArea: () => ScrollArea_default,
	ScrollNavigation: () => ScrollNavigation_default,
	SearchInput: () => SearchInput_default,
	SectionMessage: () => SectionMessage_default,
	Select: () => Select_default,
	SelectBoolean: () => SelectBoolean_default,
	Separator: () => Separator_default,
	Sidebar: () => Sidebar_default,
	SidebarListClassSlugs: () => SidebarListClassSlugs_default,
	SidebarLoading: () => SidebarLoading_default,
	Slider: () => Slider_default,
	SortButton: () => SortButton_default,
	SortSelect: () => SortSelect_default,
	Spinner: () => Spinner_default,
	SpinnerAbsolute: () => SpinnerAbsolute_default,
	SpinnerFixed: () => SpinnerFixed_default,
	StatusPanel: () => StatusPanel_default,
	StepSidebar: () => StepSidebar_default,
	StepSidebarContent: () => StepSidebarContent_default,
	SuspenseWithError: () => SuspenseWithError_default,
	Table: () => Table_default,
	TableCard: () => TableCard_default,
	TableFilter: () => TableFilter_default,
	TableFilterItem: () => TableFilterItem_default,
	TableFullRowStatus: () => TableFullRowStatus_default,
	TableList: () => TableList_default,
	TableSortBy: () => TableSortBy_default,
	Tabs: () => Tabs_default,
	TermsAndConditionsDialog: () => TermsAndConditionsDialog_default,
	Toggle: () => Toggle_default,
	Tooltip: () => Tooltip_default,
	TreeTable: () => TreeTable_default,
	UsersGroup: () => UsersGroup_default,
	Validation: () => Validation_default,
	ValidationTooltip: () => ValidationTooltip_default,
	WaferMap: () => WaferMap_default
});
//#endregion
//#region src/directives/heightAuto.ts
var HeightAuto = { mounted(el, binding) {
	const parent = el.parentElement;
	if (!parent) return;
	const target = (binding.value && el.querySelector(binding.value)) ?? el;
	target.style.height = `${parent.offsetHeight}px`;
} };
//#endregion
//#region src/directives/focus.ts
function focusFirstInput(el, binding) {
	if (!binding.value) return;
	const target = el.querySelector(`
    input[type='text']:not([disabled]):not([tabindex='-1']),
    select:not([disabled]):not([tabindex='-1']),
    textarea:not([disabled]):not([tabindex='-1'])
  `);
	if (!target) return;
	target.focus();
}
var Focus = {
	mounted: focusFirstInput,
	updated: focusFirstInput
};
//#endregion
//#region src/directives/hotkey.ts
var keyHandler;
var instances = /* @__PURE__ */ new Map();
function defineKeyMap(binding) {
	const bindingValue = binding.value;
	return Object.keys(bindingValue).reduce((acc, curr) => acc.set(curr, bindingValue[curr]), /* @__PURE__ */ new Map());
}
function bindEvent(el, binding) {
	const keyMap = defineKeyMap(binding);
	instances.set(binding.instance, keyMap);
	keyHandler = (e) => {
		if ([...instances.values()].some((keyMap) => keyMap.get(e.key) === false)) return;
		const callback = keyMap.get(e.key);
		const isElementHidden = el.offsetParent === null;
		if (typeof callback !== "function" || isElementHidden) return;
		callback();
	};
	document.addEventListener("keyup", keyHandler);
}
function unbindEvent(_, binding) {
	instances.delete(binding.instance);
	document.removeEventListener("keyup", keyHandler);
}
var Hotkey = {
	mounted: bindEvent,
	unmounted: unbindEvent
};
//#endregion
//#region src/directives/quasarVariables.ts
var variables = [
	"accent",
	"black-1",
	"blue",
	"dark-page",
	"dark",
	"grey-1",
	"grey-2",
	"grey-3",
	"grey-5",
	"grey-6",
	"info",
	"negative",
	"pink-1",
	"pink-2",
	"pink-3",
	"pink",
	"positive",
	"primary",
	"secondary",
	"warning",
	"white"
];
var QuasarVariables = { mounted(el) {
	el.onload = function() {
		for (const color of variables) el.contentDocument?.body.style.setProperty(`--q-${color}`, getCssVar(color));
	};
} };
//#endregion
//#region src/directives/index.ts
var directives_exports = /* @__PURE__ */ __exportAll({
	Focus: () => Focus,
	HeightAuto: () => HeightAuto,
	Hotkey: () => Hotkey,
	QuasarVariables: () => QuasarVariables
});
//#endregion
//#region src/layouts/FullLayout.vue?vue&type=script&lang.ts
var FullLayout_vue_vue_type_script_lang_default = defineComponent({
	name: "FullLayout",
	components: {
		NavigationBarOverlay: NavigationBarOverlay_default,
		QLayout: QLayout_default,
		QPageContainer: QPageContainer_default,
		RouterView
	},
	setup() {
		const { showOverlay, toggleShowOverlay, watchRoute } = useLayout();
		const { navigation } = useOptionsReadOnly();
		const overlayRef = ref(null);
		const helpUrl = computed(() => navigation.helpUrl);
		const homeRoute = computed(() => navigation.homeRoute);
		const items = computed(() => navigation.items ?? []);
		function closeOverlay() {
			toggleShowOverlay(false);
		}
		onMounted(() => {
			toggleShowOverlay(false);
		});
		watchRoute([Layout.Default, Layout.LeftOnly]);
		return {
			closeOverlay,
			helpUrl,
			homeRoute,
			items,
			overlayRef,
			showOverlay
		};
	}
});
//#endregion
//#region src/layouts/FullLayout.vue
var _hoisted_1$1 = {
	ref: "overlayRef",
	class: "navigation-bar-overlay"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationBarOverlay = resolveComponent("NavigationBarOverlay");
	const _component_RouterView = resolveComponent("RouterView");
	const _component_QPageContainer = resolveComponent("QPageContainer");
	const _component_QLayout = resolveComponent("QLayout");
	return openBlock(), createBlock(_component_QLayout, {
		class: "full-layout",
		view: "hHh LpR lfr"
	}, {
		default: withCtx(() => [
			withDirectives(createElementVNode("div", {
				class: "full-layout__backdrop fixed-full",
				onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
			}, null, 512), [[vShow, _ctx.showOverlay]]),
			withDirectives(createElementVNode("div", _hoisted_1$1, [renderSlot(_ctx.$slots, "navigation", { onCloseOverlay: _cache[1] || (_cache[1] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args)) }, () => [createVNode(_component_NavigationBarOverlay, {
				"data-automation": "navigationBarOverlay",
				"help-url": _ctx.helpUrl,
				"home-route": _ctx.homeRoute,
				items: _ctx.items
			}, null, 8, [
				"help-url",
				"home-route",
				"items"
			])], true)], 512), [[vShow, _ctx.showOverlay]]),
			createVNode(_component_QPageContainer, null, {
				default: withCtx(() => [createVNode(_component_RouterView)]),
				_: 1
			})
		]),
		_: 3
	});
}
var FullLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(FullLayout_vue_vue_type_script_lang_default, [["render", _sfc_render$4], ["__scopeId", "data-v-35577d11"]]);
//#endregion
//#region src/layouts/MainLayout.vue?vue&type=script&lang.ts
var MainLayout_vue_vue_type_script_lang_default = defineComponent({
	name: "MainLayout",
	components: {
		NavigationBar: NavigationBar_default,
		QDrawer: QDrawer_default,
		QLayout: QLayout_default,
		QPageContainer: QPageContainer_default,
		RouterView
	},
	setup() {
		const { collapsedNavigationbar, collapsedNavigationbarAfterAnimation, watchRoute } = useLayout();
		const { navigation } = useOptionsReadOnly();
		const helpUrl = computed(() => toValue(navigation.helpUrl));
		const homeRoute = computed(() => navigation.homeRoute);
		const items = computed(() => navigation.items ?? []);
		watchRoute([Layout.Default, Layout.LeftOnly]);
		return {
			collapsedNavigationbar,
			collapsedNavigationbarAfterAnimation,
			helpUrl,
			homeRoute,
			items
		};
	}
});
//#endregion
//#region src/layouts/MainLayout.vue
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationBar = resolveComponent("NavigationBar");
	const _component_QDrawer = resolveComponent("QDrawer");
	const _component_RouterView = resolveComponent("RouterView");
	const _component_QPageContainer = resolveComponent("QPageContainer");
	const _component_QLayout = resolveComponent("QLayout");
	return openBlock(), createBlock(_component_QLayout, {
		class: "main-layout",
		view: "lHh LpR lff"
	}, {
		default: withCtx(() => [createVNode(_component_QDrawer, {
			breakpoint: 0,
			mini: _ctx.collapsedNavigationbarAfterAnimation,
			"mini-width": 72,
			"model-value": true,
			persistent: "",
			"show-if-above": "",
			side: "left",
			width: 312
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "navigation", {}, () => [createVNode(_component_NavigationBar, {
				"data-automation": "navigationBar",
				"help-url": _ctx.helpUrl,
				"home-route": _ctx.homeRoute,
				items: _ctx.items
			}, null, 8, [
				"help-url",
				"home-route",
				"items"
			])])]),
			_: 3
		}, 8, ["mini"]), createVNode(_component_QPageContainer, null, {
			default: withCtx(() => [createVNode(_component_RouterView)]),
			_: 1
		})]),
		_: 3
	});
}
var MainLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(MainLayout_vue_vue_type_script_lang_default, [["render", _sfc_render$3]]);
//#endregion
//#region src/layouts/Passthrough.vue
var _sfc_main = {};
function _sfc_render$2(_ctx, _cache) {
	const _component_RouterView = resolveComponent("RouterView");
	return openBlock(), createBlock(_component_RouterView);
}
var Passthrough_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render$2]]);
//#endregion
//#region src/layouts/LabelerLayout.vue?vue&type=script&lang.ts
var BREAK_POINT$1 = 1536;
var SPLIT_VIEW_BREAK_POINT = 1920;
var SPLIT_ALLOWED_BREAK_POINT = 1440;
var LabelerLayout_vue_vue_type_script_lang_default = defineComponent({
	name: "LabelerLayout",
	components: {
		NavigationBar: NavigationBar_default,
		NavigationBarOverlay: NavigationBarOverlay_default,
		QDrawer: QDrawer_default,
		QLayout: QLayout_default,
		QPageContainer: QPageContainer_default,
		QResizeObserver: QResizeObserver_default,
		RouterView
	},
	setup() {
		const { availableLayouts, collapsedNavigationbar, collapsedNavigationbarAfterAnimation, isFullLayout, isSplitLayout, layout, setAvailableLayouts, setSmallScreen, showOverlay, smallScreen, toggleNavigationBar, toggleShowOverlay, watchRoute } = useLayout();
		const { navigation } = useOptionsReadOnly();
		const screenWidth = ref(window.innerWidth);
		const helpUrl = computed(() => toValue(navigation.helpUrl));
		const homeRoute = computed(() => navigation.homeRoute);
		const items = computed(() => navigation.items ?? []);
		const isSplitLayoutSmallScreen = computed(() => {
			return isSplitLayout.value && screenWidth.value < SPLIT_VIEW_BREAK_POINT;
		});
		const minDrawerWidth = computed(() => {
			return isFullLayout.value || isSplitLayoutSmallScreen.value ? 0 : 72;
		});
		watchRoute([
			Layout.Default,
			Layout.Full,
			Layout.LeftOnly,
			Layout.RightOnly,
			Layout.Split
		]);
		const onResize = ({ width }) => {
			screenWidth.value = width;
			if (width < SPLIT_ALLOWED_BREAK_POINT) setAvailableLayouts(availableLayouts.value.filter((v) => v !== Layout.Split));
			else setAvailableLayouts(distinct([...availableLayouts.value, Layout.Split]));
			if (width <= BREAK_POINT$1 || isSplitLayout.value && width < SPLIT_VIEW_BREAK_POINT) {
				setSmallScreen(true);
				toggleNavigationBar(true);
			} else setSmallScreen(false);
		};
		function closeOverlay() {
			toggleNavigationBar(true);
			toggleShowOverlay(false);
		}
		function closeOverlayOnSmallScreen() {
			if (smallScreen.value) closeOverlay();
		}
		onBeforeRouteLeave(closeOverlayOnSmallScreen);
		onBeforeRouteUpdate(closeOverlayOnSmallScreen);
		watch(isFullLayout, (value) => {
			if (value) closeOverlay();
		});
		return {
			closeOverlay,
			collapsedNavigationbar,
			collapsedNavigationbarAfterAnimation,
			helpUrl,
			homeRoute,
			items,
			layout,
			minDrawerWidth,
			onResize,
			showOverlay,
			smallScreen
		};
	}
});
//#endregion
//#region src/layouts/LabelerLayout.vue
var _hoisted_1 = {
	ref: "overlayRef",
	class: "navigation-bar-overlay"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationBarOverlay = resolveComponent("NavigationBarOverlay");
	const _component_NavigationBar = resolveComponent("NavigationBar");
	const _component_QDrawer = resolveComponent("QDrawer");
	const _component_RouterView = resolveComponent("RouterView");
	const _component_QPageContainer = resolveComponent("QPageContainer");
	const _component_QLayout = resolveComponent("QLayout");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_QLayout, {
		class: "labeler-layout",
		"data-automation-view": _ctx.layout,
		view: "lHh LpR lff"
	}, {
		default: withCtx(() => [
			withDirectives(createElementVNode("div", {
				class: "labeler-layout__backdrop fixed-full",
				onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
			}, null, 512), [[vShow, _ctx.showOverlay]]),
			withDirectives(createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "navigation", { onCloseOverlay: _cache[1] || (_cache[1] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args)) }, () => [createVNode(_component_NavigationBarOverlay, {
				"data-automation": "navigationBarOverlay",
				"help-url": _ctx.helpUrl,
				"home-route": _ctx.homeRoute,
				items: _ctx.items
			}, null, 8, [
				"help-url",
				"home-route",
				"items"
			])], true)], 512), [[vShow, _ctx.showOverlay]]),
			withDirectives(createElementVNode("div", {
				class: "labeler-layout__backdrop fixed-full",
				onClick: _cache[2] || (_cache[2] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
			}, null, 512), [[vShow, _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation]]),
			createVNode(_component_QDrawer, {
				breakpoint: 0,
				mini: _ctx.collapsedNavigationbarAfterAnimation,
				"mini-to-overlay": _ctx.smallScreen,
				"mini-width": _ctx.minDrawerWidth,
				"model-value": true,
				persistent: "",
				"show-if-above": "",
				side: "left",
				width: 312
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "navigation", {}, () => [createVNode(_component_NavigationBar, {
					"data-automation": "navigationBar",
					"help-url": _ctx.helpUrl,
					"home-route": _ctx.homeRoute,
					items: _ctx.items,
					overlay: _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation,
					"show-toggle": "",
					onCloseOverlay: _ctx.closeOverlay
				}, null, 8, [
					"help-url",
					"home-route",
					"items",
					"overlay",
					"onCloseOverlay"
				])], true)]),
				_: 3
			}, 8, [
				"mini",
				"mini-to-overlay",
				"mini-width"
			]),
			createVNode(_component_QPageContainer, null, {
				default: withCtx(() => [createVNode(_component_RouterView)]),
				_: 1
			})
		]),
		_: 3
	}, 8, ["data-automation-view"]), createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])], 64);
}
var LabelerLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(LabelerLayout_vue_vue_type_script_lang_default, [["render", _sfc_render$1], ["__scopeId", "data-v-ebd7b723"]]);
//#endregion
//#region src/layouts/ResponsiveLayout.vue?vue&type=script&lang.ts
var BREAK_POINT = 1536;
var ResponsiveLayout_vue_vue_type_script_lang_default = defineComponent({
	name: "ResponsiveLayout",
	components: {
		NavigationBar: NavigationBar_default,
		QDrawer: QDrawer_default,
		QLayout: QLayout_default,
		QPageContainer: QPageContainer_default,
		QResizeObserver: QResizeObserver_default,
		RouterView
	},
	setup() {
		const { collapsedNavigationbar, collapsedNavigationbarAfterAnimation, setSmallScreen, smallScreen, toggleNavigationBar, watchRoute } = useLayout();
		const { navigation } = useOptions();
		const helpUrl = computed(() => toValue(navigation.helpUrl));
		const homeRoute = computed(() => navigation.homeRoute);
		const items = computed(() => navigation.items ?? []);
		watchRoute([Layout.Default, Layout.LeftOnly]);
		const onResize = ({ width }) => {
			if (width <= BREAK_POINT) {
				setSmallScreen(true);
				toggleNavigationBar(true);
			} else setSmallScreen(false);
		};
		function closeOverlay() {
			toggleNavigationBar(true);
		}
		function closeOverlayOnSmallScreen() {
			if (smallScreen.value) closeOverlay();
		}
		onBeforeRouteLeave(closeOverlayOnSmallScreen);
		onBeforeRouteUpdate(closeOverlayOnSmallScreen);
		return {
			closeOverlay,
			collapsedNavigationbar,
			collapsedNavigationbarAfterAnimation,
			helpUrl,
			homeRoute,
			items,
			onResize,
			smallScreen
		};
	}
});
//#endregion
//#region src/layouts/ResponsiveLayout.vue
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_NavigationBar = resolveComponent("NavigationBar");
	const _component_QDrawer = resolveComponent("QDrawer");
	const _component_RouterView = resolveComponent("RouterView");
	const _component_QPageContainer = resolveComponent("QPageContainer");
	const _component_QLayout = resolveComponent("QLayout");
	const _component_QResizeObserver = resolveComponent("QResizeObserver");
	return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_QLayout, {
		class: "responsive-layout",
		view: "lHh LpR lff"
	}, {
		default: withCtx(() => [
			withDirectives(createElementVNode("div", {
				class: "responsive-layout__backdrop fixed-full",
				onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
			}, null, 512), [[vShow, _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation]]),
			createVNode(_component_QDrawer, {
				breakpoint: 0,
				mini: _ctx.collapsedNavigationbarAfterAnimation,
				"mini-to-overlay": _ctx.smallScreen,
				"mini-width": 72,
				"model-value": true,
				persistent: "",
				"show-if-above": "",
				side: "left",
				width: 312
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "navigation", {}, () => [createVNode(_component_NavigationBar, {
					"data-automation": "navigationBar",
					"help-url": _ctx.helpUrl,
					"home-route": _ctx.homeRoute,
					items: _ctx.items,
					overlay: _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation,
					"show-toggle": "",
					onCloseOverlay: _ctx.closeOverlay
				}, null, 8, [
					"help-url",
					"home-route",
					"items",
					"overlay",
					"onCloseOverlay"
				])], true)]),
				_: 3
			}, 8, ["mini", "mini-to-overlay"]),
			createVNode(_component_QPageContainer, null, {
				default: withCtx(() => [createVNode(_component_RouterView)]),
				_: 1
			})
		]),
		_: 3
	}), createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])], 64);
}
var ResponsiveLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponsiveLayout_vue_vue_type_script_lang_default, [["render", _sfc_render], ["__scopeId", "data-v-7f5670b5"]]);
//#endregion
//#region src/layouts/index.ts
var layouts_exports = /* @__PURE__ */ __exportAll({
	FullLayout: () => FullLayout_default,
	LabelerLayout: () => LabelerLayout_default,
	MainLayout: () => MainLayout_default,
	Passthrough: () => Passthrough_default,
	ResponsiveLayout: () => ResponsiveLayout_default
});
//#endregion
//#region src/i18n/en.json
var en_default = { "rvai-base": /*#__PURE__*/ JSON.parse("{\"charts\":{\"relative\":\"Relative: {0}\",\"step\":\"Step: {0}\"},\"components\":{\"classesTooltipInfo\":{\"displayName\":\"Display name:\",\"originalName\":\"Original name:\"},\"colorPicker\":{\"hex\":\"Hex\",\"rgb\":{\"b\":\"B\",\"g\":\"G\",\"r\":\"R\"}},\"confusionMatrix\":{\"matchPercentage\":\"Match (%)\",\"noAnnotation\":\"No label\"},\"copyContentButton\":{\"copied\":\"Copied\",\"copy\":\"Copy to clipboard\"},\"datePicker\":{\"days\":\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\",\"daysShort\":\"S_M_T_W_T_F_S\",\"hh\":\"hh\",\"mm\":\"mm\",\"months\":\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\",\"monthsShort\":\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\",\"selectTime\":\"Select time\",\"ss\":\"ss\",\"wrongFormat\":\"Date format is wrong\"},\"dropzone\":{\"addMore\":\"Add more\",\"clearAll\":\"clear all files\",\"clearFile\":\"Clear file\",\"dataDescription\":\"{0} or {1}\",\"dataTitle\":\"File selected and ready for upload | Files selected and ready for upload\",\"denseTitle\":\"Upload from computer\",\"dragDescription\":\"Release your files here to upload\",\"dragTitle\":\"Release files\",\"emptyDescription\":\"or {0}\",\"emptyTitle\":\"Drag & drop new file | Drag & drop new files\",\"errorTitle\":\"Oops...\",\"maxFiles\":\"max {n} file | max {n} files\",\"retry\":\"Try again\",\"uploadFromComputer\":\"upload from computer\",\"validation\":{\"fileExtensions\":\"The file format is not supported.\",\"maxFiles\":\"Too many files selected. A maximum of {0} files can be selected.\",\"maxSize\":\"Your data is too big. You selected {0} but the maximum size is {1}.\"}},\"duration\":{\"infinite\":\"Infinite\"},\"health\":{\"autoscalingStatus\":{\"critical\":\"Not all running instances are able to respond or are being started up through autoscaling\"},\"replicaStatus\":{\"error\":\"Group has an error\",\"queued\":\"Group is queued and will start soon\",\"running\":\"Group is running healthy\",\"starting\":\"Group is warming up for training\"},\"status\":{\"critical\":\"Not all running instances are able to respond\",\"failing\":\"Some instances are experiencing inference failures\",\"healthy\":\"Group is running healthy\",\"overpowered\":\"Reducing instances will free up resources for other groups\",\"stopped\":\"Group was stopped\",\"underpowered\":\"Increase instances if possible\",\"unknown\":\"No health information received yet\"}},\"histogram\":{\"annotations\":\"Annotations\",\"chartTitle\":\"Chart: \",\"classDistribution\":\"Class distribution\",\"classId\":\"Class ID\",\"className\":\"Class name\",\"count\":\"Count\",\"countPct\":\"<strong>{count}</strong> ({pct})\",\"emptyAnnotation\":\"Empty annotation\",\"mode\":\"Count:\",\"modes\":{\"annotations\":\"Annotations\",\"samples\":\"Samples\"},\"name\":\"Name\",\"noLabel\":\"No label\",\"notAnnotated\":\"Not annotated\",\"percentage\":\"Percentage\",\"samples\":\"Samples\",\"split\":\"Split:\",\"trainingSetup\":{\"all\":\"All\",\"test\":\"Test set\",\"train\":\"Train set\",\"validate\":\"Validation set\"},\"unknownClass\":\"Unknown class\"},\"multipleSelect\":{\"allItemsSelected\":\"All items selected\",\"noItems\":\"No items\",\"search\":\"Search\",\"selectAll\":\"Select all\",\"selectOption\":\"Select option\"},\"pagination\":{\"noPage\":\"There is no page '{page}'. Select a page between {min} and {max}.\"},\"searchInput\":{\"noMatches\":\"No matches\"},\"sliderWithInput\":{\"value\":\"The value\"},\"waferMap\":{\"annotations\":\"Annotations\",\"annotationSource\":\"Annotation source:\",\"chartSpecificFilters\":\"Chart-specific filters\",\"classes\":\"Classes\",\"deselect\":\"Deselect\",\"lastUpdatedAnnotations\":\"Last updated annotations\",\"loadingFailedExtra\":\"Please clear the chart setup and try again.\",\"locationMissing\":\"{0} of {1} sample positions are missing.\",\"makeFreehandSelection\":\"Make freehand selection\",\"noItems\":\"No items\",\"noPositions\":\"These samples don’t have positions; therefore, the wafer map cannot be generated.\",\"notAnnotated\":\"Not annotated\",\"resetZoomLevel\":\"Reset zoom\",\"selectedCount\":\"{selectedSamples} of {totalSamples} selected -\",\"zoomIn\":\"Zoom in\",\"zoomOut\":\"Zoom out\"}},\"dialogs\":{\"confirmation\":{\"dontShowAgain\":\"Don't show again\",\"typeToConfirm\":\"Type {value} to confirm.\"}},\"filters\":{\"date\":{\"endDate\":\"End date\",\"startDate\":\"Start date\"},\"errors\":{\"endIsEarlier\":\"End date is earlier than start date\",\"startIsLater\":\"Start date is later than end date\",\"typeMismatch\":\"Some types are missing\",\"typedConfig\":\"Cannot build filter config for type {0}\",\"typesMismatch\":\"Filter types do not match. Expected {0}, got {1}\",\"unknownConfig\":\"Cannot build filter config for unknown type\"}},\"general\":{\"actions\":{\"add\":\"Add\",\"back\":\"Back\",\"browse\":\"Browse\",\"cancel\":\"Cancel\",\"clear\":\"clear\",\"clone\":\"Clone\",\"confirm\":\"Confirm\",\"copyLink\":\"Copy link\",\"create\":\"Create\",\"customize\":\"Customize\",\"decline\":\"Decline\",\"delete\":\"Delete\",\"deleteMultiple\":\"Delete|Delete ({n})\",\"deploy\":\"Deploy\",\"discard\":\"Discard\",\"disconnect\":\"Disconnect\",\"disconnectMultiple\":\"Disconnect|Disconnect ({n})\",\"download\":\"Download\",\"duplicate\":\"Duplicate\",\"duplicateMultiple\":\"Duplicate|Duplicate ({n})\",\"edit\":\"Edit\",\"evaluate\":\"Evaluate\",\"export\":\"Export\",\"import\":\"Import\",\"info\":\"Info\",\"load\":\"Load\",\"logout\":\"Log out\",\"next\":\"Next\",\"noItems\":\"No items\",\"ok\":\"Ok\",\"previous\":\"Previous\",\"restore\":\"Restore\",\"review\":\"Review\",\"save\":\"Save\",\"search\":\"Search\",\"selectAll\":\"Select all\",\"selectOption\":\"Select option\",\"showAll\":\"Show all\",\"showDetail\":\"Show detail\",\"showDetails\":\"Show details\",\"showLess\":\"Show less\",\"showMore\":\"Show more\",\"skip\":\"Skip\",\"sort\":\"Sort\",\"stop\":\"Stop\",\"submit\":\"Submit\",\"unlink\":\"Unlink\",\"update\":\"Update\",\"viewProfile\":\"View profile\"},\"backBtn\":{\"default\":\"back\"},\"common\":{\"none\":\"none\",\"wordInBrackets\":\" ({0})\"},\"errors\":{\"description\":\"Please try again.\",\"title\":\"Sorry, something went wrong.\"},\"help\":{\"hint\":\"Help (F1)\",\"title\":\"Help\"},\"inputs\":{\"field\":\"Field\",\"from\":\"From\",\"maxCharacters\":\"max. {n} characters\",\"name\":\"Name\",\"optional\":\"(optional)\",\"until\":\"Until\"},\"layout\":{\"default\":\"Left and right panels\",\"full\":\"Fullscreen\",\"leftOnly\":\"Only left panel\",\"rightOnly\":\"Only right panel\",\"split\":\"Split view\"},\"process\":{\"percentage\":\"{0}%\"},\"symbols\":{\"comma\":\",\",\"dash\":\"-\",\"dots\":\"...\",\"hashtag\":\"#\",\"percentage\":\"%\",\"pipe\":\"{'|'}\",\"plus\":\"+\",\"semicolon\":\":\",\"separator\":\" • \",\"separatorX\":\" x \",\"slash\":\"/\",\"zero\":\"0\"},\"table\":{\"cancel\":\"Cancel\",\"clear\":\"(Clear)\",\"clearFilter\":\"Clear filter\",\"filter\":\"Filters\",\"filtered\":\"Filtered {0}/{1}\",\"filteredResults\":\"{0}/{1} filtered results\",\"listView\":\"List view\",\"noFilteredResults\":\"Your filters produced no results\",\"noQueryResults\":\"Sorry, we couldn't find any results\",\"noSearchResult\":\"we couldn't find any results\",\"recordPerPage\":\"Items per page:\",\"search\":\"Search\",\"searchAgain\":\"Search again\",\"select\":\"Select\",\"selected\":\"{0}/{1} selected\",\"sorry\":\"Sorry\",\"sortBy\":\"Sort by:\",\"thumbnailsView\":\"Thumbnails view\",\"total\":\"{0} items\"},\"text\":{\"advanced\":\"Advanced\",\"allRows\":\"All rows\",\"clear\":\"Clear\",\"compressed\":\"Compressed\",\"createdDate\":\"Created date\",\"dateAsc\":\"Oldest\",\"dateDesc\":\"Newest\",\"failed\":\"Failed\",\"filter\":\"Filter\",\"first\":\"First\",\"gpu\":\"GPU\",\"inUse\":\"in use\",\"items\":\"Items\",\"itemsNumber\":\"Items ({0})\",\"label\":\"{0}: \",\"labelValue\":\"{0}: {1}\",\"last\":\"Last\",\"loading\":\"Loading...\",\"loadingExtra\":\"Could take some time.\",\"loadingFailed\":\"Looks like something went wrong.\",\"more\":\"+{0}\",\"multiselect\":\"Multiselect\",\"name\":\"Name\",\"no\":\"No\",\"noItems\":\"No items\",\"notInUse\":\"not in use\",\"otherCenters\":\"Other centers\",\"role\":\"Role\",\"search\":\"Search\",\"showRows\":\"Show rows\",\"sortAsc\":\"A to Z\",\"sortDesc\":\"Z to A\",\"status\":\"Status\",\"theValue\":\"The value\",\"valueTotal\":\"{0}/{1}\",\"yes\":\"Yes\"},\"titles\":{\"sure\":\"Are you sure?\"}},\"policiesAndLicenses\":{\"actions\":{\"cookies\":{\"accept\":\"Accept all\",\"here\":\"here\",\"open\":\"Cookies\",\"reject\":\"Reject other than necessary\"},\"privacyPolicy\":{\"open\":\"Privacy policy\"},\"termsAndConditions\":{\"agree\":\"Agree & sign up\",\"disagree\":\"Disagree\",\"open\":\"Terms and conditions\"}},\"text\":{\"cookies\":\"We use cookies to improve your visit to this application. Click 'Accept all' to accept all cookies. Want to know more about these cookies? Click {here} for more information.\"},\"titles\":{\"cookies\":\"cookies\",\"termsAndConditions\":\"Terms and conditions\"}},\"tableFields\":{\"actions\":{\"save\":\"Set for all members\"},\"clearFilter\":\"Clear filter\",\"clearSearchResults\":\"Clear search results\",\"inputs\":{\"all\":\"All columns\",\"columnName\":\"Column name\",\"edit\":\"edit\",\"editable\":\"Editable\",\"showColumns\":\"Show columns\",\"view\":\"view\"},\"noFilteredResults\":\"Your filters produced no results\",\"noQueryResults\":\"Sorry, we couldn't find any results\",\"searchAgain\":\"Search again\",\"title\":\"Table settings\"},\"validation\":{\"decimal\":\"{0} must be decimal\",\"default\":\"Invalid value\",\"dnsLabel\":\"{0} must be a valid DNS label (at most 63 characters, contain only alphanumeric characters and dashes, start with an alphabetic character and end with an alphanumeric character)\",\"email\":\"Must be a valid email address\",\"equalTo\":\"{0} must be {1}\",\"fileTooLarge\":\"The file is too large (MAX. {0})\",\"integer\":\"{0} must be an integer\",\"isRequired\":\"{0} is required\",\"isUnique\":\"{0} must be unique\",\"maxLength\":\"{0} must be at most {1} characters\",\"maxValue\":\"{0} must be less than or equal to {1}\",\"maxValueExclusive\":\"{0} must be less than {1}\",\"minLength\":\"{0} must be at least {1} characters\",\"minLowerCaseCount\":\"{0} must contain at least {1} lower case letter|{0} must contain at least {1} lower case letters\",\"minNumberCount\":\"{0} must contain at least {1} number|{0} must contain at least {1} numbers\",\"minSpecialCount\":\"{0} must contain at least {1} special character|{0} must contain at least {1} special characters\",\"minUpperAndLowerCaseCount\":\"{0} must contain at least {1} upper case letter and {1} lower case letter|{0} must contain at least {1} upper case letters and {1} lower case letters\",\"minUpperCaseCount\":\"{0} must contain at least {1} upper case letter|{0} must contain at least {1} upper case letters\",\"minValue\":\"{0} must be greater than or equal to {1}\",\"minValueExclusive\":\"{0} must be greater than {1}\",\"mustBeValid\":\"{0} must be valid\",\"notAllowedSymbols\":\"{0} cannot contain {1}\",\"numbers\":\"{0} must contain only numbers\",\"numeric\":\"{0} must be numeric\",\"sameAs\":\"{0} value should be the same as {1}\",\"slug\":\"{0} must contain only lowercase letters and numbers separated by hyphen, underscore or dot\",\"url\":\"{0} in not valid URL\",\"withoutSpaces\":\"{0} cannot contain spaces\",\"wordsAndNumbers\":\"{0} must contain only letters and numbers. No spaces.\",\"wordsAndUnderscores\":\"{0} must contain only letters, numbers, underscores, dashes and spaces\",\"wordsWithoutSpaces\":\"{0} must contain only letters, numbers, underscores and dashes\",\"wordsWithSpaces\":\"{0} must contain only letters, numbers, underscores, dashes and spaces\",\"wrongFormat\":\"The file you selected has the wrong format\"}}") };
//#endregion
//#region src/setup.ts
function iconMapFn(iconName) {
	if (iconName.startsWith("rvai-base:")) return { icon: `svguse:rvai-base/icons.svg#${iconName.substring(10)}` };
}
function initializeRouter() {
	useRouter().beforeEach(navigationHistoryGuard);
}
function initializeI18n(i18n = useI18n()) {
	const merged = merge({}, en_default, i18n.getLocaleMessage("en"));
	i18n.setLocaleMessage("en", merged);
	ValidationBuilder.i18n = i18n;
}
function initialize(options) {
	const $q = useQuasar();
	$q.iconMapFn = iconMapFn;
	initializeRouter();
	initializeI18n();
	initializeOptions(options);
	provideLayoutStore(options?.layout);
	useDarkMode().initialize(options?.darkMode);
}
//#endregion
//#region src/entry.esm.ts
var PREFIX = "Rv";
var install = function(app) {
	app.config.globalProperties.$sanitize = DOMPurify.sanitize;
	Object.entries(components_exports).forEach(([componentName, component]) => {
		app.component(`${PREFIX}${componentName}`, component);
	});
	Object.entries(layouts_exports).forEach(([layoutName, layout]) => {
		app.component(`${PREFIX}${layoutName}`, layout);
	});
	Object.entries(directives_exports).forEach(([directiveName, directive]) => {
		app.directive(directiveName, directive);
	});
};
//#endregion
//#region src/entry.ts
Object.entries(components_exports).forEach(([componentName, component]) => {
	if (componentName !== "default") {
		const key = componentName;
		install[key] = component;
	}
});
var entry_default = install;
//#endregion
export { ActionButton_default as ActionButton, AutoHeight_default as AutoHeight, Avatar_default as Avatar, BackButton_default as BackButton, BarChart_default as BarChart, Bullet_default as Bullet, Button_default as Button, ButtonDropdown_default as ButtonDropdown, Card_default as Card, CardImage_default as CardImage, CardItem_default as CardItem, Carousel_default as Carousel, Chart_default as Chart, ChartDefinition, ChartEntry, ChartLineIndicator_default as ChartLineIndicator, Checkbox_default as Checkbox, Chip_default as Chip, CircularProgress_default as CircularProgress, ClickableArea_default as ClickableArea, ColorPicker_default as ColorPicker, ColorPickerInput_default as ColorPickerInput, ColorPickerV2_default as ColorPickerV2, CombinedInputs_default as CombinedInputs, ConfirmDialog_default as ConfirmDialog, ConfusionMatrix_default as ConfusionMatrix, ConfusionMatrixData, CookiesDialog_default as CookiesDialog, CookiesPolicy, CopyContentBtn_default as CopyContentBtn, CredibilityScore, CredibilityScoreThreshold, DARK_MODE_LOCAL_STORAGE_KEY, DatePicker_default as DatePicker, DetailsDataType, Dialog_default as Dialog, DoubleCircularProgress_default as DoubleCircularProgress, Dropzone_default as Dropzone, Duration_default as Duration, EditableText_default as EditableText, EllipsisText_default as EllipsisText, ExpansionItem_default as ExpansionItem, ExpansionList_default as ExpansionList, FieldEdit_default as FieldEdit, FieldVisibility, FieldsVisibilityDialog_default as FieldsVisibilityDialog, FilePicker_default as FilePicker, FilterableList_default as FilterableList, Focus, FullLayout_default as FullLayout, HeaderNavigationItems_default as HeaderNavigationItems, HealthIcon_default as HealthIcon, HeightAuto, Histogram_default as Histogram, HistogramWrapper_default as HistogramWrapper, Hotkey, InfoDialog_default as InfoDialog, InfoPanel_default as InfoPanel, Input_default as Input, KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6, KEY_7, KEY_8, KEY_9, KEY_ALT, KEY_ARROW_DOWN, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_A_LOWER, KEY_A_UPPER, KEY_BACKSPACE, KEY_B_LOWER, KEY_B_UPPER, KEY_CONTROL, KEY_C_LOWER, KEY_C_UPPER, KEY_DEL, KEY_DELETE, KEY_D_LOWER, KEY_D_UPPER, KEY_ENTER, KEY_EQUAL, KEY_ESC, KEY_ESCAPE, KEY_E_UPPER, KEY_F1, KEY_F_LOWER, KEY_F_UPPER, KEY_G_LOWER, KEY_G_UPPER, KEY_I_UPPER, KEY_L_LOWER, KEY_L_UPPER, KEY_META, KEY_MINUS, KEY_M_UPPER, KEY_O_UPPER, KEY_PLUS, KEY_P_LOWER, KEY_P_UPPER, KEY_R_LOWER, KEY_R_UPPER, KEY_SHIFT, KEY_SPACE, KEY_S_LOWER, KEY_S_UPPER, KEY_TAB, KEY_T_LOWER, KEY_T_UPPER, KEY_V_LOWER, KEY_V_UPPER, KEY_W_UPPER, KEY_X_LOWER, KEY_X_UPPER, KEY_Y_UPPER, KEY_Z_CODE, KEY_Z_LOWER, KEY_Z_UPPER, LabelerLayout_default as LabelerLayout, LabelerSlider_default as LabelerSlider, Layout, LayoutButton_default as LayoutButton, LinearProgress_default as LinearProgress, LocalUrl_default as LocalUrl, Logo_default as Logo, MainContent_default as MainContent, MainLayout_default as MainLayout, MultipleSelect_default as MultipleSelect, NULL_CLASS_ID, NavigationBar_default as NavigationBar, NavigationBarLink_default as NavigationBarLink, NavigationBarOverlay_default as NavigationBarOverlay, NavigationBarTree_default as NavigationBarTree, NavigationHeader_default as NavigationHeader, NavigationTitle_default as NavigationTitle, NoData_default as NoData, OptionGroup_default as OptionGroup, PAPER_KEY_SHIFT, PAPER_KEY_SPACE, Pagination_default as Pagination, Passthrough_default as Passthrough, PipelineHealthStatus, PoliciesAndLicenses_default as PoliciesAndLicenses, PrivacyPolicyDialog_default as PrivacyPolicyDialog, QuasarVariables, Radio_default as Radio, Range_default as Range, ReplicaStatus, ResponsiveLayout_default as ResponsiveLayout, RowActionsVisibility, RvaiExceptions, ScrollArea_default as ScrollArea, ScrollNavigation_default as ScrollNavigation, SearchInput_default as SearchInput, SectionMessage_default as SectionMessage, Select_default as Select, SelectBoolean_default as SelectBoolean, Separator_default as Separator, ShapesNoData, Sidebar_default as Sidebar, SidebarListClassSlugs_default as SidebarListClassSlugs, SidebarLoading_default as SidebarLoading, Slider_default as Slider, SortButton_default as SortButton, SortOrders, SortSelect_default as SortSelect, SortType, Spinner_default as Spinner, SpinnerAbsolute_default as SpinnerAbsolute, SpinnerFixed_default as SpinnerFixed, StatusPanel_default as StatusPanel, StepSidebar_default as StepSidebar, StepSidebarContent_default as StepSidebarContent, SuspenseWithError_default as SuspenseWithError, Table_default as Table, TableCard_default as TableCard, TableFilter_default as TableFilter, TableFilterItem_default as TableFilterItem, TableFilterType, TableFullRowStatus_default as TableFullRowStatus, TableList_default as TableList, TableSortBy_default as TableSortBy, Tabs_default as Tabs, TermsAndConditionsDialog_default as TermsAndConditionsDialog, Toggle_default as Toggle, Tooltip_default as Tooltip, TreeTable_default as TreeTable, UNKNOWN_CLASS_ID, USER_COLORS, UsersGroup_default as UsersGroup, Validation_default as Validation, ValidationBuilder, ValidationTooltip_default as ValidationTooltip, WaferMap_default as WaferMap, appendFloatScalarValidation, appendIntegerScalarValidation, buildFieldsVisibility, buildGradient, buildPaginationComposable, entry_default as default, getColor, getUserColor, iconMapFn, initialize, initializeI18n, isHistoryRouteMeta, isLayoutRouteMeta, keepAncestors, navigationHistoryGuard, provideFieldsVisibility, provideLayoutStore, providePagination, provideStepSidebar, provideTable, rgbaColor, roundToStep, scalarNumericBoundsFromDefinition, setPrimaryColor, truncateNumber, useAutomation, useChartDatasets, useChartOptions, useChartTooltip, useCollapsed, useConfirmDialog, useCookiesPolicy, useDarkMode, useFieldsVisibility, useInfoDialog, useLayout, useLogo, useNavigationHistory, usePagination, usePaletteColorsCache, useQueryParams, useRightPanelSize, useScrollNavigation, useSidebar, useSidebarHelpers, useStepSidebar, useTable, useTreeTable, useValidation };

//# sourceMappingURL=index.es.js.map